import { $ as e, $n as t, $t as n, A as r, An as i, At as a, B as o, Bn as s, Bt as c, C as l, Cn as u, Ct as d, D as f, Dn as p, Dt as m, E as h, En as g, Et as _, F as v, Fn as y, Ft as b, G as x, Gn as S, Gt as C, H as w, Hn as T, Ht as E, I as D, In as O, It as k, J as A, Jn as j, Jt as M, K as N, Kn as P, Kt as F, L as I, Ln as L, Lt as R, M as z, Mn as B, Mt as V, N as ee, Nn as H, Nt as U, O as te, On as ne, Ot as re, P as ie, Pn as ae, Pt as oe, Q as se, Qn as ce, Qt as le, R as ue, Rn as de, Rt as fe, S as pe, Sn as me, St as he, T as ge, Tn as _e, Tt as ve, U as ye, Un as be, Ut as xe, V as Se, Vn as Ce, Vt as we, W as Te, Wn as Ee, Wt as De, X as Oe, Xn as ke, Xt as Ae, Y as je, Yn as Me, Yt as Ne, Z as Pe, Zn as Fe, Zt as Ie, _ as Le, _n as Re, _t as ze, a as Be, an as Ve, ar as He, at as Ue, b as We, bn as Ge, bt as Ke, c as qe, cn as Je, cr as Ye, ct as Xe, d as Ze, dn as Qe, dr as W, dt as $e, en as et, er as tt, et as nt, f as rt, fn as it, fr as G, ft as at, g as ot, gn as st, gt as ct, h as lt, hn as ut, ht as dt, i as ft, in as pt, ir as mt, it as ht, j as gt, jn as _t, jt as vt, k as yt, kn as bt, kt as xt, l as St, ln as Ct, lr as wt, lt as Tt, m as Et, mn as Dt, mr as Ot, mt as kt, n as At, nn as jt, nr as Mt, nt as Nt, o as Pt, on as Ft, or as It, ot as Lt, p as Rt, pn as zt, pr as Bt, pt as Vt, q as Ht, qn as Ut, qt as Wt, r as Gt, rn as Kt, rr as qt, rt as Jt, s as Yt, sn as Xt, sr as Zt, st as Qt, t as $t, tn as en, tr as tn, tt as nn, u as rn, un as an, ur as on, ut as sn, v as cn, vn as ln, vt as un, w as dn, wn as fn, wt as pn, x as mn, xn as hn, xt as gn, y as _n, yn as vn, yt as yn, z as bn, zn as xn, zt as Sn } from "./icons-B7jVE4uw.js";
import { _ as Cn, a as wn, c as Tn, d as En, f as Dn, g as On, h as kn, i as An, l as jn, m as Mn, n as Nn, o as Pn, p as Fn, r as In, s as Ln, t as Rn, u as zn, v as Bn, y as Vn } from "./tree-C5H1a4Gy.js";
import { DismissButton as Hn, HiddenSelect as Un, Overlay as Wn, useButton as Gn, useCalendar as Kn, useCalendarCell as qn, useCalendarGrid as Jn, useDateField as Yn, useDateFormatter as Xn, useDatePicker as Zn, useDateRangePicker as Qn, useDateSegment as $n, useFilter as er, useInteractOutside as tr, useInteractOutside as nr, useListBox as rr, useLocale as ir, useOption as ar, usePopover as or, useRangeCalendar as sr, useSelect as cr, useVisuallyHidden as lr } from "react-aria";
import { c as K } from "react/compiler-runtime";
import * as ur from "react";
import dr, { Fragment as fr, Suspense as pr, cloneElement as mr, createContext as hr, isValidElement as gr, memo as _r, useCallback as vr, useContext as yr, useEffect as br, useId as xr, useImperativeHandle as Sr, useLayoutEffect as Cr, useMemo as q, useReducer as wr, useRef as Tr, useState as J } from "react";
import { ThemeProvider as Er } from "@emotion/react";
import { Fragment as Dr, jsx as Y, jsxs as X } from "react/jsx-runtime";
import { createPortal as Or, flushSync as kr } from "react-dom";
import { CalendarDate as Ar, CalendarDateTime as jr, DateFormatter as Mr, GregorianCalendar as Nr, Time as Pr, ZonedDateTime as Fr, createCalendar as Ir, endOfMonth as Lr, endOfWeek as Rr, getDayOfWeek as zr, getLocalTimeZone as Br, getWeeksInMonth as Vr, isEqualCalendar as Hr, isSameDay as Ur, isToday as Wr, maxDate as Gr, minDate as Kr, now as qr, parseAbsoluteToLocal as Jr, startOfMonth as Yr, startOfWeek as Xr, startOfYear as Zr, toCalendar as Qr, toCalendarDate as $r, toCalendarDateTime as ei, today as ti } from "@internationalized/date";
import { formatDistanceToNow as ni, getDefaultOptions as ri } from "date-fns";
import { Breadcrumb as ii, Breadcrumbs as ai, Button as oi, ButtonContext as si, Checkbox as ci, CheckboxGroup as li, ComboBox as ui, ComboBoxStateContext as di, Dialog as fi, DialogTrigger as pi, DialogTrigger as mi, Disclosure as hi, DisclosurePanel as gi, DisclosureStateContext as _i, Group as vi, Header as yi, Heading as bi, Input as xi, Label as Si, LabelContext as Ci, Link as wi, ListBox as Ti, ListBoxItem as Ei, ListBoxSection as Di, Modal as Oi, ModalOverlay as ki, NumberField as Ai, Popover as ji, ProgressBar as Mi, Provider as Ni, Radio as Pi, RadioGroup as Fi, RouterProvider as Ii, SearchField as Li, Switch as Ri, Tab as zi, TabList as Bi, TabPanel as Vi, Tabs as Hi, Tag as Ui, TagGroup as Wi, TagList as Gi, Text as Ki, TextArea as qi, TextField as Ji, ToggleButton as Yi, ToggleButtonGroup as Xi, UNSTABLE_Toast as Zi, UNSTABLE_ToastContent as Qi, UNSTABLE_ToastQueue as $i, UNSTABLE_ToastRegion as ea, composeRenderProps as ta } from "react-aria-components";
import { common as na, createLowlight as ra } from "lowlight";
//#region \0rolldown/runtime.js
var ia = Object.create, aa = Object.defineProperty, oa = Object.getOwnPropertyDescriptor, sa = Object.getOwnPropertyNames, ca = Object.getPrototypeOf, la = Object.prototype.hasOwnProperty, ua = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), da = (e, t) => {
	let n = {};
	for (var r in e) aa(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || aa(n, Symbol.toStringTag, { value: "Module" }), n;
}, fa = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = sa(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !la.call(e, s) && s !== n && aa(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = oa(t, s)) || r.enumerable
	});
	return e;
}, pa = (e, t, n) => (n = e == null ? {} : ia(ca(e)), fa(t || !e || !e.__esModule || !la.call(e, "default") ? aa(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), ma = 120;
function ha(e) {
	let t = e;
	if (!t || typeof t.matches != "function") return !0;
	try {
		return t.matches(":focus-visible");
	} catch {
		return !0;
	}
}
function ga(e) {
	let t = K(10), n = Tr(void 0), r;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (r = () => clearTimeout(n.current), t[0] = r) : r = t[0];
	let i = r, a, o;
	t[1] === Symbol.for("react.memo_cache_sentinel") ? (a = () => i, o = [i], t[1] = a, t[2] = o) : (a = t[1], o = t[2]), br(a, o);
	let s;
	t[3] === e ? s = t[4] : (s = () => {
		e && (i(), n.current = setTimeout(e, ma));
	}, t[3] = e, t[4] = s);
	let c = s, l;
	t[5] === c ? l = t[6] : (l = (e) => {
		ha(e.target) && c();
	}, t[5] = c, t[6] = l);
	let u;
	return t[7] !== c || t[8] !== l ? (u = {
		onMouseEnter: c,
		onMouseLeave: i,
		onFocus: l,
		onBlur: i
	}, t[7] = c, t[8] = l, t[9] = u) : u = t[9], u;
}
//#endregion
//#region lib/hooks/useFreshworksWidget.ts
var _a = 72000002430, va = !1;
function ya(e, t, n) {
	let r = K(15), i = ba, a, o;
	r[0] === Symbol.for("react.memo_cache_sentinel") ? (a = () => {
		typeof window.FreshworksWidget != "function" && (i(), window.FreshworksWidget = Object.assign(function(...e) {
			let t = e;
			i(), window.FreshworksWidget.q.push(t);
		}, { q: [] })), window.fwSettings = { widget_id: _a };
	}, o = [i], r[0] = a, r[1] = o) : (a = r[0], o = r[1]), br(a, o);
	let s;
	r[2] === n ? s = r[3] : (s = n ?? {}, r[2] = n, r[3] = s);
	let { subject: c, description: l, type: u } = s, d = c !== void 0 || l !== void 0 || u !== void 0, f;
	r[4] !== l || r[5] !== d || r[6] !== c || r[7] !== u ? (f = () => {
		d && window.FreshworksWidget("prefill", "ticketForm", {
			subject: c,
			description: l,
			type: u
		}), window.FreshworksWidget("open");
	}, r[4] = l, r[5] = d, r[6] = c, r[7] = u, r[8] = f) : f = r[8];
	let p = f, m, h;
	r[9] !== e || r[10] !== t ? (m = () => {
		va && (window.FreshworksWidget("identify", "ticketForm", {
			name: t,
			email: e
		}), window.FreshworksWidget("hide", "launcher"));
	}, h = [e, t], r[9] = e, r[10] = t, r[11] = m, r[12] = h) : (m = r[11], h = r[12]), br(m, h);
	let g;
	return r[13] === p ? g = r[14] : (g = {
		isLoaded: va,
		open: p
	}, r[13] = p, r[14] = g), g;
}
function ba() {
	if (va) return;
	let e = document.createElement("script");
	e.src = `https://widget.freshworks.com/widgets/${_a}.js`, document.body.append(e), va = !0;
}
//#endregion
//#region lib/theme/colors.ts
var xa = {
	red: {
		50: "#FFF2F4",
		100: "#FFD8E0",
		200: "#FFBDCB",
		300: "#FF859E",
		400: "#FC5275",
		500: "#EA2A51",
		600: "#D20E36",
		700: "#B50025",
		800: "#90001D",
		900: "#640014",
		950: "#32000A"
	},
	orange: {
		50: "#FFF6F2",
		100: "#FFE5D7",
		200: "#FFD4BC",
		300: "#FFAD84",
		400: "#FB8951",
		500: "#E96929",
		600: "#D24E0D",
		700: "#B43C00",
		800: "#8F3000",
		900: "#632100",
		950: "#321100"
	},
	yellow: {
		50: "#FFFCF2",
		100: "#FFF8D3",
		200: "#FFF4B2",
		300: "#FFE573",
		400: "#FFD439",
		500: "#FFC208",
		600: "#E4AC00",
		700: "#C39200",
		800: "#9A7400",
		900: "#6B5000",
		950: "#362900"
	},
	green: {
		50: "#F9FFF2",
		100: "#EAF8D6",
		200: "#DBF1BC",
		300: "#BEE688",
		400: "#A3D65C",
		500: "#8CC936",
		600: "#75B71A",
		700: "#5F9F07",
		800: "#4C7F04",
		900: "#355902",
		950: "#1A2D00"
	},
	jade: {
		50: "#F2FFF8",
		100: "#D4FBE7",
		200: "#B7F6D7",
		300: "#80EDB6",
		400: "#51E098",
		500: "#2CCE7D",
		600: "#11BB66",
		700: "#01A252",
		800: "#018241",
		900: "#005A2D",
		950: "#002E17"
	},
	blue: {
		50: "#F2FCFF",
		100: "#D7F7FF",
		200: "#BCF2FF",
		300: "#84E2FF",
		400: "#51D0FB",
		500: "#29B9E9",
		600: "#0DA0D2",
		700: "#0087B4",
		800: "#006B8F",
		900: "#004A63",
		950: "#002632"
	},
	indigo: {
		50: "#F2F6FF",
		100: "#D9E4FC",
		200: "#C0D3F9",
		300: "#8CAEF2",
		400: "#5F8CE6",
		500: "#3C6FD6",
		600: "#1D54C2",
		700: "#083DA7",
		800: "#053086",
		900: "#02215D",
		950: "#01102F"
	},
	violet: {
		50: "#FAF2FF",
		100: "#EAD7F4",
		200: "#DABEEA",
		300: "#BF8CDA",
		400: "#A463C7",
		500: "#903EBC",
		600: "#7C20AD",
		700: "#660C96",
		800: "#510779",
		900: "#380355",
		950: "#1C012B"
	},
	pink: {
		50: "#FFF2F9",
		100: "#FCD0EA",
		200: "#F8B0DA",
		300: "#F075BD",
		400: "#E648A4",
		500: "#D7248D",
		600: "#C20B76",
		700: "#A80062",
		800: "#86004E",
		900: "#5D0036",
		950: "#2F001C"
	}
}, Sa = [
	"orange",
	"blue",
	"red",
	"indigo",
	"yellow",
	"violet",
	"green",
	"pink",
	"jade"
];
function Ca(e = "500") {
	return Sa.map((t) => xa[t][e]);
}
//#endregion
//#region ../../node_modules/.pnpm/react-is@16.13.1/node_modules/react-is/cjs/react-is.production.min.js
var wa = /* @__PURE__ */ ua(((e) => {
	var t = typeof Symbol == "function" && Symbol.for, n = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, i = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, c = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, u = t ? Symbol.for("react.concurrent_mode") : 60111, d = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, p = t ? Symbol.for("react.suspense_list") : 60120, m = t ? Symbol.for("react.memo") : 60115, h = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, _ = t ? Symbol.for("react.fundamental") : 60117, v = t ? Symbol.for("react.responder") : 60118, y = t ? Symbol.for("react.scope") : 60119;
	function b(e) {
		if (typeof e == "object" && e) {
			var t = e.$$typeof;
			switch (t) {
				case n: switch (e = e.type, e) {
					case l:
					case u:
					case i:
					case o:
					case a:
					case f: return e;
					default: switch (e &&= e.$$typeof, e) {
						case c:
						case d:
						case h:
						case m:
						case s: return e;
						default: return t;
					}
				}
				case r: return t;
			}
		}
	}
	function x(e) {
		return b(e) === u;
	}
	e.AsyncMode = l, e.ConcurrentMode = u, e.ContextConsumer = c, e.ContextProvider = s, e.Element = n, e.ForwardRef = d, e.Fragment = i, e.Lazy = h, e.Memo = m, e.Portal = r, e.Profiler = o, e.StrictMode = a, e.Suspense = f, e.isAsyncMode = function(e) {
		return x(e) || b(e) === l;
	}, e.isConcurrentMode = x, e.isContextConsumer = function(e) {
		return b(e) === c;
	}, e.isContextProvider = function(e) {
		return b(e) === s;
	}, e.isElement = function(e) {
		return typeof e == "object" && !!e && e.$$typeof === n;
	}, e.isForwardRef = function(e) {
		return b(e) === d;
	}, e.isFragment = function(e) {
		return b(e) === i;
	}, e.isLazy = function(e) {
		return b(e) === h;
	}, e.isMemo = function(e) {
		return b(e) === m;
	}, e.isPortal = function(e) {
		return b(e) === r;
	}, e.isProfiler = function(e) {
		return b(e) === o;
	}, e.isStrictMode = function(e) {
		return b(e) === a;
	}, e.isSuspense = function(e) {
		return b(e) === f;
	}, e.isValidElementType = function(e) {
		return typeof e == "string" || typeof e == "function" || e === i || e === u || e === o || e === a || e === f || e === p || typeof e == "object" && !!e && (e.$$typeof === h || e.$$typeof === m || e.$$typeof === s || e.$$typeof === c || e.$$typeof === d || e.$$typeof === _ || e.$$typeof === v || e.$$typeof === y || e.$$typeof === g);
	}, e.typeOf = b;
})), Ta = /* @__PURE__ */ ua(((e) => {
	process.env.NODE_ENV !== "production" && (function() {
		var t = typeof Symbol == "function" && Symbol.for, n = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, i = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, c = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, u = t ? Symbol.for("react.concurrent_mode") : 60111, d = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, p = t ? Symbol.for("react.suspense_list") : 60120, m = t ? Symbol.for("react.memo") : 60115, h = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, _ = t ? Symbol.for("react.fundamental") : 60117, v = t ? Symbol.for("react.responder") : 60118, y = t ? Symbol.for("react.scope") : 60119;
		function b(e) {
			return typeof e == "string" || typeof e == "function" || e === i || e === u || e === o || e === a || e === f || e === p || typeof e == "object" && !!e && (e.$$typeof === h || e.$$typeof === m || e.$$typeof === s || e.$$typeof === c || e.$$typeof === d || e.$$typeof === _ || e.$$typeof === v || e.$$typeof === y || e.$$typeof === g);
		}
		function x(e) {
			if (typeof e == "object" && e) {
				var t = e.$$typeof;
				switch (t) {
					case n:
						var p = e.type;
						switch (p) {
							case l:
							case u:
							case i:
							case o:
							case a:
							case f: return p;
							default:
								var g = p && p.$$typeof;
								switch (g) {
									case c:
									case d:
									case h:
									case m:
									case s: return g;
									default: return t;
								}
						}
					case r: return t;
				}
			}
		}
		var S = l, C = u, w = c, T = s, E = n, D = d, O = i, k = h, A = m, j = r, M = o, N = a, P = f, F = !1;
		function I(e) {
			return F || (F = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), L(e) || x(e) === l;
		}
		function L(e) {
			return x(e) === u;
		}
		function R(e) {
			return x(e) === c;
		}
		function z(e) {
			return x(e) === s;
		}
		function B(e) {
			return typeof e == "object" && !!e && e.$$typeof === n;
		}
		function V(e) {
			return x(e) === d;
		}
		function ee(e) {
			return x(e) === i;
		}
		function H(e) {
			return x(e) === h;
		}
		function U(e) {
			return x(e) === m;
		}
		function te(e) {
			return x(e) === r;
		}
		function ne(e) {
			return x(e) === o;
		}
		function re(e) {
			return x(e) === a;
		}
		function ie(e) {
			return x(e) === f;
		}
		e.AsyncMode = S, e.ConcurrentMode = C, e.ContextConsumer = w, e.ContextProvider = T, e.Element = E, e.ForwardRef = D, e.Fragment = O, e.Lazy = k, e.Memo = A, e.Portal = j, e.Profiler = M, e.StrictMode = N, e.Suspense = P, e.isAsyncMode = I, e.isConcurrentMode = L, e.isContextConsumer = R, e.isContextProvider = z, e.isElement = B, e.isForwardRef = V, e.isFragment = ee, e.isLazy = H, e.isMemo = U, e.isPortal = te, e.isProfiler = ne, e.isStrictMode = re, e.isSuspense = ie, e.isValidElementType = b, e.typeOf = x;
	})();
})), Ea = /* @__PURE__ */ ua(((e, t) => {
	t.exports = process.env.NODE_ENV === "production" ? wa() : Ta();
})), Da = /* @__PURE__ */ ua(((e, t) => {
	var n = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, i = Object.prototype.propertyIsEnumerable;
	function a(e) {
		if (e == null) throw TypeError("Object.assign cannot be called with null or undefined");
		return Object(e);
	}
	function o() {
		try {
			if (!Object.assign) return !1;
			var e = /* @__PURE__ */ new String("abc");
			if (e[5] = "de", Object.getOwnPropertyNames(e)[0] === "5") return !1;
			for (var t = {}, n = 0; n < 10; n++) t["_" + String.fromCharCode(n)] = n;
			if (Object.getOwnPropertyNames(t).map(function(e) {
				return t[e];
			}).join("") !== "0123456789") return !1;
			var r = {};
			return "abcdefghijklmnopqrst".split("").forEach(function(e) {
				r[e] = e;
			}), Object.keys(Object.assign({}, r)).join("") === "abcdefghijklmnopqrst";
		} catch {
			return !1;
		}
	}
	t.exports = o() ? Object.assign : function(e, t) {
		for (var o, s = a(e), c, l = 1; l < arguments.length; l++) {
			for (var u in o = Object(arguments[l]), o) r.call(o, u) && (s[u] = o[u]);
			if (n) {
				c = n(o);
				for (var d = 0; d < c.length; d++) i.call(o, c[d]) && (s[c[d]] = o[c[d]]);
			}
		}
		return s;
	};
})), Oa = /* @__PURE__ */ ua(((e, t) => {
	t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
})), ka = /* @__PURE__ */ ua(((e, t) => {
	t.exports = Function.call.bind(Object.prototype.hasOwnProperty);
})), Aa = /* @__PURE__ */ ua(((e, t) => {
	var n = function() {};
	if (process.env.NODE_ENV !== "production") {
		var r = Oa(), i = {}, a = ka();
		n = function(e) {
			var t = "Warning: " + e;
			typeof console < "u" && console.error(t);
			try {
				throw Error(t);
			} catch {}
		};
	}
	function o(e, t, o, s, c) {
		if (process.env.NODE_ENV !== "production") {
			for (var l in e) if (a(e, l)) {
				var u;
				try {
					if (typeof e[l] != "function") {
						var d = Error((s || "React class") + ": " + o + " type `" + l + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[l] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
						throw d.name = "Invariant Violation", d;
					}
					u = e[l](t, l, s, o, null, r);
				} catch (e) {
					u = e;
				}
				if (u && !(u instanceof Error) && n((s || "React class") + ": type specification of " + o + " `" + l + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof u + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), u instanceof Error && !(u.message in i)) {
					i[u.message] = !0;
					var f = c ? c() : "";
					n("Failed " + o + " type: " + u.message + (f ?? ""));
				}
			}
		}
	}
	o.resetWarningCache = function() {
		process.env.NODE_ENV !== "production" && (i = {});
	}, t.exports = o;
})), ja = /* @__PURE__ */ ua(((e, t) => {
	var n = Ea(), r = Da(), i = Oa(), a = ka(), o = Aa(), s = function() {};
	process.env.NODE_ENV !== "production" && (s = function(e) {
		var t = "Warning: " + e;
		typeof console < "u" && console.error(t);
		try {
			throw Error(t);
		} catch {}
	});
	function c() {
		return null;
	}
	t.exports = function(e, t) {
		var l = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
		function d(e) {
			var t = e && (l && e[l] || e[u]);
			if (typeof t == "function") return t;
		}
		var f = "<<anonymous>>", p = {
			array: _("array"),
			bigint: _("bigint"),
			bool: _("boolean"),
			func: _("function"),
			number: _("number"),
			object: _("object"),
			string: _("string"),
			symbol: _("symbol"),
			any: v(),
			arrayOf: y,
			element: b(),
			elementType: x(),
			instanceOf: S,
			node: E(),
			objectOf: w,
			oneOf: C,
			oneOfType: T,
			shape: O,
			exact: k
		};
		function m(e, t) {
			return e === t ? e !== 0 || 1 / e == 1 / t : e !== e && t !== t;
		}
		function h(e, t) {
			this.message = e, this.data = t && typeof t == "object" ? t : {}, this.stack = "";
		}
		h.prototype = Error.prototype;
		function g(e) {
			if (process.env.NODE_ENV !== "production") var n = {}, r = 0;
			function a(a, o, c, l, u, d, p) {
				if (l ||= f, d ||= c, p !== i) {
					if (t) {
						var m = /* @__PURE__ */ Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
						throw m.name = "Invariant Violation", m;
					}
					if (process.env.NODE_ENV !== "production" && typeof console < "u") {
						var g = l + ":" + c;
						!n[g] && r < 3 && (s("You are manually calling a React.PropTypes validation function for the `" + d + "` prop on `" + l + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), n[g] = !0, r++);
					}
				}
				return o[c] == null ? a ? o[c] === null ? new h("The " + u + " `" + d + "` is marked as required " + ("in `" + l + "`, but its value is `null`.")) : new h("The " + u + " `" + d + "` is marked as required in " + ("`" + l + "`, but its value is `undefined`.")) : null : e(o, c, l, u, d);
			}
			var o = a.bind(null, !1);
			return o.isRequired = a.bind(null, !0), o;
		}
		function _(e) {
			function t(t, n, r, i, a, o) {
				var s = t[n];
				if (M(s) !== e) {
					var c = N(s);
					return new h("Invalid " + i + " `" + a + "` of type " + ("`" + c + "` supplied to `" + r + "`, expected ") + ("`" + e + "`."), { expectedType: e });
				}
				return null;
			}
			return g(t);
		}
		function v() {
			return g(c);
		}
		function y(e) {
			function t(t, n, r, a, o) {
				if (typeof e != "function") return new h("Property `" + o + "` of component `" + r + "` has invalid PropType notation inside arrayOf.");
				var s = t[n];
				if (!Array.isArray(s)) {
					var c = M(s);
					return new h("Invalid " + a + " `" + o + "` of type " + ("`" + c + "` supplied to `" + r + "`, expected an array."));
				}
				for (var l = 0; l < s.length; l++) {
					var u = e(s, l, r, a, o + "[" + l + "]", i);
					if (u instanceof Error) return u;
				}
				return null;
			}
			return g(t);
		}
		function b() {
			function t(t, n, r, i, a) {
				var o = t[n];
				if (!e(o)) {
					var s = M(o);
					return new h("Invalid " + i + " `" + a + "` of type " + ("`" + s + "` supplied to `" + r + "`, expected a single ReactElement."));
				}
				return null;
			}
			return g(t);
		}
		function x() {
			function e(e, t, r, i, a) {
				var o = e[t];
				if (!n.isValidElementType(o)) {
					var s = M(o);
					return new h("Invalid " + i + " `" + a + "` of type " + ("`" + s + "` supplied to `" + r + "`, expected a single ReactElement type."));
				}
				return null;
			}
			return g(e);
		}
		function S(e) {
			function t(t, n, r, i, a) {
				if (!(t[n] instanceof e)) {
					var o = e.name || f, s = F(t[n]);
					return new h("Invalid " + i + " `" + a + "` of type " + ("`" + s + "` supplied to `" + r + "`, expected ") + ("instance of `" + o + "`."));
				}
				return null;
			}
			return g(t);
		}
		function C(e) {
			if (!Array.isArray(e)) return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? s("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).") : s("Invalid argument supplied to oneOf, expected an array.")), c;
			function t(t, n, r, i, a) {
				for (var o = t[n], s = 0; s < e.length; s++) if (m(o, e[s])) return null;
				var c = JSON.stringify(e, function(e, t) {
					return N(t) === "symbol" ? String(t) : t;
				});
				return new h("Invalid " + i + " `" + a + "` of value `" + String(o) + "` " + ("supplied to `" + r + "`, expected one of " + c + "."));
			}
			return g(t);
		}
		function w(e) {
			function t(t, n, r, o, s) {
				if (typeof e != "function") return new h("Property `" + s + "` of component `" + r + "` has invalid PropType notation inside objectOf.");
				var c = t[n], l = M(c);
				if (l !== "object") return new h("Invalid " + o + " `" + s + "` of type " + ("`" + l + "` supplied to `" + r + "`, expected an object."));
				for (var u in c) if (a(c, u)) {
					var d = e(c, u, r, o, s + "." + u, i);
					if (d instanceof Error) return d;
				}
				return null;
			}
			return g(t);
		}
		function T(e) {
			if (!Array.isArray(e)) return process.env.NODE_ENV !== "production" && s("Invalid argument supplied to oneOfType, expected an instance of array."), c;
			for (var t = 0; t < e.length; t++) {
				var n = e[t];
				if (typeof n != "function") return s("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + P(n) + " at index " + t + "."), c;
			}
			function r(t, n, r, o, s) {
				for (var c = [], l = 0; l < e.length; l++) {
					var u = e[l], d = u(t, n, r, o, s, i);
					if (d == null) return null;
					d.data && a(d.data, "expectedType") && c.push(d.data.expectedType);
				}
				var f = c.length > 0 ? ", expected one of type [" + c.join(", ") + "]" : "";
				return new h("Invalid " + o + " `" + s + "` supplied to " + ("`" + r + "`" + f + "."));
			}
			return g(r);
		}
		function E() {
			function e(e, t, n, r, i) {
				return A(e[t]) ? null : new h("Invalid " + r + " `" + i + "` supplied to " + ("`" + n + "`, expected a ReactNode."));
			}
			return g(e);
		}
		function D(e, t, n, r, i) {
			return new h((e || "React class") + ": " + t + " type `" + n + "." + r + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + i + "`.");
		}
		function O(e) {
			function t(t, n, r, a, o) {
				var s = t[n], c = M(s);
				if (c !== "object") return new h("Invalid " + a + " `" + o + "` of type `" + c + "` " + ("supplied to `" + r + "`, expected `object`."));
				for (var l in e) {
					var u = e[l];
					if (typeof u != "function") return D(r, a, o, l, N(u));
					var d = u(s, l, r, a, o + "." + l, i);
					if (d) return d;
				}
				return null;
			}
			return g(t);
		}
		function k(e) {
			function t(t, n, o, s, c) {
				var l = t[n], u = M(l);
				if (u !== "object") return new h("Invalid " + s + " `" + c + "` of type `" + u + "` " + ("supplied to `" + o + "`, expected `object`."));
				for (var d in r({}, t[n], e)) {
					var f = e[d];
					if (a(e, d) && typeof f != "function") return D(o, s, c, d, N(f));
					if (!f) return new h("Invalid " + s + " `" + c + "` key `" + d + "` supplied to `" + o + "`.\nBad object: " + JSON.stringify(t[n], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
					var p = f(l, d, o, s, c + "." + d, i);
					if (p) return p;
				}
				return null;
			}
			return g(t);
		}
		function A(t) {
			switch (typeof t) {
				case "number":
				case "string":
				case "undefined": return !0;
				case "boolean": return !t;
				case "object":
					if (Array.isArray(t)) return t.every(A);
					if (t === null || e(t)) return !0;
					var n = d(t);
					if (n) {
						var r = n.call(t), i;
						if (n !== t.entries) {
							for (; !(i = r.next()).done;) if (!A(i.value)) return !1;
						} else for (; !(i = r.next()).done;) {
							var a = i.value;
							if (a && !A(a[1])) return !1;
						}
					} else return !1;
					return !0;
				default: return !1;
			}
		}
		function j(e, t) {
			return e === "symbol" ? !0 : t ? t["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && t instanceof Symbol : !1;
		}
		function M(e) {
			var t = typeof e;
			return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : j(t, e) ? "symbol" : t;
		}
		function N(e) {
			if (e == null) return "" + e;
			var t = M(e);
			if (t === "object") {
				if (e instanceof Date) return "date";
				if (e instanceof RegExp) return "regexp";
			}
			return t;
		}
		function P(e) {
			var t = N(e);
			switch (t) {
				case "array":
				case "object": return "an " + t;
				case "boolean":
				case "date":
				case "regexp": return "a " + t;
				default: return t;
			}
		}
		function F(e) {
			return !e.constructor || !e.constructor.name ? f : e.constructor.name;
		}
		return p.checkPropTypes = o, p.resetWarningCache = o.resetWarningCache, p.PropTypes = p, p;
	};
})), Ma = /* @__PURE__ */ ua(((e, t) => {
	var n = Oa();
	function r() {}
	function i() {}
	i.resetWarningCache = r, t.exports = function() {
		function e(e, t, r, i, a, o) {
			if (o !== n) {
				var s = /* @__PURE__ */ Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
				throw s.name = "Invariant Violation", s;
			}
		}
		e.isRequired = e;
		function t() {
			return e;
		}
		var a = {
			array: e,
			bigint: e,
			bool: e,
			func: e,
			number: e,
			object: e,
			string: e,
			symbol: e,
			any: e,
			arrayOf: t,
			element: e,
			elementType: e,
			instanceOf: t,
			node: e,
			objectOf: t,
			oneOf: t,
			oneOfType: t,
			shape: t,
			exact: t,
			checkPropTypes: i,
			resetWarningCache: r
		};
		return a.PropTypes = a, a;
	};
})), Na = /* @__PURE__ */ ua(((e, t) => {
	if (process.env.NODE_ENV !== "production") {
		var n = Ea();
		t.exports = ja()(n.isElement, !0);
	} else t.exports = Ma()();
}));
//#endregion
//#region ../../node_modules/.pnpm/@mui+utils@7.3.11_@types+react@19.2.14_react@19.2.7/node_modules/@mui/utils/esm/formatMuiErrorMessage/formatMuiErrorMessage.js
function Pa(e, ...t) {
	let n = new URL(`https://mui.com/production-error/?code=${e}`);
	return t.forEach((e) => n.searchParams.append("args[]", e)), `Minified MUI error #${e}; visit ${n} for the full message.`;
}
//#endregion
//#region ../../node_modules/.pnpm/@mui+utils@7.3.11_@types+react@19.2.14_react@19.2.7/node_modules/@mui/utils/esm/clamp/clamp.js
function Fa(e, t = -(2 ** 53 - 1), n = 2 ** 53 - 1) {
	return Math.max(t, Math.min(e, n));
}
//#endregion
//#region ../../node_modules/.pnpm/@mui+system@7.2.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.7_supports-col_c8417fe77d490541767d031a2823cb25/node_modules/@mui/system/esm/colorManipulator/colorManipulator.js
function Ia(e, t = 0, n = 1) {
	return process.env.NODE_ENV !== "production" && (e < t || e > n) && console.error(`MUI: The value provided ${e} is out of range [${t}, ${n}].`), Fa(e, t, n);
}
function La(e) {
	e = e.slice(1);
	let t = RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g"), n = e.match(t);
	return n && n[0].length === 1 && (n = n.map((e) => e + e)), process.env.NODE_ENV !== "production" && e.length !== e.trim().length && console.error(`MUI: The color: "${e}" is invalid. Make sure the color input doesn't contain leading/trailing space.`), n ? `rgb${n.length === 4 ? "a" : ""}(${n.map((e, t) => t < 3 ? parseInt(e, 16) : Math.round(parseInt(e, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function Ra(e) {
	if (e.type) return e;
	if (e.charAt(0) === "#") return Ra(La(e));
	let t = e.indexOf("("), n = e.substring(0, t);
	if (![
		"rgb",
		"rgba",
		"hsl",
		"hsla",
		"color"
	].includes(n)) throw Error(process.env.NODE_ENV === "production" ? Pa(9, e) : `MUI: Unsupported \`${e}\` color.\nThe following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().`);
	let r = e.substring(t + 1, e.length - 1), i;
	if (n === "color") {
		if (r = r.split(" "), i = r.shift(), r.length === 4 && r[3].charAt(0) === "/" && (r[3] = r[3].slice(1)), ![
			"srgb",
			"display-p3",
			"a98-rgb",
			"prophoto-rgb",
			"rec-2020"
		].includes(i)) throw Error(process.env.NODE_ENV === "production" ? Pa(10, i) : `MUI: unsupported \`${i}\` color space.\nThe following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.`);
	} else r = r.split(",");
	return r = r.map((e) => parseFloat(e)), {
		type: n,
		values: r,
		colorSpace: i
	};
}
var za = (e) => {
	let t = Ra(e);
	return t.values.slice(0, 3).map((e, n) => t.type.includes("hsl") && n !== 0 ? `${e}%` : e).join(" ");
}, Ba = (e, t) => {
	try {
		return za(e);
	} catch {
		return t && process.env.NODE_ENV !== "production" && console.warn(t), e;
	}
};
function Va(e) {
	let { type: t, colorSpace: n } = e, { values: r } = e;
	return t.includes("rgb") ? r = r.map((e, t) => t < 3 ? parseInt(e, 10) : e) : t.includes("hsl") && (r[1] = `${r[1]}%`, r[2] = `${r[2]}%`), r = t.includes("color") ? `${n} ${r.join(" ")}` : `${r.join(", ")}`, `${t}(${r})`;
}
function Ha(e) {
	e = Ra(e);
	let { values: t } = e, n = t[0], r = t[1] / 100, i = t[2] / 100, a = r * Math.min(i, 1 - i), o = (e, t = (e + n / 30) % 12) => i - a * Math.max(Math.min(t - 3, 9 - t, 1), -1), s = "rgb", c = [
		Math.round(o(0) * 255),
		Math.round(o(8) * 255),
		Math.round(o(4) * 255)
	];
	return e.type === "hsla" && (s += "a", c.push(t[3])), Va({
		type: s,
		values: c
	});
}
function Ua(e) {
	e = Ra(e);
	let t = e.type === "hsl" || e.type === "hsla" ? Ra(Ha(e)).values : e.values;
	return t = t.map((t) => (e.type !== "color" && (t /= 255), t <= .03928 ? t / 12.92 : ((t + .055) / 1.055) ** 2.4)), Number((.2126 * t[0] + .7152 * t[1] + .0722 * t[2]).toFixed(3));
}
function Wa(e, t) {
	let n = Ua(e), r = Ua(t);
	return (Math.max(n, r) + .05) / (Math.min(n, r) + .05);
}
function Ga(e, t) {
	return e = Ra(e), t = Ia(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, Va(e);
}
function Ka(e, t, n) {
	try {
		return Ga(e, t);
	} catch {
		return n && process.env.NODE_ENV !== "production" && console.warn(n), e;
	}
}
function qa(e, t) {
	if (e = Ra(e), t = Ia(t), e.type.includes("hsl")) e.values[2] *= 1 - t;
	else if (e.type.includes("rgb") || e.type.includes("color")) for (let n = 0; n < 3; n += 1) e.values[n] *= 1 - t;
	return Va(e);
}
function Ja(e, t, n) {
	try {
		return qa(e, t);
	} catch {
		return n && process.env.NODE_ENV !== "production" && console.warn(n), e;
	}
}
function Ya(e, t) {
	if (e = Ra(e), t = Ia(t), e.type.includes("hsl")) e.values[2] += (100 - e.values[2]) * t;
	else if (e.type.includes("rgb")) for (let n = 0; n < 3; n += 1) e.values[n] += (255 - e.values[n]) * t;
	else if (e.type.includes("color")) for (let n = 0; n < 3; n += 1) e.values[n] += (1 - e.values[n]) * t;
	return Va(e);
}
function Xa(e, t, n) {
	try {
		return Ya(e, t);
	} catch {
		return n && process.env.NODE_ENV !== "production" && console.warn(n), e;
	}
}
function Za(e, t = .15) {
	return Ua(e) > .5 ? qa(e, t) : Ya(e, t);
}
function Qa(e, t, n) {
	try {
		return Za(e, t);
	} catch {
		return n && process.env.NODE_ENV !== "production" && console.warn(n), e;
	}
}
//#endregion
//#region ../../node_modules/.pnpm/@mui+utils@7.2.0_@types+react@19.2.14_react@19.2.7/node_modules/@mui/utils/esm/formatMuiErrorMessage/formatMuiErrorMessage.js
function $a(e, ...t) {
	let n = new URL(`https://mui.com/production-error/?code=${e}`);
	return t.forEach((e) => n.searchParams.append("args[]", e)), `Minified MUI error #${e}; visit ${n} for the full message.`;
}
//#endregion
//#region ../../node_modules/.pnpm/@mui+utils@7.3.11_@types+react@19.2.14_react@19.2.7/node_modules/@mui/utils/esm/capitalize/capitalize.js
function eo(e) {
	if (typeof e != "string") throw Error(process.env.NODE_ENV === "production" ? Pa(7) : "MUI: `capitalize(string)` expects a string argument.");
	return e.charAt(0).toUpperCase() + e.slice(1);
}
//#endregion
//#region ../../node_modules/.pnpm/react-is@19.3.1/node_modules/react-is/cjs/react-is.production.js
var to = /* @__PURE__ */ ua(((e) => {
	var t = Symbol.for("react.transitional.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), o = Symbol.for("react.consumer"), s = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), p = Symbol.for("react.view_transition"), m = Symbol.for("react.client.reference");
	function h(e) {
		if (typeof e == "object" && e) {
			var m = e.$$typeof;
			switch (m) {
				case t: switch (e = e.type, e) {
					case r:
					case a:
					case i:
					case l:
					case u:
					case p: return e;
					default: switch (e &&= e.$$typeof, e) {
						case s:
						case c:
						case f:
						case d: return e;
						case o: return e;
						default: return m;
					}
				}
				case n: return m;
			}
		}
	}
	e.ContextConsumer = o, e.ContextProvider = s, e.Element = t, e.ForwardRef = c, e.Fragment = r, e.Lazy = f, e.Memo = d, e.Portal = n, e.Profiler = a, e.StrictMode = i, e.Suspense = l, e.SuspenseList = u, e.isContextConsumer = function(e) {
		return h(e) === o;
	}, e.isContextProvider = function(e) {
		return h(e) === s;
	}, e.isElement = function(e) {
		return typeof e == "object" && !!e && e.$$typeof === t;
	}, e.isForwardRef = function(e) {
		return h(e) === c;
	}, e.isFragment = function(e) {
		return h(e) === r;
	}, e.isLazy = function(e) {
		return h(e) === f;
	}, e.isMemo = function(e) {
		return h(e) === d;
	}, e.isPortal = function(e) {
		return h(e) === n;
	}, e.isProfiler = function(e) {
		return h(e) === a;
	}, e.isStrictMode = function(e) {
		return h(e) === i;
	}, e.isSuspense = function(e) {
		return h(e) === l;
	}, e.isSuspenseList = function(e) {
		return h(e) === u;
	}, e.isValidElementType = function(e) {
		return !!(typeof e == "string" || typeof e == "function" || e === r || e === a || e === i || e === l || e === u || e === p || typeof e == "object" && e && (e.$$typeof === f || e.$$typeof === d || e.$$typeof === s || e.$$typeof === o || e.$$typeof === c || e.$$typeof === m || e.getModuleId !== void 0));
	}, e.typeOf = h;
})), no = /* @__PURE__ */ ua(((e) => {
	process.env.NODE_ENV !== "production" && (function() {
		function t(e) {
			if (typeof e == "object" && e) {
				var t = e.$$typeof;
				switch (t) {
					case n: switch (e = e.type, e) {
						case i:
						case o:
						case a:
						case u:
						case d:
						case m: return e;
						default: switch (e &&= e.$$typeof, e) {
							case c:
							case l:
							case p:
							case f: return e;
							case s: return e;
							default: return t;
						}
					}
					case r: return t;
				}
			}
		}
		var n = Symbol.for("react.transitional.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.consumer"), c = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), m = Symbol.for("react.view_transition"), h = Symbol.for("react.client.reference");
		e.ContextConsumer = s, e.ContextProvider = c, e.Element = n, e.ForwardRef = l, e.Fragment = i, e.Lazy = p, e.Memo = f, e.Portal = r, e.Profiler = o, e.StrictMode = a, e.Suspense = u, e.SuspenseList = d, e.isContextConsumer = function(e) {
			return t(e) === s;
		}, e.isContextProvider = function(e) {
			return t(e) === c;
		}, e.isElement = function(e) {
			return typeof e == "object" && !!e && e.$$typeof === n;
		}, e.isForwardRef = function(e) {
			return t(e) === l;
		}, e.isFragment = function(e) {
			return t(e) === i;
		}, e.isLazy = function(e) {
			return t(e) === p;
		}, e.isMemo = function(e) {
			return t(e) === f;
		}, e.isPortal = function(e) {
			return t(e) === r;
		}, e.isProfiler = function(e) {
			return t(e) === o;
		}, e.isStrictMode = function(e) {
			return t(e) === a;
		}, e.isSuspense = function(e) {
			return t(e) === u;
		}, e.isSuspenseList = function(e) {
			return t(e) === d;
		}, e.isValidElementType = function(e) {
			return !!(typeof e == "string" || typeof e == "function" || e === i || e === o || e === a || e === u || e === d || e === m || typeof e == "object" && e && (e.$$typeof === p || e.$$typeof === f || e.$$typeof === c || e.$$typeof === s || e.$$typeof === l || e.$$typeof === h || e.getModuleId !== void 0));
		}, e.typeOf = t;
	})();
})), ro = (/* @__PURE__ */ ua(((e, t) => {
	t.exports = process.env.NODE_ENV === "production" ? to() : no();
})))();
function io(e) {
	if (typeof e != "object" || !e) return !1;
	let t = Object.getPrototypeOf(e);
	return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function ao(e) {
	if (/*#__PURE__*/ ur.isValidElement(e) || (0, ro.isValidElementType)(e) || !io(e)) return e;
	let t = {};
	return Object.keys(e).forEach((n) => {
		t[n] = ao(e[n]);
	}), t;
}
function oo(e, t, n = { clone: !0 }) {
	let r = n.clone ? { ...e } : e;
	return io(e) && io(t) && Object.keys(t).forEach((i) => {
		/*#__PURE__*/ ur.isValidElement(t[i]) || (0, ro.isValidElementType)(t[i]) ? r[i] = t[i] : io(t[i]) && Object.prototype.hasOwnProperty.call(e, i) && io(e[i]) ? r[i] = oo(e[i], t[i], n) : n.clone ? r[i] = io(t[i]) ? ao(t[i]) : t[i] : r[i] = t[i];
	}), r;
}
//#endregion
//#region ../../node_modules/.pnpm/@mui+system@7.2.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.7_supports-col_c8417fe77d490541767d031a2823cb25/node_modules/@mui/system/esm/merge/merge.js
function so(e, t) {
	return t ? oo(e, t, { clone: !1 }) : e;
}
//#endregion
//#region ../../node_modules/.pnpm/@mui+system@7.2.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.7_supports-col_c8417fe77d490541767d031a2823cb25/node_modules/@mui/system/esm/responsivePropType/responsivePropType.js
var co = /* @__PURE__ */ pa(Na()), lo = process.env.NODE_ENV === "production" ? {} : co.default.oneOfType([
	co.default.number,
	co.default.string,
	co.default.object,
	co.default.array
]);
//#endregion
//#region ../../node_modules/.pnpm/@mui+system@7.2.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.7_supports-col_c8417fe77d490541767d031a2823cb25/node_modules/@mui/system/esm/cssContainerQueries/cssContainerQueries.js
function uo(e, t) {
	if (!e.containerQueries) return t;
	let n = Object.keys(t).filter((e) => e.startsWith("@container")).sort((e, t) => {
		let n = /min-width:\s*([0-9.]+)/;
		return (e.match(n)?.[1] || 0) - +(t.match(n)?.[1] || 0);
	});
	return n.length ? n.reduce((e, n) => {
		let r = t[n];
		return delete e[n], e[n] = r, e;
	}, { ...t }) : t;
}
function fo(e, t) {
	return t === "@" || t.startsWith("@") && (e.some((e) => t.startsWith(`@${e}`)) || !!t.match(/^@\d/));
}
function po(e, t) {
	let n = t.match(/^@([^/]+)?\/?(.+)?$/);
	if (!n) {
		if (process.env.NODE_ENV !== "production") throw Error(process.env.NODE_ENV === "production" ? Pa(18, `(${t})`) : `MUI: The provided shorthand ${`(${t})`} is invalid. The format should be \`@<breakpoint | number>\` or \`@<breakpoint | number>/<container>\`.\nFor example, \`@sm\` or \`@600\` or \`@40rem/sidebar\`.`);
		return null;
	}
	let [, r, i] = n, a = Number.isNaN(+r) ? r || 0 : +r;
	return e.containerQueries(i).up(a);
}
function mo(e) {
	let t = (e, t) => e.replace("@media", t ? `@container ${t}` : "@container");
	function n(n, r) {
		n.up = (...n) => t(e.breakpoints.up(...n), r), n.down = (...n) => t(e.breakpoints.down(...n), r), n.between = (...n) => t(e.breakpoints.between(...n), r), n.only = (...n) => t(e.breakpoints.only(...n), r), n.not = (...n) => {
			let i = t(e.breakpoints.not(...n), r);
			return i.includes("not all and") ? i.replace("not all and ", "").replace("min-width:", "width<").replace("max-width:", "width>").replace("and", "or") : i;
		};
	}
	let r = {}, i = (e) => (n(r, e), r);
	return n(i), {
		...e,
		containerQueries: i
	};
}
//#endregion
//#region ../../node_modules/.pnpm/@mui+system@7.2.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.7_supports-col_c8417fe77d490541767d031a2823cb25/node_modules/@mui/system/esm/breakpoints/breakpoints.js
var ho = {
	xs: 0,
	sm: 600,
	md: 900,
	lg: 1200,
	xl: 1536
}, go = {
	keys: [
		"xs",
		"sm",
		"md",
		"lg",
		"xl"
	],
	up: (e) => `@media (min-width:${ho[e]}px)`
}, _o = { containerQueries: (e) => ({ up: (t) => {
	let n = typeof t == "number" ? t : ho[t] || t;
	return typeof n == "number" && (n = `${n}px`), e ? `@container ${e} (min-width:${n})` : `@container (min-width:${n})`;
} }) };
function vo(e, t, n) {
	let r = e.theme || {};
	if (Array.isArray(t)) {
		let e = r.breakpoints || go;
		return t.reduce((r, i, a) => (r[e.up(e.keys[a])] = n(t[a]), r), {});
	}
	if (typeof t == "object") {
		let e = r.breakpoints || go;
		return Object.keys(t).reduce((i, a) => {
			if (fo(e.keys, a)) {
				let e = po(r.containerQueries ? r : _o, a);
				e && (i[e] = n(t[a], a));
			} else if (Object.keys(e.values || ho).includes(a)) {
				let r = e.up(a);
				i[r] = n(t[a], a);
			} else {
				let e = a;
				i[e] = t[e];
			}
			return i;
		}, {});
	}
	return n(t);
}
function yo(e = {}) {
	return e.keys?.reduce((t, n) => {
		let r = e.up(n);
		return t[r] = {}, t;
	}, {}) || {};
}
function bo(e, t) {
	return e.reduce((e, t) => {
		let n = e[t];
		return (!n || Object.keys(n).length === 0) && delete e[t], e;
	}, t);
}
//#endregion
//#region ../../node_modules/.pnpm/@mui+system@7.2.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.7_supports-col_c8417fe77d490541767d031a2823cb25/node_modules/@mui/system/esm/style/style.js
function xo(e, t, n = !0) {
	if (!t || typeof t != "string") return null;
	if (e && e.vars && n) {
		let n = `vars.${t}`.split(".").reduce((e, t) => e && e[t] ? e[t] : null, e);
		if (n != null) return n;
	}
	return t.split(".").reduce((e, t) => e && e[t] != null ? e[t] : null, e);
}
function So(e, t, n, r = n) {
	let i;
	return i = typeof e == "function" ? e(n) : Array.isArray(e) ? e[n] || r : xo(e, n) || r, t && (i = t(i, r, e)), i;
}
function Co(e) {
	let { prop: t, cssProperty: n = e.prop, themeKey: r, transform: i } = e, a = (e) => {
		if (e[t] == null) return null;
		let a = e[t], o = e.theme, s = xo(o, r) || {};
		return vo(e, a, (e) => {
			let r = So(s, i, e);
			return e === r && typeof e == "string" && (r = So(s, i, `${t}${e === "default" ? "" : eo(e)}`, e)), n === !1 ? r : { [n]: r };
		});
	};
	return a.propTypes = process.env.NODE_ENV === "production" ? {} : { [t]: lo }, a.filterProps = [t], a;
}
//#endregion
//#region ../../node_modules/.pnpm/@mui+system@7.2.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.7_supports-col_c8417fe77d490541767d031a2823cb25/node_modules/@mui/system/esm/memoize/memoize.js
function wo(e) {
	let t = {};
	return (n) => (t[n] === void 0 && (t[n] = e(n)), t[n]);
}
//#endregion
//#region ../../node_modules/.pnpm/@mui+system@7.2.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.7_supports-col_c8417fe77d490541767d031a2823cb25/node_modules/@mui/system/esm/spacing/spacing.js
var To = {
	m: "margin",
	p: "padding"
}, Eo = {
	t: "Top",
	r: "Right",
	b: "Bottom",
	l: "Left",
	x: ["Left", "Right"],
	y: ["Top", "Bottom"]
}, Do = {
	marginX: "mx",
	marginY: "my",
	paddingX: "px",
	paddingY: "py"
}, Oo = wo((e) => {
	if (e.length > 2) {
		if (Do[e]) e = Do[e];
		else return [e];
	}
	let [t, n] = e.split(""), r = To[t], i = Eo[n] || "";
	return Array.isArray(i) ? i.map((e) => r + e) : [r + i];
}), ko = [
	"m",
	"mt",
	"mr",
	"mb",
	"ml",
	"mx",
	"my",
	"margin",
	"marginTop",
	"marginRight",
	"marginBottom",
	"marginLeft",
	"marginX",
	"marginY",
	"marginInline",
	"marginInlineStart",
	"marginInlineEnd",
	"marginBlock",
	"marginBlockStart",
	"marginBlockEnd"
], Ao = [
	"p",
	"pt",
	"pr",
	"pb",
	"pl",
	"px",
	"py",
	"padding",
	"paddingTop",
	"paddingRight",
	"paddingBottom",
	"paddingLeft",
	"paddingX",
	"paddingY",
	"paddingInline",
	"paddingInlineStart",
	"paddingInlineEnd",
	"paddingBlock",
	"paddingBlockStart",
	"paddingBlockEnd"
], jo = [...ko, ...Ao];
function Mo(e, t, n, r) {
	let i = xo(e, t, !0) ?? n;
	return typeof i == "number" || typeof i == "string" ? (e) => typeof e == "string" ? e : (process.env.NODE_ENV !== "production" && typeof e != "number" && console.error(`MUI: Expected ${r} argument to be a number or a string, got ${e}.`), typeof i == "string" ? i.startsWith("var(") && e === 0 ? 0 : i.startsWith("var(") && e === 1 ? i : `calc(${e} * ${i})` : i * e) : Array.isArray(i) ? (e) => {
		if (typeof e == "string") return e;
		let n = Math.abs(e);
		process.env.NODE_ENV !== "production" && (Number.isInteger(n) ? n > i.length - 1 && console.error([
			`MUI: The value provided (${n}) overflows.`,
			`The supported values are: ${JSON.stringify(i)}.`,
			`${n} > ${i.length - 1}, you need to add the missing values.`
		].join("\n")) : console.error([`MUI: The \`theme.${t}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${t}\` as a number.`].join("\n")));
		let r = i[n];
		return e >= 0 ? r : typeof r == "number" ? -r : typeof r == "string" && r.startsWith("var(") ? `calc(-1 * ${r})` : `-${r}`;
	} : typeof i == "function" ? i : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${t}\` value (${i}) is invalid.`, "It should be a number, an array or a function."].join("\n")), () => void 0);
}
function No(e) {
	return Mo(e, "spacing", 8, "spacing");
}
function Po(e, t) {
	return typeof t == "string" || t == null ? t : e(t);
}
function Fo(e, t) {
	return (n) => e.reduce((e, r) => (e[r] = Po(t, n), e), {});
}
function Io(e, t, n, r) {
	if (!t.includes(n)) return null;
	let i = Fo(Oo(n), r), a = e[n];
	return vo(e, a, i);
}
function Lo(e, t) {
	let n = No(e.theme);
	return Object.keys(e).map((r) => Io(e, t, r, n)).reduce(so, {});
}
function Ro(e) {
	return Lo(e, ko);
}
Ro.propTypes = process.env.NODE_ENV === "production" ? {} : ko.reduce((e, t) => (e[t] = lo, e), {}), Ro.filterProps = ko;
function zo(e) {
	return Lo(e, Ao);
}
zo.propTypes = process.env.NODE_ENV === "production" ? {} : Ao.reduce((e, t) => (e[t] = lo, e), {}), zo.filterProps = Ao, process.env.NODE_ENV === "production" || jo.reduce((e, t) => (e[t] = lo, e), {});
//#endregion
//#region ../../node_modules/.pnpm/@mui+system@7.2.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.7_supports-col_c8417fe77d490541767d031a2823cb25/node_modules/@mui/system/esm/compose/compose.js
function Bo(...e) {
	let t = e.reduce((e, t) => (t.filterProps.forEach((n) => {
		e[n] = t;
	}), e), {}), n = (e) => Object.keys(e).reduce((n, r) => t[r] ? so(n, t[r](e)) : n, {});
	return n.propTypes = process.env.NODE_ENV === "production" ? {} : e.reduce((e, t) => Object.assign(e, t.propTypes), {}), n.filterProps = e.reduce((e, t) => e.concat(t.filterProps), []), n;
}
//#endregion
//#region ../../node_modules/.pnpm/@mui+system@7.2.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.7_supports-col_c8417fe77d490541767d031a2823cb25/node_modules/@mui/system/esm/borders/borders.js
function Vo(e) {
	return typeof e == "number" ? `${e}px solid` : e;
}
function Ho(e, t) {
	return Co({
		prop: e,
		themeKey: "borders",
		transform: t
	});
}
var Uo = Ho("border", Vo), Wo = Ho("borderTop", Vo), Go = Ho("borderRight", Vo), Ko = Ho("borderBottom", Vo), qo = Ho("borderLeft", Vo), Jo = Ho("borderColor"), Yo = Ho("borderTopColor"), Xo = Ho("borderRightColor"), Zo = Ho("borderBottomColor"), Qo = Ho("borderLeftColor"), $o = Ho("outline", Vo), es = Ho("outlineColor"), ts = (e) => {
	if (e.borderRadius !== void 0 && e.borderRadius !== null) {
		let t = Mo(e.theme, "shape.borderRadius", 4, "borderRadius");
		return vo(e, e.borderRadius, (e) => ({ borderRadius: Po(t, e) }));
	}
	return null;
};
ts.propTypes = process.env.NODE_ENV === "production" ? {} : { borderRadius: lo }, ts.filterProps = ["borderRadius"], Bo(Uo, Wo, Go, Ko, qo, Jo, Yo, Xo, Zo, Qo, ts, $o, es);
//#endregion
//#region ../../node_modules/.pnpm/@mui+system@7.2.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.7_supports-col_c8417fe77d490541767d031a2823cb25/node_modules/@mui/system/esm/cssGrid/cssGrid.js
var ns = (e) => {
	if (e.gap !== void 0 && e.gap !== null) {
		let t = Mo(e.theme, "spacing", 8, "gap");
		return vo(e, e.gap, (e) => ({ gap: Po(t, e) }));
	}
	return null;
};
ns.propTypes = process.env.NODE_ENV === "production" ? {} : { gap: lo }, ns.filterProps = ["gap"];
var rs = (e) => {
	if (e.columnGap !== void 0 && e.columnGap !== null) {
		let t = Mo(e.theme, "spacing", 8, "columnGap");
		return vo(e, e.columnGap, (e) => ({ columnGap: Po(t, e) }));
	}
	return null;
};
rs.propTypes = process.env.NODE_ENV === "production" ? {} : { columnGap: lo }, rs.filterProps = ["columnGap"];
var is = (e) => {
	if (e.rowGap !== void 0 && e.rowGap !== null) {
		let t = Mo(e.theme, "spacing", 8, "rowGap");
		return vo(e, e.rowGap, (e) => ({ rowGap: Po(t, e) }));
	}
	return null;
};
is.propTypes = process.env.NODE_ENV === "production" ? {} : { rowGap: lo }, is.filterProps = ["rowGap"], Bo(ns, rs, is, Co({ prop: "gridColumn" }), Co({ prop: "gridRow" }), Co({ prop: "gridAutoFlow" }), Co({ prop: "gridAutoColumns" }), Co({ prop: "gridAutoRows" }), Co({ prop: "gridTemplateColumns" }), Co({ prop: "gridTemplateRows" }), Co({ prop: "gridTemplateAreas" }), Co({ prop: "gridArea" }));
//#endregion
//#region ../../node_modules/.pnpm/@mui+system@7.2.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.7_supports-col_c8417fe77d490541767d031a2823cb25/node_modules/@mui/system/esm/palette/palette.js
function as(e, t) {
	return t === "grey" ? t : e;
}
Bo(Co({
	prop: "color",
	themeKey: "palette",
	transform: as
}), Co({
	prop: "bgcolor",
	cssProperty: "backgroundColor",
	themeKey: "palette",
	transform: as
}), Co({
	prop: "backgroundColor",
	themeKey: "palette",
	transform: as
}));
//#endregion
//#region ../../node_modules/.pnpm/@mui+system@7.2.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.7_supports-col_c8417fe77d490541767d031a2823cb25/node_modules/@mui/system/esm/sizing/sizing.js
function os(e) {
	return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
var ss = Co({
	prop: "width",
	transform: os
}), cs = (e) => e.maxWidth !== void 0 && e.maxWidth !== null ? vo(e, e.maxWidth, (t) => {
	let n = e.theme?.breakpoints?.values?.[t] || ho[t];
	return n ? e.theme?.breakpoints?.unit === "px" ? { maxWidth: n } : { maxWidth: `${n}${e.theme.breakpoints.unit}` } : { maxWidth: os(t) };
}) : null;
cs.filterProps = ["maxWidth"];
var ls = Co({
	prop: "minWidth",
	transform: os
}), us = Co({
	prop: "height",
	transform: os
}), ds = Co({
	prop: "maxHeight",
	transform: os
}), fs = Co({
	prop: "minHeight",
	transform: os
});
Co({
	prop: "size",
	cssProperty: "width",
	transform: os
}), Co({
	prop: "size",
	cssProperty: "height",
	transform: os
}), Bo(ss, cs, ls, us, ds, fs, Co({ prop: "boxSizing" }));
//#endregion
//#region ../../node_modules/.pnpm/@mui+system@7.2.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.7_supports-col_c8417fe77d490541767d031a2823cb25/node_modules/@mui/system/esm/styleFunctionSx/defaultSxConfig.js
var ps = {
	border: {
		themeKey: "borders",
		transform: Vo
	},
	borderTop: {
		themeKey: "borders",
		transform: Vo
	},
	borderRight: {
		themeKey: "borders",
		transform: Vo
	},
	borderBottom: {
		themeKey: "borders",
		transform: Vo
	},
	borderLeft: {
		themeKey: "borders",
		transform: Vo
	},
	borderColor: { themeKey: "palette" },
	borderTopColor: { themeKey: "palette" },
	borderRightColor: { themeKey: "palette" },
	borderBottomColor: { themeKey: "palette" },
	borderLeftColor: { themeKey: "palette" },
	outline: {
		themeKey: "borders",
		transform: Vo
	},
	outlineColor: { themeKey: "palette" },
	borderRadius: {
		themeKey: "shape.borderRadius",
		style: ts
	},
	color: {
		themeKey: "palette",
		transform: as
	},
	bgcolor: {
		themeKey: "palette",
		cssProperty: "backgroundColor",
		transform: as
	},
	backgroundColor: {
		themeKey: "palette",
		transform: as
	},
	p: { style: zo },
	pt: { style: zo },
	pr: { style: zo },
	pb: { style: zo },
	pl: { style: zo },
	px: { style: zo },
	py: { style: zo },
	padding: { style: zo },
	paddingTop: { style: zo },
	paddingRight: { style: zo },
	paddingBottom: { style: zo },
	paddingLeft: { style: zo },
	paddingX: { style: zo },
	paddingY: { style: zo },
	paddingInline: { style: zo },
	paddingInlineStart: { style: zo },
	paddingInlineEnd: { style: zo },
	paddingBlock: { style: zo },
	paddingBlockStart: { style: zo },
	paddingBlockEnd: { style: zo },
	m: { style: Ro },
	mt: { style: Ro },
	mr: { style: Ro },
	mb: { style: Ro },
	ml: { style: Ro },
	mx: { style: Ro },
	my: { style: Ro },
	margin: { style: Ro },
	marginTop: { style: Ro },
	marginRight: { style: Ro },
	marginBottom: { style: Ro },
	marginLeft: { style: Ro },
	marginX: { style: Ro },
	marginY: { style: Ro },
	marginInline: { style: Ro },
	marginInlineStart: { style: Ro },
	marginInlineEnd: { style: Ro },
	marginBlock: { style: Ro },
	marginBlockStart: { style: Ro },
	marginBlockEnd: { style: Ro },
	displayPrint: {
		cssProperty: !1,
		transform: (e) => ({ "@media print": { display: e } })
	},
	display: {},
	overflow: {},
	textOverflow: {},
	visibility: {},
	whiteSpace: {},
	flexBasis: {},
	flexDirection: {},
	flexWrap: {},
	justifyContent: {},
	alignItems: {},
	alignContent: {},
	order: {},
	flex: {},
	flexGrow: {},
	flexShrink: {},
	alignSelf: {},
	justifyItems: {},
	justifySelf: {},
	gap: { style: ns },
	rowGap: { style: is },
	columnGap: { style: rs },
	gridColumn: {},
	gridRow: {},
	gridAutoFlow: {},
	gridAutoColumns: {},
	gridAutoRows: {},
	gridTemplateColumns: {},
	gridTemplateRows: {},
	gridTemplateAreas: {},
	gridArea: {},
	position: {},
	zIndex: { themeKey: "zIndex" },
	top: {},
	right: {},
	bottom: {},
	left: {},
	boxShadow: { themeKey: "shadows" },
	width: { transform: os },
	maxWidth: { style: cs },
	minWidth: { transform: os },
	height: { transform: os },
	maxHeight: { transform: os },
	minHeight: { transform: os },
	boxSizing: {},
	font: { themeKey: "font" },
	fontFamily: { themeKey: "typography" },
	fontSize: { themeKey: "typography" },
	fontStyle: { themeKey: "typography" },
	fontWeight: { themeKey: "typography" },
	letterSpacing: {},
	textTransform: {},
	lineHeight: {},
	textAlign: {},
	typography: {
		cssProperty: !1,
		themeKey: "typography"
	}
};
//#endregion
//#region ../../node_modules/.pnpm/@mui+system@7.2.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.7_supports-col_c8417fe77d490541767d031a2823cb25/node_modules/@mui/system/esm/styleFunctionSx/styleFunctionSx.js
function ms(...e) {
	let t = e.reduce((e, t) => e.concat(Object.keys(t)), []), n = new Set(t);
	return e.every((e) => n.size === Object.keys(e).length);
}
function hs(e, t) {
	return typeof e == "function" ? e(t) : e;
}
function gs() {
	function e(e, t, n, r) {
		let i = {
			[e]: t,
			theme: n
		}, a = r[e];
		if (!a) return { [e]: t };
		let { cssProperty: o = e, themeKey: s, transform: c, style: l } = a;
		if (t == null) return null;
		if (s === "typography" && t === "inherit") return { [e]: t };
		let u = xo(n, s) || {};
		return l ? l(i) : vo(i, t, (t) => {
			let n = So(u, c, t);
			return t === n && typeof t == "string" && (n = So(u, c, `${e}${t === "default" ? "" : eo(t)}`, t)), o === !1 ? n : { [o]: n };
		});
	}
	function t(n) {
		let { sx: r, theme: i = {}, nested: a } = n || {};
		if (!r) return null;
		let o = i.unstable_sxConfig ?? ps;
		function s(n) {
			let r = n;
			if (typeof n == "function") r = n(i);
			else if (typeof n != "object") return n;
			if (!r) return null;
			let s = yo(i.breakpoints), c = Object.keys(s), l = s;
			return Object.keys(r).forEach((n) => {
				let a = hs(r[n], i);
				if (a != null) {
					if (typeof a == "object") {
						if (o[n]) l = so(l, e(n, a, i, o));
						else {
							let e = vo({ theme: i }, a, (e) => ({ [n]: e }));
							ms(e, a) ? l[n] = t({
								sx: a,
								theme: i,
								nested: !0
							}) : l = so(l, e);
						}
					} else l = so(l, e(n, a, i, o));
				}
			}), !a && i.modularCssLayers ? { "@layer sx": uo(i, bo(c, l)) } : uo(i, bo(c, l));
		}
		return Array.isArray(r) ? r.map(s) : s(r);
	}
	return t;
}
var _s = gs();
_s.filterProps = ["sx"];
//#endregion
//#region ../../node_modules/.pnpm/@mui+system@7.2.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.7_supports-col_c8417fe77d490541767d031a2823cb25/node_modules/@mui/system/esm/createBreakpoints/createBreakpoints.js
var vs = (e) => {
	let t = Object.keys(e).map((t) => ({
		key: t,
		val: e[t]
	})) || [];
	return t.sort((e, t) => e.val - t.val), t.reduce((e, t) => ({
		...e,
		[t.key]: t.val
	}), {});
};
function ys(e) {
	let { values: t = {
		xs: 0,
		sm: 600,
		md: 900,
		lg: 1200,
		xl: 1536
	}, unit: n = "px", step: r = 5, ...i } = e, a = vs(t), o = Object.keys(a);
	function s(e) {
		return `@media (min-width:${typeof t[e] == "number" ? t[e] : e}${n})`;
	}
	function c(e) {
		return `@media (max-width:${(typeof t[e] == "number" ? t[e] : e) - r / 100}${n})`;
	}
	function l(e, i) {
		let a = o.indexOf(i);
		return `@media (min-width:${typeof t[e] == "number" ? t[e] : e}${n}) and (max-width:${(a !== -1 && typeof t[o[a]] == "number" ? t[o[a]] : i) - r / 100}${n})`;
	}
	function u(e) {
		return o.indexOf(e) + 1 < o.length ? l(e, o[o.indexOf(e) + 1]) : s(e);
	}
	function d(e) {
		let t = o.indexOf(e);
		return t === 0 ? s(o[1]) : t === o.length - 1 ? c(o[t]) : l(e, o[o.indexOf(e) + 1]).replace("@media", "@media not all and");
	}
	return {
		keys: o,
		values: a,
		up: s,
		down: c,
		between: l,
		only: u,
		not: d,
		unit: n,
		...i
	};
}
//#endregion
//#region ../../node_modules/.pnpm/@mui+system@7.2.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.7_supports-col_c8417fe77d490541767d031a2823cb25/node_modules/@mui/system/esm/createTheme/shape.js
var bs = { borderRadius: 4 };
//#endregion
//#region ../../node_modules/.pnpm/@mui+system@7.2.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.7_supports-col_c8417fe77d490541767d031a2823cb25/node_modules/@mui/system/esm/createTheme/createSpacing.js
function xs(e = 8, t = No({ spacing: e })) {
	if (e.mui) return e;
	let n = (...e) => (process.env.NODE_ENV !== "production" && (e.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${e.length}`)), (e.length === 0 ? [1] : e).map((e) => {
		let n = t(e);
		return typeof n == "number" ? `${n}px` : n;
	}).join(" "));
	return n.mui = !0, n;
}
//#endregion
//#region ../../node_modules/.pnpm/@mui+system@7.2.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.7_supports-col_c8417fe77d490541767d031a2823cb25/node_modules/@mui/system/esm/createTheme/applyStyles.js
function Ss(e, t) {
	let n = this;
	if (n.vars) {
		if (!n.colorSchemes?.[e] || typeof n.getColorSchemeSelector != "function") return {};
		let r = n.getColorSchemeSelector(e);
		return r === "&" ? t : ((r.includes("data-") || r.includes(".")) && (r = `*:where(${r.replace(/\s*&$/, "")}) &`), { [r]: t });
	}
	return n.palette.mode === e ? t : {};
}
//#endregion
//#region ../../node_modules/.pnpm/@mui+system@7.2.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.7_supports-col_c8417fe77d490541767d031a2823cb25/node_modules/@mui/system/esm/createTheme/createTheme.js
function Cs(e = {}, ...t) {
	let { breakpoints: n = {}, palette: r = {}, spacing: i, shape: a = {}, ...o } = e, s = ys(n), c = xs(i), l = oo({
		breakpoints: s,
		direction: "ltr",
		components: {},
		palette: {
			mode: "light",
			...r
		},
		spacing: c,
		shape: {
			...bs,
			...a
		}
	}, o);
	return l = mo(l), l.applyStyles = Ss, l = t.reduce((e, t) => oo(e, t), l), l.unstable_sxConfig = {
		...ps,
		...o?.unstable_sxConfig
	}, l.unstable_sx = function(e) {
		return _s({
			sx: e,
			theme: this
		});
	}, l;
}
//#endregion
//#region ../../node_modules/.pnpm/@mui+system@7.2.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.7_supports-col_c8417fe77d490541767d031a2823cb25/node_modules/@mui/system/esm/cssVars/createGetCssVar.js
function ws(e = "") {
	function t(...n) {
		if (!n.length) return "";
		let r = n[0];
		return typeof r == "string" && !r.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/) ? `, var(--${e ? `${e}-` : ""}${r}${t(...n.slice(1))})` : `, ${r}`;
	}
	return (n, ...r) => `var(--${e ? `${e}-` : ""}${n}${t(...r)})`;
}
//#endregion
//#region ../../node_modules/.pnpm/@mui+system@7.2.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.7_supports-col_c8417fe77d490541767d031a2823cb25/node_modules/@mui/system/esm/cssVars/cssVarsParser.js
var Ts = (e, t, n, r = []) => {
	let i = e;
	t.forEach((e, a) => {
		a === t.length - 1 ? Array.isArray(i) ? i[Number(e)] = n : i && typeof i == "object" && (i[e] = n) : i && typeof i == "object" && (i[e] || (i[e] = r.includes(e) ? [] : {}), i = i[e]);
	});
}, Es = (e, t, n) => {
	function r(e, i = [], a = []) {
		Object.entries(e).forEach(([e, o]) => {
			(!n || n && !n([...i, e])) && o != null && (typeof o == "object" && Object.keys(o).length > 0 ? r(o, [...i, e], Array.isArray(o) ? [...a, e] : a) : t([...i, e], o, a));
		});
	}
	r(e);
}, Ds = (e, t) => typeof t == "number" ? [
	"lineHeight",
	"fontWeight",
	"opacity",
	"zIndex"
].some((t) => e.includes(t)) || e[e.length - 1].toLowerCase().includes("opacity") ? t : `${t}px` : t;
function Os(e, t) {
	let { prefix: n, shouldSkipGeneratingVar: r } = t || {}, i = {}, a = {}, o = {};
	return Es(e, (e, t, s) => {
		if ((typeof t == "string" || typeof t == "number") && (!r || !r(e, t))) {
			let r = `--${n ? `${n}-` : ""}${e.join("-")}`, c = Ds(e, t);
			Object.assign(i, { [r]: c }), Ts(a, e, `var(${r})`, s), Ts(o, e, `var(${r}, ${c})`, s);
		}
	}, (e) => e[0] === "vars"), {
		css: i,
		vars: a,
		varsWithDefaults: o
	};
}
//#endregion
//#region ../../node_modules/.pnpm/@mui+system@7.2.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.7_supports-col_c8417fe77d490541767d031a2823cb25/node_modules/@mui/system/esm/cssVars/prepareCssVars.js
function ks(e, t = {}) {
	let { getSelector: n = g, disableCssColorScheme: r, colorSchemeSelector: i } = t, { colorSchemes: a = {}, components: o, defaultColorScheme: s = "light", ...c } = e, { vars: l, css: u, varsWithDefaults: d } = Os(c, t), f = d, p = {}, { [s]: m, ...h } = a;
	if (Object.entries(h || {}).forEach(([e, n]) => {
		let { vars: r, css: i, varsWithDefaults: a } = Os(n, t);
		f = oo(f, a), p[e] = {
			css: i,
			vars: r
		};
	}), m) {
		let { css: e, vars: n, varsWithDefaults: r } = Os(m, t);
		f = oo(f, r), p[s] = {
			css: e,
			vars: n
		};
	}
	function g(t, n) {
		let r = i;
		if (i === "class" && (r = ".%s"), i === "data" && (r = "[data-%s]"), i?.startsWith("data-") && !i.includes("%s") && (r = `[${i}="%s"]`), t) {
			if (r === "media") return e.defaultColorScheme === t ? ":root" : { [`@media (prefers-color-scheme: ${a[t]?.palette?.mode || t})`]: { ":root": n } };
			if (r) return e.defaultColorScheme === t ? `:root, ${r.replace("%s", String(t))}` : r.replace("%s", String(t));
		}
		return ":root";
	}
	return {
		vars: f,
		generateThemeVars: () => {
			let e = { ...l };
			return Object.entries(p).forEach(([, { vars: t }]) => {
				e = oo(e, t);
			}), e;
		},
		generateStyleSheets: () => {
			let t = [], i = e.defaultColorScheme || "light";
			function o(e, n) {
				Object.keys(n).length && t.push(typeof e == "string" ? { [e]: { ...n } } : e);
			}
			o(n(void 0, { ...u }), u);
			let { [i]: s, ...c } = p;
			if (s) {
				let { css: e } = s, t = a[i]?.palette?.mode, c = !r && t ? {
					colorScheme: t,
					...e
				} : { ...e };
				o(n(i, { ...c }), c);
			}
			return Object.entries(c).forEach(([e, { css: t }]) => {
				let i = a[e]?.palette?.mode, s = !r && i ? {
					colorScheme: i,
					...t
				} : { ...t };
				o(n(e, { ...s }), s);
			}), t;
		}
	};
}
//#endregion
//#region ../../node_modules/.pnpm/@mui+system@7.2.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.7_supports-col_c8417fe77d490541767d031a2823cb25/node_modules/@mui/system/esm/cssVars/getColorSchemeSelector.js
function As(e) {
	return function(t) {
		return e === "media" ? (process.env.NODE_ENV !== "production" && t !== "light" && t !== "dark" && console.error(`MUI: @media (prefers-color-scheme) supports only 'light' or 'dark', but receive '${t}'.`), `@media (prefers-color-scheme: ${t})`) : e ? e.startsWith("data-") && !e.includes("%s") ? `[${e}="${t}"] &` : e === "class" ? `.${t} &` : e === "data" ? `[data-${t}] &` : `${e.replace("%s", t)} &` : "&";
	};
}
//#endregion
//#region ../../node_modules/.pnpm/react-is@19.1.1/node_modules/react-is/cjs/react-is.production.js
var js = /* @__PURE__ */ ua(((e) => {
	var t = Symbol.for("react.transitional.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), o = Symbol.for("react.consumer"), s = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), p = Symbol.for("react.view_transition"), m = Symbol.for("react.client.reference");
	function h(e) {
		if (typeof e == "object" && e) {
			var m = e.$$typeof;
			switch (m) {
				case t: switch (e = e.type, e) {
					case r:
					case a:
					case i:
					case l:
					case u:
					case p: return e;
					default: switch (e &&= e.$$typeof, e) {
						case s:
						case c:
						case f:
						case d: return e;
						case o: return e;
						default: return m;
					}
				}
				case n: return m;
			}
		}
	}
	e.ContextConsumer = o, e.ContextProvider = s, e.Element = t, e.ForwardRef = c, e.Fragment = r, e.Lazy = f, e.Memo = d, e.Portal = n, e.Profiler = a, e.StrictMode = i, e.Suspense = l, e.SuspenseList = u, e.isContextConsumer = function(e) {
		return h(e) === o;
	}, e.isContextProvider = function(e) {
		return h(e) === s;
	}, e.isElement = function(e) {
		return typeof e == "object" && !!e && e.$$typeof === t;
	}, e.isForwardRef = function(e) {
		return h(e) === c;
	}, e.isFragment = function(e) {
		return h(e) === r;
	}, e.isLazy = function(e) {
		return h(e) === f;
	}, e.isMemo = function(e) {
		return h(e) === d;
	}, e.isPortal = function(e) {
		return h(e) === n;
	}, e.isProfiler = function(e) {
		return h(e) === a;
	}, e.isStrictMode = function(e) {
		return h(e) === i;
	}, e.isSuspense = function(e) {
		return h(e) === l;
	}, e.isSuspenseList = function(e) {
		return h(e) === u;
	}, e.isValidElementType = function(e) {
		return !!(typeof e == "string" || typeof e == "function" || e === r || e === a || e === i || e === l || e === u || typeof e == "object" && e && (e.$$typeof === f || e.$$typeof === d || e.$$typeof === s || e.$$typeof === o || e.$$typeof === c || e.$$typeof === m || e.getModuleId !== void 0));
	}, e.typeOf = h;
})), Ms = /* @__PURE__ */ ua(((e) => {
	process.env.NODE_ENV !== "production" && (function() {
		function t(e) {
			if (typeof e == "object" && e) {
				var t = e.$$typeof;
				switch (t) {
					case n: switch (e = e.type, e) {
						case i:
						case o:
						case a:
						case u:
						case d:
						case m: return e;
						default: switch (e &&= e.$$typeof, e) {
							case c:
							case l:
							case p:
							case f: return e;
							case s: return e;
							default: return t;
						}
					}
					case r: return t;
				}
			}
		}
		var n = Symbol.for("react.transitional.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.consumer"), c = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), m = Symbol.for("react.view_transition"), h = Symbol.for("react.client.reference");
		e.ContextConsumer = s, e.ContextProvider = c, e.Element = n, e.ForwardRef = l, e.Fragment = i, e.Lazy = p, e.Memo = f, e.Portal = r, e.Profiler = o, e.StrictMode = a, e.Suspense = u, e.SuspenseList = d, e.isContextConsumer = function(e) {
			return t(e) === s;
		}, e.isContextProvider = function(e) {
			return t(e) === c;
		}, e.isElement = function(e) {
			return typeof e == "object" && !!e && e.$$typeof === n;
		}, e.isForwardRef = function(e) {
			return t(e) === l;
		}, e.isFragment = function(e) {
			return t(e) === i;
		}, e.isLazy = function(e) {
			return t(e) === p;
		}, e.isMemo = function(e) {
			return t(e) === f;
		}, e.isPortal = function(e) {
			return t(e) === r;
		}, e.isProfiler = function(e) {
			return t(e) === o;
		}, e.isStrictMode = function(e) {
			return t(e) === a;
		}, e.isSuspense = function(e) {
			return t(e) === u;
		}, e.isSuspenseList = function(e) {
			return t(e) === d;
		}, e.isValidElementType = function(e) {
			return !!(typeof e == "string" || typeof e == "function" || e === i || e === o || e === a || e === u || e === d || typeof e == "object" && e && (e.$$typeof === p || e.$$typeof === f || e.$$typeof === c || e.$$typeof === s || e.$$typeof === l || e.$$typeof === h || e.getModuleId !== void 0));
		}, e.typeOf = t;
	})();
})), Ns = (/* @__PURE__ */ ua(((e, t) => {
	t.exports = process.env.NODE_ENV === "production" ? js() : Ms();
})))();
function Ps(e) {
	if (typeof e != "object" || !e) return !1;
	let t = Object.getPrototypeOf(e);
	return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function Fs(e) {
	if (/*#__PURE__*/ ur.isValidElement(e) || (0, Ns.isValidElementType)(e) || !Ps(e)) return e;
	let t = {};
	return Object.keys(e).forEach((n) => {
		t[n] = Fs(e[n]);
	}), t;
}
function Is(e, t, n = { clone: !0 }) {
	let r = n.clone ? { ...e } : e;
	return Ps(e) && Ps(t) && Object.keys(t).forEach((i) => {
		/*#__PURE__*/ ur.isValidElement(t[i]) || (0, Ns.isValidElementType)(t[i]) ? r[i] = t[i] : Ps(t[i]) && Object.prototype.hasOwnProperty.call(e, i) && Ps(e[i]) ? r[i] = Is(e[i], t[i], n) : n.clone ? r[i] = Ps(t[i]) ? Fs(t[i]) : t[i] : r[i] = t[i];
	}), r;
}
//#endregion
//#region ../../node_modules/.pnpm/@mui+material@7.2.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.7_supports-c_18f20615051290c68d46e0696ce1f805/node_modules/@mui/material/esm/colors/common.js
var Ls = {
	black: "#000",
	white: "#fff"
}, Rs = {
	50: "#fafafa",
	100: "#f5f5f5",
	200: "#eeeeee",
	300: "#e0e0e0",
	400: "#bdbdbd",
	500: "#9e9e9e",
	600: "#757575",
	700: "#616161",
	800: "#424242",
	900: "#212121",
	A100: "#f5f5f5",
	A200: "#eeeeee",
	A400: "#bdbdbd",
	A700: "#616161"
}, zs = {
	50: "#f3e5f5",
	100: "#e1bee7",
	200: "#ce93d8",
	300: "#ba68c8",
	400: "#ab47bc",
	500: "#9c27b0",
	600: "#8e24aa",
	700: "#7b1fa2",
	800: "#6a1b9a",
	900: "#4a148c",
	A100: "#ea80fc",
	A200: "#e040fb",
	A400: "#d500f9",
	A700: "#aa00ff"
}, Bs = {
	50: "#ffebee",
	100: "#ffcdd2",
	200: "#ef9a9a",
	300: "#e57373",
	400: "#ef5350",
	500: "#f44336",
	600: "#e53935",
	700: "#d32f2f",
	800: "#c62828",
	900: "#b71c1c",
	A100: "#ff8a80",
	A200: "#ff5252",
	A400: "#ff1744",
	A700: "#d50000"
}, Vs = {
	50: "#fff3e0",
	100: "#ffe0b2",
	200: "#ffcc80",
	300: "#ffb74d",
	400: "#ffa726",
	500: "#ff9800",
	600: "#fb8c00",
	700: "#f57c00",
	800: "#ef6c00",
	900: "#e65100",
	A100: "#ffd180",
	A200: "#ffab40",
	A400: "#ff9100",
	A700: "#ff6d00"
}, Hs = {
	50: "#e3f2fd",
	100: "#bbdefb",
	200: "#90caf9",
	300: "#64b5f6",
	400: "#42a5f5",
	500: "#2196f3",
	600: "#1e88e5",
	700: "#1976d2",
	800: "#1565c0",
	900: "#0d47a1",
	A100: "#82b1ff",
	A200: "#448aff",
	A400: "#2979ff",
	A700: "#2962ff"
}, Us = {
	50: "#e1f5fe",
	100: "#b3e5fc",
	200: "#81d4fa",
	300: "#4fc3f7",
	400: "#29b6f6",
	500: "#03a9f4",
	600: "#039be5",
	700: "#0288d1",
	800: "#0277bd",
	900: "#01579b",
	A100: "#80d8ff",
	A200: "#40c4ff",
	A400: "#00b0ff",
	A700: "#0091ea"
}, Ws = {
	50: "#e8f5e9",
	100: "#c8e6c9",
	200: "#a5d6a7",
	300: "#81c784",
	400: "#66bb6a",
	500: "#4caf50",
	600: "#43a047",
	700: "#388e3c",
	800: "#2e7d32",
	900: "#1b5e20",
	A100: "#b9f6ca",
	A200: "#69f0ae",
	A400: "#00e676",
	A700: "#00c853"
};
//#endregion
//#region ../../node_modules/.pnpm/@mui+material@7.2.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.7_supports-c_18f20615051290c68d46e0696ce1f805/node_modules/@mui/material/esm/styles/createPalette.js
function Gs() {
	return {
		text: {
			primary: "rgba(0, 0, 0, 0.87)",
			secondary: "rgba(0, 0, 0, 0.6)",
			disabled: "rgba(0, 0, 0, 0.38)"
		},
		divider: "rgba(0, 0, 0, 0.12)",
		background: {
			paper: Ls.white,
			default: Ls.white
		},
		action: {
			active: "rgba(0, 0, 0, 0.54)",
			hover: "rgba(0, 0, 0, 0.04)",
			hoverOpacity: .04,
			selected: "rgba(0, 0, 0, 0.08)",
			selectedOpacity: .08,
			disabled: "rgba(0, 0, 0, 0.26)",
			disabledBackground: "rgba(0, 0, 0, 0.12)",
			disabledOpacity: .38,
			focus: "rgba(0, 0, 0, 0.12)",
			focusOpacity: .12,
			activatedOpacity: .12
		}
	};
}
var Ks = Gs();
function qs() {
	return {
		text: {
			primary: Ls.white,
			secondary: "rgba(255, 255, 255, 0.7)",
			disabled: "rgba(255, 255, 255, 0.5)",
			icon: "rgba(255, 255, 255, 0.5)"
		},
		divider: "rgba(255, 255, 255, 0.12)",
		background: {
			paper: "#121212",
			default: "#121212"
		},
		action: {
			active: Ls.white,
			hover: "rgba(255, 255, 255, 0.08)",
			hoverOpacity: .08,
			selected: "rgba(255, 255, 255, 0.16)",
			selectedOpacity: .16,
			disabled: "rgba(255, 255, 255, 0.3)",
			disabledBackground: "rgba(255, 255, 255, 0.12)",
			disabledOpacity: .38,
			focus: "rgba(255, 255, 255, 0.12)",
			focusOpacity: .12,
			activatedOpacity: .24
		}
	};
}
var Js = qs();
function Ys(e, t, n, r) {
	let i = r.light || r, a = r.dark || r * 1.5;
	e[t] || (e.hasOwnProperty(n) ? e[t] = e[n] : t === "light" ? e.light = Ya(e.main, i) : t === "dark" && (e.dark = qa(e.main, a)));
}
function Xs(e = "light") {
	return e === "dark" ? {
		main: Hs[200],
		light: Hs[50],
		dark: Hs[400]
	} : {
		main: Hs[700],
		light: Hs[400],
		dark: Hs[800]
	};
}
function Zs(e = "light") {
	return e === "dark" ? {
		main: zs[200],
		light: zs[50],
		dark: zs[400]
	} : {
		main: zs[500],
		light: zs[300],
		dark: zs[700]
	};
}
function Qs(e = "light") {
	return e === "dark" ? {
		main: Bs[500],
		light: Bs[300],
		dark: Bs[700]
	} : {
		main: Bs[700],
		light: Bs[400],
		dark: Bs[800]
	};
}
function $s(e = "light") {
	return e === "dark" ? {
		main: Us[400],
		light: Us[300],
		dark: Us[700]
	} : {
		main: Us[700],
		light: Us[500],
		dark: Us[900]
	};
}
function ec(e = "light") {
	return e === "dark" ? {
		main: Ws[400],
		light: Ws[300],
		dark: Ws[700]
	} : {
		main: Ws[800],
		light: Ws[500],
		dark: Ws[900]
	};
}
function tc(e = "light") {
	return e === "dark" ? {
		main: Vs[400],
		light: Vs[300],
		dark: Vs[700]
	} : {
		main: "#ed6c02",
		light: Vs[500],
		dark: Vs[900]
	};
}
function nc(e) {
	let { mode: t = "light", contrastThreshold: n = 3, tonalOffset: r = .2, ...i } = e, a = e.primary || Xs(t), o = e.secondary || Zs(t), s = e.error || Qs(t), c = e.info || $s(t), l = e.success || ec(t), u = e.warning || tc(t);
	function d(e) {
		let t = Wa(e, Js.text.primary) >= n ? Js.text.primary : Ks.text.primary;
		if (process.env.NODE_ENV !== "production") {
			let n = Wa(e, t);
			n < 3 && console.error([
				`MUI: The contrast ratio of ${n}:1 for ${t} on ${e}`,
				"falls below the WCAG recommended absolute minimum contrast ratio of 3:1.",
				"https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"
			].join("\n"));
		}
		return t;
	}
	let f = ({ color: e, name: t, mainShade: n = 500, lightShade: i = 300, darkShade: a = 700 }) => {
		if (e = { ...e }, !e.main && e[n] && (e.main = e[n]), !e.hasOwnProperty("main")) throw Error(process.env.NODE_ENV === "production" ? $a(11, t ? ` (${t})` : "", n) : `MUI: The color${t ? ` (${t})` : ""} provided to augmentColor(color) is invalid.\nThe color object needs to have a \`main\` property or a \`${n}\` property.`);
		if (typeof e.main != "string") throw Error(process.env.NODE_ENV === "production" ? $a(12, t ? ` (${t})` : "", JSON.stringify(e.main)) : `MUI: The color${t ? ` (${t})` : ""} provided to augmentColor(color) is invalid.\n\`color.main\` should be a string, but \`${JSON.stringify(e.main)}\` was provided instead.\n
Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });`);
		return Ys(e, "light", i, r), Ys(e, "dark", a, r), e.contrastText || (e.contrastText = d(e.main)), e;
	}, p;
	return t === "light" ? p = Gs() : t === "dark" && (p = qs()), process.env.NODE_ENV !== "production" && (p || console.error(`MUI: The palette mode \`${t}\` is not supported.`)), Is({
		common: { ...Ls },
		mode: t,
		primary: f({
			color: a,
			name: "primary"
		}),
		secondary: f({
			color: o,
			name: "secondary",
			mainShade: "A400",
			lightShade: "A200",
			darkShade: "A700"
		}),
		error: f({
			color: s,
			name: "error"
		}),
		warning: f({
			color: u,
			name: "warning"
		}),
		info: f({
			color: c,
			name: "info"
		}),
		success: f({
			color: l,
			name: "success"
		}),
		grey: Rs,
		contrastThreshold: n,
		getContrastText: d,
		augmentColor: f,
		tonalOffset: r,
		...p
	}, i);
}
//#endregion
//#region ../../node_modules/.pnpm/@mui+system@7.2.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.7_supports-col_c8417fe77d490541767d031a2823cb25/node_modules/@mui/system/esm/cssVars/prepareTypographyVars.js
function rc(e) {
	let t = {};
	return Object.entries(e).forEach((e) => {
		let [n, r] = e;
		typeof r == "object" && (t[n] = `${r.fontStyle ? `${r.fontStyle} ` : ""}${r.fontVariant ? `${r.fontVariant} ` : ""}${r.fontWeight ? `${r.fontWeight} ` : ""}${r.fontStretch ? `${r.fontStretch} ` : ""}${r.fontSize || ""}${r.lineHeight ? `/${r.lineHeight} ` : ""}${r.fontFamily || ""}`);
	}), t;
}
//#endregion
//#region ../../node_modules/.pnpm/@mui+utils@7.2.0_@types+react@19.2.14_react@19.2.7/node_modules/@mui/utils/esm/ClassNameGenerator/ClassNameGenerator.js
var ic = (e) => e, ac = (() => {
	let e = ic;
	return {
		configure(t) {
			e = t;
		},
		generate(t) {
			return e(t);
		},
		reset() {
			e = ic;
		}
	};
})(), oc = {
	active: "active",
	checked: "checked",
	completed: "completed",
	disabled: "disabled",
	error: "error",
	expanded: "expanded",
	focused: "focused",
	focusVisible: "focusVisible",
	open: "open",
	readOnly: "readOnly",
	required: "required",
	selected: "selected"
};
function sc(e, t, n = "Mui") {
	let r = oc[t];
	return r ? `${n}-${r}` : `${ac.generate(e)}-${t}`;
}
//#endregion
//#region ../../node_modules/.pnpm/@mui+material@7.2.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.7_supports-c_18f20615051290c68d46e0696ce1f805/node_modules/@mui/material/esm/styles/createMixins.js
function cc(e, t) {
	return {
		toolbar: {
			minHeight: 56,
			[e.up("xs")]: { "@media (orientation: landscape)": { minHeight: 48 } },
			[e.up("sm")]: { minHeight: 64 }
		},
		...t
	};
}
//#endregion
//#region ../../node_modules/.pnpm/@mui+material@7.2.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.7_supports-c_18f20615051290c68d46e0696ce1f805/node_modules/@mui/material/esm/styles/createTypography.js
function lc(e) {
	return Math.round(e * 1e5) / 1e5;
}
var uc = { textTransform: "uppercase" }, dc = "\"Roboto\", \"Helvetica\", \"Arial\", sans-serif";
function fc(e, t) {
	let { fontFamily: n = dc, fontSize: r = 14, fontWeightLight: i = 300, fontWeightRegular: a = 400, fontWeightMedium: o = 500, fontWeightBold: s = 700, htmlFontSize: c = 16, allVariants: l, pxToRem: u, ...d } = typeof t == "function" ? t(e) : t;
	process.env.NODE_ENV !== "production" && (typeof r != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof c != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
	let f = r / 14, p = u || ((e) => `${e / c * f}rem`), m = (e, t, r, i, a) => ({
		fontFamily: n,
		fontWeight: e,
		fontSize: p(t),
		lineHeight: r,
		...n === dc ? { letterSpacing: `${lc(i / t)}em` } : {},
		...a,
		...l
	});
	return Is({
		htmlFontSize: c,
		pxToRem: p,
		fontFamily: n,
		fontSize: r,
		fontWeightLight: i,
		fontWeightRegular: a,
		fontWeightMedium: o,
		fontWeightBold: s,
		h1: m(i, 96, 1.167, -1.5),
		h2: m(i, 60, 1.2, -.5),
		h3: m(a, 48, 1.167, 0),
		h4: m(a, 34, 1.235, .25),
		h5: m(a, 24, 1.334, 0),
		h6: m(o, 20, 1.6, .15),
		subtitle1: m(a, 16, 1.75, .15),
		subtitle2: m(o, 14, 1.57, .1),
		body1: m(a, 16, 1.5, .15),
		body2: m(a, 14, 1.43, .15),
		button: m(o, 14, 1.75, .4, uc),
		caption: m(a, 12, 1.66, .4),
		overline: m(a, 12, 2.66, 1, uc),
		inherit: {
			fontFamily: "inherit",
			fontWeight: "inherit",
			fontSize: "inherit",
			lineHeight: "inherit",
			letterSpacing: "inherit"
		}
	}, d, { clone: !1 });
}
//#endregion
//#region ../../node_modules/.pnpm/@mui+material@7.2.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.7_supports-c_18f20615051290c68d46e0696ce1f805/node_modules/@mui/material/esm/styles/shadows.js
var pc = .2, mc = .14, hc = .12;
function gc(...e) {
	return [
		`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${pc})`,
		`${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${mc})`,
		`${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${hc})`
	].join(",");
}
var _c = [
	"none",
	gc(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
	gc(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
	gc(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
	gc(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
	gc(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
	gc(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
	gc(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
	gc(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
	gc(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
	gc(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
	gc(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
	gc(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
	gc(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
	gc(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
	gc(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
	gc(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
	gc(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
	gc(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
	gc(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
	gc(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
	gc(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
	gc(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
	gc(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
	gc(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
], vc = {
	easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
	easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
	easeIn: "cubic-bezier(0.4, 0, 1, 1)",
	sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, yc = {
	shortest: 150,
	shorter: 200,
	short: 250,
	standard: 300,
	complex: 375,
	enteringScreen: 225,
	leavingScreen: 195
};
function bc(e) {
	return `${Math.round(e)}ms`;
}
function xc(e) {
	if (!e) return 0;
	let t = e / 36;
	return Math.min(Math.round((4 + 15 * t ** .25 + t / 5) * 10), 3e3);
}
function Sc(e) {
	let t = {
		...vc,
		...e.easing
	}, n = {
		...yc,
		...e.duration
	};
	return {
		getAutoHeightDuration: xc,
		create: (e = ["all"], r = {}) => {
			let { duration: i = n.standard, easing: a = t.easeInOut, delay: o = 0, ...s } = r;
			if (process.env.NODE_ENV !== "production") {
				let t = (e) => typeof e == "string", n = (e) => !Number.isNaN(parseFloat(e));
				!t(e) && !Array.isArray(e) && console.error("MUI: Argument \"props\" must be a string or Array."), !n(i) && !t(i) && console.error(`MUI: Argument "duration" must be a number or a string but found ${i}.`), t(a) || console.error("MUI: Argument \"easing\" must be a string."), !n(o) && !t(o) && console.error("MUI: Argument \"delay\" must be a number or a string."), typeof r != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join("\n")), Object.keys(s).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(s).join(",")}].`);
			}
			return (Array.isArray(e) ? e : [e]).map((e) => `${e} ${typeof i == "string" ? i : bc(i)} ${a} ${typeof o == "string" ? o : bc(o)}`).join(",");
		},
		...e,
		easing: t,
		duration: n
	};
}
//#endregion
//#region ../../node_modules/.pnpm/@mui+material@7.2.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.7_supports-c_18f20615051290c68d46e0696ce1f805/node_modules/@mui/material/esm/styles/zIndex.js
var Cc = {
	mobileStepper: 1e3,
	fab: 1050,
	speedDial: 1050,
	appBar: 1100,
	drawer: 1200,
	modal: 1300,
	snackbar: 1400,
	tooltip: 1500
};
//#endregion
//#region ../../node_modules/.pnpm/@mui+material@7.2.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.7_supports-c_18f20615051290c68d46e0696ce1f805/node_modules/@mui/material/esm/styles/stringifyTheme.js
function wc(e) {
	return Ps(e) || e === void 0 || typeof e == "string" || typeof e == "boolean" || typeof e == "number" || Array.isArray(e);
}
function Tc(e = {}) {
	let t = { ...e };
	function n(e) {
		let t = Object.entries(e);
		for (let r = 0; r < t.length; r++) {
			let [i, a] = t[r];
			!wc(a) || i.startsWith("unstable_") ? delete e[i] : Ps(a) && (e[i] = { ...a }, n(e[i]));
		}
	}
	return n(t), `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(t, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}
//#endregion
//#region ../../node_modules/.pnpm/@mui+material@7.2.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.7_supports-c_18f20615051290c68d46e0696ce1f805/node_modules/@mui/material/esm/styles/createThemeNoVars.js
function Ec(e = {}, ...t) {
	let { breakpoints: n, mixins: r = {}, spacing: i, palette: a = {}, transitions: o = {}, typography: s = {}, shape: c, ...l } = e;
	if (e.vars && e.generateThemeVars === void 0) throw Error(process.env.NODE_ENV === "production" ? $a(20) : "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name or follow the [docs](https://mui.com/material-ui/customization/css-theme-variables/usage/) to enable the feature.");
	let u = nc(a), d = Cs(e), f = Is(d, {
		mixins: cc(d.breakpoints, r),
		palette: u,
		shadows: _c.slice(),
		typography: fc(u, s),
		transitions: Sc(o),
		zIndex: { ...Cc }
	});
	if (f = Is(f, l), f = t.reduce((e, t) => Is(e, t), f), process.env.NODE_ENV !== "production") {
		let e = [
			"active",
			"checked",
			"completed",
			"disabled",
			"error",
			"expanded",
			"focused",
			"focusVisible",
			"required",
			"selected"
		], t = (t, n) => {
			let r;
			for (r in t) {
				let i = t[r];
				if (e.includes(r) && Object.keys(i).length > 0) {
					if (process.env.NODE_ENV !== "production") {
						let e = sc("", r);
						console.error([
							`MUI: The \`${n}\` component increases the CSS specificity of the \`${r}\` internal state.`,
							"You can not override it like this: ",
							JSON.stringify(t, null, 2),
							"",
							`Instead, you need to use the '&.${e}' syntax:`,
							JSON.stringify({ root: { [`&.${e}`]: i } }, null, 2),
							"",
							"https://mui.com/r/state-classes-guide"
						].join("\n"));
					}
					t[r] = {};
				}
			}
		};
		Object.keys(f.components).forEach((e) => {
			let n = f.components[e].styleOverrides;
			n && e.startsWith("Mui") && t(n, e);
		});
	}
	return f.unstable_sxConfig = {
		...ps,
		...l?.unstable_sxConfig
	}, f.unstable_sx = function(e) {
		return _s({
			sx: e,
			theme: this
		});
	}, f.toRuntimeSource = Tc, f;
}
//#endregion
//#region ../../node_modules/.pnpm/@mui+material@7.2.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.7_supports-c_18f20615051290c68d46e0696ce1f805/node_modules/@mui/material/esm/styles/getOverlayAlpha.js
function Dc(e) {
	let t;
	return t = e < 1 ? 5.11916 * e ** 2 : 4.5 * Math.log(e + 1) + 2, Math.round(t * 10) / 1e3;
}
//#endregion
//#region ../../node_modules/.pnpm/@mui+material@7.2.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.7_supports-c_18f20615051290c68d46e0696ce1f805/node_modules/@mui/material/esm/styles/createColorScheme.js
var Oc = [...Array(25)].map((e, t) => {
	if (t === 0) return "none";
	let n = Dc(t);
	return `linear-gradient(rgba(255 255 255 / ${n}), rgba(255 255 255 / ${n}))`;
});
function kc(e) {
	return {
		inputPlaceholder: e === "dark" ? .5 : .42,
		inputUnderline: e === "dark" ? .7 : .42,
		switchTrackDisabled: e === "dark" ? .2 : .12,
		switchTrack: e === "dark" ? .3 : .38
	};
}
function Ac(e) {
	return e === "dark" ? Oc : [];
}
function jc(e) {
	let { palette: t = { mode: "light" }, opacity: n, overlays: r, ...i } = e, a = nc(t);
	return {
		palette: a,
		opacity: {
			...kc(a.mode),
			...n
		},
		overlays: r || Ac(a.mode),
		...i
	};
}
//#endregion
//#region ../../node_modules/.pnpm/@mui+material@7.2.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.7_supports-c_18f20615051290c68d46e0696ce1f805/node_modules/@mui/material/esm/styles/shouldSkipGeneratingVar.js
function Mc(e) {
	return !!e[0].match(/(cssVarPrefix|colorSchemeSelector|modularCssLayers|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!e[0].match(/sxConfig$/) || e[0] === "palette" && !!e[1]?.match(/(mode|contrastThreshold|tonalOffset)/);
}
//#endregion
//#region ../../node_modules/.pnpm/@mui+material@7.2.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.7_supports-c_18f20615051290c68d46e0696ce1f805/node_modules/@mui/material/esm/styles/excludeVariablesFromRoot.js
var Nc = (e) => [
	...[...Array(25)].map((t, n) => `--${e ? `${e}-` : ""}overlays-${n}`),
	`--${e ? `${e}-` : ""}palette-AppBar-darkBg`,
	`--${e ? `${e}-` : ""}palette-AppBar-darkColor`
], Pc = (e) => (t, n) => {
	let r = e.rootSelector || ":root", i = e.colorSchemeSelector, a = i;
	if (i === "class" && (a = ".%s"), i === "data" && (a = "[data-%s]"), i?.startsWith("data-") && !i.includes("%s") && (a = `[${i}="%s"]`), e.defaultColorScheme === t) {
		if (t === "dark") {
			let i = {};
			return Nc(e.cssVarPrefix).forEach((e) => {
				i[e] = n[e], delete n[e];
			}), a === "media" ? {
				[r]: n,
				"@media (prefers-color-scheme: dark)": { [r]: i }
			} : a ? {
				[a.replace("%s", t)]: i,
				[`${r}, ${a.replace("%s", t)}`]: n
			} : { [r]: {
				...n,
				...i
			} };
		}
		if (a && a !== "media") return `${r}, ${a.replace("%s", String(t))}`;
	} else if (t) {
		if (a === "media") return { [`@media (prefers-color-scheme: ${String(t)})`]: { [r]: n } };
		if (a) return a.replace("%s", String(t));
	}
	return r;
};
//#endregion
//#region ../../node_modules/.pnpm/@mui+material@7.2.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.7_supports-c_18f20615051290c68d46e0696ce1f805/node_modules/@mui/material/esm/styles/createThemeWithVars.js
function Fc(e, t) {
	t.forEach((t) => {
		e[t] || (e[t] = {});
	});
}
function Z(e, t, n) {
	!e[t] && n && (e[t] = n);
}
function Ic(e) {
	return typeof e != "string" || !e.startsWith("hsl") ? e : Ha(e);
}
function Lc(e, t) {
	`${t}Channel` in e || (e[`${t}Channel`] = Ba(Ic(e[t]), `MUI: Can't create \`palette.${t}Channel\` because \`palette.${t}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().
To suppress this warning, you need to explicitly provide the \`palette.${t}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`));
}
function Rc(e) {
	return typeof e == "number" ? `${e}px` : typeof e == "string" || typeof e == "function" || Array.isArray(e) ? e : "8px";
}
var zc = (e) => {
	try {
		return e();
	} catch {}
}, Bc = (e = "mui") => ws(e);
function Vc(e, t, n, r) {
	if (!t) return;
	t = t === !0 ? {} : t;
	let i = r === "dark" ? "dark" : "light";
	if (!n) {
		e[r] = jc({
			...t,
			palette: {
				mode: i,
				...t?.palette
			}
		});
		return;
	}
	let { palette: a, ...o } = Ec({
		...n,
		palette: {
			mode: i,
			...t?.palette
		}
	});
	return e[r] = {
		...t,
		palette: a,
		opacity: {
			...kc(i),
			...t?.opacity
		},
		overlays: t?.overlays || Ac(i)
	}, o;
}
function Hc(e = {}, ...t) {
	let { colorSchemes: n = { light: !0 }, defaultColorScheme: r, disableCssColorScheme: i = !1, cssVarPrefix: a = "mui", shouldSkipGeneratingVar: o = Mc, colorSchemeSelector: s = n.light && n.dark ? "media" : void 0, rootSelector: c = ":root", ...l } = e, u = Object.keys(n)[0], d = r || (n.light && u !== "light" ? "light" : u), f = Bc(a), { [d]: p, light: m, dark: h, ...g } = n, _ = { ...g }, v = p;
	if ((d === "dark" && !("dark" in n) || d === "light" && !("light" in n)) && (v = !0), !v) throw Error(process.env.NODE_ENV === "production" ? $a(21, d) : `MUI: The \`colorSchemes.${d}\` option is either missing or invalid.`);
	let y = Vc(_, v, l, d);
	m && !_.light && Vc(_, m, void 0, "light"), h && !_.dark && Vc(_, h, void 0, "dark");
	let b = {
		defaultColorScheme: d,
		...y,
		cssVarPrefix: a,
		colorSchemeSelector: s,
		rootSelector: c,
		getCssVar: f,
		colorSchemes: _,
		font: {
			...rc(y.typography),
			...y.font
		},
		spacing: Rc(l.spacing)
	};
	Object.keys(b.colorSchemes).forEach((e) => {
		let t = b.colorSchemes[e].palette, n = (e) => {
			let n = e.split("-"), r = n[1], i = n[2];
			return f(e, t[r][i]);
		};
		if (t.mode === "light" && (Z(t.common, "background", "#fff"), Z(t.common, "onBackground", "#000")), t.mode === "dark" && (Z(t.common, "background", "#000"), Z(t.common, "onBackground", "#fff")), Fc(t, [
			"Alert",
			"AppBar",
			"Avatar",
			"Button",
			"Chip",
			"FilledInput",
			"LinearProgress",
			"Skeleton",
			"Slider",
			"SnackbarContent",
			"SpeedDialAction",
			"StepConnector",
			"StepContent",
			"Switch",
			"TableCell",
			"Tooltip"
		]), t.mode === "light") {
			Z(t.Alert, "errorColor", Ja(t.error.light, .6)), Z(t.Alert, "infoColor", Ja(t.info.light, .6)), Z(t.Alert, "successColor", Ja(t.success.light, .6)), Z(t.Alert, "warningColor", Ja(t.warning.light, .6)), Z(t.Alert, "errorFilledBg", n("palette-error-main")), Z(t.Alert, "infoFilledBg", n("palette-info-main")), Z(t.Alert, "successFilledBg", n("palette-success-main")), Z(t.Alert, "warningFilledBg", n("palette-warning-main")), Z(t.Alert, "errorFilledColor", zc(() => t.getContrastText(t.error.main))), Z(t.Alert, "infoFilledColor", zc(() => t.getContrastText(t.info.main))), Z(t.Alert, "successFilledColor", zc(() => t.getContrastText(t.success.main))), Z(t.Alert, "warningFilledColor", zc(() => t.getContrastText(t.warning.main))), Z(t.Alert, "errorStandardBg", Xa(t.error.light, .9)), Z(t.Alert, "infoStandardBg", Xa(t.info.light, .9)), Z(t.Alert, "successStandardBg", Xa(t.success.light, .9)), Z(t.Alert, "warningStandardBg", Xa(t.warning.light, .9)), Z(t.Alert, "errorIconColor", n("palette-error-main")), Z(t.Alert, "infoIconColor", n("palette-info-main")), Z(t.Alert, "successIconColor", n("palette-success-main")), Z(t.Alert, "warningIconColor", n("palette-warning-main")), Z(t.AppBar, "defaultBg", n("palette-grey-100")), Z(t.Avatar, "defaultBg", n("palette-grey-400")), Z(t.Button, "inheritContainedBg", n("palette-grey-300")), Z(t.Button, "inheritContainedHoverBg", n("palette-grey-A100")), Z(t.Chip, "defaultBorder", n("palette-grey-400")), Z(t.Chip, "defaultAvatarColor", n("palette-grey-700")), Z(t.Chip, "defaultIconColor", n("palette-grey-700")), Z(t.FilledInput, "bg", "rgba(0, 0, 0, 0.06)"), Z(t.FilledInput, "hoverBg", "rgba(0, 0, 0, 0.09)"), Z(t.FilledInput, "disabledBg", "rgba(0, 0, 0, 0.12)"), Z(t.LinearProgress, "primaryBg", Xa(t.primary.main, .62)), Z(t.LinearProgress, "secondaryBg", Xa(t.secondary.main, .62)), Z(t.LinearProgress, "errorBg", Xa(t.error.main, .62)), Z(t.LinearProgress, "infoBg", Xa(t.info.main, .62)), Z(t.LinearProgress, "successBg", Xa(t.success.main, .62)), Z(t.LinearProgress, "warningBg", Xa(t.warning.main, .62)), Z(t.Skeleton, "bg", `rgba(${n("palette-text-primaryChannel")} / 0.11)`), Z(t.Slider, "primaryTrack", Xa(t.primary.main, .62)), Z(t.Slider, "secondaryTrack", Xa(t.secondary.main, .62)), Z(t.Slider, "errorTrack", Xa(t.error.main, .62)), Z(t.Slider, "infoTrack", Xa(t.info.main, .62)), Z(t.Slider, "successTrack", Xa(t.success.main, .62)), Z(t.Slider, "warningTrack", Xa(t.warning.main, .62));
			let e = Qa(t.background.default, .8);
			Z(t.SnackbarContent, "bg", e), Z(t.SnackbarContent, "color", zc(() => t.getContrastText(e))), Z(t.SpeedDialAction, "fabHoverBg", Qa(t.background.paper, .15)), Z(t.StepConnector, "border", n("palette-grey-400")), Z(t.StepContent, "border", n("palette-grey-400")), Z(t.Switch, "defaultColor", n("palette-common-white")), Z(t.Switch, "defaultDisabledColor", n("palette-grey-100")), Z(t.Switch, "primaryDisabledColor", Xa(t.primary.main, .62)), Z(t.Switch, "secondaryDisabledColor", Xa(t.secondary.main, .62)), Z(t.Switch, "errorDisabledColor", Xa(t.error.main, .62)), Z(t.Switch, "infoDisabledColor", Xa(t.info.main, .62)), Z(t.Switch, "successDisabledColor", Xa(t.success.main, .62)), Z(t.Switch, "warningDisabledColor", Xa(t.warning.main, .62)), Z(t.TableCell, "border", Xa(Ka(t.divider, 1), .88)), Z(t.Tooltip, "bg", Ka(t.grey[700], .92));
		}
		if (t.mode === "dark") {
			Z(t.Alert, "errorColor", Xa(t.error.light, .6)), Z(t.Alert, "infoColor", Xa(t.info.light, .6)), Z(t.Alert, "successColor", Xa(t.success.light, .6)), Z(t.Alert, "warningColor", Xa(t.warning.light, .6)), Z(t.Alert, "errorFilledBg", n("palette-error-dark")), Z(t.Alert, "infoFilledBg", n("palette-info-dark")), Z(t.Alert, "successFilledBg", n("palette-success-dark")), Z(t.Alert, "warningFilledBg", n("palette-warning-dark")), Z(t.Alert, "errorFilledColor", zc(() => t.getContrastText(t.error.dark))), Z(t.Alert, "infoFilledColor", zc(() => t.getContrastText(t.info.dark))), Z(t.Alert, "successFilledColor", zc(() => t.getContrastText(t.success.dark))), Z(t.Alert, "warningFilledColor", zc(() => t.getContrastText(t.warning.dark))), Z(t.Alert, "errorStandardBg", Ja(t.error.light, .9)), Z(t.Alert, "infoStandardBg", Ja(t.info.light, .9)), Z(t.Alert, "successStandardBg", Ja(t.success.light, .9)), Z(t.Alert, "warningStandardBg", Ja(t.warning.light, .9)), Z(t.Alert, "errorIconColor", n("palette-error-main")), Z(t.Alert, "infoIconColor", n("palette-info-main")), Z(t.Alert, "successIconColor", n("palette-success-main")), Z(t.Alert, "warningIconColor", n("palette-warning-main")), Z(t.AppBar, "defaultBg", n("palette-grey-900")), Z(t.AppBar, "darkBg", n("palette-background-paper")), Z(t.AppBar, "darkColor", n("palette-text-primary")), Z(t.Avatar, "defaultBg", n("palette-grey-600")), Z(t.Button, "inheritContainedBg", n("palette-grey-800")), Z(t.Button, "inheritContainedHoverBg", n("palette-grey-700")), Z(t.Chip, "defaultBorder", n("palette-grey-700")), Z(t.Chip, "defaultAvatarColor", n("palette-grey-300")), Z(t.Chip, "defaultIconColor", n("palette-grey-300")), Z(t.FilledInput, "bg", "rgba(255, 255, 255, 0.09)"), Z(t.FilledInput, "hoverBg", "rgba(255, 255, 255, 0.13)"), Z(t.FilledInput, "disabledBg", "rgba(255, 255, 255, 0.12)"), Z(t.LinearProgress, "primaryBg", Ja(t.primary.main, .5)), Z(t.LinearProgress, "secondaryBg", Ja(t.secondary.main, .5)), Z(t.LinearProgress, "errorBg", Ja(t.error.main, .5)), Z(t.LinearProgress, "infoBg", Ja(t.info.main, .5)), Z(t.LinearProgress, "successBg", Ja(t.success.main, .5)), Z(t.LinearProgress, "warningBg", Ja(t.warning.main, .5)), Z(t.Skeleton, "bg", `rgba(${n("palette-text-primaryChannel")} / 0.13)`), Z(t.Slider, "primaryTrack", Ja(t.primary.main, .5)), Z(t.Slider, "secondaryTrack", Ja(t.secondary.main, .5)), Z(t.Slider, "errorTrack", Ja(t.error.main, .5)), Z(t.Slider, "infoTrack", Ja(t.info.main, .5)), Z(t.Slider, "successTrack", Ja(t.success.main, .5)), Z(t.Slider, "warningTrack", Ja(t.warning.main, .5));
			let e = Qa(t.background.default, .98);
			Z(t.SnackbarContent, "bg", e), Z(t.SnackbarContent, "color", zc(() => t.getContrastText(e))), Z(t.SpeedDialAction, "fabHoverBg", Qa(t.background.paper, .15)), Z(t.StepConnector, "border", n("palette-grey-600")), Z(t.StepContent, "border", n("palette-grey-600")), Z(t.Switch, "defaultColor", n("palette-grey-300")), Z(t.Switch, "defaultDisabledColor", n("palette-grey-600")), Z(t.Switch, "primaryDisabledColor", Ja(t.primary.main, .55)), Z(t.Switch, "secondaryDisabledColor", Ja(t.secondary.main, .55)), Z(t.Switch, "errorDisabledColor", Ja(t.error.main, .55)), Z(t.Switch, "infoDisabledColor", Ja(t.info.main, .55)), Z(t.Switch, "successDisabledColor", Ja(t.success.main, .55)), Z(t.Switch, "warningDisabledColor", Ja(t.warning.main, .55)), Z(t.TableCell, "border", Ja(Ka(t.divider, 1), .68)), Z(t.Tooltip, "bg", Ka(t.grey[700], .92));
		}
		Lc(t.background, "default"), Lc(t.background, "paper"), Lc(t.common, "background"), Lc(t.common, "onBackground"), Lc(t, "divider"), Object.keys(t).forEach((e) => {
			let n = t[e];
			e !== "tonalOffset" && n && typeof n == "object" && (n.main && Z(t[e], "mainChannel", Ba(Ic(n.main))), n.light && Z(t[e], "lightChannel", Ba(Ic(n.light))), n.dark && Z(t[e], "darkChannel", Ba(Ic(n.dark))), n.contrastText && Z(t[e], "contrastTextChannel", Ba(Ic(n.contrastText))), e === "text" && (Lc(t[e], "primary"), Lc(t[e], "secondary")), e === "action" && (n.active && Lc(t[e], "active"), n.selected && Lc(t[e], "selected")));
		});
	}), b = t.reduce((e, t) => Is(e, t), b);
	let x = {
		prefix: a,
		disableCssColorScheme: i,
		shouldSkipGeneratingVar: o,
		getSelector: Pc(b)
	}, { vars: S, generateThemeVars: C, generateStyleSheets: w } = ks(b, x);
	return b.vars = S, Object.entries(b.colorSchemes[b.defaultColorScheme]).forEach(([e, t]) => {
		b[e] = t;
	}), b.generateThemeVars = C, b.generateStyleSheets = w, b.generateSpacing = function() {
		return xs(l.spacing, No(this));
	}, b.getColorSchemeSelector = As(s), b.spacing = b.generateSpacing(), b.shouldSkipGeneratingVar = o, b.unstable_sxConfig = {
		...ps,
		...l?.unstable_sxConfig
	}, b.unstable_sx = function(e) {
		return _s({
			sx: e,
			theme: this
		});
	}, b.toRuntimeSource = Tc, b;
}
//#endregion
//#region ../../node_modules/.pnpm/@mui+material@7.2.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.7_supports-c_18f20615051290c68d46e0696ce1f805/node_modules/@mui/material/esm/styles/createTheme.js
function Uc(e, t, n) {
	e.colorSchemes && n && (e.colorSchemes[t] = {
		...n !== !0 && n,
		palette: nc({
			...n === !0 ? {} : n.palette,
			mode: t
		})
	});
}
function Wc(e = {}, ...t) {
	let { palette: n, cssVariables: r = !1, colorSchemes: i = n ? void 0 : { light: !0 }, defaultColorScheme: a = n?.mode, ...o } = e, s = a || "light", c = i?.[s], l = {
		...i,
		...n ? { [s]: {
			...typeof c != "boolean" && c,
			palette: n
		} } : void 0
	};
	if (r === !1) {
		if (!("colorSchemes" in e)) return Ec(e, ...t);
		let r = n;
		"palette" in e || l[s] && (l[s] === !0 ? s === "dark" && (r = { mode: "dark" }) : r = l[s].palette);
		let i = Ec({
			...e,
			palette: r
		}, ...t);
		return i.defaultColorScheme = s, i.colorSchemes = l, i.palette.mode === "light" && (i.colorSchemes.light = {
			...l.light !== !0 && l.light,
			palette: i.palette
		}, Uc(i, "dark", l.dark)), i.palette.mode === "dark" && (i.colorSchemes.dark = {
			...l.dark !== !0 && l.dark,
			palette: i.palette
		}, Uc(i, "light", l.light)), i;
	}
	return !n && !("light" in l) && s === "light" && (l.light = !0), Hc({
		...o,
		colorSchemes: l,
		defaultColorScheme: s,
		...typeof r != "boolean" && r
	}, ...t);
}
//#endregion
//#region ../../node_modules/.pnpm/@mui+utils@7.2.0_@types+react@19.2.14_react@19.2.7/node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.js
function Gc(e, t, n = "Mui") {
	let r = {};
	return t.forEach((t) => {
		r[t] = sc(e, t, n);
	}), r;
}
//#endregion
//#region ../../node_modules/.pnpm/@mui+material@7.2.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.7_supports-c_18f20615051290c68d46e0696ce1f805/node_modules/@mui/material/esm/Checkbox/checkboxClasses.js
var Kc = Gc("MuiCheckbox", [
	"root",
	"checked",
	"disabled",
	"indeterminate",
	"colorPrimary",
	"colorSecondary",
	"sizeSmall",
	"sizeMedium"
]), qc = {
	neutrals: {
		ash: "#242424",
		denseFog: "#CBCBCB",
		eerieBlack: "#1A1A1A",
		fog: "#EEEEEE",
		stormyGray: "#6E6E6E",
		blueCharcoal: "#1A212B"
	},
	navy: {
		base: "#212B36",
		L10: "#2C3640",
		L20: "#424B54",
		L30: "#646B72",
		L40: "#858A90",
		L50: "#A6AAAF",
		L70: "#BCBFC3",
		L80: "#D3D5D7",
		L90: "#E9EAEB",
		L95: "#F4F4F5",
		D10: "#1F2933",
		D20: "#1C252E",
		D30: "#171E26",
		D40: "#12181E",
		D50: "#0D1116"
	},
	orange: {
		base: "#C05621",
		L10: "#C35E2C",
		L20: "#C96F42",
		L30: "#D38964",
		L40: "#DCA285",
		L50: "#E6BBA6",
		L70: "#ECCCBC",
		L80: "#F2DDD3",
		L90: "#F9EEE9",
		D10: "#B6521F",
		D20: "#A3491C",
		D30: "#863C17",
		D40: "#6A2F12",
		D50: "#4D220D"
	},
	darkOrange: {
		D20: "#85381C",
		D30: "#6D2E17"
	},
	tan: {
		base: "#F1EDE9",
		D30: "#A9A6A3",
		D40: "#858280",
		D50: "#605F5D"
	},
	red: {
		base: "#E53E3E",
		L30: "#ED7878",
		L40: "#F19595",
		L50: "#F5B2B2",
		L80: "#FAD8D8",
		D20: "#C33535",
		D30: "#A02B2B",
		D40: "#7E2222"
	},
	cobalt: {
		base: "#1177BB",
		D20: "#2B7491",
		D30: "#245F77",
		D40: "#1C485E",
		D50: "#143644"
	},
	green: {
		L40: "#92CBAC",
		L50: "#AFD9C3",
		D30: "#27714A",
		D50: "#16402A"
	},
	yellow: {
		L40: "#FAEEA6",
		L50: "#FBF3BF",
		D20: "#D1BE50",
		D40: "#877B34",
		D50: "#625A26"
	}
}, Jc = qc.navy.L10, Yc = {
	primary: {
		main: qc.orange.base,
		light: qc.orange.L80
	},
	secondary: {
		main: qc.navy.base,
		dark: qc.navy.D20
	},
	background: {
		default: "rgba(var(--background-primary))",
		paper: "rgba(var(--background-secondary))"
	},
	DataGrid: { bg: "rgba(var(--background-primary))" },
	action: { hover: "rgba(var(--foreground-primary), 0.08)" },
	text: {
		primary: "rgba(var(--text-primary))",
		secondary: "rgba(var(--text-secondary))"
	}
}, Xc = Wc({
	components: {
		MuiPaper: { styleOverrides: { root: {
			backgroundColor: "rgba(var(--background-secondary))",
			color: "rgba(var(--text-primary))",
			backgroundImage: "none"
		} } },
		MuiDataGrid: { styleOverrides: { root: {
			"--DataGrid-rowBorderColor": "rgba(var(--outline-decorative))",
			"& .MuiDataGrid-withBorderColor": { borderColor: "rgba(var(--outline-decorative))" },
			"& .MuiDataGrid-sortIcon, & .MuiDataGrid-menuIconButton, & .MuiDataGrid-filterIcon, & .MuiDataGrid-menuIcon": { color: "rgba(var(--foreground-secondary))" }
		} } },
		MuiListItemIcon: { styleOverrides: { root: { color: "rgba(var(--foreground-secondary))" } } },
		MuiCheckbox: { styleOverrides: { root: {
			color: "rgba(var(--foreground-primary))",
			[`&.${Kc.checked}, &.${Kc.indeterminate}`]: { color: "rgba(var(--foreground-secondary))" }
		} } },
		MuiButton: { styleOverrides: { outlined: { backgroundColor: "rgba(var(--background-primary))" } } }
	},
	palette: Yc,
	typography: { fontFamily: ["DM Sans Variable", "sans-serif"].join(",") }
});
//#endregion
//#region lib/theme/provider.tsx
function Zc(e) {
	let t = K(2), { children: n } = e, r;
	return t[0] === n ? r = t[1] : (r = /* @__PURE__ */ Y(Er, {
		theme: Xc,
		children: n
	}), t[0] = n, t[1] = r), r;
}
//#endregion
//#region lib/utils/navigation.ts
function Qc(e, t) {
	let n = (e) => e.replace(/\/+$/, "") || "/", r = n(e), i = n(t);
	return r === i || r.startsWith(`${i}/`);
}
//#endregion
//#region lib/components/ProviderIcon/formatProvider.ts
var $c = [
	"aws",
	"azure",
	"gcp",
	"tencentcloud",
	"k8s"
];
function el(e) {
	return typeof e == "string" && $c.includes(e);
}
function tl(e) {
	switch (e) {
		case "aws": return "AWS";
		case "azure": return "Azure";
		case "gcp": return "GCP";
		case "tencentcloud": return "TencentCloud";
		case "k8s": return "Kubernetes";
		default: return "AWS";
	}
}
function nl(e) {
	return e ? $c.find((t) => tl(t) === e) : void 0;
}
function rl(e) {
	switch (e) {
		case "aws": return "Amazon Web Services";
		case "azure": return "Microsoft Azure";
		case "gcp": return "Google Cloud Platform";
		case "tencentcloud": return "Tencent Cloud";
		case "k8s": return "Kubernetes";
		default: return "Amazon Web Services";
	}
}
var il = {
	identifierNoun: "account",
	showsIdentifierHint: !0
}, al = {
	AWS: { showsIdentifierHint: !1 },
	Azure: { identifierNoun: "subscription" },
	GCP: { identifierNoun: "project" },
	Kubernetes: {
		identifierNoun: "cluster",
		identifierLabel: "Cluster Key"
	}
};
function ol(e) {
	return {
		...il,
		...al[e]
	};
}
function sl(e) {
	return e.charAt(0).toUpperCase() + e.slice(1);
}
function cl(e) {
	let t = `${e}s`;
	return {
		singular: e,
		singularTitle: sl(e),
		plural: t,
		pluralTitle: sl(t)
	};
}
function ll(e) {
	return cl(ol(e).identifierNoun);
}
function ul(e) {
	let t = ol(e);
	return t.identifierLabel ?? `${sl(t.identifierNoun)} ID`;
}
var dl = /* @__PURE__ */ new Set(["account"]);
function fl(e) {
	return dl.has(e) ? "an" : "a";
}
function pl(e) {
	let t = ol(e);
	if (!t.showsIdentifierHint) return;
	let n = t.identifierNoun;
	return `${sl(fl(n))} ${n} name`;
}
//#endregion
//#region lib/components/ProviderIcon/ProviderIcon.tsx
function ml(e, t) {
	let n = { width: 22 };
	switch (e) {
		case "AWS": return Y(t ? Rt : rt, { ...n });
		case "Azure": return /* @__PURE__ */ Y(Et, { ...n });
		case "GCP": return /* @__PURE__ */ Y(ve, { ...n });
		case "TencentCloud": return /* @__PURE__ */ Y(H, { ...n });
		case "Kubernetes": return /* @__PURE__ */ Y(c, { ...n });
		default: return /* @__PURE__ */ Y(rt, { ...n });
	}
}
function hl(e) {
	let t = K(11), { provider: n, invert: r } = e, i = n === void 0 ? "AWS" : n, a = r !== void 0 && r, o;
	t[0] === i ? o = t[1] : (o = {
		"aria-label": i,
		"data-testid": "provider-tooltip"
	}, t[0] = i, t[1] = o);
	let s;
	t[2] !== a || t[3] !== i ? (s = ml(i, a), t[2] = a, t[3] = i, t[4] = s) : s = t[4];
	let c;
	t[5] === s ? c = t[6] : (c = /* @__PURE__ */ Y("span", { children: s }), t[5] = s, t[6] = c);
	let l;
	return t[7] !== i || t[8] !== o || t[9] !== c ? (l = /* @__PURE__ */ Y("div", {
		className: "flex w-[1.5rem] items-center justify-center text-text-primary",
		children: /* @__PURE__ */ Y(qt, {
			buttonProps: o,
			title: i,
			children: c
		})
	}), t[7] = i, t[8] = o, t[9] = c, t[10] = l) : l = t[10], l;
}
//#endregion
//#region lib/components/shared/FormFieldAssistiveText.tsx
function gl(e) {
	let t = K(11), { children: n, isInvalid: r, isDisabled: i, className: a, id: o } = e, s = r !== void 0 && r, c = i !== void 0 && i;
	if (!n) return null;
	let l = c ? "text-text-disabled" : void 0, u = s ? "text-text-negative" : void 0, d;
	t[0] !== a || t[1] !== l || t[2] !== u ? (d = W("flex items-center gap-x-xxs text-label-small text-text-secondary", l, u, a), t[0] = a, t[1] = l, t[2] = u, t[3] = d) : d = t[3];
	let f;
	t[4] === s ? f = t[5] : (f = s ? /* @__PURE__ */ Y(le, {
		"aria-hidden": "true",
		className: "shrink-0",
		size: 16
	}) : null, t[4] = s, t[5] = f);
	let p;
	return t[6] !== n || t[7] !== o || t[8] !== d || t[9] !== f ? (p = /* @__PURE__ */ X(Ki, {
		className: d,
		id: o,
		slot: "description",
		children: [f, n]
	}), t[6] = n, t[7] = o, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}
//#endregion
//#region lib/components/Checkbox/Checkbox.styles.ts
var _l = G({
	base: "w-4 h-4 shrink-0 rounded-[.125rem] flex items-center justify-center border transition",
	variants: {
		isSelected: {
			false: "bg-background-primary border-outline-input-enabled focus:border-outline-input-focus",
			true: "bg-brand-primary border-brand-primary focus:bg-interactive-primary-button-focus-background"
		},
		isInvalid: { true: "text-text-negative border-text-negative" },
		isDisabled: { true: "border-interactive-disabled-outline" },
		isHovered: { true: "" },
		isFocused: { true: "" }
	},
	compoundVariants: [
		{
			isSelected: !1,
			isHovered: !0,
			class: "border-outline-input-hover"
		},
		{
			isSelected: !1,
			isFocused: !0,
			class: "border-outline-input-focus"
		},
		{
			isSelected: !0,
			isHovered: !0,
			class: "bg-interactive-primary-button-hover-background border-interactive-primary-button-hover-background"
		},
		{
			isSelected: !0,
			isFocused: !0,
			class: "bg-interactive-primary-button-focus-background border-interactive-primary-button-focus-background"
		},
		{
			isInvalid: !0,
			isHovered: !0,
			class: "border-outline-input-hover"
		},
		{
			isInvalid: !0,
			isFocused: !0,
			class: "border-outline-input-focus"
		},
		{
			isInvalid: !0,
			isSelected: !0,
			class: "bg-text-negative"
		},
		{
			isInvalid: !0,
			isSelected: !0,
			isHovered: !0,
			class: "bg-interactive-primary-button-hover-background border-interactive-primary-button-hover-background"
		},
		{
			isInvalid: !0,
			isSelected: !0,
			isFocused: !0,
			class: "bg-interactive-primary-button-focus-background border-interactive-primary-button-focus-background"
		},
		{
			isDisabled: !0,
			isSelected: !0,
			class: "bg-interactive-secondary-button-focus-background border-interactive-secondary-button-focus-background"
		}
	]
}), vl = G({
	base: "relative flex items-center gap-2 text-label-medium transition",
	variants: {
		isDisabled: { true: "text-text-disabled cursor-not-allowed" },
		isInvalid: { true: "" }
	}
});
function yl(e) {
	let t = K(33), n, i, a, o, s, c;
	t[0] === e ? (n = t[1], i = t[2], a = t[3], o = t[4], s = t[5], c = t[6]) : ({className: a, assistiveText: i, isInvalid: s, isDisabled: o, "aria-describedby": n, ...c} = e, t[0] = e, t[1] = n, t[2] = i, t[3] = a, t[4] = o, t[5] = s, t[6] = c);
	let l = xr(), u;
	t[7] === s ? u = t[8] : (u = (e, t) => vl({
		...t,
		className: e,
		isInvalid: s
	}), t[7] = s, t[8] = u);
	let d;
	t[9] !== a || t[10] !== u ? (d = ta(a, u), t[9] = a, t[10] = u, t[11] = d) : d = t[11];
	let f;
	t[12] !== n || t[13] !== i || t[14] !== l ? (f = [n, i ? l : null].filter(Boolean).join(" ") || void 0, t[12] = n, t[13] = i, t[14] = l, t[15] = f) : f = t[15];
	let p;
	t[16] === c.children ? p = t[17] : (p = (e) => {
		let { isSelected: t, isIndeterminate: n, ...i } = e;
		return /* @__PURE__ */ X(Dr, { children: [/* @__PURE__ */ Y("div", {
			className: _l({
				isSelected: t || n,
				...i
			}),
			children: n ? /* @__PURE__ */ Y("span", {
				className: "text-sm leading-none flex items-center justify-center font-bold text-neutral-white",
				children: "-"
			}) : t ? /* @__PURE__ */ Y(r, {
				className: "text-neutral-white",
				size: 8
			}) : null
		}), c.children] });
	}, t[16] = c.children, t[17] = p);
	let m;
	t[18] !== o || t[19] !== s || t[20] !== c || t[21] !== d || t[22] !== f || t[23] !== p ? (m = /* @__PURE__ */ Y(ci, {
		className: d,
		...c,
		"aria-describedby": f,
		isDisabled: o,
		isInvalid: s,
		children: p
	}), t[18] = o, t[19] = s, t[20] = c, t[21] = d, t[22] = f, t[23] = p, t[24] = m) : m = t[24];
	let h = i ? l : void 0, g;
	t[25] !== i || t[26] !== o || t[27] !== s || t[28] !== h ? (g = /* @__PURE__ */ Y(gl, {
		id: h,
		isDisabled: o,
		isInvalid: s,
		children: i
	}), t[25] = i, t[26] = o, t[27] = s, t[28] = h, t[29] = g) : g = t[29];
	let _;
	return t[30] !== m || t[31] !== g ? (_ = /* @__PURE__ */ X("div", {
		className: "flex flex-col gap-y-[.15rem]",
		children: [m, g]
	}), t[30] = m, t[31] = g, t[32] = _) : _ = t[32], _;
}
//#endregion
//#region lib/components/Checkbox/CheckboxIndicator.tsx
function bl(e) {
	let t = K(9), { isSelected: n, isHovered: i, isFocused: a } = e, o;
	t[0] !== a || t[1] !== i || t[2] !== n ? (o = _l({
		isSelected: n,
		isHovered: i,
		isFocused: a
	}), t[0] = a, t[1] = i, t[2] = n, t[3] = o) : o = t[3];
	let s;
	t[4] === n ? s = t[5] : (s = n ? /* @__PURE__ */ Y(r, {
		className: "text-neutral-white",
		size: 8
	}) : null, t[4] = n, t[5] = s);
	let c;
	return t[6] !== o || t[7] !== s ? (c = /* @__PURE__ */ Y("div", {
		className: o,
		children: s
	}), t[6] = o, t[7] = s, t[8] = c) : c = t[8], c;
}
//#endregion
//#region lib/components/ProviderSelectBox/ProviderSelectBox.tsx
function xl(e) {
	let t = K(25), { providers: n, selectedProviders: r, onSelected: i, className: a } = e, o = n === void 0 ? $c : n, s;
	t[0] === a ? s = t[1] : (s = W("flex flex-col gap-y-3", a), t[0] = a, t[1] = s);
	let c;
	t[2] !== o || t[3] !== r ? (c = r.length === o.length && o.length > 0 && r.every((e) => o.includes(e)), t[2] = o, t[3] = r, t[4] = c) : c = t[4];
	let l;
	t[5] !== i || t[6] !== o ? (l = (e) => i(e ? Array.from(o) : []), t[5] = i, t[6] = o, t[7] = l) : l = t[7];
	let u;
	t[8] !== c || t[9] !== l ? (u = /* @__PURE__ */ Y(yl, {
		className: "flex items-center gap-2",
		isSelected: c,
		onChange: l,
		children: "All Providers"
	}), t[8] = c, t[9] = l, t[10] = u) : u = t[10];
	let d;
	t[11] === i ? d = t[12] : (d = (e) => i(e.filter(el)), t[11] = i, t[12] = d);
	let f;
	t[13] === o ? f = t[14] : (f = o.map(Sl), t[13] = o, t[14] = f);
	let p;
	t[15] === f ? p = t[16] : (p = /* @__PURE__ */ Y("div", {
		className: "flex gap-x-8",
		children: f
	}), t[15] = f, t[16] = p);
	let m;
	t[17] !== r || t[18] !== d || t[19] !== p ? (m = /* @__PURE__ */ Y(li, {
		"aria-label": "Provider selection",
		onChange: d,
		value: r,
		children: p
	}), t[17] = r, t[18] = d, t[19] = p, t[20] = m) : m = t[20];
	let h;
	return t[21] !== s || t[22] !== u || t[23] !== m ? (h = /* @__PURE__ */ X("div", {
		className: s,
		children: [u, m]
	}), t[21] = s, t[22] = u, t[23] = m, t[24] = h) : h = t[24], h;
}
function Sl(e) {
	return /* @__PURE__ */ Y(yl, {
		value: e,
		children: /* @__PURE__ */ Y(hl, { provider: tl(e) })
	}, `provider-select-box-${e}`);
}
//#endregion
//#region lib/assets/cloudcustodian.svg?react
var Cl = (e) => /* @__PURE__ */ X("svg", {
	id: "svg3355",
	"xmlns:cc": "http://creativecommons.org/ns#",
	"xmlns:dc": "http://purl.org/dc/elements/1.1/",
	"xmlns:rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
	"xmlns:svg": "http://www.w3.org/2000/svg",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 157.5 157.3",
	style: { enableBackground: "new 0 0 157.5 157.3" },
	xmlSpace: "preserve",
	...e,
	children: [/* @__PURE__ */ Y("style", {
		type: "text/css",
		children: "\n	.st0{fill:#FFFFFF;}\n	.st1{clip-path:url(#SVGID_2_);}\n	.st2{fill:url(#path3453_1_);}\n	.st3{fill:#87752E;}\n"
	}), /* @__PURE__ */ X("g", {
		id: "g3363",
		transform: "matrix(1.25,0,0,-1.25,0,236.25)",
		children: [
			/* @__PURE__ */ Y("g", {
				id: "g3365",
				transform: "translate(88.8357,84.5112)",
				children: /* @__PURE__ */ Y("path", {
					id: "path3367",
					className: "st0",
					d: "M-9,27.2l-16.9-9.3l-17,9.6v19.2l17,9.7L-9,47.6V27.2z M-8.9,66.1l-16.9,9.7l-17-9.7l-16.9,9.8 V17.4l34.1-19.2L8,17.4l0.4,58.5C8.4,75.9-8.9,66.1-8.9,66.1z"
				})
			}),
			/* @__PURE__ */ Y("g", {
				id: "g3433",
				children: /* @__PURE__ */ X("g", { children: [
					/* @__PURE__ */ Y("defs", { children: /* @__PURE__ */ Y("path", {
						id: "SVGID_1_",
						d: "M0,126.2c0-34.8,28.2-63,63-63l0,0c34.8,0,63,28.2,63,63l0,0c0,34.8-28.2,63-63,63l0,0 C28.2,189.2,0,161,0,126.2"
					}) }),
					/* @__PURE__ */ Y("clipPath", {
						id: "SVGID_2_",
						children: /* @__PURE__ */ Y("use", {
							xlinkHref: "#SVGID_1_",
							style: { overflow: "visible" }
						})
					}),
					/* @__PURE__ */ Y("g", {
						id: "g3435",
						className: "st1",
						children: /* @__PURE__ */ Y("g", {
							id: "g3441",
							children: /* @__PURE__ */ X("g", {
								id: "g3443",
								children: [/* @__PURE__ */ X("linearGradient", {
									id: "path3453_1_",
									gradientUnits: "userSpaceOnUse",
									x1: -286.6233,
									y1: 22.3334,
									x2: -285.6233,
									y2: 22.3334,
									gradientTransform: "matrix(0 206.4569 206.4569 0 -4547.8828 59153.9961)",
									children: [
										/* @__PURE__ */ Y("stop", {
											offset: 0,
											style: { stopColor: "#F79422" }
										}),
										/* @__PURE__ */ Y("stop", {
											offset: .9835,
											style: { stopColor: "#F4C91D" }
										}),
										/* @__PURE__ */ Y("stop", {
											offset: 1,
											style: { stopColor: "#F4C91D" }
										})
									]
								}), /* @__PURE__ */ Y("path", {
									id: "path3453",
									className: "st2",
									d: "M0,126.2c0-34.8,28.2-63,63-63l0,0c34.8,0,63,28.2,63,63l0,0c0,34.8-28.2,63-63,63l0,0 C28.2,189.2,0,161,0,126.2"
								})]
							})
						})
					})
				] })
			}),
			/* @__PURE__ */ Y("g", {
				id: "g3455",
				children: /* @__PURE__ */ Y("g", { children: /* @__PURE__ */ X("g", {
					id: "g3457",
					children: [
						/* @__PURE__ */ Y("g", {
							id: "g3463",
							transform: "translate(74.5551,128.4795)",
							children: /* @__PURE__ */ Y("path", {
								id: "path3465",
								className: "st0",
								d: "M-9,27.2l12-6.9V6.4l-12,6.9V27.2z"
							})
						}),
						/* @__PURE__ */ Y("g", {
							id: "g3467",
							transform: "translate(57.7491,121.5353)",
							children: /* @__PURE__ */ Y("path", {
								id: "path3469",
								className: "st0",
								d: "M-9,27.2l12,6.9V20.2l-12-6.9V27.2z"
							})
						}),
						/* @__PURE__ */ Y("g", {
							id: "g3471",
							transform: "translate(40.9432,128.4792)",
							children: /* @__PURE__ */ Y("path", {
								id: "path3473",
								className: "st0",
								d: "M-9,27.2l12-6.9V3.6L-9-3.3V27.2z"
							})
						}),
						/* @__PURE__ */ Y("g", {
							id: "g3475",
							transform: "translate(40.9432,92.4265)",
							children: /* @__PURE__ */ Y("path", {
								id: "path3477",
								className: "st0",
								d: "M-9,27.2l12,6.9V20.2l-12-6.9V27.2z"
							})
						}),
						/* @__PURE__ */ Y("g", {
							id: "g3479",
							transform: "translate(69.7776,59.1304)",
							children: /* @__PURE__ */ Y("path", {
								id: "path3481",
								className: "st0",
								d: "M-9,27.2l-26.4,15.3l12,6.9L-9,41.1V27.2z"
							})
						}),
						/* @__PURE__ */ Y("g", {
							id: "g3483",
							transform: "translate(74.5551,59.1304)",
							children: /* @__PURE__ */ Y("path", {
								id: "path3485",
								className: "st0",
								d: "M-9,27.2v13.9l14.4,8.3l12-6.9L-9,27.2z"
							})
						}),
						/* @__PURE__ */ Y("g", {
							id: "g3487",
							transform: "translate(103.3884,78.5369)",
							children: /* @__PURE__ */ Y("path", {
								id: "path3489",
								className: "st0",
								d: "M-9,27.2l-12,6.9V48l12-6.9V27.2z"
							})
						}),
						/* @__PURE__ */ Y("g", {
							id: "g3491",
							transform: "translate(103.3884,97.9427)",
							children: /* @__PURE__ */ Y("path", {
								id: "path3493",
								className: "st0",
								d: "M-9,27.2l-12,6.9v16.6l12,6.9V27.2z"
							})
						}),
						/* @__PURE__ */ Y("g", {
							id: "g3495",
							transform: "translate(103.3884,97.9427)",
							children: /* @__PURE__ */ Y("path", {
								id: "path3497",
								className: "st3",
								d: "M-9,27.2l-12,6.9v16.6l12,6.9V27.2z M-9,7.8l-12,6.9v13.9l12-6.9V7.8z M-37.8-11.6V2.3 l14.4,8.3l12-6.9L-37.8-11.6z M-25.8,28.6V14.7l-12-6.9v13.9L-25.8,28.6z M-52.2,32.8l12,6.9l12-6.9l-12-6.9L-52.2,32.8z  M-42.6,7.8l-12,6.9v13.9l12-6.9V7.8z M-42.6-11.6L-69.1,3.6l12,6.9l14.4-8.3C-42.6,2.3-42.6-11.6-42.6-11.6z M-71.4,21.7 l12,6.9V14.7l-12-6.9V21.7z M-71.4,57.7l12-6.9V34.1l-12-6.9V57.7z M-54.6,50.8l12,6.9V43.8l-12-6.9V50.8z M-37.8,57.7l12-6.9 V36.9l-12,6.9V57.7z M-23.4,54.9l-16.8,9.7L-57,54.9L-76.2,66V2.3l36-20.8l36,20.8V66C-4.2,66-23.4,54.9-23.4,54.9z"
							})
						})
					]
				}) })
			})
		]
	})]
}), wl = (e) => /* @__PURE__ */ Y("svg", {
	width: "800px",
	height: "800px",
	viewBox: "-28 0 312 312",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	preserveAspectRatio: "xMidYMid",
	...e,
	children: /* @__PURE__ */ X("g", { children: [
		/* @__PURE__ */ Y("path", {
			d: "M16.491,215.53 L18.667,218 L128.582,249.157 L129.08,229.844 L52.1,210.526 L48.333,209.167 L16.491,215.53",
			fill: "#B7CA9D"
		}),
		/* @__PURE__ */ Y("path", {
			d: "M239.505,215.53 L127.25,253 L126.916,229.844 L203.895,210.526 L207.25,206.75 L239.505,215.53",
			fill: "#B7CA9D"
		}),
		/* @__PURE__ */ Y("path", {
			d: "M126.916,83.165 L203.895,101.106 L237.75,99.5 L239.505,96.107 L132.25,57.5 L126.916,83.165",
			fill: "#3C4929"
		}),
		/* @__PURE__ */ Y("path", {
			d: "M52.1,210.526 L16.491,215.53 L15.5,211.833 L15.5,100 L16.491,96.107 L48.667,98.5 L52.1,101.11 L52.1,210.526",
			fill: "#759C3E"
		}),
		/* @__PURE__ */ Y("path", {
			d: "M129.08,83.165 L52.1,101.106 L16.491,96.107 L17.833,94 L128.582,62.48 L129.08,83.165",
			fill: "#3C4929"
		}),
		/* @__PURE__ */ Y("path", {
			d: "M127.846,0 L0,64.531 L0.061,247.144 L127.846,311.641 L129.75,308.75 L129.75,3.75 L127.846,0 L127.846,0 Z M90.462,237.73 L16.491,215.53 L16.491,96.107 L90.462,73.915 L90.462,237.73 L90.462,237.73 Z",
			fill: "#4B612C"
		}),
		/* @__PURE__ */ Y("path", {
			d: "M203.895,210.526 L239.505,215.53 L241.5,212 L241.5,99.5 L239.505,96.107 L203.895,101.11 L203.895,210.526",
			fill: "#4B612C"
		}),
		/* @__PURE__ */ Y("path", {
			d: "M127.846,311.641 L255.939,247.148 L256,64.536 L127.846,0 L127.846,311.641 L127.846,311.641 Z M165.533,73.915 L239.505,96.107 L239.505,215.53 L165.533,237.73 L165.533,73.915 L165.533,73.915 Z",
			fill: "#759C3E"
		})
	] })
}), Tl = (e) => /* @__PURE__ */ X("svg", {
	width: "800px",
	height: "800px",
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ Y("path", {
		d: "M38.06 26.151v11.473L48 31.891V20.406l-9.94 5.745z",
		fill: "#4040B2"
	}), /* @__PURE__ */ Y("path", {
		d: "m27.03 20.406 9.94 5.745v11.473l-9.94-5.74V20.407zM16 14v11.479l9.94 5.74v-11.48L16 14zm11.03 30.624 9.94 5.74v-11.48l-9.94-5.739v11.48z",
		fill: "#5C4EE5"
	})]
});
//#endregion
//#region lib/components/ResourceManagerIcon/ResourceManagerIcon.tsx
function El(e) {
	let t = K(14), { manager: n, size: r } = e, i = r === void 0 ? 14 : r, a;
	a = n.toLocaleLowerCase().includes("cloudcustodian") ? Cl : n.toLocaleLowerCase().includes("cloudformation") ? wl : n.toLocaleLowerCase().includes("terraform") ? Tl : Mt;
	let o;
	t[0] === i ? o = t[1] : (o = {
		height: i,
		width: i
	}, t[0] = i, t[1] = o);
	let s;
	t[2] === n ? s = t[3] : (s = { "aria-label": n }, t[2] = n, t[3] = s);
	let c;
	t[4] !== a || t[5] !== i ? (c = /* @__PURE__ */ Y(a, {
		height: i,
		width: i
	}), t[4] = a, t[5] = i, t[6] = c) : c = t[6];
	let l;
	t[7] !== n || t[8] !== s || t[9] !== c ? (l = /* @__PURE__ */ Y(qt, {
		buttonProps: s,
		title: n,
		children: c
	}), t[7] = n, t[8] = s, t[9] = c, t[10] = l) : l = t[10];
	let u;
	return t[11] !== o || t[12] !== l ? (u = /* @__PURE__ */ Y("div", {
		className: "flex",
		style: o,
		children: l
	}), t[11] = o, t[12] = l, t[13] = u) : u = t[13], u;
}
//#endregion
//#region lib/components/CircularProgress/CircularProgress.tsx
function Dl(e) {
	let t = K(18), { value: n, size: r, variant: i, "aria-label": a } = e, o = r === void 0 ? "medium" : r, s = i === void 0 ? "default" : i, c = a === void 0 ? "Loading…" : a, l;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (l = {
		small: 14,
		medium: 24,
		large: 32,
		xl: 48
	}, t[0] = l) : l = t[0];
	let u = l[o], d = 24 * Math.PI, f = s === "inverted" ? "text-neutral-white" : "text-foreground-brand";
	if (n === void 0) {
		let e;
		t[1] === f ? e = t[2] : (e = W("animate-spin", f), t[1] = f, t[2] = e);
		let n, r;
		t[3] === Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ Y("circle", {
			cx: 16,
			cy: 16,
			fill: "none",
			opacity: .2,
			r: 12,
			stroke: "currentColor",
			strokeWidth: 4
		}), r = /* @__PURE__ */ Y("circle", {
			cx: 16,
			cy: 16,
			fill: "none",
			r: 12,
			stroke: "currentColor",
			strokeDasharray: `${d * .25} ${d * .75}`,
			strokeLinecap: "round",
			strokeWidth: 4
		}), t[3] = n, t[4] = r) : (n = t[3], r = t[4]);
		let i;
		t[5] !== u || t[6] !== e ? (i = /* @__PURE__ */ X("svg", {
			className: e,
			fill: "none",
			height: u,
			viewBox: "0 0 32 32",
			width: u,
			children: [n, r]
		}), t[5] = u, t[6] = e, t[7] = i) : i = t[7];
		let a;
		return t[8] !== c || t[9] !== i ? (a = /* @__PURE__ */ Y("div", {
			"aria-label": c,
			"aria-valuenow": void 0,
			role: "progressbar",
			children: i
		}), t[8] = c, t[9] = i, t[10] = a) : a = t[10], a;
	}
	let p;
	t[11] !== f || t[12] !== u ? (p = (e) => {
		let { percentage: t } = e;
		return /* @__PURE__ */ X("svg", {
			className: f,
			fill: "none",
			height: u,
			strokeWidth: 4,
			viewBox: "0 0 32 32",
			width: u,
			children: [
				/* @__PURE__ */ Y("circle", {
					cx: 16,
					cy: 16,
					fill: "none",
					opacity: .3,
					r: 10.25,
					stroke: "currentColor",
					strokeWidth: .5
				}),
				/* @__PURE__ */ Y("circle", {
					cx: 16,
					cy: 16,
					fill: "none",
					opacity: .3,
					r: 13.75,
					stroke: "currentColor",
					strokeWidth: .5
				}),
				/* @__PURE__ */ Y("circle", {
					cx: 16,
					cy: 16,
					fill: "none",
					r: 12,
					stroke: "currentColor",
					strokeDasharray: `${d} ${d}`,
					strokeDashoffset: d - (t ?? 0) / 100 * d,
					strokeLinecap: "round",
					strokeWidth: 4,
					transform: "rotate(-90 16 16)"
				})
			]
		});
	}, t[11] = f, t[12] = u, t[13] = p) : p = t[13];
	let m;
	return t[14] !== c || t[15] !== p || t[16] !== n ? (m = /* @__PURE__ */ Y(Mi, {
		"aria-label": c,
		value: n,
		children: p
	}), t[14] = c, t[15] = p, t[16] = n, t[17] = m) : m = t[17], m;
}
//#endregion
//#region lib/components/shared/buttonVariants.ts
var Ol = { variant: {
	primary: "\n      bg-interactive-primary-button-enabled-background\n      hover:bg-interactive-primary-button-hover-background\n      focus:bg-interactive-primary-button-focus-background\n      disabled:bg-interactive-disabled-background disabled:text-interactive-disabled-foreground",
	secondary: "\n      border-interactive-secondary-button-enabled-outline\n      text-interactive-secondary-button-enabled-foreground\n      bg-interactive-secondary-button-enabled-background\n      hover:bg-interactive-secondary-button-hover-background\n      hover:text-interactive-secondary-button-hover-foreground\n      hover:border-interactive-secondary-button-hover-outline\n      focus:bg-interactive-secondary-button-focus-background\n      focus:text-interactive-secondary-button-focus-foreground\n      focus:border-interactive-secondary-button-focus-outline\n      disabled:border-interactive-disabled-outline disabled:bg-transparent disabled:text-interactive-disabled-foreground",
	tertiary: "\n      text-interactive-tertiary-button-enabled-foreground\n      bg-transparent\n      hover:bg-interactive-tertiary-button-hover-background\n      hover:text-interactive-tertiary-button-hover-foreground\n      focus:text-interactive-tertiary-button-focus-foreground\n      focus:bg-interactive-tertiary-button-focus-background\n      disabled:text-interactive-disabled-foreground disabled:hover:bg-transparent",
	glass: "\n      bg-interactive-glass-button-enabled-background\n      border-interactive-glass-button-enabled-outline\n      text-interactive-glass-button-enabled-foreground\n      hover:text-interactive-glass-button-hover-foreground\n      hover:bg-interactive-glass-button-hover-background\n      hover:border-interactive-glass-button-hover-outline\n      focus:bg-interactive-glass-button-focus-background focus:text-interactive-glass-button-focus-foreground focus:border-interactive-glass-button-focus-outline backdrop-blur hover:backdrop-blur-xl  focus:backdrop-blur-2xl  disabled:bg-interactive-disabled-background disabled:text-interactive-disabled-foreground",
	negative: "\n      text-interactive-negative-button-enabled-foreground\n      bg-interactive-negative-button-enabled-background\n      hover:bg-interactive-negative-button-hover-background\n      hover:text-interactive-negative-button-hover-foreground\n      focus:text-interactive-negative-button-focus-foreground\n      focus:bg-interactive-negative-button-focus-background\n      disabled:text-interactive-disabled-foreground disabled:hover:bg-interactive-negative-button-enabled-background",
	"app-selector": "\n      flex items-center text-label-medium\n      hover:bg-interactive-primary-button-enabled-background\n      hover:text-interactive-primary-button-enabled-foreground\n      outline-none justify-center py-1 px-3 gap-1 rounded-10 hover:border-interactive-primary-button-enabled-background bg-neutral-white transition text-interactive-secondary-button-enabled-foreground",
	dropdown: "\n    py-3xs px-3xs rounded-sm\n    text-label-medium text-text-primary font-label-medium font-normal\n    hover:bg-interactive-secondary-button-focus-background\n    focus:bg-interactive-secondary-button-focus-background",
	plain: "\n      text-text-primary bg-transparent\n      disabled:text-neutral-200",
	link: "\n      p-0 border-0 rounded-none font-normal bg-transparent\n      text-interactive-link-enabled underline\n      hover:text-interactive-link-hover\n      focus:text-interactive-link-focus\n      disabled:text-interactive-link-disabled disabled:cursor-not-allowed"
} }, kl = { variant: "primary" }, Al = { variant: {
	primary: "\n      bg-interactive-primary-button-enabled-background\n      hover:bg-interactive-primary-button-hover-background\n      focus:bg-interactive-primary-button-focus-background\n      data-[disabled]:bg-interactive-disabled-background data-[disabled]:text-interactive-disabled-foreground",
	secondary: "\n      border-interactive-secondary-button-enabled-outline\n      text-interactive-secondary-button-enabled-foreground\n      bg-interactive-secondary-button-enabled-background\n      hover:bg-interactive-secondary-button-hover-background\n      hover:text-interactive-secondary-button-hover-foreground\n      hover:border-interactive-secondary-button-hover-outline\n      focus:bg-interactive-secondary-button-focus-background\n      focus:text-interactive-secondary-button-focus-foreground\n      focus:border-interactive-secondary-button-focus-outline\n      data-[disabled]:border-interactive-disabled-outline data-[disabled]:bg-transparent data-[disabled]:text-interactive-disabled-foreground",
	tertiary: "\n      text-interactive-tertiary-button-enabled-foreground\n      bg-transparent\n      hover:bg-interactive-tertiary-button-hover-background\n      hover:text-interactive-tertiary-button-hover-foreground\n      focus:text-interactive-tertiary-button-focus-foreground\n      focus:bg-interactive-tertiary-button-focus-background\n      data-[disabled]:text-interactive-disabled-foreground  data-[disabled]:hover:bg-transparent",
	glass: "\n      bg-interactive-glass-button-enabled-background\n      border-interactive-glass-button-enabled-outline\n      text-interactive-glass-button-enabled-foreground\n      hover:text-interactive-glass-button-hover-foreground\n      hover:bg-interactive-glass-button-hover-background\n      hover:border-interactive-glass-button-hover-outline\n      focus:bg-interactive-glass-button-focus-background focus:text-interactive-glass-button-focus-foreground focus:border-interactive-glass-button-focus-outline backdrop-blur hover:backdrop-blur-xl  focus:backdrop-blur-2xl  data-[disabled]:bg-interactive-disabled-background data-[disabled]:text-interactive-disabled-foreground",
	negative: "\n      text-interactive-negative-button-enabled-foreground\n      bg-interactive-negative-button-enabled-background\n      hover:bg-interactive-negative-button-hover-background\n      hover:text-interactive-negative-button-hover-foreground\n      focus:text-interactive-negative-button-focus-foreground\n      focus:bg-interactive-negative-button-focus-background\n      data-[disabled]:text-interactive-disabled-foreground data-[disabled]:hover:bg-interactive-negative-button-enabled-background",
	"app-selector": "\n      flex items-center text-label-medium\n      hover:bg-interactive-primary-button-enabled-background\n      hover:text-interactive-primary-button-enabled-foreground\n      outline-none justify-center py-1 px-3 gap-1 rounded-10 hover:border-interactive-primary-button-enabled-background bg-neutral-white transition text-interactive-secondary-button-enabled-foreground",
	dropdown: "\n    py-3xs px-3xs rounded-sm\n    text-label-medium text-text-primary font-label-medium font-normal\n    hover:bg-interactive-secondary-button-focus-background\n    focus:bg-interactive-secondary-button-focus-background",
	plain: "\n      text-text-primary bg-transparent\n      data-[disabled]:text-neutral-200",
	link: "\n      p-0 border-0 rounded-none font-normal bg-transparent\n      text-interactive-link-enabled underline\n      hover:text-interactive-link-hover\n      focus:text-interactive-link-focus\n      data-[disabled]:text-interactive-link-disabled data-[disabled]:cursor-not-allowed"
} };
//#endregion
//#region lib/hooks/useCopyToClipboard.ts
function jl(e, t) {
	let n = K(9), r = t === void 0 ? 2500 : t, [i, a] = J("inactive"), o;
	n[0] === e ? o = n[1] : (o = () => {
		navigator.clipboard.writeText(e).then(() => a("copied"), () => a("failed"));
	}, n[0] = e, n[1] = o);
	let s = o, c, l;
	n[2] !== i || n[3] !== r ? (c = () => {
		if (i === "inactive") return;
		let e = setTimeout(() => a("inactive"), r);
		return () => clearTimeout(e);
	}, l = [i, r], n[2] = i, n[3] = r, n[4] = c, n[5] = l) : (c = n[4], l = n[5]), br(c, l);
	let u;
	return n[6] !== s || n[7] !== i ? (u = [i, s], n[6] = s, n[7] = i, n[8] = u) : u = n[8], u;
}
//#endregion
//#region lib/hooks/usePendingState.ts
function Ml(e, t) {
	let n = K(6), r = t === void 0 ? 500 : t, [i, a] = J(!1), o, s;
	n[0] !== r || n[1] !== e ? (o = () => {
		let t;
		return e ? t = setTimeout(() => a(!0), r) : a(!1), () => clearTimeout(t);
	}, s = [e, r], n[0] = r, n[1] = e, n[2] = o, n[3] = s) : (o = n[2], s = n[3]), br(o, s);
	let c;
	return n[4] === i ? c = n[5] : (c = { isProgressVisible: i }, n[4] = i, n[5] = c), c;
}
//#endregion
//#region lib/hooks/useScrollEnd.ts
function Nl(e, t, n) {
	let r = Tr([]);
	br(() => {
		let i = e.current;
		if (!i || !t) return;
		let a = [], o = [], s = [];
		return i.forEach((e, r) => {
			if (!e) return;
			s[r] = !1;
			let i = document.createElement("div");
			i.style.height = "1px", i.style.width = "100%", i.style.pointerEvents = "none", i.setAttribute("data-scroll-sentinel", "true"), e.appendChild(i), o.push(i);
			let c = new IntersectionObserver((n) => {
				let [i] = n;
				if (i.isIntersecting) {
					let n = e.scrollHeight > e.clientHeight;
					!s[r] && n && (s[r] = !0, t(r));
				} else s[r] = !1;
			}, {
				root: e,
				rootMargin: `${n?.threshold ?? 1}px`,
				threshold: 0
			});
			c.observe(i), a.push(c);
		}), r.current = s, () => {
			a.forEach((e) => e.disconnect()), o.forEach((e) => {
				e.parentNode && e.parentNode.removeChild(e);
			});
		};
	}, [
		e,
		t,
		n?.threshold,
		...n?.deps ?? []
	]);
}
//#endregion
//#region lib/components/Button/Button.tsx
var Pl = G({
	base: "relative px-md py-xxs transition-all ease-in-out font-semibold rounded-md text-label-medium flex items-center gap-x-xs text-interactive-primary-button-enabled-foreground outline-none border border-transparent disabled:cursor-not-allowed",
	variants: Ol,
	defaultVariants: kl
}), Q = (e) => {
	let t = K(25), n, r, i, a, o, s, c, l;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4], o = t[5], s = t[6], c = t[7], l = t[8]) : ({variant: l, children: i, IconLeft: n, IconRight: r, ref: a, isPending: s, pendingText: c, ...o} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a, t[5] = o, t[6] = s, t[7] = c, t[8] = l);
	let u = s !== void 0 && s, d = c === void 0 ? "Loading…" : c, f = (l ?? "primary") === "primary", { isProgressVisible: p } = Ml(u), m;
	t[9] !== e.className || t[10] !== l ? (m = Pl({
		variant: l,
		class: e.className
	}), t[9] = e.className, t[10] = l, t[11] = m) : m = t[11];
	let h;
	t[12] !== n || t[13] !== r || t[14] !== i || t[15] !== p || t[16] !== d || t[17] !== f ? (h = (e) => {
		if (typeof i == "function") return i(e);
		let t = /* @__PURE__ */ Y(Dl, {
			size: "small",
			variant: f ? "inverted" : "default"
		});
		return p ? /* @__PURE__ */ X(Dr, { children: [/* @__PURE__ */ X("span", {
			className: "invisible inline-flex items-center gap-x-xs",
			children: [t, /* @__PURE__ */ Y("span", {
				className: "text-label-medium font-semibold",
				children: d
			})]
		}), /* @__PURE__ */ X("span", {
			className: "absolute inset-0 flex items-center justify-center gap-x-xs",
			children: [t, /* @__PURE__ */ Y("span", {
				className: "text-label-medium font-semibold",
				children: d
			})]
		})] }) : /* @__PURE__ */ X(Dr, { children: [
			n ? /* @__PURE__ */ Y("span", {
				className: "relative flex items-center justify-center",
				children: n
			}) : null,
			i == null ? null : n != null || r != null ? /* @__PURE__ */ Y("span", {
				className: "inline-flex min-w-0 items-center gap-x-xs",
				children: i
			}) : i,
			r ? /* @__PURE__ */ Y("span", { children: r }) : null
		] });
	}, t[12] = n, t[13] = r, t[14] = i, t[15] = p, t[16] = d, t[17] = f, t[18] = h) : h = t[18];
	let g;
	return t[19] !== u || t[20] !== a || t[21] !== o || t[22] !== m || t[23] !== h ? (g = /* @__PURE__ */ Y(oi, {
		...o,
		className: m,
		isPending: u,
		ref: a,
		children: h
	}), t[19] = u, t[20] = a, t[21] = o, t[22] = m, t[23] = h, t[24] = g) : g = t[24], g;
}, Fl = G({
	base: "flex flex-col gap-1 p-2 rounded-md text-text-primary text-label-medium",
	variants: {
		severity: {
			success: "",
			info: "",
			warning: "",
			error: "",
			secondary: ""
		},
		variant: {
			normal: "",
			light: ""
		}
	},
	compoundVariants: [
		{
			severity: "success",
			variant: "normal",
			class: "bg-background-positive"
		},
		{
			severity: "info",
			variant: "normal",
			class: "bg-background-informative"
		},
		{
			severity: "warning",
			variant: "normal",
			class: "bg-background-warning"
		},
		{
			severity: "error",
			variant: "normal",
			class: "bg-background-negative"
		},
		{
			severity: "secondary",
			variant: "normal",
			class: "bg-background-secondary"
		},
		{
			severity: "success",
			variant: "light",
			class: "bg-background-primary border border-positive-600"
		},
		{
			severity: "info",
			variant: "light",
			class: "bg-background-primary border border-informative-600"
		},
		{
			severity: "warning",
			variant: "light",
			class: "bg-background-primary border border-warning-500"
		},
		{
			severity: "error",
			variant: "light",
			class: "bg-background-primary border border-negative-600"
		},
		{
			severity: "secondary",
			variant: "light",
			class: "bg-background-primary border border-neutral-700"
		}
	],
	defaultVariants: {
		severity: "success",
		variant: "normal"
	}
}), Il = G({
	base: "flex-shrink-0 w-6 h-6",
	variants: { severity: {
		success: "text-positive-600",
		info: "text-informative-600",
		warning: "text-warning-500",
		error: "text-negative-600",
		secondary: "text-foreground-secondary"
	} }
}), Ll = {
	success: /* @__PURE__ */ Y(f, { className: "h-6 w-6" }),
	info: /* @__PURE__ */ Y(U, { className: "h-6 w-6" }),
	warning: /* @__PURE__ */ Y(j, { className: "h-6 w-6" }),
	error: /* @__PURE__ */ Y(le, { className: "h-6 w-6" }),
	secondary: /* @__PURE__ */ Y(De, { className: "h-6 w-6" })
};
function Rl(e) {
	let t = K(23), { children: n, severity: r, variant: i, icon: a, action: o, onClose: s, closeText: c, className: l, role: u } = e, d = r === void 0 ? "success" : r, f = i === void 0 ? "normal" : i, p = c === void 0 ? "Close" : c, m = u === void 0 ? "alert" : u, h = a || (a === !1 ? null : Ll[d]), g;
	t[0] !== l || t[1] !== d || t[2] !== f ? (g = W(Fl({
		severity: d,
		variant: f
	}), l), t[0] = l, t[1] = d, t[2] = f, t[3] = g) : g = t[3];
	let _;
	t[4] !== h || t[5] !== d ? (_ = h ? /* @__PURE__ */ Y("div", {
		className: Il({ severity: d }),
		children: h
	}) : null, t[4] = h, t[5] = d, t[6] = _) : _ = t[6];
	let v;
	t[7] === n ? v = t[8] : (v = /* @__PURE__ */ Y("div", {
		className: "flex flex-grow flex-col items-start justify-center",
		children: /* @__PURE__ */ Y("div", { children: n })
	}), t[7] = n, t[8] = v);
	let y;
	t[9] !== p || t[10] !== s ? (y = s ? /* @__PURE__ */ Y("div", {
		className: "flex-shrink-0",
		children: /* @__PURE__ */ Y(Q, {
			"aria-label": p,
			className: "border-none p-1",
			onPress: s,
			variant: "tertiary",
			children: /* @__PURE__ */ Y(ie, { className: "h-4 w-4" })
		})
	}) : null, t[9] = p, t[10] = s, t[11] = y) : y = t[11];
	let b;
	t[12] !== _ || t[13] !== v || t[14] !== y ? (b = /* @__PURE__ */ X("div", {
		className: "flex gap-2",
		children: [
			_,
			v,
			y
		]
	}), t[12] = _, t[13] = v, t[14] = y, t[15] = b) : b = t[15];
	let x;
	t[16] === o ? x = t[17] : (x = o ? /* @__PURE__ */ Y("div", {
		className: "flex justify-end",
		children: o
	}) : null, t[16] = o, t[17] = x);
	let S;
	return t[18] !== m || t[19] !== x || t[20] !== g || t[21] !== b ? (S = /* @__PURE__ */ X("div", {
		className: g,
		role: m,
		children: [b, x]
	}), t[18] = m, t[19] = x, t[20] = g, t[21] = b, t[22] = S) : S = t[22], S;
}
//#endregion
//#region lib/components/Alert/AlertTitle.tsx
var zl = G({
	base: "mb-1 font-semibold",
	variants: { severity: {
		success: "text-positive-700",
		info: "text-informative-700",
		warning: "text-warning-700",
		error: "text-negative-700",
		secondary: "text-neutral-700"
	} },
	defaultVariants: { severity: "success" }
});
function Bl(e) {
	let t = K(6), { children: n, severity: r, className: i } = e, a = r === void 0 ? "success" : r, o;
	t[0] !== i || t[1] !== a ? (o = W(zl({ severity: a }), i), t[0] = i, t[1] = a, t[2] = o) : o = t[2];
	let s;
	return t[3] !== n || t[4] !== o ? (s = /* @__PURE__ */ Y("div", {
		className: o,
		children: n
	}), t[3] = n, t[4] = o, t[5] = s) : s = t[5], s;
}
//#endregion
//#region lib/components/shared/FormFieldHeader.tsx
function Vl(e) {
	let t = K(13), { label: n, tooltipText: r, isDisabled: i, isRequired: a, labelClassName: o, labelProps: s, tooltipButtonProps: c } = e;
	if (!n && !r) return null;
	let l;
	t[0] !== i || t[1] !== a || t[2] !== n || t[3] !== o || t[4] !== s ? (l = n ? /* @__PURE__ */ X("div", {
		className: "flex items-center",
		children: [/* @__PURE__ */ Y(Si, {
			className: W("text-label-small text-text-secondary", i ? "text-text-disabled" : "", o),
			...s,
			children: n
		}), a ? /* @__PURE__ */ Y("span", {
			"aria-hidden": "true",
			className: W("ml-0-5 text-label-small text-foreground-negative", i ? "text-text-disabled" : ""),
			children: "*"
		}) : null]
	}) : null, t[0] = i, t[1] = a, t[2] = n, t[3] = o, t[4] = s, t[5] = l) : l = t[5];
	let u;
	t[6] !== i || t[7] !== c || t[8] !== r ? (u = r ? /* @__PURE__ */ Y(qt, {
		buttonProps: c,
		title: r,
		children: /* @__PURE__ */ Y(oe, { className: W("size-lg text-foreground-secondary", i ? "text-text-disabled" : "") })
	}) : null, t[6] = i, t[7] = c, t[8] = r, t[9] = u) : u = t[9];
	let d;
	return t[10] !== l || t[11] !== u ? (d = /* @__PURE__ */ X("div", {
		className: "flex items-center justify-between gap-x-3",
		children: [l, u]
	}), t[10] = l, t[11] = u, t[12] = d) : d = t[12], d;
}
//#endregion
//#region lib/components/SearchField/SearchField.tsx
var Hl = G({
	base: "\n      text-label-small text-text-primary outline-none border border-outline-input-enabled bg-background-primary rounded-1 leading-md-20 truncate\n      hover:border-outline-input-hover hover:ring-1 hover:ring-outline-input-hover\n      relative flex items-center gap-3 px-3 py-0-5\n      focus-within:!border-outline-input-focus focus-within:ring-1 focus-within:!ring-outline-input-focus\n    ",
	variants: {
		isInvalid: { true: "border-outline-negative ring-1 ring-outline-negative" },
		isDisabled: { true: "cursor-not-allowed bg-background-primary text-text-disabled border-outline-input-disabled hover:ring-0 hover:border-outline-input-disabled focus-within:ring-0 focus-within:border-outline-input-disabled" }
	}
}), Ul = G({
	base: "\n    border-0 bg-transparent outline-none\n    appearance-none [&::-webkit-search-cancel-button]:hidden\n    flex-1\n        text-label-small placeholder:text-text-secondary\n  ",
	variants: { isDisabled: { true: "cursor-not-allowed text-text-disabled placeholder:text-text-disabled" } }
});
function Wl(e) {
	let t = K(33), n, r, i, a, o, s, c, l, u, d, f;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4], o = t[5], s = t[6], c = t[7], l = t[8], u = t[9], d = t[10], f = t[11]) : ({label: u, assistiveText: r, placeholder: d, className: i, isDisabled: s, isInvalid: c, inputProps: o, hasSubmitButton: a, isPending: l, "aria-label": n, ...f} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a, t[5] = o, t[6] = s, t[7] = c, t[8] = l, t[9] = u, t[10] = d, t[11] = f);
	let p, m;
	t[12] === f ? (p = t[13], m = t[14]) : ({onSubmit: p, ...m} = f, t[12] = f, t[13] = p, t[14] = m);
	let h = n ?? (u ? void 0 : "Search"), g;
	t[15] === i ? g = t[16] : (g = W("group flex w-[12.5rem] flex-col gap-[.15rem]", i), t[15] = i, t[16] = g);
	let _;
	t[17] !== r || t[18] !== a || t[19] !== o || t[20] !== l || t[21] !== u || t[22] !== p || t[23] !== d ? (_ = (e) => {
		let { isEmpty: t, isDisabled: n, isInvalid: i, state: s } = e;
		return /* @__PURE__ */ X(Dr, { children: [
			/* @__PURE__ */ Y(Vl, {
				isDisabled: n,
				label: u
			}),
			/* @__PURE__ */ X("div", {
				className: Hl({
					isInvalid: i,
					isDisabled: n
				}),
				children: [
					l ? /* @__PURE__ */ Y(Dl, { size: "small" }) : a ? /* @__PURE__ */ Y("button", {
						"aria-label": "search",
						className: W("shrink-0", n ? "cursor-not-allowed text-text-disabled" : "cursor-pointer"),
						disabled: n,
						onClick: () => p?.(s.value),
						type: "button",
						children: /* @__PURE__ */ Y(hn, { size: 12 })
					}) : /* @__PURE__ */ Y(hn, {
						className: "shrink-0",
						size: 12
					}),
					/* @__PURE__ */ Y(xi, {
						size: 1,
						...o,
						className: Ul({
							isDisabled: n,
							className: o?.className
						}),
						placeholder: o?.placeholder ?? d,
						type: "search"
					}),
					t ? null : /* @__PURE__ */ Y(oi, {
						"aria-label": "Clear search",
						slot: "clear",
						children: /* @__PURE__ */ Y(ie, {})
					})
				]
			}),
			/* @__PURE__ */ Y(gl, {
				isDisabled: n,
				isInvalid: i,
				children: r
			})
		] });
	}, t[17] = r, t[18] = a, t[19] = o, t[20] = l, t[21] = u, t[22] = p, t[23] = d, t[24] = _) : _ = t[24];
	let v;
	return t[25] !== s || t[26] !== c || t[27] !== p || t[28] !== m || t[29] !== h || t[30] !== g || t[31] !== _ ? (v = /* @__PURE__ */ Y(Li, {
		"aria-label": h,
		className: g,
		isDisabled: s,
		isInvalid: c,
		onSubmit: p,
		...m,
		children: _
	}), t[25] = s, t[26] = c, t[27] = p, t[28] = m, t[29] = h, t[30] = g, t[31] = _, t[32] = v) : v = t[32], v;
}
//#endregion
//#region lib/components/Skeleton/Skeleton.tsx
function Gl(e) {
	let t = K(16), { variant: n, width: r, height: i, className: a, "aria-label": o } = e, s = n === void 0 ? "text" : n, c = o === void 0 ? "Loading…" : o, l = r ? typeof r == "number" ? `${r}px` : r : void 0, u = i ? typeof i == "number" ? `${i}px` : i : void 0, d = s === "text" ? "1em" : void 0, f, p, m, h;
	t[0] !== c || t[1] !== a || t[2] !== s ? (f = "true", p = c, m = "polite", h = W("relative overflow-hidden bg-background-secondary", "before:absolute before:inset-0 before:-translate-x-full before:animate-shimmer motion-reduce:before:animate-none", "before:bg-gradient-to-r before:from-transparent before:via-background-tertiary before:to-transparent", {
		text: "rounded-1",
		rectangular: "rounded-1",
		circular: "rounded-full"
	}[s], a), t[0] = c, t[1] = a, t[2] = s, t[3] = f, t[4] = p, t[5] = m, t[6] = h) : (f = t[3], p = t[4], m = t[5], h = t[6]);
	let g = u ?? d, _;
	t[7] !== g || t[8] !== l ? (_ = {
		width: l,
		height: g
	}, t[7] = g, t[8] = l, t[9] = _) : _ = t[9];
	let v;
	return t[10] !== f || t[11] !== p || t[12] !== m || t[13] !== h || t[14] !== _ ? (v = /* @__PURE__ */ Y("div", {
		"aria-busy": f,
		"aria-label": p,
		"aria-live": m,
		className: h,
		style: _
	}), t[10] = f, t[11] = p, t[12] = m, t[13] = h, t[14] = _, t[15] = v) : v = t[15], v;
}
//#endregion
//#region lib/components/SingleSelectDropdown/DropdownCTA.tsx
function Kl(e) {
	let t = K(9), { leftCTA: n, rightCTA: r } = e, i;
	t[0] !== n.action || t[1] !== n.text ? (i = /* @__PURE__ */ Y(Q, {
		onPress: n.action,
		slot: "close",
		variant: "tertiary",
		children: n.text
	}), t[0] = n.action, t[1] = n.text, t[2] = i) : i = t[2];
	let a;
	t[3] !== r.action || t[4] !== r.text ? (a = /* @__PURE__ */ Y(Q, {
		onPress: r.action,
		slot: "close",
		variant: "primary",
		children: r.text
	}), t[3] = r.action, t[4] = r.text, t[5] = a) : a = t[5];
	let o;
	return t[6] !== i || t[7] !== a ? (o = /* @__PURE__ */ X("div", {
		className: "flex items-center justify-between gap-xl border-t border-outline-decorative px-4 pt-xs",
		children: [i, a]
	}), t[6] = i, t[7] = a, t[8] = o) : o = t[8], o;
}
//#endregion
//#region lib/components/SingleSelectDropdown/SingleSelectDropdown.tsx
var ql = G({
	base: "w-full text-start px-xs",
	variants: { isSelected: { true: "bg-interactive-secondary-button-focus-background" } }
});
function Jl(e) {
	let t = K(18), n, r, i, a, o, s, c;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4], o = t[5], s = t[6], c = t[7]) : ({children: r, onPress: s, className: i, isDisabled: a, isSelected: o, slot: c, ...n} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a, t[5] = o, t[6] = s, t[7] = c);
	let l = c === void 0 ? "close" : c, u;
	t[8] !== i || t[9] !== o ? (u = ql({
		className: i,
		isSelected: o
	}), t[8] = i, t[9] = o, t[10] = u) : u = t[10];
	let d;
	return t[11] !== n || t[12] !== r || t[13] !== a || t[14] !== s || t[15] !== l || t[16] !== u ? (d = /* @__PURE__ */ Y("li", {
		role: "menuitem",
		children: /* @__PURE__ */ Y(Q, {
			...n,
			className: u,
			isDisabled: a,
			onPress: s,
			slot: l,
			variant: "dropdown",
			children: r
		})
	}), t[11] = n, t[12] = r, t[13] = a, t[14] = s, t[15] = l, t[16] = u, t[17] = d) : d = t[17], d;
}
var Yl = G({ base: "min-w-[12.5rem] py-xs outline-none rounded-1 flex flex-col gap-y-2 border border-outline-decorative bg-background-secondary shadow-md px-1" });
function Xl(e) {
	let t = K(66), n, r, i, a, o, s, c, l, u, d, f, p, m, h, g, _, v, y, b;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4], o = t[5], s = t[6], c = t[7], l = t[8], u = t[9], d = t[10], f = t[11], p = t[12], m = t[13], h = t[14], g = t[15], _ = t[16], v = t[17], y = t[18], b = t[19]) : ({AnchorEle: n, children: r, className: i, style: g, placement: _, withSearch: b, searchValue: h, searchPlaceholder: m, onSearch: d, withCTA: y, leftCTA: l, rightCTA: p, matchTriggerWidth: u, dialogClassName: o, isPending: s, label: c, description: a, fullWidth: v, ...f} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a, t[5] = o, t[6] = s, t[7] = c, t[8] = l, t[9] = u, t[10] = d, t[11] = f, t[12] = p, t[13] = m, t[14] = h, t[15] = g, t[16] = _, t[17] = v, t[18] = y, t[19] = b);
	let x = _ === void 0 ? "bottom" : _, S = v !== void 0 && v, C = y && l && p, w = b && d, T = Tr(null), [E, D] = J(0), O, k;
	t[20] === u ? (O = t[21], k = t[22]) : (O = () => {
		if (!u) return;
		let e = T.current;
		if (!e) return;
		let t = new ResizeObserver((e) => {
			for (let t of e) D(t.target.clientWidth);
		});
		return t.observe(e), () => {
			t.unobserve(e);
		};
	}, k = [u], t[20] = u, t[21] = O, t[22] = k), br(O, k);
	let A = S ? "flex w-full" : "inline-flex", j = u ? T : void 0, M;
	t[23] !== n || t[24] !== A || t[25] !== j ? (M = /* @__PURE__ */ Y("span", {
		className: A,
		ref: j,
		children: n
	}), t[23] = n, t[24] = A, t[25] = j, t[26] = M) : M = t[26];
	let N;
	t[27] !== u || t[28] !== E ? (N = u ? { minWidth: E } : void 0, t[27] = u, t[28] = E, t[29] = N) : N = t[29];
	let P;
	t[30] === o ? P = t[31] : (P = Yl({ className: o }), t[30] = o, t[31] = P);
	let F;
	t[32] === Symbol.for("react.memo_cache_sentinel") ? (F = { maxHeight: "inherit" }, t[32] = F) : F = t[32];
	let I;
	t[33] !== a || t[34] !== c ? (I = c ? /* @__PURE__ */ X("div", {
		className: "px-4 pb-xs pt-2",
		children: [/* @__PURE__ */ Y("p", {
			className: "text-[0.875rem] font-bold uppercase text-legacy-neutrals-ash",
			children: c
		}), a ? /* @__PURE__ */ Y("p", {
			className: "text-[0.625rem] font-medium text-legacy-navy-L40",
			children: a
		}) : null]
	}) : null, t[33] = a, t[34] = c, t[35] = I) : I = t[35];
	let L;
	t[36] !== d || t[37] !== m || t[38] !== h || t[39] !== w ? (L = w ? /* @__PURE__ */ Y("div", {
		className: "flex p-0-5",
		children: /* @__PURE__ */ Y(Wl, {
			className: "w-full",
			onChange: d,
			placeholder: m || "Search",
			value: h
		})
	}) : null, t[36] = d, t[37] = m, t[38] = h, t[39] = w, t[40] = L) : L = t[40];
	let R;
	t[41] !== r || t[42] !== i || t[43] !== s || t[44] !== g ? (R = s ? /* @__PURE__ */ X("div", {
		className: "flex flex-col gap-y-1 p-2",
		children: [
			/* @__PURE__ */ Y(Gl, { width: "100%" }),
			/* @__PURE__ */ Y(Gl, { width: "100%" }),
			/* @__PURE__ */ Y(Gl, { width: "100%" }),
			/* @__PURE__ */ Y(Gl, { width: "100%" })
		]
	}) : /* @__PURE__ */ Y("ol", {
		className: W("flex flex-col", i, "gap-y-2"),
		role: "menu",
		style: g,
		children: r
	}), t[41] = r, t[42] = i, t[43] = s, t[44] = g, t[45] = R) : R = t[45];
	let z;
	t[46] !== I || t[47] !== L || t[48] !== R ? (z = /* @__PURE__ */ X("div", {
		className: "flex min-h-0 flex-1 flex-col gap-y-2 overflow-y-auto max-h-[min(26rem,70vh)]",
		children: [
			I,
			L,
			R
		]
	}), t[46] = I, t[47] = L, t[48] = R, t[49] = z) : z = t[49];
	let B;
	t[50] !== l || t[51] !== p || t[52] !== C ? (B = C ? /* @__PURE__ */ Y(Kl, {
		leftCTA: l,
		rightCTA: p
	}) : null, t[50] = l, t[51] = p, t[52] = C, t[53] = B) : B = t[53];
	let V;
	t[54] !== z || t[55] !== B || t[56] !== P ? (V = /* @__PURE__ */ X(fi, {
		className: P,
		style: F,
		children: [z, B]
	}), t[54] = z, t[55] = B, t[56] = P, t[57] = V) : V = t[57];
	let ee;
	t[58] !== x || t[59] !== V || t[60] !== N ? (ee = /* @__PURE__ */ Y(ji, {
		className: "scrollbar-custom",
		placement: x,
		style: N,
		children: V
	}), t[58] = x, t[59] = V, t[60] = N, t[61] = ee) : ee = t[61];
	let H;
	return t[62] !== f || t[63] !== ee || t[64] !== M ? (H = /* @__PURE__ */ X(mi, {
		...f,
		children: [M, ee]
	}), t[62] = f, t[63] = ee, t[64] = M, t[65] = H) : H = t[65], H;
}
//#endregion
//#region lib/components/SupportMenu/SupportMenu.tsx
function Zl(e) {
	let t = K(8), { display: n, userName: r, userEmail: i } = e, a = n === void 0 ? "button" : n, { open: o } = ya(i, r), s = Ql;
	if (a === "button") {
		let e;
		t[0] === Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ Y(Q, {
			"aria-controls": "menu-appbar",
			"aria-haspopup": "true",
			"aria-label": "support",
			className: "hover:bg-transparent hover:text-brand-primary focus:bg-transparent focus:text-neutral-700",
			variant: "tertiary",
			children: /* @__PURE__ */ Y(b, { className: "h-lg w-lg" })
		}), t[0] = e) : e = t[0];
		let n;
		t[1] === o ? n = t[2] : (n = /* @__PURE__ */ Y(Jl, {
			onPress: o,
			children: "Contact Support"
		}), t[1] = o, t[2] = n);
		let r;
		t[3] === Symbol.for("react.memo_cache_sentinel") ? (r = /* @__PURE__ */ Y(Jl, {
			onPress: s,
			children: "Explore Help Portal"
		}), t[3] = r) : r = t[3];
		let i;
		return t[4] === n ? i = t[5] : (i = /* @__PURE__ */ X(Xl, {
			AnchorEle: e,
			children: [n, r]
		}), t[4] = n, t[5] = i), i;
	}
	let c;
	return t[6] === o ? c = t[7] : (c = /* @__PURE__ */ Y("a", {
		className: "cursor-pointer text-label-large underline",
		onClick: o,
		role: "button",
		children: "Support"
	}), t[6] = o, t[7] = c), c;
}
function Ql() {
	window.open("https://stacklet.freshdesk.com/", "_blank");
}
//#endregion
//#region lib/components/AppHeader/AppHeader.tsx
function $l(e) {
	let t = K(17), { supportEnabled: n, username: r, email: i, docsUrl: a, children: o } = e, s = n !== void 0 && n, c;
	t[0] === a ? c = t[1] : (c = function() {
		window.open(a, "_blank");
	}, t[0] = a, t[1] = c);
	let l = c, u = s, d;
	t[2] === o ? d = t[3] : (d = /* @__PURE__ */ Y("span", {
		className: "text-page-headline font-semibold text-text-primary",
		children: o
	}), t[2] = o, t[3] = d);
	let f;
	t[4] !== i || t[5] !== u || t[6] !== r ? (f = u ? /* @__PURE__ */ Y(Zl, {
		userEmail: i || "",
		userName: r || ""
	}) : null, t[4] = i, t[5] = u, t[6] = r, t[7] = f) : f = t[7];
	let p;
	t[8] !== a || t[9] !== l ? (p = a ? /* @__PURE__ */ Y(Q, {
		"aria-controls": "menu-appbar",
		"aria-haspopup": "true",
		"aria-label": "documentation",
		className: "hover:bg-transparent hover:text-brand-primary focus:bg-transparent focus:text-neutral-700",
		onPress: l,
		variant: "tertiary",
		children: /* @__PURE__ */ Y(yn, { className: "size-lg" })
	}) : null, t[8] = a, t[9] = l, t[10] = p) : p = t[10];
	let m;
	t[11] !== f || t[12] !== p ? (m = /* @__PURE__ */ X("div", {
		className: "flex items-center justify-end gap-1",
		children: [f, p]
	}), t[11] = f, t[12] = p, t[13] = m) : m = t[13];
	let h;
	return t[14] !== d || t[15] !== m ? (h = /* @__PURE__ */ X("div", {
		className: "flex h-[3rem] w-full items-center justify-between gap-3 rounded-xl bg-overlay-medium px-xl py-md shadow",
		children: [d, m]
	}), t[14] = d, t[15] = m, t[16] = h) : h = t[16], h;
}
//#endregion
//#region lib/components/Avatar/avatarColors.ts
var eu = /* @__PURE__ */ pa((/* @__PURE__ */ ua(((e, t) => {
	(function(n) {
		if (typeof e == "object") t.exports = n();
		else if (typeof define == "function" && define.amd) define(n);
		else {
			var r;
			try {
				r = window;
			} catch {
				r = self;
			}
			r.SparkMD5 = n();
		}
	})(function(e) {
		var t = [
			"0",
			"1",
			"2",
			"3",
			"4",
			"5",
			"6",
			"7",
			"8",
			"9",
			"a",
			"b",
			"c",
			"d",
			"e",
			"f"
		];
		function n(e, t) {
			var n = e[0], r = e[1], i = e[2], a = e[3];
			n += (r & i | ~r & a) + t[0] - 680876936 | 0, n = (n << 7 | n >>> 25) + r | 0, a += (n & r | ~n & i) + t[1] - 389564586 | 0, a = (a << 12 | a >>> 20) + n | 0, i += (a & n | ~a & r) + t[2] + 606105819 | 0, i = (i << 17 | i >>> 15) + a | 0, r += (i & a | ~i & n) + t[3] - 1044525330 | 0, r = (r << 22 | r >>> 10) + i | 0, n += (r & i | ~r & a) + t[4] - 176418897 | 0, n = (n << 7 | n >>> 25) + r | 0, a += (n & r | ~n & i) + t[5] + 1200080426 | 0, a = (a << 12 | a >>> 20) + n | 0, i += (a & n | ~a & r) + t[6] - 1473231341 | 0, i = (i << 17 | i >>> 15) + a | 0, r += (i & a | ~i & n) + t[7] - 45705983 | 0, r = (r << 22 | r >>> 10) + i | 0, n += (r & i | ~r & a) + t[8] + 1770035416 | 0, n = (n << 7 | n >>> 25) + r | 0, a += (n & r | ~n & i) + t[9] - 1958414417 | 0, a = (a << 12 | a >>> 20) + n | 0, i += (a & n | ~a & r) + t[10] - 42063 | 0, i = (i << 17 | i >>> 15) + a | 0, r += (i & a | ~i & n) + t[11] - 1990404162 | 0, r = (r << 22 | r >>> 10) + i | 0, n += (r & i | ~r & a) + t[12] + 1804603682 | 0, n = (n << 7 | n >>> 25) + r | 0, a += (n & r | ~n & i) + t[13] - 40341101 | 0, a = (a << 12 | a >>> 20) + n | 0, i += (a & n | ~a & r) + t[14] - 1502002290 | 0, i = (i << 17 | i >>> 15) + a | 0, r += (i & a | ~i & n) + t[15] + 1236535329 | 0, r = (r << 22 | r >>> 10) + i | 0, n += (r & a | i & ~a) + t[1] - 165796510 | 0, n = (n << 5 | n >>> 27) + r | 0, a += (n & i | r & ~i) + t[6] - 1069501632 | 0, a = (a << 9 | a >>> 23) + n | 0, i += (a & r | n & ~r) + t[11] + 643717713 | 0, i = (i << 14 | i >>> 18) + a | 0, r += (i & n | a & ~n) + t[0] - 373897302 | 0, r = (r << 20 | r >>> 12) + i | 0, n += (r & a | i & ~a) + t[5] - 701558691 | 0, n = (n << 5 | n >>> 27) + r | 0, a += (n & i | r & ~i) + t[10] + 38016083 | 0, a = (a << 9 | a >>> 23) + n | 0, i += (a & r | n & ~r) + t[15] - 660478335 | 0, i = (i << 14 | i >>> 18) + a | 0, r += (i & n | a & ~n) + t[4] - 405537848 | 0, r = (r << 20 | r >>> 12) + i | 0, n += (r & a | i & ~a) + t[9] + 568446438 | 0, n = (n << 5 | n >>> 27) + r | 0, a += (n & i | r & ~i) + t[14] - 1019803690 | 0, a = (a << 9 | a >>> 23) + n | 0, i += (a & r | n & ~r) + t[3] - 187363961 | 0, i = (i << 14 | i >>> 18) + a | 0, r += (i & n | a & ~n) + t[8] + 1163531501 | 0, r = (r << 20 | r >>> 12) + i | 0, n += (r & a | i & ~a) + t[13] - 1444681467 | 0, n = (n << 5 | n >>> 27) + r | 0, a += (n & i | r & ~i) + t[2] - 51403784 | 0, a = (a << 9 | a >>> 23) + n | 0, i += (a & r | n & ~r) + t[7] + 1735328473 | 0, i = (i << 14 | i >>> 18) + a | 0, r += (i & n | a & ~n) + t[12] - 1926607734 | 0, r = (r << 20 | r >>> 12) + i | 0, n += (r ^ i ^ a) + t[5] - 378558 | 0, n = (n << 4 | n >>> 28) + r | 0, a += (n ^ r ^ i) + t[8] - 2022574463 | 0, a = (a << 11 | a >>> 21) + n | 0, i += (a ^ n ^ r) + t[11] + 1839030562 | 0, i = (i << 16 | i >>> 16) + a | 0, r += (i ^ a ^ n) + t[14] - 35309556 | 0, r = (r << 23 | r >>> 9) + i | 0, n += (r ^ i ^ a) + t[1] - 1530992060 | 0, n = (n << 4 | n >>> 28) + r | 0, a += (n ^ r ^ i) + t[4] + 1272893353 | 0, a = (a << 11 | a >>> 21) + n | 0, i += (a ^ n ^ r) + t[7] - 155497632 | 0, i = (i << 16 | i >>> 16) + a | 0, r += (i ^ a ^ n) + t[10] - 1094730640 | 0, r = (r << 23 | r >>> 9) + i | 0, n += (r ^ i ^ a) + t[13] + 681279174 | 0, n = (n << 4 | n >>> 28) + r | 0, a += (n ^ r ^ i) + t[0] - 358537222 | 0, a = (a << 11 | a >>> 21) + n | 0, i += (a ^ n ^ r) + t[3] - 722521979 | 0, i = (i << 16 | i >>> 16) + a | 0, r += (i ^ a ^ n) + t[6] + 76029189 | 0, r = (r << 23 | r >>> 9) + i | 0, n += (r ^ i ^ a) + t[9] - 640364487 | 0, n = (n << 4 | n >>> 28) + r | 0, a += (n ^ r ^ i) + t[12] - 421815835 | 0, a = (a << 11 | a >>> 21) + n | 0, i += (a ^ n ^ r) + t[15] + 530742520 | 0, i = (i << 16 | i >>> 16) + a | 0, r += (i ^ a ^ n) + t[2] - 995338651 | 0, r = (r << 23 | r >>> 9) + i | 0, n += (i ^ (r | ~a)) + t[0] - 198630844 | 0, n = (n << 6 | n >>> 26) + r | 0, a += (r ^ (n | ~i)) + t[7] + 1126891415 | 0, a = (a << 10 | a >>> 22) + n | 0, i += (n ^ (a | ~r)) + t[14] - 1416354905 | 0, i = (i << 15 | i >>> 17) + a | 0, r += (a ^ (i | ~n)) + t[5] - 57434055 | 0, r = (r << 21 | r >>> 11) + i | 0, n += (i ^ (r | ~a)) + t[12] + 1700485571 | 0, n = (n << 6 | n >>> 26) + r | 0, a += (r ^ (n | ~i)) + t[3] - 1894986606 | 0, a = (a << 10 | a >>> 22) + n | 0, i += (n ^ (a | ~r)) + t[10] - 1051523 | 0, i = (i << 15 | i >>> 17) + a | 0, r += (a ^ (i | ~n)) + t[1] - 2054922799 | 0, r = (r << 21 | r >>> 11) + i | 0, n += (i ^ (r | ~a)) + t[8] + 1873313359 | 0, n = (n << 6 | n >>> 26) + r | 0, a += (r ^ (n | ~i)) + t[15] - 30611744 | 0, a = (a << 10 | a >>> 22) + n | 0, i += (n ^ (a | ~r)) + t[6] - 1560198380 | 0, i = (i << 15 | i >>> 17) + a | 0, r += (a ^ (i | ~n)) + t[13] + 1309151649 | 0, r = (r << 21 | r >>> 11) + i | 0, n += (i ^ (r | ~a)) + t[4] - 145523070 | 0, n = (n << 6 | n >>> 26) + r | 0, a += (r ^ (n | ~i)) + t[11] - 1120210379 | 0, a = (a << 10 | a >>> 22) + n | 0, i += (n ^ (a | ~r)) + t[2] + 718787259 | 0, i = (i << 15 | i >>> 17) + a | 0, r += (a ^ (i | ~n)) + t[9] - 343485551 | 0, r = (r << 21 | r >>> 11) + i | 0, e[0] = n + e[0] | 0, e[1] = r + e[1] | 0, e[2] = i + e[2] | 0, e[3] = a + e[3] | 0;
		}
		function r(e) {
			var t = [], n;
			for (n = 0; n < 64; n += 4) t[n >> 2] = e.charCodeAt(n) + (e.charCodeAt(n + 1) << 8) + (e.charCodeAt(n + 2) << 16) + (e.charCodeAt(n + 3) << 24);
			return t;
		}
		function i(e) {
			var t = [], n;
			for (n = 0; n < 64; n += 4) t[n >> 2] = e[n] + (e[n + 1] << 8) + (e[n + 2] << 16) + (e[n + 3] << 24);
			return t;
		}
		function a(e) {
			var t = e.length, i = [
				1732584193,
				-271733879,
				-1732584194,
				271733878
			], a, o, s, c, l, u;
			for (a = 64; a <= t; a += 64) n(i, r(e.substring(a - 64, a)));
			for (e = e.substring(a - 64), o = e.length, s = [
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0
			], a = 0; a < o; a += 1) s[a >> 2] |= e.charCodeAt(a) << (a % 4 << 3);
			if (s[a >> 2] |= 128 << (a % 4 << 3), a > 55) for (n(i, s), a = 0; a < 16; a += 1) s[a] = 0;
			return c = t * 8, c = c.toString(16).match(/(.*?)(.{0,8})$/), l = parseInt(c[2], 16), u = parseInt(c[1], 16) || 0, s[14] = l, s[15] = u, n(i, s), i;
		}
		function o(e) {
			var t = e.length, r = [
				1732584193,
				-271733879,
				-1732584194,
				271733878
			], a, o, s, c, l, u;
			for (a = 64; a <= t; a += 64) n(r, i(e.subarray(a - 64, a)));
			for (e = a - 64 < t ? e.subarray(a - 64) : /* @__PURE__ */ new Uint8Array(), o = e.length, s = [
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0
			], a = 0; a < o; a += 1) s[a >> 2] |= e[a] << (a % 4 << 3);
			if (s[a >> 2] |= 128 << (a % 4 << 3), a > 55) for (n(r, s), a = 0; a < 16; a += 1) s[a] = 0;
			return c = t * 8, c = c.toString(16).match(/(.*?)(.{0,8})$/), l = parseInt(c[2], 16), u = parseInt(c[1], 16) || 0, s[14] = l, s[15] = u, n(r, s), r;
		}
		function s(e) {
			var n = "", r;
			for (r = 0; r < 4; r += 1) n += t[e >> r * 8 + 4 & 15] + t[e >> r * 8 & 15];
			return n;
		}
		function c(e) {
			var t;
			for (t = 0; t < e.length; t += 1) e[t] = s(e[t]);
			return e.join("");
		}
		c(a("hello")), typeof ArrayBuffer < "u" && !ArrayBuffer.prototype.slice && (function() {
			function t(e, t) {
				return e = e | 0 || 0, e < 0 ? Math.max(e + t, 0) : Math.min(e, t);
			}
			ArrayBuffer.prototype.slice = function(n, r) {
				var i = this.byteLength, a = t(n, i), o = i, s, c, l, u;
				return r !== e && (o = t(r, i)), a > o ? /* @__PURE__ */ new ArrayBuffer(0) : (s = o - a, c = new ArrayBuffer(s), l = new Uint8Array(c), u = new Uint8Array(this, a, s), l.set(u), c);
			};
		})();
		function l(e) {
			return /[\u0080-\uFFFF]/.test(e) && (e = unescape(encodeURIComponent(e))), e;
		}
		function u(e, t) {
			var n = e.length, r = new ArrayBuffer(n), i = new Uint8Array(r), a;
			for (a = 0; a < n; a += 1) i[a] = e.charCodeAt(a);
			return t ? i : r;
		}
		function d(e) {
			return String.fromCharCode.apply(null, new Uint8Array(e));
		}
		function f(e, t, n) {
			var r = new Uint8Array(e.byteLength + t.byteLength);
			return r.set(new Uint8Array(e)), r.set(new Uint8Array(t), e.byteLength), n ? r : r.buffer;
		}
		function p(e) {
			var t = [], n = e.length, r;
			for (r = 0; r < n - 1; r += 2) t.push(parseInt(e.substr(r, 2), 16));
			return String.fromCharCode.apply(String, t);
		}
		function m() {
			this.reset();
		}
		return m.prototype.append = function(e) {
			return this.appendBinary(l(e)), this;
		}, m.prototype.appendBinary = function(e) {
			this._buff += e, this._length += e.length;
			var t = this._buff.length, i;
			for (i = 64; i <= t; i += 64) n(this._hash, r(this._buff.substring(i - 64, i)));
			return this._buff = this._buff.substring(i - 64), this;
		}, m.prototype.end = function(e) {
			var t = this._buff, n = t.length, r, i = [
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0
			], a;
			for (r = 0; r < n; r += 1) i[r >> 2] |= t.charCodeAt(r) << (r % 4 << 3);
			return this._finish(i, n), a = c(this._hash), e && (a = p(a)), this.reset(), a;
		}, m.prototype.reset = function() {
			return this._buff = "", this._length = 0, this._hash = [
				1732584193,
				-271733879,
				-1732584194,
				271733878
			], this;
		}, m.prototype.getState = function() {
			return {
				buff: this._buff,
				length: this._length,
				hash: this._hash.slice()
			};
		}, m.prototype.setState = function(e) {
			return this._buff = e.buff, this._length = e.length, this._hash = e.hash, this;
		}, m.prototype.destroy = function() {
			delete this._hash, delete this._buff, delete this._length;
		}, m.prototype._finish = function(e, t) {
			var r = t, i, a, o;
			if (e[r >> 2] |= 128 << (r % 4 << 3), r > 55) for (n(this._hash, e), r = 0; r < 16; r += 1) e[r] = 0;
			i = this._length * 8, i = i.toString(16).match(/(.*?)(.{0,8})$/), a = parseInt(i[2], 16), o = parseInt(i[1], 16) || 0, e[14] = a, e[15] = o, n(this._hash, e);
		}, m.hash = function(e, t) {
			return m.hashBinary(l(e), t);
		}, m.hashBinary = function(e, t) {
			var n = c(a(e));
			return t ? p(n) : n;
		}, m.ArrayBuffer = function() {
			this.reset();
		}, m.ArrayBuffer.prototype.append = function(e) {
			var t = f(this._buff.buffer, e, !0), r = t.length, a;
			for (this._length += e.byteLength, a = 64; a <= r; a += 64) n(this._hash, i(t.subarray(a - 64, a)));
			return this._buff = a - 64 < r ? new Uint8Array(t.buffer.slice(a - 64)) : /* @__PURE__ */ new Uint8Array(), this;
		}, m.ArrayBuffer.prototype.end = function(e) {
			var t = this._buff, n = t.length, r = [
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				0
			], i, a;
			for (i = 0; i < n; i += 1) r[i >> 2] |= t[i] << (i % 4 << 3);
			return this._finish(r, n), a = c(this._hash), e && (a = p(a)), this.reset(), a;
		}, m.ArrayBuffer.prototype.reset = function() {
			return this._buff = /* @__PURE__ */ new Uint8Array(), this._length = 0, this._hash = [
				1732584193,
				-271733879,
				-1732584194,
				271733878
			], this;
		}, m.ArrayBuffer.prototype.getState = function() {
			var e = m.prototype.getState.call(this);
			return e.buff = d(e.buff), e;
		}, m.ArrayBuffer.prototype.setState = function(e) {
			return e.buff = u(e.buff, !0), m.prototype.setState.call(this, e);
		}, m.ArrayBuffer.prototype.destroy = m.prototype.destroy, m.ArrayBuffer.prototype._finish = m.prototype._finish, m.ArrayBuffer.hash = function(e, t) {
			var n = c(o(new Uint8Array(e)));
			return t ? p(n) : n;
		}, m;
	});
})))(), 1), tu = [
	{
		key: "indigo",
		label: "Indigo",
		bgClassName: "bg-data-viz-soft-indigo",
		textClassName: "text-data-viz-indigo-900"
	},
	{
		key: "purple",
		label: "Purple",
		bgClassName: "bg-data-viz-soft-violet",
		textClassName: "text-data-viz-violet-900"
	},
	{
		key: "pink",
		label: "Pink",
		bgClassName: "bg-data-viz-soft-pink",
		textClassName: "text-data-viz-pink-900"
	},
	{
		key: "red",
		label: "Red",
		bgClassName: "bg-data-viz-soft-red",
		textClassName: "text-data-viz-red-900"
	},
	{
		key: "orange",
		label: "Orange",
		bgClassName: "bg-data-viz-soft-orange",
		textClassName: "text-stacklet-orange-900"
	},
	{
		key: "yellow",
		label: "Yellow",
		bgClassName: "bg-data-viz-soft-yellow",
		textClassName: "text-data-viz-yellow-900"
	},
	{
		key: "green",
		label: "Green",
		bgClassName: "bg-data-viz-soft-green",
		textClassName: "text-data-viz-green-900"
	},
	{
		key: "blue",
		label: "Blue",
		bgClassName: "bg-data-viz-soft-blue",
		textClassName: "text-data-viz-blue-900"
	},
	{
		key: "grey",
		label: "Grey",
		bgClassName: "bg-data-viz-soft-grey",
		textClassName: "text-text-tag"
	}
], nu = Object.fromEntries(tu.map((e) => [e.key, e]));
function ru(e) {
	return e in nu;
}
function iu(e) {
	return nu[e];
}
var au = "gravatar";
function ou(e) {
	return e === "gravatar" || ru(e);
}
//#endregion
//#region lib/components/Avatar/formatter.ts
var su = (e) => {
	let [t, n, r] = (e.match(/.{2}/g) || []).map((e) => parseInt(e, 16)), i = (r * .299 + t * .587 + n * .114) / 255 > .6 ? "#222" : "#fff";
	return {
		background: `rgb(${[
			r,
			t,
			n
		]})`,
		color: i
	};
}, cu = (e, t = 2) => e.length <= t ? e : e.split(" ").map((e) => e.replace(/[^\p{L}]/gu, "")).filter(Boolean).slice(0, t).map((e) => e[0]).join("");
//#endregion
//#region lib/components/Avatar/Avatar.tsx
function lu(e) {
	let t = K(32), { email: n, name: r, size: i, colorKey: a } = e, o = i === void 0 ? 24 : i, s;
	t[0] === r ? s = t[1] : (s = cu(r), t[0] = r, t[1] = s);
	let c = s, l, u, d, f, p, m;
	if (t[2] !== a || t[3] !== n || t[4] !== c.length || t[5] !== o) {
		let e = eu.default.hash(n.trim().toLowerCase());
		d = a ? iu(a) : void 0, {background: l, color: u} = d ? {
			background: void 0,
			color: void 0
		} : su(e);
		let r = Math.max(o, 250), i;
		t[12] === r ? i = t[13] : (i = r.toString(), t[12] = r, t[13] = i), m = `https://www.gravatar.com/avatar/${e}?s=${i}&d=404`, f = o / (1 * Math.max(c.length, 2)), p = W("relative inline-flex shrink-0 items-center justify-center rounded-full", d?.bgClassName, d?.textClassName), t[2] = a, t[3] = n, t[4] = c.length, t[5] = o, t[6] = l, t[7] = u, t[8] = d, t[9] = f, t[10] = p, t[11] = m;
	} else l = t[6], u = t[7], d = t[8], f = t[9], p = t[10], m = t[11];
	let h;
	t[14] !== l || t[15] !== u || t[16] !== o ? (h = {
		width: o,
		height: o,
		backgroundColor: l,
		color: u
	}, t[14] = l, t[15] = u, t[16] = o, t[17] = h) : h = t[17];
	let g;
	t[18] === f ? g = t[19] : (g = { fontSize: f }, t[18] = f, t[19] = g);
	let _;
	t[20] !== c || t[21] !== g ? (_ = /* @__PURE__ */ Y("div", {
		className: "absolute select-none font-sans uppercase",
		style: g,
		children: c
	}), t[20] = c, t[21] = g, t[22] = _) : _ = t[22];
	let v;
	t[23] !== d || t[24] !== o || t[25] !== m ? (v = d ? null : /* @__PURE__ */ Y("div", {
		className: "absolute left-0 top-0 rounded-full bg-cover bg-center bg-no-repeat",
		style: {
			width: o,
			height: o,
			backgroundImage: `url(${m})`
		}
	}), t[23] = d, t[24] = o, t[25] = m, t[26] = v) : v = t[26];
	let y;
	return t[27] !== p || t[28] !== h || t[29] !== _ || t[30] !== v ? (y = /* @__PURE__ */ X("div", {
		className: p,
		style: h,
		children: [_, v]
	}), t[27] = p, t[28] = h, t[29] = _, t[30] = v, t[31] = y) : y = t[31], y;
}
//#endregion
//#region lib/components/BreadcrumbHeader/BreadcrumbNavList.tsx
function uu(e) {
	let t = K(7), { breadcrumbs: n } = e, r = n.length, i;
	if (t[0] !== n || t[1] !== r) {
		let e;
		t[3] === r ? e = t[4] : (e = (e, t) => /* @__PURE__ */ X(ii, {
			className: "flex items-center gap-md",
			children: [e.target ? /* @__PURE__ */ Y(wi, {
				className: "text text-label-medium text-interactive-tertiary-button-enabled-foreground data-[current]:font-bold data-[current]:text-text-primary",
				href: e.target,
				children: e.label
			}) : /* @__PURE__ */ Y("span", {
				className: "text-label-medium text-text-secondary",
				children: e.label
			}), t === r - 1 ? null : /* @__PURE__ */ Y(mn, { className: "text-foreground-primary" })]
		}, `${e.label}-${e.target ?? t}`), t[3] = r, t[4] = e), i = n.map(e), t[0] = n, t[1] = r, t[2] = i;
	} else i = t[2];
	let a;
	return t[5] === i ? a = t[6] : (a = /* @__PURE__ */ Y(ai, {
		"aria-label": "breadcrumb",
		className: "flex items-center gap-sm",
		children: i
	}), t[5] = i, t[6] = a), a;
}
//#endregion
//#region lib/components/BreadcrumbHeader/BreadcrumbHeader.tsx
function du(e) {
	let t = K(24), { pathname: n, breadcrumbs: r, supportEnabled: i, username: a, email: o, docsUrl: s, className: c, isLoading: l } = e, u = l !== void 0 && l, d;
	t[0] === s ? d = t[1] : (d = function() {
		window.open(s, "_blank");
	}, t[0] = s, t[1] = d);
	let f = d, p = i, m;
	t[2] === c ? m = t[3] : (m = W("flex items-center justify-between rounded-2 border border-overlay-medium bg-overlay-light p-md shadow backdrop-blur-md", c), t[2] = c, t[3] = m);
	let h;
	t[4] === u ? h = t[5] : (h = u ? /* @__PURE__ */ Y("span", {
		className: "flex items-center border border-transparent px-md py-xxs text-text-primary",
		children: /* @__PURE__ */ Y(fn, {})
	}) : /* @__PURE__ */ Y(Q, {
		IconLeft: /* @__PURE__ */ Y(fn, {}),
		variant: "plain"
	}), t[4] = u, t[5] = h);
	let g;
	t[6] !== r || t[7] !== u || t[8] !== n ? (g = u ? /* @__PURE__ */ X("div", {
		className: "flex items-center gap-md",
		children: [/* @__PURE__ */ Y(Gl, {
			height: 16,
			variant: "text",
			width: 96
		}), /* @__PURE__ */ Y(Gl, {
			height: 16,
			variant: "text",
			width: 128
		})]
	}) : /* @__PURE__ */ Y(uu, {
		breadcrumbs: r,
		pathname: n
	}), t[6] = r, t[7] = u, t[8] = n, t[9] = g) : g = t[9];
	let _;
	t[10] !== h || t[11] !== g ? (_ = /* @__PURE__ */ X("div", {
		className: "flex min-h-7 items-center gap-sm",
		children: [h, g]
	}), t[10] = h, t[11] = g, t[12] = _) : _ = t[12];
	let v;
	t[13] !== s || t[14] !== o || t[15] !== p || t[16] !== u || t[17] !== f || t[18] !== a ? (v = u ? null : /* @__PURE__ */ X("div", {
		className: "flex min-h-7 items-center justify-end gap-sm",
		children: [p ? /* @__PURE__ */ Y(qt, {
			title: "Support",
			asChild: !0,
			children: /* @__PURE__ */ Y("div", {
				className: "-mr-md",
				children: /* @__PURE__ */ Y(Zl, {
					userEmail: o || "",
					userName: a || ""
				})
			})
		}) : null, s ? /* @__PURE__ */ Y(qt, {
			title: "Documentation",
			asChild: !0,
			children: /* @__PURE__ */ Y(Q, {
				"aria-label": "documentation",
				className: "hover:bg-transparent hover:text-brand-primary focus:bg-transparent focus:text-neutral-700",
				onPress: f,
				variant: "tertiary",
				children: /* @__PURE__ */ Y(yn, { className: "size-lg" })
			})
		}) : null]
	}), t[13] = s, t[14] = o, t[15] = p, t[16] = u, t[17] = f, t[18] = a, t[19] = v) : v = t[19];
	let y;
	return t[20] !== m || t[21] !== _ || t[22] !== v ? (y = /* @__PURE__ */ X("div", {
		className: m,
		children: [_, v]
	}), t[20] = m, t[21] = _, t[22] = v, t[23] = y) : y = t[23], y;
}
//#endregion
//#region lib/components/Link/Link.tsx
var fu = (e) => {
	let t = K(15), n, r, i, a;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4]) : ({className: r, external: i, children: n, ...a} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a);
	let o = i ? "inline-flex items-center gap-1" : void 0, s;
	t[5] !== r || t[6] !== o ? (s = W("cursor-pointer underline outline-none data-[disabled]:cursor-not-allowed", "text-interactive-link-enabled hover:text-interactive-link-hover focus:text-interactive-link-focus data-[disabled]:text-interactive-link-disabled", o, r), t[5] = r, t[6] = o, t[7] = s) : s = t[7];
	let c;
	t[8] === i ? c = t[9] : (c = i ? /* @__PURE__ */ Y(sn, {
		fill: "currentColor",
		size: 12
	}) : null, t[8] = i, t[9] = c);
	let l;
	return t[10] !== n || t[11] !== a || t[12] !== s || t[13] !== c ? (l = /* @__PURE__ */ X(wi, {
		...a,
		className: s,
		children: [n, c]
	}), t[10] = n, t[11] = a, t[12] = s, t[13] = c, t[14] = l) : l = t[14], l;
}, pu = G({
	base: "px-md py-xxs transition-all ease-in-out font-semibold rounded-md text-label-medium inline-flex items-center gap-x-xs text-interactive-primary-button-enabled-foreground outline-none border border-transparent no-underline data-[disabled]:cursor-not-allowed",
	variants: Al,
	defaultVariants: kl
}), mu = (e) => {
	let t = K(17), n, r, i, a, o;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4], o = t[5]) : ({variant: o, children: i, IconLeft: n, IconRight: r, ...a} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a, t[5] = o);
	let s;
	t[6] !== e.className || t[7] !== o ? (s = pu({
		variant: o,
		class: e.className
	}), t[6] = e.className, t[7] = o, t[8] = s) : s = t[8];
	let c;
	t[9] !== n || t[10] !== r || t[11] !== i ? (c = (e) => typeof i == "function" ? i(e) : /* @__PURE__ */ X(Dr, { children: [
		n,
		i,
		r
	] }), t[9] = n, t[10] = r, t[11] = i, t[12] = c) : c = t[12];
	let l;
	return t[13] !== a || t[14] !== s || t[15] !== c ? (l = /* @__PURE__ */ Y(wi, {
		...a,
		className: s,
		children: c
	}), t[13] = a, t[14] = s, t[15] = c, t[16] = l) : l = t[16], l;
}, hu = G({
	base: "flex gap-xs",
	variants: {
		orientation: {
			horizontal: "flex-row",
			vertical: "flex-col"
		},
		align: {
			start: "",
			center: "",
			end: ""
		}
	},
	compoundVariants: [
		{
			orientation: "horizontal",
			align: "start",
			class: "justify-start"
		},
		{
			orientation: "horizontal",
			align: "center",
			class: "justify-center"
		},
		{
			orientation: "horizontal",
			align: "end",
			class: "justify-end"
		},
		{
			orientation: "vertical",
			align: "start",
			class: "items-start"
		},
		{
			orientation: "vertical",
			align: "center",
			class: "items-center"
		},
		{
			orientation: "vertical",
			align: "end",
			class: "items-end"
		}
	],
	defaultVariants: {
		orientation: "horizontal",
		align: "start"
	}
});
function gu(e) {
	let t = K(14), { children: n, isDisabled: r, orientation: i, align: a, className: o, ref: s } = e, c = r !== void 0 && r, l = i === void 0 ? "horizontal" : i, u = a === void 0 ? "start" : a, d = xr(), f;
	t[0] === c ? f = t[1] : (f = [[si, { isDisabled: c }]], t[0] = c, t[1] = f);
	let p;
	t[2] !== u || t[3] !== o || t[4] !== l ? (p = hu({
		orientation: l,
		align: u,
		class: o
	}), t[2] = u, t[3] = o, t[4] = l, t[5] = p) : p = t[5];
	let m;
	t[6] !== n || t[7] !== d || t[8] !== s || t[9] !== p ? (m = /* @__PURE__ */ Y("div", {
		"aria-label": "Actions",
		className: p,
		id: d,
		ref: s,
		role: "group",
		children: n
	}), t[6] = n, t[7] = d, t[8] = s, t[9] = p, t[10] = m) : m = t[10];
	let h;
	return t[11] !== f || t[12] !== m ? (h = /* @__PURE__ */ Y(Ni, {
		values: f,
		children: m
	}), t[11] = f, t[12] = m, t[13] = h) : h = t[13], h;
}
//#endregion
//#region lib/components/Card/Card.tsx
var _u = Bt({
	base: "rounded-sm bg-background-primary p-3",
	variants: {
		variant: {
			statCard: "bg-background-tertiary flex flex-col justify-center w-full",
			muted: "bg-background-tertiary"
		},
		elevation: {
			none: "shadow-none",
			sm: "shadow-sm",
			md: "shadow-md",
			lg: "shadow-lg"
		},
		isClickable: {
			true: "cursor-pointer w-full text-left border border-outline-decorative transition-colors duration-200 hover:border-outline-brand",
			false: ""
		}
	},
	defaultVariants: {
		elevation: "none",
		isClickable: !1
	}
});
function vu(e) {
	let t = K(14), { variant: n, elevation: r, className: i, children: a, onPress: o, "aria-describedby": s } = e, c = !!o, l;
	t[0] !== i || t[1] !== r || t[2] !== c || t[3] !== n ? (l = _u({
		variant: n,
		elevation: r,
		isClickable: c,
		className: i
	}), t[0] = i, t[1] = r, t[2] = c, t[3] = n, t[4] = l) : l = t[4];
	let u = l;
	if (c) {
		let e;
		return t[5] !== s || t[6] !== u || t[7] !== a || t[8] !== o ? (e = /* @__PURE__ */ Y(oi, {
			"aria-describedby": s,
			className: u,
			onPress: o,
			children: a
		}), t[5] = s, t[6] = u, t[7] = a, t[8] = o, t[9] = e) : e = t[9], e;
	}
	let d;
	return t[10] !== s || t[11] !== u || t[12] !== a ? (d = /* @__PURE__ */ Y("div", {
		"aria-describedby": s,
		className: u,
		children: a
	}), t[10] = s, t[11] = u, t[12] = a, t[13] = d) : d = t[13], d;
}
//#endregion
//#region lib/components/Paper/Paper.tsx
var yu = G({
	base: "bg-background-primary p-xl",
	variants: { variant: {
		"card-like": "rounded-sm border-2 border-background-secondary",
		pure: ""
	} },
	defaultVariants: { variant: "card-like" }
});
function bu(e) {
	let t = K(6), { variant: n, className: r, children: i } = e, a = n === void 0 ? "card-like" : n, o;
	t[0] !== r || t[1] !== a ? (o = yu({
		variant: a,
		class: r
	}), t[0] = r, t[1] = a, t[2] = o) : o = t[2];
	let s;
	return t[3] !== i || t[4] !== o ? (s = /* @__PURE__ */ Y("article", {
		className: o,
		children: i
	}), t[3] = i, t[4] = o, t[5] = s) : s = t[5], s;
}
//#endregion
//#region lib/components/Popover/Popover.tsx
var xu = G({ base: "rounded-1 border border-outline-decorative bg-background-primary shadow-md outline-none" });
function Su(e) {
	let t = K(22), n, r, i, a, o, s, c;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4], o = t[5], s = t[6], c = t[7]) : ({"aria-label": n, "aria-labelledby": r, className: a, dialogClassName: o, children: i, ref: c, ...s} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a, t[5] = o, t[6] = s, t[7] = c);
	let l;
	t[8] === a ? l = t[9] : (l = xu({ className: a }), t[8] = a, t[9] = l);
	let u;
	t[10] === o ? u = t[11] : (u = W("outline-none", o), t[10] = o, t[11] = u);
	let d;
	t[12] !== n || t[13] !== r || t[14] !== i || t[15] !== u ? (d = /* @__PURE__ */ Y(fi, {
		"aria-label": n,
		"aria-labelledby": r,
		className: u,
		children: i
	}), t[12] = n, t[13] = r, t[14] = i, t[15] = u, t[16] = d) : d = t[16];
	let f;
	return t[17] !== s || t[18] !== c || t[19] !== l || t[20] !== d ? (f = /* @__PURE__ */ Y(ji, {
		...s,
		className: l,
		ref: c,
		children: d
	}), t[17] = s, t[18] = c, t[19] = l, t[20] = d, t[21] = f) : f = t[21], f;
}
//#endregion
//#region lib/components/CopyButton/CopyButton.tsx
var Cu = G({
	base: "hover:cursor-pointer",
	variants: { variant: { "stacklet-orange": "text-stacklet-orange-700" } }
}), wu = G({
	base: "flex w-fit items-center gap-xxs",
	variants: { variant: { "stacklet-orange": "text-stacklet-orange-700" } }
});
function Tu(e) {
	let t = K(24), { "aria-label": n, children: r, className: i, copyLabel: a, tooltipTarget: o, value: s, variant: c } = e, l = o === void 0 ? "container" : o, [u, d] = jl(s), f = `Copy ${a ?? "value"}`;
	u === "copied" ? f = "Copied" : u === "failed" && (f = "Copy failed!");
	let p = n ?? `Copy ${a ?? "value"} button`, m = r === "" ? null : r, h = l === "icon", g;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (g = /* @__PURE__ */ Y(x, {}), t[0] = g) : g = t[0];
	let _ = h ? void 0 : i, v;
	t[1] !== _ || t[2] !== c ? (v = Cu({
		class: _,
		variant: c
	}), t[1] = _, t[2] = c, t[3] = v) : v = t[3];
	let y;
	t[4] === d ? y = t[5] : (y = () => d(), t[4] = d, t[5] = y);
	let b = h ? null : m, S;
	t[6] !== p || t[7] !== v || t[8] !== y || t[9] !== b ? (S = /* @__PURE__ */ Y(Q, {
		IconRight: g,
		"aria-label": p,
		className: v,
		onPress: y,
		variant: "tertiary",
		preventFocusOnPress: !0,
		children: b
	}), t[6] = p, t[7] = v, t[8] = y, t[9] = b, t[10] = S) : S = t[10];
	let C = S;
	if (h) {
		let e;
		t[11] !== i || t[12] !== c ? (e = wu({
			class: i,
			variant: c
		}), t[11] = i, t[12] = c, t[13] = e) : e = t[13];
		let n;
		t[14] !== C || t[15] !== f ? (n = /* @__PURE__ */ Y(qt, {
			shouldCloseOnPress: !1,
			title: f,
			asChild: !0,
			children: C
		}), t[14] = C, t[15] = f, t[16] = n) : n = t[16];
		let r;
		return t[17] !== m || t[18] !== e || t[19] !== n ? (r = /* @__PURE__ */ X("div", {
			className: e,
			children: [m, n]
		}), t[17] = m, t[18] = e, t[19] = n, t[20] = r) : r = t[20], r;
	}
	if (l === "none") return C;
	let w;
	return t[21] !== C || t[22] !== f ? (w = /* @__PURE__ */ Y(qt, {
		shouldCloseOnPress: !1,
		title: f,
		asChild: !0,
		children: C
	}), t[21] = C, t[22] = f, t[23] = w) : w = t[23], w;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/locale/en-US/_lib/formatDistance.js
var Eu = {
	lessThanXSeconds: {
		one: "less than a second",
		other: "less than {{count}} seconds"
	},
	xSeconds: {
		one: "1 second",
		other: "{{count}} seconds"
	},
	halfAMinute: "half a minute",
	lessThanXMinutes: {
		one: "less than a minute",
		other: "less than {{count}} minutes"
	},
	xMinutes: {
		one: "1 minute",
		other: "{{count}} minutes"
	},
	aboutXHours: {
		one: "about 1 hour",
		other: "about {{count}} hours"
	},
	xHours: {
		one: "1 hour",
		other: "{{count}} hours"
	},
	xDays: {
		one: "1 day",
		other: "{{count}} days"
	},
	aboutXWeeks: {
		one: "about 1 week",
		other: "about {{count}} weeks"
	},
	xWeeks: {
		one: "1 week",
		other: "{{count}} weeks"
	},
	aboutXMonths: {
		one: "about 1 month",
		other: "about {{count}} months"
	},
	xMonths: {
		one: "1 month",
		other: "{{count}} months"
	},
	aboutXYears: {
		one: "about 1 year",
		other: "about {{count}} years"
	},
	xYears: {
		one: "1 year",
		other: "{{count}} years"
	},
	overXYears: {
		one: "over 1 year",
		other: "over {{count}} years"
	},
	almostXYears: {
		one: "almost 1 year",
		other: "almost {{count}} years"
	}
}, Du = (e, t, n) => {
	let r, i = Eu[e];
	return r = typeof i == "string" ? i : t === 1 ? i.one : i.other.replace("{{count}}", t.toString()), n?.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/locale/_lib/buildFormatLongFn.js
function Ou(e) {
	return (t = {}) => {
		let n = t.width ? String(t.width) : e.defaultWidth;
		return e.formats[n] || e.formats[e.defaultWidth];
	};
}
var ku = {
	date: Ou({
		formats: {
			full: "EEEE, MMMM do, y",
			long: "MMMM do, y",
			medium: "MMM d, y",
			short: "MM/dd/yyyy"
		},
		defaultWidth: "full"
	}),
	time: Ou({
		formats: {
			full: "h:mm:ss a zzzz",
			long: "h:mm:ss a z",
			medium: "h:mm:ss a",
			short: "h:mm a"
		},
		defaultWidth: "full"
	}),
	dateTime: Ou({
		formats: {
			full: "{{date}} 'at' {{time}}",
			long: "{{date}} 'at' {{time}}",
			medium: "{{date}}, {{time}}",
			short: "{{date}}, {{time}}"
		},
		defaultWidth: "full"
	})
}, Au = {
	lastWeek: "'last' eeee 'at' p",
	yesterday: "'yesterday at' p",
	today: "'today at' p",
	tomorrow: "'tomorrow at' p",
	nextWeek: "eeee 'at' p",
	other: "P"
}, ju = (e, t, n, r) => Au[e];
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/locale/_lib/buildLocalizeFn.js
function Mu(e) {
	return (t, n) => {
		let r = n?.context ? String(n.context) : "standalone", i;
		if (r === "formatting" && e.formattingValues) {
			let t = e.defaultFormattingWidth || e.defaultWidth, r = n?.width ? String(n.width) : t;
			i = e.formattingValues[r] || e.formattingValues[t];
		} else {
			let t = e.defaultWidth, r = n?.width ? String(n.width) : e.defaultWidth;
			i = e.values[r] || e.values[t];
		}
		let a = e.argumentCallback ? e.argumentCallback(t) : t;
		return i[a];
	};
}
var Nu = {
	ordinalNumber: (e, t) => {
		let n = Number(e), r = n % 100;
		if (r > 20 || r < 10) switch (r % 10) {
			case 1: return n + "st";
			case 2: return n + "nd";
			case 3: return n + "rd";
		}
		return n + "th";
	},
	era: Mu({
		values: {
			narrow: ["B", "A"],
			abbreviated: ["BC", "AD"],
			wide: ["Before Christ", "Anno Domini"]
		},
		defaultWidth: "wide"
	}),
	quarter: Mu({
		values: {
			narrow: [
				"1",
				"2",
				"3",
				"4"
			],
			abbreviated: [
				"Q1",
				"Q2",
				"Q3",
				"Q4"
			],
			wide: [
				"1st quarter",
				"2nd quarter",
				"3rd quarter",
				"4th quarter"
			]
		},
		defaultWidth: "wide",
		argumentCallback: (e) => e - 1
	}),
	month: Mu({
		values: {
			narrow: [
				"J",
				"F",
				"M",
				"A",
				"M",
				"J",
				"J",
				"A",
				"S",
				"O",
				"N",
				"D"
			],
			abbreviated: [
				"Jan",
				"Feb",
				"Mar",
				"Apr",
				"May",
				"Jun",
				"Jul",
				"Aug",
				"Sep",
				"Oct",
				"Nov",
				"Dec"
			],
			wide: [
				"January",
				"February",
				"March",
				"April",
				"May",
				"June",
				"July",
				"August",
				"September",
				"October",
				"November",
				"December"
			]
		},
		defaultWidth: "wide"
	}),
	day: Mu({
		values: {
			narrow: [
				"S",
				"M",
				"T",
				"W",
				"T",
				"F",
				"S"
			],
			short: [
				"Su",
				"Mo",
				"Tu",
				"We",
				"Th",
				"Fr",
				"Sa"
			],
			abbreviated: [
				"Sun",
				"Mon",
				"Tue",
				"Wed",
				"Thu",
				"Fri",
				"Sat"
			],
			wide: [
				"Sunday",
				"Monday",
				"Tuesday",
				"Wednesday",
				"Thursday",
				"Friday",
				"Saturday"
			]
		},
		defaultWidth: "wide"
	}),
	dayPeriod: Mu({
		values: {
			narrow: {
				am: "a",
				pm: "p",
				midnight: "mi",
				noon: "n",
				morning: "morning",
				afternoon: "afternoon",
				evening: "evening",
				night: "night"
			},
			abbreviated: {
				am: "AM",
				pm: "PM",
				midnight: "midnight",
				noon: "noon",
				morning: "morning",
				afternoon: "afternoon",
				evening: "evening",
				night: "night"
			},
			wide: {
				am: "a.m.",
				pm: "p.m.",
				midnight: "midnight",
				noon: "noon",
				morning: "morning",
				afternoon: "afternoon",
				evening: "evening",
				night: "night"
			}
		},
		defaultWidth: "wide",
		formattingValues: {
			narrow: {
				am: "a",
				pm: "p",
				midnight: "mi",
				noon: "n",
				morning: "in the morning",
				afternoon: "in the afternoon",
				evening: "in the evening",
				night: "at night"
			},
			abbreviated: {
				am: "AM",
				pm: "PM",
				midnight: "midnight",
				noon: "noon",
				morning: "in the morning",
				afternoon: "in the afternoon",
				evening: "in the evening",
				night: "at night"
			},
			wide: {
				am: "a.m.",
				pm: "p.m.",
				midnight: "midnight",
				noon: "noon",
				morning: "in the morning",
				afternoon: "in the afternoon",
				evening: "in the evening",
				night: "at night"
			}
		},
		defaultFormattingWidth: "wide"
	})
};
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/locale/_lib/buildMatchFn.js
function Pu(e) {
	return (t, n = {}) => {
		let r = n.width, i = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], a = t.match(i);
		if (!a) return null;
		let o = a[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(s) ? Iu(s, (e) => e.test(o)) : Fu(s, (e) => e.test(o)), l;
		l = e.valueCallback ? e.valueCallback(c) : c, l = n.valueCallback ? n.valueCallback(l) : l;
		let u = t.slice(o.length);
		return {
			value: l,
			rest: u
		};
	};
}
function Fu(e, t) {
	for (let n in e) if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n])) return n;
}
function Iu(e, t) {
	for (let n = 0; n < e.length; n++) if (t(e[n])) return n;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/locale/_lib/buildMatchPatternFn.js
function Lu(e) {
	return (t, n = {}) => {
		let r = t.match(e.matchPattern);
		if (!r) return null;
		let i = r[0], a = t.match(e.parsePattern);
		if (!a) return null;
		let o = e.valueCallback ? e.valueCallback(a[0]) : a[0];
		o = n.valueCallback ? n.valueCallback(o) : o;
		let s = t.slice(i.length);
		return {
			value: o,
			rest: s
		};
	};
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/locale/en-US.js
var Ru = {
	code: "en-US",
	formatDistance: Du,
	formatLong: ku,
	formatRelative: ju,
	localize: Nu,
	match: {
		ordinalNumber: Lu({
			matchPattern: /^(\d+)(th|st|nd|rd)?/i,
			parsePattern: /\d+/i,
			valueCallback: (e) => parseInt(e, 10)
		}),
		era: Pu({
			matchPatterns: {
				narrow: /^(b|a)/i,
				abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
				wide: /^(before christ|before common era|anno domini|common era)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [/^b/i, /^(a|c)/i] },
			defaultParseWidth: "any"
		}),
		quarter: Pu({
			matchPatterns: {
				narrow: /^[1234]/i,
				abbreviated: /^q[1234]/i,
				wide: /^[1234](th|st|nd|rd)? quarter/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [
				/1/i,
				/2/i,
				/3/i,
				/4/i
			] },
			defaultParseWidth: "any",
			valueCallback: (e) => e + 1
		}),
		month: Pu({
			matchPatterns: {
				narrow: /^[jfmasond]/i,
				abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
				wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/^j/i,
					/^f/i,
					/^m/i,
					/^a/i,
					/^m/i,
					/^j/i,
					/^j/i,
					/^a/i,
					/^s/i,
					/^o/i,
					/^n/i,
					/^d/i
				],
				any: [
					/^ja/i,
					/^f/i,
					/^mar/i,
					/^ap/i,
					/^may/i,
					/^jun/i,
					/^jul/i,
					/^au/i,
					/^s/i,
					/^o/i,
					/^n/i,
					/^d/i
				]
			},
			defaultParseWidth: "any"
		}),
		day: Pu({
			matchPatterns: {
				narrow: /^[smtwf]/i,
				short: /^(su|mo|tu|we|th|fr|sa)/i,
				abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
				wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/^s/i,
					/^m/i,
					/^t/i,
					/^w/i,
					/^t/i,
					/^f/i,
					/^s/i
				],
				any: [
					/^su/i,
					/^m/i,
					/^tu/i,
					/^w/i,
					/^th/i,
					/^f/i,
					/^sa/i
				]
			},
			defaultParseWidth: "any"
		}),
		dayPeriod: Pu({
			matchPatterns: {
				narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
				any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
			},
			defaultMatchWidth: "any",
			parsePatterns: { any: {
				am: /^a/i,
				pm: /^p/i,
				midnight: /^mi/i,
				noon: /^no/i,
				morning: /morning/i,
				afternoon: /afternoon/i,
				evening: /evening/i,
				night: /night/i
			} },
			defaultParseWidth: "any"
		})
	},
	options: {
		weekStartsOn: 0,
		firstWeekContainsDate: 1
	}
}, zu = {};
function Bu() {
	return zu;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/constants.js
var Vu = 365.2425, Hu = 6048e5, Uu = 864e5, Wu = 86400;
Wu * 7, Wu * Vu / 12 * 3;
var Gu = Symbol.for("constructDateFrom");
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/constructFrom.js
function Ku(e, t) {
	return typeof e == "function" ? e(t) : e && typeof e == "object" && Gu in e ? e[Gu](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/toDate.js
function qu(e, t) {
	return Ku(t || e, e);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/_lib/getTimezoneOffsetInMilliseconds.js
function Ju(e) {
	let t = qu(e), n = new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()));
	return n.setUTCFullYear(t.getFullYear()), e - +n;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/_lib/normalizeDates.js
function Yu(e, ...t) {
	let n = Ku.bind(null, e || t.find((e) => typeof e == "object"));
	return t.map(n);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/startOfDay.js
function Xu(e, t) {
	let n = qu(e, t?.in);
	return n.setHours(0, 0, 0, 0), n;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/differenceInCalendarDays.js
function Zu(e, t, n) {
	let [r, i] = Yu(n?.in, e, t), a = Xu(r), o = Xu(i), s = +a - Ju(a), c = +o - Ju(o);
	return Math.round((s - c) / Uu);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/startOfYear.js
function Qu(e, t) {
	let n = qu(e, t?.in);
	return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/getDayOfYear.js
function $u(e, t) {
	let n = qu(e, t?.in);
	return Zu(n, Qu(n)) + 1;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/startOfWeek.js
function ed(e, t) {
	let n = Bu(), r = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, i = qu(e, t?.in), a = i.getDay(), o = (a < r ? 7 : 0) + a - r;
	return i.setDate(i.getDate() - o), i.setHours(0, 0, 0, 0), i;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/startOfISOWeek.js
function td(e, t) {
	return ed(e, {
		...t,
		weekStartsOn: 1
	});
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/getISOWeekYear.js
function nd(e, t) {
	let n = qu(e, t?.in), r = n.getFullYear(), i = Ku(n, 0);
	i.setFullYear(r + 1, 0, 4), i.setHours(0, 0, 0, 0);
	let a = td(i), o = Ku(n, 0);
	o.setFullYear(r, 0, 4), o.setHours(0, 0, 0, 0);
	let s = td(o);
	return n.getTime() >= a.getTime() ? r + 1 : n.getTime() >= s.getTime() ? r : r - 1;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/startOfISOWeekYear.js
function rd(e, t) {
	let n = nd(e, t), r = Ku(t?.in || e, 0);
	return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), td(r);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/getISOWeek.js
function id(e, t) {
	let n = qu(e, t?.in), r = td(n) - +rd(n);
	return Math.round(r / Hu) + 1;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/getWeekYear.js
function ad(e, t) {
	let n = qu(e, t?.in), r = n.getFullYear(), i = Bu(), a = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? i.firstWeekContainsDate ?? i.locale?.options?.firstWeekContainsDate ?? 1, o = Ku(t?.in || e, 0);
	o.setFullYear(r + 1, 0, a), o.setHours(0, 0, 0, 0);
	let s = ed(o, t), c = Ku(t?.in || e, 0);
	c.setFullYear(r, 0, a), c.setHours(0, 0, 0, 0);
	let l = ed(c, t);
	return +n >= +s ? r + 1 : +n >= +l ? r : r - 1;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/startOfWeekYear.js
function od(e, t) {
	let n = Bu(), r = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? n.firstWeekContainsDate ?? n.locale?.options?.firstWeekContainsDate ?? 1, i = ad(e, t), a = Ku(t?.in || e, 0);
	return a.setFullYear(i, 0, r), a.setHours(0, 0, 0, 0), ed(a, t);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/getWeek.js
function sd(e, t) {
	let n = qu(e, t?.in), r = ed(n, t) - +od(n, t);
	return Math.round(r / Hu) + 1;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/_lib/addLeadingZeros.js
function cd(e, t) {
	return (e < 0 ? "-" : "") + Math.abs(e).toString().padStart(t, "0");
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/_lib/format/lightFormatters.js
var ld = {
	y(e, t) {
		let n = e.getFullYear(), r = n > 0 ? n : 1 - n;
		return cd(t === "yy" ? r % 100 : r, t.length);
	},
	M(e, t) {
		let n = e.getMonth();
		return t === "M" ? String(n + 1) : cd(n + 1, 2);
	},
	d(e, t) {
		return cd(e.getDate(), t.length);
	},
	a(e, t) {
		let n = e.getHours() / 12 >= 1 ? "pm" : "am";
		switch (t) {
			case "a":
			case "aa": return n.toUpperCase();
			case "aaa": return n;
			case "aaaaa": return n[0];
			default: return n === "am" ? "a.m." : "p.m.";
		}
	},
	h(e, t) {
		return cd(e.getHours() % 12 || 12, t.length);
	},
	H(e, t) {
		return cd(e.getHours(), t.length);
	},
	m(e, t) {
		return cd(e.getMinutes(), t.length);
	},
	s(e, t) {
		return cd(e.getSeconds(), t.length);
	},
	S(e, t) {
		let n = t.length, r = e.getMilliseconds();
		return cd(Math.trunc(r * 10 ** (n - 3)), t.length);
	}
}, ud = {
	am: "am",
	pm: "pm",
	midnight: "midnight",
	noon: "noon",
	morning: "morning",
	afternoon: "afternoon",
	evening: "evening",
	night: "night"
}, dd = {
	G: function(e, t, n) {
		let r = +(e.getFullYear() > 0);
		switch (t) {
			case "G":
			case "GG":
			case "GGG": return n.era(r, { width: "abbreviated" });
			case "GGGGG": return n.era(r, { width: "narrow" });
			default: return n.era(r, { width: "wide" });
		}
	},
	y: function(e, t, n) {
		if (t === "yo") {
			let t = e.getFullYear(), r = t > 0 ? t : 1 - t;
			return n.ordinalNumber(r, { unit: "year" });
		}
		return ld.y(e, t);
	},
	Y: function(e, t, n, r) {
		let i = ad(e, r), a = i > 0 ? i : 1 - i;
		return t === "YY" ? cd(a % 100, 2) : t === "Yo" ? n.ordinalNumber(a, { unit: "year" }) : cd(a, t.length);
	},
	R: function(e, t) {
		return cd(nd(e), t.length);
	},
	u: function(e, t) {
		return cd(e.getFullYear(), t.length);
	},
	Q: function(e, t, n) {
		let r = Math.ceil((e.getMonth() + 1) / 3);
		switch (t) {
			case "Q": return String(r);
			case "QQ": return cd(r, 2);
			case "Qo": return n.ordinalNumber(r, { unit: "quarter" });
			case "QQQ": return n.quarter(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "QQQQQ": return n.quarter(r, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.quarter(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	q: function(e, t, n) {
		let r = Math.ceil((e.getMonth() + 1) / 3);
		switch (t) {
			case "q": return String(r);
			case "qq": return cd(r, 2);
			case "qo": return n.ordinalNumber(r, { unit: "quarter" });
			case "qqq": return n.quarter(r, {
				width: "abbreviated",
				context: "standalone"
			});
			case "qqqqq": return n.quarter(r, {
				width: "narrow",
				context: "standalone"
			});
			default: return n.quarter(r, {
				width: "wide",
				context: "standalone"
			});
		}
	},
	M: function(e, t, n) {
		let r = e.getMonth();
		switch (t) {
			case "M":
			case "MM": return ld.M(e, t);
			case "Mo": return n.ordinalNumber(r + 1, { unit: "month" });
			case "MMM": return n.month(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "MMMMM": return n.month(r, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.month(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	L: function(e, t, n) {
		let r = e.getMonth();
		switch (t) {
			case "L": return String(r + 1);
			case "LL": return cd(r + 1, 2);
			case "Lo": return n.ordinalNumber(r + 1, { unit: "month" });
			case "LLL": return n.month(r, {
				width: "abbreviated",
				context: "standalone"
			});
			case "LLLLL": return n.month(r, {
				width: "narrow",
				context: "standalone"
			});
			default: return n.month(r, {
				width: "wide",
				context: "standalone"
			});
		}
	},
	w: function(e, t, n, r) {
		let i = sd(e, r);
		return t === "wo" ? n.ordinalNumber(i, { unit: "week" }) : cd(i, t.length);
	},
	I: function(e, t, n) {
		let r = id(e);
		return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : cd(r, t.length);
	},
	d: function(e, t, n) {
		return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : ld.d(e, t);
	},
	D: function(e, t, n) {
		let r = $u(e);
		return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : cd(r, t.length);
	},
	E: function(e, t, n) {
		let r = e.getDay();
		switch (t) {
			case "E":
			case "EE":
			case "EEE": return n.day(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "EEEEE": return n.day(r, {
				width: "narrow",
				context: "formatting"
			});
			case "EEEEEE": return n.day(r, {
				width: "short",
				context: "formatting"
			});
			default: return n.day(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	e: function(e, t, n, r) {
		let i = e.getDay(), a = (i - r.weekStartsOn + 8) % 7 || 7;
		switch (t) {
			case "e": return String(a);
			case "ee": return cd(a, 2);
			case "eo": return n.ordinalNumber(a, { unit: "day" });
			case "eee": return n.day(i, {
				width: "abbreviated",
				context: "formatting"
			});
			case "eeeee": return n.day(i, {
				width: "narrow",
				context: "formatting"
			});
			case "eeeeee": return n.day(i, {
				width: "short",
				context: "formatting"
			});
			default: return n.day(i, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	c: function(e, t, n, r) {
		let i = e.getDay(), a = (i - r.weekStartsOn + 8) % 7 || 7;
		switch (t) {
			case "c": return String(a);
			case "cc": return cd(a, t.length);
			case "co": return n.ordinalNumber(a, { unit: "day" });
			case "ccc": return n.day(i, {
				width: "abbreviated",
				context: "standalone"
			});
			case "ccccc": return n.day(i, {
				width: "narrow",
				context: "standalone"
			});
			case "cccccc": return n.day(i, {
				width: "short",
				context: "standalone"
			});
			default: return n.day(i, {
				width: "wide",
				context: "standalone"
			});
		}
	},
	i: function(e, t, n) {
		let r = e.getDay(), i = r === 0 ? 7 : r;
		switch (t) {
			case "i": return String(i);
			case "ii": return cd(i, t.length);
			case "io": return n.ordinalNumber(i, { unit: "day" });
			case "iii": return n.day(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "iiiii": return n.day(r, {
				width: "narrow",
				context: "formatting"
			});
			case "iiiiii": return n.day(r, {
				width: "short",
				context: "formatting"
			});
			default: return n.day(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	a: function(e, t, n) {
		let r = e.getHours() / 12 >= 1 ? "pm" : "am";
		switch (t) {
			case "a":
			case "aa": return n.dayPeriod(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "aaa": return n.dayPeriod(r, {
				width: "abbreviated",
				context: "formatting"
			}).toLowerCase();
			case "aaaaa": return n.dayPeriod(r, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.dayPeriod(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	b: function(e, t, n) {
		let r = e.getHours(), i;
		switch (i = r === 12 ? ud.noon : r === 0 ? ud.midnight : r / 12 >= 1 ? "pm" : "am", t) {
			case "b":
			case "bb": return n.dayPeriod(i, {
				width: "abbreviated",
				context: "formatting"
			});
			case "bbb": return n.dayPeriod(i, {
				width: "abbreviated",
				context: "formatting"
			}).toLowerCase();
			case "bbbbb": return n.dayPeriod(i, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.dayPeriod(i, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	B: function(e, t, n) {
		let r = e.getHours(), i;
		switch (i = r >= 17 ? ud.evening : r >= 12 ? ud.afternoon : r >= 4 ? ud.morning : ud.night, t) {
			case "B":
			case "BB":
			case "BBB": return n.dayPeriod(i, {
				width: "abbreviated",
				context: "formatting"
			});
			case "BBBBB": return n.dayPeriod(i, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.dayPeriod(i, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	h: function(e, t, n) {
		if (t === "ho") {
			let t = e.getHours() % 12;
			return t === 0 && (t = 12), n.ordinalNumber(t, { unit: "hour" });
		}
		return ld.h(e, t);
	},
	H: function(e, t, n) {
		return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : ld.H(e, t);
	},
	K: function(e, t, n) {
		let r = e.getHours() % 12;
		return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : cd(r, t.length);
	},
	k: function(e, t, n) {
		let r = e.getHours();
		return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : cd(r, t.length);
	},
	m: function(e, t, n) {
		return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : ld.m(e, t);
	},
	s: function(e, t, n) {
		return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : ld.s(e, t);
	},
	S: function(e, t) {
		return ld.S(e, t);
	},
	X: function(e, t, n) {
		let r = e.getTimezoneOffset();
		if (r === 0) return "Z";
		switch (t) {
			case "X": return pd(r);
			case "XXXX":
			case "XX": return md(r);
			default: return md(r, ":");
		}
	},
	x: function(e, t, n) {
		let r = e.getTimezoneOffset();
		switch (t) {
			case "x": return pd(r);
			case "xxxx":
			case "xx": return md(r);
			default: return md(r, ":");
		}
	},
	O: function(e, t, n) {
		let r = e.getTimezoneOffset();
		switch (t) {
			case "O":
			case "OO":
			case "OOO": return "GMT" + fd(r, ":");
			default: return "GMT" + md(r, ":");
		}
	},
	z: function(e, t, n) {
		let r = e.getTimezoneOffset();
		switch (t) {
			case "z":
			case "zz":
			case "zzz": return "GMT" + fd(r, ":");
			default: return "GMT" + md(r, ":");
		}
	},
	t: function(e, t, n) {
		return cd(Math.trunc(e / 1e3), t.length);
	},
	T: function(e, t, n) {
		return cd(+e, t.length);
	}
};
function fd(e, t = "") {
	let n = e > 0 ? "-" : "+", r = Math.abs(e), i = Math.trunc(r / 60), a = r % 60;
	return a === 0 ? n + String(i) : n + String(i) + t + cd(a, 2);
}
function pd(e, t) {
	return e % 60 == 0 ? (e > 0 ? "-" : "+") + cd(Math.abs(e) / 60, 2) : md(e, t);
}
function md(e, t = "") {
	let n = e > 0 ? "-" : "+", r = Math.abs(e), i = cd(Math.trunc(r / 60), 2), a = cd(r % 60, 2);
	return n + i + t + a;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/_lib/format/longFormatters.js
var hd = (e, t) => {
	switch (e) {
		case "P": return t.date({ width: "short" });
		case "PP": return t.date({ width: "medium" });
		case "PPP": return t.date({ width: "long" });
		default: return t.date({ width: "full" });
	}
}, gd = (e, t) => {
	switch (e) {
		case "p": return t.time({ width: "short" });
		case "pp": return t.time({ width: "medium" });
		case "ppp": return t.time({ width: "long" });
		default: return t.time({ width: "full" });
	}
}, _d = {
	p: gd,
	P: (e, t) => {
		let n = e.match(/(P+)(p+)?/) || [], r = n[1], i = n[2];
		if (!i) return hd(e, t);
		let a;
		switch (r) {
			case "P":
				a = t.dateTime({ width: "short" });
				break;
			case "PP":
				a = t.dateTime({ width: "medium" });
				break;
			case "PPP":
				a = t.dateTime({ width: "long" });
				break;
			default: a = t.dateTime({ width: "full" });
		}
		return a.replace("{{date}}", hd(r, t)).replace("{{time}}", gd(i, t));
	}
}, vd = /^D+$/, yd = /^Y+$/, bd = [
	"D",
	"DD",
	"YY",
	"YYYY"
];
function xd(e) {
	return vd.test(e);
}
function Sd(e) {
	return yd.test(e);
}
function Cd(e, t, n) {
	let r = wd(e, t, n);
	if (console.warn(r), bd.includes(e)) throw RangeError(r);
}
function wd(e, t, n) {
	let r = e[0] === "Y" ? "years" : "days of the month";
	return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/isDate.js
function Td(e) {
	return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/isValid.js
function Ed(e) {
	return !(!Td(e) && typeof e != "number" || isNaN(+qu(e)));
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/format.js
var Dd = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Od = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, kd = /^'([^]*?)'?$/, Ad = /''/g, jd = /[a-zA-Z]/;
function Md(e, t, n) {
	let r = Bu(), i = n?.locale ?? r.locale ?? Ru, a = n?.firstWeekContainsDate ?? n?.locale?.options?.firstWeekContainsDate ?? r.firstWeekContainsDate ?? r.locale?.options?.firstWeekContainsDate ?? 1, o = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? r.weekStartsOn ?? r.locale?.options?.weekStartsOn ?? 0, s = qu(e, n?.in);
	if (!Ed(s)) throw RangeError("Invalid time value");
	let c = t.match(Od).map((e) => {
		let t = e[0];
		if (t === "p" || t === "P") {
			let n = _d[t];
			return n(e, i.formatLong);
		}
		return e;
	}).join("").match(Dd).map((e) => {
		if (e === "''") return {
			isToken: !1,
			value: "'"
		};
		let t = e[0];
		if (t === "'") return {
			isToken: !1,
			value: Nd(e)
		};
		if (dd[t]) return {
			isToken: !0,
			value: e
		};
		if (t.match(jd)) throw RangeError("Format string contains an unescaped latin alphabet character `" + t + "`");
		return {
			isToken: !1,
			value: e
		};
	});
	i.localize.preprocessor && (c = i.localize.preprocessor(s, c));
	let l = {
		firstWeekContainsDate: a,
		weekStartsOn: o,
		locale: i
	};
	return c.map((r) => {
		if (!r.isToken) return r.value;
		let a = r.value;
		(!n?.useAdditionalWeekYearTokens && Sd(a) || !n?.useAdditionalDayOfYearTokens && xd(a)) && Cd(a, t, String(e));
		let o = dd[a[0]];
		return o(s, a, i.localize, l);
	}).join("");
}
function Nd(e) {
	let t = e.match(kd);
	return t ? t[1].replace(Ad, "'") : e;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns-tz@3.2.0_date-fns@4.1.0/node_modules/date-fns-tz/dist/esm/_lib/tzIntlTimeZoneName/index.js
function Pd(e, t, n) {
	let r = ri(), i = Ld(e, n.timeZone, n.locale ?? r.locale);
	return "formatToParts" in i ? Fd(i, t) : Id(i, t);
}
function Fd(e, t) {
	let n = e.formatToParts(t);
	for (let e = n.length - 1; e >= 0; --e) if (n[e].type === "timeZoneName") return n[e].value;
}
function Id(e, t) {
	let n = e.format(t).replace(/\u200E/g, ""), r = / [\w-+ ]+$/.exec(n);
	return r ? r[0].substr(1) : "";
}
function Ld(e, t, n) {
	return new Intl.DateTimeFormat(n ? [n.code, "en-US"] : void 0, {
		timeZone: t,
		timeZoneName: e
	});
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns-tz@3.2.0_date-fns@4.1.0/node_modules/date-fns-tz/dist/esm/_lib/tzTokenizeDate/index.js
function Rd(e, t) {
	let n = Gd(t);
	return "formatToParts" in n ? Bd(n, e) : Vd(n, e);
}
var zd = {
	year: 0,
	month: 1,
	day: 2,
	hour: 3,
	minute: 4,
	second: 5
};
function Bd(e, t) {
	try {
		let n = e.formatToParts(t), r = [];
		for (let e = 0; e < n.length; e++) {
			let t = zd[n[e].type];
			t !== void 0 && (r[t] = parseInt(n[e].value, 10));
		}
		return r;
	} catch (e) {
		if (e instanceof RangeError) return [NaN];
		throw e;
	}
}
function Vd(e, t) {
	let n = e.format(t), r = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(n);
	return [
		parseInt(r[3], 10),
		parseInt(r[1], 10),
		parseInt(r[2], 10),
		parseInt(r[4], 10),
		parseInt(r[5], 10),
		parseInt(r[6], 10)
	];
}
var Hd = {}, Ud = new Intl.DateTimeFormat("en-US", {
	hourCycle: "h23",
	timeZone: "America/New_York",
	year: "numeric",
	month: "2-digit",
	day: "2-digit",
	hour: "2-digit",
	minute: "2-digit",
	second: "2-digit"
}).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), Wd = Ud === "06/25/2014, 00:00:00" || Ud === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
function Gd(e) {
	return Hd[e] || (Hd[e] = Wd ? new Intl.DateTimeFormat("en-US", {
		hourCycle: "h23",
		timeZone: e,
		year: "numeric",
		month: "numeric",
		day: "2-digit",
		hour: "2-digit",
		minute: "2-digit",
		second: "2-digit"
	}) : new Intl.DateTimeFormat("en-US", {
		hour12: !1,
		timeZone: e,
		year: "numeric",
		month: "numeric",
		day: "2-digit",
		hour: "2-digit",
		minute: "2-digit",
		second: "2-digit"
	})), Hd[e];
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns-tz@3.2.0_date-fns@4.1.0/node_modules/date-fns-tz/dist/esm/_lib/newDateUTC/index.js
function Kd(e, t, n, r, i, a, o) {
	let s = /* @__PURE__ */ new Date(0);
	return s.setUTCFullYear(e, t, n), s.setUTCHours(r, i, a, o), s;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns-tz@3.2.0_date-fns@4.1.0/node_modules/date-fns-tz/dist/esm/_lib/tzParseTimezone/index.js
var qd = 36e5, Jd = 6e4, Yd = {
	timezone: /([Z+-].*)$/,
	timezoneZ: /^(Z)$/,
	timezoneHH: /^([+-]\d{2})$/,
	timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function Xd(e, t, n) {
	if (!e) return 0;
	let r = Yd.timezoneZ.exec(e);
	if (r) return 0;
	let i, a;
	if (r = Yd.timezoneHH.exec(e), r) return i = parseInt(r[1], 10), ef(i) ? -(i * qd) : NaN;
	if (r = Yd.timezoneHHMM.exec(e), r) {
		i = parseInt(r[2], 10);
		let e = parseInt(r[3], 10);
		return ef(i, e) ? (a = Math.abs(i) * qd + e * Jd, r[1] === "+" ? -a : a) : NaN;
	}
	if (nf(e)) {
		t = new Date(t || Date.now());
		let r = Qd(n ? t : Zd(t), e);
		return -(n ? r : $d(t, r, e));
	}
	return NaN;
}
function Zd(e) {
	return Kd(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds());
}
function Qd(e, t) {
	let n = Rd(e, t), r = Kd(n[0], n[1] - 1, n[2], n[3] % 24, n[4], n[5], 0).getTime(), i = e.getTime(), a = i % 1e3;
	return i -= a >= 0 ? a : 1e3 + a, r - i;
}
function $d(e, t, n) {
	let r = e.getTime() - t, i = Qd(new Date(r), n);
	if (t === i) return t;
	r -= i - t;
	let a = Qd(new Date(r), n);
	return i === a ? i : Math.max(i, a);
}
function ef(e, t) {
	return -23 <= e && e <= 23 && (t == null || 0 <= t && t <= 59);
}
var tf = {};
function nf(e) {
	if (tf[e]) return !0;
	try {
		return new Intl.DateTimeFormat(void 0, { timeZone: e }), tf[e] = !0, !0;
	} catch {
		return !1;
	}
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns-tz@3.2.0_date-fns@4.1.0/node_modules/date-fns-tz/dist/esm/format/formatters/index.js
var rf = 6e4, af = {
	X: function(e, t, n) {
		let r = of(n.timeZone, e);
		if (r === 0) return "Z";
		switch (t) {
			case "X": return lf(r);
			case "XXXX":
			case "XX": return cf(r);
			default: return cf(r, ":");
		}
	},
	x: function(e, t, n) {
		let r = of(n.timeZone, e);
		switch (t) {
			case "x": return lf(r);
			case "xxxx":
			case "xx": return cf(r);
			default: return cf(r, ":");
		}
	},
	O: function(e, t, n) {
		let r = of(n.timeZone, e);
		switch (t) {
			case "O":
			case "OO":
			case "OOO": return "GMT" + uf(r, ":");
			default: return "GMT" + cf(r, ":");
		}
	},
	z: function(e, t, n) {
		switch (t) {
			case "z":
			case "zz":
			case "zzz": return Pd("short", e, n);
			default: return Pd("long", e, n);
		}
	}
};
function of(e, t) {
	let n = e ? Xd(e, t, !0) / rf : t?.getTimezoneOffset() ?? 0;
	if (Number.isNaN(n)) throw RangeError("Invalid time zone specified: " + e);
	return n;
}
function sf(e, t) {
	let n = e < 0 ? "-" : "", r = Math.abs(e).toString();
	for (; r.length < t;) r = "0" + r;
	return n + r;
}
function cf(e, t = "") {
	let n = e > 0 ? "-" : "+", r = Math.abs(e), i = sf(Math.floor(r / 60), 2), a = sf(Math.floor(r % 60), 2);
	return n + i + t + a;
}
function lf(e, t) {
	return e % 60 == 0 ? (e > 0 ? "-" : "+") + sf(Math.abs(e) / 60, 2) : cf(e, t);
}
function uf(e, t = "") {
	let n = e > 0 ? "-" : "+", r = Math.abs(e), i = Math.floor(r / 60), a = r % 60;
	return a === 0 ? n + String(i) : n + String(i) + t + sf(a, 2);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns-tz@3.2.0_date-fns@4.1.0/node_modules/date-fns-tz/dist/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
function df(e) {
	let t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
	return t.setUTCFullYear(e.getFullYear()), e - +t;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns-tz@3.2.0_date-fns@4.1.0/node_modules/date-fns-tz/dist/esm/_lib/tzPattern/index.js
var ff = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/, pf = 36e5, mf = 6e4, hf = 2, gf = {
	dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
	datePattern: /^([0-9W+-]+)(.*)/,
	plainTime: /:/,
	YY: /^(\d{2})$/,
	YYY: [
		/^([+-]\d{2})$/,
		/^([+-]\d{3})$/,
		/^([+-]\d{4})$/
	],
	YYYY: /^(\d{4})/,
	YYYYY: [
		/^([+-]\d{4})/,
		/^([+-]\d{5})/,
		/^([+-]\d{6})/
	],
	MM: /^-(\d{2})$/,
	DDD: /^-?(\d{3})$/,
	MMDD: /^-?(\d{2})-?(\d{2})$/,
	Www: /^-?W(\d{2})$/,
	WwwD: /^-?W(\d{2})-?(\d{1})$/,
	HH: /^(\d{2}([.,]\d*)?)$/,
	HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
	HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
	timeZone: ff
};
function _f(e, t = {}) {
	if (arguments.length < 1) throw TypeError("1 argument required, but only " + arguments.length + " present");
	if (e === null) return /* @__PURE__ */ new Date(NaN);
	let n = t.additionalDigits == null ? hf : Number(t.additionalDigits);
	if (n !== 2 && n !== 1 && n !== 0) throw RangeError("additionalDigits must be 0, 1 or 2");
	if (e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]") return new Date(e.getTime());
	if (typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]") return new Date(e);
	if (Object.prototype.toString.call(e) !== "[object String]") return /* @__PURE__ */ new Date(NaN);
	let r = vf(e), { year: i, restDateString: a } = yf(r.date, n), o = bf(a, i);
	if (o === null || isNaN(o.getTime())) return /* @__PURE__ */ new Date(NaN);
	if (o) {
		let e = o.getTime(), n = 0, i;
		if (r.time && (n = xf(r.time), n === null || isNaN(n))) return /* @__PURE__ */ new Date(NaN);
		if (r.timeZone || t.timeZone) {
			if (i = Xd(r.timeZone || t.timeZone, new Date(e + n)), isNaN(i)) return /* @__PURE__ */ new Date(NaN);
		} else i = df(new Date(e + n)), i = df(new Date(e + n + i));
		return new Date(e + n + i);
	}
	return /* @__PURE__ */ new Date(NaN);
}
function vf(e) {
	let t = {}, n = gf.dateTimePattern.exec(e), r;
	if (n ? (t.date = n[1], r = n[3]) : (n = gf.datePattern.exec(e), n ? (t.date = n[1], r = n[2]) : (t.date = null, r = e)), r) {
		let e = gf.timeZone.exec(r);
		e ? (t.time = r.replace(e[1], ""), t.timeZone = e[1].trim()) : t.time = r;
	}
	return t;
}
function yf(e, t) {
	if (e) {
		let n = gf.YYY[t], r = gf.YYYYY[t], i = gf.YYYY.exec(e) || r.exec(e);
		if (i) {
			let t = i[1];
			return {
				year: parseInt(t, 10),
				restDateString: e.slice(t.length)
			};
		}
		if (i = gf.YY.exec(e) || n.exec(e), i) {
			let t = i[1];
			return {
				year: parseInt(t, 10) * 100,
				restDateString: e.slice(t.length)
			};
		}
	}
	return { year: null };
}
function bf(e, t) {
	if (t === null) return null;
	let n, r, i;
	if (!e || !e.length) return n = /* @__PURE__ */ new Date(0), n.setUTCFullYear(t), n;
	let a = gf.MM.exec(e);
	if (a) return n = /* @__PURE__ */ new Date(0), r = parseInt(a[1], 10) - 1, Ef(t, r) ? (n.setUTCFullYear(t, r), n) : /* @__PURE__ */ new Date(NaN);
	if (a = gf.DDD.exec(e), a) {
		n = /* @__PURE__ */ new Date(0);
		let e = parseInt(a[1], 10);
		return Df(t, e) ? (n.setUTCFullYear(t, 0, e), n) : /* @__PURE__ */ new Date(NaN);
	}
	if (a = gf.MMDD.exec(e), a) {
		n = /* @__PURE__ */ new Date(0), r = parseInt(a[1], 10) - 1;
		let e = parseInt(a[2], 10);
		return Ef(t, r, e) ? (n.setUTCFullYear(t, r, e), n) : /* @__PURE__ */ new Date(NaN);
	}
	if (a = gf.Www.exec(e), a) return i = parseInt(a[1], 10) - 1, Of(i) ? Sf(t, i) : /* @__PURE__ */ new Date(NaN);
	if (a = gf.WwwD.exec(e), a) {
		i = parseInt(a[1], 10) - 1;
		let e = parseInt(a[2], 10) - 1;
		return Of(i, e) ? Sf(t, i, e) : /* @__PURE__ */ new Date(NaN);
	}
	return null;
}
function xf(e) {
	let t, n, r = gf.HH.exec(e);
	if (r) return t = parseFloat(r[1].replace(",", ".")), kf(t) ? t % 24 * pf : NaN;
	if (r = gf.HHMM.exec(e), r) return t = parseInt(r[1], 10), n = parseFloat(r[2].replace(",", ".")), kf(t, n) ? t % 24 * pf + n * mf : NaN;
	if (r = gf.HHMMSS.exec(e), r) {
		t = parseInt(r[1], 10), n = parseInt(r[2], 10);
		let e = parseFloat(r[3].replace(",", "."));
		return kf(t, n, e) ? t % 24 * pf + n * mf + e * 1e3 : NaN;
	}
	return null;
}
function Sf(e, t, n) {
	t ||= 0, n ||= 0;
	let r = /* @__PURE__ */ new Date(0);
	r.setUTCFullYear(e, 0, 4);
	let i = r.getUTCDay() || 7, a = t * 7 + n + 1 - i;
	return r.setUTCDate(r.getUTCDate() + a), r;
}
var Cf = [
	31,
	28,
	31,
	30,
	31,
	30,
	31,
	31,
	30,
	31,
	30,
	31
], wf = [
	31,
	29,
	31,
	30,
	31,
	30,
	31,
	31,
	30,
	31,
	30,
	31
];
function Tf(e) {
	return e % 400 == 0 || e % 4 == 0 && e % 100 != 0;
}
function Ef(e, t, n) {
	if (t < 0 || t > 11) return !1;
	if (n != null) {
		if (n < 1) return !1;
		let r = Tf(e);
		if (r && n > wf[t] || !r && n > Cf[t]) return !1;
	}
	return !0;
}
function Df(e, t) {
	if (t < 1) return !1;
	let n = Tf(e);
	return !(n && t > 366 || !n && t > 365);
}
function Of(e, t) {
	return !(e < 0 || e > 52 || t != null && (t < 0 || t > 6));
}
function kf(e, t, n) {
	return !(e < 0 || e >= 25 || t != null && (t < 0 || t >= 60) || n != null && (n < 0 || n >= 60));
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns-tz@3.2.0_date-fns@4.1.0/node_modules/date-fns-tz/dist/esm/format/index.js
var Af = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function jf(e, t, n = {}) {
	t = String(t);
	let r = t.match(Af);
	if (r) {
		let i = _f(n.originalDate || e, n);
		t = r.reduce(function(e, t) {
			if (t[0] === "'") return e;
			let r = e.indexOf(t), a = e[r - 1] === "'", o = e.replace(t, "'" + af[t[0]](i, t, n) + "'");
			return a ? o.substring(0, r - 1) + o.substring(r + 1) : o;
		}, t);
	}
	return Md(e, t, n);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns-tz@3.2.0_date-fns@4.1.0/node_modules/date-fns-tz/dist/esm/toZonedTime/index.js
function Mf(e, t, n) {
	e = _f(e, n);
	let r = Xd(t, e, !0), i = new Date(e.getTime() - r), a = /* @__PURE__ */ new Date(0);
	return a.setFullYear(i.getUTCFullYear(), i.getUTCMonth(), i.getUTCDate()), a.setHours(i.getUTCHours(), i.getUTCMinutes(), i.getUTCSeconds(), i.getUTCMilliseconds()), a;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns-tz@3.2.0_date-fns@4.1.0/node_modules/date-fns-tz/dist/esm/formatInTimeZone/index.js
function Nf(e, t, n, r) {
	return r = {
		...r,
		timeZone: t,
		originalDate: e
	}, jf(Mf(e, t, { timeZone: r.timeZone }), n, r);
}
//#endregion
//#region lib/assets/commit_icon.svg?react
var Pf = (e) => /* @__PURE__ */ X("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ Y("circle", {
			cx: 12,
			cy: 12,
			r: 12,
			fill: "#424B54"
		}),
		/* @__PURE__ */ Y("path", {
			d: "M12 6.5V9",
			stroke: "white",
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ Y("path", {
			d: "M12 15V17.5",
			stroke: "white",
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ Y("path", {
			d: "M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z",
			stroke: "white",
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		})
	]
});
//#endregion
//#region lib/components/ChangelogCard/ChangelogCard.tsx
function Ff(e) {
	let t = K(34), { timestamp: n, copyValue: r, title: i, action: a, actionMsg: o, selected: s, isLast: c, children: l } = e, u = o === void 0 ? "" : o, d = s !== void 0 && s, f = c !== void 0 && c, p;
	t[0] === n ? p = t[1] : (p = Nf(new Date(n), "UTC", "MMMM dd, yyyy"), t[0] = n, t[1] = p);
	let m = p, h;
	t[2] === n ? h = t[3] : (h = Nf(new Date(n), "UTC", "hh:mm aa"), t[2] = n, t[3] = h);
	let g = h, _ = f ? "bottom-6" : "bottom-0", v;
	t[4] === _ ? v = t[5] : (v = W("border-outline-decorative absolute left-6 top-2 z-0 border-l", _), t[4] = _, t[5] = v);
	let y;
	t[6] === v ? y = t[7] : (y = /* @__PURE__ */ Y("div", { className: v }), t[6] = v, t[7] = y);
	let b;
	t[8] === Symbol.for("react.memo_cache_sentinel") ? (b = /* @__PURE__ */ Y(Pf, {}), t[8] = b) : b = t[8];
	let x;
	t[9] === m ? x = t[10] : (x = /* @__PURE__ */ X("div", {
		className: "relative z-10 mb-2 flex items-center gap-2",
		children: [b, /* @__PURE__ */ Y("span", {
			className: "text-text-secondary mb-1 font-semibold uppercase",
			children: m
		})]
	}), t[9] = m, t[10] = x);
	let S = `border-outline-decorative relative z-10 cursor-pointer rounded-sm border-2 p-4 ${d ? "bg-background-tertiary" : "bg-background-primary"}`, C;
	t[11] !== r || t[12] !== i ? (C = /* @__PURE__ */ Y("div", { children: r ? /* @__PURE__ */ Y(Tu, {
		tooltipTarget: "icon",
		value: r,
		children: i
	}) : /* @__PURE__ */ Y("span", { children: i }) }), t[11] = r, t[12] = i, t[13] = C) : C = t[13];
	let w;
	t[14] === g ? w = t[15] : (w = /* @__PURE__ */ X("span", {
		className: "whitespace-nowrap text-text-secondary",
		children: [g, " UTC"]
	}), t[14] = g, t[15] = w);
	let T;
	t[16] !== C || t[17] !== w ? (T = /* @__PURE__ */ X("header", {
		className: "mb-4 flex items-center justify-between gap-6",
		children: [C, w]
	}), t[16] = C, t[17] = w, t[18] = T) : T = t[18];
	let E;
	t[19] === l ? E = t[20] : (E = /* @__PURE__ */ Y("div", {
		className: "mb-4",
		children: l
	}), t[19] = l, t[20] = E);
	let D;
	t[21] !== a || t[22] !== u ? (D = a || u ? /* @__PURE__ */ X("div", {
		className: "flex items-center gap-2",
		children: [a ? /* @__PURE__ */ Y("div", {
			className: "bg-background-tertiary text-text-primary rounded-sm px-2 py-px font-bold uppercase",
			children: a
		}) : null, u ? /* @__PURE__ */ Y("div", {
			className: "text-text-secondary",
			children: u
		}) : null]
	}) : null, t[21] = a, t[22] = u, t[23] = D) : D = t[23];
	let O;
	t[24] !== d || t[25] !== S || t[26] !== T || t[27] !== E || t[28] !== D ? (O = /* @__PURE__ */ X("article", {
		"aria-selected": d,
		className: S,
		children: [
			T,
			E,
			D
		]
	}), t[24] = d, t[25] = S, t[26] = T, t[27] = E, t[28] = D, t[29] = O) : O = t[29];
	let k;
	return t[30] !== x || t[31] !== O || t[32] !== y ? (k = /* @__PURE__ */ X("section", {
		"aria-label": "Changelog card",
		className: "bg-background-primary isolate relative pb-6 pl-3",
		children: [
			y,
			x,
			O
		]
	}), t[30] = x, t[31] = O, t[32] = y, t[33] = k) : k = t[33], k;
}
//#endregion
//#region lib/components/CheckboxGroup/CheckboxGroup.tsx
function If(e) {
	let t = K(24), n, r, i, a, o, s, c, l, u;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4], o = t[5], s = t[6], c = t[7], l = t[8], u = t[9]) : ({label: s, assistiveText: n, tooltipText: u, className: i, isDisabled: a, isInvalid: o, orientation: l, children: r, ...c} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a, t[5] = o, t[6] = s, t[7] = c, t[8] = l, t[9] = u);
	let d = l === void 0 ? "vertical" : l, f;
	t[10] === i ? f = t[11] : (f = W("flex flex-col gap-[.625rem]", i), t[10] = i, t[11] = f);
	let p;
	t[12] !== n || t[13] !== r || t[14] !== s || t[15] !== d || t[16] !== u ? (p = (e) => /* @__PURE__ */ X(Dr, { children: [
		/* @__PURE__ */ Y(Vl, {
			isDisabled: e.isDisabled,
			label: s,
			tooltipText: u
		}),
		/* @__PURE__ */ Y("div", {
			className: W("flex gap-lg", d === "horizontal" ? "flex-row flex-wrap" : "flex-col"),
			children: typeof r == "function" ? r(e) : r
		}),
		/* @__PURE__ */ Y(gl, {
			isDisabled: e.isDisabled,
			isInvalid: e.isInvalid,
			children: n
		})
	] }), t[12] = n, t[13] = r, t[14] = s, t[15] = d, t[16] = u, t[17] = p) : p = t[17];
	let m;
	return t[18] !== a || t[19] !== o || t[20] !== c || t[21] !== f || t[22] !== p ? (m = /* @__PURE__ */ Y(li, {
		className: f,
		isDisabled: a,
		isInvalid: o,
		...c,
		children: p
	}), t[18] = a, t[19] = o, t[20] = c, t[21] = f, t[22] = p, t[23] = m) : m = t[23], m;
}
//#endregion
//#region lib/components/Radio/Radio.tsx
var Lf = G({
	base: "relative flex items-center gap-2 text-label-medium transition",
	variants: { isDisabled: { true: "text-text-disabled cursor-not-allowed" } }
}), Rf = G({
	base: "shrink-0 flex items-center justify-center transition w-4 h-4 rounded-4 bg-neutral-white border border-outline-input-enabled",
	variants: {
		isSelected: {
			true: "!border-[5px] border-outline-brand",
			false: ""
		},
		isDisabled: {
			true: "border-outline-input-disabled",
			false: ""
		},
		isFocusVisible: {
			true: "border-2 border-outline-brand",
			false: ""
		},
		isHovered: {
			true: "border-outline-input-hover",
			false: ""
		}
	},
	compoundVariants: [
		{
			isSelected: !0,
			isHovered: !0,
			class: "border-interactive-primary-button-hover-background"
		},
		{
			isSelected: !0,
			isFocusVisible: !0,
			class: "border-interactive-primary-button-focus-background"
		},
		{
			isDisabled: !0,
			isHovered: !0,
			class: "border-outline-input-disabled"
		},
		{
			isSelected: !0,
			isDisabled: !0,
			class: "border-interactive-secondary-button-focus-background bg-interactive-secondary-button-hover-background"
		},
		{
			isSelected: !0,
			isDisabled: !0,
			isHovered: !0,
			class: "border-interactive-secondary-button-focus-background"
		}
	]
});
function zf(e) {
	let t = K(11), n, r;
	t[0] === e ? (n = t[1], r = t[2]) : ({className: n, ...r} = e, t[0] = e, t[1] = n, t[2] = r);
	let i;
	t[3] === n ? i = t[4] : (i = ta(n, Bf), t[3] = n, t[4] = i);
	let a;
	t[5] === r.children ? a = t[6] : (a = (e) => /* @__PURE__ */ X(Dr, { children: [/* @__PURE__ */ Y("div", { className: Rf({
		isSelected: e.isSelected,
		isDisabled: e.isDisabled,
		isFocusVisible: e.isFocusVisible,
		isHovered: e.isHovered
	}) }), r.children] }), t[5] = r.children, t[6] = a);
	let o;
	return t[7] !== r || t[8] !== i || t[9] !== a ? (o = /* @__PURE__ */ Y(Pi, {
		className: i,
		...r,
		children: a
	}), t[7] = r, t[8] = i, t[9] = a, t[10] = o) : o = t[10], o;
}
function Bf(e, t) {
	return Lf({
		...t,
		className: e
	});
}
//#endregion
//#region lib/components/RadioGroup/RadioGroup.tsx
function Vf(e) {
	let t = K(25), n, r, i, a, o, s, c, l, u;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4], o = t[5], s = t[6], c = t[7], l = t[8], u = t[9]) : ({label: s, assistiveText: n, tooltipText: u, className: i, isDisabled: a, isInvalid: o, orientation: l, children: r, ...c} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a, t[5] = o, t[6] = s, t[7] = c, t[8] = l, t[9] = u);
	let d = l === void 0 ? "vertical" : l, f;
	t[10] === i ? f = t[11] : (f = W("flex flex-col gap-[.625rem]", i), t[10] = i, t[11] = f);
	let p;
	t[12] !== n || t[13] !== r || t[14] !== s || t[15] !== d || t[16] !== u ? (p = (e) => /* @__PURE__ */ X(Dr, { children: [
		/* @__PURE__ */ Y(Vl, {
			isDisabled: e.isDisabled,
			label: s,
			tooltipText: u
		}),
		/* @__PURE__ */ Y("div", {
			className: W("flex gap-lg", d === "horizontal" ? "flex-row flex-wrap" : "flex-col"),
			children: typeof r == "function" ? r(e) : r
		}),
		/* @__PURE__ */ Y(gl, {
			isDisabled: e.isDisabled,
			isInvalid: e.isInvalid,
			children: n
		})
	] }), t[12] = n, t[13] = r, t[14] = s, t[15] = d, t[16] = u, t[17] = p) : p = t[17];
	let m;
	return t[18] !== a || t[19] !== o || t[20] !== d || t[21] !== c || t[22] !== f || t[23] !== p ? (m = /* @__PURE__ */ Y(Fi, {
		className: f,
		isDisabled: a,
		isInvalid: o,
		orientation: d,
		...c,
		children: p
	}), t[18] = a, t[19] = o, t[20] = d, t[21] = c, t[22] = f, t[23] = p, t[24] = m) : m = t[24], m;
}
//#endregion
//#region lib/components/Dialog/DialogContext.ts
var Hf = hr(null);
function Uf() {
	let e = yr(Hf);
	if (!e) throw Error("Dialog subcomponent must be used inside <Dialog>");
	return e;
}
//#endregion
//#region lib/components/Dialog/Modal.tsx
var Wf = G({
	base: "border border-outline-decorative bg-background-primary shadow-lg overflow-auto max-h-[90vh] overscroll-none rounded-xl",
	variants: { size: {
		sm: "w-full max-w-[400px]",
		md: "w-full max-w-[560px]",
		lg: "w-full max-w-[720px]",
		xl: "w-full max-w-[900px]"
	} },
	defaultVariants: { size: "md" }
});
function Gf(e) {
	let t = K(6), { children: n, className: r, size: i } = e, a = i === void 0 ? "md" : i, o;
	t[0] !== r || t[1] !== a ? (o = Wf({
		size: a,
		className: r
	}), t[0] = r, t[1] = a, t[2] = o) : o = t[2];
	let s;
	return t[3] !== n || t[4] !== o ? (s = /* @__PURE__ */ Y(Oi, {
		className: o,
		children: n
	}), t[3] = n, t[4] = o, t[5] = s) : s = t[5], s;
}
//#endregion
//#region lib/components/Dialog/Dialog.tsx
var Kf = G({ base: "sticky top-0 z-10 flex items-center justify-between bg-background-primary p-6 pb-0" }), qf = G({
	base: "px-6 pt-6",
	variants: { hasFooter: {
		true: "",
		false: "pb-6"
	} },
	defaultVariants: { hasFooter: !1 }
}), Jf = G({ base: "sticky bottom-0 z-10 bg-background-primary p-6 empty:hidden" }), Yf = G({ base: "flex justify-end gap-x-4" });
function Xf(e) {
	let t = K(30), n, r, i, a, o, s, c, l, u, d;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4], o = t[5], s = t[6], c = t[7], l = t[8], u = t[9], d = t[10]) : ({isOpen: o, onOpenChange: s, isDismissable: i, isKeyboardDismissDisabled: a, shouldCloseOnInteractOutside: u, overlayClassName: c, size: d, className: r, children: n, ...l} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a, t[5] = o, t[6] = s, t[7] = c, t[8] = l, t[9] = u, t[10] = d);
	let f;
	t[11] === c ? f = t[12] : (f = W("fixed inset-0 z-50 flex items-center justify-center bg-neutral-900/20 p-4 backdrop-blur-sm", c), t[11] = c, t[12] = f);
	let p = d ?? "md", m;
	t[13] === n ? m = t[14] : (m = (e) => {
		let { close: t } = e;
		return /* @__PURE__ */ Y(Zf, {
			close: t,
			children: n
		});
	}, t[13] = n, t[14] = m);
	let h;
	t[15] !== l || t[16] !== m ? (h = /* @__PURE__ */ Y(fi, {
		className: "outline-none",
		role: "dialog",
		...l,
		children: m
	}), t[15] = l, t[16] = m, t[17] = h) : h = t[17];
	let g;
	t[18] !== r || t[19] !== p || t[20] !== h ? (g = /* @__PURE__ */ Y(Gf, {
		className: r,
		size: p,
		children: h
	}), t[18] = r, t[19] = p, t[20] = h, t[21] = g) : g = t[21];
	let _;
	return t[22] !== i || t[23] !== a || t[24] !== o || t[25] !== s || t[26] !== u || t[27] !== f || t[28] !== g ? (_ = /* @__PURE__ */ Y(ki, {
		className: f,
		isDismissable: i,
		isKeyboardDismissDisabled: a,
		isOpen: o,
		onOpenChange: s,
		shouldCloseOnInteractOutside: u,
		children: g
	}), t[22] = i, t[23] = a, t[24] = o, t[25] = s, t[26] = u, t[27] = f, t[28] = g, t[29] = _) : _ = t[29], _;
}
function Zf(e) {
	let t = K(8), { close: n, children: r } = e, [i, a] = J(null), [o, s] = J(!1), c;
	t[0] !== n || t[1] !== i || t[2] !== o ? (c = {
		close: n,
		footerSlot: i,
		hasFooter: o,
		setHasFooter: s
	}, t[0] = n, t[1] = i, t[2] = o, t[3] = c) : c = t[3];
	let l;
	t[4] === Symbol.for("react.memo_cache_sentinel") ? (l = /* @__PURE__ */ Y("div", {
		className: Jf(),
		ref: a
	}), t[4] = l) : l = t[4];
	let u;
	return t[5] !== r || t[6] !== c ? (u = /* @__PURE__ */ X(Hf.Provider, {
		value: c,
		children: [r, l]
	}), t[5] = r, t[6] = c, t[7] = u) : u = t[7], u;
}
function Qf({ children: e, className: t, onClosePress: n, hideCloseButton: r = !1 }) {
	let { close: i } = Uf();
	return /* @__PURE__ */ X("div", {
		className: Kf(),
		children: [/* @__PURE__ */ Y(bi, {
			className: W("text-title-large font-semibold text-text-primary", t),
			slot: "title",
			children: e
		}), r ? null : /* @__PURE__ */ Y(Q, {
			"aria-label": "Close",
			className: "text-text-tertiary transition-colors hover:text-text-primary",
			onPress: () => {
				try {
					n?.();
				} finally {
					i();
				}
			},
			variant: "plain",
			children: /* @__PURE__ */ Y(ie, {})
		})]
	});
}
function $f(e) {
	let t = K(12), { text: n, children: r, className: i } = e, { close: a, hasFooter: o } = Uf(), s;
	t[0] !== i || t[1] !== o ? (s = W(qf({ hasFooter: o }), i), t[0] = i, t[1] = o, t[2] = s) : s = t[2];
	let c;
	t[3] === n ? c = t[4] : (c = n ? /* @__PURE__ */ Y("p", {
		className: "text-text-secondary",
		children: n
	}) : null, t[3] = n, t[4] = c);
	let l;
	t[5] !== r || t[6] !== a ? (l = typeof r == "function" ? r({ close: a }) : r, t[5] = r, t[6] = a, t[7] = l) : l = t[7];
	let u;
	return t[8] !== s || t[9] !== c || t[10] !== l ? (u = /* @__PURE__ */ X("div", {
		className: s,
		children: [c, l]
	}), t[8] = s, t[9] = c, t[10] = l, t[11] = u) : u = t[11], u;
}
function ep(e) {
	let t = K(14), { children: n, className: r } = e, i = yr(Hf), a = i?.setHasFooter, o, s;
	t[0] === a ? (o = t[1], s = t[2]) : (o = () => (a?.(!0), () => a?.(!1)), s = [a], t[0] = a, t[1] = o, t[2] = s), br(o, s);
	let c;
	t[3] === r ? c = t[4] : (c = W(Yf(), r), t[3] = r, t[4] = c);
	let l;
	t[5] !== n || t[6] !== i?.close ? (l = typeof n == "function" ? n({ close: i?.close ?? tp }) : n, t[5] = n, t[6] = i?.close, t[7] = l) : l = t[7];
	let u;
	t[8] !== c || t[9] !== l ? (u = /* @__PURE__ */ Y("div", {
		className: c,
		children: l
	}), t[8] = c, t[9] = l, t[10] = u) : u = t[10];
	let d = u;
	if (!i) return d;
	if (!i.footerSlot) return null;
	let f;
	return t[11] !== d || t[12] !== i.footerSlot ? (f = Or(d, i.footerSlot), t[11] = d, t[12] = i.footerSlot, t[13] = f) : f = t[13], f;
}
function tp() {}
//#endregion
//#region ../../node_modules/.pnpm/comma-separated-tokens@2.0.3/node_modules/comma-separated-tokens/index.js
function np(e, t) {
	let n = t || {};
	return (e[e.length - 1] === "" ? [...e, ""] : e).join((n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")).trim();
}
//#endregion
//#region ../../node_modules/.pnpm/estree-util-is-identifier-name@3.0.0/node_modules/estree-util-is-identifier-name/lib/index.js
var rp = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, ip = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, ap = {};
function op(e, t) {
	return ((t || ap).jsx ? ip : rp).test(e);
}
//#endregion
//#region ../../node_modules/.pnpm/hast-util-whitespace@3.0.0/node_modules/hast-util-whitespace/lib/index.js
var sp = /[ \t\n\f\r]/g;
function cp(e) {
	return typeof e == "object" ? e.type === "text" && lp(e.value) : lp(e);
}
function lp(e) {
	return e.replace(sp, "") === "";
}
//#endregion
//#region ../../node_modules/.pnpm/property-information@7.0.0/node_modules/property-information/lib/util/schema.js
var up = class {
	constructor(e, t, n) {
		this.normal = t, this.property = e, n && (this.space = n);
	}
};
up.prototype.normal = {}, up.prototype.property = {}, up.prototype.space = void 0;
//#endregion
//#region ../../node_modules/.pnpm/property-information@7.0.0/node_modules/property-information/lib/util/merge.js
function dp(e, t) {
	let n = {}, r = {};
	for (let t of e) Object.assign(n, t.property), Object.assign(r, t.normal);
	return new up(n, r, t);
}
//#endregion
//#region ../../node_modules/.pnpm/property-information@7.0.0/node_modules/property-information/lib/normalize.js
function fp(e) {
	return e.toLowerCase();
}
//#endregion
//#region ../../node_modules/.pnpm/property-information@7.0.0/node_modules/property-information/lib/util/info.js
var pp = class {
	constructor(e, t) {
		this.attribute = t, this.property = e;
	}
};
pp.prototype.attribute = "", pp.prototype.booleanish = !1, pp.prototype.boolean = !1, pp.prototype.commaOrSpaceSeparated = !1, pp.prototype.commaSeparated = !1, pp.prototype.defined = !1, pp.prototype.mustUseProperty = !1, pp.prototype.number = !1, pp.prototype.overloadedBoolean = !1, pp.prototype.property = "", pp.prototype.spaceSeparated = !1, pp.prototype.space = void 0;
//#endregion
//#region ../../node_modules/.pnpm/property-information@7.0.0/node_modules/property-information/lib/util/types.js
var mp = /* @__PURE__ */ da({
	boolean: () => gp,
	booleanish: () => _p,
	commaOrSpaceSeparated: () => xp,
	commaSeparated: () => bp,
	number: () => $,
	overloadedBoolean: () => vp,
	spaceSeparated: () => yp
}), hp = 0, gp = Sp(), _p = Sp(), vp = Sp(), $ = Sp(), yp = Sp(), bp = Sp(), xp = Sp();
function Sp() {
	return 2 ** ++hp;
}
//#endregion
//#region ../../node_modules/.pnpm/property-information@7.0.0/node_modules/property-information/lib/util/defined-info.js
var Cp = Object.keys(mp), wp = class extends pp {
	constructor(e, t, n, r) {
		let i = -1;
		if (super(e, t), Tp(this, "space", r), typeof n == "number") for (; ++i < Cp.length;) {
			let e = Cp[i];
			Tp(this, Cp[i], (n & mp[e]) === mp[e]);
		}
	}
};
wp.prototype.defined = !0;
function Tp(e, t, n) {
	n && (e[t] = n);
}
//#endregion
//#region ../../node_modules/.pnpm/property-information@7.0.0/node_modules/property-information/lib/util/create.js
function Ep(e) {
	let t = {}, n = {};
	for (let [r, i] of Object.entries(e.properties)) {
		let a = new wp(r, e.transform(e.attributes || {}, r), i, e.space);
		e.mustUseProperty && e.mustUseProperty.includes(r) && (a.mustUseProperty = !0), t[r] = a, n[fp(r)] = r, n[fp(a.attribute)] = r;
	}
	return new up(t, n, e.space);
}
//#endregion
//#region ../../node_modules/.pnpm/property-information@7.0.0/node_modules/property-information/lib/aria.js
var Dp = Ep({
	properties: {
		ariaActiveDescendant: null,
		ariaAtomic: _p,
		ariaAutoComplete: null,
		ariaBusy: _p,
		ariaChecked: _p,
		ariaColCount: $,
		ariaColIndex: $,
		ariaColSpan: $,
		ariaControls: yp,
		ariaCurrent: null,
		ariaDescribedBy: yp,
		ariaDetails: null,
		ariaDisabled: _p,
		ariaDropEffect: yp,
		ariaErrorMessage: null,
		ariaExpanded: _p,
		ariaFlowTo: yp,
		ariaGrabbed: _p,
		ariaHasPopup: null,
		ariaHidden: _p,
		ariaInvalid: null,
		ariaKeyShortcuts: null,
		ariaLabel: null,
		ariaLabelledBy: yp,
		ariaLevel: $,
		ariaLive: null,
		ariaModal: _p,
		ariaMultiLine: _p,
		ariaMultiSelectable: _p,
		ariaOrientation: null,
		ariaOwns: yp,
		ariaPlaceholder: null,
		ariaPosInSet: $,
		ariaPressed: _p,
		ariaReadOnly: _p,
		ariaRelevant: null,
		ariaRequired: _p,
		ariaRoleDescription: yp,
		ariaRowCount: $,
		ariaRowIndex: $,
		ariaRowSpan: $,
		ariaSelected: _p,
		ariaSetSize: $,
		ariaSort: null,
		ariaValueMax: $,
		ariaValueMin: $,
		ariaValueNow: $,
		ariaValueText: null,
		role: null
	},
	transform(e, t) {
		return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
	}
});
//#endregion
//#region ../../node_modules/.pnpm/property-information@7.0.0/node_modules/property-information/lib/util/case-sensitive-transform.js
function Op(e, t) {
	return t in e ? e[t] : t;
}
//#endregion
//#region ../../node_modules/.pnpm/property-information@7.0.0/node_modules/property-information/lib/util/case-insensitive-transform.js
function kp(e, t) {
	return Op(e, t.toLowerCase());
}
//#endregion
//#region ../../node_modules/.pnpm/property-information@7.0.0/node_modules/property-information/lib/html.js
var Ap = Ep({
	attributes: {
		acceptcharset: "accept-charset",
		classname: "class",
		htmlfor: "for",
		httpequiv: "http-equiv"
	},
	mustUseProperty: [
		"checked",
		"multiple",
		"muted",
		"selected"
	],
	properties: {
		abbr: null,
		accept: bp,
		acceptCharset: yp,
		accessKey: yp,
		action: null,
		allow: null,
		allowFullScreen: gp,
		allowPaymentRequest: gp,
		allowUserMedia: gp,
		alt: null,
		as: null,
		async: gp,
		autoCapitalize: null,
		autoComplete: yp,
		autoFocus: gp,
		autoPlay: gp,
		blocking: yp,
		capture: null,
		charSet: null,
		checked: gp,
		cite: null,
		className: yp,
		cols: $,
		colSpan: null,
		content: null,
		contentEditable: _p,
		controls: gp,
		controlsList: yp,
		coords: $ | bp,
		crossOrigin: null,
		data: null,
		dateTime: null,
		decoding: null,
		default: gp,
		defer: gp,
		dir: null,
		dirName: null,
		disabled: gp,
		download: vp,
		draggable: _p,
		encType: null,
		enterKeyHint: null,
		fetchPriority: null,
		form: null,
		formAction: null,
		formEncType: null,
		formMethod: null,
		formNoValidate: gp,
		formTarget: null,
		headers: yp,
		height: $,
		hidden: gp,
		high: $,
		href: null,
		hrefLang: null,
		htmlFor: yp,
		httpEquiv: yp,
		id: null,
		imageSizes: null,
		imageSrcSet: null,
		inert: gp,
		inputMode: null,
		integrity: null,
		is: null,
		isMap: gp,
		itemId: null,
		itemProp: yp,
		itemRef: yp,
		itemScope: gp,
		itemType: yp,
		kind: null,
		label: null,
		lang: null,
		language: null,
		list: null,
		loading: null,
		loop: gp,
		low: $,
		manifest: null,
		max: null,
		maxLength: $,
		media: null,
		method: null,
		min: null,
		minLength: $,
		multiple: gp,
		muted: gp,
		name: null,
		nonce: null,
		noModule: gp,
		noValidate: gp,
		onAbort: null,
		onAfterPrint: null,
		onAuxClick: null,
		onBeforeMatch: null,
		onBeforePrint: null,
		onBeforeToggle: null,
		onBeforeUnload: null,
		onBlur: null,
		onCancel: null,
		onCanPlay: null,
		onCanPlayThrough: null,
		onChange: null,
		onClick: null,
		onClose: null,
		onContextLost: null,
		onContextMenu: null,
		onContextRestored: null,
		onCopy: null,
		onCueChange: null,
		onCut: null,
		onDblClick: null,
		onDrag: null,
		onDragEnd: null,
		onDragEnter: null,
		onDragExit: null,
		onDragLeave: null,
		onDragOver: null,
		onDragStart: null,
		onDrop: null,
		onDurationChange: null,
		onEmptied: null,
		onEnded: null,
		onError: null,
		onFocus: null,
		onFormData: null,
		onHashChange: null,
		onInput: null,
		onInvalid: null,
		onKeyDown: null,
		onKeyPress: null,
		onKeyUp: null,
		onLanguageChange: null,
		onLoad: null,
		onLoadedData: null,
		onLoadedMetadata: null,
		onLoadEnd: null,
		onLoadStart: null,
		onMessage: null,
		onMessageError: null,
		onMouseDown: null,
		onMouseEnter: null,
		onMouseLeave: null,
		onMouseMove: null,
		onMouseOut: null,
		onMouseOver: null,
		onMouseUp: null,
		onOffline: null,
		onOnline: null,
		onPageHide: null,
		onPageShow: null,
		onPaste: null,
		onPause: null,
		onPlay: null,
		onPlaying: null,
		onPopState: null,
		onProgress: null,
		onRateChange: null,
		onRejectionHandled: null,
		onReset: null,
		onResize: null,
		onScroll: null,
		onScrollEnd: null,
		onSecurityPolicyViolation: null,
		onSeeked: null,
		onSeeking: null,
		onSelect: null,
		onSlotChange: null,
		onStalled: null,
		onStorage: null,
		onSubmit: null,
		onSuspend: null,
		onTimeUpdate: null,
		onToggle: null,
		onUnhandledRejection: null,
		onUnload: null,
		onVolumeChange: null,
		onWaiting: null,
		onWheel: null,
		open: gp,
		optimum: $,
		pattern: null,
		ping: yp,
		placeholder: null,
		playsInline: gp,
		popover: null,
		popoverTarget: null,
		popoverTargetAction: null,
		poster: null,
		preload: null,
		readOnly: gp,
		referrerPolicy: null,
		rel: yp,
		required: gp,
		reversed: gp,
		rows: $,
		rowSpan: $,
		sandbox: yp,
		scope: null,
		scoped: gp,
		seamless: gp,
		selected: gp,
		shadowRootClonable: gp,
		shadowRootDelegatesFocus: gp,
		shadowRootMode: null,
		shape: null,
		size: $,
		sizes: null,
		slot: null,
		span: $,
		spellCheck: _p,
		src: null,
		srcDoc: null,
		srcLang: null,
		srcSet: null,
		start: $,
		step: null,
		style: null,
		tabIndex: $,
		target: null,
		title: null,
		translate: null,
		type: null,
		typeMustMatch: gp,
		useMap: null,
		value: _p,
		width: $,
		wrap: null,
		writingSuggestions: null,
		align: null,
		aLink: null,
		archive: yp,
		axis: null,
		background: null,
		bgColor: null,
		border: $,
		borderColor: null,
		bottomMargin: $,
		cellPadding: null,
		cellSpacing: null,
		char: null,
		charOff: null,
		classId: null,
		clear: null,
		code: null,
		codeBase: null,
		codeType: null,
		color: null,
		compact: gp,
		declare: gp,
		event: null,
		face: null,
		frame: null,
		frameBorder: null,
		hSpace: $,
		leftMargin: $,
		link: null,
		longDesc: null,
		lowSrc: null,
		marginHeight: $,
		marginWidth: $,
		noResize: gp,
		noHref: gp,
		noShade: gp,
		noWrap: gp,
		object: null,
		profile: null,
		prompt: null,
		rev: null,
		rightMargin: $,
		rules: null,
		scheme: null,
		scrolling: _p,
		standby: null,
		summary: null,
		text: null,
		topMargin: $,
		valueType: null,
		version: null,
		vAlign: null,
		vLink: null,
		vSpace: $,
		allowTransparency: null,
		autoCorrect: null,
		autoSave: null,
		disablePictureInPicture: gp,
		disableRemotePlayback: gp,
		prefix: null,
		property: null,
		results: $,
		security: null,
		unselectable: null
	},
	space: "html",
	transform: kp
}), jp = Ep({
	attributes: {
		accentHeight: "accent-height",
		alignmentBaseline: "alignment-baseline",
		arabicForm: "arabic-form",
		baselineShift: "baseline-shift",
		capHeight: "cap-height",
		className: "class",
		clipPath: "clip-path",
		clipRule: "clip-rule",
		colorInterpolation: "color-interpolation",
		colorInterpolationFilters: "color-interpolation-filters",
		colorProfile: "color-profile",
		colorRendering: "color-rendering",
		crossOrigin: "crossorigin",
		dataType: "datatype",
		dominantBaseline: "dominant-baseline",
		enableBackground: "enable-background",
		fillOpacity: "fill-opacity",
		fillRule: "fill-rule",
		floodColor: "flood-color",
		floodOpacity: "flood-opacity",
		fontFamily: "font-family",
		fontSize: "font-size",
		fontSizeAdjust: "font-size-adjust",
		fontStretch: "font-stretch",
		fontStyle: "font-style",
		fontVariant: "font-variant",
		fontWeight: "font-weight",
		glyphName: "glyph-name",
		glyphOrientationHorizontal: "glyph-orientation-horizontal",
		glyphOrientationVertical: "glyph-orientation-vertical",
		hrefLang: "hreflang",
		horizAdvX: "horiz-adv-x",
		horizOriginX: "horiz-origin-x",
		horizOriginY: "horiz-origin-y",
		imageRendering: "image-rendering",
		letterSpacing: "letter-spacing",
		lightingColor: "lighting-color",
		markerEnd: "marker-end",
		markerMid: "marker-mid",
		markerStart: "marker-start",
		navDown: "nav-down",
		navDownLeft: "nav-down-left",
		navDownRight: "nav-down-right",
		navLeft: "nav-left",
		navNext: "nav-next",
		navPrev: "nav-prev",
		navRight: "nav-right",
		navUp: "nav-up",
		navUpLeft: "nav-up-left",
		navUpRight: "nav-up-right",
		onAbort: "onabort",
		onActivate: "onactivate",
		onAfterPrint: "onafterprint",
		onBeforePrint: "onbeforeprint",
		onBegin: "onbegin",
		onCancel: "oncancel",
		onCanPlay: "oncanplay",
		onCanPlayThrough: "oncanplaythrough",
		onChange: "onchange",
		onClick: "onclick",
		onClose: "onclose",
		onCopy: "oncopy",
		onCueChange: "oncuechange",
		onCut: "oncut",
		onDblClick: "ondblclick",
		onDrag: "ondrag",
		onDragEnd: "ondragend",
		onDragEnter: "ondragenter",
		onDragExit: "ondragexit",
		onDragLeave: "ondragleave",
		onDragOver: "ondragover",
		onDragStart: "ondragstart",
		onDrop: "ondrop",
		onDurationChange: "ondurationchange",
		onEmptied: "onemptied",
		onEnd: "onend",
		onEnded: "onended",
		onError: "onerror",
		onFocus: "onfocus",
		onFocusIn: "onfocusin",
		onFocusOut: "onfocusout",
		onHashChange: "onhashchange",
		onInput: "oninput",
		onInvalid: "oninvalid",
		onKeyDown: "onkeydown",
		onKeyPress: "onkeypress",
		onKeyUp: "onkeyup",
		onLoad: "onload",
		onLoadedData: "onloadeddata",
		onLoadedMetadata: "onloadedmetadata",
		onLoadStart: "onloadstart",
		onMessage: "onmessage",
		onMouseDown: "onmousedown",
		onMouseEnter: "onmouseenter",
		onMouseLeave: "onmouseleave",
		onMouseMove: "onmousemove",
		onMouseOut: "onmouseout",
		onMouseOver: "onmouseover",
		onMouseUp: "onmouseup",
		onMouseWheel: "onmousewheel",
		onOffline: "onoffline",
		onOnline: "ononline",
		onPageHide: "onpagehide",
		onPageShow: "onpageshow",
		onPaste: "onpaste",
		onPause: "onpause",
		onPlay: "onplay",
		onPlaying: "onplaying",
		onPopState: "onpopstate",
		onProgress: "onprogress",
		onRateChange: "onratechange",
		onRepeat: "onrepeat",
		onReset: "onreset",
		onResize: "onresize",
		onScroll: "onscroll",
		onSeeked: "onseeked",
		onSeeking: "onseeking",
		onSelect: "onselect",
		onShow: "onshow",
		onStalled: "onstalled",
		onStorage: "onstorage",
		onSubmit: "onsubmit",
		onSuspend: "onsuspend",
		onTimeUpdate: "ontimeupdate",
		onToggle: "ontoggle",
		onUnload: "onunload",
		onVolumeChange: "onvolumechange",
		onWaiting: "onwaiting",
		onZoom: "onzoom",
		overlinePosition: "overline-position",
		overlineThickness: "overline-thickness",
		paintOrder: "paint-order",
		panose1: "panose-1",
		pointerEvents: "pointer-events",
		referrerPolicy: "referrerpolicy",
		renderingIntent: "rendering-intent",
		shapeRendering: "shape-rendering",
		stopColor: "stop-color",
		stopOpacity: "stop-opacity",
		strikethroughPosition: "strikethrough-position",
		strikethroughThickness: "strikethrough-thickness",
		strokeDashArray: "stroke-dasharray",
		strokeDashOffset: "stroke-dashoffset",
		strokeLineCap: "stroke-linecap",
		strokeLineJoin: "stroke-linejoin",
		strokeMiterLimit: "stroke-miterlimit",
		strokeOpacity: "stroke-opacity",
		strokeWidth: "stroke-width",
		tabIndex: "tabindex",
		textAnchor: "text-anchor",
		textDecoration: "text-decoration",
		textRendering: "text-rendering",
		transformOrigin: "transform-origin",
		typeOf: "typeof",
		underlinePosition: "underline-position",
		underlineThickness: "underline-thickness",
		unicodeBidi: "unicode-bidi",
		unicodeRange: "unicode-range",
		unitsPerEm: "units-per-em",
		vAlphabetic: "v-alphabetic",
		vHanging: "v-hanging",
		vIdeographic: "v-ideographic",
		vMathematical: "v-mathematical",
		vectorEffect: "vector-effect",
		vertAdvY: "vert-adv-y",
		vertOriginX: "vert-origin-x",
		vertOriginY: "vert-origin-y",
		wordSpacing: "word-spacing",
		writingMode: "writing-mode",
		xHeight: "x-height",
		playbackOrder: "playbackorder",
		timelineBegin: "timelinebegin"
	},
	properties: {
		about: xp,
		accentHeight: $,
		accumulate: null,
		additive: null,
		alignmentBaseline: null,
		alphabetic: $,
		amplitude: $,
		arabicForm: null,
		ascent: $,
		attributeName: null,
		attributeType: null,
		azimuth: $,
		bandwidth: null,
		baselineShift: null,
		baseFrequency: null,
		baseProfile: null,
		bbox: null,
		begin: null,
		bias: $,
		by: null,
		calcMode: null,
		capHeight: $,
		className: yp,
		clip: null,
		clipPath: null,
		clipPathUnits: null,
		clipRule: null,
		color: null,
		colorInterpolation: null,
		colorInterpolationFilters: null,
		colorProfile: null,
		colorRendering: null,
		content: null,
		contentScriptType: null,
		contentStyleType: null,
		crossOrigin: null,
		cursor: null,
		cx: null,
		cy: null,
		d: null,
		dataType: null,
		defaultAction: null,
		descent: $,
		diffuseConstant: $,
		direction: null,
		display: null,
		dur: null,
		divisor: $,
		dominantBaseline: null,
		download: gp,
		dx: null,
		dy: null,
		edgeMode: null,
		editable: null,
		elevation: $,
		enableBackground: null,
		end: null,
		event: null,
		exponent: $,
		externalResourcesRequired: null,
		fill: null,
		fillOpacity: $,
		fillRule: null,
		filter: null,
		filterRes: null,
		filterUnits: null,
		floodColor: null,
		floodOpacity: null,
		focusable: null,
		focusHighlight: null,
		fontFamily: null,
		fontSize: null,
		fontSizeAdjust: null,
		fontStretch: null,
		fontStyle: null,
		fontVariant: null,
		fontWeight: null,
		format: null,
		fr: null,
		from: null,
		fx: null,
		fy: null,
		g1: bp,
		g2: bp,
		glyphName: bp,
		glyphOrientationHorizontal: null,
		glyphOrientationVertical: null,
		glyphRef: null,
		gradientTransform: null,
		gradientUnits: null,
		handler: null,
		hanging: $,
		hatchContentUnits: null,
		hatchUnits: null,
		height: null,
		href: null,
		hrefLang: null,
		horizAdvX: $,
		horizOriginX: $,
		horizOriginY: $,
		id: null,
		ideographic: $,
		imageRendering: null,
		initialVisibility: null,
		in: null,
		in2: null,
		intercept: $,
		k: $,
		k1: $,
		k2: $,
		k3: $,
		k4: $,
		kernelMatrix: xp,
		kernelUnitLength: null,
		keyPoints: null,
		keySplines: null,
		keyTimes: null,
		kerning: null,
		lang: null,
		lengthAdjust: null,
		letterSpacing: null,
		lightingColor: null,
		limitingConeAngle: $,
		local: null,
		markerEnd: null,
		markerMid: null,
		markerStart: null,
		markerHeight: null,
		markerUnits: null,
		markerWidth: null,
		mask: null,
		maskContentUnits: null,
		maskUnits: null,
		mathematical: null,
		max: null,
		media: null,
		mediaCharacterEncoding: null,
		mediaContentEncodings: null,
		mediaSize: $,
		mediaTime: null,
		method: null,
		min: null,
		mode: null,
		name: null,
		navDown: null,
		navDownLeft: null,
		navDownRight: null,
		navLeft: null,
		navNext: null,
		navPrev: null,
		navRight: null,
		navUp: null,
		navUpLeft: null,
		navUpRight: null,
		numOctaves: null,
		observer: null,
		offset: null,
		onAbort: null,
		onActivate: null,
		onAfterPrint: null,
		onBeforePrint: null,
		onBegin: null,
		onCancel: null,
		onCanPlay: null,
		onCanPlayThrough: null,
		onChange: null,
		onClick: null,
		onClose: null,
		onCopy: null,
		onCueChange: null,
		onCut: null,
		onDblClick: null,
		onDrag: null,
		onDragEnd: null,
		onDragEnter: null,
		onDragExit: null,
		onDragLeave: null,
		onDragOver: null,
		onDragStart: null,
		onDrop: null,
		onDurationChange: null,
		onEmptied: null,
		onEnd: null,
		onEnded: null,
		onError: null,
		onFocus: null,
		onFocusIn: null,
		onFocusOut: null,
		onHashChange: null,
		onInput: null,
		onInvalid: null,
		onKeyDown: null,
		onKeyPress: null,
		onKeyUp: null,
		onLoad: null,
		onLoadedData: null,
		onLoadedMetadata: null,
		onLoadStart: null,
		onMessage: null,
		onMouseDown: null,
		onMouseEnter: null,
		onMouseLeave: null,
		onMouseMove: null,
		onMouseOut: null,
		onMouseOver: null,
		onMouseUp: null,
		onMouseWheel: null,
		onOffline: null,
		onOnline: null,
		onPageHide: null,
		onPageShow: null,
		onPaste: null,
		onPause: null,
		onPlay: null,
		onPlaying: null,
		onPopState: null,
		onProgress: null,
		onRateChange: null,
		onRepeat: null,
		onReset: null,
		onResize: null,
		onScroll: null,
		onSeeked: null,
		onSeeking: null,
		onSelect: null,
		onShow: null,
		onStalled: null,
		onStorage: null,
		onSubmit: null,
		onSuspend: null,
		onTimeUpdate: null,
		onToggle: null,
		onUnload: null,
		onVolumeChange: null,
		onWaiting: null,
		onZoom: null,
		opacity: null,
		operator: null,
		order: null,
		orient: null,
		orientation: null,
		origin: null,
		overflow: null,
		overlay: null,
		overlinePosition: $,
		overlineThickness: $,
		paintOrder: null,
		panose1: null,
		path: null,
		pathLength: $,
		patternContentUnits: null,
		patternTransform: null,
		patternUnits: null,
		phase: null,
		ping: yp,
		pitch: null,
		playbackOrder: null,
		pointerEvents: null,
		points: null,
		pointsAtX: $,
		pointsAtY: $,
		pointsAtZ: $,
		preserveAlpha: null,
		preserveAspectRatio: null,
		primitiveUnits: null,
		propagate: null,
		property: xp,
		r: null,
		radius: null,
		referrerPolicy: null,
		refX: null,
		refY: null,
		rel: xp,
		rev: xp,
		renderingIntent: null,
		repeatCount: null,
		repeatDur: null,
		requiredExtensions: xp,
		requiredFeatures: xp,
		requiredFonts: xp,
		requiredFormats: xp,
		resource: null,
		restart: null,
		result: null,
		rotate: null,
		rx: null,
		ry: null,
		scale: null,
		seed: null,
		shapeRendering: null,
		side: null,
		slope: null,
		snapshotTime: null,
		specularConstant: $,
		specularExponent: $,
		spreadMethod: null,
		spacing: null,
		startOffset: null,
		stdDeviation: null,
		stemh: null,
		stemv: null,
		stitchTiles: null,
		stopColor: null,
		stopOpacity: null,
		strikethroughPosition: $,
		strikethroughThickness: $,
		string: null,
		stroke: null,
		strokeDashArray: xp,
		strokeDashOffset: null,
		strokeLineCap: null,
		strokeLineJoin: null,
		strokeMiterLimit: $,
		strokeOpacity: $,
		strokeWidth: null,
		style: null,
		surfaceScale: $,
		syncBehavior: null,
		syncBehaviorDefault: null,
		syncMaster: null,
		syncTolerance: null,
		syncToleranceDefault: null,
		systemLanguage: xp,
		tabIndex: $,
		tableValues: null,
		target: null,
		targetX: $,
		targetY: $,
		textAnchor: null,
		textDecoration: null,
		textRendering: null,
		textLength: null,
		timelineBegin: null,
		title: null,
		transformBehavior: null,
		type: null,
		typeOf: xp,
		to: null,
		transform: null,
		transformOrigin: null,
		u1: null,
		u2: null,
		underlinePosition: $,
		underlineThickness: $,
		unicode: null,
		unicodeBidi: null,
		unicodeRange: null,
		unitsPerEm: $,
		values: null,
		vAlphabetic: $,
		vMathematical: $,
		vectorEffect: null,
		vHanging: $,
		vIdeographic: $,
		version: null,
		vertAdvY: $,
		vertOriginX: $,
		vertOriginY: $,
		viewBox: null,
		viewTarget: null,
		visibility: null,
		width: null,
		widths: null,
		wordSpacing: null,
		writingMode: null,
		x: null,
		x1: null,
		x2: null,
		xChannelSelector: null,
		xHeight: $,
		y: null,
		y1: null,
		y2: null,
		yChannelSelector: null,
		z: null,
		zoomAndPan: null
	},
	space: "svg",
	transform: Op
}), Mp = Ep({
	properties: {
		xLinkActuate: null,
		xLinkArcRole: null,
		xLinkHref: null,
		xLinkRole: null,
		xLinkShow: null,
		xLinkTitle: null,
		xLinkType: null
	},
	space: "xlink",
	transform(e, t) {
		return "xlink:" + t.slice(5).toLowerCase();
	}
}), Np = Ep({
	attributes: { xmlnsxlink: "xmlns:xlink" },
	properties: {
		xmlnsXLink: null,
		xmlns: null
	},
	space: "xmlns",
	transform: kp
}), Pp = Ep({
	properties: {
		xmlBase: null,
		xmlLang: null,
		xmlSpace: null
	},
	space: "xml",
	transform(e, t) {
		return "xml:" + t.slice(3).toLowerCase();
	}
}), Fp = {
	classId: "classID",
	dataType: "datatype",
	itemId: "itemID",
	strokeDashArray: "strokeDasharray",
	strokeDashOffset: "strokeDashoffset",
	strokeLineCap: "strokeLinecap",
	strokeLineJoin: "strokeLinejoin",
	strokeMiterLimit: "strokeMiterlimit",
	typeOf: "typeof",
	xLinkActuate: "xlinkActuate",
	xLinkArcRole: "xlinkArcrole",
	xLinkHref: "xlinkHref",
	xLinkRole: "xlinkRole",
	xLinkShow: "xlinkShow",
	xLinkTitle: "xlinkTitle",
	xLinkType: "xlinkType",
	xmlnsXLink: "xmlnsXlink"
}, Ip = /[A-Z]/g, Lp = /-[a-z]/g, Rp = /^data[-\w.:]+$/i;
function zp(e, t) {
	let n = fp(t), r = t, i = pp;
	if (n in e.normal) return e.property[e.normal[n]];
	if (n.length > 4 && n.slice(0, 4) === "data" && Rp.test(t)) {
		if (t.charAt(4) === "-") {
			let e = t.slice(5).replace(Lp, Vp);
			r = "data" + e.charAt(0).toUpperCase() + e.slice(1);
		} else {
			let e = t.slice(4);
			if (!Lp.test(e)) {
				let n = e.replace(Ip, Bp);
				n.charAt(0) !== "-" && (n = "-" + n), t = "data" + n;
			}
		}
		i = wp;
	}
	return new i(r, t);
}
function Bp(e) {
	return "-" + e.toLowerCase();
}
function Vp(e) {
	return e.charAt(1).toUpperCase();
}
//#endregion
//#region ../../node_modules/.pnpm/property-information@7.0.0/node_modules/property-information/index.js
var Hp = dp([
	Dp,
	Ap,
	Mp,
	Np,
	Pp
], "html"), Up = dp([
	Dp,
	jp,
	Mp,
	Np,
	Pp
], "svg");
//#endregion
//#region ../../node_modules/.pnpm/space-separated-tokens@2.0.2/node_modules/space-separated-tokens/index.js
function Wp(e) {
	return e.join(" ").trim();
}
//#endregion
//#region ../../node_modules/.pnpm/inline-style-parser@0.2.4/node_modules/inline-style-parser/index.js
var Gp = /* @__PURE__ */ ua(((e, t) => {
	var n = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, r = /\n/g, i = /^\s*/, a = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, o = /^:\s*/, s = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, c = /^[;\s]*/, l = /^\s+|\s+$/g;
	t.exports = function(e, t) {
		if (typeof e != "string") throw TypeError("First argument must be a string");
		if (!e) return [];
		t ||= {};
		var l = 1, d = 1;
		function f(e) {
			var t = e.match(r);
			t && (l += t.length);
			var n = e.lastIndexOf("\n");
			d = ~n ? e.length - n : d + e.length;
		}
		function p() {
			var e = {
				line: l,
				column: d
			};
			return function(t) {
				return t.position = new m(e), v(), t;
			};
		}
		function m(e) {
			this.start = e, this.end = {
				line: l,
				column: d
			}, this.source = t.source;
		}
		m.prototype.content = e;
		var h = [];
		function g(n) {
			var r = /* @__PURE__ */ Error(t.source + ":" + l + ":" + d + ": " + n);
			if (r.reason = n, r.filename = t.source, r.line = l, r.column = d, r.source = e, t.silent) h.push(r);
			else throw r;
		}
		function _(t) {
			var n = t.exec(e);
			if (n) {
				var r = n[0];
				return f(r), e = e.slice(r.length), n;
			}
		}
		function v() {
			_(i);
		}
		function y(e) {
			var t;
			for (e ||= []; t = b();) t !== !1 && e.push(t);
			return e;
		}
		function b() {
			var t = p();
			if (e.charAt(0) == "/" && e.charAt(1) == "*") {
				for (var n = 2; e.charAt(n) != "" && (e.charAt(n) != "*" || e.charAt(n + 1) != "/");) ++n;
				if (n += 2, e.charAt(n - 1) === "") return g("End of comment missing");
				var r = e.slice(2, n - 2);
				return d += 2, f(r), e = e.slice(n), d += 2, t({
					type: "comment",
					comment: r
				});
			}
		}
		function x() {
			var e = p(), t = _(a);
			if (t) {
				if (b(), !_(o)) return g("property missing ':'");
				var r = _(s), i = e({
					type: "declaration",
					property: u(t[0].replace(n, "")),
					value: r ? u(r[0].replace(n, "")) : ""
				});
				return _(c), i;
			}
		}
		function S() {
			var e = [];
			y(e);
			for (var t; t = x();) t !== !1 && (e.push(t), y(e));
			return e;
		}
		return v(), S();
	};
	function u(e) {
		return e ? e.replace(l, "") : "";
	}
})), Kp = /* @__PURE__ */ ua(((e) => {
	var t = e && e.__importDefault || function(e) {
		return e && e.__esModule ? e : { default: e };
	};
	Object.defineProperty(e, "__esModule", { value: !0 }), e.default = r;
	var n = t(Gp());
	function r(e, t) {
		var r = null;
		if (!e || typeof e != "string") return r;
		var i = (0, n.default)(e), a = typeof t == "function";
		return i.forEach(function(e) {
			if (e.type === "declaration") {
				var n = e.property, i = e.value;
				a ? t(n, i, e) : i && (r ||= {}, r[n] = i);
			}
		}), r;
	}
})), qp = /* @__PURE__ */ ua(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.camelCase = void 0;
	var t = /^--[a-zA-Z0-9_-]+$/, n = /-([a-z])/g, r = /^[^-]+$/, i = /^-(webkit|moz|ms|o|khtml)-/, a = /^-(ms)-/, o = function(e) {
		return !e || r.test(e) || t.test(e);
	}, s = function(e, t) {
		return t.toUpperCase();
	}, c = function(e, t) {
		return `${t}-`;
	};
	e.camelCase = function(e, t) {
		return t === void 0 && (t = {}), o(e) ? e : (e = e.toLowerCase(), e = t.reactCompat ? e.replace(a, c) : e.replace(i, c), e.replace(n, s));
	};
})), Jp = /* @__PURE__ */ ua(((e, t) => {
	var n = (e && e.__importDefault || function(e) {
		return e && e.__esModule ? e : { default: e };
	})(Kp()), r = qp();
	function i(e, t) {
		var i = {};
		return !e || typeof e != "string" || (0, n.default)(e, function(e, n) {
			e && n && (i[(0, r.camelCase)(e, t)] = n);
		}), i;
	}
	i.default = i, t.exports = i;
})), Yp = Xp("start");
function Xp(e) {
	return t;
	function t(t) {
		let n = t && t.position && t.position[e] || {};
		if (typeof n.line == "number" && n.line > 0 && typeof n.column == "number" && n.column > 0) return {
			line: n.line,
			column: n.column,
			offset: typeof n.offset == "number" && n.offset > -1 ? n.offset : void 0
		};
	}
}
//#endregion
//#region ../../node_modules/.pnpm/unist-util-stringify-position@4.0.0/node_modules/unist-util-stringify-position/lib/index.js
function Zp(e) {
	return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? $p(e.position) : "start" in e || "end" in e ? $p(e) : "line" in e || "column" in e ? Qp(e) : "";
}
function Qp(e) {
	return em(e && e.line) + ":" + em(e && e.column);
}
function $p(e) {
	return Qp(e && e.start) + "-" + Qp(e && e.end);
}
function em(e) {
	return e && typeof e == "number" ? e : 1;
}
//#endregion
//#region ../../node_modules/.pnpm/vfile-message@4.0.2/node_modules/vfile-message/lib/index.js
var tm = class extends Error {
	constructor(e, t, n) {
		super(), typeof t == "string" && (n = t, t = void 0);
		let r = "", i = {}, a = !1;
		if (t && (i = "line" in t && "column" in t || "start" in t && "end" in t ? { place: t } : "type" in t ? {
			ancestors: [t],
			place: t.position
		} : { ...t }), typeof e == "string" ? r = e : !i.cause && e && (a = !0, r = e.message, i.cause = e), !i.ruleId && !i.source && typeof n == "string") {
			let e = n.indexOf(":");
			e === -1 ? i.ruleId = n : (i.source = n.slice(0, e), i.ruleId = n.slice(e + 1));
		}
		if (!i.place && i.ancestors && i.ancestors) {
			let e = i.ancestors[i.ancestors.length - 1];
			e && (i.place = e.position);
		}
		let o = i.place && "start" in i.place ? i.place.start : i.place;
		this.ancestors = i.ancestors || void 0, this.cause = i.cause || void 0, this.column = o ? o.column : void 0, this.fatal = void 0, this.file, this.message = r, this.line = o ? o.line : void 0, this.name = Zp(i.place) || "1:1", this.place = i.place || void 0, this.reason = this.message, this.ruleId = i.ruleId || void 0, this.source = i.source || void 0, this.stack = a && i.cause && typeof i.cause.stack == "string" ? i.cause.stack : "", this.actual, this.expected, this.note, this.url;
	}
};
tm.prototype.file = "", tm.prototype.name = "", tm.prototype.reason = "", tm.prototype.message = "", tm.prototype.stack = "", tm.prototype.column = void 0, tm.prototype.line = void 0, tm.prototype.ancestors = void 0, tm.prototype.cause = void 0, tm.prototype.fatal = void 0, tm.prototype.place = void 0, tm.prototype.ruleId = void 0, tm.prototype.source = void 0;
//#endregion
//#region ../../node_modules/.pnpm/hast-util-to-jsx-runtime@2.3.6_supports-color@8.1.1/node_modules/hast-util-to-jsx-runtime/lib/index.js
var nm = /* @__PURE__ */ pa(Jp(), 1), rm = {}.hasOwnProperty, im = /* @__PURE__ */ new Map(), am = /[A-Z]/g, om = /* @__PURE__ */ new Set([
	"table",
	"tbody",
	"thead",
	"tfoot",
	"tr"
]), sm = /* @__PURE__ */ new Set(["td", "th"]);
function cm(e, t) {
	if (!t || t.Fragment === void 0) throw TypeError("Expected `Fragment` in options");
	let n = t.filePath || void 0, r;
	if (t.development) {
		if (typeof t.jsxDEV != "function") throw TypeError("Expected `jsxDEV` in options when `development: true`");
		r = ym(n, t.jsxDEV);
	} else {
		if (typeof t.jsx != "function") throw TypeError("Expected `jsx` in production options");
		if (typeof t.jsxs != "function") throw TypeError("Expected `jsxs` in production options");
		r = vm(n, t.jsx, t.jsxs);
	}
	let i = {
		Fragment: t.Fragment,
		ancestors: [],
		components: t.components || {},
		create: r,
		elementAttributeNameCase: t.elementAttributeNameCase || "react",
		evaluater: t.createEvaluater ? t.createEvaluater() : void 0,
		filePath: n,
		ignoreInvalidStyle: t.ignoreInvalidStyle || !1,
		passKeys: t.passKeys !== !1,
		passNode: t.passNode || !1,
		schema: t.space === "svg" ? Up : Hp,
		stylePropertyNameCase: t.stylePropertyNameCase || "dom",
		tableCellAlignToStyle: t.tableCellAlignToStyle !== !1
	}, a = lm(i, e, void 0);
	return a && typeof a != "string" ? a : i.create(e, i.Fragment, { children: a || void 0 }, void 0);
}
function lm(e, t, n) {
	if (t.type === "element") return um(e, t, n);
	if (t.type === "mdxFlowExpression" || t.type === "mdxTextExpression") return dm(e, t);
	if (t.type === "mdxJsxFlowElement" || t.type === "mdxJsxTextElement") return pm(e, t, n);
	if (t.type === "mdxjsEsm") return fm(e, t);
	if (t.type === "root") return mm(e, t, n);
	if (t.type === "text") return hm(e, t);
}
function um(e, t, n) {
	let r = e.schema, i = r;
	t.tagName.toLowerCase() === "svg" && r.space === "html" && (i = Up, e.schema = i), e.ancestors.push(t);
	let a = Tm(e, t.tagName, !1), o = bm(e, t), s = Sm(e, t);
	return om.has(t.tagName) && (s = s.filter(function(e) {
		return typeof e != "string" || !cp(e);
	})), gm(e, o, a, t), _m(o, s), e.ancestors.pop(), e.schema = r, e.create(t, a, o, n);
}
function dm(e, t) {
	if (t.data && t.data.estree && e.evaluater) {
		let n = t.data.estree.body[0];
		return n.type, e.evaluater.evaluateExpression(n.expression);
	}
	Em(e, t.position);
}
function fm(e, t) {
	if (t.data && t.data.estree && e.evaluater) return e.evaluater.evaluateProgram(t.data.estree);
	Em(e, t.position);
}
function pm(e, t, n) {
	let r = e.schema, i = r;
	t.name === "svg" && r.space === "html" && (i = Up, e.schema = i), e.ancestors.push(t);
	let a = t.name === null ? e.Fragment : Tm(e, t.name, !0), o = xm(e, t), s = Sm(e, t);
	return gm(e, o, a, t), _m(o, s), e.ancestors.pop(), e.schema = r, e.create(t, a, o, n);
}
function mm(e, t, n) {
	let r = {};
	return _m(r, Sm(e, t)), e.create(t, e.Fragment, r, n);
}
function hm(e, t) {
	return t.value;
}
function gm(e, t, n, r) {
	typeof n != "string" && n !== e.Fragment && e.passNode && (t.node = r);
}
function _m(e, t) {
	if (t.length > 0) {
		let n = t.length > 1 ? t : t[0];
		n && (e.children = n);
	}
}
function vm(e, t, n) {
	return r;
	function r(e, r, i, a) {
		let o = Array.isArray(i.children) ? n : t;
		return a ? o(r, i, a) : o(r, i);
	}
}
function ym(e, t) {
	return n;
	function n(n, r, i, a) {
		let o = Array.isArray(i.children), s = Yp(n);
		return t(r, i, a, o, {
			columnNumber: s ? s.column - 1 : void 0,
			fileName: e,
			lineNumber: s ? s.line : void 0
		}, void 0);
	}
}
function bm(e, t) {
	let n = {}, r, i;
	for (i in t.properties) if (i !== "children" && rm.call(t.properties, i)) {
		let a = Cm(e, i, t.properties[i]);
		if (a) {
			let [i, o] = a;
			e.tableCellAlignToStyle && i === "align" && typeof o == "string" && sm.has(t.tagName) ? r = o : n[i] = o;
		}
	}
	if (r) {
		let t = n.style ||= {};
		t[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = r;
	}
	return n;
}
function xm(e, t) {
	let n = {};
	for (let r of t.attributes) if (r.type === "mdxJsxExpressionAttribute") {
		if (r.data && r.data.estree && e.evaluater) {
			let t = r.data.estree.body[0];
			t.type;
			let i = t.expression;
			i.type;
			let a = i.properties[0];
			a.type, Object.assign(n, e.evaluater.evaluateExpression(a.argument));
		} else Em(e, t.position);
	} else {
		let i = r.name, a;
		if (r.value && typeof r.value == "object") {
			if (r.value.data && r.value.data.estree && e.evaluater) {
				let t = r.value.data.estree.body[0];
				t.type, a = e.evaluater.evaluateExpression(t.expression);
			} else Em(e, t.position);
		} else a = r.value === null || r.value;
		n[i] = a;
	}
	return n;
}
function Sm(e, t) {
	let n = [], r = -1, i = e.passKeys ? /* @__PURE__ */ new Map() : im;
	for (; ++r < t.children.length;) {
		let a = t.children[r], o;
		if (e.passKeys) {
			let e = a.type === "element" ? a.tagName : a.type === "mdxJsxFlowElement" || a.type === "mdxJsxTextElement" ? a.name : void 0;
			if (e) {
				let t = i.get(e) || 0;
				o = e + "-" + t, i.set(e, t + 1);
			}
		}
		let s = lm(e, a, o);
		s !== void 0 && n.push(s);
	}
	return n;
}
function Cm(e, t, n) {
	let r = zp(e.schema, t);
	if (!(n == null || typeof n == "number" && Number.isNaN(n))) {
		if (Array.isArray(n) && (n = r.commaSeparated ? np(n) : Wp(n)), r.property === "style") {
			let t = typeof n == "object" ? n : wm(e, String(n));
			return e.stylePropertyNameCase === "css" && (t = Dm(t)), ["style", t];
		}
		return [e.elementAttributeNameCase === "react" && r.space ? Fp[r.property] || r.property : r.attribute, n];
	}
}
function wm(e, t) {
	try {
		return (0, nm.default)(t, { reactCompat: !0 });
	} catch (t) {
		if (e.ignoreInvalidStyle) return {};
		let n = t, r = new tm("Cannot parse `style` attribute", {
			ancestors: e.ancestors,
			cause: n,
			ruleId: "style",
			source: "hast-util-to-jsx-runtime"
		});
		throw r.file = e.filePath || void 0, r.url = "https://github.com/syntax-tree/hast-util-to-jsx-runtime#cannot-parse-style-attribute", r;
	}
}
function Tm(e, t, n) {
	let r;
	if (!n) r = {
		type: "Literal",
		value: t
	};
	else if (t.includes(".")) {
		let e = t.split("."), n = -1, i;
		for (; ++n < e.length;) {
			let t = op(e[n]) ? {
				type: "Identifier",
				name: e[n]
			} : {
				type: "Literal",
				value: e[n]
			};
			i = i ? {
				type: "MemberExpression",
				object: i,
				property: t,
				computed: !!(n && t.type === "Literal"),
				optional: !1
			} : t;
		}
		r = i;
	} else r = op(t) && !/^[a-z]/.test(t) ? {
		type: "Identifier",
		name: t
	} : {
		type: "Literal",
		value: t
	};
	if (r.type === "Literal") {
		let t = r.value;
		return rm.call(e.components, t) ? e.components[t] : t;
	}
	if (e.evaluater) return e.evaluater.evaluateExpression(r);
	Em(e);
}
function Em(e, t) {
	let n = new tm("Cannot handle MDX estrees without `createEvaluater`", {
		ancestors: e.ancestors,
		place: t,
		ruleId: "mdx-estree",
		source: "hast-util-to-jsx-runtime"
	});
	throw n.file = e.filePath || void 0, n.url = "https://github.com/syntax-tree/hast-util-to-jsx-runtime#cannot-handle-mdx-estrees-without-createevaluater", n;
}
function Dm(e) {
	let t = {}, n;
	for (n in e) rm.call(e, n) && (t[Om(n)] = e[n]);
	return t;
}
function Om(e) {
	let t = e.replace(am, km);
	return t.slice(0, 3) === "ms-" && (t = "-" + t), t;
}
function km(e) {
	return "-" + e.toLowerCase();
}
//#endregion
//#region lib/components/CodeBlock/hcl.ts
var Am = () => ({
	keywords: {
		keyword: "resource variable provider output locals module data terraform for for_each count depends_on lifecycle dynamic if in",
		literal: "true false null"
	},
	contains: [
		{
			className: "comment",
			begin: "#",
			end: "$"
		},
		{
			className: "comment",
			begin: "//",
			end: "$"
		},
		{
			className: "comment",
			begin: "/\\*",
			end: "\\*/"
		},
		{
			className: "string",
			begin: "<<[-]?\\s*\\w+",
			end: "^\\s*\\w+\\s*$"
		},
		{
			className: "string",
			begin: "\"",
			end: "\"",
			contains: [{
				className: "subst",
				begin: "\\$\\{",
				end: "\\}",
				keywords: { built_in: "var local module data path each count self terraform" }
			}]
		},
		{
			className: "number",
			begin: "\\b\\d+(\\.\\d+)?",
			relevance: 0
		},
		{
			className: "built_in",
			begin: "\\b(var|local|module|data|path|each|count|self)\\b"
		}
	]
}), jm = ra(na);
jm.register({ hcl: Am }), jm.registerAlias({ hcl: ["terraform", "tf"] });
function Mm(e) {
	let t = K(38), { code: n, grammar: r, className: i, codeBlockClassName: a, maxLines: o, download: s, hideDialogPreview: c } = e, l = r === void 0 ? "yaml" : r, u = c !== void 0 && c, d = jm.registered(l) ? l : "plaintext", f;
	t[0] !== n || t[1] !== d ? (f = jm.highlight(d, n || ""), t[0] = n, t[1] = d, t[2] = f) : f = t[2];
	let p = f, m = o && o > 0 ? o : void 0, h;
	t[3] !== n || t[4] !== s ? (h = () => {
		if (!s) return;
		let e = new Blob([n || ""], { type: "text/plain" }), t = URL.createObjectURL(e), r = document.createElement("a");
		r.href = t, r.download = s, document.body.appendChild(r), r.click(), document.body.removeChild(r), URL.revokeObjectURL(t);
	}, t[3] = n, t[4] = s, t[5] = h) : h = t[5];
	let g = h, _;
	t[6] === i ? _ = t[7] : (_ = W("overflow-x-auto whitespace-pre-wrap font-mono text-mono-medium flex gap-x-xs justify-between", i), t[6] = i, t[7] = _);
	let v = m ? "flex-1 overflow-y-auto" : "overflow-hidden", y;
	t[8] === m ? y = t[9] : (y = m ? { maxHeight: `calc(${m} * 1lh)` } : void 0, t[8] = m, t[9] = y);
	let b;
	t[10] === a ? b = t[11] : (b = W("break-all", a), t[10] = a, t[11] = b);
	let x;
	t[12] === p ? x = t[13] : (x = cm(p, {
		Fragment: Dr,
		jsx: Y,
		jsxs: X
	}), t[12] = p, t[13] = x);
	let S;
	t[14] !== b || t[15] !== x ? (S = /* @__PURE__ */ Y("div", {
		className: b,
		children: x
	}), t[14] = b, t[15] = x, t[16] = S) : S = t[16];
	let C;
	t[17] !== S || t[18] !== v || t[19] !== y ? (C = /* @__PURE__ */ Y("div", {
		className: v,
		style: y,
		children: S
	}), t[17] = S, t[18] = v, t[19] = y, t[20] = C) : C = t[20];
	let w = `${l} code`, T;
	t[21] !== s || t[22] !== g ? (T = s ? /* @__PURE__ */ Y(Q, {
		IconLeft: /* @__PURE__ */ Y(Ue, {}),
		"aria-label": "Download file",
		onPress: g,
		variant: "tertiary"
	}) : null, t[21] = s, t[22] = g, t[23] = T) : T = t[23];
	let E = n || "", D;
	t[24] === E ? D = t[25] : (D = /* @__PURE__ */ Y(Tu, { value: E }), t[24] = E, t[25] = D);
	let O;
	t[26] !== u || t[27] !== p ? (O = u ? null : /* @__PURE__ */ X(pi, { children: [/* @__PURE__ */ Y(Q, {
		IconLeft: /* @__PURE__ */ Y(Ze, {}),
		variant: "tertiary"
	}), /* @__PURE__ */ X(Xf, {
		overlayClassName: "z-[1300]",
		size: "lg",
		isDismissable: !0,
		children: [/* @__PURE__ */ Y(Qf, { children: "Code Preview" }), /* @__PURE__ */ Y($f, { children: /* @__PURE__ */ Y("div", {
			className: "whitespace-pre-wrap font-mono text-mono-medium",
			children: cm(p, {
				Fragment: Dr,
				jsx: Y,
				jsxs: X
			})
		}) })]
	})] }), t[26] = u, t[27] = p, t[28] = O) : O = t[28];
	let k;
	t[29] !== w || t[30] !== T || t[31] !== D || t[32] !== O ? (k = /* @__PURE__ */ X("div", {
		"aria-label": w,
		className: "flex items-center gap-x-3xs self-start",
		role: "code",
		children: [
			T,
			D,
			O
		]
	}), t[29] = w, t[30] = T, t[31] = D, t[32] = O, t[33] = k) : k = t[33];
	let A;
	return t[34] !== C || t[35] !== k || t[36] !== _ ? (A = /* @__PURE__ */ X(vu, {
		className: _,
		children: [C, k]
	}), t[34] = C, t[35] = k, t[36] = _, t[37] = A) : A = t[37], A;
}
//#endregion
//#region lib/components/Disclosure/Disclosure.tsx
var Nm = G({
	base: "flex w-full items-center outline-none text-title-medium gap-x-md text-text-primary",
	variants: { isDisabled: {
		true: "cursor-not-allowed opacity-50",
		false: "cursor-pointer"
	} },
	defaultVariants: { isDisabled: !1 }
}), Pm = G({
	base: "grid overflow-hidden transition-all duration-300 ease-in-out",
	variants: { isExpanded: {
		true: "grid-rows-[1fr]",
		false: "grid-rows-[0fr]"
	} },
	defaultVariants: { isExpanded: !1 }
}), Fm = G({
	base: "shrink-0 transition-transform duration-200 text-text-primary",
	variants: { isExpanded: {
		true: "rotate-[270deg]",
		false: "rotate-90"
	} }
});
function Im(e) {
	let t = K(6), n, r;
	t[0] === e ? (n = t[1], r = t[2]) : ({children: n, ...r} = e, t[0] = e, t[1] = n, t[2] = r);
	let i;
	return t[3] !== n || t[4] !== r ? (i = /* @__PURE__ */ Y(hi, {
		...r,
		children: n
	}), t[3] = n, t[4] = r, t[5] = i) : i = t[5], i;
}
function Lm(e) {
	let t = K(13), { children: n, className: r, iconClassName: i, collapsed: a, position: o } = e, s = a !== void 0 && a, c = o === void 0 ? "trailing" : o, { isExpanded: l } = yr(_i) ?? { isExpanded: !1 }, u;
	t[0] !== s || t[1] !== i || t[2] !== l ? (u = s ? null : /* @__PURE__ */ Y(mn, {
		className: Fm({
			isExpanded: l,
			class: i
		}),
		size: 16,
		"aria-hidden": !0
	}), t[0] = s, t[1] = i, t[2] = l, t[3] = u) : u = t[3];
	let d = u, f;
	t[4] === r ? f = t[5] : (f = (e) => {
		let { isDisabled: t } = e;
		return Nm({
			isDisabled: t,
			className: r
		});
	}, t[4] = r, t[5] = f);
	let p = c === "leading" ? d : null, m;
	t[6] === n ? m = t[7] : (m = /* @__PURE__ */ Y("span", {
		className: "flex-1 text-start",
		children: n
	}), t[6] = n, t[7] = m);
	let h = c === "trailing" ? d : null, g;
	return t[8] !== f || t[9] !== p || t[10] !== m || t[11] !== h ? (g = /* @__PURE__ */ Y(bi, { children: /* @__PURE__ */ X(oi, {
		className: f,
		slot: "trigger",
		children: [
			p,
			m,
			h
		]
	}) }), t[8] = f, t[9] = p, t[10] = m, t[11] = h, t[12] = g) : g = t[12], g;
}
function Rm(e) {
	let t = K(9), { children: n, className: r } = e, { isExpanded: i } = yr(_i) ?? { isExpanded: !1 }, a;
	t[0] !== r || t[1] !== i ? (a = Pm({
		isExpanded: i,
		className: r
	}), t[0] = r, t[1] = i, t[2] = a) : a = t[2];
	let o;
	t[3] === Symbol.for("react.memo_cache_sentinel") ? (o = { contentVisibility: "auto" }, t[3] = o) : o = t[3];
	let s;
	t[4] === n ? s = t[5] : (s = /* @__PURE__ */ Y("div", {
		className: "overflow-hidden",
		children: n
	}), t[4] = n, t[5] = s);
	let c;
	return t[6] !== a || t[7] !== s ? (c = /* @__PURE__ */ Y(gi, {
		className: a,
		style: o,
		children: s
	}), t[6] = a, t[7] = s, t[8] = c) : c = t[8], c;
}
//#endregion
//#region ../../node_modules/.pnpm/react-diff-view@3.3.1_react@19.2.7/node_modules/react-diff-view/es/index.js
function zm(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter((function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		}))), n.push.apply(n, r);
	}
	return n;
}
function Bm(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? zm(Object(n), !0).forEach((function(t) {
			Vm(e, t, n[t]);
		})) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : zm(Object(n)).forEach((function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		}));
	}
	return e;
}
function Vm(e, t, n) {
	return (t = function(e) {
		var t = function(e, t) {
			if (typeof e != "object" || !e) return e;
			var n = e[Symbol.toPrimitive];
			if (n !== void 0) {
				var r = n.call(e, t || "default");
				if (typeof r != "object") return r;
				throw TypeError("@@toPrimitive must return a primitive value.");
			}
			return (t === "string" ? String : Number)(e);
		}(e, "string");
		return typeof t == "symbol" ? t : String(t);
	}(t)) in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function Hm(e, t) {
	if (e == null) return {};
	var n, r, i = function(e, t) {
		if (e == null) return {};
		var n, r, i = {}, a = Object.keys(e);
		for (r = 0; r < a.length; r++) n = a[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
		return i;
	}(e, t);
	if (Object.getOwnPropertySymbols) {
		var a = Object.getOwnPropertySymbols(e);
		for (r = 0; r < a.length; r++) n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
	}
	return i;
}
function Um(e, t) {
	return Gm(e) || function(e, t) {
		var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
		if (n != null) {
			var r, i, a, o, s = [], c = !0, l = !1;
			try {
				if (a = (n = n.call(e)).next, t === 0) {
					if (Object(n) !== n) return;
					c = !1;
				} else for (; !(c = (r = a.call(n)).done) && (s.push(r.value), s.length !== t); c = !0);
			} catch (e) {
				l = !0, i = e;
			} finally {
				try {
					if (!c && n.return != null && (o = n.return(), Object(o) !== o)) return;
				} finally {
					if (l) throw i;
				}
			}
			return s;
		}
	}(e, t) || qm(e, t) || Ym();
}
function Wm(e) {
	return function(e) {
		if (Array.isArray(e)) return Jm(e);
	}(e) || Km(e) || qm(e) || function() {
		throw TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}();
}
function Gm(e) {
	if (Array.isArray(e)) return e;
}
function Km(e) {
	if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function qm(e, t) {
	if (e) {
		if (typeof e == "string") return Jm(e, t);
		var n = Object.prototype.toString.call(e).slice(8, -1);
		return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Jm(e, t) : void 0;
	}
}
function Jm(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}
function Ym() {
	throw TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Xm(e, t) {
	var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
	if (!n) {
		if (Array.isArray(e) || (n = qm(e)) || t && e && typeof e.length == "number") {
			n && (e = n);
			var r = 0, i = function() {};
			return {
				s: i,
				n: function() {
					return r >= e.length ? { done: !0 } : {
						done: !1,
						value: e[r++]
					};
				},
				e: function(e) {
					throw e;
				},
				f: i
			};
		}
		throw TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	var a, o = !0, s = !1;
	return {
		s: function() {
			n = n.call(e);
		},
		n: function() {
			var e = n.next();
			return o = e.done, e;
		},
		e: function(e) {
			s = !0, a = e;
		},
		f: function() {
			try {
				o || n.return == null || n.return();
			} finally {
				if (s) throw a;
			}
		}
	};
}
var Zm = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Qm(e, t) {
	return e(t = { exports: {} }, t.exports), t.exports;
}
var $m = Qm((function(e) {
	(function() {
		var t = {}.hasOwnProperty;
		function n() {
			for (var e = [], r = 0; r < arguments.length; r++) {
				var i = arguments[r];
				if (i) {
					var a = typeof i;
					if (a === "string" || a === "number") e.push(i);
					else if (Array.isArray(i)) {
						if (i.length) {
							var o = n.apply(null, i);
							o && e.push(o);
						}
					} else if (a === "object") {
						if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]")) {
							e.push(i.toString());
							continue;
						}
						for (var s in i) t.call(i, s) && i[s] && e.push(s);
					}
				}
			}
			return e.join(" ");
		}
		e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
	})();
})), eh = {
	hunkClassName: "",
	lineClassName: "",
	gutterClassName: "",
	codeClassName: "",
	monotonous: !1,
	gutterType: "default",
	viewType: "split",
	widgets: {},
	hideGutter: !1,
	selectedChanges: [],
	generateAnchorID: function() {},
	generateLineClassName: function() {},
	renderGutter: function(e) {
		var t = e.renderDefault;
		return (0, e.wrapInAnchor)(t());
	},
	codeEvents: {},
	gutterEvents: {}
}, th = hr(eh), nh = th.Provider, rh = function() {
	return yr(th);
}, ih = Qm((function(e, t) {
	(function(t) {
		function n(e) {
			var t = e.slice(11), n = null, r = null;
			switch (t.indexOf("\"")) {
				case -1:
					n = (o = t.split(" "))[0].slice(2), r = o[1].slice(2);
					break;
				case 0:
					var i = t.indexOf("\"", 2);
					n = t.slice(3, i);
					var a = t.indexOf("\"", i + 1);
					r = a < 0 ? t.slice(i + 4) : t.slice(a + 3, -1);
					break;
				default:
					var o;
					n = (o = t.split(" "))[0].slice(2), r = o[1].slice(3, -1);
			}
			return {
				oldPath: n,
				newPath: r
			};
		}
		e.exports = { parse: function(e) {
			for (var t, r, i, a, o, s = [], c = 2, l = e.split("\n"), u = l.length, d = 0; d < u;) {
				var f = l[d];
				if (f.indexOf("diff --git") === 0) {
					t = {
						hunks: [],
						oldEndingNewLine: !0,
						newEndingNewLine: !0,
						oldPath: (o = n(f)).oldPath,
						newPath: o.newPath
					}, s.push(t);
					var p, m = null;
					simiLoop: for (; p = l[++d];) {
						var h = p.indexOf(" "), g = h > -1 ? p.slice(0, h) : g;
						switch (g) {
							case "diff":
								d--;
								break simiLoop;
							case "deleted":
							case "new":
								var _ = p.slice(h + 1);
								_.indexOf("file mode") === 0 && (t[g === "new" ? "newMode" : "oldMode"] = _.slice(10));
								break;
							case "similarity":
								t.similarity = parseInt(p.split(" ")[2], 10);
								break;
							case "index":
								var v = p.slice(h + 1).split(" "), y = v[0].split("..");
								t.oldRevision = y[0], t.newRevision = y[1], v[1] && (t.oldMode = t.newMode = v[1]);
								break;
							case "copy":
							case "rename":
								var b = p.slice(h + 1);
								b.indexOf("from") === 0 ? t.oldPath = b.slice(5) : t.newPath = b.slice(3), m = g;
								break;
							case "---":
								var x = p.slice(h + 1), S = l[++d].slice(4);
								x === "/dev/null" ? (S = S.slice(2), m = "add") : S === "/dev/null" ? (x = x.slice(2), m = "delete") : (m = "modify", x = x.slice(2), S = S.slice(2)), x && (t.oldPath = x), S && (t.newPath = S), c = 5;
								break simiLoop;
						}
					}
					t.type = m || "modify";
				} else if (f.indexOf("Binary") === 0) t.isBinary = !0, t.type = f.indexOf("/dev/null and") >= 0 ? "add" : f.indexOf("and /dev/null") >= 0 ? "delete" : "modify", c = 2, t = null;
				else if (c === 5) {
					if (f.indexOf("@@") === 0) {
						var C = /^@@\s+-([0-9]+)(,([0-9]+))?\s+\+([0-9]+)(,([0-9]+))?/.exec(f);
						r = {
							content: f,
							oldStart: C[1] - 0,
							newStart: C[4] - 0,
							oldLines: C[3] - 0 || 1,
							newLines: C[6] - 0 || 1,
							changes: []
						}, t.hunks.push(r), i = r.oldStart, a = r.newStart;
					} else {
						var w = f.slice(0, 1), T = { content: f.slice(1) };
						switch (w) {
							case "+":
								T.type = "insert", T.isInsert = !0, T.lineNumber = a, a++;
								break;
							case "-":
								T.type = "delete", T.isDelete = !0, T.lineNumber = i, i++;
								break;
							case " ":
								T.type = "normal", T.isNormal = !0, T.oldLineNumber = i, T.newLineNumber = a, i++, a++;
								break;
							case "\\":
								var E = r.changes[r.changes.length - 1];
								E.isDelete || (t.newEndingNewLine = !1), E.isInsert || (t.oldEndingNewLine = !1);
						}
						T.type && r.changes.push(T);
					}
				}
				d++;
			}
			return s;
		} };
	})();
}));
function ah(e) {
	return e.type === "insert";
}
function oh(e) {
	return e.type === "delete";
}
function sh(e) {
	return e.type === "normal";
}
function ch(e, t) {
	var n = t.nearbySequences === "zip" ? function(e) {
		return Um(e.reduce((function(e, t, n) {
			var r = Um(e, 3), i = r[0], a = r[1], o = r[2];
			return a ? ah(t) && o >= 0 ? (i.splice(o + 1, 0, t), [
				i,
				t,
				o + 2
			]) : (i.push(t), [
				i,
				t,
				oh(t) && oh(a) ? o : n
			]) : (i.push(t), [
				i,
				t,
				oh(t) ? n : -1
			]);
		}), [
			[],
			null,
			-1
		]), 1)[0];
	}(e.changes) : e.changes;
	return Bm(Bm({}, e), {}, {
		isPlain: !1,
		changes: n
	});
}
function lh(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = function(e) {
		if (e.startsWith("diff --git")) return e;
		var t = e.indexOf("\n"), n = e.indexOf("\n", t + 1), r = e.slice(0, t), i = e.slice(t + 1, n), a = r.split(" ").slice(1, -3).join(" "), o = i.split(" ").slice(1, -3).join(" ");
		return [
			`diff --git a/${a} b/${o}`,
			"index 1111111..2222222 100644",
			`--- a/${a}`,
			`+++ b/${o}`,
			e.slice(n + 1)
		].join("\n");
	}(e.trimStart());
	return ih.parse(n).map((function(e) {
		return function(e, t) {
			var n = e.hunks.map((function(e) {
				return ch(e, t);
			}));
			return Bm(Bm({}, e), {}, { hunks: n });
		}(e, t);
	}));
}
function uh(e) {
	return e[0];
}
function dh(e) {
	return e[e.length - 1];
}
function fh(e) {
	return [`${e}Start`, `${e}Lines`];
}
function ph(e) {
	return e === "old" ? function(e) {
		return ah(e) ? -1 : sh(e) ? e.oldLineNumber : e.lineNumber;
	} : function(e) {
		return oh(e) ? -1 : sh(e) ? e.newLineNumber : e.lineNumber;
	};
}
function mh(e, t) {
	return function(n, r) {
		var i = n[e], a = i + n[t];
		return r >= i && r < a;
	};
}
function hh(e, t) {
	return function(n, r, i) {
		var a = n[e] + n[t], o = r[e];
		return i >= a && i < o;
	};
}
function gh(e) {
	var t = ph(e), n = function(e) {
		var t = Um(fh(e), 2), n = mh(t[0], t[1]);
		return function(e, t) {
			return e.find((function(e) {
				return n(e, t);
			}));
		};
	}(e);
	return function(e, r) {
		var i = n(e, r);
		if (i) return i.changes.find((function(e) {
			return t(e) === r;
		}));
	};
}
function _h(e) {
	var t = e === "old" ? "new" : "old", n = Um(fh(e), 2), r = n[0], i = n[1], a = Um(fh(t), 2), o = a[0], s = a[1], c = ph(e), l = ph(t), u = mh(r, i), d = hh(r, i);
	return function(e, t) {
		var n = uh(e);
		if (t < n[r]) {
			var a = n[r] - t;
			return n[o] - a;
		}
		var f = dh(e);
		if (f[r] + f[i] <= t) {
			var p = t - f[r] - f[i];
			return f[o] + f[s] + p;
		}
		for (var m = 0; m < e.length; m++) {
			var h = e[m], g = e[m + 1];
			if (u(h, t)) {
				var _ = h.changes.findIndex((function(e) {
					return c(e) === t;
				})), v = h.changes[_];
				if (sh(v)) return l(v);
				var y = oh(v) ? _ + 1 : _ - 1, b = h.changes[y];
				if (!b) return -1;
				var x = ah(v) ? "delete" : "insert";
				return b.type === x ? l(b) : -1;
			}
			if (d(h, g, t)) {
				var S = t - h[r] - h[i];
				return h[o] + h[s] + S;
			}
		}
		throw Error(`Unexpected line position ${t}`);
	};
}
var vh = function() {
	this.__data__ = [], this.size = 0;
}, yh = function(e, t) {
	return e === t || e != e && t != t;
}, bh = function(e, t) {
	for (var n = e.length; n--;) if (yh(e[n][0], t)) return n;
	return -1;
}, xh = Array.prototype.splice, Sh = function(e) {
	var t = this.__data__, n = bh(t, e);
	return !(n < 0) && (n == t.length - 1 ? t.pop() : xh.call(t, n, 1), --this.size, !0);
}, Ch = function(e) {
	var t = this.__data__, n = bh(t, e);
	return n < 0 ? void 0 : t[n][1];
}, wh = function(e) {
	return bh(this.__data__, e) > -1;
}, Th = function(e, t) {
	var n = this.__data__, r = bh(n, e);
	return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
};
function Eh(e) {
	var t = -1, n = e == null ? 0 : e.length;
	for (this.clear(); ++t < n;) {
		var r = e[t];
		this.set(r[0], r[1]);
	}
}
Eh.prototype.clear = vh, Eh.prototype.delete = Sh, Eh.prototype.get = Ch, Eh.prototype.has = wh, Eh.prototype.set = Th;
var Dh = Eh, Oh = function() {
	this.__data__ = new Dh(), this.size = 0;
}, kh = function(e) {
	var t = this.__data__, n = t.delete(e);
	return this.size = t.size, n;
}, Ah = function(e) {
	return this.__data__.get(e);
}, jh = function(e) {
	return this.__data__.has(e);
}, Mh = typeof Zm == "object" && Zm && Zm.Object === Object && Zm, Nh = typeof self == "object" && self && self.Object === Object && self, Ph = Mh || Nh || Function("return this")(), Fh = Ph.Symbol, Ih = Object.prototype, Lh = Ih.hasOwnProperty, Rh = Ih.toString, zh = Fh ? Fh.toStringTag : void 0, Bh = function(e) {
	var t = Lh.call(e, zh), n = e[zh];
	try {
		e[zh] = void 0;
		var r = !0;
	} catch {}
	var i = Rh.call(e);
	return r && (t ? e[zh] = n : delete e[zh]), i;
}, Vh = Object.prototype.toString, Hh = function(e) {
	return Vh.call(e);
}, Uh = Fh ? Fh.toStringTag : void 0, Wh = function(e) {
	return e == null ? e === void 0 ? "[object Undefined]" : "[object Null]" : Uh && Uh in Object(e) ? Bh(e) : Hh(e);
}, Gh = function(e) {
	var t = typeof e;
	return e != null && (t == "object" || t == "function");
}, Kh = function(e) {
	if (!Gh(e)) return !1;
	var t = Wh(e);
	return t == "[object Function]" || t == "[object GeneratorFunction]" || t == "[object AsyncFunction]" || t == "[object Proxy]";
}, qh = Ph["__core-js_shared__"], Jh = function() {
	var e = /[^.]+$/.exec(qh && qh.keys && qh.keys.IE_PROTO || "");
	return e ? "Symbol(src)_1." + e : "";
}(), Yh = function(e) {
	return !!Jh && Jh in e;
}, Xh = Function.prototype.toString, Zh = function(e) {
	if (e != null) {
		try {
			return Xh.call(e);
		} catch {}
		try {
			return e + "";
		} catch {}
	}
	return "";
}, Qh = /^\[object .+?Constructor\]$/, $h = Function.prototype, eg = Object.prototype, tg = $h.toString, ng = eg.hasOwnProperty, rg = RegExp("^" + tg.call(ng).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), ig = function(e) {
	return !(!Gh(e) || Yh(e)) && (Kh(e) ? rg : Qh).test(Zh(e));
}, ag = function(e, t) {
	return e?.[t];
}, og = function(e, t) {
	var n = ag(e, t);
	return ig(n) ? n : void 0;
}, sg = og(Ph, "Map"), cg = og(Object, "create"), lg = function() {
	this.__data__ = cg ? cg(null) : {}, this.size = 0;
}, ug = function(e) {
	var t = this.has(e) && delete this.__data__[e];
	return this.size -= +!!t, t;
}, dg = Object.prototype.hasOwnProperty, fg = function(e) {
	var t = this.__data__;
	if (cg) {
		var n = t[e];
		return n === "__lodash_hash_undefined__" ? void 0 : n;
	}
	return dg.call(t, e) ? t[e] : void 0;
}, pg = Object.prototype.hasOwnProperty, mg = function(e) {
	var t = this.__data__;
	return cg ? t[e] !== void 0 : pg.call(t, e);
}, hg = function(e, t) {
	var n = this.__data__;
	return this.size += +!this.has(e), n[e] = cg && t === void 0 ? "__lodash_hash_undefined__" : t, this;
};
function gg(e) {
	var t = -1, n = e == null ? 0 : e.length;
	for (this.clear(); ++t < n;) {
		var r = e[t];
		this.set(r[0], r[1]);
	}
}
gg.prototype.clear = lg, gg.prototype.delete = ug, gg.prototype.get = fg, gg.prototype.has = mg, gg.prototype.set = hg;
var _g = gg, vg = function() {
	this.size = 0, this.__data__ = {
		hash: new _g(),
		map: new (sg || Dh)(),
		string: new _g()
	};
}, yg = function(e) {
	var t = typeof e;
	return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}, bg = function(e, t) {
	var n = e.__data__;
	return yg(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}, xg = function(e) {
	var t = bg(this, e).delete(e);
	return this.size -= +!!t, t;
}, Sg = function(e) {
	return bg(this, e).get(e);
}, Cg = function(e) {
	return bg(this, e).has(e);
}, wg = function(e, t) {
	var n = bg(this, e), r = n.size;
	return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
};
function Tg(e) {
	var t = -1, n = e == null ? 0 : e.length;
	for (this.clear(); ++t < n;) {
		var r = e[t];
		this.set(r[0], r[1]);
	}
}
Tg.prototype.clear = vg, Tg.prototype.delete = xg, Tg.prototype.get = Sg, Tg.prototype.has = Cg, Tg.prototype.set = wg;
var Eg = Tg, Dg = function(e, t) {
	var n = this.__data__;
	if (n instanceof Dh) {
		var r = n.__data__;
		if (!sg || r.length < 199) return r.push([e, t]), this.size = ++n.size, this;
		n = this.__data__ = new Eg(r);
	}
	return n.set(e, t), this.size = n.size, this;
};
function Og(e) {
	var t = this.__data__ = new Dh(e);
	this.size = t.size;
}
Og.prototype.clear = Oh, Og.prototype.delete = kh, Og.prototype.get = Ah, Og.prototype.has = jh, Og.prototype.set = Dg;
var kg = Og, Ag = function(e) {
	return this.__data__.set(e, "__lodash_hash_undefined__"), this;
}, jg = function(e) {
	return this.__data__.has(e);
};
function Mg(e) {
	var t = -1, n = e == null ? 0 : e.length;
	for (this.__data__ = new Eg(); ++t < n;) this.add(e[t]);
}
Mg.prototype.add = Mg.prototype.push = Ag, Mg.prototype.has = jg;
var Ng = Mg, Pg = function(e, t) {
	for (var n = -1, r = e == null ? 0 : e.length; ++n < r;) if (t(e[n], n, e)) return !0;
	return !1;
}, Fg = function(e, t) {
	return e.has(t);
}, Ig = function(e, t, n, r, i, a) {
	var o = 1 & n, s = e.length, c = t.length;
	if (s != c && !(o && c > s)) return !1;
	var l = a.get(e), u = a.get(t);
	if (l && u) return l == t && u == e;
	var d = -1, f = !0, p = 2 & n ? new Ng() : void 0;
	for (a.set(e, t), a.set(t, e); ++d < s;) {
		var m = e[d], h = t[d];
		if (r) var g = o ? r(h, m, d, t, e, a) : r(m, h, d, e, t, a);
		if (g !== void 0) {
			if (g) continue;
			f = !1;
			break;
		}
		if (p) {
			if (!Pg(t, (function(e, t) {
				if (!Fg(p, t) && (m === e || i(m, e, n, r, a))) return p.push(t);
			}))) {
				f = !1;
				break;
			}
		} else if (m !== h && !i(m, h, n, r, a)) {
			f = !1;
			break;
		}
	}
	return a.delete(e), a.delete(t), f;
}, Lg = Ph.Uint8Array, Rg = function(e) {
	var t = -1, n = Array(e.size);
	return e.forEach((function(e, r) {
		n[++t] = [r, e];
	})), n;
}, zg = function(e) {
	var t = -1, n = Array(e.size);
	return e.forEach((function(e) {
		n[++t] = e;
	})), n;
}, Bg = Fh ? Fh.prototype : void 0, Vg = Bg ? Bg.valueOf : void 0, Hg = function(e, t, n, r, i, a, o) {
	switch (n) {
		case "[object DataView]":
			if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
			e = e.buffer, t = t.buffer;
		case "[object ArrayBuffer]": return !(e.byteLength != t.byteLength || !a(new Lg(e), new Lg(t)));
		case "[object Boolean]":
		case "[object Date]":
		case "[object Number]": return yh(+e, +t);
		case "[object Error]": return e.name == t.name && e.message == t.message;
		case "[object RegExp]":
		case "[object String]": return e == t + "";
		case "[object Map]": var s = Rg;
		case "[object Set]":
			var c = 1 & r;
			if (s ||= zg, e.size != t.size && !c) return !1;
			var l = o.get(e);
			if (l) return l == t;
			r |= 2, o.set(e, t);
			var u = Ig(s(e), s(t), r, i, a, o);
			return o.delete(e), u;
		case "[object Symbol]": if (Vg) return Vg.call(e) == Vg.call(t);
	}
	return !1;
}, Ug = function(e, t) {
	for (var n = -1, r = t.length, i = e.length; ++n < r;) e[i + n] = t[n];
	return e;
}, Wg = Array.isArray, Gg = function(e, t, n) {
	var r = t(e);
	return Wg(e) ? r : Ug(r, n(e));
}, Kg = function(e, t) {
	for (var n = -1, r = e == null ? 0 : e.length, i = 0, a = []; ++n < r;) {
		var o = e[n];
		t(o, n, e) && (a[i++] = o);
	}
	return a;
}, qg = function() {
	return [];
}, Jg = Object.prototype.propertyIsEnumerable, Yg = Object.getOwnPropertySymbols, Xg = Yg ? function(e) {
	return e == null ? [] : (e = Object(e), Kg(Yg(e), (function(t) {
		return Jg.call(e, t);
	})));
} : qg, Zg = function(e, t) {
	for (var n = -1, r = Array(e); ++n < e;) r[n] = t(n);
	return r;
}, Qg = function(e) {
	return typeof e == "object" && !!e;
}, $g = function(e) {
	return Qg(e) && Wh(e) == "[object Arguments]";
}, e_ = Object.prototype, t_ = e_.hasOwnProperty, n_ = e_.propertyIsEnumerable, r_ = $g(function() {
	return arguments;
}()) ? $g : function(e) {
	return Qg(e) && t_.call(e, "callee") && !n_.call(e, "callee");
}, i_ = function() {
	return !1;
}, a_ = Qm((function(e, t) {
	var n = t && !t.nodeType && t, r = n && e && !e.nodeType && e, i = r && r.exports === n ? Ph.Buffer : void 0;
	e.exports = (i ? i.isBuffer : void 0) || i_;
})), o_ = /^(?:0|[1-9]\d*)$/, s_ = function(e, t) {
	var n = typeof e;
	return !!(t ??= 9007199254740991) && (n == "number" || n != "symbol" && o_.test(e)) && e > -1 && e % 1 == 0 && e < t;
}, c_ = function(e) {
	return typeof e == "number" && e > -1 && e % 1 == 0 && e <= 9007199254740991;
}, l_ = {};
l_["[object Float32Array]"] = l_["[object Float64Array]"] = l_["[object Int8Array]"] = l_["[object Int16Array]"] = l_["[object Int32Array]"] = l_["[object Uint8Array]"] = l_["[object Uint8ClampedArray]"] = l_["[object Uint16Array]"] = l_["[object Uint32Array]"] = !0, l_["[object Arguments]"] = l_["[object Array]"] = l_["[object ArrayBuffer]"] = l_["[object Boolean]"] = l_["[object DataView]"] = l_["[object Date]"] = l_["[object Error]"] = l_["[object Function]"] = l_["[object Map]"] = l_["[object Number]"] = l_["[object Object]"] = l_["[object RegExp]"] = l_["[object Set]"] = l_["[object String]"] = l_["[object WeakMap]"] = !1;
var u_ = function(e) {
	return Qg(e) && c_(e.length) && !!l_[Wh(e)];
}, d_ = function(e) {
	return function(t) {
		return e(t);
	};
}, f_ = Qm((function(e, t) {
	var n = t && !t.nodeType && t, r = n && e && !e.nodeType && e, i = r && r.exports === n && Mh.process;
	e.exports = function() {
		try {
			return r && r.require && r.require("util").types || i && i.binding && i.binding("util");
		} catch {}
	}();
})), p_ = f_ && f_.isTypedArray, m_ = p_ ? d_(p_) : u_, h_ = Object.prototype.hasOwnProperty, g_ = function(e, t) {
	var n = Wg(e), r = !n && r_(e), i = !n && !r && a_(e), a = !n && !r && !i && m_(e), o = n || r || i || a, s = o ? Zg(e.length, String) : [], c = s.length;
	for (var l in e) !t && !h_.call(e, l) || o && (l == "length" || i && (l == "offset" || l == "parent") || a && (l == "buffer" || l == "byteLength" || l == "byteOffset") || s_(l, c)) || s.push(l);
	return s;
}, __ = Object.prototype, v_ = function(e) {
	var t = e && e.constructor;
	return e === (typeof t == "function" && t.prototype || __);
}, y_ = function(e, t) {
	return function(n) {
		return e(t(n));
	};
}(Object.keys, Object), b_ = Object.prototype.hasOwnProperty, x_ = function(e) {
	if (!v_(e)) return y_(e);
	var t = [];
	for (var n in Object(e)) b_.call(e, n) && n != "constructor" && t.push(n);
	return t;
}, S_ = function(e) {
	return e != null && c_(e.length) && !Kh(e);
}, C_ = function(e) {
	return S_(e) ? g_(e) : x_(e);
}, w_ = function(e) {
	return Gg(e, C_, Xg);
}, T_ = Object.prototype.hasOwnProperty, E_ = function(e, t, n, r, i, a) {
	var o = 1 & n, s = w_(e), c = s.length;
	if (c != w_(t).length && !o) return !1;
	for (var l = c; l--;) {
		var u = s[l];
		if (!(o ? u in t : T_.call(t, u))) return !1;
	}
	var d = a.get(e), f = a.get(t);
	if (d && f) return d == t && f == e;
	var p = !0;
	a.set(e, t), a.set(t, e);
	for (var m = o; ++l < c;) {
		var h = e[u = s[l]], g = t[u];
		if (r) var _ = o ? r(g, h, u, t, e, a) : r(h, g, u, e, t, a);
		if (!(_ === void 0 ? h === g || i(h, g, n, r, a) : _)) {
			p = !1;
			break;
		}
		m ||= u == "constructor";
	}
	if (p && !m) {
		var v = e.constructor, y = t.constructor;
		v == y || !("constructor" in e) || !("constructor" in t) || typeof v == "function" && v instanceof v && typeof y == "function" && y instanceof y || (p = !1);
	}
	return a.delete(e), a.delete(t), p;
}, D_ = og(Ph, "DataView"), O_ = og(Ph, "Promise"), k_ = og(Ph, "Set"), A_ = og(Ph, "WeakMap"), j_ = Zh(D_), M_ = Zh(sg), N_ = Zh(O_), P_ = Zh(k_), F_ = Zh(A_), I_ = Wh;
(D_ && I_(new D_(/* @__PURE__ */ new ArrayBuffer(1))) != "[object DataView]" || sg && I_(new sg()) != "[object Map]" || O_ && I_(O_.resolve()) != "[object Promise]" || k_ && I_(new k_()) != "[object Set]" || A_ && I_(new A_()) != "[object WeakMap]") && (I_ = function(e) {
	var t = Wh(e), n = t == "[object Object]" ? e.constructor : void 0, r = n ? Zh(n) : "";
	if (r) switch (r) {
		case j_: return "[object DataView]";
		case M_: return "[object Map]";
		case N_: return "[object Promise]";
		case P_: return "[object Set]";
		case F_: return "[object WeakMap]";
	}
	return t;
});
var L_ = I_, R_ = "[object Object]", z_ = Object.prototype.hasOwnProperty, B_ = function(e, t, n, r, i, a) {
	var o = Wg(e), s = Wg(t), c = o ? "[object Array]" : L_(e), l = s ? "[object Array]" : L_(t), u = (c = c == "[object Arguments]" ? R_ : c) == R_, d = (l = l == "[object Arguments]" ? R_ : l) == R_, f = c == l;
	if (f && a_(e)) {
		if (!a_(t)) return !1;
		o = !0, u = !1;
	}
	if (f && !u) return a ||= new kg(), o || m_(e) ? Ig(e, t, n, r, i, a) : Hg(e, t, c, n, r, i, a);
	if (!(1 & n)) {
		var p = u && z_.call(e, "__wrapped__"), m = d && z_.call(t, "__wrapped__");
		if (p || m) {
			var h = p ? e.value() : e, g = m ? t.value() : t;
			return a ||= new kg(), i(h, g, n, r, a);
		}
	}
	return !!f && (a ||= new kg(), E_(e, t, n, r, i, a));
}, V_ = function e(t, n, r, i, a) {
	return t === n || (t == null || n == null || !Qg(t) && !Qg(n) ? t != t && n != n : B_(t, n, r, i, e, a));
}, H_ = function(e, t, n, r) {
	var i = n.length, a = i, o = !r;
	if (e == null) return !a;
	for (e = Object(e); i--;) {
		var s = n[i];
		if (o && s[2] ? s[1] !== e[s[0]] : !(s[0] in e)) return !1;
	}
	for (; ++i < a;) {
		var c = (s = n[i])[0], l = e[c], u = s[1];
		if (o && s[2]) {
			if (l === void 0 && !(c in e)) return !1;
		} else {
			var d = new kg();
			if (r) var f = r(l, u, c, e, t, d);
			if (!(f === void 0 ? V_(u, l, 3, r, d) : f)) return !1;
		}
	}
	return !0;
}, U_ = function(e) {
	return e == e && !Gh(e);
}, W_ = function(e) {
	for (var t = C_(e), n = t.length; n--;) {
		var r = t[n], i = e[r];
		t[n] = [
			r,
			i,
			U_(i)
		];
	}
	return t;
}, G_ = function(e, t) {
	return function(n) {
		return n != null && n[e] === t && (t !== void 0 || e in Object(n));
	};
}, K_ = function(e) {
	var t = W_(e);
	return t.length == 1 && t[0][2] ? G_(t[0][0], t[0][1]) : function(n) {
		return n === e || H_(n, e, t);
	};
}, q_ = function(e) {
	return typeof e == "symbol" || Qg(e) && Wh(e) == "[object Symbol]";
}, J_ = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Y_ = /^\w*$/, X_ = function(e, t) {
	if (Wg(e)) return !1;
	var n = typeof e;
	return !(n != "number" && n != "symbol" && n != "boolean" && e != null && !q_(e)) || Y_.test(e) || !J_.test(e) || t != null && e in Object(t);
};
function Z_(e, t) {
	if (typeof e != "function" || t != null && typeof t != "function") throw TypeError("Expected a function");
	var n = function() {
		var r = arguments, i = t ? t.apply(this, r) : r[0], a = n.cache;
		if (a.has(i)) return a.get(i);
		var o = e.apply(this, r);
		return n.cache = a.set(i, o) || a, o;
	};
	return n.cache = new (Z_.Cache || Eg)(), n;
}
Z_.Cache = Eg;
var Q_ = Z_, $_ = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, ev = /\\(\\)?/g, tv = function(e) {
	var t = Q_(e, (function(e) {
		return n.size === 500 && n.clear(), e;
	})), n = t.cache;
	return t;
}((function(e) {
	var t = [];
	return e.charCodeAt(0) === 46 && t.push(""), e.replace($_, (function(e, n, r, i) {
		t.push(r ? i.replace(ev, "$1") : n || e);
	})), t;
})), nv = function(e, t) {
	for (var n = -1, r = e == null ? 0 : e.length, i = Array(r); ++n < r;) i[n] = t(e[n], n, e);
	return i;
}, rv = Fh ? Fh.prototype : void 0, iv = rv ? rv.toString : void 0, av = function e(t) {
	if (typeof t == "string") return t;
	if (Wg(t)) return nv(t, e) + "";
	if (q_(t)) return iv ? iv.call(t) : "";
	var n = t + "";
	return n == "0" && 1 / t == -Infinity ? "-0" : n;
}, ov = function(e) {
	return e == null ? "" : av(e);
}, sv = function(e, t) {
	return Wg(e) ? e : X_(e, t) ? [e] : tv(ov(e));
}, cv = function(e) {
	if (typeof e == "string" || q_(e)) return e;
	var t = e + "";
	return t == "0" && 1 / e == -Infinity ? "-0" : t;
}, lv = function(e, t) {
	for (var n = 0, r = (t = sv(t, e)).length; e != null && n < r;) e = e[cv(t[n++])];
	return n && n == r ? e : void 0;
}, uv = function(e, t, n) {
	var r = e == null ? void 0 : lv(e, t);
	return r === void 0 ? n : r;
}, dv = function(e, t) {
	return e != null && t in Object(e);
}, fv = function(e, t, n) {
	for (var r = -1, i = (t = sv(t, e)).length, a = !1; ++r < i;) {
		var o = cv(t[r]);
		if (!(a = e != null && n(e, o))) break;
		e = e[o];
	}
	return a || ++r != i ? a : !!(i = e == null ? 0 : e.length) && c_(i) && s_(o, i) && (Wg(e) || r_(e));
}, pv = function(e, t) {
	return e != null && fv(e, t, dv);
}, mv = function(e, t) {
	return X_(e) && U_(t) ? G_(cv(e), t) : function(n) {
		var r = uv(n, e);
		return r === void 0 && r === t ? pv(n, e) : V_(t, r, 3);
	};
}, hv = function(e) {
	return e;
}, gv = function(e) {
	return function(t) {
		return t?.[e];
	};
}, _v = function(e) {
	return function(t) {
		return lv(t, e);
	};
}, vv = function(e) {
	return X_(e) ? gv(cv(e)) : _v(e);
}, yv = function(e) {
	return typeof e == "function" ? e : e == null ? hv : typeof e == "object" ? Wg(e) ? mv(e[0], e[1]) : K_(e) : vv(e);
};
function bv(e) {
	if (!e) throw Error("change is not provided");
	return sh(e) ? `N${e.oldLineNumber}` : `${ah(e) ? "I" : "D"}${e.lineNumber}`;
}
_h("old");
var xv = ph("old"), Sv = ph("new");
gh("old"), gh("new"), _h("new"), _h("old");
var Cv = function() {
	try {
		var e = og(Object, "defineProperty");
		return e({}, "", {}), e;
	} catch {}
}(), wv = function(e, t, n) {
	t == "__proto__" && Cv ? Cv(e, t, {
		configurable: !0,
		enumerable: !0,
		value: n,
		writable: !0
	}) : e[t] = n;
}, Tv = function(e) {
	return function(t, n, r) {
		for (var i = -1, a = Object(t), o = r(t), s = o.length; s--;) {
			var c = o[e ? s : ++i];
			if (!1 === n(a[c], c, a)) break;
		}
		return t;
	};
}(), Ev = function(e, t) {
	return e && Tv(e, t, C_);
}, Dv = function(e, t) {
	var n = {};
	return t = yv(t), Ev(e, (function(e, r, i) {
		wv(n, r, t(e, r, i));
	})), n;
}, Ov = [
	"changeKey",
	"text",
	"tokens",
	"renderToken"
], kv = function e(t, n) {
	var r = t.type, i = t.value, a = t.markType, o = t.properties, s = t.className, c = t.children, l = function(t) {
		return Y("span", {
			className: t,
			children: i || c && c.map(e)
		}, n);
	};
	switch (r) {
		case "text": return i;
		case "mark": return l(`diff-code-mark diff-code-mark-${a}`);
		case "edit": return l("diff-code-edit");
		default:
			var u = o && o.className;
			return l($m(s || u));
	}
};
function Av(e) {
	if (!Array.isArray(e)) return !0;
	if (e.length > 1) return !1;
	if (e.length === 1) {
		var t = Um(e, 1)[0];
		return t.type === "text" && !t.value;
	}
	return !0;
}
function jv(e) {
	var t = e.changeKey, n = e.text, r = e.tokens, i = e.renderToken, a = Hm(e, Ov), o = i ? function(e, t) {
		return i(e, kv, t);
	} : kv;
	return Y("td", Bm(Bm({}, a), {}, {
		"data-change-key": t,
		children: r ? Av(r) ? " " : r.map(o) : n || " "
	}));
}
var Mv = _r(jv);
function Nv(e, t) {
	return function() {
		var n = t === "old" ? xv(e) : Sv(e);
		return n === -1 ? void 0 : n;
	};
}
function Pv(e, t) {
	return function(n) {
		return e && n ? Y("a", {
			href: t ? "#" + t : void 0,
			children: n
		}) : n;
	};
}
function Fv(e, t) {
	return t ? function(n) {
		e(), t(n);
	} : e;
}
function Iv(e, t, n, r) {
	return q((function() {
		var i = Dv(e, (function(e) {
			return function(n) {
				return e && e(t, n);
			};
		}));
		return i.onMouseEnter = Fv(n, i.onMouseEnter), i.onMouseLeave = Fv(r, i.onMouseLeave), i;
	}), [
		e,
		n,
		r,
		t
	]);
}
function Lv(e, t, n, r, i, a, o, s, c) {
	var l = {
		change: t,
		side: r,
		inHoverState: s,
		renderDefault: Nv(t, r),
		wrapInAnchor: Pv(i, a)
	};
	return Y("td", Bm(Bm({ className: e }, o), {}, {
		"data-change-key": n,
		children: c(l)
	}));
}
function Rv(e) {
	var t, n, r, i = e.change, a = e.selected, o = e.tokens, s = e.className, c = e.generateLineClassName, l = e.gutterClassName, u = e.codeClassName, d = e.gutterEvents, f = e.codeEvents, p = e.hideGutter, m = e.gutterAnchor, h = e.generateAnchorID, g = e.renderToken, _ = e.renderGutter, v = i.type, y = i.content, b = bv(i), x = Um((t = Um(J(!1), 2), n = t[0], r = t[1], [
		n,
		vr((function() {
			return r(!0);
		}), []),
		vr((function() {
			return r(!1);
		}), [])
	]), 3), S = x[0], C = x[1], w = x[2], T = q((function() {
		return { change: i };
	}), [i]), E = Iv(d, T, C, w), D = Iv(f, T, C, w), O = h(i), k = c({
		changes: [i],
		defaultGenerate: function() {
			return s;
		}
	}), A = $m("diff-gutter", `diff-gutter-${v}`, l, { "diff-gutter-selected": a }), j = $m("diff-code", `diff-code-${v}`, u, { "diff-code-selected": a });
	return X("tr", {
		id: O,
		className: $m("diff-line", k),
		children: [
			!p && Lv(A, i, b, "old", m, O, E, S, _),
			!p && Lv(A, i, b, "new", m, O, E, S, _),
			Y(Mv, Bm({
				className: j,
				changeKey: b,
				text: y,
				tokens: o,
				renderToken: g
			}, D))
		]
	});
}
var zv = _r(Rv);
function Bv(e) {
	var t = e.hideGutter, n = e.element;
	return Y("tr", {
		className: "diff-widget",
		children: Y("td", {
			colSpan: t ? 1 : 3,
			className: "diff-widget-content",
			children: n
		})
	});
}
var Vv = [
	"hideGutter",
	"selectedChanges",
	"tokens",
	"lineClassName"
], Hv = [
	"hunk",
	"widgets",
	"className"
];
function Uv(e) {
	var t = e.hunk, n = e.widgets, r = e.className, i = Hm(e, Hv), a = function(e, t) {
		return e.reduce((function(e, n) {
			var r = bv(n);
			e.push([
				"change",
				r,
				n
			]);
			var i = t[r];
			return i && e.push([
				"widget",
				r,
				i
			]), e;
		}), []);
	}(t.changes, n);
	return Y("tbody", {
		className: $m("diff-hunk", r),
		children: a.map((function(e) {
			return function(e, t) {
				var n = Um(e, 3), r = n[0], i = n[1], a = n[2], o = t.hideGutter, s = t.selectedChanges, c = t.tokens, l = t.lineClassName, u = Hm(t, Vv);
				if (r === "change") {
					var d = oh(a) ? "old" : "new", f = oh(a) ? xv(a) : Sv(a), p = c ? c[d][f - 1] : null;
					return Y(zv, Bm({
						className: l,
						change: a,
						hideGutter: o,
						selected: s.includes(i),
						tokens: p
					}, u), `change${i}`);
				}
				return r === "widget" ? Y(Bv, {
					hideGutter: o,
					element: a
				}, `widget${i}`) : null;
			}(e, i);
		}))
	});
}
var Wv = 0;
function Gv(e, t, n, r) {
	var i = vr((function() {
		return t(e);
	}), [e, t]), a = vr((function() {
		return t("");
	}), [t]);
	return q((function() {
		var t = Dv(r, (function(t) {
			return function(r) {
				return t && t({
					side: e,
					change: n
				}, r);
			};
		}));
		return t.onMouseEnter = Fv(i, t.onMouseEnter), t.onMouseLeave = Fv(a, t.onMouseLeave), t;
	}), [
		n,
		r,
		i,
		e,
		a
	]);
}
function Kv(e) {
	var t = e.change, n = e.side, r = e.selected, i = e.tokens, a = e.gutterClassName, o = e.codeClassName, s = e.gutterEvents, c = e.codeEvents, l = e.anchorID, u = e.gutterAnchor, d = e.gutterAnchorTarget, f = e.hideGutter, p = e.hover, m = e.renderToken, h = e.renderGutter;
	if (!t) {
		var g = $m("diff-gutter", "diff-gutter-omit", a), _ = $m("diff-code", "diff-code-omit", o);
		return [!f && Y("td", { className: g }, "gutter"), Y("td", { className: _ }, "code")];
	}
	var v = t.type, y = t.content, b = bv(t), x = n === Wv ? "old" : "new", S = Bm({
		id: l || void 0,
		className: $m("diff-gutter", `diff-gutter-${v}`, Vm({ "diff-gutter-selected": r }, "diff-line-hover-" + x, p), a),
		children: h({
			change: t,
			side: x,
			inHoverState: p,
			renderDefault: Nv(t, x),
			wrapInAnchor: Pv(u, d)
		})
	}, s), C = $m("diff-code", `diff-code-${v}`, Vm({ "diff-code-selected": r }, "diff-line-hover-" + x, p), o);
	return [!f && Y("td", Bm(Bm({}, S), {}, { "data-change-key": b }), "gutter"), Y(Mv, Bm({
		className: C,
		changeKey: b,
		text: y,
		tokens: i,
		renderToken: m
	}, c), "code")];
}
function qv(e) {
	var t = e.className, n = e.oldChange, r = e.newChange, i = e.oldSelected, a = e.newSelected, o = e.oldTokens, s = e.newTokens, c = e.monotonous, l = e.gutterClassName, u = e.codeClassName, d = e.gutterEvents, f = e.codeEvents, p = e.hideGutter, m = e.generateAnchorID, h = e.generateLineClassName, g = e.gutterAnchor, _ = e.renderToken, v = e.renderGutter, y = Um(J(""), 2), b = y[0], x = y[1], S = Gv("old", x, n, d), C = Gv("new", x, r, d), w = Gv("old", x, n, f), T = Gv("new", x, r, f), E = n && m(n), D = r && m(r), O = h({
		changes: [n, r],
		defaultGenerate: function() {
			return t;
		}
	}), k = {
		monotonous: c,
		hideGutter: p,
		gutterClassName: l,
		codeClassName: u,
		gutterEvents: d,
		codeEvents: f,
		renderToken: _,
		renderGutter: v
	}, A = Bm(Bm({}, k), {}, {
		change: n,
		side: Wv,
		selected: i,
		tokens: o,
		gutterEvents: S,
		codeEvents: w,
		anchorID: E,
		gutterAnchor: g,
		gutterAnchorTarget: E,
		hover: b === "old"
	}), j = Bm(Bm({}, k), {}, {
		change: r,
		side: 1,
		selected: a,
		tokens: s,
		gutterEvents: C,
		codeEvents: T,
		anchorID: n === r ? null : D,
		gutterAnchor: g,
		gutterAnchorTarget: n === r ? E : D,
		hover: b === "new"
	});
	return c ? Y("tr", {
		className: $m("diff-line", O),
		children: Kv(n ? A : j)
	}) : X("tr", {
		className: $m("diff-line", function(e, t) {
			return e && !t ? "diff-line-old-only" : !e && t ? "diff-line-new-only" : e === t ? "diff-line-normal" : "diff-line-compare";
		}(n, r), O),
		children: [Kv(A), Kv(j)]
	});
}
var Jv = _r(qv);
function Yv(e) {
	var t = e.hideGutter, n = e.oldElement, r = e.newElement;
	return e.monotonous ? Y("tr", {
		className: "diff-widget",
		children: Y("td", {
			colSpan: t ? 1 : 2,
			className: "diff-widget-content",
			children: n || r
		})
	}) : n === r ? Y("tr", {
		className: "diff-widget",
		children: Y("td", {
			colSpan: t ? 2 : 4,
			className: "diff-widget-content",
			children: n
		})
	}) : X("tr", {
		className: "diff-widget",
		children: [Y("td", {
			colSpan: t ? 1 : 2,
			className: "diff-widget-content",
			children: n
		}), Y("td", {
			colSpan: t ? 1 : 2,
			className: "diff-widget-content",
			children: r
		})]
	});
}
var Xv = [
	"selectedChanges",
	"monotonous",
	"hideGutter",
	"tokens",
	"lineClassName"
], Zv = [
	"hunk",
	"widgets",
	"className"
];
function Qv(e, t) {
	return (e ? bv(e) : "00") + (t ? bv(t) : "00");
}
function $v(e) {
	var t = e.hunk, n = e.widgets, r = e.className, i = Hm(e, Zv), a = function(e, t) {
		for (var n = function(e) {
			return e && t[bv(e)] || null;
		}, r = [], i = 0; i < e.length; i++) {
			var a = e[i];
			if (sh(a)) r.push([
				"change",
				Qv(a, a),
				a,
				a
			]);
			else if (oh(a)) {
				var o = e[i + 1];
				o && ah(o) ? (i += 1, r.push([
					"change",
					Qv(a, o),
					a,
					o
				])) : r.push([
					"change",
					Qv(a, null),
					a,
					null
				]);
			} else r.push([
				"change",
				Qv(null, a),
				null,
				a
			]);
			var s = r[r.length - 1], c = n(s[2]), l = n(s[3]);
			if (c || l) {
				var u = s[1];
				r.push([
					"widget",
					u,
					c,
					l
				]);
			}
		}
		return r;
	}(t.changes, n);
	return Y("tbody", {
		className: $m("diff-hunk", r),
		children: a.map((function(e) {
			return function(e, t) {
				var n = Um(e, 4), r = n[0], i = n[1], a = n[2], o = n[3], s = t.selectedChanges, c = t.monotonous, l = t.hideGutter, u = t.tokens, d = t.lineClassName, f = Hm(t, Xv);
				if (r === "change") {
					var p = !!a && s.includes(bv(a)), m = !!o && s.includes(bv(o)), h = a && u ? u.old[xv(a) - 1] : null, g = o && u ? u.new[Sv(o) - 1] : null;
					return Y(Jv, Bm({
						className: d,
						oldChange: a,
						newChange: o,
						monotonous: c,
						hideGutter: l,
						oldSelected: p,
						newSelected: m,
						oldTokens: h,
						newTokens: g
					}, f), `change${i}`);
				}
				return r === "widget" ? Y(Yv, {
					monotonous: c,
					hideGutter: l,
					oldElement: a,
					newElement: o
				}, `widget${i}`) : null;
			}(e, i);
		}))
	});
}
var ey = ["gutterType", "hunkClassName"];
function ty(e) {
	var t = e.hunk, n = rh(), r = n.gutterType, i = n.hunkClassName, a = Hm(n, ey), o = r === "none", s = r === "anchor", c = a.viewType === "unified" ? Uv : $v;
	return Y(c, Bm(Bm({}, a), {}, {
		hunk: t,
		hideGutter: o,
		gutterAnchor: s,
		className: i
	}));
}
function ny() {}
function ry(e, t) {
	var n = t ? "auto" : "none";
	e instanceof HTMLElement && e.style.userSelect !== n && (e.style.userSelect = n);
}
function iy(e) {
	return e.map((function(e) {
		return Y(ty, { hunk: e }, function(e) {
			return `-${e.oldStart},${e.oldLines} +${e.newStart},${e.newLines}`;
		}(e));
	}));
}
function ay(e) {
	var t = e.diffType, n = e.hunks, r = e.optimizeSelection, i = e.className, a = e.hunkClassName, o = a === void 0 ? eh.hunkClassName : a, s = e.lineClassName, c = s === void 0 ? eh.lineClassName : s, l = e.generateLineClassName, u = l === void 0 ? eh.generateLineClassName : l, d = e.gutterClassName, f = d === void 0 ? eh.gutterClassName : d, p = e.codeClassName, m = p === void 0 ? eh.codeClassName : p, h = e.gutterType, g = h === void 0 ? eh.gutterType : h, _ = e.viewType, v = _ === void 0 ? eh.viewType : _, y = e.gutterEvents, b = y === void 0 ? eh.gutterEvents : y, x = e.codeEvents, S = x === void 0 ? eh.codeEvents : x, C = e.generateAnchorID, w = C === void 0 ? eh.generateAnchorID : C, T = e.selectedChanges, E = T === void 0 ? eh.selectedChanges : T, D = e.widgets, O = D === void 0 ? eh.widgets : D, k = e.renderGutter, A = k === void 0 ? eh.renderGutter : k, j = e.tokens, M = e.renderToken, N = e.children, P = N === void 0 ? iy : N, F = Tr(null), I = vr((function(e) {
		var t = e.target;
		if (e.button === 0) {
			var n = function(e, t) {
				for (var n = e; n && n !== document.documentElement && !n.classList.contains(t);) n = n.parentElement;
				return n === document.documentElement ? null : n;
			}(t, "diff-code");
			if (n && n.parentElement) {
				var r = window.getSelection();
				r && r.removeAllRanges();
				var i = Wm(n.parentElement.children).indexOf(n);
				if (i === 1 || i === 3) {
					var a, o = Xm(F.current ? F.current.querySelectorAll(".diff-line") : []);
					try {
						for (o.s(); !(a = o.n()).done;) {
							var s = a.value.children;
							ry(s[1], i === 1), ry(s[3], i === 3);
						}
					} catch (e) {
						o.e(e);
					} finally {
						o.f();
					}
				}
			}
		}
	}), []), L = g === "none", R = t === "add" || t === "delete", z = v === "split" && !R && r ? I : ny, B = q((function() {
		return X("colgroup", v === "unified" ? { children: [
			!L && Y("col", { className: "diff-gutter-col" }),
			!L && Y("col", { className: "diff-gutter-col" }),
			Y("col", {})
		] } : R ? { children: [!L && Y("col", { className: "diff-gutter-col" }), Y("col", {})] } : { children: [
			!L && Y("col", { className: "diff-gutter-col" }),
			Y("col", {}),
			!L && Y("col", { className: "diff-gutter-col" }),
			Y("col", {})
		] });
	}), [
		v,
		R,
		L
	]), V = q((function() {
		return {
			hunkClassName: o,
			lineClassName: c,
			generateLineClassName: u,
			gutterClassName: f,
			codeClassName: m,
			monotonous: R,
			hideGutter: L,
			viewType: v,
			gutterType: g,
			codeEvents: S,
			gutterEvents: b,
			generateAnchorID: w,
			selectedChanges: E,
			widgets: O,
			renderGutter: A,
			tokens: j,
			renderToken: M
		};
	}), [
		m,
		S,
		w,
		f,
		b,
		g,
		L,
		o,
		c,
		u,
		R,
		A,
		M,
		E,
		j,
		v,
		O
	]);
	return Y(nh, {
		value: V,
		children: X("table", {
			ref: F,
			className: $m("diff", `diff-${v}`, i),
			onMouseDown: z,
			children: [B, P(n)]
		})
	});
}
var oy = _r(ay);
if (process.env.NODE_ENV !== "production") var sy = function(e, t) {
	var n = arguments.length;
	t = Array(n > 1 ? n - 1 : 0);
	for (var r = 1; r < n; r++) t[r - 1] = arguments[r];
	var i = 0, a = "Warning: " + e.replace(/%s/g, (function() {
		return t[i++];
	}));
	typeof console < "u" && console.error(a);
	try {
		throw Error(a);
	} catch {}
};
Fh && Fh.isConcatSpreadable;
var cy = Qm((function(e) {
	var t = function() {
		this.Diff_Timeout = 1, this.Diff_EditCost = 4, this.Match_Threshold = .5, this.Match_Distance = 1e3, this.Patch_DeleteThreshold = .5, this.Patch_Margin = 4, this.Match_MaxBits = 32;
	};
	t.Diff = function(e, t) {
		return [e, t];
	}, t.prototype.diff_main = function(e, n, r, i) {
		i === void 0 && (i = this.Diff_Timeout <= 0 ? Number.MAX_VALUE : (/* @__PURE__ */ new Date()).getTime() + 1e3 * this.Diff_Timeout);
		var a = i;
		if (e == null || n == null) throw Error("Null input. (diff_main)");
		if (e == n) return e ? [new t.Diff(0, e)] : [];
		r === void 0 && (r = !0);
		var o = r, s = this.diff_commonPrefix(e, n), c = e.substring(0, s);
		e = e.substring(s), n = n.substring(s), s = this.diff_commonSuffix(e, n);
		var l = e.substring(e.length - s);
		e = e.substring(0, e.length - s), n = n.substring(0, n.length - s);
		var u = this.diff_compute_(e, n, o, a);
		return c && u.unshift(new t.Diff(0, c)), l && u.push(new t.Diff(0, l)), this.diff_cleanupMerge(u), u;
	}, t.prototype.diff_compute_ = function(e, n, r, i) {
		var a;
		if (!e) return [new t.Diff(1, n)];
		if (!n) return [new t.Diff(-1, e)];
		var o = e.length > n.length ? e : n, s = e.length > n.length ? n : e, c = o.indexOf(s);
		if (c != -1) return a = [
			new t.Diff(1, o.substring(0, c)),
			new t.Diff(0, s),
			new t.Diff(1, o.substring(c + s.length))
		], e.length > n.length && (a[0][0] = a[2][0] = -1), a;
		if (s.length == 1) return [new t.Diff(-1, e), new t.Diff(1, n)];
		var l = this.diff_halfMatch_(e, n);
		if (l) {
			var u = l[0], d = l[1], f = l[2], p = l[3], m = l[4], h = this.diff_main(u, f, r, i), g = this.diff_main(d, p, r, i);
			return h.concat([new t.Diff(0, m)], g);
		}
		return r && e.length > 100 && n.length > 100 ? this.diff_lineMode_(e, n, i) : this.diff_bisect_(e, n, i);
	}, t.prototype.diff_lineMode_ = function(e, n, r) {
		var i = this.diff_linesToChars_(e, n);
		e = i.chars1, n = i.chars2;
		var a = i.lineArray, o = this.diff_main(e, n, !1, r);
		this.diff_charsToLines_(o, a), this.diff_cleanupSemantic(o), o.push(new t.Diff(0, ""));
		for (var s = 0, c = 0, l = 0, u = "", d = ""; s < o.length;) {
			switch (o[s][0]) {
				case 1:
					l++, d += o[s][1];
					break;
				case -1:
					c++, u += o[s][1];
					break;
				case 0:
					if (c >= 1 && l >= 1) {
						o.splice(s - c - l, c + l), s = s - c - l;
						for (var f = this.diff_main(u, d, !1, r), p = f.length - 1; p >= 0; p--) o.splice(s, 0, f[p]);
						s += f.length;
					}
					l = 0, c = 0, u = "", d = "";
			}
			s++;
		}
		return o.pop(), o;
	}, t.prototype.diff_bisect_ = function(e, n, r) {
		for (var i = e.length, a = n.length, o = Math.ceil((i + a) / 2), s = o, c = 2 * o, l = Array(c), u = Array(c), d = 0; d < c; d++) l[d] = -1, u[d] = -1;
		l[s + 1] = 0, u[s + 1] = 0;
		for (var f = i - a, p = f % 2 != 0, m = 0, h = 0, g = 0, _ = 0, v = 0; v < o && !((/* @__PURE__ */ new Date()).getTime() > r); v++) {
			for (var y = -v + m; y <= v - h; y += 2) {
				for (var b = s + y, x = (E = y == -v || y != v && l[b - 1] < l[b + 1] ? l[b + 1] : l[b - 1] + 1) - y; E < i && x < a && e.charAt(E) == n.charAt(x);) E++, x++;
				if (l[b] = E, E > i) h += 2;
				else if (x > a) m += 2;
				else if (p && (w = s + f - y) >= 0 && w < c && u[w] != -1 && E >= (C = i - u[w])) return this.diff_bisectSplit_(e, n, E, x, r);
			}
			for (var S = -v + g; S <= v - _; S += 2) {
				for (var C, w = s + S, T = (C = S == -v || S != v && u[w - 1] < u[w + 1] ? u[w + 1] : u[w - 1] + 1) - S; C < i && T < a && e.charAt(i - C - 1) == n.charAt(a - T - 1);) C++, T++;
				if (u[w] = C, C > i) _ += 2;
				else if (T > a) g += 2;
				else if (!p && (b = s + f - S) >= 0 && b < c && l[b] != -1) {
					var E;
					if (x = s + (E = l[b]) - b, E >= (C = i - C)) return this.diff_bisectSplit_(e, n, E, x, r);
				}
			}
		}
		return [new t.Diff(-1, e), new t.Diff(1, n)];
	}, t.prototype.diff_bisectSplit_ = function(e, t, n, r, i) {
		var a = e.substring(0, n), o = t.substring(0, r), s = e.substring(n), c = t.substring(r), l = this.diff_main(a, o, !1, i), u = this.diff_main(s, c, !1, i);
		return l.concat(u);
	}, t.prototype.diff_linesToChars_ = function(e, t) {
		var n = [], r = {};
		function i(e) {
			for (var t = "", i = 0, o = -1, s = n.length; o < e.length - 1;) {
				(o = e.indexOf("\n", i)) == -1 && (o = e.length - 1);
				var c = e.substring(i, o + 1);
				(r.hasOwnProperty ? r.hasOwnProperty(c) : r[c] !== void 0) ? t += String.fromCharCode(r[c]) : (s == a && (c = e.substring(i), o = e.length), t += String.fromCharCode(s), r[c] = s, n[s++] = c), i = o + 1;
			}
			return t;
		}
		n[0] = "";
		var a = 4e4, o = i(e);
		return a = 65535, {
			chars1: o,
			chars2: i(t),
			lineArray: n
		};
	}, t.prototype.diff_charsToLines_ = function(e, t) {
		for (var n = 0; n < e.length; n++) {
			for (var r = e[n][1], i = [], a = 0; a < r.length; a++) i[a] = t[r.charCodeAt(a)];
			e[n][1] = i.join("");
		}
	}, t.prototype.diff_commonPrefix = function(e, t) {
		if (!e || !t || e.charAt(0) != t.charAt(0)) return 0;
		for (var n = 0, r = Math.min(e.length, t.length), i = r, a = 0; n < i;) e.substring(a, i) == t.substring(a, i) ? a = n = i : r = i, i = Math.floor((r - n) / 2 + n);
		return i;
	}, t.prototype.diff_commonSuffix = function(e, t) {
		if (!e || !t || e.charAt(e.length - 1) != t.charAt(t.length - 1)) return 0;
		for (var n = 0, r = Math.min(e.length, t.length), i = r, a = 0; n < i;) e.substring(e.length - i, e.length - a) == t.substring(t.length - i, t.length - a) ? a = n = i : r = i, i = Math.floor((r - n) / 2 + n);
		return i;
	}, t.prototype.diff_commonOverlap_ = function(e, t) {
		var n = e.length, r = t.length;
		if (n == 0 || r == 0) return 0;
		n > r ? e = e.substring(n - r) : n < r && (t = t.substring(0, n));
		var i = Math.min(n, r);
		if (e == t) return i;
		for (var a = 0, o = 1;;) {
			var s = e.substring(i - o), c = t.indexOf(s);
			if (c == -1) return a;
			o += c, c != 0 && e.substring(i - o) != t.substring(0, o) || (a = o, o++);
		}
	}, t.prototype.diff_halfMatch_ = function(e, t) {
		if (this.Diff_Timeout <= 0) return null;
		var n = e.length > t.length ? e : t, r = e.length > t.length ? t : e;
		if (n.length < 4 || 2 * r.length < n.length) return null;
		var i = this;
		function a(e, t, n) {
			for (var r, a, o, s, c = e.substring(n, n + Math.floor(e.length / 4)), l = -1, u = ""; (l = t.indexOf(c, l + 1)) != -1;) {
				var d = i.diff_commonPrefix(e.substring(n), t.substring(l)), f = i.diff_commonSuffix(e.substring(0, n), t.substring(0, l));
				u.length < f + d && (u = t.substring(l - f, l) + t.substring(l, l + d), r = e.substring(0, n - f), a = e.substring(n + d), o = t.substring(0, l - f), s = t.substring(l + d));
			}
			return 2 * u.length >= e.length ? [
				r,
				a,
				o,
				s,
				u
			] : null;
		}
		var o, s, c, l, u, d = a(n, r, Math.ceil(n.length / 4)), f = a(n, r, Math.ceil(n.length / 2));
		return d || f ? (o = f ? d && d[4].length > f[4].length ? d : f : d, e.length > t.length ? (s = o[0], c = o[1], l = o[2], u = o[3]) : (l = o[0], u = o[1], s = o[2], c = o[3]), [
			s,
			c,
			l,
			u,
			o[4]
		]) : null;
	}, t.prototype.diff_cleanupSemantic = function(e) {
		for (var n = !1, r = [], i = 0, a = null, o = 0, s = 0, c = 0, l = 0, u = 0; o < e.length;) e[o][0] == 0 ? (r[i++] = o, s = l, c = u, l = 0, u = 0, a = e[o][1]) : (e[o][0] == 1 ? l += e[o][1].length : u += e[o][1].length, a && a.length <= Math.max(s, c) && a.length <= Math.max(l, u) && (e.splice(r[i - 1], 0, new t.Diff(-1, a)), e[r[i - 1] + 1][0] = 1, i--, o = --i > 0 ? r[i - 1] : -1, s = 0, c = 0, l = 0, u = 0, a = null, n = !0)), o++;
		for (n && this.diff_cleanupMerge(e), this.diff_cleanupSemanticLossless(e), o = 1; o < e.length;) {
			if (e[o - 1][0] == -1 && e[o][0] == 1) {
				var d = e[o - 1][1], f = e[o][1], p = this.diff_commonOverlap_(d, f), m = this.diff_commonOverlap_(f, d);
				p >= m ? (p >= d.length / 2 || p >= f.length / 2) && (e.splice(o, 0, new t.Diff(0, f.substring(0, p))), e[o - 1][1] = d.substring(0, d.length - p), e[o + 1][1] = f.substring(p), o++) : (m >= d.length / 2 || m >= f.length / 2) && (e.splice(o, 0, new t.Diff(0, d.substring(0, m))), e[o - 1][0] = 1, e[o - 1][1] = f.substring(0, f.length - m), e[o + 1][0] = -1, e[o + 1][1] = d.substring(m), o++), o++;
			}
			o++;
		}
	}, t.prototype.diff_cleanupSemanticLossless = function(e) {
		function n(e, n) {
			if (!e || !n) return 6;
			var r = e.charAt(e.length - 1), i = n.charAt(0), a = r.match(t.nonAlphaNumericRegex_), o = i.match(t.nonAlphaNumericRegex_), s = a && r.match(t.whitespaceRegex_), c = o && i.match(t.whitespaceRegex_), l = s && r.match(t.linebreakRegex_), u = c && i.match(t.linebreakRegex_), d = l && e.match(t.blanklineEndRegex_), f = u && n.match(t.blanklineStartRegex_);
			return d || f ? 5 : l || u ? 4 : a && !s && c ? 3 : s || c ? 2 : a || o ? 1 : 0;
		}
		for (var r = 1; r < e.length - 1;) {
			if (e[r - 1][0] == 0 && e[r + 1][0] == 0) {
				var i = e[r - 1][1], a = e[r][1], o = e[r + 1][1], s = this.diff_commonSuffix(i, a);
				if (s) {
					var c = a.substring(a.length - s);
					i = i.substring(0, i.length - s), a = c + a.substring(0, a.length - s), o = c + o;
				}
				for (var l = i, u = a, d = o, f = n(i, a) + n(a, o); a.charAt(0) === o.charAt(0);) {
					i += a.charAt(0), a = a.substring(1) + o.charAt(0), o = o.substring(1);
					var p = n(i, a) + n(a, o);
					p >= f && (f = p, l = i, u = a, d = o);
				}
				e[r - 1][1] != l && (l ? e[r - 1][1] = l : (e.splice(r - 1, 1), r--), e[r][1] = u, d ? e[r + 1][1] = d : (e.splice(r + 1, 1), r--));
			}
			r++;
		}
	}, t.nonAlphaNumericRegex_ = /[^a-zA-Z0-9]/, t.whitespaceRegex_ = /\s/, t.linebreakRegex_ = /[\r\n]/, t.blanklineEndRegex_ = /\n\r?\n$/, t.blanklineStartRegex_ = /^\r?\n\r?\n/, t.prototype.diff_cleanupEfficiency = function(e) {
		for (var n = !1, r = [], i = 0, a = null, o = 0, s = !1, c = !1, l = !1, u = !1; o < e.length;) e[o][0] == 0 ? (e[o][1].length < this.Diff_EditCost && (l || u) ? (r[i++] = o, s = l, c = u, a = e[o][1]) : (i = 0, a = null), l = u = !1) : (e[o][0] == -1 ? u = !0 : l = !0, a && (s && c && l && u || a.length < this.Diff_EditCost / 2 && s + c + l + u == 3) && (e.splice(r[i - 1], 0, new t.Diff(-1, a)), e[r[i - 1] + 1][0] = 1, i--, a = null, s && c ? (l = u = !0, i = 0) : (o = --i > 0 ? r[i - 1] : -1, l = u = !1), n = !0)), o++;
		n && this.diff_cleanupMerge(e);
	}, t.prototype.diff_cleanupMerge = function(e) {
		e.push(new t.Diff(0, ""));
		for (var n, r = 0, i = 0, a = 0, o = "", s = ""; r < e.length;) switch (e[r][0]) {
			case 1:
				a++, s += e[r][1], r++;
				break;
			case -1:
				i++, o += e[r][1], r++;
				break;
			case 0: i + a > 1 ? (i !== 0 && a !== 0 && ((n = this.diff_commonPrefix(s, o)) !== 0 && (r - i - a > 0 && e[r - i - a - 1][0] == 0 ? e[r - i - a - 1][1] += s.substring(0, n) : (e.splice(0, 0, new t.Diff(0, s.substring(0, n))), r++), s = s.substring(n), o = o.substring(n)), (n = this.diff_commonSuffix(s, o)) !== 0 && (e[r][1] = s.substring(s.length - n) + e[r][1], s = s.substring(0, s.length - n), o = o.substring(0, o.length - n))), r -= i + a, e.splice(r, i + a), o.length && (e.splice(r, 0, new t.Diff(-1, o)), r++), s.length && (e.splice(r, 0, new t.Diff(1, s)), r++), r++) : r !== 0 && e[r - 1][0] == 0 ? (e[r - 1][1] += e[r][1], e.splice(r, 1)) : r++, a = 0, i = 0, o = "", s = "";
		}
		e[e.length - 1][1] === "" && e.pop();
		var c = !1;
		for (r = 1; r < e.length - 1;) e[r - 1][0] == 0 && e[r + 1][0] == 0 && (e[r][1].substring(e[r][1].length - e[r - 1][1].length) == e[r - 1][1] ? (e[r][1] = e[r - 1][1] + e[r][1].substring(0, e[r][1].length - e[r - 1][1].length), e[r + 1][1] = e[r - 1][1] + e[r + 1][1], e.splice(r - 1, 1), c = !0) : e[r][1].substring(0, e[r + 1][1].length) == e[r + 1][1] && (e[r - 1][1] += e[r + 1][1], e[r][1] = e[r][1].substring(e[r + 1][1].length) + e[r + 1][1], e.splice(r + 1, 1), c = !0)), r++;
		c && this.diff_cleanupMerge(e);
	}, t.prototype.diff_xIndex = function(e, t) {
		var n, r = 0, i = 0, a = 0, o = 0;
		for (n = 0; n < e.length && (e[n][0] !== 1 && (r += e[n][1].length), e[n][0] !== -1 && (i += e[n][1].length), !(r > t)); n++) a = r, o = i;
		return e.length != n && e[n][0] === -1 ? o : o + (t - a);
	}, t.prototype.diff_prettyHtml = function(e) {
		for (var t = [], n = /&/g, r = /</g, i = />/g, a = /\n/g, o = 0; o < e.length; o++) {
			var s = e[o][0], c = e[o][1].replace(n, "&amp;").replace(r, "&lt;").replace(i, "&gt;").replace(a, "&para;<br>");
			switch (s) {
				case 1:
					t[o] = "<ins style=\"background:#e6ffe6;\">" + c + "</ins>";
					break;
				case -1:
					t[o] = "<del style=\"background:#ffe6e6;\">" + c + "</del>";
					break;
				case 0: t[o] = "<span>" + c + "</span>";
			}
		}
		return t.join("");
	}, t.prototype.diff_text1 = function(e) {
		for (var t = [], n = 0; n < e.length; n++) e[n][0] !== 1 && (t[n] = e[n][1]);
		return t.join("");
	}, t.prototype.diff_text2 = function(e) {
		for (var t = [], n = 0; n < e.length; n++) e[n][0] !== -1 && (t[n] = e[n][1]);
		return t.join("");
	}, t.prototype.diff_levenshtein = function(e) {
		for (var t = 0, n = 0, r = 0, i = 0; i < e.length; i++) {
			var a = e[i][0], o = e[i][1];
			switch (a) {
				case 1:
					n += o.length;
					break;
				case -1:
					r += o.length;
					break;
				case 0: t += Math.max(n, r), n = 0, r = 0;
			}
		}
		return t += Math.max(n, r);
	}, t.prototype.diff_toDelta = function(e) {
		for (var t = [], n = 0; n < e.length; n++) switch (e[n][0]) {
			case 1:
				t[n] = "+" + encodeURI(e[n][1]);
				break;
			case -1:
				t[n] = "-" + e[n][1].length;
				break;
			case 0: t[n] = "=" + e[n][1].length;
		}
		return t.join("	").replace(/%20/g, " ");
	}, t.prototype.diff_fromDelta = function(e, n) {
		for (var r = [], i = 0, a = 0, o = n.split(/\t/g), s = 0; s < o.length; s++) {
			var c = o[s].substring(1);
			switch (o[s].charAt(0)) {
				case "+":
					try {
						r[i++] = new t.Diff(1, decodeURI(c));
					} catch {
						throw Error("Illegal escape in diff_fromDelta: " + c);
					}
					break;
				case "-":
				case "=":
					var l = parseInt(c, 10);
					if (isNaN(l) || l < 0) throw Error("Invalid number in diff_fromDelta: " + c);
					var u = e.substring(a, a += l);
					o[s].charAt(0) == "=" ? r[i++] = new t.Diff(0, u) : r[i++] = new t.Diff(-1, u);
					break;
				default: if (o[s]) throw Error("Invalid diff operation in diff_fromDelta: " + o[s]);
			}
		}
		if (a != e.length) throw Error("Delta length (" + a + ") does not equal source text length (" + e.length + ").");
		return r;
	}, t.prototype.match_main = function(e, t, n) {
		if (e == null || t == null || n == null) throw Error("Null input. (match_main)");
		return n = Math.max(0, Math.min(n, e.length)), e == t ? 0 : e.length ? e.substring(n, n + t.length) == t ? n : this.match_bitap_(e, t, n) : -1;
	}, t.prototype.match_bitap_ = function(e, t, n) {
		if (t.length > this.Match_MaxBits) throw Error("Pattern too long for this browser.");
		var r = this.match_alphabet_(t), i = this;
		function a(e, r) {
			var a = e / t.length, o = Math.abs(n - r);
			return i.Match_Distance ? a + o / i.Match_Distance : o ? 1 : a;
		}
		var o = this.Match_Threshold, s = e.indexOf(t, n);
		s != -1 && (o = Math.min(a(0, s), o), (s = e.lastIndexOf(t, n + t.length)) != -1 && (o = Math.min(a(0, s), o)));
		var c, l, u = 1 << t.length - 1;
		s = -1;
		for (var d, f = t.length + e.length, p = 0; p < t.length; p++) {
			for (c = 0, l = f; c < l;) a(p, n + l) <= o ? c = l : f = l, l = Math.floor((f - c) / 2 + c);
			f = l;
			var m = Math.max(1, n - l + 1), h = Math.min(n + l, e.length) + t.length, g = Array(h + 2);
			g[h + 1] = (1 << p) - 1;
			for (var _ = h; _ >= m; _--) {
				var v = r[e.charAt(_ - 1)];
				if (g[_] = p === 0 ? (g[_ + 1] << 1 | 1) & v : (g[_ + 1] << 1 | 1) & v | (d[_ + 1] | d[_]) << 1 | 1 | d[_ + 1], g[_] & u) {
					var y = a(p, _ - 1);
					if (y <= o) {
						if (o = y, !((s = _ - 1) > n)) break;
						m = Math.max(1, 2 * n - s);
					}
				}
			}
			if (a(p + 1, n) > o) break;
			d = g;
		}
		return s;
	}, t.prototype.match_alphabet_ = function(e) {
		for (var t = {}, n = 0; n < e.length; n++) t[e.charAt(n)] = 0;
		for (n = 0; n < e.length; n++) t[e.charAt(n)] |= 1 << e.length - n - 1;
		return t;
	}, t.prototype.patch_addContext_ = function(e, n) {
		if (n.length != 0) {
			if (e.start2 === null) throw Error("patch not initialized");
			for (var r = n.substring(e.start2, e.start2 + e.length1), i = 0; n.indexOf(r) != n.lastIndexOf(r) && r.length < this.Match_MaxBits - this.Patch_Margin - this.Patch_Margin;) i += this.Patch_Margin, r = n.substring(e.start2 - i, e.start2 + e.length1 + i);
			i += this.Patch_Margin;
			var a = n.substring(e.start2 - i, e.start2);
			a && e.diffs.unshift(new t.Diff(0, a));
			var o = n.substring(e.start2 + e.length1, e.start2 + e.length1 + i);
			o && e.diffs.push(new t.Diff(0, o)), e.start1 -= a.length, e.start2 -= a.length, e.length1 += a.length + o.length, e.length2 += a.length + o.length;
		}
	}, t.prototype.patch_make = function(e, n, r) {
		var i, a;
		if (typeof e == "string" && typeof n == "string" && r === void 0) i = e, (a = this.diff_main(i, n, !0)).length > 2 && (this.diff_cleanupSemantic(a), this.diff_cleanupEfficiency(a));
		else if (e && typeof e == "object" && n === void 0 && r === void 0) a = e, i = this.diff_text1(a);
		else if (typeof e == "string" && n && typeof n == "object" && r === void 0) i = e, a = n;
		else {
			if (typeof e != "string" || typeof n != "string" || !r || typeof r != "object") throw Error("Unknown call format to patch_make.");
			i = e, a = r;
		}
		if (a.length === 0) return [];
		for (var o = [], s = new t.patch_obj(), c = 0, l = 0, u = 0, d = i, f = i, p = 0; p < a.length; p++) {
			var m = a[p][0], h = a[p][1];
			switch (c || m === 0 || (s.start1 = l, s.start2 = u), m) {
				case 1:
					s.diffs[c++] = a[p], s.length2 += h.length, f = f.substring(0, u) + h + f.substring(u);
					break;
				case -1:
					s.length1 += h.length, s.diffs[c++] = a[p], f = f.substring(0, u) + f.substring(u + h.length);
					break;
				case 0: h.length <= 2 * this.Patch_Margin && c && a.length != p + 1 ? (s.diffs[c++] = a[p], s.length1 += h.length, s.length2 += h.length) : h.length >= 2 * this.Patch_Margin && c && (this.patch_addContext_(s, d), o.push(s), s = new t.patch_obj(), c = 0, d = f, l = u);
			}
			m !== 1 && (l += h.length), m !== -1 && (u += h.length);
		}
		return c && (this.patch_addContext_(s, d), o.push(s)), o;
	}, t.prototype.patch_deepCopy = function(e) {
		for (var n = [], r = 0; r < e.length; r++) {
			var i = e[r], a = new t.patch_obj();
			a.diffs = [];
			for (var o = 0; o < i.diffs.length; o++) a.diffs[o] = new t.Diff(i.diffs[o][0], i.diffs[o][1]);
			a.start1 = i.start1, a.start2 = i.start2, a.length1 = i.length1, a.length2 = i.length2, n[r] = a;
		}
		return n;
	}, t.prototype.patch_apply = function(e, t) {
		if (e.length == 0) return [t, []];
		e = this.patch_deepCopy(e);
		var n = this.patch_addPadding(e);
		t = n + t + n, this.patch_splitMax(e);
		for (var r = 0, i = [], a = 0; a < e.length; a++) {
			var o, s, c = e[a].start2 + r, l = this.diff_text1(e[a].diffs), u = -1;
			if (l.length > this.Match_MaxBits ? (o = this.match_main(t, l.substring(0, this.Match_MaxBits), c)) != -1 && ((u = this.match_main(t, l.substring(l.length - this.Match_MaxBits), c + l.length - this.Match_MaxBits)) == -1 || o >= u) && (o = -1) : o = this.match_main(t, l, c), o == -1) i[a] = !1, r -= e[a].length2 - e[a].length1;
			else if (i[a] = !0, r = o - c, l == (s = u == -1 ? t.substring(o, o + l.length) : t.substring(o, u + this.Match_MaxBits))) t = t.substring(0, o) + this.diff_text2(e[a].diffs) + t.substring(o + l.length);
			else {
				var d = this.diff_main(l, s, !1);
				if (l.length > this.Match_MaxBits && this.diff_levenshtein(d) / l.length > this.Patch_DeleteThreshold) i[a] = !1;
				else {
					this.diff_cleanupSemanticLossless(d);
					for (var f, p = 0, m = 0; m < e[a].diffs.length; m++) {
						var h = e[a].diffs[m];
						h[0] !== 0 && (f = this.diff_xIndex(d, p)), h[0] === 1 ? t = t.substring(0, o + f) + h[1] + t.substring(o + f) : h[0] === -1 && (t = t.substring(0, o + f) + t.substring(o + this.diff_xIndex(d, p + h[1].length))), h[0] !== -1 && (p += h[1].length);
					}
				}
			}
		}
		return [t = t.substring(n.length, t.length - n.length), i];
	}, t.prototype.patch_addPadding = function(e) {
		for (var n = this.Patch_Margin, r = "", i = 1; i <= n; i++) r += String.fromCharCode(i);
		for (i = 0; i < e.length; i++) e[i].start1 += n, e[i].start2 += n;
		var a = e[0], o = a.diffs;
		if (o.length == 0 || o[0][0] != 0) o.unshift(new t.Diff(0, r)), a.start1 -= n, a.start2 -= n, a.length1 += n, a.length2 += n;
		else if (n > o[0][1].length) {
			var s = n - o[0][1].length;
			o[0][1] = r.substring(o[0][1].length) + o[0][1], a.start1 -= s, a.start2 -= s, a.length1 += s, a.length2 += s;
		}
		return (o = (a = e[e.length - 1]).diffs).length == 0 || o[o.length - 1][0] != 0 ? (o.push(new t.Diff(0, r)), a.length1 += n, a.length2 += n) : n > o[o.length - 1][1].length && (s = n - o[o.length - 1][1].length, o[o.length - 1][1] += r.substring(0, s), a.length1 += s, a.length2 += s), r;
	}, t.prototype.patch_splitMax = function(e) {
		for (var n = this.Match_MaxBits, r = 0; r < e.length; r++) if (!(e[r].length1 <= n)) {
			var i = e[r];
			e.splice(r--, 1);
			for (var a = i.start1, o = i.start2, s = ""; i.diffs.length !== 0;) {
				var c = new t.patch_obj(), l = !0;
				for (c.start1 = a - s.length, c.start2 = o - s.length, s !== "" && (c.length1 = c.length2 = s.length, c.diffs.push(new t.Diff(0, s))); i.diffs.length !== 0 && c.length1 < n - this.Patch_Margin;) {
					var u = i.diffs[0][0], d = i.diffs[0][1];
					u === 1 ? (c.length2 += d.length, o += d.length, c.diffs.push(i.diffs.shift()), l = !1) : u === -1 && c.diffs.length == 1 && c.diffs[0][0] == 0 && d.length > 2 * n ? (c.length1 += d.length, a += d.length, l = !1, c.diffs.push(new t.Diff(u, d)), i.diffs.shift()) : (d = d.substring(0, n - c.length1 - this.Patch_Margin), c.length1 += d.length, a += d.length, u === 0 ? (c.length2 += d.length, o += d.length) : l = !1, c.diffs.push(new t.Diff(u, d)), d == i.diffs[0][1] ? i.diffs.shift() : i.diffs[0][1] = i.diffs[0][1].substring(d.length));
				}
				s = (s = this.diff_text2(c.diffs)).substring(s.length - this.Patch_Margin);
				var f = this.diff_text1(i.diffs).substring(0, this.Patch_Margin);
				f !== "" && (c.length1 += f.length, c.length2 += f.length, c.diffs.length !== 0 && c.diffs[c.diffs.length - 1][0] === 0 ? c.diffs[c.diffs.length - 1][1] += f : c.diffs.push(new t.Diff(0, f))), l || e.splice(++r, 0, c);
			}
		}
	}, t.prototype.patch_toText = function(e) {
		for (var t = [], n = 0; n < e.length; n++) t[n] = e[n];
		return t.join("");
	}, t.prototype.patch_fromText = function(e) {
		var n = [];
		if (!e) return n;
		for (var r = e.split("\n"), i = 0, a = /^@@ -(\d+),?(\d*) \+(\d+),?(\d*) @@$/; i < r.length;) {
			var o = r[i].match(a);
			if (!o) throw Error("Invalid patch string: " + r[i]);
			var s = new t.patch_obj();
			for (n.push(s), s.start1 = parseInt(o[1], 10), o[2] === "" ? (s.start1--, s.length1 = 1) : o[2] == "0" ? s.length1 = 0 : (s.start1--, s.length1 = parseInt(o[2], 10)), s.start2 = parseInt(o[3], 10), o[4] === "" ? (s.start2--, s.length2 = 1) : o[4] == "0" ? s.length2 = 0 : (s.start2--, s.length2 = parseInt(o[4], 10)), i++; i < r.length;) {
				var c = r[i].charAt(0);
				try {
					var l = decodeURI(r[i].substring(1));
				} catch {
					throw Error("Illegal escape in patch_fromText: " + l);
				}
				if (c == "-") s.diffs.push(new t.Diff(-1, l));
				else if (c == "+") s.diffs.push(new t.Diff(1, l));
				else if (c == " ") s.diffs.push(new t.Diff(0, l));
				else {
					if (c == "@") break;
					if (c !== "") throw Error("Invalid patch mode \"" + c + "\" in: " + l);
				}
				i++;
			}
		}
		return n;
	}, (t.patch_obj = function() {
		this.diffs = [], this.start1 = null, this.start2 = null, this.length1 = 0, this.length2 = 0;
	}).prototype.toString = function() {
		for (var e, t = ["@@ -" + (this.length1 === 0 ? this.start1 + ",0" : this.length1 == 1 ? this.start1 + 1 : this.start1 + 1 + "," + this.length1) + " +" + (this.length2 === 0 ? this.start2 + ",0" : this.length2 == 1 ? this.start2 + 1 : this.start2 + 1 + "," + this.length2) + " @@\n"], n = 0; n < this.diffs.length; n++) {
			switch (this.diffs[n][0]) {
				case 1:
					e = "+";
					break;
				case -1:
					e = "-";
					break;
				case 0: e = " ";
			}
			t[n + 1] = e + encodeURI(this.diffs[n][1]) + "\n";
		}
		return t.join("").replace(/%20/g, " ");
	}, e.exports = t, e.exports.diff_match_patch = t, e.exports.DIFF_DELETE = -1, e.exports.DIFF_INSERT = 1, e.exports.DIFF_EQUAL = 0;
}));
cy.DIFF_EQUAL, cy.DIFF_DELETE, cy.DIFF_INSERT;
var ly = /* @__PURE__ */ ua(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.default = t;
	/*istanbul ignore end*/
	function t() {}
	t.prototype = {
		/*istanbul ignore start*/
		/*istanbul ignore end*/
		diff: function(e, t) {
			/*istanbul ignore start*/
			var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i = r.callback;
			typeof r == "function" && (i = r, r = {}), this.options = r;
			var a = this;
			function o(e) {
				return i ? (setTimeout(function() {
					i(void 0, e);
				}, 0), !0) : e;
			}
			e = this.castInput(e), t = this.castInput(t), e = this.removeEmpty(this.tokenize(e)), t = this.removeEmpty(this.tokenize(t));
			var s = t.length, c = e.length, l = 1, u = s + c;
			r.maxEditLength && (u = Math.min(u, r.maxEditLength));
			var d = r.timeout ?? Infinity, f = Date.now() + d, p = [{
				oldPos: -1,
				lastComponent: void 0
			}], m = this.extractCommon(p[0], t, e, 0);
			if (p[0].oldPos + 1 >= c && m + 1 >= s) return o([{
				value: this.join(t),
				count: t.length
			}]);
			var h = -Infinity, g = Infinity;
			function _() {
				for (var r = Math.max(h, -l); r <= Math.min(g, l); r += 2) {
					var i = void 0, u = p[r - 1], d = p[r + 1];
					u && (p[r - 1] = void 0);
					var f = !1;
					if (d) {
						var _ = d.oldPos - r;
						f = d && 0 <= _ && _ < s;
					}
					var v = u && u.oldPos + 1 < c;
					if (!f && !v) {
						p[r] = void 0;
						continue;
					}
					if (i = !v || f && u.oldPos + 1 < d.oldPos ? a.addToPath(d, !0, void 0, 0) : a.addToPath(u, void 0, !0, 1), m = a.extractCommon(i, t, e, r), i.oldPos + 1 >= c && m + 1 >= s) return o(n(a, i.lastComponent, t, e, a.useLongestToken));
					p[r] = i, i.oldPos + 1 >= c && (g = Math.min(g, r - 1)), m + 1 >= s && (h = Math.max(h, r + 1));
				}
				l++;
			}
			if (i) (function e() {
				setTimeout(function() {
					if (l > u || Date.now() > f) return i();
					_() || e();
				}, 0);
			})();
			else for (; l <= u && Date.now() <= f;) {
				var v = _();
				if (v) return v;
			}
		},
		/*istanbul ignore start*/
		/*istanbul ignore end*/
		addToPath: function(e, t, n, r) {
			var i = e.lastComponent;
			return i && i.added === t && i.removed === n ? {
				oldPos: e.oldPos + r,
				lastComponent: {
					count: i.count + 1,
					added: t,
					removed: n,
					previousComponent: i.previousComponent
				}
			} : {
				oldPos: e.oldPos + r,
				lastComponent: {
					count: 1,
					added: t,
					removed: n,
					previousComponent: i
				}
			};
		},
		/*istanbul ignore start*/
		/*istanbul ignore end*/
		extractCommon: function(e, t, n, r) {
			for (var i = t.length, a = n.length, o = e.oldPos, s = o - r, c = 0; s + 1 < i && o + 1 < a && this.equals(t[s + 1], n[o + 1]);) s++, o++, c++;
			return c && (e.lastComponent = {
				count: c,
				previousComponent: e.lastComponent
			}), e.oldPos = o, s;
		},
		/*istanbul ignore start*/
		/*istanbul ignore end*/
		equals: function(e, t) {
			return this.options.comparator ? this.options.comparator(e, t) : e === t || this.options.ignoreCase && e.toLowerCase() === t.toLowerCase();
		},
		/*istanbul ignore start*/
		/*istanbul ignore end*/
		removeEmpty: function(e) {
			for (var t = [], n = 0; n < e.length; n++) e[n] && t.push(e[n]);
			return t;
		},
		/*istanbul ignore start*/
		/*istanbul ignore end*/
		castInput: function(e) {
			return e;
		},
		/*istanbul ignore start*/
		/*istanbul ignore end*/
		tokenize: function(e) {
			return e.split("");
		},
		/*istanbul ignore start*/
		/*istanbul ignore end*/
		join: function(e) {
			return e.join("");
		}
	};
	function n(e, t, n, r, i) {
		for (var a = [], o; t;) a.push(t), o = t.previousComponent, delete t.previousComponent, t = o;
		a.reverse();
		for (var s = 0, c = a.length, l = 0, u = 0; s < c; s++) {
			var d = a[s];
			if (!d.removed) {
				if (!d.added && i) {
					var f = n.slice(l, l + d.count);
					f = f.map(function(e, t) {
						var n = r[u + t];
						return n.length > e.length ? n : e;
					}), d.value = e.join(f);
				} else d.value = e.join(n.slice(l, l + d.count));
				l += d.count, d.added || (u += d.count);
			} else if (d.value = e.join(r.slice(u, u + d.count)), u += d.count, s && a[s - 1].added) {
				var p = a[s - 1];
				a[s - 1] = a[s], a[s] = p;
			}
		}
		var m = a[c - 1];
		return c > 1 && typeof m.value == "string" && (m.added || m.removed) && e.equals("", m.value) && (a[c - 2].value += m.value, a.pop()), a;
	}
})), uy = /* @__PURE__ */ ua(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.diffChars = i, e.characterDiff = void 0;
	/*istanbul ignore end*/
	var t = n(ly());
	/*istanbul ignore start*/ function n(e) {
		return e && e.__esModule ? e : { default: e };
	}
	/*istanbul ignore end*/
	var r = new t.default();
	/*istanbul ignore start*/
	e.characterDiff = r;
	/*istanbul ignore end*/
	function i(e, t, n) {
		return r.diff(e, t, n);
	}
})), dy = /* @__PURE__ */ ua(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.generateOptions = t;
	/*istanbul ignore end*/
	function t(e, t) {
		if (typeof e == "function") t.callback = e;
		else if (e) for (var n in e)
 /* istanbul ignore else */
		e.hasOwnProperty(n) && (t[n] = e[n]);
		return t;
	}
})), fy = /* @__PURE__ */ ua(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.diffWords = s, e.diffWordsWithSpace = c, e.wordDiff = void 0;
	/*istanbul ignore end*/
	var t = r(ly()), n = dy();
	/*istanbul ignore start*/ function r(e) {
		return e && e.__esModule ? e : { default: e };
	}
	/*istanbul ignore end*/
	var i = /^[A-Za-z\xC0-\u02C6\u02C8-\u02D7\u02DE-\u02FF\u1E00-\u1EFF]+$/, a = /\S/, o = new t.default();
	e.wordDiff = o, o.equals = function(e, t) {
		return this.options.ignoreCase && (e = e.toLowerCase(), t = t.toLowerCase()), e === t || this.options.ignoreWhitespace && !a.test(e) && !a.test(t);
	}, o.tokenize = function(e) {
		for (var t = e.split(/([^\S\r\n]+|[()[\]{}'"\r\n]|\b)/), n = 0; n < t.length - 1; n++) !t[n + 1] && t[n + 2] && i.test(t[n]) && i.test(t[n + 2]) && (t[n] += t[n + 2], t.splice(n + 1, 2), n--);
		return t;
	};
	function s(e, t, r) {
		return r = (0, n.generateOptions)(r, { ignoreWhitespace: !0 }), o.diff(e, t, r);
	}
	function c(e, t, n) {
		return o.diff(e, t, n);
	}
})), py = /* @__PURE__ */ ua(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.diffLines = a, e.diffTrimmedLines = o, e.lineDiff = void 0;
	/*istanbul ignore end*/
	var t = r(ly()), n = dy();
	/*istanbul ignore start*/ function r(e) {
		return e && e.__esModule ? e : { default: e };
	}
	/*istanbul ignore end*/
	var i = new t.default();
	/*istanbul ignore end*/
	e.lineDiff = i, i.tokenize = function(e) {
		this.options.stripTrailingCr && (e = e.replace(/\r\n/g, "\n"));
		var t = [], n = e.split(/(\n|\r\n)/);
		n[n.length - 1] || n.pop();
		for (var r = 0; r < n.length; r++) {
			var i = n[r];
			r % 2 && !this.options.newlineIsToken ? t[t.length - 1] += i : (this.options.ignoreWhitespace && (i = i.trim()), t.push(i));
		}
		return t;
	};
	function a(e, t, n) {
		return i.diff(e, t, n);
	}
	function o(e, t, r) {
		var a = (0, n.generateOptions)(r, { ignoreWhitespace: !0 });
		return i.diff(e, t, a);
	}
})), my = /* @__PURE__ */ ua(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.diffSentences = i, e.sentenceDiff = void 0;
	/*istanbul ignore end*/
	var t = n(ly());
	/*istanbul ignore start*/ function n(e) {
		return e && e.__esModule ? e : { default: e };
	}
	/*istanbul ignore end*/
	var r = new t.default();
	/*istanbul ignore end*/
	e.sentenceDiff = r, r.tokenize = function(e) {
		return e.split(/(\S.+?[.!?])(?=\s+|$)/);
	};
	function i(e, t, n) {
		return r.diff(e, t, n);
	}
})), hy = /* @__PURE__ */ ua(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.diffCss = i, e.cssDiff = void 0;
	/*istanbul ignore end*/
	var t = n(ly());
	/*istanbul ignore start*/ function n(e) {
		return e && e.__esModule ? e : { default: e };
	}
	/*istanbul ignore end*/
	var r = new t.default();
	/*istanbul ignore end*/
	e.cssDiff = r, r.tokenize = function(e) {
		return e.split(/([{}:;,]|\s+)/);
	};
	function i(e, t, n) {
		return r.diff(e, t, n);
	}
})), gy = /* @__PURE__ */ ua(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.diffJson = s, e.canonicalize = c, e.jsonDiff = void 0;
	/*istanbul ignore end*/
	var t = r(ly()), n = py();
	/*istanbul ignore start*/ function r(e) {
		return e && e.__esModule ? e : { default: e };
	}
	function i(e) {
		"@babel/helpers - typeof";
		return i = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
			return typeof e;
		} : function(e) {
			return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
		}, i(e);
	}
	/*istanbul ignore end*/
	var a = Object.prototype.toString, o = new t.default();
	e.jsonDiff = o, o.useLongestToken = !0, o.tokenize = n.lineDiff.tokenize, o.castInput = function(e) {
		/*istanbul ignore start*/
		var t = this.options, n = t.undefinedReplacement, r = t.stringifyReplacer, i = r === void 0 ? function(e, t) {
			return t === void 0 ? n : t;
		} : r;
		return typeof e == "string" ? e : JSON.stringify(c(e, null, null, i), i, "  ");
	}, o.equals = function(e, n) {
		return t.default.prototype.equals.call(o, e.replace(/,([\r\n])/g, "$1"), n.replace(/,([\r\n])/g, "$1"));
	};
	function s(e, t, n) {
		return o.diff(e, t, n);
	}
	function c(e, t, n, r, o) {
		t ||= [], n ||= [], r && (e = r(o, e));
		var s;
		for (s = 0; s < t.length; s += 1) if (t[s] === e) return n[s];
		var l;
		if (a.call(e) === "[object Array]") {
			for (t.push(e), l = Array(e.length), n.push(l), s = 0; s < e.length; s += 1) l[s] = c(e[s], t, n, r, o);
			return t.pop(), n.pop(), l;
		}
		if (e && e.toJSON && (e = e.toJSON()), i(
			/*istanbul ignore end*/
			e
		) === "object" && e !== null) {
			t.push(e), l = {}, n.push(l);
			var u = [], d;
			for (d in e)
 /* istanbul ignore else */
			e.hasOwnProperty(d) && u.push(d);
			for (u.sort(), s = 0; s < u.length; s += 1) d = u[s], l[d] = c(e[d], t, n, r, d);
			t.pop(), n.pop();
		} else l = e;
		return l;
	}
})), _y = /* @__PURE__ */ ua(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.diffArrays = i, e.arrayDiff = void 0;
	/*istanbul ignore end*/
	var t = n(ly());
	/*istanbul ignore start*/ function n(e) {
		return e && e.__esModule ? e : { default: e };
	}
	/*istanbul ignore end*/
	var r = new t.default();
	e.arrayDiff = r, r.tokenize = function(e) {
		return e.slice();
	}, r.join = r.removeEmpty = function(e) {
		return e;
	};
	function i(e, t, n) {
		return r.diff(e, t, n);
	}
})), vy = /* @__PURE__ */ ua(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.parsePatch = t;
	/*istanbul ignore end*/
	function t(e) {
		/*istanbul ignore start*/
		var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = e.split(/\r\n|[\n\v\f\r\x85]/), r = e.match(/\r\n|[\n\v\f\r\x85]/g) || [], i = [], a = 0;
		function o() {
			var e = {};
			for (i.push(e); a < n.length;) {
				var r = n[a];
				if (/^(\-\-\-|\+\+\+|@@)\s/.test(r)) break;
				var o = /^(?:Index:|diff(?: -r \w+)+)\s+(.+?)\s*$/.exec(r);
				o && (e.index = o[1]), a++;
			}
			for (s(e), s(e), e.hunks = []; a < n.length;) {
				var l = n[a];
				if (/^(Index:|diff|\-\-\-|\+\+\+)\s/.test(l)) break;
				if (/^@@/.test(l)) e.hunks.push(c());
				else if (l && t.strict) throw Error("Unknown line " + (a + 1) + " " + JSON.stringify(l));
				else a++;
			}
		}
		function s(e) {
			var t = /^(---|\+\+\+)\s+(.*)$/.exec(n[a]);
			if (t) {
				var r = t[1] === "---" ? "old" : "new", i = t[2].split("	", 2), o = i[0].replace(/\\\\/g, "\\");
				/^".*"$/.test(o) && (o = o.substr(1, o.length - 2)), e[r + "FileName"] = o, e[r + "Header"] = (i[1] || "").trim(), a++;
			}
		}
		function c() {
			var e = a, i = n[a++].split(/@@ -(\d+)(?:,(\d+))? \+(\d+)(?:,(\d+))? @@/), o = {
				oldStart: +i[1],
				oldLines: i[2] === void 0 ? 1 : +i[2],
				newStart: +i[3],
				newLines: i[4] === void 0 ? 1 : +i[4],
				lines: [],
				linedelimiters: []
			};
			o.oldLines === 0 && (o.oldStart += 1), o.newLines === 0 && (o.newStart += 1);
			for (var s = 0, c = 0; a < n.length && !(n[a].indexOf("--- ") === 0 && a + 2 < n.length && n[a + 1].indexOf("+++ ") === 0 && n[a + 2].indexOf("@@") === 0); a++) {
				var l = n[a].length == 0 && a != n.length - 1 ? " " : n[a][0];
				if (l === "+" || l === "-" || l === " " || l === "\\") o.lines.push(n[a]), o.linedelimiters.push(r[a] || "\n"), l === "+" ? s++ : l === "-" ? c++ : l === " " && (s++, c++);
				else break;
			}
			if (!s && o.newLines === 1 && (o.newLines = 0), !c && o.oldLines === 1 && (o.oldLines = 0), t.strict) {
				if (s !== o.newLines) throw Error("Added line count did not match for hunk at line " + (e + 1));
				if (c !== o.oldLines) throw Error("Removed line count did not match for hunk at line " + (e + 1));
			}
			return o;
		}
		for (; a < n.length;) o();
		return i;
	}
})), yy = /* @__PURE__ */ ua(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.default = t;
	/*istanbul ignore end*/
	function t(e, t, n) {
		var r = !0, i = !1, a = !1, o = 1;
		return function s() {
			if (r && !a) {
				if (i ? o++ : r = !1, e + o <= n) return o;
				a = !0;
			}
			if (!i) return a || (r = !0), t <= e - o ? -o++ : (i = !0, s());
		};
	}
})), by = /* @__PURE__ */ ua(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.applyPatch = i, e.applyPatches = a;
	/*istanbul ignore end*/
	var t = vy(), n = r(yy());
	/*istanbul ignore start*/ function r(e) {
		return e && e.__esModule ? e : { default: e };
	}
	/*istanbul ignore end*/
	function i(e, r) {
		/*istanbul ignore start*/
		var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
		if (typeof r == "string" && (r = (0, t.parsePatch)(r)), Array.isArray(r)) {
			if (r.length > 1) throw Error("applyPatch only works with a single input.");
			r = r[0];
		}
		var a = e.split(/\r\n|[\n\v\f\r\x85]/), o = e.match(/\r\n|[\n\v\f\r\x85]/g) || [], s = r.hunks, c = i.compareLine || function(e, t, n, r) {
			return t === r;
		}, l = 0, u = i.fuzzFactor || 0, d = 0, f = 0, p, m;
		function h(e, t) {
			for (var n = 0; n < e.lines.length; n++) {
				var r = e.lines[n], i = r.length > 0 ? r[0] : " ", o = r.length > 0 ? r.substr(1) : r;
				if (i === " " || i === "-") {
					if (!c(t + 1, a[t], i, o) && (l++, l > u)) return !1;
					t++;
				}
			}
			return !0;
		}
		for (var g = 0; g < s.length; g++) {
			for (var _ = s[g], v = a.length - _.oldLines, y = 0, b = f + _.oldStart - 1, x = (0, n.default)(b, d, v); y !== void 0; y = x()) if (h(_, b + y)) {
				_.offset = f += y;
				break;
			}
			if (y === void 0) return !1;
			d = _.offset + _.oldStart + _.oldLines;
		}
		for (var S = 0, C = 0; C < s.length; C++) {
			var w = s[C], T = w.oldStart + w.offset + S - 1;
			S += w.newLines - w.oldLines;
			for (var E = 0; E < w.lines.length; E++) {
				var D = w.lines[E], O = D.length > 0 ? D[0] : " ", k = D.length > 0 ? D.substr(1) : D, A = w.linedelimiters && w.linedelimiters[E] || "\n";
				if (O === " ") T++;
				else if (O === "-") a.splice(T, 1), o.splice(T, 1);
				else if (O === "+") a.splice(T, 0, k), o.splice(T, 0, A), T++;
				else if (O === "\\") {
					var j = w.lines[E - 1] ? w.lines[E - 1][0] : null;
					j === "+" ? p = !0 : j === "-" && (m = !0);
				}
			}
		}
		if (p) for (; !a[a.length - 1];) a.pop(), o.pop();
		else m && (a.push(""), o.push("\n"));
		for (var M = 0; M < a.length - 1; M++) a[M] = a[M] + o[M];
		return a.join("");
	}
	function a(e, n) {
		typeof e == "string" && (e = (0, t.parsePatch)(e));
		var r = 0;
		function a() {
			var t = e[r++];
			if (!t) return n.complete();
			n.loadFile(t, function(e, r) {
				if (e) return n.complete(e);
				var o = i(r, t, n);
				n.patched(t, o, function(e) {
					if (e) return n.complete(e);
					a();
				});
			});
		}
		a();
	}
})), xy = /* @__PURE__ */ ua(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.structuredPatch = c, e.formatPatch = l, e.createTwoFilesPatch = u, e.createPatch = d;
	/*istanbul ignore end*/
	var t = py();
	/*istanbul ignore start*/ function n(e) {
		return o(e) || a(e) || i(e) || r();
	}
	function r() {
		throw TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	function i(e, t) {
		if (e) {
			if (typeof e == "string") return s(e, t);
			var n = Object.prototype.toString.call(e).slice(8, -1);
			if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
			if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return s(e, t);
		}
	}
	function a(e) {
		if (typeof Symbol < "u" && Symbol.iterator in Object(e)) return Array.from(e);
	}
	function o(e) {
		if (Array.isArray(e)) return s(e);
	}
	function s(e, t) {
		(t == null || t > e.length) && (t = e.length);
		for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
		return r;
	}
	/*istanbul ignore end*/
	function c(e, r, i, a, o, s, c) {
		c ||= {}, c.context === void 0 && (c.context = 4);
		var l = (0, t.diffLines)(i, a, c);
		if (!l) return;
		l.push({
			value: "",
			lines: []
		});
		function u(e) {
			return e.map(function(e) {
				return " " + e;
			});
		}
		for (var d = [], f = 0, p = 0, m = [], h = 1, g = 1, _ = function(e) {
			var t = l[e], r = t.lines || t.value.replace(/\n$/, "").split("\n");
			if (t.lines = r, t.added || t.removed) {
				/*istanbul ignore start*/
				var o;
				/*istanbul ignore end*/
				if (!f) {
					var s = l[e - 1];
					f = h, p = g, s && (m = c.context > 0 ? u(s.lines.slice(-c.context)) : [], f -= m.length, p -= m.length);
				}
				(o = m).push.apply(
					/*istanbul ignore start*/
					o,
					/*istanbul ignore start*/
					n(
						/*istanbul ignore end*/
						r.map(function(e) {
							return (t.added ? "+" : "-") + e;
						})
					)
				), t.added ? g += r.length : h += r.length;
			} else {
				if (f) {
					if (r.length <= c.context * 2 && e < l.length - 2) {
						/*istanbul ignore start*/
						var _;
						/*istanbul ignore end*/
						/*istanbul ignore start*/
						/*istanbul ignore end*/
						/*istanbul ignore start*/
						(_ = m).push.apply(
							/*istanbul ignore start*/
							_,
							/*istanbul ignore start*/
							n(
								/*istanbul ignore end*/
								u(r)
							)
						);
					} else {
						/*istanbul ignore start*/
						var v, y = Math.min(r.length, c.context);
						/*istanbul ignore start*/
						/*istanbul ignore end*/
						/*istanbul ignore start*/
						(v = m).push.apply(
							/*istanbul ignore start*/
							v,
							/*istanbul ignore start*/
							n(
								/*istanbul ignore end*/
								u(r.slice(0, y))
							)
						);
						var b = {
							oldStart: f,
							oldLines: h - f + y,
							newStart: p,
							newLines: g - p + y,
							lines: m
						};
						if (e >= l.length - 2 && r.length <= c.context) {
							var x = /\n$/.test(i), S = /\n$/.test(a), C = r.length == 0 && m.length > b.oldLines;
							!x && C && i.length > 0 && m.splice(b.oldLines, 0, "\\ No newline at end of file"), (!x && !C || !S) && m.push("\\ No newline at end of file");
						}
						d.push(b), f = 0, p = 0, m = [];
					}
				}
				h += r.length, g += r.length;
			}
		}, v = 0; v < l.length; v++)
 /*istanbul ignore start*/
		_(
			/*istanbul ignore end*/
			v
		);
		return {
			oldFileName: e,
			newFileName: r,
			oldHeader: o,
			newHeader: s,
			hunks: d
		};
	}
	function l(e) {
		if (Array.isArray(e)) return e.map(l).join("\n");
		var t = [];
		e.oldFileName == e.newFileName && t.push("Index: " + e.oldFileName), t.push("==================================================================="), t.push("--- " + e.oldFileName + (e.oldHeader === void 0 ? "" : "	" + e.oldHeader)), t.push("+++ " + e.newFileName + (e.newHeader === void 0 ? "" : "	" + e.newHeader));
		for (var n = 0; n < e.hunks.length; n++) {
			var r = e.hunks[n];
			r.oldLines === 0 && --r.oldStart, r.newLines === 0 && --r.newStart, t.push("@@ -" + r.oldStart + "," + r.oldLines + " +" + r.newStart + "," + r.newLines + " @@"), t.push.apply(t, r.lines);
		}
		return t.join("\n") + "\n";
	}
	function u(e, t, n, r, i, a, o) {
		return l(c(e, t, n, r, i, a, o));
	}
	function d(e, t, n, r, i, a) {
		return u(e, e, t, n, r, i, a);
	}
})), Sy = /* @__PURE__ */ ua(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.arrayEqual = t, e.arrayStartsWith = n;
	/*istanbul ignore end*/
	function t(e, t) {
		return e.length === t.length && n(e, t);
	}
	function n(e, t) {
		if (t.length > e.length) return !1;
		for (var n = 0; n < t.length; n++) if (t[n] !== e[n]) return !1;
		return !0;
	}
})), Cy = /* @__PURE__ */ ua(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.calcLineCount = u, e.merge = d;
	/*istanbul ignore end*/
	var t = xy(), n = vy(), r = Sy();
	/*istanbul ignore start*/ function i(e) {
		return c(e) || s(e) || o(e) || a();
	}
	function a() {
		throw TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	function o(e, t) {
		if (e) {
			if (typeof e == "string") return l(e, t);
			var n = Object.prototype.toString.call(e).slice(8, -1);
			if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
			if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return l(e, t);
		}
	}
	function s(e) {
		if (typeof Symbol < "u" && Symbol.iterator in Object(e)) return Array.from(e);
	}
	function c(e) {
		if (Array.isArray(e)) return l(e);
	}
	function l(e, t) {
		(t == null || t > e.length) && (t = e.length);
		for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
		return r;
	}
	/*istanbul ignore end*/
	function u(e) {
		/*istanbul ignore start*/
		var t = D(e.lines), n = t.oldLines, r = t.newLines;
		n === void 0 ? delete e.oldLines : e.oldLines = n, r === void 0 ? delete e.newLines : e.newLines = r;
	}
	function d(e, t, n) {
		e = f(e, n), t = f(t, n);
		var r = {};
		(e.index || t.index) && (r.index = e.index || t.index), (e.newFileName || t.newFileName) && (p(e) ? p(t) ? (r.oldFileName = m(r, e.oldFileName, t.oldFileName), r.newFileName = m(r, e.newFileName, t.newFileName), r.oldHeader = m(r, e.oldHeader, t.oldHeader), r.newHeader = m(r, e.newHeader, t.newHeader)) : (r.oldFileName = e.oldFileName, r.newFileName = e.newFileName, r.oldHeader = e.oldHeader, r.newHeader = e.newHeader) : (r.oldFileName = t.oldFileName || e.oldFileName, r.newFileName = t.newFileName || e.newFileName, r.oldHeader = t.oldHeader || e.oldHeader, r.newHeader = t.newHeader || e.newHeader)), r.hunks = [];
		for (var i = 0, a = 0, o = 0, s = 0; i < e.hunks.length || a < t.hunks.length;) {
			var c = e.hunks[i] || { oldStart: Infinity }, l = t.hunks[a] || { oldStart: Infinity };
			if (h(c, l)) r.hunks.push(g(c, o)), i++, s += c.newLines - c.oldLines;
			else if (h(l, c)) r.hunks.push(g(l, s)), a++, o += l.newLines - l.oldLines;
			else {
				var u = {
					oldStart: Math.min(c.oldStart, l.oldStart),
					oldLines: 0,
					newStart: Math.min(c.newStart + o, l.oldStart + s),
					newLines: 0,
					lines: []
				};
				_(u, c.oldStart, c.lines, l.oldStart, l.lines), a++, i++, r.hunks.push(u);
			}
		}
		return r;
	}
	function f(e, r) {
		if (typeof e == "string") {
			if (/^@@/m.test(e) || /^Index:/m.test(e)) return (0, n.parsePatch)(e)[0];
			if (!r) throw Error("Must provide a base reference or pass in a patch");
			return (0, t.structuredPatch)(void 0, void 0, r, e);
		}
		return e;
	}
	function p(e) {
		return e.newFileName && e.newFileName !== e.oldFileName;
	}
	function m(e, t, n) {
		return t === n ? t : (e.conflict = !0, {
			mine: t,
			theirs: n
		});
	}
	function h(e, t) {
		return e.oldStart < t.oldStart && e.oldStart + e.oldLines < t.oldStart;
	}
	function g(e, t) {
		return {
			oldStart: e.oldStart,
			oldLines: e.oldLines,
			newStart: e.newStart + t,
			newLines: e.newLines,
			lines: e.lines
		};
	}
	function _(e, t, n, r, a) {
		var o = {
			offset: t,
			lines: n,
			index: 0
		}, s = {
			offset: r,
			lines: a,
			index: 0
		};
		for (x(e, o, s), x(e, s, o); o.index < o.lines.length && s.index < s.lines.length;) {
			var c = o.lines[o.index], l = s.lines[s.index];
			if ((c[0] === "-" || c[0] === "+") && (l[0] === "-" || l[0] === "+")) v(e, o, s);
			else if (c[0] === "+" && l[0] === " ") {
				/*istanbul ignore start*/
				var d;
				/*istanbul ignore end*/
				/*istanbul ignore start*/
				/*istanbul ignore end*/
				/*istanbul ignore start*/
				(d = e.lines).push.apply(
					/*istanbul ignore start*/
					d,
					/*istanbul ignore start*/
					i(
						/*istanbul ignore end*/
						C(o)
					)
				);
			} else if (l[0] === "+" && c[0] === " ") {
				/*istanbul ignore start*/
				var f;
				/*istanbul ignore end*/
				/*istanbul ignore start*/
				/*istanbul ignore end*/
				/*istanbul ignore start*/
				(f = e.lines).push.apply(
					/*istanbul ignore start*/
					f,
					/*istanbul ignore start*/
					i(
						/*istanbul ignore end*/
						C(s)
					)
				);
			} else c[0] === "-" && l[0] === " " ? y(e, o, s) : l[0] === "-" && c[0] === " " ? y(e, s, o, !0) : c === l ? (e.lines.push(c), o.index++, s.index++) : b(e, C(o), C(s));
		}
		S(e, o), S(e, s), u(e);
	}
	function v(e, t, n) {
		var a = C(t), o = C(n);
		if (T(a) && T(o)) {
			if ((0, r.arrayStartsWith)(a, o) && E(n, a, a.length - o.length)) {
				/*istanbul ignore start*/
				var s;
				/*istanbul ignore end*/
				/*istanbul ignore start*/
				/*istanbul ignore end*/
				/*istanbul ignore start*/
				(s = e.lines).push.apply(
					/*istanbul ignore start*/
					s,
					/*istanbul ignore start*/
					i(
						/*istanbul ignore end*/
						a
					)
				);
				return;
			}
			if ((0, r.arrayStartsWith)(o, a) && E(t, o, o.length - a.length)) {
				/*istanbul ignore start*/
				var c;
				/*istanbul ignore end*/
				/*istanbul ignore start*/
				/*istanbul ignore end*/
				/*istanbul ignore start*/
				(c = e.lines).push.apply(
					/*istanbul ignore start*/
					c,
					/*istanbul ignore start*/
					i(
						/*istanbul ignore end*/
						o
					)
				);
				return;
			}
		} else if ((0, r.arrayEqual)(a, o)) {
			/*istanbul ignore start*/
			var l;
			/*istanbul ignore end*/
			/*istanbul ignore start*/
			/*istanbul ignore end*/
			/*istanbul ignore start*/
			(l = e.lines).push.apply(
				/*istanbul ignore start*/
				l,
				/*istanbul ignore start*/
				i(
					/*istanbul ignore end*/
					a
				)
			);
			return;
		}
		b(e, a, o);
	}
	function y(e, t, n, r) {
		var a = C(t), o = w(n, a);
		if (o.merged) {
			/*istanbul ignore start*/
			var s;
			/*istanbul ignore end*/
			/*istanbul ignore start*/
			/*istanbul ignore end*/
			/*istanbul ignore start*/
			(s = e.lines).push.apply(
				/*istanbul ignore start*/
				s,
				/*istanbul ignore start*/
				i(
					/*istanbul ignore end*/
					o.merged
				)
			);
		} else b(e, r ? o : a, r ? a : o);
	}
	function b(e, t, n) {
		e.conflict = !0, e.lines.push({
			conflict: !0,
			mine: t,
			theirs: n
		});
	}
	function x(e, t, n) {
		for (; t.offset < n.offset && t.index < t.lines.length;) {
			var r = t.lines[t.index++];
			e.lines.push(r), t.offset++;
		}
	}
	function S(e, t) {
		for (; t.index < t.lines.length;) {
			var n = t.lines[t.index++];
			e.lines.push(n);
		}
	}
	function C(e) {
		for (var t = [], n = e.lines[e.index][0]; e.index < e.lines.length;) {
			var r = e.lines[e.index];
			if (n === "-" && r[0] === "+" && (n = "+"), n === r[0]) t.push(r), e.index++;
			else break;
		}
		return t;
	}
	function w(e, t) {
		for (var n = [], r = [], i = 0, a = !1, o = !1; i < t.length && e.index < e.lines.length;) {
			var s = e.lines[e.index], c = t[i];
			if (c[0] === "+") break;
			if (a ||= s[0] !== " ", r.push(c), i++, s[0] === "+") for (o = !0; s[0] === "+";) n.push(s), s = e.lines[++e.index];
			c.substr(1) === s.substr(1) ? (n.push(s), e.index++) : o = !0;
		}
		if ((t[i] || "")[0] === "+" && a && (o = !0), o) return n;
		for (; i < t.length;) r.push(t[i++]);
		return {
			merged: r,
			changes: n
		};
	}
	function T(e) {
		return e.reduce(function(e, t) {
			return e && t[0] === "-";
		}, !0);
	}
	function E(e, t, n) {
		for (var r = 0; r < n; r++) {
			var i = t[t.length - n + r].substr(1);
			if (e.lines[e.index + r] !== " " + i) return !1;
		}
		return e.index += n, !0;
	}
	function D(e) {
		var t = 0, n = 0;
		return e.forEach(function(e) {
			if (typeof e != "string") {
				var r = D(e.mine), i = D(e.theirs);
				t !== void 0 && (r.oldLines === i.oldLines ? t += r.oldLines : t = void 0), n !== void 0 && (r.newLines === i.newLines ? n += r.newLines : n = void 0);
			} else n !== void 0 && (e[0] === "+" || e[0] === " ") && n++, t !== void 0 && (e[0] === "-" || e[0] === " ") && t++;
		}), {
			oldLines: t,
			newLines: n
		};
	}
})), wy = /* @__PURE__ */ ua(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.reversePatch = i;
	function t(e, t) {
		var n = Object.keys(e);
		if (Object.getOwnPropertySymbols) {
			var r = Object.getOwnPropertySymbols(e);
			t && (r = r.filter(function(t) {
				return Object.getOwnPropertyDescriptor(e, t).enumerable;
			})), n.push.apply(n, r);
		}
		return n;
	}
	function n(e) {
		for (var n = 1; n < arguments.length; n++) {
			var i = arguments[n] == null ? {} : arguments[n];
			n % 2 ? t(Object(i), !0).forEach(function(t) {
				r(e, t, i[t]);
			}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : t(Object(i)).forEach(function(t) {
				Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
			});
		}
		return e;
	}
	function r(e, t, n) {
		return t in e ? Object.defineProperty(e, t, {
			value: n,
			enumerable: !0,
			configurable: !0,
			writable: !0
		}) : e[t] = n, e;
	}
	/*istanbul ignore end*/
	function i(e) {
		return Array.isArray(e) ? e.map(i).reverse() : n(n(
			{},
			/*istanbul ignore end*/
			e
		), {}, {
			oldFileName: e.newFileName,
			oldHeader: e.newHeader,
			newFileName: e.oldFileName,
			newHeader: e.oldHeader,
			hunks: e.hunks.map(function(e) {
				return {
					oldLines: e.newLines,
					oldStart: e.newStart,
					newLines: e.oldLines,
					newStart: e.oldStart,
					linedelimiters: e.linedelimiters,
					lines: e.lines.map(function(e) {
						return e.startsWith("-") ? `+${
						/*istanbul ignore end*/
						e.slice(1)}` : e.startsWith("+") ? `-${
						/*istanbul ignore end*/
						e.slice(1)}` : e;
					})
				};
			})
		});
	}
})), Ty = /* @__PURE__ */ ua(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.convertChangesToDMP = t;
	/*istanbul ignore end*/
	function t(e) {
		for (var t = [], n, r, i = 0; i < e.length; i++) n = e[i], r = n.added ? 1 : n.removed ? -1 : 0, t.push([r, n.value]);
		return t;
	}
})), Ey = /* @__PURE__ */ ua(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.convertChangesToXML = t;
	/*istanbul ignore end*/
	function t(e) {
		for (var t = [], r = 0; r < e.length; r++) {
			var i = e[r];
			i.added ? t.push("<ins>") : i.removed && t.push("<del>"), t.push(n(i.value)), i.added ? t.push("</ins>") : i.removed && t.push("</del>");
		}
		return t.join("");
	}
	function n(e) {
		var t = e;
		return t = t.replace(/&/g, "&amp;"), t = t.replace(/</g, "&lt;"), t = t.replace(/>/g, "&gt;"), t = t.replace(/"/g, "&quot;"), t;
	}
})), Dy = /* @__PURE__ */ ua(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), Object.defineProperty(e, "Diff", {
		enumerable: !0,
		get: function() {
			return t.default;
		}
	}), Object.defineProperty(e, "diffChars", {
		enumerable: !0,
		get: function() {
			return n.diffChars;
		}
	}), Object.defineProperty(e, "diffWords", {
		enumerable: !0,
		get: function() {
			return r.diffWords;
		}
	}), Object.defineProperty(e, "diffWordsWithSpace", {
		enumerable: !0,
		get: function() {
			return r.diffWordsWithSpace;
		}
	}), Object.defineProperty(e, "diffLines", {
		enumerable: !0,
		get: function() {
			return i.diffLines;
		}
	}), Object.defineProperty(e, "diffTrimmedLines", {
		enumerable: !0,
		get: function() {
			return i.diffTrimmedLines;
		}
	}), Object.defineProperty(e, "diffSentences", {
		enumerable: !0,
		get: function() {
			return a.diffSentences;
		}
	}), Object.defineProperty(e, "diffCss", {
		enumerable: !0,
		get: function() {
			return o.diffCss;
		}
	}), Object.defineProperty(e, "diffJson", {
		enumerable: !0,
		get: function() {
			return s.diffJson;
		}
	}), Object.defineProperty(e, "canonicalize", {
		enumerable: !0,
		get: function() {
			return s.canonicalize;
		}
	}), Object.defineProperty(e, "diffArrays", {
		enumerable: !0,
		get: function() {
			return c.diffArrays;
		}
	}), Object.defineProperty(e, "applyPatch", {
		enumerable: !0,
		get: function() {
			return l.applyPatch;
		}
	}), Object.defineProperty(e, "applyPatches", {
		enumerable: !0,
		get: function() {
			return l.applyPatches;
		}
	}), Object.defineProperty(e, "parsePatch", {
		enumerable: !0,
		get: function() {
			return u.parsePatch;
		}
	}), Object.defineProperty(e, "merge", {
		enumerable: !0,
		get: function() {
			return d.merge;
		}
	}), Object.defineProperty(e, "reversePatch", {
		enumerable: !0,
		get: function() {
			return f.reversePatch;
		}
	}), Object.defineProperty(e, "structuredPatch", {
		enumerable: !0,
		get: function() {
			return p.structuredPatch;
		}
	}), Object.defineProperty(e, "createTwoFilesPatch", {
		enumerable: !0,
		get: function() {
			return p.createTwoFilesPatch;
		}
	}), Object.defineProperty(e, "createPatch", {
		enumerable: !0,
		get: function() {
			return p.createPatch;
		}
	}), Object.defineProperty(e, "formatPatch", {
		enumerable: !0,
		get: function() {
			return p.formatPatch;
		}
	}), Object.defineProperty(e, "convertChangesToDMP", {
		enumerable: !0,
		get: function() {
			return m.convertChangesToDMP;
		}
	}), Object.defineProperty(e, "convertChangesToXML", {
		enumerable: !0,
		get: function() {
			return h.convertChangesToXML;
		}
	});
	/*istanbul ignore end*/
	var t = g(ly()), n = uy(), r = fy(), i = py(), a = my(), o = hy(), s = gy(), c = _y(), l = by(), u = vy(), d = Cy(), f = wy(), p = xy(), m = Ty(), h = Ey();
	/*istanbul ignore start*/ function g(e) {
		return e && e.__esModule ? e : { default: e };
	}
})), Oy = /* @__PURE__ */ ua(((e) => {
	function t(e, t) {
		let n = 0;
		for (let o = 0; o < e.length; o++) switch (e[o].type) {
			case i:
				n += t[0];
				break;
			case r:
				n += t[1];
				break;
			case a:
				n++;
				break;
			default: throw Error("unknown change type: " + e[o].type);
		}
		return n;
	}
	function n(e, t, n) {
		this.changes = n, this.aoff = e, this.boff = t, this._alen = -1, this._blen = -1;
	}
	Object.defineProperty(n.prototype, "alen", { get: function() {
		return this._alen === -1 ? this._alen = t(this.changes, [1, 0]) : this._alen;
	} }), Object.defineProperty(n.prototype, "blen", { get: function() {
		return this._blen === -1 ? this._blen = t(this.changes, [0, 1]) : this._blen;
	} }), n.prototype.unified = function() {
		let e = [this.unifiedHeader()];
		return this.changes.forEach(function(t) {
			e.push(t.unified());
		}), e.join("\n");
	}, n.prototype.unifiedHeader = function() {
		let e = this.alen === 1 ? "" : "," + this.alen, t = this.blen === 1 ? "" : "," + this.blen, n = this.alen === 0 ? 0 : 1, r = this.blen === 0 ? 0 : 1;
		return "@@ -" + (this.aoff + n) + e + " +" + (this.boff + r) + t + " @@";
	}, n.prototype.shorthand = function() {
		return this.changes.reduce(function(e, t) {
			return e + t.type;
		}, "");
	}, n.prototype.toString = function() {
		return "{" + this.shorthand() + "} " + this.unifiedHeader();
	};
	var r = "+", i = "-", a = "s";
	function o(e) {
		return e === "s" ? " " : e;
	}
	function s(e, t) {
		this.type = e, this.text = t;
	}
	s.prototype.unified = function() {
		return o(this.type) + this.text;
	}, s.prototype.toString = function() {
		return this.unified();
	};
	function c(e, t) {
		t ||= 60;
		let n = e.count + ": " + o(e.type), r = Math.min(t - n.length, e.value.length - 1);
		return n + (e.value.substring(0, r).replace(/\n/g, ",") + (e.value.length > r + 1 ? "..." : ""));
	}
	function l(e, t) {
		if (t === 0) return [];
		let n = [], r = e.value;
		if (t === void 0) n = r.split("\n"), n[n.length - 1] || n.pop();
		else if (t > 0) {
			let e = p(r, "\n", 0, t, !1);
			n = r.substring(0, e).split("\n");
		} else {
			let e = r[r.length - 1] === "\n" ? r.length - 1 : r.length, i = p(r, "\n", e - 1, -t, !0);
			n = r.substring(i + 1, e).split("\n");
		}
		return n.map(function(t) {
			return new s(e.type, t);
		});
	}
	function u(e) {
		return "{" + e.reduce(function(e, t) {
			for (let n = 0; n < t.count; n++) e += t.type;
			return e;
		}, "") + "}";
	}
	function d(e, t) {
		return Array.prototype.push.apply(t, e), t;
	}
	function f(e, t, r) {
		let i = [], o = [], s = 0;
		function c() {
			if (o.length) {
				let e = s, t = s;
				if (i.length) {
					let n = i[i.length - 1];
					e += n.aoff + n.alen, t += n.boff + n.blen;
				}
				i.push(new n(e, t, o)), o = [], s = 0;
			}
		}
		for (let n = 0; n < e.length; n++) {
			let i = e[n];
			if (i.type === a) {
				let a = n > 0 ? r : 0, u = n < e.length - 1 ? t : 0, f = Math.max(i.count - (a + u), 0);
				f > 0 ? (d(l(i, a), o), c(), d(l(i, -u), o), s = f) : d(l(i), o);
			} else d(l(i), o);
		}
		return c(), i;
	}
	function p(e, t, n, r, i) {
		let a = i ? -1 : 1;
		n -= a;
		for (let o = 0; o < r; o++) n = i ? e.lastIndexOf(t, n + a) : e.indexOf(t, n + a);
		return n;
	}
	e.hunk = function(e, t, r) {
		return new n(e, t, r);
	}, e.linechange = function(e, t) {
		return new s(e, t);
	}, e.lineChanges = l, e.change2string = c, e.changes2shorthand = u, e.nthIndexOf = p, e.makeHunks = f, e.ADDED = r, e.REMOVED = i, e.UNMODIFIED = a;
})), ky = (/* @__PURE__ */ ua(((e) => {
	var t = Dy(), n = Oy();
	function r(e) {
		return e.added ? n.ADDED : e.removed ? n.REMOVED : n.UNMODIFIED;
	}
	function i(e) {
		return e.length === 0 ? [] : (e[0].type = r(e[0]), e.reduce(function(e, t, n) {
			if (t.type = r(t), e.type === t.type) throw Error("repeating change types are not handled: " + e.type + " (at " + (n - 1) + " and " + n + ")");
			return t;
		}));
	}
	function a(e, t) {
		i(e), t ||= {}, t.aname = t.aname || "a", t.bname = t.bname || "b";
		let r = t.context || t.context === 0 ? t.context : 0;
		t.pre_context = t.pre_context || t.pre_context === 0 ? t.pre_context : r, t.post_context = t.post_context || t.post_context === 0 ? t.post_context : r;
		let a = n.makeHunks(e, t.pre_context, t.post_context);
		if (a.length) {
			let e = [];
			return e.push("--- " + t.aname), e.push("+++ " + t.bname), a.forEach(function(t) {
				e.push(t.unified());
			}), e.join("\n");
		}
		return "";
	}
	function o(e, n, r) {
		e = Array.isArray(e) ? e.join("\n") + "\n" : e, n = Array.isArray(n) ? n.join("\n") + "\n" : n;
		let i = t.diffLines(e, n, r);
		return i.length === 1 && !i[0].added && !i[0].removed ? [] : i;
	}
	function s(e, t, n) {
		return a(o(e, t), n);
	}
	function c(e, t, n, r, i) {
		i ||= console.log, n = n.ok || n;
		let a = s(e, t, {
			context: 3,
			aname: r + " (actual)",
			bname: r + " (expected)"
		});
		n(!a, r), a && a.split("\n").forEach(function(e) {
			i("  " + e);
		});
	}
	e.assertEqual = c, e.diffAsText = s, e.formatLines = a, e.diffLines = o, Object.keys(t).forEach(function(n) {
		e[n] || (e[n] = t[n]);
	});
})))();
function Ay(e) {
	let t = K(12), { newStr: n, oldStr: r, context: i } = e, a = i === void 0 ? 3 : i, o;
	bb0: {
		if (!n || !r) {
			o = null;
			break bb0;
		}
		let e;
		t[0] !== a || t[1] !== n || t[2] !== r ? (e = (0, ky.formatLines)((0, ky.diffLines)(r, n), { context: a }), t[0] = a, t[1] = n, t[2] = r, t[3] = e) : e = t[3], o = e;
	}
	let s = o;
	if (!s) return null;
	let c, l, u;
	if (t[4] !== s) {
		let e = lh(s), n = jy;
		c = vu, l = "text-mono-medium", u = e.map(n), t[4] = s, t[5] = c, t[6] = l, t[7] = u;
	} else c = t[5], l = t[6], u = t[7];
	let d;
	return t[8] !== c || t[9] !== l || t[10] !== u ? (d = /* @__PURE__ */ Y(c, {
		className: l,
		children: u
	}), t[8] = c, t[9] = l, t[10] = u, t[11] = d) : d = t[11], d;
}
function jy(e) {
	let { oldRevision: t, newRevision: n, type: r, hunks: i } = e;
	return /* @__PURE__ */ Y(oy, {
		diffType: r,
		hunks: i,
		viewType: "unified",
		children: My
	}, t + "-" + n);
}
function My(e) {
	return e.map(Ny);
}
function Ny(e) {
	return /* @__PURE__ */ Y(ty, { hunk: e }, e.content);
}
//#endregion
//#region lib/components/Divider/Divider.tsx
var Py = G({
	base: "border-0 border-solid",
	variants: {
		orientation: {
			horizontal: "w-full",
			vertical: "h-full"
		},
		size: {
			s: "",
			l: "",
			xl: ""
		},
		variant: {
			normal: "border-outline-decorative",
			decorative: "border-outline-brand rounded-xs"
		}
	},
	compoundVariants: [
		{
			orientation: "horizontal",
			size: "s",
			class: "h-px border-t"
		},
		{
			orientation: "horizontal",
			size: "l",
			class: "h-0.5 border-t-2"
		},
		{
			orientation: "horizontal",
			size: "xl",
			class: "h-1 border-t-4"
		},
		{
			orientation: "vertical",
			size: "s",
			class: "w-px border-l"
		},
		{
			orientation: "vertical",
			size: "l",
			class: "w-0.5 border-l-2"
		},
		{
			orientation: "vertical",
			size: "xl",
			class: "w-1 border-l-4"
		}
	],
	defaultVariants: {
		orientation: "horizontal",
		size: "s",
		variant: "normal"
	}
});
function Fy(e) {
	let t = K(7), { orientation: n, size: r, className: i, variant: a } = e, o = n === void 0 ? "horizontal" : n, s = r === void 0 ? "s" : r, c = a === void 0 ? "normal" : a, l;
	t[0] !== i || t[1] !== o || t[2] !== s || t[3] !== c ? (l = Py({
		orientation: o,
		size: s,
		variant: c,
		class: i
	}), t[0] = i, t[1] = o, t[2] = s, t[3] = c, t[4] = l) : l = t[4];
	let u;
	return t[5] === l ? u = t[6] : (u = /* @__PURE__ */ Y("hr", { className: l }), t[5] = l, t[6] = u), u;
}
//#endregion
//#region lib/components/EmptyState/EmptyState.tsx
function Iy(e) {
	let t = K(23), { message: n, title: r, children: i, className: a } = e;
	if (r) {
		let e;
		t[0] === a ? e = t[1] : (e = W("flex h-[300px] w-1/2 flex-col items-center justify-center bg-background-primary", a), t[0] = a, t[1] = e);
		let o;
		t[2] === r ? o = t[3] : (o = /* @__PURE__ */ Y("div", {
			className: "mb-3",
			children: /* @__PURE__ */ Y("h3", {
				className: "text-center text-title-medium text-text-secondary",
				children: r
			})
		}), t[2] = r, t[3] = o);
		let s;
		t[4] === n ? s = t[5] : (s = /* @__PURE__ */ Y("p", {
			className: "text-center text-body-small text-text-secondary",
			children: n
		}), t[4] = n, t[5] = s);
		let c;
		t[6] === i ? c = t[7] : (c = i ? /* @__PURE__ */ Y("div", {
			className: "mt-6",
			children: i
		}) : null, t[6] = i, t[7] = c);
		let l;
		return t[8] !== e || t[9] !== o || t[10] !== s || t[11] !== c ? (l = /* @__PURE__ */ Y("div", {
			className: "mt-3 grow",
			children: /* @__PURE__ */ Y("div", {
				className: "mt-10 flex items-center justify-center",
				children: /* @__PURE__ */ X("div", {
					className: e,
					children: [
						o,
						s,
						c
					]
				})
			})
		}), t[8] = e, t[9] = o, t[10] = s, t[11] = c, t[12] = l) : l = t[12], l;
	}
	let o;
	t[13] === a ? o = t[14] : (o = W("flex min-h-full flex-col items-center justify-center bg-background-secondary p-2", a), t[13] = a, t[14] = o);
	let s;
	t[15] === n ? s = t[16] : (s = /* @__PURE__ */ Y("p", {
		className: "text-center text-body-small text-text-secondary",
		children: n
	}), t[15] = n, t[16] = s);
	let c;
	t[17] === i ? c = t[18] : (c = i ? /* @__PURE__ */ Y("div", {
		className: "mt-6",
		children: i
	}) : null, t[17] = i, t[18] = c);
	let l;
	return t[19] !== o || t[20] !== s || t[21] !== c ? (l = /* @__PURE__ */ Y("div", {
		className: "mt-3 grow",
		children: /* @__PURE__ */ X("div", {
			className: o,
			children: [s, c]
		})
	}), t[19] = o, t[20] = s, t[21] = c, t[22] = l) : l = t[22], l;
}
//#endregion
//#region lib/components/FormFooter/FormFooter.tsx
var Ly = {
	pending: "Changes Pending",
	unchanged: "No Changes",
	saved: "Changes Confirmed"
}, Ry = G({
	base: "whitespace-nowrap text-label-medium",
	variants: { status: {
		pending: "text-text-warning",
		unchanged: "text-text-secondary",
		saved: "text-text-positive"
	} }
});
function zy(e) {
	let t = K(13), { children: n, status: r, statusText: i, className: a } = e, o;
	t[0] === a ? o = t[1] : (o = W("sticky bottom-0 z-10 flex items-center justify-end gap-sm border-t border-background-tertiary bg-overlay-light px-xl py-lg", a), t[0] = a, t[1] = o);
	let s;
	t[2] !== r || t[3] !== i ? (s = r ? /* @__PURE__ */ Y("span", {
		className: Ry({ status: r }),
		children: i ?? Ly[r]
	}) : null, t[2] = r, t[3] = i, t[4] = s) : s = t[4];
	let c;
	t[5] === s ? c = t[6] : (c = /* @__PURE__ */ Y("span", {
		"aria-live": "polite",
		role: "status",
		children: s
	}), t[5] = s, t[6] = c);
	let l;
	t[7] === n ? l = t[8] : (l = /* @__PURE__ */ Y(gu, { children: n }), t[7] = n, t[8] = l);
	let u;
	return t[9] !== o || t[10] !== c || t[11] !== l ? (u = /* @__PURE__ */ X("div", {
		className: o,
		children: [c, l]
	}), t[9] = o, t[10] = c, t[11] = l, t[12] = u) : u = t[12], u;
}
//#endregion
//#region lib/components/Heading/Heading.tsx
var By = G({
	base: "",
	variants: { level: {
		1: "text-page-headline leading-[2rem]",
		2: "text-[1.25rem] font-bold leading-[2rem] tracking-normal",
		3: "text-title-medium",
		4: "text-title-small"
	} },
	defaultVariants: { level: 1 }
});
function Vy(e) {
	let t = K(13), n, r, i, a;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4]) : ({children: n, className: r, level: a, ...i} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a);
	let o = a === void 0 ? 1 : a, s = `h${o}`, c;
	t[5] !== r || t[6] !== o ? (c = By({
		level: o,
		class: r
	}), t[5] = r, t[6] = o, t[7] = c) : c = t[7];
	let l;
	return t[8] !== s || t[9] !== n || t[10] !== i || t[11] !== c ? (l = /* @__PURE__ */ Y(s, {
		className: c,
		...i,
		children: n
	}), t[8] = s, t[9] = n, t[10] = i, t[11] = c, t[12] = l) : l = t[12], l;
}
//#endregion
//#region lib/components/shared/MultiDropdownBase.tsx
var Hy = G({ base: "flex min-w-[12.5rem] flex-col gap-y-1 rounded-1 border border-outline-decorative bg-background-secondary px-1 py-2 shadow-md outline-none" }), Uy = G({ base: "pointer-events-none select-none p-3xs text-title-medium border-b border-outline-decorative mx-xs" });
function Wy(e) {
	let t = K(7), { item: n } = e;
	if (!n.assistiveText) return n.name;
	let r;
	t[0] === n.name ? r = t[1] : (r = /* @__PURE__ */ Y("span", {
		className: "block",
		children: n.name
	}), t[0] = n.name, t[1] = r);
	let i;
	t[2] === n.assistiveText ? i = t[3] : (i = /* @__PURE__ */ Y("span", {
		className: "block text-label-small text-text-secondary",
		children: n.assistiveText
	}), t[2] = n.assistiveText, t[3] = i);
	let a;
	return t[4] !== r || t[5] !== i ? (a = /* @__PURE__ */ X("span", { children: [r, i] }), t[4] = r, t[5] = i, t[6] = a) : a = t[6], a;
}
function Gy(e) {
	let t = K(8), n, r, i;
	t[0] === e ? (n = t[1], r = t[2], i = t[3]) : ({closeOnClick: r, variant: i, ...n} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i);
	let a = r ? "close" : void 0, o = i ?? "tertiary", s;
	return t[4] !== n || t[5] !== a || t[6] !== o ? (s = /* @__PURE__ */ Y(Q, {
		...n,
		slot: a,
		variant: o
	}), t[4] = n, t[5] = a, t[6] = o, t[7] = s) : s = t[7], s;
}
function Ky(e) {
	let t = K(10), { left: n, right: r, className: i } = e, a;
	t[0] === i ? a = t[1] : (a = W("flex items-center justify-between", i), t[0] = i, t[1] = a);
	let o;
	t[2] === n ? o = t[3] : (o = n ? /* @__PURE__ */ Y(Gy, { ...n }) : null, t[2] = n, t[3] = o);
	let s;
	t[4] === r ? s = t[5] : (s = r ? /* @__PURE__ */ Y(Gy, { ...r }) : null, t[4] = r, t[5] = s);
	let c;
	return t[6] !== a || t[7] !== o || t[8] !== s ? (c = /* @__PURE__ */ X("div", {
		className: a,
		children: [o, s]
	}), t[6] = a, t[7] = o, t[8] = s, t[9] = c) : c = t[9], c;
}
function qy(e) {
	let t = K(87), n, r, i, a, o, s, c, l, u, d, f, p, m, h, g, _, v, y, b, x;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4], o = t[5], s = t[6], c = t[7], l = t[8], u = t[9], d = t[10], f = t[11], p = t[12], m = t[13], h = t[14], g = t[15], _ = t[16], v = t[17], y = t[18], b = t[19], x = t[20]) : ({trigger: x, placement: v, label: u, value: i, defaultValue: a, className: r, onChange: p, options: h, topCTA: b, bottomCTA: n, onSearch: m, searchPlaceholder: y, searchValue: _, matchTriggerWidth: f, loadMore: d, hasMore: s, isLoadingMore: c, isPending: l, renderItem: g, ...o} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a, t[5] = o, t[6] = s, t[7] = c, t[8] = l, t[9] = u, t[10] = d, t[11] = f, t[12] = p, t[13] = m, t[14] = h, t[15] = g, t[16] = _, t[17] = v, t[18] = y, t[19] = b, t[20] = x);
	let S = v === void 0 ? "bottom" : v, C = y === void 0 ? "Search" : y, w = i !== void 0, T;
	t[21] === a ? T = t[22] : (T = a ?? [], t[21] = a, t[22] = T);
	let [E, D] = J(T), O = w ? i : E, k = !!m, A = Tr(null), [j, M] = J(0), N = Tr(null), P;
	t[23] !== s || t[24] !== c || t[25] !== d ? (P = () => {
		let e = N.current;
		!e || c || !s || !d || e.scrollHeight - e.scrollTop <= e.clientHeight + 8 && d();
	}, t[23] = s, t[24] = c, t[25] = d, t[26] = P) : P = t[26];
	let F = P, I, L;
	t[27] === f ? (I = t[28], L = t[29]) : (I = () => {
		if (!f) return;
		let e = A.current;
		if (!e) return;
		let t = new ResizeObserver((e) => {
			for (let t of e) M(t.target.clientWidth);
		});
		return t.observe(e), () => {
			t.unobserve(e);
		};
	}, L = [f], t[27] = f, t[28] = I, t[29] = L), br(I, L);
	let R;
	t[30] === O ? R = t[31] : (R = new Set(O.map(Zy)), t[30] = O, t[31] = R);
	let z = R, B;
	t[32] !== w || t[33] !== p || t[34] !== h || t[35] !== O ? (B = (e) => {
		if (e === "all") {
			let e = new Set(h.map(Xy)), t = [...O.filter((t) => !e.has(t.id)), ...h];
			w || D(t), p?.(t);
			return;
		}
		let t = O.filter((t) => e.has(t.id)), n = new Set(t.map(Yy)), r = h.filter((t) => e.has(t.id) && !n.has(t.id)), i = [...t, ...r];
		w || D(i), p?.(i);
	}, t[32] = w, t[33] = p, t[34] = h, t[35] = O, t[36] = B) : B = t[36];
	let V = B, ee = Jy, H;
	t[37] === g ? H = t[38] : (H = (e) => e.map((e) => /* @__PURE__ */ Y(Ei, {
		className: "flex cursor-default items-center gap-xs p-2 focus:outline-none",
		id: e.id,
		textValue: ee(e),
		children: (t) => {
			let { isSelected: n, isHovered: r, isFocused: i } = t;
			return g(e, n, r, i);
		}
	}, e.id)), t[37] = g, t[38] = H);
	let U = H, te;
	t[39] !== h || t[40] !== U ? (te = () => {
		let e = [], t = /* @__PURE__ */ new Map();
		return h.forEach((n) => {
			let r = n.group ?? "";
			t.has(r) || (e.push(r), t.set(r, []));
			let i = t.get(r);
			i && i.push(n);
		}), e.flatMap((e) => {
			let n = t.get(e);
			return n ? e ? /* @__PURE__ */ X(Di, { children: [/* @__PURE__ */ Y(yi, {
				className: Uy(),
				children: e
			}), U(n)] }, `group-${e}`) : U(n) : [];
		});
	}, t[39] = h, t[40] = U, t[41] = te) : te = t[41];
	let ne = te, re = f ? A : void 0, ie;
	t[42] !== re || t[43] !== x ? (ie = /* @__PURE__ */ Y("span", {
		className: "inline-flex",
		ref: re,
		children: x
	}), t[42] = re, t[43] = x, t[44] = ie) : ie = t[44];
	let ae;
	t[45] !== f || t[46] !== j ? (ae = f ? { minWidth: j } : void 0, t[45] = f, t[46] = j, t[47] = ae) : ae = t[47];
	let oe = `Dialog Multi Dropdown ${u}`, se;
	t[48] === r ? se = t[49] : (se = Hy({ className: r }), t[48] = r, t[49] = se);
	let ce;
	t[50] !== m || t[51] !== C || t[52] !== _ || t[53] !== k ? (ce = k ? /* @__PURE__ */ Y("div", {
		className: "flex p-0-5",
		children: /* @__PURE__ */ Y(Wl, {
			className: "w-full",
			inputProps: { placeholder: C },
			onChange: m,
			value: _
		})
	}) : null, t[50] = m, t[51] = C, t[52] = _, t[53] = k, t[54] = ce) : ce = t[54];
	let le;
	t[55] === b ? le = t[56] : (le = b ? /* @__PURE__ */ Y(Ky, {
		left: b.left,
		right: b.right
	}) : null, t[55] = b, t[56] = le);
	let ue;
	t[57] !== V || t[58] !== l || t[59] !== u || t[60] !== h.length || t[61] !== ne || t[62] !== z ? (ue = l ? /* @__PURE__ */ X("div", {
		className: "flex flex-col gap-y-1 p-2",
		children: [
			/* @__PURE__ */ Y(Gl, { width: "100%" }),
			/* @__PURE__ */ Y(Gl, { width: "100%" }),
			/* @__PURE__ */ Y(Gl, { width: "100%" }),
			/* @__PURE__ */ Y(Gl, { width: "100%" })
		]
	}) : h.length === 0 ? /* @__PURE__ */ Y("div", {
		className: "p-2 text-label-medium text-text-secondary",
		children: "No results found..."
	}) : /* @__PURE__ */ Y(Ti, {
		"aria-label": `list-${u}`,
		className: "flex flex-col gap-y-1",
		onSelectionChange: V,
		selectedKeys: z,
		selectionMode: "multiple",
		shouldSelectOnPressUp: !0,
		children: ne()
	}), t[57] = V, t[58] = l, t[59] = u, t[60] = h.length, t[61] = ne, t[62] = z, t[63] = ue) : ue = t[63];
	let de;
	t[64] === c ? de = t[65] : (de = c ? /* @__PURE__ */ Y("div", {
		className: "flex justify-center py-xs",
		children: /* @__PURE__ */ Y(Dl, { size: "small" })
	}) : null, t[64] = c, t[65] = de);
	let fe;
	t[66] !== F || t[67] !== ue || t[68] !== de ? (fe = /* @__PURE__ */ X("div", {
		className: "flex max-h-[19.75rem] flex-col overflow-y-auto overscroll-y-contain",
		onScroll: F,
		ref: N,
		children: [ue, de]
	}), t[66] = F, t[67] = ue, t[68] = de, t[69] = fe) : fe = t[69];
	let pe;
	t[70] === n ? pe = t[71] : (pe = n ? /* @__PURE__ */ Y(Ky, {
		className: "border-t border-outline-decorative pt-3",
		left: n.left,
		right: n.right
	}) : null, t[70] = n, t[71] = pe);
	let me;
	t[72] !== oe || t[73] !== se || t[74] !== ce || t[75] !== le || t[76] !== fe || t[77] !== pe ? (me = /* @__PURE__ */ X(fi, {
		"aria-label": oe,
		className: se,
		children: [
			ce,
			le,
			fe,
			pe
		]
	}), t[72] = oe, t[73] = se, t[74] = ce, t[75] = le, t[76] = fe, t[77] = pe, t[78] = me) : me = t[78];
	let he;
	t[79] !== S || t[80] !== ae || t[81] !== me ? (he = /* @__PURE__ */ Y(ji, {
		className: "scrollbar-custom overscroll-contain",
		placement: S,
		style: ae,
		children: me
	}), t[79] = S, t[80] = ae, t[81] = me, t[82] = he) : he = t[82];
	let ge;
	return t[83] !== o || t[84] !== ie || t[85] !== he ? (ge = /* @__PURE__ */ X(mi, {
		...o,
		children: [ie, he]
	}), t[83] = o, t[84] = ie, t[85] = he, t[86] = ge) : ge = t[86], ge;
}
function Jy(e) {
	return e.searchLabel ?? (typeof e.name == "string" ? e.name : e.id);
}
function Yy(e) {
	return e.id;
}
function Xy(e) {
	return e.id;
}
function Zy(e) {
	return e.id;
}
//#endregion
//#region lib/components/Switch/Switch.styles.ts
var Qy = G({
	base: "flex items-center h-[1.25rem] w-[2.625rem] shrink-0 rounded-10 bg-clip-padding px-[3px] outline outline-1 transition duration-200 ease-in-out",
	variants: {
		isSelected: {
			false: "bg-background-primary outline-outline-input-enabled",
			true: "bg-brand-primary outline-brand-primary"
		},
		isHovered: { true: "" },
		isFocused: { true: "outline-2 outline-outline-brand" },
		isDisabled: { true: "cursor-not-allowed" }
	},
	compoundVariants: [
		{
			isSelected: !1,
			isHovered: !0,
			class: "outline-outline-input-hover"
		},
		{
			isSelected: !1,
			isFocused: !0,
			class: "outline-outline-brand"
		},
		{
			isSelected: !0,
			isHovered: !0,
			class: "bg-interactive-primary-button-hover-background outline-interactive-primary-button-hover-background"
		},
		{
			isSelected: !0,
			isFocused: !0,
			class: "bg-interactive-primary-button-focus-background outline-interactive-primary-button-focus-background"
		},
		{
			isDisabled: !0,
			isSelected: !1,
			class: "bg-background-primary outline-interactive-disabled-outline"
		},
		{
			isDisabled: !0,
			isSelected: !0,
			class: "bg-interactive-secondary-button-focus-background outline-interactive-secondary-button-focus-background"
		}
	]
}), $y = G({
	base: "size-[.875rem] transform rounded-10 shadow-sm transition duration-200 ease-in-out",
	variants: {
		isSelected: {
			false: "translate-x-0 bg-brand-primary",
			true: "translate-x-[150%] bg-text-primary-inverse"
		},
		isDisabled: { true: "" }
	},
	compoundVariants: [{
		isDisabled: !0,
		isSelected: !1,
		class: "bg-interactive-disabled-outline"
	}, {
		isDisabled: !0,
		isSelected: !0,
		class: "bg-interactive-secondary-button-hover-background"
	}]
}), eb = G({
	base: "relative group flex items-center gap-md text-label-medium font-medium transition text-text-primary",
	variants: { isDisabled: { true: "text-text-disabled cursor-not-allowed" } }
});
function tb(e) {
	let t = K(33), n, r, i, a, o, s, c;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4], o = t[5], s = t[6], c = t[7]) : ({children: i, position: c, className: a, assistiveText: r, isDisabled: o, "aria-describedby": n, ...s} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a, t[5] = o, t[6] = s, t[7] = c);
	let l = c === void 0 ? "leading" : c, u = xr(), d;
	t[8] !== n || t[9] !== r || t[10] !== u ? (d = [n, r ? u : null].filter(Boolean).join(" ") || void 0, t[8] = n, t[9] = r, t[10] = u, t[11] = d) : d = t[11];
	let f = r ? void 0 : a, p;
	t[12] === f ? p = t[13] : (p = ta(f, nb), t[12] = f, t[13] = p);
	let m;
	t[14] !== i || t[15] !== l ? (m = (e) => {
		let { isSelected: t, isHovered: n, isFocused: r, isDisabled: a } = e;
		return /* @__PURE__ */ X(Dr, { children: [
			l === "leading" ? i : null,
			/* @__PURE__ */ Y("div", {
				className: Qy({
					isSelected: t,
					isHovered: n,
					isFocused: r,
					isDisabled: a
				}),
				children: /* @__PURE__ */ Y("div", { className: $y({
					isSelected: t,
					isDisabled: a
				}) })
			}),
			l === "trailing" ? /* @__PURE__ */ Y("span", { children: i }) : null
		] });
	}, t[14] = i, t[15] = l, t[16] = m) : m = t[16];
	let h;
	t[17] !== o || t[18] !== s || t[19] !== d || t[20] !== p || t[21] !== m ? (h = /* @__PURE__ */ Y(Ri, {
		"aria-describedby": d,
		className: p,
		...s,
		isDisabled: o,
		children: m
	}), t[17] = o, t[18] = s, t[19] = d, t[20] = p, t[21] = m, t[22] = h) : h = t[22];
	let g = h;
	if (!r) return g;
	let _;
	t[23] === a ? _ = t[24] : (_ = W("flex flex-col gap-y-[.15rem]", a), t[23] = a, t[24] = _);
	let v;
	t[25] !== r || t[26] !== u || t[27] !== o ? (v = /* @__PURE__ */ Y(gl, {
		id: u,
		isDisabled: o,
		children: r
	}), t[25] = r, t[26] = u, t[27] = o, t[28] = v) : v = t[28];
	let y;
	return t[29] !== g || t[30] !== _ || t[31] !== v ? (y = /* @__PURE__ */ X("div", {
		className: _,
		children: [g, v]
	}), t[29] = g, t[30] = _, t[31] = v, t[32] = y) : y = t[32], y;
}
function nb(e, t) {
	return eb({
		...t,
		className: e
	});
}
//#endregion
//#region lib/components/Switch/SwitchIndicator.tsx
function rb(e) {
	let t = K(11), { isSelected: n, isHovered: r, isFocused: i } = e, a;
	t[0] !== i || t[1] !== r || t[2] !== n ? (a = Qy({
		isSelected: n,
		isHovered: r,
		isFocused: i
	}), t[0] = i, t[1] = r, t[2] = n, t[3] = a) : a = t[3];
	let o;
	t[4] === n ? o = t[5] : (o = $y({ isSelected: n }), t[4] = n, t[5] = o);
	let s;
	t[6] === o ? s = t[7] : (s = /* @__PURE__ */ Y("div", { className: o }), t[6] = o, t[7] = s);
	let c;
	return t[8] !== a || t[9] !== s ? (c = /* @__PURE__ */ Y("div", {
		className: a,
		children: s
	}), t[8] = a, t[9] = s, t[10] = c) : c = t[10], c;
}
//#endregion
//#region lib/components/MultiToggleDropdown/MultiToggleDropdown.tsx
function ib(e) {
	let t = K(2), n;
	return t[0] === e ? n = t[1] : (n = /* @__PURE__ */ Y(qy, {
		...e,
		renderItem: ab
	}), t[0] = e, t[1] = n), n;
}
function ab(e, t, n, r) {
	return /* @__PURE__ */ X("div", {
		className: "flex items-center gap-md",
		children: [/* @__PURE__ */ Y(rb, {
			isFocused: r,
			isHovered: n,
			isSelected: t
		}), /* @__PURE__ */ Y(Wy, { item: e })]
	});
}
//#endregion
//#region lib/components/MultiSelectDropdown/MultiSelectDropdown.tsx
function ob(e) {
	let t = K(2), n;
	return t[0] === e ? n = t[1] : (n = /* @__PURE__ */ Y(qy, {
		...e,
		renderItem: sb
	}), t[0] = e, t[1] = n), n;
}
function sb(e, t, n, r) {
	return /* @__PURE__ */ X(Dr, { children: [/* @__PURE__ */ Y(bl, {
		isFocused: r,
		isHovered: n,
		isSelected: t
	}), /* @__PURE__ */ Y(Wy, { item: e })] });
}
//#endregion
//#region lib/components/Progress/ProgressBar.tsx
var cb = G({
	base: "w-full overflow-hidden rounded-lg",
	variants: {
		variant: {
			rounded: "",
			square: "rounded-none"
		},
		size: {
			medium: "h-4 border border-outline-brand",
			slim: "h-[3px] bg-overlay-medium"
		}
	},
	defaultVariants: {
		variant: "rounded",
		size: "medium"
	}
}), lb = G({
	base: "h-full rounded-lg bg-foreground-brand transition-all duration-300 ease-out",
	variants: { variant: {
		rounded: "",
		square: "rounded-none"
	} },
	defaultVariants: { variant: "rounded" }
}), ub = G({ base: "text-sm text-gray-700 font-medium" });
function db(e) {
	let t = K(10), { label: n, percentage: r, indeterminate: i, variant: a, size: o } = e, s = r === void 0 ? 0 : r, c = i !== void 0 && i, l = a === void 0 ? "rounded" : a, u = o === void 0 ? "medium" : o, d = !n || c ? n ?? "Loading" : void 0, f = c ? void 0 : s, p;
	t[0] !== c || t[1] !== n || t[2] !== u || t[3] !== l ? (p = (e) => {
		let { percentage: t, valueText: r } = e;
		return /* @__PURE__ */ X(Dr, { children: [c ? null : /* @__PURE__ */ X("div", {
			className: W("flex items-center justify-between", "mb-2"),
			children: [/* @__PURE__ */ Y(Si, {
				className: W(ub()),
				children: n
			}), /* @__PURE__ */ Y("span", {
				className: "text-sm text-gray-700 ml-2 font-medium",
				children: r
			})]
		}), /* @__PURE__ */ Y("div", {
			className: W(cb({
				variant: l,
				size: u
			})),
			children: c ? /* @__PURE__ */ Y("div", {
				className: "relative h-full w-full overflow-hidden",
				children: /* @__PURE__ */ Y("div", { className: W("absolute inset-y-0 left-0 w-1/2 animate-loading-overlay-slide", W("bg-foreground-brand", l === "rounded" ? "rounded-lg" : void 0)) })
			}) : /* @__PURE__ */ Y("div", {
				className: W(lb({ variant: l })),
				style: { width: `${t}%` }
			})
		})] });
	}, t[0] = c, t[1] = n, t[2] = u, t[3] = l, t[4] = p) : p = t[4];
	let m;
	return t[5] !== c || t[6] !== d || t[7] !== f || t[8] !== p ? (m = /* @__PURE__ */ Y(Mi, {
		"aria-label": d,
		className: "w-full",
		isIndeterminate: c,
		value: f,
		children: p
	}), t[5] = c, t[6] = d, t[7] = f, t[8] = p, t[9] = m) : m = t[9], m;
}
//#endregion
//#region lib/components/shared/tagVariants.ts
var fb = G({
	base: "gap-x-xs inline-flex items-center justify-center text-label-extra-small leading-[normal] font-bold capitalize px-xs py-3xs rounded-md",
	variants: { color: {
		indigo: "bg-data-viz-soft-indigo text-data-viz-indigo-900",
		"bright-indigo": "bg-data-viz-bright-indigo text-data-viz-indigo-50",
		purple: "bg-data-viz-soft-violet text-data-viz-violet-900",
		"bright-purple": "bg-data-viz-bright-violet text-data-viz-violet-50",
		pink: "bg-data-viz-soft-pink text-data-viz-pink-900",
		"bright-pink": "bg-data-viz-bright-pink text-data-viz-pink-50",
		red: "bg-data-viz-soft-red text-data-viz-red-900",
		"bright-red": "bg-data-viz-bright-red text-data-viz-red-50",
		orange: "bg-data-viz-soft-orange text-stacklet-orange-900",
		"bright-orange": "bg-data-viz-bright-orange text-stacklet-orange-50",
		yellow: "bg-data-viz-soft-yellow text-data-viz-yellow-900",
		"bright-yellow": "bg-data-viz-bright-yellow text-data-viz-yellow-900",
		green: "bg-data-viz-soft-green text-data-viz-green-900",
		"bright-green": "bg-data-viz-bright-green text-data-viz-green-50",
		blue: "bg-data-viz-soft-blue text-data-viz-blue-900",
		"bright-blue": "bg-data-viz-bright-blue text-data-viz-blue-50",
		grey: "bg-data-viz-soft-grey text-text-tag",
		"dark-grey": "bg-neutral-700 text-neutral-50",
		region: "border border-foreground-primary bg-transparent text-foreground-primary leading-[11px] font-mono font-normal normal-case"
	} },
	defaultVariants: { color: "indigo" }
});
//#endregion
//#region lib/components/Tag/Tag.tsx
function pb(e) {
	let t = K(17), n, r, i, a, o;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4], o = t[5]) : ({children: n, icon: i, color: o, className: r, ...a} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a, t[5] = o);
	let s = o === void 0 ? "indigo" : o, c = typeof n == "string" ? n : void 0, l;
	t[6] !== r || t[7] !== s ? (l = fb({
		color: s,
		className: W("mr-1", r)
	}), t[6] = r, t[7] = s, t[8] = l) : l = t[8];
	let u;
	t[9] !== n || t[10] !== i ? (u = (e) => {
		let { allowsRemoving: t } = e;
		return /* @__PURE__ */ X(Dr, { children: [
			i ? /* @__PURE__ */ Y("span", {
				className: "mr-0.5 inline-flex items-center",
				children: i
			}) : null,
			n,
			t ? /* @__PURE__ */ Y(Q, {
				IconLeft: /* @__PURE__ */ Y(ie, {}),
				className: "border-none p-0 text-inherit outline-none",
				slot: "remove",
				variant: "plain"
			}) : null
		] });
	}, t[9] = n, t[10] = i, t[11] = u) : u = t[11];
	let d;
	return t[12] !== a || t[13] !== l || t[14] !== u || t[15] !== c ? (d = /* @__PURE__ */ Y(Ui, {
		className: l,
		textValue: c,
		...a,
		children: u
	}), t[12] = a, t[13] = l, t[14] = u, t[15] = c, t[16] = d) : d = t[16], d;
}
//#endregion
//#region lib/components/TagGroup/TagGroup.tsx
function mb(e) {
	let t = K(26), n, r, i, a, o, s, c, l;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4], o = t[5], s = t[6], c = t[7], l = t[8]) : ({label: o, description: r, errorMessage: i, items: a, children: n, renderEmptyState: c, tagListClassName: l, ...s} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a, t[5] = o, t[6] = s, t[7] = c, t[8] = l);
	let u;
	t[9] === o ? u = t[10] : (u = o ? /* @__PURE__ */ Y(Si, {
		className: "text-label-small",
		children: o
	}) : null, t[9] = o, t[10] = u);
	let d;
	t[11] !== n || t[12] !== a || t[13] !== c || t[14] !== l ? (d = /* @__PURE__ */ Y(Gi, {
		className: l,
		items: a,
		renderEmptyState: c,
		children: n
	}), t[11] = n, t[12] = a, t[13] = c, t[14] = l, t[15] = d) : d = t[15];
	let f;
	t[16] === r ? f = t[17] : (f = r ? /* @__PURE__ */ Y(Ki, {
		className: "text-label-small",
		slot: "description",
		children: r
	}) : null, t[16] = r, t[17] = f);
	let p;
	t[18] === i ? p = t[19] : (p = i ? /* @__PURE__ */ X("div", {
		className: "gap-x-2xs flex items-center gap-1",
		children: [/* @__PURE__ */ Y(le, {}), /* @__PURE__ */ Y(Ki, {
			className: "text-label-small text-text-negative",
			slot: "errorMessage",
			children: i
		})]
	}) : null, t[18] = i, t[19] = p);
	let m;
	return t[20] !== s || t[21] !== u || t[22] !== d || t[23] !== f || t[24] !== p ? (m = /* @__PURE__ */ X(Wi, {
		...s,
		children: [
			u,
			d,
			f,
			p
		]
	}), t[20] = s, t[21] = u, t[22] = d, t[23] = f, t[24] = p, t[25] = m) : m = t[25], m;
}
//#endregion
//#region lib/components/ComboBox/ComboBox.tsx
var hb = hr("multiple"), gb = hr("md"), _b = "__combobox_select_all__", vb = G({ base: "group flex w-full min-w-0 flex-col gap-[.15rem]" }), yb = G({
	base: W("relative flex flex-row flex-wrap transition", "rounded-1 border border-outline-input-enabled bg-primary", "hover:border-outline-input-hover hover:ring-1 hover:ring-outline-input-hover", "focus-within:!border-outline-input-focus focus-within:ring-1 focus-within:!ring-outline-input-focus", "py-0 pr-0 items-center"),
	variants: {
		size: {
			md: "pl-lg",
			sm: "pl-md",
			xs: "pl-sm"
		},
		isClickable: { true: "cursor-pointer" },
		isInvalid: { true: "border-outline-negative ring-1 ring-outline-negative" },
		isOpen: { true: "border-outline-input-focus ring-1 ring-outline-input-focus" },
		isDisabled: { true: "cursor-not-allowed bg-background-primary border-outline-input-disabled hover:ring-0 hover:border-outline-input-disabled focus-within:!ring-0 focus-within:!border-outline-input-disabled" },
		isReadOnly: { true: "!cursor-default !bg-background-secondary !border-transparent hover:ring-0 focus-within:!ring-0 focus-within:!border-transparent" }
	}
}), bb = G({
	base: "min-w-0 flex-1 shadow-none bg-transparent leading-md-20 focus:outline-none px-0 text-text-primary placeholder:text-text-secondary disabled:text-text-disabled disabled:placeholder:text-text-disabled",
	variants: {
		size: {
			md: "py-xs text-label-medium",
			sm: "py-xxs text-label-extra-small",
			xs: "py-xxs text-label-extra-small"
		},
		isSearchable: { false: "disabled:cursor-not-allowed" },
		isClickable: { true: "cursor-pointer" }
	}
}), xb = G({ base: "overflow-hidden outline-none rounded-1 border border-outline-input-enabled bg-background-secondary shadow-md" }), Sb = G({
	base: "max-h-[calc(50vh-80px)] overflow-y-auto px-xxs py-xs flex flex-col",
	variants: { size: {
		md: "gap-y-3xs",
		sm: "gap-y-xs",
		xs: "gap-y-xs"
	} }
}), Cb = G({
	base: W("w-full text-start outline-none", "rounded-sm px-xs py-3xs cursor-default", "hover:bg-interactive-secondary-button-hover-background", "data-[focused]:bg-interactive-secondary-button-focus-background data-[focused]:outline-none", "data-[pressed]:bg-interactive-secondary-button-focus-background", "data-[selected]:font-semibold"),
	variants: { size: {
		md: "text-label-small",
		sm: "text-label-extra-small",
		xs: "text-label-extra-small"
	} }
}), wb = G({
	base: "flex shrink-0 items-center justify-center text-label-small transition self-stretch rounded-r-1 text-text-secondary hover:text-text-primary focus:text-text-primary",
	variants: { size: {
		md: "pl-xs pr-lg",
		sm: "border-0 py-0 pl-lg pr-md",
		xs: "border-0 py-0 px-xxs"
	} }
}), Tb = G({ base: "relative ml-auto flex shrink-0 self-stretch items-stretch" }), Eb = G({ base: "pointer-events-none select-none px-3xs py-xs text-label-small mx-xs text-text-secondary" }), Db = (e) => {
	let t = K(18), { ariaLabelledBy: n, className: r, inputRef: i, isInteractive: a, onBlur: o, onKeyDownCapture: s, placeholder: c, readOnly: l, reopenOnClick: u, selectOnFocus: d } = e, f = yr(di), p;
	t[0] !== a || t[1] !== u || t[2] !== f ? (p = () => {
		u && a && f && !f.isOpen && f.open(null, "manual");
	}, t[0] = a, t[1] = u, t[2] = f, t[3] = p) : p = t[3];
	let m;
	t[4] === d ? m = t[5] : (m = (e) => {
		d && e.target.select();
	}, t[4] = d, t[5] = m);
	let h = a ? void 0 : Nb, g = a ? void 0 : -1, _;
	return t[6] !== n || t[7] !== r || t[8] !== i || t[9] !== o || t[10] !== s || t[11] !== c || t[12] !== l || t[13] !== p || t[14] !== m || t[15] !== h || t[16] !== g ? (_ = /* @__PURE__ */ Y(xi, {
		"aria-labelledby": n,
		className: r,
		onBlur: o,
		onClick: p,
		onFocus: m,
		onKeyDownCapture: s,
		onPointerDown: h,
		placeholder: c,
		readOnly: l,
		ref: i,
		tabIndex: g
	}), t[6] = n, t[7] = r, t[8] = i, t[9] = o, t[10] = s, t[11] = c, t[12] = l, t[13] = p, t[14] = m, t[15] = h, t[16] = g, t[17] = _) : _ = t[17], _;
}, Ob = (e) => {
	let t = K(13), { inputValue: n, selectedMatches: r, variant: i } = e, a = i === "all-selected" || i === "already-selected", o;
	t[0] !== n || t[1] !== r || t[2] !== i ? (o = () => {
		switch (i) {
			case "all-selected": return "All options selected";
			case "already-selected": return r.length === 1 ? /* @__PURE__ */ X(Dr, { children: ["Already selected: ", /* @__PURE__ */ Y("strong", {
				className: "font-medium text-fg",
				children: r[0]
			})] }) : "All matching options are already selected";
			case "no-results": return /* @__PURE__ */ X(Dr, { children: ["No results found for: ", /* @__PURE__ */ Y("strong", {
				className: "font-medium text-fg",
				children: n
			})] });
			default: return "No options";
		}
	}, t[0] = n, t[1] = r, t[2] = i, t[3] = o) : o = t[3];
	let s = o, c;
	t[4] === a ? c = t[5] : (c = a ? /* @__PURE__ */ Y(yt, { className: "size-lg shrink-0" }) : null, t[4] = a, t[5] = c);
	let l;
	t[6] === s ? l = t[7] : (l = s(), t[6] = s, t[7] = l);
	let u;
	t[8] === l ? u = t[9] : (u = /* @__PURE__ */ Y("span", { children: l }), t[8] = l, t[9] = u);
	let d;
	return t[10] !== c || t[11] !== u ? (d = /* @__PURE__ */ X(Ki, {
		className: "flex items-center gap-sm p-3 text-label-small text-text-secondary",
		slot: "description",
		children: [c, u]
	}), t[10] = c, t[11] = u, t[12] = d) : d = t[12], d;
};
function kb(e) {
	return /* @__PURE__ */ Y(Mb, {
		id: e.id,
		textValue: e.name,
		children: /* @__PURE__ */ Y("span", { children: e.name })
	});
}
var Ab = (e) => {
	let t = K(97), { children: n, items: r, selectedItems: i, onItemCleared: a, onItemInserted: o, onInputChange: s, className: c, name: l, renderEmptyState: u, assistiveText: d, tooltipText: f, inputRef: p, selectionMode: m, label: h, freeSolo: g, selectAllLabel: _, serverSideFilter: v, isClearable: y, isSearchable: b, size: x, tag: S, ...C } = e, w = n === void 0 ? kb : n, T = m === void 0 ? "multiple" : m, E = g !== void 0 && g, D = v !== void 0 && v, O = y === void 0 || y, k = b === void 0 || b, A = x === void 0 ? "md" : x, j = xr(), M = xr(), N = Tr(null), [P, F] = J(0), I;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (I = { sensitivity: "base" }, t[0] = I) : I = t[0];
	let { contains: L } = er(I), R;
	t[1] === i.items ? R = t[2] : (R = i.items.map(Pb), t[1] = i.items, t[2] = R);
	let z = R, B;
	t[3] !== L || t[4] !== z || t[5] !== T || t[6] !== D ? (B = (e, t) => T === "multiple" && z.includes(e.id) ? !1 : D || L(e.name, t), t[3] = L, t[4] = z, t[5] = T, t[6] = D, t[7] = B) : B = t[7];
	let V = B, ee;
	if (t[8] !== r) {
		let e = /* @__PURE__ */ new Set();
		ee = r.filter((t) => t.id === "" || t.id == null || e.has(t.id) ? !1 : (e.add(t.id), !0)), t[8] = r, t[9] = ee;
	} else ee = t[9];
	let H = ee, U;
	t[10] === H ? U = t[11] : (U = new Map(H.map(Fb)), t[10] = H, t[11] = U);
	let te = U, [ne, re] = J(""), ae = ne.trim(), oe = H.filter((e) => V(e, ae)), se = E && ae !== "" && !te.has(ae) && !r.some((e) => e.name === ae) ? {
		id: ae,
		name: ae
	} : null, ce = T === "multiple" && H.length > 0 && oe.length === 0 && ae === "", le = ae === "" ? [] : i.items.filter((e) => L(e.name, ae)).map(Ib), ue = ae === "" ? ce ? "all-selected" : "no-options" : le.length > 0 ? "already-selected" : "no-results", de = _ && i.appendMany && T === "multiple" && oe.length > 0 ? {
		id: _b,
		name: _
	} : null, fe = [
		...de ? [de] : [],
		...se ? [se] : [],
		...oe
	], pe = typeof w == "function" && oe.some(Lb), me = (e) => {
		let t = (t) => {
			let n = e(t);
			return gr(n) ? mr(n, { key: String(t.id) }) : n;
		}, n = [...de ? [t(de)] : [], ...se ? [t(se)] : []], r = [], i = /* @__PURE__ */ new Map();
		oe.forEach((e) => {
			let t = e.group ?? "";
			i.has(t) || (r.push(t), i.set(t, [])), i.get(t)?.push(e);
		});
		let a = r.flatMap((e) => {
			let n = i.get(e) ?? [];
			return e ? [/* @__PURE__ */ Y(yi, {
				className: Eb(),
				children: e
			}, `group-${e}`), ...n.map(t)] : n.map(t);
		});
		return [...n, ...a];
	}, [he, ge] = J(null), [_e, ve] = J(!1), ye = T === "single" ? i.items[0] : void 0, be = T === "single" ? he ?? ye?.name ?? "" : he ?? "", xe = T === "single" && he === null ? ye?.id ?? null : null, Se;
	t[12] !== a || t[13] !== i ? (Se = (e) => {
		let t = e.values().next().value;
		t && (i.remove?.(t), ge(null), a?.(t));
	}, t[12] = a, t[13] = i, t[14] = Se) : Se = t[14];
	let Ce = Se, we = (e) => {
		if (!e) return;
		let t = () => {
			ge(null), re(""), s?.("");
		};
		if (e === _b) {
			let e = oe.filter((e) => !z.includes(e.id));
			i.appendMany?.(e), e.forEach((e) => o?.(e.id)), t();
			return;
		}
		let n = te.get(e) ?? (se && e === se.id ? se : void 0);
		n && (z.includes(e) || (i.append?.(n), o?.(e)), t());
	}, Te;
	t[15] === s ? Te = t[16] : (Te = (e) => {
		ge(e), re(e), s?.(e);
	}, t[15] = s, t[16] = Te);
	let Ee = Te, De;
	t[17] !== a || t[18] !== i ? (De = () => {
		if (i.items.length === 0) return;
		let e = i.items[i.items.length - 1];
		e && (i.remove?.(e.id), a?.(e.id)), ge(null);
	}, t[17] = a, t[18] = i, t[19] = De) : De = t[19];
	let Oe = De, ke = (e) => {
		if (e.key === "Backspace" && be === "") {
			Oe();
			return;
		}
		e.key === "Enter" && se && !e.currentTarget.getAttribute("aria-activedescendant") && (e.preventDefault(), e.stopPropagation(), we(se.id));
	}, Ae, je;
	t[20] === Symbol.for("react.memo_cache_sentinel") ? (Ae = () => {
		let e = N.current;
		if (!e) return;
		let t = new ResizeObserver((e) => {
			for (let t of e) F(t.target.clientWidth);
		});
		return t.observe(e), () => {
			t.unobserve(e);
		};
	}, je = [], t[20] = Ae, t[21] = je) : (Ae = t[20], je = t[21]), br(Ae, je);
	let Me = i.items.length > 0 ? "py-1.5" : "", Ne;
	t[22] === Me ? Ne = t[23] : (Ne = W("flex flex-wrap gap-xxs outline-hidden", Me), t[22] = Me, t[23] = Ne);
	let Pe = Ne, Fe = !C.isDisabled && !C.isReadOnly, Ie = !k && Fe, Le = C.menuTrigger ?? "focus", Re;
	t[24] === c ? Re = t[25] : (Re = W(vb(), c), t[24] = c, t[25] = Re);
	let ze;
	t[26] === M ? ze = t[27] : (ze = { id: M }, t[26] = M, t[27] = ze);
	let Be = yb({
		size: A,
		isClickable: Ie,
		isInvalid: C.isInvalid,
		isOpen: _e,
		isDisabled: C.isDisabled,
		isReadOnly: C.isReadOnly
	}), Ve;
	t[28] !== Fe || t[29] !== Ce || t[30] !== C.isDisabled || t[31] !== i.items || t[32] !== T || t[33] !== S || t[34] !== j || t[35] !== Pe ? (Ve = T === "multiple" && i.items.length > 0 ? /* @__PURE__ */ Y(mb, {
		"aria-label": "Selected items",
		className: W("py-xs mr-xs", C.isDisabled ? "opacity-50" : ""),
		disabledKeys: Fe ? void 0 : i.items.map(Rb),
		id: j,
		items: i.items,
		onRemove: Fe ? Ce : void 0,
		tagListClassName: Pe,
		children: S
	}) : null, t[28] = Fe, t[29] = Ce, t[30] = C.isDisabled, t[31] = i.items, t[32] = T, t[33] = S, t[34] = j, t[35] = Pe, t[36] = Ve) : Ve = t[36];
	let He = T === "multiple" ? "min-w-20" : "min-w-0", Ue;
	t[37] === He ? Ue = t[38] : (Ue = W("group peer flex flex-1 items-stretch self-stretch", He), t[37] = He, t[38] = Ue);
	let We;
	t[39] === C ? We = t[40] : (We = (e) => {
		ve(e), C.onOpenChange?.(e);
	}, t[39] = C, t[40] = We);
	let Ge;
	t[41] !== Ie || t[42] !== k || t[43] !== A ? (Ge = bb({
		size: A,
		isSearchable: k,
		isClickable: Ie
	}), t[41] = Ie, t[42] = k, t[43] = A, t[44] = Ge) : Ge = t[44];
	let Ke;
	t[45] === s ? Ke = t[46] : (Ke = () => {
		ge(null), re(""), s?.("");
	}, t[45] = s, t[46] = Ke);
	let qe;
	t[47] === Symbol.for("react.memo_cache_sentinel") ? (qe = Tb(), t[47] = qe) : qe = t[47];
	let Je;
	t[48] !== s || t[49] !== O || t[50] !== a || t[51] !== C.isDisabled || t[52] !== C.isReadOnly || t[53] !== i || t[54] !== T ? (Je = T === "single" && O && i.items.length > 0 ? /* @__PURE__ */ Y(Q, {
		IconLeft: /* @__PURE__ */ Y(ie, { size: 16 }),
		"aria-label": "Clear selection",
		className: W("p-0 flex items-center justify-center transition-colors", "text-text-secondary hover:text-text-primary"),
		isDisabled: C.isDisabled || C.isReadOnly,
		onPress: () => {
			if (i.items[0]) {
				let e = i.items[0];
				i.remove?.(e.id), a?.(e.id), ge(null), re(""), s?.("");
			}
		},
		slot: null,
		variant: "plain"
	}) : null, t[48] = s, t[49] = O, t[50] = a, t[51] = C.isDisabled, t[52] = C.isReadOnly, t[53] = i, t[54] = T, t[55] = Je) : Je = t[55];
	let Ye = _e ? "Close dropdown" : "Open dropdown", Xe;
	t[56] === A ? Xe = t[57] : (Xe = wb({ size: A }), t[56] = A, t[57] = Xe);
	let Ze = C.isDisabled || C.isReadOnly, Qe = _e ? "rotate-180" : "", $e;
	t[58] === Qe ? $e = t[59] : ($e = W("size-lg transition", Qe), t[58] = Qe, t[59] = $e);
	let et;
	t[60] === $e ? et = t[61] : (et = /* @__PURE__ */ Y(gt, { className: $e }), t[60] = $e, t[61] = et);
	let tt;
	t[62] !== Ye || t[63] !== Xe || t[64] !== Ze || t[65] !== et ? (tt = /* @__PURE__ */ Y(Q, {
		"aria-label": Ye,
		className: Xe,
		isDisabled: Ze,
		variant: "plain",
		children: et
	}), t[62] = Ye, t[63] = Xe, t[64] = Ze, t[65] = et, t[66] = tt) : tt = t[66];
	let nt;
	t[67] !== Je || t[68] !== tt ? (nt = /* @__PURE__ */ X("div", {
		className: qe,
		children: [Je, tt]
	}), t[67] = Je, t[68] = tt, t[69] = nt) : nt = t[69];
	let rt = ji, it;
	t[70] === Symbol.for("react.memo_cache_sentinel") ? (it = xb(), t[70] = it) : it = t[70];
	let G = `${P}px`, at;
	t[71] === G ? at = t[72] : (at = { minWidth: G }, t[71] = G, t[72] = at);
	let ot = gb, st = Ti, ct;
	t[73] === A ? ct = t[74] : (ct = Sb({ size: A }), t[73] = A, t[74] = ct);
	let lt = () => u ? u(be) : /* @__PURE__ */ Y(Ob, {
		inputValue: be,
		selectedMatches: le,
		variant: ue
	}), ut = pe && typeof w == "function" ? me(w) : w, dt;
	t[75] !== st || t[76] !== T || t[77] !== ct || t[78] !== lt || t[79] !== ut ? (dt = /* @__PURE__ */ Y(st, {
		className: ct,
		renderEmptyState: lt,
		selectionMode: T,
		children: ut
	}), t[75] = st, t[76] = T, t[77] = ct, t[78] = lt, t[79] = ut, t[80] = dt) : dt = t[80];
	let ft;
	t[81] !== A || t[82] !== ot.Provider || t[83] !== dt ? (ft = /* @__PURE__ */ Y(ot.Provider, {
		value: A,
		children: dt
	}), t[81] = A, t[82] = ot.Provider, t[83] = dt, t[84] = ft) : ft = t[84];
	let pt;
	t[85] !== rt || t[86] !== it || t[87] !== at || t[88] !== ft ? (pt = /* @__PURE__ */ Y(rt, {
		className: it,
		style: at,
		trigger: "ComboBox",
		triggerRef: N,
		isNonModal: !0,
		children: ft
	}), t[85] = rt, t[86] = it, t[87] = at, t[88] = ft, t[89] = pt) : pt = t[89];
	let mt;
	t[90] !== d || t[91] !== C.isDisabled || t[92] !== C.isInvalid ? (mt = /* @__PURE__ */ Y(gl, {
		isDisabled: C.isDisabled,
		isInvalid: C.isInvalid,
		children: d
	}), t[90] = d, t[91] = C.isDisabled, t[92] = C.isInvalid, t[93] = mt) : mt = t[93];
	let ht;
	return t[94] !== l || t[95] !== z ? (ht = l ? /* @__PURE__ */ Y("input", {
		name: l,
		value: z.join(","),
		hidden: !0,
		readOnly: !0
	}) : null, t[94] = l, t[95] = z, t[96] = ht) : ht = t[96], /* @__PURE__ */ Y(hb.Provider, {
		value: T,
		children: /* @__PURE__ */ X("div", {
			className: Re,
			children: [
				/* @__PURE__ */ Y(Ci.Provider, {
					value: null,
					children: /* @__PURE__ */ Y(Vl, {
						isDisabled: C.isDisabled,
						isRequired: C.isRequired,
						label: h,
						labelProps: ze,
						tooltipText: f
					})
				}),
				/* @__PURE__ */ X("div", {
					className: Be,
					ref: N,
					children: [Ve, /* @__PURE__ */ X(ui, {
						...C,
						"aria-label": h ? void 0 : C["aria-label"] ?? "Available items",
						"aria-labelledby": h ? M : C["aria-labelledby"],
						className: Ue,
						inputValue: be,
						isRequired: T !== "multiple" && C.isRequired,
						items: pe ? void 0 : fe,
						menuTrigger: Le,
						onInputChange: Ee,
						onOpenChange: We,
						onSelectionChange: we,
						selectedKey: xe,
						allowsEmptyCollection: !0,
						shouldFocusWrap: !0,
						children: [/* @__PURE__ */ X("div", {
							className: "inline-flex min-w-0 flex-1 flex-nowrap items-stretch px-0",
							children: [/* @__PURE__ */ Y(Db, {
								ariaLabelledBy: h ? M : void 0,
								className: Ge,
								inputRef: p,
								isInteractive: Fe,
								onBlur: Ke,
								onKeyDownCapture: ke,
								placeholder: ce ? "All options selected" : C.placeholder,
								readOnly: !k || void 0,
								reopenOnClick: Le === "focus",
								selectOnFocus: k && T === "single" && i.items.length > 0
							}), nt]
						}), pt]
					})]
				}),
				mt,
				ht
			]
		})
	});
}, jb = (e) => {
	let t = K(6), n = yr(hb) === "multiple" ? "" : "bg-transparent border-none", r;
	t[0] !== e.className || t[1] !== n ? (r = W(n, e.className, "mr-0"), t[0] = e.className, t[1] = n, t[2] = r) : r = t[2];
	let i;
	return t[3] !== e || t[4] !== r ? (i = /* @__PURE__ */ Y(pb, {
		...e,
		className: r
	}), t[3] = e, t[4] = r, t[5] = i) : i = t[5], i;
}, Mb = (e) => {
	let t = K(9), n, r;
	t[0] === e ? (n = t[1], r = t[2]) : ({className: n, ...r} = e, t[0] = e, t[1] = n, t[2] = r);
	let i = yr(gb), a;
	t[3] !== n || t[4] !== i ? (a = (e) => W(Cb({ size: i }), typeof n == "function" ? n(e) : n), t[3] = n, t[4] = i, t[5] = a) : a = t[5];
	let o;
	return t[6] !== r || t[7] !== a ? (o = /* @__PURE__ */ Y(Ei, {
		...r,
		className: a
	}), t[6] = r, t[7] = a, t[8] = o) : o = t[8], o;
};
Ab.Tag = jb, Ab.Option = Mb;
function Nb(e) {
	return e.preventDefault();
}
function Pb(e) {
	return e.id;
}
function Fb(e) {
	return [e.id, e];
}
function Ib(e) {
	return e.name;
}
function Lb(e) {
	return e.group;
}
function Rb(e) {
	return e.id;
}
//#endregion
//#region lib/components/ProviderSelector/ProviderSelector.tsx
function zb(e) {
	let t = K(26), { providers: n, selected: r, onChange: i, formatProvider: a, icons: o, className: s } = e, c = o !== void 0 && o, l = n.length <= 1, u, d;
	if (t[0] !== a || t[1] !== n || t[2] !== r) {
		let e;
		t[5] === a ? e = t[6] : (e = (e) => ({
			id: e.key,
			name: a(e.key),
			logo: e.logo
		}), t[5] = a, t[6] = e), u = n.map(e);
		let i;
		t[7] === r ? i = t[8] : (i = (e) => e.id === r, t[7] = r, t[8] = i), d = u.find(i), t[0] = a, t[1] = n, t[2] = r, t[3] = u, t[4] = d;
	} else u = t[3], d = t[4];
	let f = d, p;
	t[9] === s ? p = t[10] : (p = W("w-auto", s), t[9] = s, t[10] = p);
	let m;
	t[11] === f ? m = t[12] : (m = f ? [f] : [], t[11] = f, t[12] = m);
	let h;
	t[13] === i ? h = t[14] : (h = (e) => i(e.id), t[13] = i, t[14] = h);
	let g;
	t[15] !== m || t[16] !== h ? (g = {
		items: m,
		append: h
	}, t[15] = m, t[16] = h, t[17] = g) : g = t[17];
	let _;
	t[18] === c ? _ = t[19] : (_ = (e) => /* @__PURE__ */ X(Ab.Option, {
		className: c ? "flex items-center gap-xs" : void 0,
		id: e.id,
		textValue: e.name,
		children: [c ? /* @__PURE__ */ Y(e.logo, {
			"aria-hidden": "true",
			className: "size-4 shrink-0"
		}) : null, e.name]
	}), t[18] = c, t[19] = _);
	let v;
	return t[20] !== l || t[21] !== u || t[22] !== p || t[23] !== g || t[24] !== _ ? (v = /* @__PURE__ */ Y(Ab, {
		"aria-label": "provider-selector",
		className: p,
		isClearable: !1,
		isDisabled: l,
		isSearchable: !1,
		items: u,
		placeholder: "Select a cloud provider...",
		selectedItems: g,
		selectionMode: "single",
		size: "sm",
		children: _
	}), t[20] = l, t[21] = u, t[22] = p, t[23] = g, t[24] = _, t[25] = v) : v = t[25], v;
}
//#endregion
//#region lib/components/ExpandableSearchField/ExpandableSearchField.tsx
function Bb(e) {
	let t = K(52), n, r, i, a, o, s, c, l, u, d;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4], o = t[5], s = t[6], c = t[7], l = t[8], u = t[9], d = t[10]) : ({className: r, expandedWidth: s, buttonLabel: c, defaultExpanded: l, collapseWhenEmpty: u, value: d, defaultValue: i, onChange: a, "aria-label": n, ...o} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a, t[5] = o, t[6] = s, t[7] = c, t[8] = l, t[9] = u, t[10] = d);
	let f = s === void 0 ? "12.5rem" : s, p = c === void 0 ? "Search" : c, m = l !== void 0 && l, h = u === void 0 || u, [g, _] = J(m), [v, y] = J(d ?? i ?? ""), b = Tr(null), x = d ?? v, S, C;
	t[11] === g ? (S = t[12], C = t[13]) : (S = () => {
		g && b.current?.querySelector("input")?.focus();
	}, C = [g], t[11] = g, t[12] = S, t[13] = C), Cr(S, C);
	let w;
	t[14] === a ? w = t[15] : (w = (e) => {
		y(e), a?.(e);
	}, t[14] = a, t[15] = w);
	let T = w, E;
	t[16] !== h || t[17] !== x ? (E = (e) => {
		h && x === "" && !e.currentTarget.contains(e.relatedTarget) && _(!1);
	}, t[16] = h, t[17] = x, t[18] = E) : E = t[18];
	let D = E, O;
	t[19] === x ? O = t[20] : (O = (e) => {
		e.key === "Escape" && x === "" && _(!1);
	}, t[19] = x, t[20] = O);
	let k = O, A;
	t[21] === r ? A = t[22] : (A = W("relative inline-flex transition-[width] duration-200 ease-in-out", r), t[21] = r, t[22] = A);
	let j = g ? f : "2rem", M;
	t[23] === j ? M = t[24] : (M = { width: j }, t[23] = j, t[24] = M);
	let N = !g || void 0, P = g ? "opacity-100" : "pointer-events-none opacity-0", F;
	t[25] === P ? F = t[26] : (F = W("w-full transition-opacity duration-200", P), t[25] = P, t[26] = F);
	let I = !g, L = n ?? p, R;
	t[27] !== x || t[28] !== T || t[29] !== o || t[30] !== L ? (R = /* @__PURE__ */ Y(Wl, {
		...o,
		"aria-label": L,
		className: "w-full",
		onChange: T,
		value: x
	}), t[27] = x, t[28] = T, t[29] = o, t[30] = L, t[31] = R) : R = t[31];
	let z;
	t[32] !== N || t[33] !== F || t[34] !== I || t[35] !== R ? (z = /* @__PURE__ */ Y("div", {
		"aria-hidden": N,
		className: F,
		inert: I,
		children: R
	}), t[32] = N, t[33] = F, t[34] = I, t[35] = R, t[36] = z) : z = t[36];
	let B = g ? "pointer-events-none opacity-0" : "opacity-100", V;
	t[37] === B ? V = t[38] : (V = W("absolute inset-0 flex items-center w-10 justify-center rounded-full border border-outline-input-enabled bg-background-primary text-text-secondary transition-all duration-200", "hover:border-outline-input-hover hover:text-text-primary hover:ring-1 hover:ring-outline-input-hover p-0", "data-[focus-visible]:border-outline-input-focus data-[focus-visible]:text-text-primary data-[focus-visible]:ring-1 data-[focus-visible]:ring-outline-input-focus", B), t[37] = B, t[38] = V);
	let ee;
	t[39] === Symbol.for("react.memo_cache_sentinel") ? (ee = () => _(!0), t[39] = ee) : ee = t[39];
	let H;
	t[40] === Symbol.for("react.memo_cache_sentinel") ? (H = /* @__PURE__ */ Y(hn, { size: 16 }), t[40] = H) : H = t[40];
	let U;
	t[41] !== p || t[42] !== g || t[43] !== V ? (U = /* @__PURE__ */ Y(Q, {
		"aria-hidden": g,
		"aria-label": p,
		className: V,
		excludeFromTabOrder: g,
		onPress: ee,
		variant: "plain",
		children: H
	}), t[41] = p, t[42] = g, t[43] = V, t[44] = U) : U = t[44];
	let te;
	return t[45] !== D || t[46] !== k || t[47] !== A || t[48] !== M || t[49] !== z || t[50] !== U ? (te = /* @__PURE__ */ X("div", {
		className: A,
		onBlur: D,
		onKeyDown: k,
		ref: b,
		style: M,
		children: [z, U]
	}), t[45] = D, t[46] = k, t[47] = A, t[48] = M, t[49] = z, t[50] = U, t[51] = te) : te = t[51], te;
}
//#endregion
//#region lib/components/SecretTextField/SecretTextField.tsx
var Vb = G({
	base: "\n    text-label-medium text-text-primary outline-none border border-outline-input-enabled bg-primary rounded-1 leading-md-20 truncate\n    hover:border-outline-input-hover hover:ring-1 hover:ring-outline-input-hover\n    relative flex items-center gap-xxs\n  ",
	variants: {
		variant: { primary: "" },
		isReadOnly: { true: "!cursor-text !bg-background-secondary !text-text-primary !border-transparent hover:ring-0" },
		isInvalid: { true: "border-outline-negative ring-1 ring-outline-negative" },
		isInputFocused: { true: "ring-1 !ring-outline-input-focus !border-outline-input-focus" },
		isDisabled: { true: "cursor-not-allowed bg-background-primary text-text-disabled border-outline-input-disabled hover:ring-0 hover:border-outline-input-disabled" }
	}
});
function Hb(e) {
	let t = K(68), n, r, i, a, o, s, c, l, u, d, f;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4], o = t[5], s = t[6], c = t[7], l = t[8], u = t[9], d = t[10], f = t[11]) : ({inputProps: i, label: l, tooltipText: f, className: r, assistiveText: n, isDisabled: a, isReadOnly: s, isInvalid: o, isRequired: c, ref: u, ...d} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a, t[5] = o, t[6] = s, t[7] = c, t[8] = l, t[9] = u, t[10] = d, t[11] = f);
	let [p, m] = J(!1), [h, g] = J(!1), _;
	t[12] === p ? _ = t[13] : (_ = () => {
		m(!p);
	}, t[12] = p, t[13] = _);
	let v = _, y;
	t[14] === r ? y = t[15] : (y = W("flex flex-col gap-[.15rem]", r), t[14] = r, t[15] = y);
	let b = p ? "text" : "password", x;
	t[16] !== a || t[17] !== c || t[18] !== l || t[19] !== f ? (x = /* @__PURE__ */ Y(Vl, {
		isDisabled: a,
		isRequired: c,
		label: l,
		tooltipText: f
	}), t[16] = a, t[17] = c, t[18] = l, t[19] = f, t[20] = x) : x = t[20];
	let S = i?.variant, C = i?.className, w;
	t[21] !== a || t[22] !== h || t[23] !== o || t[24] !== s || t[25] !== S || t[26] !== C ? (w = Vb({
		variant: S,
		isInvalid: o,
		isInputFocused: h,
		isDisabled: a,
		isReadOnly: s,
		className: C
	}), t[21] = a, t[22] = h, t[23] = o, t[24] = s, t[25] = S, t[26] = C, t[27] = w) : w = t[27];
	let T;
	t[28] === Symbol.for("react.memo_cache_sentinel") ? (T = W("w-full border-0 bg-transparent pr-[2.5rem] outline-0", "flex-1 truncate disabled:cursor-not-allowed disabled:text-text-disabled", "placeholder:text-text-secondary focus-visible:outline-none disabled:placeholder:text-text-disabled", "px-lg py-xs"), t[28] = T) : T = t[28];
	let E, D;
	t[29] !== i || t[30] !== s ? (D = (e) => {
		s || (g(!1), i?.onBlur?.(e));
	}, E = (e) => {
		s || (g(!0), i?.onFocus?.(e));
	}, t[29] = i, t[30] = s, t[31] = E, t[32] = D) : (E = t[31], D = t[32]);
	let O = i?.placeholder || "Enter secret...", k = p ? "text" : "password", A;
	t[33] !== i || t[34] !== u || t[35] !== E || t[36] !== O || t[37] !== k || t[38] !== D ? (A = /* @__PURE__ */ Y(xi, {
		...i,
		className: T,
		onBlur: D,
		onFocus: E,
		placeholder: O,
		ref: u,
		type: k
	}), t[33] = i, t[34] = u, t[35] = E, t[36] = O, t[37] = k, t[38] = D, t[39] = A) : A = t[39];
	let j = a ? "cursor-not-allowed opacity-50" : "", M;
	t[40] === j ? M = t[41] : (M = W("absolute right-0 px-md text-text-secondary hover:text-text-primary focus:text-text-primary", "outline-none transition-colors", j), t[40] = j, t[41] = M);
	let N;
	t[42] === p ? N = t[43] : (N = Y(p ? $e : at, { className: "size-lg" }), t[42] = p, t[43] = N);
	let P;
	t[44] !== v || t[45] !== a || t[46] !== M || t[47] !== N ? (P = /* @__PURE__ */ Y(oi, {
		"aria-label": "toggle password visibility",
		className: M,
		isDisabled: a,
		onPress: v,
		children: N
	}), t[44] = v, t[45] = a, t[46] = M, t[47] = N, t[48] = P) : P = t[48];
	let F;
	t[49] !== A || t[50] !== P || t[51] !== w ? (F = /* @__PURE__ */ X("div", {
		className: w,
		children: [A, P]
	}), t[49] = A, t[50] = P, t[51] = w, t[52] = F) : F = t[52];
	let I;
	t[53] !== n || t[54] !== a || t[55] !== o ? (I = /* @__PURE__ */ Y(gl, {
		isDisabled: a,
		isInvalid: o,
		children: n
	}), t[53] = n, t[54] = a, t[55] = o, t[56] = I) : I = t[56];
	let L;
	return t[57] !== a || t[58] !== o || t[59] !== s || t[60] !== c || t[61] !== d || t[62] !== F || t[63] !== I || t[64] !== y || t[65] !== b || t[66] !== x ? (L = /* @__PURE__ */ X(Ji, {
		className: y,
		isDisabled: a,
		isInvalid: o,
		isReadOnly: s,
		isRequired: c,
		type: b,
		...d,
		children: [
			x,
			F,
			I
		]
	}), t[57] = a, t[58] = o, t[59] = s, t[60] = c, t[61] = d, t[62] = F, t[63] = I, t[64] = y, t[65] = b, t[66] = x, t[67] = L) : L = t[67], L;
}
//#endregion
//#region lib/components/AppSelector/AppSelector.tsx
var Ub = (e) => `app-selector-${e}`;
function Wb(e) {
	let t = K(64), { appOptions: n, selected: r, collapsed: i } = e, [a, o] = J(!1), s;
	t[0] === r ? s = t[1] : (s = Ub(r), t[0] = r, t[1] = s);
	let c = s, l = n.length === 1, u, d, f, p, m, h, g, _, v, b, x, S, C;
	if (t[2] !== n || t[3] !== i || t[4] !== l || t[5] !== a || t[6] !== r) {
		let e;
		t[20] === r ? e = t[21] : (e = (e) => e.label === r, t[20] = r, t[21] = e);
		let s = n.find(e);
		u = Gb, f = mi, C = "App selector", p = a, m = o;
		let c = l ? "" : "hover:bg-overlay-medium hover:backdrop-blur-[15px]", w = a ? "opacity-0" : "";
		t[22] !== c || t[23] !== w ? (S = W("w-fit rounded-10 p-xs shadow outline-none transition", c, w), t[22] = c, t[23] = w, t[24] = S) : S = t[24], d = Q, t[25] === Symbol.for("react.memo_cache_sentinel") ? (h = /* @__PURE__ */ Y(y, { className: "h-[0.75em] w-auto" }), t[25] = h) : h = t[25], g = `App selector - currently selected: ${r}`;
		let T = l ? "border-interactive-disabled-outline text-interactive-disabled-foreground" : "cursor-pointer border-interactive-secondary-button-enabled-outline text-interactive-primary-button-enabled-background hover:border-interactive-primary-button-enabled-background hover:bg-interactive-primary-button-enabled-background hover:text-interactive-primary-button-enabled-foreground", E = a ? "opacity-0" : "";
		t[26] !== T || t[27] !== E ? (_ = W("flex items-baseline justify-center gap-[0.5rem] rounded-10 bg-background-primary px-xs py-3xs text-label-medium outline-none transition", T, E), t[26] = T, t[27] = E, t[28] = _) : _ = t[28], v = l, b = "plain", x = i ? null : /* @__PURE__ */ X(Dr, { children: [/* @__PURE__ */ Y("span", {
			className: "whitespace-nowrap",
			children: r
		}), u(s, !1)] }), t[2] = n, t[3] = i, t[4] = l, t[5] = a, t[6] = r, t[7] = u, t[8] = d, t[9] = f, t[10] = p, t[11] = m, t[12] = h, t[13] = g, t[14] = _, t[15] = v, t[16] = b, t[17] = x, t[18] = S, t[19] = C;
	} else u = t[7], d = t[8], f = t[9], p = t[10], m = t[11], h = t[12], g = t[13], _ = t[14], v = t[15], b = t[16], x = t[17], S = t[18], C = t[19];
	let w;
	t[29] !== d || t[30] !== h || t[31] !== g || t[32] !== _ || t[33] !== v || t[34] !== b || t[35] !== x ? (w = /* @__PURE__ */ Y(d, {
		IconRight: h,
		"aria-label": g,
		className: _,
		isDisabled: v,
		variant: b,
		children: x
	}), t[29] = d, t[30] = h, t[31] = g, t[32] = _, t[33] = v, t[34] = b, t[35] = x, t[36] = w) : w = t[36];
	let T;
	t[37] !== w || t[38] !== S ? (T = /* @__PURE__ */ Y("div", {
		className: S,
		children: w
	}), t[37] = w, t[38] = S, t[39] = T) : T = t[39];
	let E = i ? "bottom left" : "bottom", D;
	t[40] === c ? D = t[41] : (D = [c], t[40] = c, t[41] = D);
	let O;
	if (t[42] !== u || t[43] !== n || t[44] !== r) {
		let e;
		t[46] === r ? e = t[47] : (e = (e, t) => e.label === r ? -1 : +(t.label === r), t[46] = r, t[47] = e);
		let i;
		t[48] !== u || t[49] !== r ? (i = (e) => {
			let t = Ub(e.label), n = e.label === r;
			return /* @__PURE__ */ X(Ei, {
				"aria-label": e.label,
				className: W("size-full flex w-fit cursor-pointer items-baseline justify-center gap-[0.5rem] whitespace-nowrap rounded-10 border px-3 py-1 text-label-medium outline-none transition", n ? "border-interactive-primary-button-enabled-background bg-interactive-primary-button-enabled-background text-interactive-primary-button-enabled-foreground" : "border-interactive-secondary-button-enabled-outline bg-neutral-white/30 text-interactive-secondary-button-enabled-foreground hover:bg-interactive-secondary-button-hover-background hover:text-interactive-secondary-button-enabled-foreground active:bg-interactive-secondary-button-focus-background active:text-interactive-secondary-button-focus-foreground"),
				href: e.href,
				id: t,
				onAction: () => o(!1),
				children: [
					/* @__PURE__ */ Y(Si, {
						className: "whitespace-nowrap font-semibold",
						children: e.label
					}),
					n ? /* @__PURE__ */ Y(y, { className: "h-[0.75em] w-auto" }) : null,
					u(e, n)
				]
			}, t);
		}, t[48] = u, t[49] = r, t[50] = i) : i = t[50], O = n.sort(e).map(i), t[42] = u, t[43] = n, t[44] = r, t[45] = O;
	} else O = t[45];
	let k;
	t[51] !== D || t[52] !== O ? (k = /* @__PURE__ */ Y(Ti, {
		"aria-label": "App selection options",
		className: "flex flex-col gap-[0.5rem] rounded-lg border border-background-secondary bg-interactive-glass-button-enabled-background p-xs shadow-md outline-none backdrop-blur-md",
		selectedKeys: D,
		selectionMode: "single",
		children: O
	}), t[51] = D, t[52] = O, t[53] = k) : k = t[53];
	let A;
	t[54] !== E || t[55] !== k ? (A = /* @__PURE__ */ Y(ji, {
		offset: -40,
		placement: E,
		children: k
	}), t[54] = E, t[55] = k, t[56] = A) : A = t[56];
	let j;
	return t[57] !== f || t[58] !== p || t[59] !== m || t[60] !== T || t[61] !== A || t[62] !== C ? (j = /* @__PURE__ */ X(f, {
		"aria-label": C,
		isOpen: p,
		onOpenChange: m,
		children: [T, A]
	}), t[57] = f, t[58] = p, t[59] = m, t[60] = T, t[61] = A, t[62] = C, t[63] = j) : j = t[63], j;
}
function Gb(e, t) {
	return e?.isBeta ? /* @__PURE__ */ Y("span", {
		className: W("pl-.5 text-label-extra-small", t ? "!text-interactive-primary-button-enabled-foreground" : ""),
		children: "BETA"
	}) : null;
}
//#endregion
//#region lib/components/Sidebar/SidebarLink.tsx
function Kb(e, t) {
	let n = (e) => e.replace(/\/+$/, "") || "/", r = n(e), i = n(t);
	return r === i || r.startsWith(`${i}/`);
}
function qb(e, t, n) {
	return Kb(e, t) || (n?.some((t) => Kb(e, t)) ?? !1);
}
function Jb(e) {
	let t = K(47), { children: n, isExternalLink: r, target: i, navigate: a, pathname: o, className: s, isChild: c, indented: l, activePaths: u, variant: d, onPreload: f, "aria-describedby": p } = e, m = d === void 0 ? "default" : d, h = qb(o, i, u), g = ga(o === i ? void 0 : f), _;
	t[0] !== a || t[1] !== i ? (_ = (e) => {
		e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey && (e.preventDefault(), a(i));
	}, t[0] = a, t[1] = i, t[2] = _) : _ = t[2];
	let v = _;
	if (r) {
		let e;
		t[3] === s ? e = t[4] : (e = W("flex items-center justify-between", s), t[3] = s, t[4] = e);
		let r;
		t[5] === Symbol.for("react.memo_cache_sentinel") ? (r = /* @__PURE__ */ Y(sn, {}), t[5] = r) : r = t[5];
		let a;
		return t[6] !== p || t[7] !== n || t[8] !== e || t[9] !== i ? (a = /* @__PURE__ */ X("a", {
			"aria-describedby": p,
			className: e,
			href: i,
			rel: "noreferrer",
			target: "_blank",
			children: [n, r]
		}), t[6] = p, t[7] = n, t[8] = e, t[9] = i, t[10] = a) : a = t[10], a;
	}
	if (m === "popout") {
		let e;
		t[11] === s ? e = t[12] : (e = W("flex w-full cursor-pointer items-center justify-between gap-xs px-xl py-sm text-label-medium text-text-secondary outline-none transition-colors hover:bg-background-tertiary hover:text-text-primary focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-outline-brand", s), t[11] = s, t[12] = e);
		let r;
		return t[13] !== p || t[14] !== n || t[15] !== v || t[16] !== g || t[17] !== e || t[18] !== i ? (r = /* @__PURE__ */ Y("a", {
			"aria-describedby": p,
			className: e,
			href: i,
			onClick: v,
			...g,
			children: n
		}), t[13] = p, t[14] = n, t[15] = v, t[16] = g, t[17] = e, t[18] = i, t[19] = r) : r = t[19], r;
	}
	if (m === "grouped") {
		let e = h ? "bg-overlay-brand text-text-primary" : "text-text-secondary hover:text-text-primary", r;
		t[20] !== s || t[21] !== e ? (r = W("flex w-full cursor-pointer items-center py-xxs pl-xl pr-[20px] text-label-small font-medium transition-colors duration-300", e, s), t[20] = s, t[21] = e, t[22] = r) : r = t[22];
		let a;
		return t[23] !== p || t[24] !== n || t[25] !== v || t[26] !== g || t[27] !== r || t[28] !== i ? (a = /* @__PURE__ */ Y("a", {
			"aria-describedby": p,
			className: r,
			href: i,
			onClick: v,
			...g,
			children: n
		}), t[23] = p, t[24] = n, t[25] = v, t[26] = g, t[27] = r, t[28] = i, t[29] = a) : a = t[29], a;
	}
	let y = l ? "pl-4xl" : "pl-xl", b = h ? "border-outline-brand bg-overlay-brand" : "border-transparent", x;
	t[30] !== s || t[31] !== y || t[32] !== b ? (x = W("flex w-full cursor-pointer items-center border-r-2 py-xxs pr-[20px] transition-colors duration-300", y, b, s), t[30] = s, t[31] = y, t[32] = b, t[33] = x) : x = t[33];
	let S = c ? "text-label-small font-normal text-text-secondary" : "text-title-small", C = h ? "font-semibold text-text-brand" : "", w;
	t[34] !== S || t[35] !== C ? (w = W("transition-colors duration-300", S, C), t[34] = S, t[35] = C, t[36] = w) : w = t[36];
	let T;
	t[37] !== n || t[38] !== w ? (T = /* @__PURE__ */ Y("div", {
		className: w,
		children: n
	}), t[37] = n, t[38] = w, t[39] = T) : T = t[39];
	let E;
	return t[40] !== p || t[41] !== v || t[42] !== g || t[43] !== x || t[44] !== T || t[45] !== i ? (E = /* @__PURE__ */ Y("a", {
		"aria-describedby": p,
		className: x,
		href: i,
		onClick: v,
		...g,
		children: T
	}), t[40] = p, t[41] = v, t[42] = g, t[43] = x, t[44] = T, t[45] = i, t[46] = E) : E = t[46], E;
}
//#endregion
//#region lib/components/Sidebar/NavItemList.tsx
function Yb(e, t) {
	return t.target ? e.startsWith(t.target) || (t.activePaths?.some((t) => e.startsWith(t)) ?? !1) : Xb(e, t.children ?? []);
}
function Xb(e, t) {
	return t.some((t) => Yb(e, t));
}
function Zb(e) {
	let t = K(12), { label: n, collapsed: r, Icon: i } = e, a = i ? "gap-xs" : "", o;
	t[0] === a ? o = t[1] : (o = W("flex w-full items-center", a), t[0] = a, t[1] = o);
	let s;
	t[2] !== i || t[3] !== r ? (s = i ? /* @__PURE__ */ Y("div", {
		className: W("flex items-center justify-center stroke-text-primary", r ? "w-full" : ""),
		children: /* @__PURE__ */ Y(i, { className: W("stroke-0", r ? "size-lg" : "size-md") })
	}) : null, t[2] = i, t[3] = r, t[4] = s) : s = t[4];
	let c;
	t[5] !== r || t[6] !== n ? (c = r ? null : /* @__PURE__ */ Y("div", {
		className: "whitespace-nowrap text-label-small font-normal text-text-secondary",
		children: n
	}), t[5] = r, t[6] = n, t[7] = c) : c = t[7];
	let l;
	return t[8] !== o || t[9] !== s || t[10] !== c ? (l = /* @__PURE__ */ X("div", {
		className: o,
		children: [s, c]
	}), t[8] = o, t[9] = s, t[10] = c, t[11] = l) : l = t[11], l;
}
function Qb(e) {
	let t = K(89), { data: n, collapsed: r, collapsible: i, variant: a, pathname: o, navigate: s, Icon: c, onPopoutToggle: l } = e, u = r !== void 0 && r, d = i !== void 0 && i, f = a === void 0 ? "default" : a;
	if (n.popoutContent !== void 0) {
		let e;
		t[0] !== n.mainPath || t[1] !== o ? (e = !!n.mainPath && o.startsWith(n.mainPath), t[0] = n.mainPath, t[1] = o, t[2] = e) : e = t[2];
		let r = e, i = r ? "border-outline-brand bg-overlay-brand font-semibold text-text-brand" : "border-transparent text-text-secondary hover:text-text-primary", a;
		t[3] === i ? a = t[4] : (a = W("flex w-full cursor-pointer items-center border-r-2 py-xxs pl-xl pr-[20px] transition-colors duration-300", i), t[3] = i, t[4] = a);
		let s;
		t[5] !== n.id || t[6] !== l ? (s = () => l?.(n.id), t[5] = n.id, t[6] = l, t[7] = s) : s = t[7];
		let d;
		t[8] !== c || t[9] !== u ? (d = c ? /* @__PURE__ */ Y("div", {
			className: "mr-xs flex items-center justify-center stroke-text-primary",
			children: /* @__PURE__ */ Y(c, { className: W("stroke-0", u ? "size-lg" : "size-md") })
		}) : null, t[8] = c, t[9] = u, t[10] = d) : d = t[10];
		let f;
		t[11] !== u || t[12] !== n.label || t[13] !== r ? (f = u ? null : /* @__PURE__ */ Y("span", {
			className: W("whitespace-nowrap text-label-small", r ? "font-semibold" : "font-medium"),
			children: n.label
		}), t[11] = u, t[12] = n.label, t[13] = r, t[14] = f) : f = t[14];
		let p;
		t[15] !== u || t[16] !== n.chip ? (p = !u && n.chip ? /* @__PURE__ */ Y("span", {
			className: "ml-auto rounded-sm bg-background-informative px-xs py-3xs text-label-extra-small font-bold capitalize text-text-informative",
			children: n.chip
		}) : null, t[15] = u, t[16] = n.chip, t[17] = p) : p = t[17];
		let m;
		return t[18] !== p || t[19] !== a || t[20] !== s || t[21] !== d || t[22] !== f ? (m = /* @__PURE__ */ X("button", {
			className: a,
			onClick: s,
			type: "button",
			children: [
				d,
				f,
				p
			]
		}), t[18] = p, t[19] = a, t[20] = s, t[21] = d, t[22] = f, t[23] = m) : m = t[23], m;
	}
	if (n.children) {
		let e = f === "grouped", r = n.collapsible ?? d, i;
		t[24] !== n.children || t[25] !== o ? (i = Xb(o, n.children), t[24] = n.children, t[25] = o, t[26] = i) : i = t[26];
		let a = i, l;
		if (t[27] !== u || t[28] !== n.children || t[29] !== e || t[30] !== s || t[31] !== o || t[32] !== f) {
			let r;
			t[34] !== u || t[35] !== e || t[36] !== s || t[37] !== o || t[38] !== f ? (r = (t) => /* @__PURE__ */ Y(Jb, {
				activePaths: t.activePaths,
				indented: !e && !u,
				isExternalLink: t.isExternalLink,
				navigate: s,
				onPreload: t.onPreload,
				pathname: o,
				target: t.target ?? "",
				variant: f,
				isChild: !0,
				children: /* @__PURE__ */ X("div", {
					className: "flex items-center gap-xs",
					children: [
						(e || u) && t.Icon ? /* @__PURE__ */ Y(t.Icon, { className: "size-md stroke-0 shrink-0" }) : null,
						u ? null : /* @__PURE__ */ Y("span", {
							className: e ? "whitespace-nowrap" : void 0,
							children: t.label
						}),
						!u && t.chip ? /* @__PURE__ */ Y("span", {
							className: "rounded-xl bg-data-viz-soft-indigo px-xs text-label-extra-small font-bold capitalize text-data-viz-indigo-800",
							children: t.chip
						}) : null
					]
				})
			}, t.id), t[34] = u, t[35] = e, t[36] = s, t[37] = o, t[38] = f, t[39] = r) : r = t[39], l = n.children.map(r), t[27] = u, t[28] = n.children, t[29] = e, t[30] = s, t[31] = o, t[32] = f, t[33] = l;
		} else l = t[33];
		let p = l;
		if (e && u) {
			let e;
			return t[40] === p ? e = t[41] : (e = /* @__PURE__ */ Y("div", { children: p }), t[40] = p, t[41] = e), e;
		}
		let m;
		t[42] !== c || t[43] !== u || t[44] !== n.label || t[45] !== e ? (m = e ? /* @__PURE__ */ Y("div", {
			className: "whitespace-nowrap text-label-extra-small-strong capitalize text-text-secondary",
			children: n.label
		}) : /* @__PURE__ */ Y(Zb, {
			Icon: c,
			collapsed: u,
			label: n.label
		}), t[42] = c, t[43] = u, t[44] = n.label, t[45] = e, t[46] = m) : m = t[46];
		let h = m, g = e ? "py-3xs" : "py-xxs";
		if (!r) {
			let e;
			t[47] === g ? e = t[48] : (e = W("flex w-full items-center pl-xl pr-[20px]", g), t[47] = g, t[48] = e);
			let n;
			t[49] !== h || t[50] !== e ? (n = /* @__PURE__ */ Y("div", {
				className: e,
				children: h
			}), t[49] = h, t[50] = e, t[51] = n) : n = t[51];
			let r;
			t[52] === p ? r = t[53] : (r = /* @__PURE__ */ Y("div", { children: p }), t[52] = p, t[53] = r);
			let i;
			return t[54] !== n || t[55] !== r ? (i = /* @__PURE__ */ X("div", { children: [n, r] }), t[54] = n, t[55] = r, t[56] = i) : i = t[56], i;
		}
		let _ = a || (n.defaultExpanded ?? !1), v = n.onExpandedChange, y;
		t[57] === g ? y = t[58] : (y = W("flex w-full items-center justify-between pl-xl pr-[20px]", g), t[57] = g, t[58] = y);
		let b = e ? "size-sm text-text-secondary" : void 0, x;
		t[59] !== u || t[60] !== h || t[61] !== b || t[62] !== y ? (x = /* @__PURE__ */ Y(Lm, {
			className: y,
			collapsed: u,
			iconClassName: b,
			children: h
		}), t[59] = u, t[60] = h, t[61] = b, t[62] = y, t[63] = x) : x = t[63];
		let S;
		t[64] === p ? S = t[65] : (S = /* @__PURE__ */ Y(Rm, { children: p }), t[64] = p, t[65] = S);
		let C;
		return t[66] !== n.onExpandedChange || t[67] !== x || t[68] !== S || t[69] !== _ ? (C = /* @__PURE__ */ X(Im, {
			defaultExpanded: _,
			onExpandedChange: v,
			children: [x, S]
		}), t[66] = n.onExpandedChange, t[67] = x, t[68] = S, t[69] = _, t[70] = C) : C = t[70], C;
	}
	let p;
	t[71] === c ? p = t[72] : (p = c ? /* @__PURE__ */ Y(c, { className: "size-md shrink-0 stroke-0" }) : null, t[71] = c, t[72] = p);
	let m;
	t[73] !== u || t[74] !== n.label || t[75] !== f ? (m = u ? null : /* @__PURE__ */ Y("span", {
		className: f === "grouped" ? "whitespace-nowrap" : void 0,
		children: n.label
	}), t[73] = u, t[74] = n.label, t[75] = f, t[76] = m) : m = t[76];
	let h;
	t[77] !== p || t[78] !== m ? (h = /* @__PURE__ */ X("div", {
		className: "flex items-center gap-xs",
		children: [p, m]
	}), t[77] = p, t[78] = m, t[79] = h) : h = t[79];
	let g;
	return t[80] !== n.activePaths || t[81] !== n.isExternalLink || t[82] !== n.onPreload || t[83] !== n.target || t[84] !== s || t[85] !== o || t[86] !== h || t[87] !== f ? (g = /* @__PURE__ */ Y(Jb, {
		activePaths: n.activePaths,
		isExternalLink: n.isExternalLink,
		navigate: s,
		onPreload: n.onPreload,
		pathname: o,
		target: n.target,
		variant: f,
		isChild: !0,
		children: h
	}), t[80] = n.activePaths, t[81] = n.isExternalLink, t[82] = n.onPreload, t[83] = n.target, t[84] = s, t[85] = o, t[86] = h, t[87] = f, t[88] = g) : g = t[88], g;
}
//#endregion
//#region lib/components/Sidebar/SidebarPopout.tsx
function $b(e) {
	let t = K(9), { isOpen: n, children: r, className: i } = e, a = n ? "w-[16rem] border-l border-outline-decorative shadow-lg" : "w-0", o;
	t[0] !== i || t[1] !== a ? (o = W("flex h-screen flex-shrink-0 flex-col overflow-hidden", "bg-background-secondary transition-[width] duration-200 ease-in-out", a, i), t[0] = i, t[1] = a, t[2] = o) : o = t[2];
	let s;
	t[3] === Symbol.for("react.memo_cache_sentinel") ? (s = { scrollbarWidth: "none" }, t[3] = s) : s = t[3];
	let c;
	t[4] === r ? c = t[5] : (c = /* @__PURE__ */ Y("div", {
		className: "w-[16rem] flex-1 overflow-y-auto",
		style: s,
		children: r
	}), t[4] = r, t[5] = c);
	let l;
	return t[6] !== o || t[7] !== c ? (l = /* @__PURE__ */ Y("div", {
		className: o,
		children: c
	}), t[6] = o, t[7] = c, t[8] = l) : l = t[8], l;
}
//#endregion
//#region lib/components/Sidebar/Sidebar.tsx
function ex(e) {
	let t = K(66), { appSelectorOptions: n, selectedApp: r, Callout: i, ProviderSelector: a, SignInMenu: o, pathname: s, navItems: c, collapsed: l, collapsible: u, variant: d, handleCollapsed: f, navigate: p, className: m } = e, h = l !== void 0 && l, g = u !== void 0 && u, _ = d === void 0 ? "default" : d, [v, y] = J(null), b;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (b = (e) => {
		y((t) => t === e ? null : e);
	}, t[0] = b) : b = t[0];
	let x = b, S;
	t[1] === p ? S = t[2] : (S = (e) => {
		y(null), p(e);
	}, t[1] = p, t[2] = S);
	let C = S, w;
	t[3] !== c || t[4] !== v ? (w = v ? c.find((e) => e.id === v && e.popoutContent !== void 0) : null, t[3] = c, t[4] = v, t[5] = w) : w = t[5];
	let T = w, E = h ? "w-[4.5rem]" : "", D;
	t[6] !== m || t[7] !== E ? (D = W("text-primary z-10 flex h-screen w-[13.625rem] flex-col items-center border-overlay-medium bg-background-secondary shadow backdrop-blur", E, m), t[6] = m, t[7] = E, t[8] = D) : D = t[8];
	let O = h ? "flex-col gap-md" : "", k;
	t[9] === O ? k = t[10] : (k = W("flex w-full items-center justify-between gap-x-sm px-xl py-lg", O), t[9] = O, t[10] = k);
	let A;
	t[11] === Symbol.for("react.memo_cache_sentinel") ? (A = /* @__PURE__ */ Y("a", {
		className: "flex justify-center",
		href: "/",
		children: /* @__PURE__ */ Y(bt, {
			className: "text-brand-primary",
			size: 28
		})
	}), t[11] = A) : A = t[11];
	let j;
	t[12] !== n || t[13] !== h || t[14] !== r ? (j = /* @__PURE__ */ Y(Wb, {
		appOptions: n,
		collapsed: h,
		selected: r
	}), t[12] = n, t[13] = h, t[14] = r, t[15] = j) : j = t[15];
	let M;
	t[16] !== k || t[17] !== j ? (M = /* @__PURE__ */ X("div", {
		className: k,
		children: [A, j]
	}), t[16] = k, t[17] = j, t[18] = M) : M = t[18];
	let N;
	t[19] !== h || t[20] !== f ? (N = h ? /* @__PURE__ */ Y(Q, {
		className: "size-fit mb-lg rounded-md border border-neutral-white px-px py-px text-interactive-glass-button-enabled-foreground hover:bg-neutral-white",
		onPress: f ? () => f() : tx,
		variant: "plain",
		children: /* @__PURE__ */ Y(Pt, { className: "size-xxl" })
	}) : null, t[19] = h, t[20] = f, t[21] = N) : N = t[21];
	let P;
	t[22] === Symbol.for("react.memo_cache_sentinel") ? (P = /* @__PURE__ */ Y("hr", { className: "mx-xl mb-lg h-1 self-stretch border-outline-decorative" }), t[22] = P) : P = t[22];
	let F;
	t[23] !== a || t[24] !== h ? (F = !h && a && /* @__PURE__ */ Y("div", {
		className: "mb-lg flex justify-center px-xl",
		children: a
	}), t[23] = a, t[24] = h, t[25] = F) : F = t[25];
	let I = _ === "grouped" ? "gap-md" : "", L;
	t[26] === I ? L = t[27] : (L = W("flex w-full flex-col overflow-x-hidden overflow-y-scroll", I), t[26] = I, t[27] = L);
	let R;
	t[28] === Symbol.for("react.memo_cache_sentinel") ? (R = { scrollbarWidth: "none" }, t[28] = R) : R = t[28];
	let z;
	if (t[29] !== h || t[30] !== g || t[31] !== C || t[32] !== c || t[33] !== s || t[34] !== _) {
		let e;
		t[36] !== h || t[37] !== g || t[38] !== C || t[39] !== s || t[40] !== _ ? (e = (e, t) => {
			let n = _ === "default", r = n && t > 0 && !!(e.startsGroup || e.groupLabel), i = n && !h && !!e.groupLabel;
			return /* @__PURE__ */ X("div", {
				className: r ? "mt-md" : void 0,
				children: [i ? /* @__PURE__ */ Y("div", {
					className: "mb-xxs whitespace-nowrap px-xl text-label-extra-small-strong text-text-secondary",
					children: e.groupLabel
				}) : null, /* @__PURE__ */ Y(Qb, {
					Icon: e.Icon,
					collapsed: h,
					collapsible: g,
					data: e,
					navigate: C,
					onPopoutToggle: x,
					pathname: s,
					variant: _
				})]
			}, e.id);
		}, t[36] = h, t[37] = g, t[38] = C, t[39] = s, t[40] = _, t[41] = e) : e = t[41], z = c.map(e), t[29] = h, t[30] = g, t[31] = C, t[32] = c, t[33] = s, t[34] = _, t[35] = z;
	} else z = t[35];
	let B;
	t[42] !== L || t[43] !== z ? (B = /* @__PURE__ */ Y("div", {
		className: L,
		style: R,
		children: z
	}), t[42] = L, t[43] = z, t[44] = B) : B = t[44];
	let V;
	t[45] !== i || t[46] !== h ? (V = !h && i ? /* @__PURE__ */ Y("div", {
		className: "w-full p-xs",
		children: i
	}) : null, t[45] = i, t[46] = h, t[47] = V) : V = t[47];
	let ee = o || null, H;
	t[48] === ee ? H = t[49] : (H = /* @__PURE__ */ Y("div", {
		className: "mb-xs flex items-center justify-center pt-md",
		children: ee
	}), t[48] = ee, t[49] = H);
	let U;
	t[50] !== V || t[51] !== H ? (U = /* @__PURE__ */ X("div", {
		className: "mt-auto flex w-full flex-col items-center",
		children: [V, H]
	}), t[50] = V, t[51] = H, t[52] = U) : U = t[52];
	let te;
	t[53] !== M || t[54] !== N || t[55] !== F || t[56] !== B || t[57] !== U || t[58] !== D ? (te = /* @__PURE__ */ X("aside", {
		className: D,
		children: [
			M,
			N,
			P,
			F,
			B,
			U
		]
	}), t[53] = M, t[54] = N, t[55] = F, t[56] = B, t[57] = U, t[58] = D, t[59] = te) : te = t[59];
	let ne = !!T, re = T?.popoutContent ?? null, ie;
	t[60] !== ne || t[61] !== re ? (ie = /* @__PURE__ */ Y($b, {
		isOpen: ne,
		children: re
	}), t[60] = ne, t[61] = re, t[62] = ie) : ie = t[62];
	let ae;
	return t[63] !== te || t[64] !== ie ? (ae = /* @__PURE__ */ X("div", {
		className: "relative flex h-screen",
		children: [te, ie]
	}), t[63] = te, t[64] = ie, t[65] = ae) : ae = t[65], ae;
}
function tx() {
	return null;
}
//#endregion
//#region lib/components/SkeletonStatus/SkeletonStatus.tsx
function nx(e) {
	let t = K(8), { label: n, className: r, children: i } = e, a;
	t[0] === n ? a = t[1] : (a = /* @__PURE__ */ Y("div", {
		"aria-label": n,
		className: "sr-only",
		role: "status",
		children: n
	}), t[0] = n, t[1] = a);
	let o;
	t[2] !== i || t[3] !== r ? (o = /* @__PURE__ */ Y("div", {
		"aria-hidden": "true",
		className: r,
		children: i
	}), t[2] = i, t[3] = r, t[4] = o) : o = t[4];
	let s;
	return t[5] !== a || t[6] !== o ? (s = /* @__PURE__ */ X(Dr, { children: [a, o] }), t[5] = a, t[6] = o, t[7] = s) : s = t[7], s;
}
//#endregion
//#region lib/components/SectionSkeleton/SectionSkeleton.tsx
function rx(e) {
	let t = K(6), { label: n } = e, r = n === void 0 ? "Loading section…" : n, i, a, o, s;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (i = /* @__PURE__ */ Y(Gl, {
		height: 20,
		variant: "text",
		width: 240
	}), a = /* @__PURE__ */ Y(Gl, {
		height: 16,
		variant: "text",
		width: "80%"
	}), o = /* @__PURE__ */ Y(Gl, {
		height: 16,
		variant: "text",
		width: "60%"
	}), s = /* @__PURE__ */ Y(Gl, {
		height: 160,
		variant: "rectangular",
		width: "100%"
	}), t[0] = i, t[1] = a, t[2] = o, t[3] = s) : (i = t[0], a = t[1], o = t[2], s = t[3]);
	let c;
	return t[4] === r ? c = t[5] : (c = /* @__PURE__ */ X(nx, {
		className: "flex w-full flex-col gap-lg",
		label: r,
		children: [
			i,
			a,
			o,
			s
		]
	}), t[4] = r, t[5] = c), c;
}
//#endregion
//#region lib/components/TableSkeleton/TableSkeleton.tsx
var ix = [
	"70%",
	"45%",
	"60%",
	"35%",
	"55%"
];
function ax(e) {
	let t = K(3), { rows: n } = e, r;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (r = /* @__PURE__ */ Y("div", {
		className: "grid grid-cols-5 gap-md border-b border-overlay-medium py-sm",
		children: ix.map(cx)
	}), t[0] = r) : r = t[0];
	let i;
	return t[1] === n ? i = t[2] : (i = /* @__PURE__ */ X("div", {
		className: "flex flex-col",
		children: [r, Array.from({ length: n }, ox)]
	}), t[1] = n, t[2] = i), i;
}
function ox(e, t) {
	return /* @__PURE__ */ Y("div", {
		className: "grid grid-cols-5 gap-md py-md",
		children: ix.map(sx)
	}, t);
}
function sx(e) {
	return /* @__PURE__ */ Y(Gl, {
		height: 16,
		variant: "text",
		width: e
	}, e);
}
function cx(e) {
	return /* @__PURE__ */ Y(Gl, {
		height: 12,
		variant: "text",
		width: "50%"
	}, e);
}
function lx(e) {
	let t = K(8), { toolbar: n, pagination: r } = e, i;
	t[0] === n ? i = t[1] : (i = n ? /* @__PURE__ */ X("div", {
		className: "flex items-center justify-between",
		children: [/* @__PURE__ */ Y(Gl, {
			height: 36,
			variant: "rectangular",
			width: 320
		}), /* @__PURE__ */ X("div", {
			className: "flex gap-sm",
			children: [/* @__PURE__ */ Y(Gl, {
				height: 36,
				variant: "rectangular",
				width: 96
			}), /* @__PURE__ */ Y(Gl, {
				height: 36,
				variant: "rectangular",
				width: 96
			})]
		})]
	}) : null, t[0] = n, t[1] = i);
	let a;
	t[2] === Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ Y(ax, { rows: 8 }), t[2] = a) : a = t[2];
	let o;
	t[3] === r ? o = t[4] : (o = r ? /* @__PURE__ */ Y("div", {
		className: "flex justify-end",
		children: /* @__PURE__ */ Y(Gl, {
			height: 28,
			variant: "rectangular",
			width: 144
		})
	}) : null, t[3] = r, t[4] = o);
	let s;
	return t[5] !== i || t[6] !== o ? (s = /* @__PURE__ */ X("div", {
		className: "flex w-full flex-col gap-lg",
		children: [
			i,
			a,
			o
		]
	}), t[5] = i, t[6] = o, t[7] = s) : s = t[7], s;
}
function ux(e) {
	let t = K(6), { label: n, toolbar: r, pagination: i } = e, a = n === void 0 ? "Loading table…" : n, o = r !== void 0 && r, s = i !== void 0 && i, c;
	t[0] !== s || t[1] !== o ? (c = /* @__PURE__ */ Y(lx, {
		pagination: s,
		toolbar: o
	}), t[0] = s, t[1] = o, t[2] = c) : c = t[2];
	let l;
	return t[3] !== a || t[4] !== c ? (l = /* @__PURE__ */ Y(nx, {
		label: a,
		children: c
	}), t[3] = a, t[4] = c, t[5] = l) : l = t[5], l;
}
//#endregion
//#region lib/components/PageSkeleton/PageSkeleton.tsx
function dx(e) {
	let t = K(7), { kind: n, tabs: r, label: i } = e, a = n === void 0 ? "detail" : n, o = r !== void 0 && r, s = i === void 0 ? "Loading page…" : i, c;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (c = /* @__PURE__ */ Y("div", {
		className: "sticky top-0 z-10 mb-xl mt-xs",
		children: /* @__PURE__ */ Y(du, {
			breadcrumbs: [],
			pathname: "",
			isLoading: !0
		})
	}), t[0] = c) : c = t[0];
	let l;
	t[1] !== a || t[2] !== o ? (l = /* @__PURE__ */ Y(bu, {
		className: "grow",
		children: /* @__PURE__ */ Y(_x, {
			kind: a,
			tabs: o
		})
	}), t[1] = a, t[2] = o, t[3] = l) : l = t[3];
	let u;
	return t[4] !== s || t[5] !== l ? (u = /* @__PURE__ */ X(nx, {
		className: "flex h-full flex-col",
		label: s,
		children: [c, l]
	}), t[4] = s, t[5] = l, t[6] = u) : u = t[6], u;
}
var fx = [
	112,
	128,
	104
], px = [
	120,
	96,
	140,
	104
], mx = [
	140,
	96,
	160,
	120
];
function hx() {
	let e = K(1), t;
	return e[0] === Symbol.for("react.memo_cache_sentinel") ? (t = /* @__PURE__ */ Y("div", {
		className: "mb-sm flex gap-xs",
		children: fx.map(gx)
	}), e[0] = t) : t = e[0], t;
}
function gx(e) {
	return /* @__PURE__ */ Y(Gl, {
		height: 30,
		variant: "rectangular",
		width: e
	}, e);
}
function _x(e) {
	let t = K(11), { kind: n, tabs: r } = e;
	if (n === "table") {
		let e;
		t[0] === r ? e = t[1] : (e = r ? /* @__PURE__ */ Y(hx, {}) : null, t[0] = r, t[1] = e);
		let n;
		t[2] === Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ Y(lx, {
			pagination: !1,
			toolbar: !0
		}), t[2] = n) : n = t[2];
		let i;
		return t[3] === e ? i = t[4] : (i = /* @__PURE__ */ X(Dr, { children: [e, n] }), t[3] = e, t[4] = i), i;
	}
	if (n === "form") {
		let e;
		t[5] === Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ Y("div", {
			className: "mb-xl",
			children: /* @__PURE__ */ Y(Gl, {
				height: 28,
				variant: "text",
				width: 240
			})
		}), t[5] = e) : e = t[5];
		let n;
		t[6] === Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ Y("div", {
			className: "flex flex-col gap-y-lg",
			children: px.map(yx)
		}), t[6] = n) : n = t[6];
		let r;
		return t[7] === Symbol.for("react.memo_cache_sentinel") ? (r = /* @__PURE__ */ X("div", {
			className: "w-full max-w-[700px]",
			children: [
				e,
				n,
				/* @__PURE__ */ X("div", {
					className: "mt-xl flex gap-sm",
					children: [/* @__PURE__ */ Y(Gl, {
						height: 36,
						variant: "rectangular",
						width: 96
					}), /* @__PURE__ */ Y(Gl, {
						height: 36,
						variant: "rectangular",
						width: 96
					})]
				})
			]
		}), t[7] = r) : r = t[7], r;
	}
	let i;
	t[8] === Symbol.for("react.memo_cache_sentinel") ? (i = /* @__PURE__ */ Y(Gl, {
		height: 28,
		variant: "text",
		width: 320
	}), t[8] = i) : i = t[8];
	let a;
	t[9] === Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ X("div", {
		className: "mb-xl flex items-center justify-between",
		children: [i, /* @__PURE__ */ X("div", {
			className: "flex gap-sm",
			children: [/* @__PURE__ */ Y(Gl, {
				height: 36,
				variant: "rectangular",
				width: 96
			}), /* @__PURE__ */ Y(Gl, {
				height: 36,
				variant: "rectangular",
				width: 96
			})]
		})]
	}), t[9] = a) : a = t[9];
	let o;
	return t[10] === Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ X(Dr, { children: [
		a,
		/* @__PURE__ */ Y("div", {
			className: "mb-xl grid grid-cols-[repeat(auto-fit,minmax(160px,1fr))] gap-lg",
			children: mx.map(vx)
		}),
		/* @__PURE__ */ Y(hx, {}),
		/* @__PURE__ */ Y(ax, { rows: 5 })
	] }), t[10] = o) : o = t[10], o;
}
function vx(e) {
	return /* @__PURE__ */ X("div", {
		className: "flex flex-col gap-xs",
		children: [/* @__PURE__ */ Y(Gl, {
			height: 12,
			variant: "text",
			width: 80
		}), /* @__PURE__ */ Y(Gl, {
			height: 16,
			variant: "text",
			width: e
		})]
	}, e);
}
function yx(e) {
	return /* @__PURE__ */ X("div", {
		className: "flex flex-col gap-xs",
		children: [/* @__PURE__ */ Y(Gl, {
			height: 14,
			variant: "text",
			width: e
		}), /* @__PURE__ */ Y(Gl, {
			height: 40,
			variant: "rectangular",
			width: "100%"
		})]
	}, e);
}
//#endregion
//#region lib/components/StatCard/StatCardContent.tsx
function bx(e) {
	let t = K(8), { message: n, children: r, className: i } = e, a;
	t[0] === r ? a = t[1] : (a = typeof r == "string" ? /* @__PURE__ */ Y("div", {
		className: "text-display-small font-semibold text-text-primary",
		children: r
	}) : r, t[0] = r, t[1] = a);
	let o;
	t[2] === n ? o = t[3] : (o = /* @__PURE__ */ Y("div", {
		className: "text-sm leading-4",
		children: n
	}), t[2] = n, t[3] = o);
	let s;
	return t[4] !== i || t[5] !== a || t[6] !== o ? (s = /* @__PURE__ */ X("div", {
		className: i,
		children: [a, o]
	}), t[4] = i, t[5] = a, t[6] = o, t[7] = s) : s = t[7], s;
}
//#endregion
//#region lib/components/StatCard/StatCardTitle.tsx
function xx(e) {
	let t = K(7), { title: n, info: r } = e, i;
	t[0] === n ? i = t[1] : (i = /* @__PURE__ */ Y("div", {
		className: "text-label-medium",
		children: n
	}), t[0] = n, t[1] = i);
	let a;
	t[2] === r ? a = t[3] : (a = r ? /* @__PURE__ */ Y(qt, {
		buttonProps: {
			"aria-label": "info",
			"data-testid": "stat-card-info-tooltip"
		},
		title: r,
		children: /* @__PURE__ */ Y("span", { children: /* @__PURE__ */ Y(b, { className: "size-icon-m text-foreground-secondary" }) })
	}) : null, t[2] = r, t[3] = a);
	let o;
	return t[4] !== i || t[5] !== a ? (o = /* @__PURE__ */ X("div", {
		className: "flex items-center gap-sm",
		children: [i, a]
	}), t[4] = i, t[5] = a, t[6] = o) : o = t[6], o;
}
//#endregion
//#region lib/components/StatCard/StatCard.tsx
function Sx(e) {
	let t = K(20), { className: n, title: r, message: i, description: a, children: o, info: s, menu: c } = e, l;
	t[0] !== s || t[1] !== r ? (l = /* @__PURE__ */ Y(xx, {
		info: s,
		title: r
	}), t[0] = s, t[1] = r, t[2] = l) : l = t[2];
	let u;
	t[3] === c ? u = t[4] : (u = c ? /* @__PURE__ */ Y("div", {
		className: "flex h-6 w-6 flex-shrink-0 items-center justify-center",
		children: c
	}) : null, t[3] = c, t[4] = u);
	let d;
	t[5] !== l || t[6] !== u ? (d = /* @__PURE__ */ X("div", {
		className: "flex items-center justify-between gap-3",
		children: [l, u]
	}), t[5] = l, t[6] = u, t[7] = d) : d = t[7];
	let f;
	t[8] === a ? f = t[9] : (f = a ? /* @__PURE__ */ Y("div", {
		className: "text-sm mt-1",
		children: a
	}) : null, t[8] = a, t[9] = f);
	let p;
	t[10] !== o || t[11] !== i ? (p = /* @__PURE__ */ Y(bx, {
		className: "mt-auto",
		message: i,
		children: o
	}), t[10] = o, t[11] = i, t[12] = p) : p = t[12];
	let m;
	t[13] !== d || t[14] !== f || t[15] !== p ? (m = /* @__PURE__ */ X("div", {
		className: "flex h-full flex-col",
		children: [
			d,
			f,
			p
		]
	}), t[13] = d, t[14] = f, t[15] = p, t[16] = m) : m = t[16];
	let h;
	return t[17] !== n || t[18] !== m ? (h = /* @__PURE__ */ Y(vu, {
		className: n,
		variant: "statCard",
		children: m
	}), t[17] = n, t[18] = m, t[19] = h) : h = t[19], h;
}
//#endregion
//#region lib/components/Stepper/Stepper.tsx
var Cx = G({
	base: "flex items-center",
	variants: { spacing: {
		sm: "gap-4",
		md: "gap-6",
		lg: "gap-8"
	} },
	defaultVariants: { spacing: "md" }
}), wx = G({
	base: "flex items-center gap-2 cursor-pointer bg-transparent border-none outline-none transition-opacity duration-200 hover:opacity-80 disabled:cursor-not-allowed disabled:opacity-50",
	variants: {}
}), Tx = G({
	base: "w-[24px] h-[24px] min-w-[24px] shrink-0 min-h-[24px] rounded-lg flex items-center justify-center font-family-text text-label-medium font-semibold leading-5 transition-all duration-200 border-2 capitalize",
	variants: {
		status: {
			pending: "bg-background-secondary border-background-secondary",
			completed: "bg-positive-700 border-positive-700",
			current: "bg-brand-primary border-brand-primary "
		},
		disabled: { true: "opacity-50" }
	}
}), Ex = G({
	base: "text-sm font-semibold transition-colors duration-200",
	variants: { status: {
		pending: "text-text-primary",
		current: "text-text-brand",
		completed: "text-text-secondary"
	} }
});
function Dx(e) {
	let t = K(4), { stepNumber: n, status: r } = e;
	if (r === "completed") {
		let e;
		return t[0] === Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ Y(h, { className: "p-0.5 text-text-primary-inverse" }), t[0] = e) : e = t[0], e;
	}
	let i = r === "pending" ? "text-gray-600" : "text-text-primary-inverse", a = n + 1, o;
	return t[1] !== a || t[2] !== i ? (o = /* @__PURE__ */ Y("span", {
		className: i,
		children: a
	}), t[1] = a, t[2] = i, t[3] = o) : o = t[3], o;
}
function Ox(e) {
	let t = K(24), { steps: n, currentStep: r, onStepClick: i, spacing: a, allowSkipping: o, className: s } = e, c = a === void 0 ? "md" : a, l = o !== void 0 && o, [u, d] = J(0), f = r !== void 0, p = f ? r : u, m, h;
	if (t[0] !== p || t[1] !== l || t[2] !== s || t[3] !== f || t[4] !== i || t[5] !== c || t[6] !== n) {
		let e;
		t[9] === p ? e = t[10] : (e = (e, t) => {
			let n = "pending";
			return t < p ? n = "completed" : t === p && (n = "current"), {
				...e,
				status: e.status ?? n
			};
		}, t[9] = p, t[10] = e);
		let r = n.map(e), a;
		t[11] !== p || t[12] !== l || t[13] !== f || t[14] !== i ? (a = (e, t) => {
			t.disabled || (l || e <= p || e === p + 1) && (i && i(e, t), f || d(e));
		}, t[11] = p, t[12] = l, t[13] = f, t[14] = i, t[15] = a) : a = t[15];
		let o = a;
		t[16] !== s || t[17] !== c ? (m = Cx({
			class: s,
			spacing: c
		}), t[16] = s, t[17] = c, t[18] = m) : m = t[18];
		let u;
		t[19] === o ? u = t[20] : (u = (e, t) => /* @__PURE__ */ Y("div", {
			className: "flex items-center",
			children: /* @__PURE__ */ X("button", {
				"aria-label": `Step ${t + 1}: ${e.label}`,
				className: wx(),
				disabled: e.disabled,
				onClick: () => o(t, e),
				type: "button",
				children: [/* @__PURE__ */ Y("div", {
					className: Tx({
						disabled: e.disabled,
						status: e.status
					}),
					children: /* @__PURE__ */ Y(Dx, {
						status: e.status,
						stepNumber: t
					})
				}), /* @__PURE__ */ Y("div", {
					className: Ex({ status: e.status }),
					children: e.label
				})]
			})
		}, e.id), t[19] = o, t[20] = u), h = r.map(u), t[0] = p, t[1] = l, t[2] = s, t[3] = f, t[4] = i, t[5] = c, t[6] = n, t[7] = m, t[8] = h;
	} else m = t[7], h = t[8];
	let g;
	return t[21] !== m || t[22] !== h ? (g = /* @__PURE__ */ Y("div", {
		className: m,
		children: h
	}), t[21] = m, t[22] = h, t[23] = g) : g = t[23], g;
}
//#endregion
//#region lib/components/ModeToggleButton/ModeToggleButton.tsx
function kx(e) {
	let t = K(20), n, r, i, a, o, s, c;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4], o = t[5], s = t[6], c = t[7]) : ({isSelected: r, leftIcon: i, leftLabel: a, rightIcon: s, rightLabel: c, className: n, ...o} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a, t[5] = o, t[6] = s, t[7] = c);
	let l;
	t[8] === n ? l = t[9] : (l = W("flex items-center justify-between rounded-xl bg-background-primary p-xxs shadow-[inset_0_0_0.5rem_0.125rem_rgba(0,0,0,0.25)]", "hover:outline-2 hover:outline-interactive-primary-button-hover-background hover:[outline-style:solid]", "data-[focus-visible]:outline-2 data-[focus-visible]:outline-interactive-primary-button-focus-background data-[focus-visible]:[outline-style:solid]", "data-[focused]:outline-2 data-[focused]:outline-interactive-primary-button-focus-background data-[focused]:[outline-style:solid]", n), t[8] = n, t[9] = l);
	let u;
	t[10] !== i || t[11] !== a || t[12] !== s || t[13] !== c ? (u = (e) => {
		let { isSelected: t } = e;
		return /* @__PURE__ */ X(Dr, { children: [/* @__PURE__ */ Y(Ax, {
			isSelected: !t,
			children: t ? i : a
		}), /* @__PURE__ */ Y(Ax, {
			isSelected: t,
			children: t ? c : s
		})] });
	}, t[10] = i, t[11] = a, t[12] = s, t[13] = c, t[14] = u) : u = t[14];
	let d;
	return t[15] !== r || t[16] !== o || t[17] !== l || t[18] !== u ? (d = /* @__PURE__ */ Y(Ri, {
		className: l,
		isSelected: r,
		...o,
		children: u
	}), t[15] = r, t[16] = o, t[17] = l, t[18] = u, t[19] = d) : d = t[19], d;
}
function Ax(e) {
	let t = K(5), { isSelected: n, children: r } = e, i = n ? "bg-brand-primary py-xxs text-interactive-primary-button-enabled-foreground shadow-[inset_0_0.25rem_0.25rem_0_rgba(255,255,255,0.25)]" : "shadow-none", a;
	t[0] === i ? a = t[1] : (a = W("rounded-md px-md text-label-medium-strong", i), t[0] = i, t[1] = a);
	let o;
	return t[2] !== r || t[3] !== a ? (o = /* @__PURE__ */ Y("div", {
		className: a,
		children: r
	}), t[2] = r, t[3] = a, t[4] = o) : o = t[4], o;
}
//#endregion
//#region lib/components/Tabs/Tabs.tsx
function jx(e) {
	let t = K(4), n;
	t[0] === e ? n = t[1] : ({...n} = e, t[0] = e, t[1] = n);
	let r;
	return t[2] === n ? r = t[3] : (r = /* @__PURE__ */ Y(Hi, {
		...n,
		children: n.children
	}), t[2] = n, t[3] = r), r;
}
function Mx(e) {
	let t = K(10), n, r;
	t[0] === e ? (n = t[1], r = t[2]) : ({children: n, ...r} = e, t[0] = e, t[1] = n, t[2] = r);
	let i;
	t[3] !== n || t[4] !== r.id || t[5] !== r.shouldForceMount ? (i = (e) => r.shouldForceMount || e.state.selectedKey === r.id ? typeof n == "function" ? n(e) : n : null, t[3] = n, t[4] = r.id, t[5] = r.shouldForceMount, t[6] = i) : i = t[6];
	let a;
	return t[7] !== r || t[8] !== i ? (a = /* @__PURE__ */ Y(Vi, {
		...r,
		children: i
	}), t[7] = r, t[8] = i, t[9] = a) : a = t[9], a;
}
var Nx = G({ base: "flex gap-x-0-5 mb-1-5" });
function Px(e) {
	let t = K(10), n, r, i;
	t[0] === e ? (n = t[1], r = t[2], i = t[3]) : ({className: r, children: n, ...i} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i);
	let a;
	t[4] === r ? a = t[5] : (a = Nx({ className: r }), t[4] = r, t[5] = a);
	let o;
	return t[6] !== n || t[7] !== i || t[8] !== a ? (o = /* @__PURE__ */ Y(Bi, {
		className: a,
		...i,
		children: n
	}), t[6] = n, t[7] = i, t[8] = a, t[9] = o) : o = t[9], o;
}
var Fx = G({
	base: "px-8 py-xxs text-label-medium-strong text-text-primary border-b-transparent outline-none transition-all ease-in-out cursor-pointer data-[selected]:text-text-brand border-b-2 data-[selected]:border-b-brand-primary hover:!text-stacklet-orange-700",
	variants: { isDisabled: {
		true: "text-text-disabled hover:!text-text-disabled",
		false: ""
	} },
	defaultVariants: { isDisabled: !1 }
});
function Ix(e) {
	let t = K(9), n, r;
	t[0] === e ? (n = t[1], r = t[2]) : ({className: n, ...r} = e, t[0] = e, t[1] = n, t[2] = r);
	let i;
	t[3] !== n || t[4] !== r.isDisabled ? (i = Fx({
		isDisabled: r.isDisabled,
		className: n
	}), t[3] = n, t[4] = r.isDisabled, t[5] = i) : i = t[5];
	let a;
	return t[6] !== r || t[7] !== i ? (a = /* @__PURE__ */ Y(zi, {
		className: i,
		...r,
		children: r.children
	}), t[6] = r, t[7] = i, t[8] = a) : a = t[8], a;
}
//#endregion
//#region lib/components/EntityCard/EntityCardHeader.tsx
function Lx(e) {
	let t = K(36), { icon: n, label: r, title: i, meta: a, aside: o, layout: s, trailing: c } = e, l = s === void 0 ? "inline" : s, u;
	t[0] === n ? u = t[1] : (u = /* @__PURE__ */ Y("span", {
		className: "size-3.5 inline-flex shrink-0 items-center justify-center",
		children: n
	}), t[0] = n, t[1] = u);
	let d = u, f;
	t[2] === r ? f = t[3] : (f = /* @__PURE__ */ Y("span", {
		className: "text-label-medium font-medium capitalize text-text-secondary",
		children: r
	}), t[2] = r, t[3] = f);
	let p = f, m = i != null && typeof i != "boolean" && i !== "", h;
	t[4] !== m || t[5] !== i ? (h = m ? /* @__PURE__ */ Y("span", {
		className: "min-w-5 truncate text-label-medium text-text-primary",
		children: i
	}) : null, t[4] = m, t[5] = i, t[6] = h) : h = t[6];
	let g = h, _;
	t[7] === a ? _ = t[8] : (_ = a ? /* @__PURE__ */ Y("span", {
		className: "flex shrink-0 items-center",
		children: a
	}) : null, t[7] = a, t[8] = _);
	let v = _;
	if (l === "stacked") {
		let e;
		t[9] !== d || t[10] !== p ? (e = /* @__PURE__ */ X("div", {
			className: "flex min-w-0 items-center gap-xs",
			children: [d, p]
		}), t[9] = d, t[10] = p, t[11] = e) : e = t[11];
		let n;
		t[12] === o ? n = t[13] : (n = o ? /* @__PURE__ */ Y("span", {
			className: "shrink-0 text-label-small text-text-secondary",
			children: o
		}) : null, t[12] = o, t[13] = n);
		let r;
		t[14] !== e || t[15] !== n ? (r = /* @__PURE__ */ X("div", {
			className: "flex w-full items-start justify-between gap-xs",
			children: [e, n]
		}), t[14] = e, t[15] = n, t[16] = r) : r = t[16];
		let i;
		t[17] !== v || t[18] !== g ? (i = /* @__PURE__ */ X("div", {
			className: "flex min-w-0 items-center gap-xs overflow-hidden",
			children: [g, v]
		}), t[17] = v, t[18] = g, t[19] = i) : i = t[19];
		let a;
		t[20] !== i || t[21] !== c ? (a = /* @__PURE__ */ X("div", {
			className: "flex w-full items-center justify-between gap-xs",
			children: [i, c]
		}), t[20] = i, t[21] = c, t[22] = a) : a = t[22];
		let s;
		return t[23] !== a || t[24] !== r ? (s = /* @__PURE__ */ X(Dr, { children: [r, a] }), t[23] = a, t[24] = r, t[25] = s) : s = t[25], s;
	}
	let y;
	t[26] !== d || t[27] !== p ? (y = /* @__PURE__ */ X("div", {
		className: "flex shrink-0 items-center gap-xs",
		children: [d, p]
	}), t[26] = d, t[27] = p, t[28] = y) : y = t[28];
	let b;
	t[29] !== v || t[30] !== g ? (b = /* @__PURE__ */ X("div", {
		className: "flex min-w-0 flex-1 items-center gap-xs overflow-hidden",
		children: [g, v]
	}), t[29] = v, t[30] = g, t[31] = b) : b = t[31];
	let x;
	return t[32] !== y || t[33] !== b || t[34] !== c ? (x = /* @__PURE__ */ X(Dr, { children: [
		y,
		b,
		c
	] }), t[32] = y, t[33] = b, t[34] = c, t[35] = x) : x = t[35], x;
}
//#endregion
//#region lib/components/EntityCard/styles.ts
var Rx = "bg-background-primary border border-overlay-medium rounded-sm flex", zx = G({
	base: Rx,
	variants: {
		layout: {
			inline: "items-center gap-xs p-sm",
			stacked: "flex-col gap-xs p-md"
		},
		interactive: { true: "cursor-pointer outline-none transition-colors duration-200 hover:border-outline-brand focus-visible:border-outline-brand data-[disabled]:cursor-not-allowed" }
	}
});
function Bx(e) {
	let t = K(28), { icon: n, label: r, title: i, meta: a, aside: o, layout: s, className: c } = e, l = s === void 0 ? "inline" : s, u = e.href !== void 0, d;
	t[0] === u ? d = t[1] : (d = u ? /* @__PURE__ */ Y("span", {
		className: "flex shrink-0 items-center justify-center text-text-primary",
		children: /* @__PURE__ */ Y(mn, { size: 16 })
	}) : null, t[0] = u, t[1] = d);
	let f;
	t[2] !== o || t[3] !== n || t[4] !== r || t[5] !== l || t[6] !== a || t[7] !== d || t[8] !== i ? (f = /* @__PURE__ */ Y(Lx, {
		aside: o,
		icon: n,
		label: r,
		layout: l,
		meta: a,
		title: i,
		trailing: d
	}), t[2] = o, t[3] = n, t[4] = r, t[5] = l, t[6] = a, t[7] = d, t[8] = i, t[9] = f) : f = t[9];
	let p = f;
	if (e.href !== void 0) {
		let n;
		if (t[10] !== e) {
			let { icon: r, label: i, title: a, meta: o, aside: s, layout: c, className: l, ...u } = e;
			n = u, t[10] = e, t[11] = n;
		} else n = t[11];
		let r;
		t[12] !== c || t[13] !== l ? (r = zx({
			layout: l,
			interactive: !0,
			className: c
		}), t[12] = c, t[13] = l, t[14] = r) : r = t[14];
		let i;
		return t[15] !== p || t[16] !== n || t[17] !== r ? (i = /* @__PURE__ */ Y(wi, {
			...n,
			className: r,
			children: p
		}), t[15] = p, t[16] = n, t[17] = r, t[18] = i) : i = t[18], i;
	}
	let m;
	if (t[19] !== e) {
		let { icon: n, label: r, title: i, meta: a, aside: o, layout: s, className: c, href: l, ...u } = e;
		m = u, t[19] = e, t[20] = m;
	} else m = t[20];
	let h;
	t[21] !== c || t[22] !== l ? (h = zx({
		layout: l,
		className: c
	}), t[21] = c, t[22] = l, t[23] = h) : h = t[23];
	let g;
	return t[24] !== m || t[25] !== p || t[26] !== h ? (g = /* @__PURE__ */ Y("div", {
		...m,
		className: h,
		children: p
	}), t[24] = m, t[25] = p, t[26] = h, t[27] = g) : g = t[27], g;
}
//#endregion
//#region lib/components/EntityCard/ExpandableEntityCard.tsx
function Vx(e) {
	let t = K(5), { label: n } = e, { isExpanded: r } = yr(_i) ?? { isExpanded: !1 }, i;
	t[0] === r ? i = t[1] : (i = Y(r ? rn : Ze, { size: 16 }), t[0] = r, t[1] = i);
	let a;
	return t[2] !== n || t[3] !== i ? (a = /* @__PURE__ */ Y(oi, {
		"aria-label": n,
		className: "size-4 flex shrink-0 cursor-pointer items-center justify-center rounded-sm text-text-primary outline-none focus-visible:ring-2 focus-visible:ring-outline-brand",
		slot: "trigger",
		children: i
	}), t[2] = n, t[3] = i, t[4] = a) : a = t[4], a;
}
function Hx(e) {
	let t = K(23), { icon: n, label: r, title: i, meta: a, aside: o, layout: s, expandedContent: c, expandToggleLabel: l, className: u } = e, d = s === void 0 ? "inline" : s, f = l === void 0 ? "Toggle details" : l, p;
	t[0] === u ? p = t[1] : (p = W(Rx, "flex-col p-sm", u), t[0] = u, t[1] = p);
	let m = d === "stacked" ? "flex-col" : "items-center", h;
	t[2] === m ? h = t[3] : (h = W("flex w-full gap-xs", m), t[2] = m, t[3] = h);
	let g;
	t[4] === f ? g = t[5] : (g = /* @__PURE__ */ Y(Vx, { label: f }), t[4] = f, t[5] = g);
	let _;
	t[6] !== o || t[7] !== n || t[8] !== r || t[9] !== d || t[10] !== a || t[11] !== g || t[12] !== i ? (_ = /* @__PURE__ */ Y(Lx, {
		aside: o,
		icon: n,
		label: r,
		layout: d,
		meta: a,
		title: i,
		trailing: g
	}), t[6] = o, t[7] = n, t[8] = r, t[9] = d, t[10] = a, t[11] = g, t[12] = i, t[13] = _) : _ = t[13];
	let v;
	t[14] !== h || t[15] !== _ ? (v = /* @__PURE__ */ Y("div", {
		className: h,
		children: _
	}), t[14] = h, t[15] = _, t[16] = v) : v = t[16];
	let y;
	t[17] === c ? y = t[18] : (y = /* @__PURE__ */ Y(Rm, { children: /* @__PURE__ */ Y("div", {
		className: "pt-xs",
		children: c
	}) }), t[17] = c, t[18] = y);
	let b;
	return t[19] !== p || t[20] !== v || t[21] !== y ? (b = /* @__PURE__ */ X(hi, {
		className: p,
		children: [v, y]
	}), t[19] = p, t[20] = v, t[21] = y, t[22] = b) : b = t[22], b;
}
//#endregion
//#region lib/components/Chip/Chip.tsx
function Ux(e) {
	let t = K(16), n, r, i, a, o;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4], o = t[5]) : ({children: n, icon: i, color: o, className: r, ...a} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a, t[5] = o);
	let s = o === void 0 ? "indigo" : o, c;
	t[6] !== r || t[7] !== s ? (c = fb({
		color: s,
		className: r
	}), t[6] = r, t[7] = s, t[8] = c) : c = t[8];
	let l;
	t[9] === i ? l = t[10] : (l = i ? /* @__PURE__ */ Y("span", {
		className: "mr-0.5 inline-flex items-center",
		children: i
	}) : null, t[9] = i, t[10] = l);
	let u;
	return t[11] !== n || t[12] !== a || t[13] !== c || t[14] !== l ? (u = /* @__PURE__ */ X("span", {
		className: c,
		...a,
		children: [l, n]
	}), t[11] = n, t[12] = a, t[13] = c, t[14] = l, t[15] = u) : u = t[15], u;
}
//#endregion
//#region lib/components/HumanTimestamp/HumanTimestamp.tsx
var Wx = "MMM dd, yyyy, h:mm aa";
function Gx(e) {
	let t = K(18), { timestamp: n, additional: r } = e;
	if (!n) {
		let e;
		return t[0] === Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ Y("span", { children: "--" }), t[0] = e) : e = t[0], e;
	}
	let i;
	try {
		let e;
		t[1] === n ? e = t[2] : (e = Nf(n, "UTC", Wx), t[1] = n, t[2] = e), i = e;
	} catch {
		console.error("unable to format timestamp", n);
		let e;
		return t[3] === Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ Y("span", { children: "--" }), t[3] = e) : e = t[3], e;
	}
	let a = `${i} UTC`, o;
	t[4] === Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ Y("br", {}), t[4] = o) : o = t[4];
	let s;
	t[5] === r ? s = t[6] : (s = r ? /* @__PURE__ */ X("div", { children: [/* @__PURE__ */ Y("br", {}), r] }) : null, t[5] = r, t[6] = s);
	let c;
	t[7] !== a || t[8] !== s || t[9] !== n ? (c = /* @__PURE__ */ X("div", { children: [
		a,
		o,
		n,
		s
	] }), t[7] = a, t[8] = s, t[9] = n, t[10] = c) : c = t[10];
	let l = c, u;
	t[11] === n ? u = t[12] : (u = ni(new Date(n), { addSuffix: !0 }), t[11] = n, t[12] = u);
	let d;
	t[13] === u ? d = t[14] : (d = /* @__PURE__ */ Y("span", { children: u }), t[13] = u, t[14] = d);
	let f;
	return t[15] !== d || t[16] !== l ? (f = /* @__PURE__ */ Y(qt, {
		title: l,
		children: d
	}), t[15] = d, t[16] = l, t[17] = f) : f = t[17], f;
}
//#endregion
//#region lib/components/VisuallyHidden/VisuallyHidden.tsx
function Kx(e) {
	let t = K(3), { children: n } = e, { visuallyHiddenProps: r } = lr(), i;
	return t[0] !== n || t[1] !== r ? (i = /* @__PURE__ */ Y("span", {
		...r,
		children: n
	}), t[0] = n, t[1] = r, t[2] = i) : i = t[2], i;
}
//#endregion
//#region lib/components/StatusLight/StatusLight.tsx
var qx = {
	green: "bg-foreground-positive",
	amber: "bg-foreground-warning",
	red: "bg-foreground-negative",
	grey: "bg-neutral-500"
}, Jx = {
	green: "succeeded",
	amber: "partly failed",
	red: "failed",
	grey: "no result"
};
function Yx(e) {
	let t = K(18), { light: n, children: r, running: i, statusText: a, className: o } = e, s = a === void 0 ? Jx[n] : a, c = i ? "running" : null, l;
	t[0] !== s || t[1] !== c ? (l = [s, c].filter(Boolean), t[0] = s, t[1] = c, t[2] = l) : l = t[2];
	let u = l.join(", "), d;
	t[3] === o ? d = t[4] : (d = W("inline-flex items-center gap-xs", o), t[3] = o, t[4] = d);
	let f = qx[n], p = i ? "animate-pulse motion-reduce:animate-none" : void 0, m;
	t[5] !== f || t[6] !== p ? (m = W("size-xs shrink-0 rounded-full", f, p), t[5] = f, t[6] = p, t[7] = m) : m = t[7];
	let h;
	t[8] === m ? h = t[9] : (h = /* @__PURE__ */ Y("span", {
		className: m,
		"aria-hidden": !0
	}), t[8] = m, t[9] = h);
	let g;
	t[10] === u ? g = t[11] : (g = u ? /* @__PURE__ */ X(Kx, { children: [
		" (",
		u,
		")"
	] }) : null, t[10] = u, t[11] = g);
	let _;
	return t[12] !== r || t[13] !== n || t[14] !== d || t[15] !== h || t[16] !== g ? (_ = /* @__PURE__ */ X("span", {
		className: d,
		"data-light": n,
		children: [
			h,
			r,
			g
		]
	}), t[12] = r, t[13] = n, t[14] = d, t[15] = h, t[16] = g, t[17] = _) : _ = t[17], _;
}
//#endregion
//#region lib/components/TextField/TextField.tsx
var Xx = G({
	base: "\n    text-label-medium text-text-primary py-xs outline-none border border-outline-input-enabled bg-primary rounded-1 px-lg leading-md-20 truncate\n    hover:border-outline-input-hover hover:ring-1 hover:ring-outline-input-hover\n    focus:border-outline-input-focus focus:ring-1 focus:ring-outline-input-focus\n    disabled:border-outline-input-disabled disabled:cursor-not-allowed disabled:text-text-disabled disabled:bg-background-primary disabled:hover:ring-0 disabled:hover:border-outline-input-disabled\n    placeholder:text-text-secondary disabled:placeholder:text-text-disabled\n  ",
	variants: {
		variant: {
			primary: "",
			compact: "px-sm py-xxs text-label-small font-normal leading-xs tracking-normal"
		},
		isReadOnly: { true: "!cursor-text !bg-background-secondary !text-text-primary !border-transparent hover:ring-0 focus:ring-0" },
		isInvalid: { true: "border-outline-negative ring-1 ring-outline-negative" }
	}
});
function Zx(e) {
	let t = K(43), n, r, i, a, o, s, c, l, u, d, f;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4], o = t[5], s = t[6], c = t[7], l = t[8], u = t[9], d = t[10], f = t[11]) : ({inputProps: i, label: l, tooltipText: f, className: r, assistiveText: n, isDisabled: a, isReadOnly: s, isInvalid: o, isRequired: c, ref: u, ...d} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a, t[5] = o, t[6] = s, t[7] = c, t[8] = l, t[9] = u, t[10] = d, t[11] = f);
	let p;
	t[12] === r ? p = t[13] : (p = W("flex flex-col gap-[.15rem]", r), t[12] = r, t[13] = p);
	let m;
	t[14] !== a || t[15] !== c || t[16] !== l || t[17] !== f ? (m = /* @__PURE__ */ Y(Vl, {
		isDisabled: a,
		isRequired: c,
		label: l,
		tooltipText: f
	}), t[14] = a, t[15] = c, t[16] = l, t[17] = f, t[18] = m) : m = t[18];
	let h = i?.variant, g = i?.className, _;
	t[19] !== o || t[20] !== s || t[21] !== h || t[22] !== g ? (_ = Xx({
		variant: h,
		className: g,
		isReadOnly: s,
		isInvalid: o
	}), t[19] = o, t[20] = s, t[21] = h, t[22] = g, t[23] = _) : _ = t[23];
	let v = i?.placeholder ?? "Type here...", y;
	t[24] !== i || t[25] !== u || t[26] !== _ || t[27] !== v ? (y = /* @__PURE__ */ Y(xi, {
		...i,
		className: _,
		placeholder: v,
		ref: u
	}), t[24] = i, t[25] = u, t[26] = _, t[27] = v, t[28] = y) : y = t[28];
	let b;
	t[29] !== n || t[30] !== a || t[31] !== o ? (b = /* @__PURE__ */ Y(gl, {
		isDisabled: a,
		isInvalid: o,
		children: n
	}), t[29] = n, t[30] = a, t[31] = o, t[32] = b) : b = t[32];
	let x;
	return t[33] !== a || t[34] !== o || t[35] !== s || t[36] !== c || t[37] !== d || t[38] !== p || t[39] !== m || t[40] !== y || t[41] !== b ? (x = /* @__PURE__ */ X(Ji, {
		className: p,
		isDisabled: a,
		isInvalid: o,
		isReadOnly: s,
		isRequired: c,
		...d,
		children: [
			m,
			y,
			b
		]
	}), t[33] = a, t[34] = o, t[35] = s, t[36] = c, t[37] = d, t[38] = p, t[39] = m, t[40] = y, t[41] = b, t[42] = x) : x = t[42], x;
}
//#endregion
//#region lib/components/NumberField/NumberField.tsx
var Qx = G({
	base: "\n    flex items-center gap-x-sm bg-primary rounded-1 px-lg py-xs outline-none border border-outline-input-enabled\n    hover:border-outline-input-hover hover:ring-1 hover:ring-outline-input-hover\n    focus-within:!border-outline-input-focus focus-within:!ring-1 focus-within:!ring-outline-input-focus\n  ",
	variants: {
		isDisabled: { true: "border-outline-input-disabled cursor-not-allowed bg-background-primary hover:ring-0 hover:border-outline-input-disabled" },
		isReadOnly: { true: "bg-background-secondary !border-transparent hover:!ring-0 focus-within:!ring-0 focus-within:!border-transparent" },
		isInvalid: { true: "border-outline-negative ring-1 ring-outline-negative" }
	}
}), $x = G({
	base: "\n    flex-1 text-label-medium text-text-primary bg-transparent border-none outline-none leading-md-20 truncate\n    placeholder:text-text-secondary disabled:placeholder:text-text-disabled\n    disabled:cursor-not-allowed disabled:text-text-disabled\n    [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none\n  ",
	variants: { isReadOnly: { true: "!cursor-text !text-text-primary" } }
}), eS = G({
	base: "text-label-small text-text-secondary shrink-0",
	variants: { isDisabled: { true: "text-text-disabled" } }
});
function tS(e) {
	let t = K(51), n, r, i, a, o, s, c, l, u, d, f, p;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4], o = t[5], s = t[6], c = t[7], l = t[8], u = t[9], d = t[10], f = t[11], p = t[12]) : ({label: s, tooltipText: f, className: i, assistiveText: r, isDisabled: a, isReadOnly: o, isInvalid: u, placeholder: d, unit: p, ref: c, "aria-label": n, ...l} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a, t[5] = o, t[6] = s, t[7] = c, t[8] = l, t[9] = u, t[10] = d, t[11] = f, t[12] = p);
	let m = u !== void 0 && u, h = d === void 0 ? "0" : d, g = n ?? (s ? void 0 : "number input"), _;
	t[13] === i ? _ = t[14] : (_ = W("flex flex-col gap-[.15rem]", i), t[13] = i, t[14] = _);
	let v;
	t[15] === Symbol.for("react.memo_cache_sentinel") ? (v = { slot: null }, t[15] = v) : v = t[15];
	let y;
	t[16] !== a || t[17] !== s || t[18] !== f ? (y = /* @__PURE__ */ Y(Vl, {
		isDisabled: a,
		label: s,
		tooltipButtonProps: v,
		tooltipText: f
	}), t[16] = a, t[17] = s, t[18] = f, t[19] = y) : y = t[19];
	let b;
	t[20] !== a || t[21] !== m || t[22] !== o ? (b = Qx({
		isDisabled: a,
		isReadOnly: o,
		isInvalid: m
	}), t[20] = a, t[21] = m, t[22] = o, t[23] = b) : b = t[23];
	let x;
	t[24] === o ? x = t[25] : (x = $x({ isReadOnly: o }), t[24] = o, t[25] = x);
	let S;
	t[26] !== h || t[27] !== c || t[28] !== x ? (S = /* @__PURE__ */ Y(xi, {
		className: x,
		placeholder: h,
		ref: c
	}), t[26] = h, t[27] = c, t[28] = x, t[29] = S) : S = t[29];
	let C;
	t[30] !== a || t[31] !== p ? (C = p ? /* @__PURE__ */ Y("span", {
		className: eS({ isDisabled: a }),
		children: p
	}) : null, t[30] = a, t[31] = p, t[32] = C) : C = t[32];
	let w;
	t[33] !== b || t[34] !== S || t[35] !== C ? (w = /* @__PURE__ */ X(vi, {
		className: b,
		children: [S, C]
	}), t[33] = b, t[34] = S, t[35] = C, t[36] = w) : w = t[36];
	let T;
	t[37] !== r || t[38] !== a || t[39] !== m ? (T = /* @__PURE__ */ Y(gl, {
		isDisabled: a,
		isInvalid: m,
		children: r
	}), t[37] = r, t[38] = a, t[39] = m, t[40] = T) : T = t[40];
	let E;
	return t[41] !== a || t[42] !== m || t[43] !== o || t[44] !== l || t[45] !== w || t[46] !== T || t[47] !== g || t[48] !== _ || t[49] !== y ? (E = /* @__PURE__ */ X(Ai, {
		"aria-label": g,
		className: _,
		isDisabled: a,
		isInvalid: m,
		isReadOnly: o,
		...l,
		slot: null,
		children: [
			y,
			w,
			T
		]
	}), t[41] = a, t[42] = m, t[43] = o, t[44] = l, t[45] = w, t[46] = T, t[47] = g, t[48] = _, t[49] = y, t[50] = E) : E = t[50], E;
}
//#endregion
//#region lib/components/SelectField/selectFieldStyles.ts
var nS = G({
	base: "\n    flex w-full items-center justify-between\n    rounded-1 outline-none bg-primary px-lg py-xs text-label-medium leading-md-20 text-text-primary\n    cursor-pointer select-none border border-outline-input-enabled\n    hover:border-outline-input-hover hover:ring-1 hover:ring-outline-input-hover\n    focus:border-outline-input-focus focus:ring-1 focus:ring-outline-input-focus\n  ",
	variants: {
		isDisabled: { true: "cursor-not-allowed bg-background-primary text-text-disabled border-outline-input-disabled hover:ring-0 hover:border-outline-input-disabled" },
		isReadOnly: { true: "!cursor-default !bg-background-secondary !border-transparent hover:ring-0 focus:ring-0" },
		isInvalid: { true: "border-outline-negative ring-1 ring-outline-negative" },
		isOpen: { true: "border-outline-input-focus ring-1 ring-outline-input-focus" }
	}
}), rS = G({
	base: "size-lg shrink-0 text-foreground-secondary transition-transform duration-200 ml-xs",
	variants: {
		isOpen: {
			true: "rotate-180",
			false: "rotate-0"
		},
		isDisabled: { true: "text-text-disabled" }
	}
});
//#endregion
//#region lib/components/SelectField/SelectField.tsx
function iS(e) {
	let t = K(67), n, r, i, a, o, s, c, l, u, d, f, p, m, h, g, _;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4], o = t[5], s = t[6], c = t[7], l = t[8], u = t[9], d = t[10], f = t[11], p = t[12], m = t[13], h = t[14], g = t[15], _ = t[16]) : ({value: _, placeholder: p, label: l, tooltipText: g, assistiveText: n, isDisabled: o, isReadOnly: s, isInvalid: m, isOpen: h, isRequired: c, className: i, buttonClassName: r, startAdornment: f, endAdornment: a, ref: u, ...d} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a, t[5] = o, t[6] = s, t[7] = c, t[8] = l, t[9] = u, t[10] = d, t[11] = f, t[12] = p, t[13] = m, t[14] = h, t[15] = g, t[16] = _);
	let v = p === void 0 ? "Select an option..." : p, y = m !== void 0 && m, b = h !== void 0 && h, x = _ != null && _ !== "", S;
	t[17] === i ? S = t[18] : (S = W("flex w-full flex-col gap-[.15rem]", i), t[17] = i, t[18] = S);
	let C;
	t[19] !== o || t[20] !== c || t[21] !== l || t[22] !== g ? (C = /* @__PURE__ */ Y(Vl, {
		isDisabled: o,
		isRequired: c,
		label: l,
		tooltipText: g
	}), t[19] = o, t[20] = c, t[21] = l, t[22] = g, t[23] = C) : C = t[23];
	let w = e["aria-label"] ?? `select-field ${l ?? ""}`, T;
	t[24] !== r || t[25] !== o || t[26] !== y || t[27] !== b || t[28] !== s ? (T = nS({
		isDisabled: o,
		isReadOnly: s,
		isInvalid: y,
		isOpen: b,
		className: r
	}), t[24] = r, t[25] = o, t[26] = y, t[27] = b, t[28] = s, t[29] = T) : T = t[29];
	let E;
	t[30] !== s || t[31] !== d ? (E = (e) => {
		s || d.onPress?.(e);
	}, t[30] = s, t[31] = d, t[32] = E) : E = t[32];
	let D;
	t[33] === f ? D = t[34] : (D = f ? /* @__PURE__ */ Y("span", {
		className: "mr-xs flex shrink-0 items-center",
		children: f
	}) : null, t[33] = f, t[34] = D);
	let O = x ? "text-text-primary" : "text-text-secondary", k = o ? "text-text-disabled" : "", A;
	t[35] !== k || t[36] !== O ? (A = W("flex-1 truncate text-left", O, k), t[35] = k, t[36] = O, t[37] = A) : A = t[37];
	let j = x ? _ : v, M;
	t[38] !== A || t[39] !== j ? (M = /* @__PURE__ */ Y("span", {
		className: A,
		children: j
	}), t[38] = A, t[39] = j, t[40] = M) : M = t[40];
	let N;
	t[41] !== o || t[42] !== b ? (N = rS({
		isOpen: b,
		isDisabled: o
	}), t[41] = o, t[42] = b, t[43] = N) : N = t[43];
	let P;
	t[44] === N ? P = t[45] : (P = /* @__PURE__ */ Y(gt, {
		"aria-hidden": "true",
		className: N
	}), t[44] = N, t[45] = P);
	let F;
	t[46] !== a || t[47] !== o || t[48] !== b || t[49] !== u || t[50] !== d || t[51] !== M || t[52] !== P || t[53] !== w || t[54] !== T || t[55] !== E || t[56] !== D ? (F = /* @__PURE__ */ X(oi, {
		...d,
		"aria-expanded": b,
		"aria-label": w,
		className: T,
		isDisabled: o,
		onPress: E,
		ref: u,
		children: [
			D,
			M,
			a,
			P
		]
	}), t[46] = a, t[47] = o, t[48] = b, t[49] = u, t[50] = d, t[51] = M, t[52] = P, t[53] = w, t[54] = T, t[55] = E, t[56] = D, t[57] = F) : F = t[57];
	let I;
	t[58] !== n || t[59] !== o || t[60] !== y ? (I = /* @__PURE__ */ Y(gl, {
		isDisabled: o,
		isInvalid: y,
		children: n
	}), t[58] = n, t[59] = o, t[60] = y, t[61] = I) : I = t[61];
	let L;
	return t[62] !== F || t[63] !== I || t[64] !== S || t[65] !== C ? (L = /* @__PURE__ */ X("div", {
		className: S,
		children: [
			C,
			F,
			I
		]
	}), t[62] = F, t[63] = I, t[64] = S, t[65] = C, t[66] = L) : L = t[66], L;
}
//#endregion
//#region lib/components/MultiSelectField/MultiSelectField.tsx
var aS = G({
	base: "inline-flex items-center justify-center gap-x-xs px-xs text-text-primary rounded-md bg-data-viz-soft-indigo text-label-extra-small-strong",
	variants: {
		isDisabled: { true: "opacity-50" },
		isReadOnly: { true: "!text-label-small" }
	}
}), oS = G({ base: "inline-flex cursor-pointer items-center hover:text-outline-input-hover focus-visible:text-outline-input-focus focus-visible:outline-none" });
function sS(e) {
	let t = K(33), n, r, i, a, o, s, c;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4], o = t[5], s = t[6], c = t[7]) : ({value: n, defaultValue: r, onChange: o, isDisabled: i, isReadOnly: a, showClearAll: c, ...s} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a, t[5] = o, t[6] = s, t[7] = c);
	let l = c !== void 0 && c, u = n !== void 0, d;
	t[8] === r ? d = t[9] : (d = r ?? [], t[8] = r, t[9] = d);
	let [f, p] = J(d), m = u ? n : f, h;
	t[10] !== u || t[11] !== m || t[12] !== o ? (h = (e) => {
		let t = m.filter((t) => t.id !== e);
		u || p(t), o?.(t);
	}, t[10] = u, t[11] = m, t[12] = o, t[13] = h) : h = t[13];
	let g = h, _;
	t[14] !== u || t[15] !== o ? (_ = () => {
		u || p([]), o?.([]);
	}, t[14] = u, t[15] = o, t[16] = _) : _ = t[16];
	let v = _, y = m.length > 0, b = !i && !a, x = l && y && b, S;
	t[17] !== b || t[18] !== y || t[19] !== i || t[20] !== a || t[21] !== m || t[22] !== g ? (S = y ? /* @__PURE__ */ Y("span", {
		className: "flex min-h-5 flex-wrap items-center gap-xs py-[0.0625rem] text-text-primary",
		role: "list",
		children: m.map((e) => /* @__PURE__ */ X("span", {
			className: aS({
				isDisabled: i,
				isReadOnly: a
			}),
			role: "listitem",
			children: [e.name, b ? /* @__PURE__ */ Y("span", {
				"aria-label": `Remove ${e.name}`,
				className: oS(),
				onClick: (t) => {
					t.stopPropagation(), t.preventDefault(), g(e.id);
				},
				onKeyDown: (t) => {
					(t.key === "Enter" || t.key === " ") && (t.stopPropagation(), t.preventDefault(), g(e.id));
				},
				role: "button",
				tabIndex: 0,
				children: /* @__PURE__ */ Y(ie, { size: 14 })
			}) : null]
		}, e.id))
	}) : void 0, t[17] = b, t[18] = y, t[19] = i, t[20] = a, t[21] = m, t[22] = g, t[23] = S) : S = t[23];
	let C = S, w;
	t[24] !== v || t[25] !== x ? (w = x ? /* @__PURE__ */ Y("span", {
		"aria-label": "Clear all",
		className: W(oS(), "ml-xs shrink-0"),
		onClick: (e) => {
			e.stopPropagation(), e.preventDefault(), v();
		},
		onKeyDown: (e) => {
			(e.key === "Enter" || e.key === " ") && (e.stopPropagation(), e.preventDefault(), v());
		},
		role: "button",
		tabIndex: 0,
		children: /* @__PURE__ */ Y(ie, { size: 14 })
	}) : void 0, t[24] = v, t[25] = x, t[26] = w) : w = t[26];
	let T = w, E;
	return t[27] !== T || t[28] !== i || t[29] !== a || t[30] !== C || t[31] !== s ? (E = /* @__PURE__ */ Y(iS, {
		...s,
		endAdornment: T,
		isDisabled: i,
		isReadOnly: a,
		value: C
	}), t[27] = T, t[28] = i, t[29] = a, t[30] = C, t[31] = s, t[32] = E) : E = t[32], E;
}
//#endregion
//#region lib/components/MultiTextField/MultiTextField.tsx
var cS = G({
	base: "inline-flex items-center justify-center gap-x-xs px-xs text-text-primary rounded-md bg-data-viz-soft-indigo text-label-extra-small-strong",
	variants: {
		isDisabled: { true: "opacity-50" },
		isReadOnly: { true: "!text-label-small" }
	}
}), lS = G({ base: "inline-flex cursor-pointer items-center hover:text-outline-input-hover focus-visible:text-outline-input-focus focus-visible:outline-none" }), uS = G({
	base: "\n    text-label-medium text-text-primary outline-none border border-outline-input-enabled bg-primary rounded-1 leading-md-20\n    hover:border-outline-input-hover hover:ring-1 hover:ring-outline-input-hover\n    flex flex-wrap items-center gap-xs py-xs px-lg\n  ",
	variants: {
		isReadOnly: { true: "!cursor-text !bg-background-secondary !text-text-primary !border-transparent hover:ring-0" },
		isInvalid: { true: "border-outline-negative ring-1 ring-outline-negative" },
		isInputFocused: { true: "ring-1 !ring-outline-input-focus !border-outline-input-focus" },
		isDisabled: { true: "cursor-not-allowed bg-background-primary text-text-disabled border-outline-input-disabled hover:ring-0 hover:border-outline-input-disabled" }
	}
});
function dS(e) {
	let t = K(87), n, r, i, a, o, s, c, l, u, d, f, p;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4], o = t[5], s = t[6], c = t[7], l = t[8], u = t[9], d = t[10], f = t[11], p = t[12]) : ({value: i, defaultValue: a, onChange: d, inputProps: o, label: u, tooltipText: p, className: r, assistiveText: n, isDisabled: s, isReadOnly: l, isInvalid: c, ...f} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a, t[5] = o, t[6] = s, t[7] = c, t[8] = l, t[9] = u, t[10] = d, t[11] = f, t[12] = p);
	let m = i !== void 0, h;
	t[13] === a ? h = t[14] : (h = a ?? [], t[13] = a, t[14] = h);
	let [g, _] = J(h), [v, y] = J(""), [b, x] = J(!1), S = Tr(null), C = m ? i : g, w = !s && !l, T;
	t[15] !== m || t[16] !== d ? (T = (e) => {
		m || _(e), d?.(e);
	}, t[15] = m, t[16] = d, t[17] = T) : T = t[17];
	let E = T, D;
	t[18] !== C || t[19] !== E ? (D = (e) => {
		let t = e.trim();
		if (!t) return;
		let n = {
			id: crypto.randomUUID(),
			name: t
		};
		E([...C, n]), y("");
	}, t[18] = C, t[19] = E, t[20] = D) : D = t[20];
	let O = D, k;
	t[21] !== C || t[22] !== E ? (k = (e) => {
		E(C.filter((t) => t.id !== e));
	}, t[21] = C, t[22] = E, t[23] = k) : k = t[23];
	let A = k, j;
	t[24] !== C || t[25] !== E ? (j = () => {
		C.length !== 0 && E(C.slice(0, -1));
	}, t[24] = C, t[25] = E, t[26] = j) : j = t[26];
	let M = j, N;
	t[27] !== O || t[28] !== w || t[29] !== o || t[30] !== v || t[31] !== M ? (N = (e) => {
		w && (e.key === "Enter" ? (e.preventDefault(), O(v)) : e.key === "Backspace" && v === "" && (e.preventDefault(), M()), o?.onKeyDown?.(e));
	}, t[27] = O, t[28] = w, t[29] = o, t[30] = v, t[31] = M, t[32] = N) : N = t[32];
	let P = N, F = u ?? "multi-text-field", I;
	t[33] === r ? I = t[34] : (I = W("flex flex-col gap-[.15rem]", r), t[33] = r, t[34] = I);
	let L = w ? y : void 0, R;
	t[35] !== s || t[36] !== u || t[37] !== p ? (R = /* @__PURE__ */ Y(Vl, {
		isDisabled: s,
		label: u,
		tooltipText: p
	}), t[35] = s, t[36] = u, t[37] = p, t[38] = R) : R = t[38];
	let z = o?.className, B;
	t[39] !== s || t[40] !== b || t[41] !== c || t[42] !== l || t[43] !== z ? (B = uS({
		isInvalid: c,
		isInputFocused: b,
		isDisabled: s,
		isReadOnly: l,
		className: z
	}), t[39] = s, t[40] = b, t[41] = c, t[42] = l, t[43] = z, t[44] = B) : B = t[44];
	let V;
	t[45] === Symbol.for("react.memo_cache_sentinel") ? (V = () => {
		S.current?.focus();
	}, t[45] = V) : V = t[45];
	let ee;
	t[46] !== w || t[47] !== s || t[48] !== l || t[49] !== C || t[50] !== A ? (ee = C.length > 0 ? /* @__PURE__ */ Y("span", {
		className: "flex flex-wrap items-center gap-xs",
		role: "list",
		children: C.map((e) => /* @__PURE__ */ X("span", {
			className: cS({
				isDisabled: s,
				isReadOnly: l
			}),
			onClick: fS,
			role: "listitem",
			children: [e.name, w ? /* @__PURE__ */ Y("span", {
				"aria-label": `Remove ${e.name}`,
				className: lS(),
				onClick: (t) => {
					t.stopPropagation(), A(e.id);
				},
				onKeyDown: (t) => {
					(t.key === "Enter" || t.key === " ") && (t.stopPropagation(), t.preventDefault(), A(e.id));
				},
				role: "button",
				tabIndex: 0,
				children: /* @__PURE__ */ Y(ie, { size: 14 })
			}) : null]
		}, e.id))
	}) : null, t[46] = w, t[47] = s, t[48] = l, t[49] = C, t[50] = A, t[51] = ee) : ee = t[51];
	let H;
	t[52] === Symbol.for("react.memo_cache_sentinel") ? (H = W("min-w-[4rem] flex-1 border-0 bg-transparent outline-0", "disabled:cursor-not-allowed disabled:text-text-disabled", "placeholder:text-text-secondary focus-visible:outline-none disabled:placeholder:text-text-disabled"), t[52] = H) : H = t[52];
	let U;
	t[53] !== O || t[54] !== w || t[55] !== o || t[56] !== v || t[57] !== l ? (U = (e) => {
		l || (x(!1), w && O(v), o?.onBlur?.(e));
	}, t[53] = O, t[54] = w, t[55] = o, t[56] = v, t[57] = l, t[58] = U) : U = t[58];
	let te;
	t[59] !== o || t[60] !== l ? (te = (e) => {
		l || (x(!0), o?.onFocus?.(e));
	}, t[59] = o, t[60] = l, t[61] = te) : te = t[61];
	let ne = o?.placeholder ?? "Type and press Enter...", re;
	t[62] !== P || t[63] !== o || t[64] !== U || t[65] !== te || t[66] !== ne ? (re = /* @__PURE__ */ Y(xi, {
		...o,
		className: H,
		onBlur: U,
		onFocus: te,
		onKeyDown: P,
		placeholder: ne,
		ref: S
	}), t[62] = P, t[63] = o, t[64] = U, t[65] = te, t[66] = ne, t[67] = re) : re = t[67];
	let ae;
	t[68] !== B || t[69] !== ee || t[70] !== re ? (ae = /* @__PURE__ */ X("div", {
		className: B,
		onClick: V,
		children: [ee, re]
	}), t[68] = B, t[69] = ee, t[70] = re, t[71] = ae) : ae = t[71];
	let oe;
	t[72] !== n || t[73] !== s || t[74] !== c ? (oe = /* @__PURE__ */ Y(gl, {
		isDisabled: s,
		isInvalid: c,
		children: n
	}), t[72] = n, t[73] = s, t[74] = c, t[75] = oe) : oe = t[75];
	let se;
	return t[76] !== v || t[77] !== s || t[78] !== l || t[79] !== f || t[80] !== R || t[81] !== ae || t[82] !== oe || t[83] !== F || t[84] !== I || t[85] !== L ? (se = /* @__PURE__ */ X(Ji, {
		"aria-label": F,
		className: I,
		isDisabled: s,
		isReadOnly: l,
		onChange: L,
		value: v,
		...f,
		children: [
			R,
			ae,
			oe
		]
	}), t[76] = v, t[77] = s, t[78] = l, t[79] = f, t[80] = R, t[81] = ae, t[82] = oe, t[83] = F, t[84] = I, t[85] = L, t[86] = se) : se = t[86], se;
}
function fS(e) {
	return e.stopPropagation();
}
//#endregion
//#region lib/components/TextArea/TextArea.tsx
var pS = G({
	base: "\n    text-label-medium text-text-primary py-xs outline-none border border-outline-input-enabled bg-primary rounded-1 px-lg leading-md-20\n    hover:border-outline-input-hover hover:ring-1 hover:ring-outline-input-hover\n    focus:border-outline-input-focus focus:ring-1 focus:ring-outline-input-focus\n    disabled:border-outline-input-disabled disabled:cursor-not-allowed disabled:text-text-disabled disabled:bg-background-primary disabled:hover:ring-0 disabled:hover:border-outline-input-disabled\n    resize-y min-h-[4.5rem]\n    placeholder:text-text-secondary disabled:placeholder:text-text-disabled\n  ",
	variants: {
		variant: { primary: "" },
		autoResize: { true: "min-h-fit [field-sizing:content]" },
		isReadOnly: { true: "!cursor-text !bg-background-secondary !text-text-primary !border-transparent hover:ring-0 focus:ring-0" },
		isInvalid: { true: "border-outline-negative ring-1 ring-outline-negative" }
	}
});
function mS(e) {
	let t = K(46), n, r, i, a, o, s, c, l, u, d, f, p;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4], o = t[5], s = t[6], c = t[7], l = t[8], u = t[9], d = t[10], f = t[11], p = t[12]) : ({textAreaProps: f, label: l, tooltipText: p, className: i, assistiveText: n, isDisabled: a, isReadOnly: s, isInvalid: o, isRequired: c, autoResize: r, ref: u, ...d} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a, t[5] = o, t[6] = s, t[7] = c, t[8] = l, t[9] = u, t[10] = d, t[11] = f, t[12] = p);
	let m;
	t[13] === i ? m = t[14] : (m = W("flex flex-col gap-[.15rem]", i), t[13] = i, t[14] = m);
	let h;
	t[15] !== a || t[16] !== c || t[17] !== l || t[18] !== p ? (h = /* @__PURE__ */ Y(Vl, {
		isDisabled: a,
		isRequired: c,
		label: l,
		tooltipText: p
	}), t[15] = a, t[16] = c, t[17] = l, t[18] = p, t[19] = h) : h = t[19];
	let g = f?.variant, _ = f?.className, v;
	t[20] !== r || t[21] !== o || t[22] !== s || t[23] !== g || t[24] !== _ ? (v = pS({
		variant: g,
		className: _,
		autoResize: r,
		isReadOnly: s,
		isInvalid: o
	}), t[20] = r, t[21] = o, t[22] = s, t[23] = g, t[24] = _, t[25] = v) : v = t[25];
	let y = f?.placeholder || "Type here...", b = f?.rows ?? 2, x;
	t[26] !== u || t[27] !== v || t[28] !== y || t[29] !== b || t[30] !== f ? (x = /* @__PURE__ */ Y(qi, {
		...f,
		className: v,
		placeholder: y,
		ref: u,
		rows: b
	}), t[26] = u, t[27] = v, t[28] = y, t[29] = b, t[30] = f, t[31] = x) : x = t[31];
	let S;
	t[32] !== n || t[33] !== a || t[34] !== o ? (S = /* @__PURE__ */ Y(gl, {
		isDisabled: a,
		isInvalid: o,
		children: n
	}), t[32] = n, t[33] = a, t[34] = o, t[35] = S) : S = t[35];
	let C;
	return t[36] !== a || t[37] !== o || t[38] !== s || t[39] !== c || t[40] !== d || t[41] !== m || t[42] !== h || t[43] !== x || t[44] !== S ? (C = /* @__PURE__ */ X(Ji, {
		className: m,
		isDisabled: a,
		isInvalid: o,
		isReadOnly: s,
		isRequired: c,
		...d,
		children: [
			h,
			x,
			S
		]
	}), t[36] = a, t[37] = o, t[38] = s, t[39] = c, t[40] = d, t[41] = m, t[42] = h, t[43] = x, t[44] = S, t[45] = C) : C = t[45], C;
}
//#endregion
//#region lib/components/ToggleButtonGroup/ToggleButtonGroup.tsx
var hS = G({ base: "rounded-sm bg-background-secondary p-[.125rem] flex flex-row gap-x-xs w-fit" });
function gS(e) {
	let t = K(8), n, r;
	t[0] === e ? (n = t[1], r = t[2]) : ({className: n, ...r} = e, t[0] = e, t[1] = n, t[2] = r);
	let i;
	t[3] === n ? i = t[4] : (i = hS({ className: n }), t[3] = n, t[4] = i);
	let a;
	return t[5] !== r || t[6] !== i ? (a = /* @__PURE__ */ Y(Xi, {
		className: i,
		...r,
		children: r.children
	}), t[5] = r, t[6] = i, t[7] = a) : a = t[7], a;
}
var _S = G({ base: "rounded-sm px-md py-[.125rem] text-label-medium text-interactive-tertiary-button-enabled-foreground outline-none transition-all ease-in-out data-[selected]:bg-interactive-primary-button-enabled-background data-[selected]:text-interactive-primary-button-enabled-foreground hover:!bg-interactive-primary-button-hover-background hover:text-interactive-primary-button-enabled-foreground font-medium data-[disabled]:cursor-not-allowed data-[disabled]:text-interactive-disabled-foreground data-[disabled]:hover:!bg-transparent data-[disabled]:hover:!text-interactive-disabled-foreground data-[disabled]:data-[selected]:bg-background-tertiary data-[disabled]:data-[selected]:text-interactive-disabled-foreground data-[disabled]:opacity-60 data-[disabled]:data-[selected]:opacity-100" });
function vS(e) {
	let t = K(10), n, r, i;
	t[0] === e ? (n = t[1], r = t[2], i = t[3]) : ({children: n, className: r, ...i} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i);
	let a;
	t[4] === r ? a = t[5] : (a = _S({ className: r }), t[4] = r, t[5] = a);
	let o;
	return t[6] !== n || t[7] !== i || t[8] !== a ? (o = /* @__PURE__ */ Y(Yi, {
		className: a,
		...i,
		children: n
	}), t[6] = n, t[7] = i, t[8] = a, t[9] = o) : o = t[9], o;
}
//#endregion
//#region lib/components/UserMenu/UserMenu.tsx
function yS(e) {
	let t = K(21), { username: n, collapsed: r, onLogout: i, onPreferences: a, children: o } = e, s = !!a, c = r ? "w-12 justify-center" : "", l;
	t[0] === c ? l = t[1] : (l = W("flex w-[13rem] items-center gap-x-3 rounded-10 border-2 border-neutral-400 bg-interactive-tertiary-button-enabled-background px-xl py-lg font-normal text-text-primary shadow-[0_0_4px_0_#A0B7E4] hover:bg-overlay-medium", c), t[0] = c, t[1] = l);
	let u;
	t[2] === Symbol.for("react.memo_cache_sentinel") ? (u = /* @__PURE__ */ Y(be, { className: "size-lg" }), t[2] = u) : u = t[2];
	let d;
	t[3] !== r || t[4] !== n ? (d = r ? null : /* @__PURE__ */ Y("span", {
		className: "truncate",
		children: n
	}), t[3] = r, t[4] = n, t[5] = d) : d = t[5];
	let f;
	t[6] !== l || t[7] !== d || t[8] !== n ? (f = /* @__PURE__ */ X(Q, {
		"aria-label": n,
		className: l,
		variant: "tertiary",
		children: [u, d]
	}), t[6] = l, t[7] = d, t[8] = n, t[9] = f) : f = t[9];
	let p = r ? "top left" : "top", m;
	t[10] !== o || t[11] !== i || t[12] !== a || t[13] !== s ? (m = /* @__PURE__ */ Y(fi, {
		className: "flex w-[12.5rem] flex-col gap-y-1 rounded-md bg-transparent px-1 py-2 shadow-[0_0_4px_0_#A0B7E4] outline-none backdrop-blur-md",
		children: (e) => {
			let { close: t } = e;
			return /* @__PURE__ */ X(Dr, { children: [o, /* @__PURE__ */ X("ol", {
				className: "flex flex-col gap-y-1",
				role: "menu",
				children: [s ? /* @__PURE__ */ Y(Q, {
					className: "text-text-label-medium justify-center rounded-10 border-2 border-neutral-400 bg-overlay-medium px-xl py-lg text-center font-semibold shadow hover:bg-interactive-tertiary-button-hover-background",
					onPress: () => {
						a?.(), t();
					},
					slot: null,
					variant: "tertiary",
					children: "Preferences"
				}) : null, /* @__PURE__ */ Y(Q, {
					className: W("text-text-label-medium justify-center rounded-10 border-2 border-neutral-400 bg-overlay-medium px-xl py-lg text-center font-bold text-interactive-negative-button-enabled-foreground shadow hover:bg-interactive-negative-button-hover-background focus:bg-interactive-negative-button-focus-background"),
					onPress: i,
					variant: "plain",
					children: "Log Out"
				})]
			})] });
		}
	}), t[10] = o, t[11] = i, t[12] = a, t[13] = s, t[14] = m) : m = t[14];
	let h;
	t[15] !== p || t[16] !== m ? (h = /* @__PURE__ */ Y(ji, {
		placement: p,
		children: m
	}), t[15] = p, t[16] = m, t[17] = h) : h = t[17];
	let g;
	return t[18] !== f || t[19] !== h ? (g = /* @__PURE__ */ X(mi, { children: [f, h] }), t[18] = f, t[19] = h, t[20] = g) : g = t[20], g;
}
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/calendar/utils.mjs
function bS(e, t, n) {
	return t != null && e.compare(t) < 0 || n != null && e.compare(n) > 0;
}
function xS(e, t, n, r, i) {
	let a = {};
	for (let e in t) a[e] = Math.floor(t[e] / 2), a[e] > 0 && t[e] % 2 == 0 && a[e]--;
	return wS(e, SS(e, t, n).subtract(a), t, n, r, i);
}
function SS(e, t, n, r, i) {
	let a = e;
	return t.years ? a = Zr(e) : t.months ? a = Yr(e) : (t.weeks || t.days && t.days > 7) && (a = Xr(e, n)), wS(e, a, t, n, r, i);
}
function CS(e, t, n, r, i) {
	let a = { ...t };
	return a.days ? a.days-- : a.weeks ? a.weeks-- : a.months ? a.months-- : a.years && a.years--, wS(e, SS(e, t, n).subtract(a), t, n, r, i);
}
function wS(e, t, n, r, i, a) {
	if (i && e.compare(i) >= 0) {
		let e = Gr(t, SS($r(i), n, r));
		e && (t = e);
	}
	if (a && e.compare(a) <= 0) {
		let e = Kr(t, CS($r(a), n, r));
		e && (t = e);
	}
	return t;
}
function TS(e, t, n) {
	if (t) {
		let n = Gr(e, $r(t));
		n && (e = n);
	}
	if (n) {
		let t = Kr(e, $r(n));
		t && (e = t);
	}
	return e;
}
function ES(e, t, n) {
	if (!n) return e;
	for (; e.compare(t) >= 0 && n(e);) e = e.subtract({ days: 1 });
	return e.compare(t) >= 0 ? e : null;
}
function DS(e, t) {
	return e === t || e.days === t.days && e.weeks === t.weeks && e.months === t.months && e.years === t.years;
}
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/utils/useControlledState.mjs
var OS = typeof document < "u" ? dr.useInsertionEffect ?? dr.useLayoutEffect : () => {};
function kS(e, t, n) {
	let [r, i] = J(e || t), a = Tr(r), o = Tr(e !== void 0), s = e !== void 0;
	br(() => {
		let e = o.current;
		e !== s && process.env.NODE_ENV !== "production" && console.warn(`WARN: A component changed from ${e ? "controlled" : "uncontrolled"} to ${s ? "controlled" : "uncontrolled"}.`), o.current = s;
	}, [s]);
	let c = s ? e : r;
	OS(() => {
		a.current = c;
	});
	let [, l] = wr(() => ({}), {});
	return [c, vr((e, ...t) => {
		let r = typeof e == "function" ? e(a.current) : e;
		Object.is(a.current, r) || (a.current = r, i(r), l(), n?.(r, ...t));
	}, [n])];
}
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/calendar/useCalendarState.mjs
function AS(e) {
	let t = q(() => new Mr(e.locale), [e.locale]), n = q(() => t.resolvedOptions(), [t]), { locale: r, createCalendar: i, visibleDuration: a = { months: 1 }, minValue: o, maxValue: s, selectionAlignment: c, isDateUnavailable: l, pageBehavior: u = "visible", selectionMode: d = "single", firstDayOfWeek: f, weeksInMonth: p } = e, m = q(() => i(n.calendar), [i, n.calendar]), [h, g] = kS(e.value, e.defaultValue ?? null, e.onChange), _ = q(() => Array.isArray(h) ? h.map((e) => Qr($r(e), m)) : h ? Qr($r(h), m) : null, [h, m]), v = q(() => {
		let e = Array.isArray(h) ? h[0] : h;
		return e && "timeZone" in e ? e.timeZone : n.timeZone;
	}, [h, n.timeZone]), [y, b] = kS(q(() => e.focusedValue ? TS(Qr($r(e.focusedValue), m), o, s) : void 0, [
		e.focusedValue,
		m,
		o,
		s
	]), q(() => e.defaultFocusedValue ? TS(Qr($r(e.defaultFocusedValue), m), o, s) : TS(_ ? Array.isArray(_) ? _[0] : _ : Qr(ti(v), m), o, s), [
		e.defaultFocusedValue,
		_,
		v,
		m,
		o,
		s
	]), e.onFocusChange), x = () => {
		switch (c) {
			case "start": return SS(y, a, r, o, s);
			case "end": return CS(y, a, r, o, s);
			default: return xS(y, a, r, o, s);
		}
	}, [S, C] = J(x), [w, T] = J(e.autoFocus || !1), [E, D] = J(a);
	DS(a, E) || (D(a), C(x()));
	let O = q(() => {
		let e = { ...a };
		return e.days ? e.days-- : e.days = -1, S.add(e);
	}, [S, a]), [k, A] = J(m);
	if (!Hr(m, k)) {
		let e = Qr(y, m);
		C(xS(e, a, r, o, s)), b(e), A(m);
	}
	bS(y, o, s) ? b(TS(y, o, s)) : y.compare(S) < 0 ? C(CS(y, a, r, o, s)) : y.compare(O) > 0 && C(SS(y, a, r, o, s));
	function j(e) {
		e = TS(e, o, s), b(e);
	}
	function M(e) {
		let t = ES(TS(e, o, s), S, l);
		if (!t) return null;
		let n = Array.isArray(h) ? h[0] : h, r = Qr(t, n?.calendar || new Nr());
		return n && "hour" in n ? n.set(r) : r;
	}
	function N(t) {
		if (!e.isDisabled && !e.isReadOnly) {
			if (t === null) {
				g(d === "multiple" ? [] : null);
				return;
			}
			if (Array.isArray(t)) g(t.map(M).filter(Boolean));
			else {
				let e = M(t);
				e && g(e);
			}
		}
	}
	let P = q(() => _ ? Array.isArray(_) ? _.some((e) => l?.(e) || bS(e, o, s)) : l?.(_) || bS(_, o, s) : !1, [
		_,
		l,
		o,
		s
	]), F = e.isInvalid || e.validationState === "invalid" || P, I = F ? "invalid" : null, L = q(() => u === "visible" ? a : jS(a), [u, a]);
	return {
		isDisabled: e.isDisabled ?? !1,
		isReadOnly: e.isReadOnly ?? !1,
		value: _,
		setValue: N,
		selectionMode: d,
		visibleDuration: a,
		visibleRange: {
			start: S,
			end: O
		},
		minValue: o,
		maxValue: s,
		focusedDate: y,
		timeZone: v,
		validationState: I,
		isValueInvalid: F,
		setFocusedDate(e) {
			j(e);
		},
		focusNextDay() {
			j(y.add({ days: 1 }));
		},
		focusPreviousDay() {
			j(y.subtract({ days: 1 }));
		},
		focusNextRow() {
			a.days ? this.focusNextPage() : (a.weeks || a.months || a.years) && j(y.add({ weeks: 1 }));
		},
		focusPreviousRow() {
			a.days ? this.focusPreviousPage() : (a.weeks || a.months || a.years) && j(y.subtract({ weeks: 1 }));
		},
		focusNextPage() {
			let e = S.add(L);
			b(TS(y.add(L), o, s)), C(SS(wS(y, e, L, r, o, s), L, r));
		},
		focusPreviousPage() {
			let e = S.subtract(L);
			b(TS(y.subtract(L), o, s)), C(SS(wS(y, e, L, r, o, s), L, r));
		},
		focusSectionStart() {
			a.days ? j(S) : a.weeks ? j(Xr(y, r)) : (a.months || a.years) && j(Yr(y));
		},
		focusSectionEnd() {
			a.days ? j(O) : a.weeks ? j(Rr(y, r)) : (a.months || a.years) && j(Lr(y));
		},
		focusNextSection(e) {
			if (!e && !a.days) {
				j(y.add(jS(a)));
				return;
			}
			a.days ? this.focusNextPage() : a.weeks ? j(y.add({ months: 1 })) : (a.months || a.years) && j(y.add({ years: 1 }));
		},
		focusPreviousSection(e) {
			if (!e && !a.days) {
				j(y.subtract(jS(a)));
				return;
			}
			a.days ? this.focusPreviousPage() : a.weeks ? j(y.subtract({ months: 1 })) : (a.months || a.years) && j(y.subtract({ years: 1 }));
		},
		selectFocusedDate() {
			l && l(y) || this.selectDate(y);
		},
		selectDate(t) {
			if (!(e.isDisabled || e.isReadOnly)) {
				if (d === "multiple" && t != null) {
					let e = M(t);
					if (!e) return;
					let n = [];
					Array.isArray(h) ? n = h : h != null && (n = [h]);
					let r = n.findIndex((t) => Ur(t, e)), i = r >= 0 ? n.slice(0, r).concat(n.slice(r + 1)) : [...n, e];
					g(i);
				} else N(t);
			}
		},
		isFocused: w,
		setFocused: T,
		isInvalid(e) {
			return bS(e, o, s);
		},
		isSelected(e) {
			return !_ || this.isCellDisabled(e) || this.isCellUnavailable(e) ? !1 : Array.isArray(_) ? _.some((t) => Ur(t, e)) : Ur(e, _);
		},
		isCellFocused(e) {
			return w && y && Ur(e, y);
		},
		isCellDisabled(t) {
			return e.isDisabled || t.compare(S) < 0 || t.compare(O) > 0 || this.isInvalid(t);
		},
		isCellUnavailable(t) {
			return e.isDateUnavailable ? e.isDateUnavailable(t) : !1;
		},
		isPreviousVisibleRangeInvalid() {
			let e = S.subtract({ days: 1 });
			return Ur(e, S) || this.isInvalid(e);
		},
		isNextVisibleRangeInvalid() {
			let e = O.add({ days: 1 });
			return Ur(e, O) || this.isInvalid(e);
		},
		getDatesInWeek(e, t = S) {
			let n = t.add({ weeks: e }), i = [], o = a.days && a.days < 7 ? a.days : 7;
			if (o === 7) {
				n = Xr(n, r, f);
				let e = zr(n, r, f);
				for (let t = 0; t < e; t++) i.push(null);
			}
			for (; i.length < o;) {
				i.push(n);
				let e = n.add({ days: 1 });
				if (Ur(n, e)) break;
				n = e;
			}
			for (; i.length < o;) i.push(null);
			return i;
		},
		getWeeksInMonth(e = S) {
			let t = p || Vr(e, r, f);
			return (a.weeks || a.days) && (t = a.weeks ?? 0, a.days && (t += Math.ceil(a.days / 7))), t;
		}
	};
}
function jS(e) {
	let t = { ...e };
	for (let n in e) t[n] = 1;
	return t;
}
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/calendar/useRangeCalendarState.mjs
function MS(e) {
	let { value: t, defaultValue: n, onChange: r, createCalendar: i, locale: a, visibleDuration: o = { months: 1 }, minValue: s, maxValue: c, ...l } = e, [u, d] = kS(t, n || null, r), [f, p] = J(null), m = "center";
	if (u && u.start && u.end) {
		let e = xS($r(u.start), o, a, s, c).add(o).subtract({ days: 1 });
		u.end.compare(e) > 0 && (m = "start");
	}
	let h = q(() => {
		let t = e.isDateUnavailable;
		if (t) return (e) => t(e, f);
	}, [e.isDateUnavailable, f]), g = vr((t) => t && h && !e.allowsNonContiguousRanges ? {
		start: FS(t, h, o, -1),
		end: FS(t, h, o, 1)
	} : null, [
		h,
		o,
		e.allowsNonContiguousRanges
	]), _ = q(() => g(f), [g, f]), v = q(() => Gr(s, _?.start), [s, _]), y = q(() => Kr(c, _?.end), [c, _]), b = AS({
		...l,
		value: u && u.start,
		createCalendar: i,
		locale: a,
		visibleDuration: o,
		minValue: v,
		maxValue: y,
		selectionAlignment: e.selectionAlignment || m,
		isDateUnavailable: h
	}), x = f ? NS(f, b.focusedDate) : u && NS(u.start, u.end), S = (t) => {
		if (e.isReadOnly) return;
		let n = ES(TS(t, v, y), b.visibleRange.start, h);
		if (n) {
			if (!f) p(n);
			else {
				let e = NS(f, n);
				e && d({
					start: PS(e.start, u?.start),
					end: PS(e.end, u?.end)
				}), p(null);
			}
		}
	}, [C, w] = J(!1), T = q(() => !u || f ? !1 : h && (h(u.start) || h(u.end)) ? !0 : bS(u.start, s, c) || bS(u.end, s, c), [
		h,
		u,
		f,
		s,
		c
	]), E = e.isInvalid || e.validationState === "invalid" || T, D = E ? "invalid" : null;
	return {
		...b,
		value: u,
		setValue: d,
		anchorDate: f,
		setAnchorDate: p,
		highlightedRange: x,
		validationState: D,
		isValueInvalid: E,
		selectFocusedDate() {
			b.isCellUnavailable(b.focusedDate) || S(b.focusedDate);
		},
		commitSelection() {
			S(b.focusedDate);
		},
		selectDate: S,
		highlightDate(e) {
			f && b.setFocusedDate(e);
		},
		isSelected(e) {
			return !!(x && e.compare(x.start) >= 0 && e.compare(x.end) <= 0 && !b.isCellDisabled(e) && !b.isCellUnavailable(e));
		},
		isInvalid(e) {
			return b.isInvalid(e) || bS(e, _?.start, _?.end);
		},
		isDragging: C,
		setDragging: w,
		clearSelection() {
			p(null), d(null);
		},
		focusNearestAvailableDate(e) {
			let t = g(e), n = (e) => this.isInvalid(e) || bS(e, t?.start, t?.end), r = e.add({ days: 1 });
			n(r) && (r = e.subtract({ days: 1 })), n(r) || (this.setFocusedDate(r), this.setFocused(!0));
		}
	};
}
function NS(e, t) {
	return !e || !t ? null : (t.compare(e) < 0 && ([e, t] = [t, e]), {
		start: $r(e),
		end: $r(t)
	});
}
function PS(e, t) {
	return e = Qr(e, t?.calendar || new Nr()), t && "hour" in t ? t.set(e) : e;
}
function FS(e, t, n, r) {
	let i = e.add({ days: r }), a = e.subtract(n), o = e.add(n);
	for (; (r < 0 ? i.compare(a) >= 0 : i.compare(o) <= 0) && !t(i);) i = i.add({ days: r });
	if (t(i)) return i.add({ days: -r });
}
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/form/useFormValidationState.mjs
var IS = {
	badInput: !1,
	customError: !1,
	patternMismatch: !1,
	rangeOverflow: !1,
	rangeUnderflow: !1,
	stepMismatch: !1,
	tooLong: !1,
	tooShort: !1,
	typeMismatch: !1,
	valueMissing: !1,
	valid: !0
}, LS = {
	...IS,
	customError: !0,
	valid: !1
}, RS = {
	isInvalid: !1,
	validationDetails: IS,
	validationErrors: []
}, zS = hr({}), BS = "__reactAriaFormValidationState";
function VS(e) {
	if (e.__reactAriaFormValidationState) {
		let { realtimeValidation: t, displayValidation: n, updateValidation: r, resetValidation: i, commitValidation: a } = e[BS];
		return {
			realtimeValidation: t,
			displayValidation: n,
			updateValidation: r,
			resetValidation: i,
			commitValidation: a
		};
	}
	return HS(e);
}
function HS(e) {
	let { isInvalid: t, validationState: n, name: r, value: i, builtinValidation: a, validate: o, validationBehavior: s = "aria" } = e;
	n && (t ||= n === "invalid");
	let c = t === void 0 ? null : {
		isInvalid: t,
		validationErrors: [],
		validationDetails: LS
	}, l = q(() => !o || i == null ? null : GS(WS(o, i)), [o, i]);
	a?.validationDetails.valid && (a = void 0);
	let u = yr(zS), d = q(() => r ? Array.isArray(r) ? r.flatMap((e) => US(u[e])) : US(u[r]) : [], [u, r]), [f, p] = J(u), [m, h] = J(!1);
	u !== f && (p(u), h(!1));
	let g = q(() => GS(m ? [] : d), [m, d]), _ = Tr(RS), [v, y] = J(RS), b = Tr(RS), x = () => {
		if (!S) return;
		C(!1);
		let e = l || a || _.current;
		KS(e, b.current) || (b.current = e, y(e));
	}, [S, C] = J(!1);
	return br(x), {
		realtimeValidation: c || g || l || a || RS,
		displayValidation: s === "native" ? c || g || v : c || g || l || a || v,
		updateValidation(e) {
			s === "aria" && !KS(v, e) ? y(e) : _.current = e;
		},
		resetValidation() {
			let e = RS;
			KS(e, b.current) || (b.current = e, y(e)), s === "native" && C(!1), h(!0);
		},
		commitValidation() {
			s === "native" && C(!0), h(!0);
		}
	};
}
function US(e) {
	return e ? Array.isArray(e) ? e : [e] : [];
}
function WS(e, t) {
	if (typeof e == "function") {
		let n = e(t);
		if (n && typeof n != "boolean") return US(n);
	}
	return [];
}
function GS(e) {
	return e.length ? {
		isInvalid: !0,
		validationErrors: e,
		validationDetails: LS
	} : null;
}
function KS(e, t) {
	return e === t || !!e && !!t && e.isInvalid === t.isInvalid && e.validationErrors.length === t.validationErrors.length && e.validationErrors.every((e, n) => e === t.validationErrors[n]) && Object.entries(e.validationDetails).every(([e, n]) => t.validationDetails[e] === n);
}
function qS(...e) {
	let t = /* @__PURE__ */ new Set(), n = !1, r = { ...IS };
	for (let i of e) {
		for (let e of i.validationErrors) t.add(e);
		n ||= i.isInvalid;
		for (let e in r) r[e] ||= i.validationDetails[e];
	}
	return r.valid = !n, {
		isInvalid: n,
		validationErrors: [...t],
		validationDetails: r
	};
}
//#endregion
//#region ../../node_modules/.pnpm/@internationalized+string@3.2.10/node_modules/@internationalized/string/dist/private/LocalizedStringDictionary.mjs
var JS = Symbol.for("react-aria.i18n.locale"), YS = Symbol.for("react-aria.i18n.strings"), XS = void 0, ZS = class e {
	constructor(e, t = "en-US") {
		this.strings = Object.fromEntries(Object.entries(e).filter(([, e]) => e)), this.defaultLocale = t;
	}
	getStringForLocale(e, t) {
		let n = this.getStringsForLocale(t)[e];
		if (!n) throw Error(`Could not find intl message ${e} in ${t} locale`);
		return n;
	}
	getStringsForLocale(e) {
		let t = this.strings[e];
		return t || (t = QS(e, this.strings, this.defaultLocale), this.strings[e] = t), t;
	}
	static getGlobalDictionaryForPackage(t) {
		if (typeof window > "u") return null;
		let n = window[JS];
		if (XS === void 0) {
			let t = window[YS];
			if (!t) return null;
			XS = {};
			for (let r in t) XS[r] = new e({ [n]: t[r] }, n);
		}
		let r = XS?.[t];
		if (!r) throw Error(`Strings for package "${t}" were not included by LocalizedStringProvider. Please add it to the list passed to createLocalizedStringDictionary.`);
		return r;
	}
};
function QS(e, t, n = "en-US") {
	if (t[e]) return t[e];
	let r = $S(e), i = eC(e);
	if (i && t[`${r}-${i}`]) return t[`${r}-${i}`];
	if (t[r]) return t[r];
	for (let e in t) if (e.startsWith(r + "-")) return t[e];
	return t[n];
}
function $S(e) {
	return Intl.Locale ? new Intl.Locale(e).language : e.split("-")[0];
}
function eC(e) {
	if (Intl.Locale) return new Intl.Locale(e).script;
}
//#endregion
//#region ../../node_modules/.pnpm/@internationalized+string@3.2.10/node_modules/@internationalized/string/dist/private/LocalizedStringFormatter.mjs
var tC = /* @__PURE__ */ new Map(), nC = /* @__PURE__ */ new Map(), rC = class {
	constructor(e, t) {
		this.locale = e, this.strings = t;
	}
	format(e, t) {
		let n = this.strings.getStringForLocale(e, this.locale);
		return typeof n == "function" ? n(t, this) : n;
	}
	plural(e, t, n = "cardinal") {
		let r = t["=" + e];
		if (r) return typeof r == "function" ? r() : r;
		let i = this.locale + ":" + n, a = tC.get(i);
		return a || (a = new Intl.PluralRules(this.locale, { type: n }), tC.set(i, a)), r = t[a.select(e)] || t.other, typeof r == "function" ? r() : r;
	}
	number(e) {
		let t = nC.get(this.locale);
		return t || (t = new Intl.NumberFormat(this.locale), nC.set(this.locale, t)), t.format(e);
	}
	select(e, t) {
		let n = e[t] || e.other;
		return typeof n == "function" ? n() : n;
	}
}, iC = /* @__PURE__ */ new Map(), aC = !1;
try {
	aC = new Intl.NumberFormat("de-DE", { signDisplay: "exceptZero" }).resolvedOptions().signDisplay === "exceptZero";
} catch {}
var oC = !1;
try {
	oC = new Intl.NumberFormat("de-DE", {
		style: "unit",
		unit: "degree"
	}).resolvedOptions().style === "unit";
} catch {}
var sC = { degree: { narrow: {
	default: "°",
	"ja-JP": " 度",
	"zh-TW": "度",
	"sl-SI": " °"
} } }, cC = class {
	constructor(e, t = {}) {
		this.numberFormatter = lC(e, t), this.options = t;
	}
	format(e) {
		let t = "";
		if (t = !aC && this.options.signDisplay != null ? uC(this.numberFormatter, this.options.signDisplay, e) : this.numberFormatter.format(e), this.options.style === "unit" && !oC) {
			let { unit: e, unitDisplay: n = "short", locale: r } = this.resolvedOptions();
			if (!e) return t;
			let i = sC[e]?.[n];
			t += i[r] || i.default;
		}
		return t;
	}
	formatToParts(e) {
		return this.numberFormatter.formatToParts(e);
	}
	formatRange(e, t) {
		if (typeof this.numberFormatter.formatRange == "function") return this.numberFormatter.formatRange(e, t);
		if (t < e) throw RangeError("End date must be >= start date");
		return `${this.format(e)} \u{2013} ${this.format(t)}`;
	}
	formatRangeToParts(e, t) {
		if (typeof this.numberFormatter.formatRangeToParts == "function") return this.numberFormatter.formatRangeToParts(e, t);
		if (t < e) throw RangeError("End date must be >= start date");
		let n = this.numberFormatter.formatToParts(e), r = this.numberFormatter.formatToParts(t);
		return [
			...n.map((e) => ({
				...e,
				source: "startRange"
			})),
			{
				type: "literal",
				value: " – ",
				source: "shared"
			},
			...r.map((e) => ({
				...e,
				source: "endRange"
			}))
		];
	}
	resolvedOptions() {
		let e = this.numberFormatter.resolvedOptions();
		return !aC && this.options.signDisplay != null && (e = {
			...e,
			signDisplay: this.options.signDisplay
		}), !oC && this.options.style === "unit" && (e = {
			...e,
			style: "unit",
			unit: this.options.unit,
			unitDisplay: this.options.unitDisplay
		}), e;
	}
};
function lC(e, t = {}) {
	let { numberingSystem: n } = t;
	if (n && e.includes("-nu-") && (e.includes("-u-") || (e += "-u-"), e += `-nu-${n}`), t.style === "unit" && !oC) {
		let { unit: e, unitDisplay: n = "short" } = t;
		if (!e) throw Error("unit option must be provided with style: \"unit\"");
		if (!sC[e]?.[n]) throw Error(`Unsupported unit ${e} with unitDisplay = ${n}`);
		t = {
			...t,
			style: "decimal"
		};
	}
	let r = e + (t ? Object.entries(t).sort((e, t) => e[0] < t[0] ? -1 : 1).join() : "");
	if (iC.has(r)) return iC.get(r);
	let i = new Intl.NumberFormat(e, t);
	return iC.set(r, i), i;
}
function uC(e, t, n) {
	if (t === "auto") return e.format(n);
	if (t === "never") return e.format(Math.abs(n));
	{
		let r = !1;
		if (t === "always" ? r = n > 0 || Object.is(n, 0) : t === "exceptZero" && (Object.is(n, -0) || Object.is(n, 0) ? n = Math.abs(n) : r = n > 0), r) {
			let t = e.format(-n), r = e.format(n), i = t.replace(r, "").replace(/\u200e|\u061C/, "");
			return [...i].length !== 1 && console.warn("@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case"), t.replace(r, "!!!").replace(i, "+").replace("!!!", r);
		}
		return e.format(n);
	}
}
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/collections/getChildNodes.mjs
function dC(e, t) {
	return typeof t.getChildren == "function" ? t.getChildren(e.key) : e.childNodes;
}
function fC(e) {
	return pC(e, 0);
}
function pC(e, t) {
	if (t < 0) return;
	let n = 0;
	for (let r of e) {
		if (n === t) return r;
		n++;
	}
}
function mC(e, t, n) {
	if (t.parentKey === n.parentKey) return t.index - n.index;
	let r = [...hC(e, t), t], i = [...hC(e, n), n], a = r.slice(0, i.length).findIndex((e, t) => e !== i[t]);
	return a === -1 ? r.findIndex((e) => e === n) >= 0 ? 1 : (i.findIndex((e) => e === t), -1) : (t = r[a], n = i[a], t.index - n.index);
}
function hC(e, t) {
	let n = [], r = t;
	for (; r?.parentKey != null;) r = e.getItem(r.parentKey), r && n.unshift(r);
	return n;
}
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/list/ListCollection.mjs
var gC = class {
	constructor(e) {
		this.keyMap = /* @__PURE__ */ new Map(), this.firstKey = null, this.lastKey = null, this.iterable = e;
		let t = (e) => {
			if (this.keyMap.set(e.key, e), e.childNodes && e.type === "section") for (let n of e.childNodes) t(n);
		};
		for (let n of e) t(n);
		let n = null, r = 0, i = 0;
		for (let [e, t] of this.keyMap) n ? (n.nextKey = e, t.prevKey = n.key) : (this.firstKey = e, t.prevKey = void 0), t.type === "item" && (t.index = r++), (t.type === "section" || t.type === "item") && i++, n = t, n.nextKey = void 0;
		this._size = i, this.lastKey = n?.key ?? null;
	}
	*[Symbol.iterator]() {
		yield* this.iterable;
	}
	get size() {
		return this._size;
	}
	getKeys() {
		return this.keyMap.keys();
	}
	getKeyBefore(e) {
		let t = this.keyMap.get(e);
		return t ? t.prevKey ?? null : null;
	}
	getKeyAfter(e) {
		let t = this.keyMap.get(e);
		return t ? t.nextKey ?? null : null;
	}
	getFirstKey() {
		return this.firstKey;
	}
	getLastKey() {
		return this.lastKey;
	}
	getItem(e) {
		return this.keyMap.get(e) ?? null;
	}
	at(e) {
		let t = [...this.getKeys()];
		return this.getItem(t[e]);
	}
	getChildren(e) {
		return this.keyMap.get(e)?.childNodes || [];
	}
}, _C = class e extends Set {
	constructor(t, n, r) {
		super(t), t instanceof e ? (this.anchorKey = n ?? t.anchorKey, this.currentKey = r ?? t.currentKey) : (this.anchorKey = n ?? null, this.currentKey = r ?? null);
	}
};
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/selection/useMultipleSelectionState.mjs
function vC(e, t) {
	if (e.size !== t.size) return !1;
	for (let n of e) if (!t.has(n)) return !1;
	return !0;
}
function yC(e) {
	let { selectionMode: t = "none", disallowEmptySelection: n = !1, allowDuplicateSelectionEvents: r, selectionBehavior: i = "toggle", disabledBehavior: a = "all" } = e, o = Tr(!1), [, s] = J(!1), c = Tr(null), l = Tr(null), [, u] = J(null), [d, f] = kS(q(() => bC(e.selectedKeys), [e.selectedKeys]), q(() => bC(e.defaultSelectedKeys, new _C()), [e.defaultSelectedKeys]), e.onSelectionChange), p = q(() => e.disabledKeys ? new Set(e.disabledKeys) : /* @__PURE__ */ new Set(), [e.disabledKeys]), [m, h] = J(i);
	i === "replace" && m === "toggle" && typeof d == "object" && d.size === 0 && h("replace");
	let g = Tr(i);
	return br(() => {
		i !== g.current && (h(i), g.current = i);
	}, [i]), {
		selectionMode: t,
		disallowEmptySelection: n,
		selectionBehavior: m,
		setSelectionBehavior: h,
		get isFocused() {
			return o.current;
		},
		setFocused(e) {
			o.current = e, s(e);
		},
		get focusedKey() {
			return c.current;
		},
		get childFocusStrategy() {
			return l.current;
		},
		setFocusedKey(e, t = "first") {
			c.current = e, l.current = t, u(e);
		},
		selectedKeys: d,
		setSelectedKeys(e) {
			(r || !vC(e, d)) && f(e);
		},
		disabledKeys: p,
		disabledBehavior: a
	};
}
function bC(e, t) {
	return e ? e === "all" ? "all" : new _C(e) : t;
}
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/selection/SelectionManager.mjs
var xC = class e {
	constructor(e, t, n) {
		this.collection = e, this.state = t, this.allowsCellSelection = n?.allowsCellSelection ?? !1, this._isSelectAll = null, this.layoutDelegate = n?.layoutDelegate || null, this.fullCollection = n?.fullCollection || null;
	}
	get selectionMode() {
		return this.state.selectionMode;
	}
	get disallowEmptySelection() {
		return this.state.disallowEmptySelection;
	}
	get selectionBehavior() {
		return this.state.selectionBehavior;
	}
	setSelectionBehavior(e) {
		this.state.setSelectionBehavior(e);
	}
	get isFocused() {
		return this.state.isFocused;
	}
	setFocused(e) {
		this.state.setFocused(e);
	}
	get focusedKey() {
		return this.state.focusedKey;
	}
	get childFocusStrategy() {
		return this.state.childFocusStrategy;
	}
	setFocusedKey(e, t) {
		(e == null || this.collection.getItem(e)) && this.state.setFocusedKey(e, t);
	}
	get selectedKeys() {
		return this.state.selectedKeys === "all" ? new Set(this.getSelectAllKeys()) : this.state.selectedKeys;
	}
	get rawSelection() {
		return this.state.selectedKeys;
	}
	isSelected(e) {
		if (this.state.selectionMode === "none") return !1;
		let t = this.getKey(e);
		return t == null ? !1 : this.state.selectedKeys === "all" ? this.canSelectItem(t) : this.state.selectedKeys.has(t);
	}
	get isEmpty() {
		return this.state.selectedKeys !== "all" && this.state.selectedKeys.size === 0;
	}
	get isSelectAll() {
		if (this.isEmpty) return !1;
		if (this.state.selectedKeys === "all") return !0;
		if (this._isSelectAll != null) return this._isSelectAll;
		let e = this.getSelectAllKeys(), t = this.state.selectedKeys;
		return this._isSelectAll = e.every((e) => t.has(e)), this._isSelectAll;
	}
	get firstSelectedKey() {
		let e = null;
		for (let t of this.state.selectedKeys) {
			let n = this.collection.getItem(t);
			(!e || n && mC(this.collection, n, e) < 0) && (e = n);
		}
		return e?.key ?? null;
	}
	get lastSelectedKey() {
		let e = null;
		for (let t of this.state.selectedKeys) {
			let n = this.collection.getItem(t);
			(!e || n && mC(this.collection, n, e) > 0) && (e = n);
		}
		return e?.key ?? null;
	}
	get disabledKeys() {
		return this.state.disabledKeys;
	}
	get disabledBehavior() {
		return this.state.disabledBehavior;
	}
	extendSelection(e) {
		if (this.selectionMode === "none") return;
		if (this.selectionMode === "single") {
			this.replaceSelection(e);
			return;
		}
		let t = this.getKey(e);
		if (t == null) return;
		let n;
		if (this.state.selectedKeys === "all") n = new _C([t], t, t);
		else {
			let e = this.state.selectedKeys, r = e.anchorKey ?? t;
			n = new _C(e, r, t);
			for (let i of this.getKeyRange(r, e.currentKey ?? t)) n.delete(i);
			for (let e of this.getKeyRange(t, r)) this.canSelectItem(e) && n.add(e);
		}
		this.state.setSelectedKeys(n);
	}
	getKeyRange(e, t) {
		let n = this.collection.getItem(e), r = this.collection.getItem(t);
		return n && r ? mC(this.collection, n, r) <= 0 ? this.getKeyRangeInternal(e, t) : this.getKeyRangeInternal(t, e) : [];
	}
	getKeyRangeInternal(e, t) {
		if (this.layoutDelegate?.getKeyRange) return this.layoutDelegate.getKeyRange(e, t);
		let n = [], r = e;
		for (; r != null;) {
			let e = this.collection.getItem(r);
			if (e && (e.type === "item" || e.type === "cell" && this.allowsCellSelection) && n.push(r), r === t) return n;
			r = this.collection.getKeyAfter(r);
		}
		return [];
	}
	getKey(e) {
		let t = this.collection.getItem(e);
		if (!t || t.type === "cell" && this.allowsCellSelection) return e;
		for (; t && t.type !== "item" && t.parentKey != null;) t = this.collection.getItem(t.parentKey);
		return !t || t.type !== "item" ? null : t.key;
	}
	toggleSelection(e) {
		if (this.selectionMode === "none") return;
		if (this.selectionMode === "single" && !this.isSelected(e)) {
			this.replaceSelection(e);
			return;
		}
		let t = this.getKey(e);
		if (t == null) return;
		let n = new _C(this.state.selectedKeys === "all" ? this.getSelectAllKeys() : this.state.selectedKeys);
		n.has(t) ? n.delete(t) : this.canSelectItem(t) && (n.add(t), n.anchorKey = t, n.currentKey = t), !(this.disallowEmptySelection && n.size === 0) && this.state.setSelectedKeys(n);
	}
	replaceSelection(e) {
		if (this.selectionMode === "none") return;
		let t = this.getKey(e);
		if (t == null) return;
		let n = this.canSelectItem(t) ? new _C([t], t, t) : new _C();
		this.state.setSelectedKeys(n);
	}
	setSelectedKeys(e) {
		if (this.selectionMode === "none") return;
		let t = new _C();
		for (let n of e) {
			let e = this.getKey(n);
			if (e != null && (t.add(e), this.selectionMode === "single")) break;
		}
		this.state.setSelectedKeys(t);
	}
	getSelectAllKeys() {
		let e = this.fullCollection ?? this.collection, t = [], n = (r) => {
			for (; r != null;) {
				if (this.canSelectItemIn(r, e)) {
					let i = e.getItem(r);
					i?.type === "item" && t.push(r), i?.hasChildNodes && (this.allowsCellSelection || i.type !== "item") && n(fC(dC(i, e))?.key ?? null);
				}
				r = e.getKeyAfter(r);
			}
		};
		return n(e.getFirstKey()), t;
	}
	selectAll() {
		!this.isSelectAll && this.selectionMode === "multiple" && this.state.setSelectedKeys("all");
	}
	clearSelection() {
		!this.disallowEmptySelection && (this.state.selectedKeys === "all" || this.state.selectedKeys.size > 0) && this.state.setSelectedKeys(new _C());
	}
	toggleSelectAll() {
		this.isSelectAll ? this.clearSelection() : this.selectAll();
	}
	select(e, t) {
		this.selectionMode !== "none" && (this.selectionMode === "single" ? this.isSelected(e) && !this.disallowEmptySelection ? this.toggleSelection(e) : this.replaceSelection(e) : this.selectionBehavior === "toggle" || t && (t.pointerType === "touch" || t.pointerType === "virtual") ? this.toggleSelection(e) : this.replaceSelection(e));
	}
	isSelectionEqual(e) {
		if (e === this.state.selectedKeys) return !0;
		let t = this.selectedKeys;
		if (e.size !== t.size) return !1;
		for (let n of e) if (!t.has(n)) return !1;
		for (let n of t) if (!e.has(n)) return !1;
		return !0;
	}
	canSelectItem(e) {
		return this.canSelectItemIn(e, this.collection);
	}
	canSelectItemIn(e, t) {
		if (this.state.selectionMode === "none" || this.state.disabledKeys.has(e)) return !1;
		let n = t.getItem(e);
		return !(!n || n?.props?.isDisabled || n.type === "cell" && !this.allowsCellSelection);
	}
	isDisabled(e) {
		let t = this.collection.getItem(e);
		return this.state.disabledBehavior === "all" && (this.state.disabledKeys.has(e) || !!t?.props?.isDisabled) && t?.props?.disabledBehavior !== "selection";
	}
	isLink(e) {
		return !!this.collection.getItem(e)?.props?.href;
	}
	getItemProps(e) {
		return this.collection.getItem(e)?.props;
	}
	withCollection(t) {
		return new e(t, this.state, {
			allowsCellSelection: this.allowsCellSelection,
			layoutDelegate: this.layoutDelegate || void 0,
			fullCollection: this.fullCollection ?? this.collection
		});
	}
}, SC = class {
	build(e, t) {
		return this.context = t, CC(() => this.iterateCollection(e));
	}
	*iterateCollection(e) {
		let { children: t, items: n } = e;
		if (dr.isValidElement(t) && t.type === dr.Fragment) yield* this.iterateCollection({
			children: t.props.children,
			items: n
		});
		else if (typeof t == "function") {
			if (!n) throw Error("props.children was a function but props.items is missing");
			let e = 0;
			for (let r of n) yield* this.getFullNode({
				value: r,
				index: e
			}, { renderer: t }), e++;
		} else {
			let e = [];
			dr.Children.forEach(t, (t) => {
				t && e.push(t);
			});
			let n = 0;
			for (let t of e) {
				let e = this.getFullNode({
					element: t,
					index: n
				}, {});
				for (let t of e) n++, yield t;
			}
		}
	}
	getKey(e, t, n, r) {
		if (e.key != null) return e.key;
		if (t.type === "cell" && t.key != null) return `${r}${t.key}`;
		let i = t.value;
		if (i != null) {
			let e = i.key ?? i.id;
			if (e == null) throw Error("No key found for item");
			return e;
		}
		return r ? `${r}.${t.index}` : `$.${t.index}`;
	}
	getChildState(e, t) {
		return { renderer: t.renderer || e.renderer };
	}
	*getFullNode(e, t, n, r) {
		if (dr.isValidElement(e.element) && e.element.type === dr.Fragment) {
			let i = [];
			dr.Children.forEach(e.element.props.children, (e) => {
				i.push(e);
			});
			let a = e.index ?? 0;
			for (let e of i) yield* this.getFullNode({
				element: e,
				index: a++
			}, t, n, r);
			return;
		}
		let i = e.element;
		if (!i && e.value && t && t.renderer) {
			let n = this.cache.get(e.value);
			if (n && (!n.shouldInvalidate || !n.shouldInvalidate(this.context))) {
				n.index = e.index, n.parentKey = r ? r.key : null, yield n;
				return;
			}
			i = t.renderer(e.value);
		}
		if (dr.isValidElement(i)) {
			let a = i.type;
			if (typeof a != "function" && typeof a.getCollectionNode != "function") {
				let e = i.type;
				throw Error(`Unknown element <${e}> in collection.`);
			}
			let o = a.getCollectionNode(i.props, this.context), s = e.index ?? 0, c = o.next();
			for (; !c.done && c.value;) {
				let a = c.value;
				e.index = s;
				let l = a.key ?? null;
				l ??= a.element ? null : this.getKey(i, e, t, n);
				let u = [...this.getFullNode({
					...a,
					key: l,
					index: s,
					wrapper: wC(e.wrapper, a.wrapper)
				}, this.getChildState(t, a), n ? `${n}${i.key}` : i.key, r)];
				for (let t of u) {
					if (t.value = a.value ?? e.value ?? null, t.value && this.cache.set(t.value, t), e.type && t.type !== e.type) throw Error(`Unsupported type <${TC(t.type)}> in <${TC(r?.type ?? "unknown parent type")}>. Only <${TC(e.type)}> is supported.`);
					s++, yield t;
				}
				c = o.next(u);
			}
			return;
		}
		if (e.key == null || e.type == null) return;
		let a = this, o = {
			type: e.type,
			props: e.props,
			key: e.key,
			parentKey: r ? r.key : null,
			value: e.value ?? null,
			level: (r?.level ?? 0) + +(r?.type === "item"),
			index: e.index,
			rendered: e.rendered,
			textValue: e.textValue ?? "",
			"aria-label": e["aria-label"],
			wrapper: e.wrapper,
			shouldInvalidate: e.shouldInvalidate,
			hasChildNodes: e.hasChildNodes || !1,
			childNodes: CC(function* () {
				if (!e.hasChildNodes || !e.childNodes) return;
				let n = 0;
				for (let r of e.childNodes()) {
					r.key != null && (r.key = `${o.key}${r.key}`);
					let e = a.getFullNode({
						...r,
						index: n
					}, a.getChildState(t, r), o.key, o);
					for (let t of e) n++, yield t;
				}
			})
		};
		yield o;
	}
	constructor() {
		this.cache = /* @__PURE__ */ new WeakMap();
	}
};
function CC(e) {
	let t = [], n = null;
	return { *[Symbol.iterator]() {
		for (let e of t) yield e;
		n ||= e();
		for (let e of n) t.push(e), yield e;
	} };
}
function wC(e, t) {
	if (e && t) return (n) => e(t(n));
	if (e) return e;
	if (t) return t;
}
function TC(e) {
	return e[0].toUpperCase() + e.slice(1);
}
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/collections/useCollection.mjs
function EC(e, t, n) {
	let r = q(() => new SC(), []), { children: i, items: a, collection: o } = e;
	return q(() => o || t(r.build({
		children: i,
		items: a
	}, n)), [
		r,
		i,
		a,
		o,
		n,
		t
	]);
}
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/list/useListState.mjs
function DC(e) {
	let { filter: t, layoutDelegate: n } = e, r = yC(e), i = q(() => e.disabledKeys ? new Set(e.disabledKeys) : /* @__PURE__ */ new Set(), [e.disabledKeys]), a = EC(e, vr((e) => t ? new gC(t(e)) : new gC(e), [t]), q(() => ({ suppressTextValueWarning: e.suppressTextValueWarning }), [e.suppressTextValueWarning])), o = q(() => new xC(a, r, { layoutDelegate: n }), [
		a,
		r,
		n
	]);
	return OC(a, o), {
		collection: a,
		disabledKeys: i,
		selectionManager: o
	};
}
function OC(e, t) {
	let n = Tr(null);
	br(() => {
		if (t.focusedKey != null && !e.getItem(t.focusedKey) && n.current) {
			let r = n.current.getKeyAfter(t.focusedKey), i = null;
			for (; r != null;) {
				let a = e.getItem(r);
				if (a && a.type === "item" && !t.isDisabled(r)) {
					i = r;
					break;
				}
				r = n.current.getKeyAfter(r);
			}
			if (i == null) for (r = n.current.getKeyBefore(t.focusedKey); r != null;) {
				let a = e.getItem(r);
				if (a && a.type === "item" && !t.isDisabled(r)) {
					i = r;
					break;
				}
				r = n.current.getKeyBefore(r);
			}
			t.setFocusedKey(i);
		}
		n.current = e;
	}, [e, t]);
}
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/overlays/useOverlayTriggerState.mjs
function kC(e) {
	let [t, n] = kS(e.isOpen, e.defaultOpen || !1, e.onOpenChange), [r, i] = J(null);
	return {
		isOpen: t,
		setOpen: n,
		open: vr(() => {
			n(!0);
		}, [n]),
		close: vr(() => {
			n(!1);
		}, [n]),
		toggle: vr(() => {
			n(!t);
		}, [n, t]),
		point: r,
		setPoint: i
	};
}
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/intl/datepicker/ar-AE.mjs
var AC = {};
AC = {
	rangeOverflow: (e) => `\u{64A}\u{62C}\u{628} \u{623}\u{646} \u{62A}\u{643}\u{648}\u{646} \u{627}\u{644}\u{642}\u{64A}\u{645}\u{629} ${e.maxValue} \u{623}\u{648} \u{642}\u{628}\u{644} \u{630}\u{644}\u{643}.`,
	rangeReversed: "تاريخ البدء يجب أن يكون قبل تاريخ الانتهاء.",
	rangeUnderflow: (e) => `\u{64A}\u{62C}\u{628} \u{623}\u{646} \u{62A}\u{643}\u{648}\u{646} \u{627}\u{644}\u{642}\u{64A}\u{645}\u{629} ${e.minValue} \u{623}\u{648} \u{628}\u{639}\u{62F} \u{630}\u{644}\u{643}.`,
	unavailableDate: "البيانات المحددة غير متاحة."
};
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/intl/datepicker/bg-BG.mjs
var jC = {};
jC = {
	rangeOverflow: (e) => `\u{421}\u{442}\u{43E}\u{439}\u{43D}\u{43E}\u{441}\u{442}\u{442}\u{430} \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{435} ${e.maxValue} \u{438}\u{43B}\u{438} \u{43F}\u{43E}-\u{440}\u{430}\u{43D}\u{43D}\u{430}.`,
	rangeReversed: "Началната дата трябва да е преди крайната.",
	rangeUnderflow: (e) => `\u{421}\u{442}\u{43E}\u{439}\u{43D}\u{43E}\u{441}\u{442}\u{442}\u{430} \u{442}\u{440}\u{44F}\u{431}\u{432}\u{430} \u{434}\u{430} \u{435} ${e.minValue} \u{438}\u{43B}\u{438} \u{43F}\u{43E}-\u{43A}\u{44A}\u{441}\u{43D}\u{43E}.`,
	unavailableDate: "Избраната дата не е налична."
};
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/intl/datepicker/cs-CZ.mjs
var MC = {};
MC = {
	rangeOverflow: (e) => `Hodnota mus\xed b\xfdt ${e.maxValue} nebo d\u{159}\xedv\u{11B}j\u{161}\xed.`,
	rangeReversed: "Datum zahájení musí předcházet datu ukončení.",
	rangeUnderflow: (e) => `Hodnota mus\xed b\xfdt ${e.minValue} nebo pozd\u{11B}j\u{161}\xed.`,
	unavailableDate: "Vybrané datum není k dispozici."
};
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/intl/datepicker/da-DK.mjs
var NC = {};
NC = {
	rangeOverflow: (e) => `V\xe6rdien skal v\xe6re ${e.maxValue} eller tidligere.`,
	rangeReversed: "Startdatoen skal være før slutdatoen.",
	rangeUnderflow: (e) => `V\xe6rdien skal v\xe6re ${e.minValue} eller nyere.`,
	unavailableDate: "Den valgte dato er ikke tilgængelig."
};
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/intl/datepicker/de-DE.mjs
var PC = {};
PC = {
	rangeOverflow: (e) => `Der Wert muss ${e.maxValue} oder fr\xfcher sein.`,
	rangeReversed: "Das Startdatum muss vor dem Enddatum liegen.",
	rangeUnderflow: (e) => `Der Wert muss ${e.minValue} oder sp\xe4ter sein.`,
	unavailableDate: "Das ausgewählte Datum ist nicht verfügbar."
};
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/intl/datepicker/el-GR.mjs
var FC = {};
FC = {
	rangeOverflow: (e) => `\u{397} \u{3C4}\u{3B9}\u{3BC}\u{3AE} \u{3C0}\u{3C1}\u{3AD}\u{3C0}\u{3B5}\u{3B9} \u{3BD}\u{3B1} \u{3B5}\u{3AF}\u{3BD}\u{3B1}\u{3B9} ${e.maxValue} \u{3AE} \u{3C0}\u{3B1}\u{3BB}\u{3B1}\u{3B9}\u{3CC}\u{3C4}\u{3B5}\u{3C1}\u{3B7}.`,
	rangeReversed: "Η ημερομηνία έναρξης πρέπει να είναι πριν από την ημερομηνία λήξης.",
	rangeUnderflow: (e) => `\u{397} \u{3C4}\u{3B9}\u{3BC}\u{3AE} \u{3C0}\u{3C1}\u{3AD}\u{3C0}\u{3B5}\u{3B9} \u{3BD}\u{3B1} \u{3B5}\u{3AF}\u{3BD}\u{3B1}\u{3B9} ${e.minValue} \u{3AE} \u{3BC}\u{3B5}\u{3C4}\u{3B1}\u{3B3}\u{3B5}\u{3BD}\u{3AD}\u{3C3}\u{3C4}\u{3B5}\u{3C1}\u{3B7}.`,
	unavailableDate: "Η επιλεγμένη ημερομηνία δεν είναι διαθέσιμη."
};
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/intl/datepicker/en-US.mjs
var IC = {};
IC = {
	rangeUnderflow: (e) => `Value must be ${e.minValue} or later.`,
	rangeOverflow: (e) => `Value must be ${e.maxValue} or earlier.`,
	rangeReversed: "Start date must be before end date.",
	unavailableDate: "Selected date unavailable."
};
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/intl/datepicker/es-ES.mjs
var LC = {};
LC = {
	rangeOverflow: (e) => `El valor debe ser ${e.maxValue} o anterior.`,
	rangeReversed: "La fecha de inicio debe ser anterior a la fecha de finalización.",
	rangeUnderflow: (e) => `El valor debe ser ${e.minValue} o posterior.`,
	unavailableDate: "Fecha seleccionada no disponible."
};
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/intl/datepicker/et-EE.mjs
var RC = {};
RC = {
	rangeOverflow: (e) => `V\xe4\xe4rtus peab olema ${e.maxValue} v\xf5i varasem.`,
	rangeReversed: "Alguskuupäev peab olema enne lõppkuupäeva.",
	rangeUnderflow: (e) => `V\xe4\xe4rtus peab olema ${e.minValue} v\xf5i hilisem.`,
	unavailableDate: "Valitud kuupäev pole saadaval."
};
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/intl/datepicker/fi-FI.mjs
var zC = {};
zC = {
	rangeOverflow: (e) => `Arvon on oltava ${e.maxValue} tai sit\xe4 aikaisempi.`,
	rangeReversed: "Aloituspäivän on oltava ennen lopetuspäivää.",
	rangeUnderflow: (e) => `Arvon on oltava ${e.minValue} tai sit\xe4 my\xf6h\xe4isempi.`,
	unavailableDate: "Valittu päivämäärä ei ole käytettävissä."
};
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/intl/datepicker/fr-FR.mjs
var BC = {};
BC = {
	rangeOverflow: (e) => `La valeur doit \xeatre ${e.maxValue} ou ant\xe9rieure.`,
	rangeReversed: "La date de début doit être antérieure à la date de fin.",
	rangeUnderflow: (e) => `La valeur doit \xeatre ${e.minValue} ou ult\xe9rieure.`,
	unavailableDate: "La date sélectionnée n’est pas disponible."
};
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/intl/datepicker/he-IL.mjs
var VC = {};
VC = {
	rangeOverflow: (e) => `\u{5D4}\u{5E2}\u{5E8}\u{5DA} \u{5D7}\u{5D9}\u{5D9}\u{5D1} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} ${e.maxValue} \u{5D0}\u{5D5} \u{5DE}\u{5D5}\u{5E7}\u{5D3}\u{5DD} \u{5D9}\u{5D5}\u{5EA}\u{5E8}.`,
	rangeReversed: "תאריך ההתחלה חייב להיות לפני תאריך הסיום.",
	rangeUnderflow: (e) => `\u{5D4}\u{5E2}\u{5E8}\u{5DA} \u{5D7}\u{5D9}\u{5D9}\u{5D1} \u{5DC}\u{5D4}\u{5D9}\u{5D5}\u{5EA} ${e.minValue} \u{5D0}\u{5D5} \u{5DE}\u{5D0}\u{5D5}\u{5D7}\u{5E8} \u{5D9}\u{5D5}\u{5EA}\u{5E8}.`,
	unavailableDate: "התאריך הנבחר אינו זמין."
};
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/intl/datepicker/hr-HR.mjs
var HC = {};
HC = {
	rangeOverflow: (e) => `Vrijednost mora biti ${e.maxValue} ili ranije.`,
	rangeReversed: "Datum početka mora biti prije datuma završetka.",
	rangeUnderflow: (e) => `Vrijednost mora biti ${e.minValue} ili kasnije.`,
	unavailableDate: "Odabrani datum nije dostupan."
};
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/intl/datepicker/hu-HU.mjs
var UC = {};
UC = {
	rangeOverflow: (e) => `Az \xe9rt\xe9knek ${e.maxValue} vagy kor\xe1bbinak kell lennie.`,
	rangeReversed: "A kezdő dátumnak a befejező dátumnál korábbinak kell lennie.",
	rangeUnderflow: (e) => `Az \xe9rt\xe9knek ${e.minValue} vagy k\xe9s\u{151}bbinek kell lennie.`,
	unavailableDate: "A kiválasztott dátum nem érhető el."
};
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/intl/datepicker/it-IT.mjs
var WC = {};
WC = {
	rangeOverflow: (e) => `Il valore deve essere ${e.maxValue} o precedente.`,
	rangeReversed: "La data di inizio deve essere antecedente alla data di fine.",
	rangeUnderflow: (e) => `Il valore deve essere ${e.minValue} o successivo.`,
	unavailableDate: "Data selezionata non disponibile."
};
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/intl/datepicker/ja-JP.mjs
var GC = {};
GC = {
	rangeOverflow: (e) => `\u{5024}\u{306F} ${e.maxValue} \u{4EE5}\u{4E0B}\u{306B}\u{3059}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}`,
	rangeReversed: "開始日は終了日より前にする必要があります。",
	rangeUnderflow: (e) => `\u{5024}\u{306F} ${e.minValue} \u{4EE5}\u{4E0A}\u{306B}\u{3059}\u{308B}\u{5FC5}\u{8981}\u{304C}\u{3042}\u{308A}\u{307E}\u{3059}\u{3002}`,
	unavailableDate: "選択した日付は使用できません。"
};
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/intl/datepicker/ko-KR.mjs
var KC = {};
KC = {
	rangeOverflow: (e) => `\u{AC12}\u{C740} ${e.maxValue} \u{C774}\u{C804}\u{C774}\u{C5B4}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}.`,
	rangeReversed: "시작일은 종료일 이전이어야 합니다.",
	rangeUnderflow: (e) => `\u{AC12}\u{C740} ${e.minValue} \u{C774}\u{D6C4}\u{C5EC}\u{C57C} \u{D569}\u{B2C8}\u{B2E4}.`,
	unavailableDate: "선택한 날짜를 사용할 수 없습니다."
};
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/intl/datepicker/lt-LT.mjs
var qC = {};
qC = {
	rangeOverflow: (e) => `Reik\u{161}m\u{117} turi b\u{16B}ti ${e.maxValue} arba ankstesn\u{117}.`,
	rangeReversed: "Pradžios data turi būti ankstesnė nei pabaigos data.",
	rangeUnderflow: (e) => `Reik\u{161}m\u{117} turi b\u{16B}ti ${e.minValue} arba naujesn\u{117}.`,
	unavailableDate: "Pasirinkta data nepasiekiama."
};
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/intl/datepicker/lv-LV.mjs
var JC = {};
JC = {
	rangeOverflow: (e) => `V\u{113}rt\u{12B}bai ir j\u{101}b\u{16B}t ${e.maxValue} vai agr\u{101}kai.`,
	rangeReversed: "Sākuma datumam ir jābūt pirms beigu datuma.",
	rangeUnderflow: (e) => `V\u{113}rt\u{12B}bai ir j\u{101}b\u{16B}t ${e.minValue} vai v\u{113}l\u{101}kai.`,
	unavailableDate: "Atlasītais datums nav pieejams."
};
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/intl/datepicker/nb-NO.mjs
var YC = {};
YC = {
	rangeOverflow: (e) => `Verdien m\xe5 v\xe6re ${e.maxValue} eller tidligere.`,
	rangeReversed: "Startdatoen må være før sluttdatoen.",
	rangeUnderflow: (e) => `Verdien m\xe5 v\xe6re ${e.minValue} eller senere.`,
	unavailableDate: "Valgt dato utilgjengelig."
};
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/intl/datepicker/nl-NL.mjs
var XC = {};
XC = {
	rangeOverflow: (e) => `Waarde moet ${e.maxValue} of eerder zijn.`,
	rangeReversed: "De startdatum moet voor de einddatum liggen.",
	rangeUnderflow: (e) => `Waarde moet ${e.minValue} of later zijn.`,
	unavailableDate: "Geselecteerde datum niet beschikbaar."
};
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/intl/datepicker/pl-PL.mjs
var ZC = {};
ZC = {
	rangeOverflow: (e) => `Warto\u{15B}\u{107} musi mie\u{107} warto\u{15B}\u{107} ${e.maxValue} lub wcze\u{15B}niejsz\u{105}.`,
	rangeReversed: "Data rozpoczęcia musi być wcześniejsza niż data zakończenia.",
	rangeUnderflow: (e) => `Warto\u{15B}\u{107} musi mie\u{107} warto\u{15B}\u{107} ${e.minValue} lub p\xf3\u{17A}niejsz\u{105}.`,
	unavailableDate: "Wybrana data jest niedostępna."
};
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/intl/datepicker/pt-BR.mjs
var QC = {};
QC = {
	rangeOverflow: (e) => `O valor deve ser ${e.maxValue} ou anterior.`,
	rangeReversed: "A data inicial deve ser anterior à data final.",
	rangeUnderflow: (e) => `O valor deve ser ${e.minValue} ou posterior.`,
	unavailableDate: "Data selecionada indisponível."
};
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/intl/datepicker/pt-PT.mjs
var $C = {};
$C = {
	rangeOverflow: (e) => `O valor tem de ser ${e.maxValue} ou anterior.`,
	rangeReversed: "A data de início deve ser anterior à data de fim.",
	rangeUnderflow: (e) => `O valor tem de ser ${e.minValue} ou posterior.`,
	unavailableDate: "Data selecionada indisponível."
};
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/intl/datepicker/ro-RO.mjs
var ew = {};
ew = {
	rangeOverflow: (e) => `Valoarea trebuie s\u{103} fie ${e.maxValue} sau anterioar\u{103}.`,
	rangeReversed: "Data de început trebuie să fie anterioară datei de sfârșit.",
	rangeUnderflow: (e) => `Valoarea trebuie s\u{103} fie ${e.minValue} sau ulterioar\u{103}.`,
	unavailableDate: "Data selectată nu este disponibilă."
};
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/intl/datepicker/ru-RU.mjs
var tw = {};
tw = {
	rangeOverflow: (e) => `\u{417}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{43E} \u{431}\u{44B}\u{442}\u{44C} \u{43D}\u{435} \u{43F}\u{43E}\u{437}\u{436}\u{435} ${e.maxValue}.`,
	rangeReversed: "Дата начала должна предшествовать дате окончания.",
	rangeUnderflow: (e) => `\u{417}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{438}\u{435} \u{434}\u{43E}\u{43B}\u{436}\u{43D}\u{43E} \u{431}\u{44B}\u{442}\u{44C} \u{43D}\u{435} \u{440}\u{430}\u{43D}\u{44C}\u{448}\u{435} ${e.minValue}.`,
	unavailableDate: "Выбранная дата недоступна."
};
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/intl/datepicker/sk-SK.mjs
var nw = {};
nw = {
	rangeOverflow: (e) => `Hodnota mus\xed by\u{165} ${e.maxValue} alebo skor\u{161}ia.`,
	rangeReversed: "Dátum začiatku musí byť skorší ako dátum konca.",
	rangeUnderflow: (e) => `Hodnota mus\xed by\u{165} ${e.minValue} alebo neskor\u{161}ia.`,
	unavailableDate: "Vybratý dátum je nedostupný."
};
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/intl/datepicker/sl-SI.mjs
var rw = {};
rw = {
	rangeOverflow: (e) => `Vrednost mora biti ${e.maxValue} ali starej\u{161}a.`,
	rangeReversed: "Začetni datum mora biti pred končnim datumom.",
	rangeUnderflow: (e) => `Vrednost mora biti ${e.minValue} ali novej\u{161}a.`,
	unavailableDate: "Izbrani datum ni na voljo."
};
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/intl/datepicker/sr-SP.mjs
var iw = {};
iw = {
	rangeOverflow: (e) => `Vrednost mora da bude ${e.maxValue} ili starija.`,
	rangeReversed: "Datum početka mora biti pre datuma završetka.",
	rangeUnderflow: (e) => `Vrednost mora da bude ${e.minValue} ili novija.`,
	unavailableDate: "Izabrani datum nije dostupan."
};
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/intl/datepicker/sv-SE.mjs
var aw = {};
aw = {
	rangeOverflow: (e) => `V\xe4rdet m\xe5ste vara ${e.maxValue} eller tidigare.`,
	rangeReversed: "Startdatumet måste vara före slutdatumet.",
	rangeUnderflow: (e) => `V\xe4rdet m\xe5ste vara ${e.minValue} eller senare.`,
	unavailableDate: "Det valda datumet är inte tillgängligt."
};
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/intl/datepicker/tr-TR.mjs
var ow = {};
ow = {
	rangeOverflow: (e) => `De\u{11F}er, ${e.maxValue} veya \xf6ncesi olmal\u{131}d\u{131}r.`,
	rangeReversed: "Başlangıç tarihi bitiş tarihinden önce olmalıdır.",
	rangeUnderflow: (e) => `De\u{11F}er, ${e.minValue} veya sonras\u{131} olmal\u{131}d\u{131}r.`,
	unavailableDate: "Seçilen tarih kullanılamıyor."
};
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/intl/datepicker/uk-UA.mjs
var sw = {};
sw = {
	rangeOverflow: (e) => `\u{417}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{43D}\u{44F} \u{43C}\u{430}\u{454} \u{431}\u{443}\u{442}\u{438} \u{43D}\u{435} \u{43F}\u{456}\u{437}\u{43D}\u{456}\u{448}\u{435} ${e.maxValue}.`,
	rangeReversed: "Дата початку має передувати даті завершення.",
	rangeUnderflow: (e) => `\u{417}\u{43D}\u{430}\u{447}\u{435}\u{43D}\u{43D}\u{44F} \u{43C}\u{430}\u{454} \u{431}\u{443}\u{442}\u{438} \u{43D}\u{435} \u{440}\u{430}\u{43D}\u{456}\u{448}\u{435} ${e.minValue}.`,
	unavailableDate: "Вибрана дата недоступна."
};
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/intl/datepicker/zh-CN.mjs
var cw = {};
cw = {
	rangeOverflow: (e) => `\u{503C}\u{5FC5}\u{987B}\u{662F} ${e.maxValue} \u{6216}\u{66F4}\u{65E9}\u{65E5}\u{671F}\u{3002}`,
	rangeReversed: "开始日期必须早于结束日期。",
	rangeUnderflow: (e) => `\u{503C}\u{5FC5}\u{987B}\u{662F} ${e.minValue} \u{6216}\u{66F4}\u{665A}\u{65E5}\u{671F}\u{3002}`,
	unavailableDate: "所选日期不可用。"
};
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/intl/datepicker/zh-TW.mjs
var lw = {};
lw = {
	rangeOverflow: (e) => `\u{503C}\u{5FC5}\u{9808}\u{662F} ${e.maxValue} \u{6216}\u{66F4}\u{65E9}\u{3002}`,
	rangeReversed: "開始日期必須在結束日期之前。",
	rangeUnderflow: (e) => `\u{503C}\u{5FC5}\u{9808}\u{662F} ${e.minValue} \u{6216}\u{66F4}\u{665A}\u{3002}`,
	unavailableDate: "所選日期無法使用。"
};
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/datepicker/intlStrings.mjs
var uw = {};
uw = {
	"ar-AE": AC,
	"bg-BG": jC,
	"cs-CZ": MC,
	"da-DK": NC,
	"de-DE": PC,
	"el-GR": FC,
	"en-US": IC,
	"es-ES": LC,
	"et-EE": RC,
	"fi-FI": zC,
	"fr-FR": BC,
	"he-IL": VC,
	"hr-HR": HC,
	"hu-HU": UC,
	"it-IT": WC,
	"ja-JP": GC,
	"ko-KR": KC,
	"lt-LT": qC,
	"lv-LV": JC,
	"nb-NO": YC,
	"nl-NL": XC,
	"pl-PL": ZC,
	"pt-BR": QC,
	"pt-PT": $C,
	"ro-RO": ew,
	"ru-RU": tw,
	"sk-SK": nw,
	"sl-SI": rw,
	"sr-SP": iw,
	"sv-SE": aw,
	"tr-TR": ow,
	"uk-UA": sw,
	"zh-CN": cw,
	"zh-TW": lw
};
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/datepicker/utils.mjs
function dw(e) {
	return e && e.__esModule ? e.default : e;
}
var fw = new ZS(dw(uw));
function pw() {
	let e = typeof navigator < "u" && (navigator.language || navigator.userLanguage) || "en-US";
	try {
		Intl.DateTimeFormat.supportedLocalesOf([e]);
	} catch {
		e = "en-US";
	}
	return e;
}
function mw(e, t, n, r, i) {
	let a = e != null && n != null && e.compare(n) > 0, o = e != null && t != null && e.compare(t) < 0, s = e != null && r?.(e) || !1, c = a || o || s, l = [];
	if (c) {
		let e = pw(), r = new rC(e, ZS.getGlobalDictionaryForPackage("@react-stately/datepicker") || fw), c = new Mr(e, vw({}, i)), u = c.resolvedOptions().timeZone;
		o && t != null && l.push(r.format("rangeUnderflow", { minValue: c.format(t.toDate(u)) })), a && n != null && l.push(r.format("rangeOverflow", { maxValue: c.format(n.toDate(u)) })), s && l.push(r.format("unavailableDate"));
	}
	return {
		isInvalid: c,
		validationErrors: l,
		validationDetails: {
			badInput: s,
			customError: !1,
			patternMismatch: !1,
			rangeOverflow: a,
			rangeUnderflow: o,
			stepMismatch: !1,
			tooLong: !1,
			tooShort: !1,
			typeMismatch: !1,
			valueMissing: !1,
			valid: !c
		}
	};
}
function hw(e, t, n, r, i) {
	let a = qS(mw(e?.start ?? null, t, n, r, i), mw(e?.end ?? null, t, n, r, i));
	if (e?.end != null && e.start != null && e.end.compare(e.start) < 0) {
		let e = ZS.getGlobalDictionaryForPackage("@react-stately/datepicker") || fw;
		a = qS(a, {
			isInvalid: !0,
			validationErrors: [e.getStringForLocale("rangeReversed", pw())],
			validationDetails: {
				...IS,
				rangeUnderflow: !0,
				rangeOverflow: !0,
				valid: !1
			}
		});
	}
	return a;
}
var gw = {
	year: "numeric",
	month: "numeric",
	day: "numeric",
	hour: "numeric",
	minute: "2-digit",
	second: "2-digit"
}, _w = {
	year: "numeric",
	month: "2-digit",
	day: "2-digit",
	hour: "2-digit",
	minute: "2-digit",
	second: "2-digit"
};
function vw(e, t) {
	e = {
		...t.shouldForceLeadingZeros ? _w : gw,
		...e
	};
	let n = t.granularity || "minute", r = Object.keys(e), i = r.indexOf(t.maxGranularity ?? "year");
	i < 0 && (i = 0);
	let a = r.indexOf(n);
	if (a < 0 && (a = 2), i > a) throw Error("maxGranularity must be greater than granularity");
	let o = r.slice(i, a + 1).reduce((t, n) => (t[n] = e[n], t), {});
	return t.hourCycle != null && (o.hour12 = t.hourCycle === 12), o.timeZone = t.timeZone || "UTC", (n === "hour" || n === "minute" || n === "second") && t.timeZone && !t.hideTimeZone && (o.timeZoneName = "short"), t.showEra && i === 0 && (o.era = "short"), o;
}
function yw(e) {
	return e && "hour" in e ? e : new Pr();
}
function bw(e, t) {
	if (e === null) return null;
	if (e) return Qr(e, t);
}
function xw(e, t, n, r) {
	if (e) return bw(e, n);
	let i = Qr(qr(r ?? Br()).set({
		hour: 0,
		minute: 0,
		second: 0,
		millisecond: 0
	}), n);
	return t === "year" || t === "month" || t === "day" ? $r(i) : r ? i : ei(i);
}
function Sw(e, t) {
	let n = e && "timeZone" in e ? e.timeZone : void 0, r = e && "minute" in e ? "minute" : "day";
	if (e && t && !(t in e)) throw Error("Invalid granularity " + t + " for value " + e.toString());
	let [i, a] = J([r, n]);
	e && (i[0] !== r || i[1] !== n) && a([r, n]), t ||= e ? r : i[0];
	let o = e ? n : i[1];
	return [t, o];
}
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/datepicker/placeholders.mjs
var Cw = new ZS({
	ach: {
		year: "mwaka",
		month: "dwe",
		day: "nino"
	},
	af: {
		year: "jjjj",
		month: "mm",
		day: "dd"
	},
	am: {
		year: "ዓዓዓዓ",
		month: "ሚሜ",
		day: "ቀቀ"
	},
	an: {
		year: "aaaa",
		month: "mm",
		day: "dd"
	},
	ar: {
		year: "سنة",
		month: "شهر",
		day: "يوم"
	},
	ast: {
		year: "aaaa",
		month: "mm",
		day: "dd"
	},
	az: {
		year: "iiii",
		month: "aa",
		day: "gg"
	},
	be: {
		year: "гггг",
		month: "мм",
		day: "дд"
	},
	bg: {
		year: "гггг",
		month: "мм",
		day: "дд"
	},
	bn: {
		year: "yyyy",
		month: "মিমি",
		day: "dd"
	},
	br: {
		year: "bbbb",
		month: "mm",
		day: "dd"
	},
	bs: {
		year: "gggg",
		month: "mm",
		day: "dd"
	},
	ca: {
		year: "aaaa",
		month: "mm",
		day: "dd"
	},
	cak: {
		year: "jjjj",
		month: "ii",
		day: "q'q'"
	},
	ckb: {
		year: "ساڵ",
		month: "مانگ",
		day: "ڕۆژ"
	},
	cs: {
		year: "rrrr",
		month: "mm",
		day: "dd"
	},
	cy: {
		year: "bbbb",
		month: "mm",
		day: "dd"
	},
	da: {
		year: "åååå",
		month: "mm",
		day: "dd"
	},
	de: {
		year: "jjjj",
		month: "mm",
		day: "tt"
	},
	dsb: {
		year: "llll",
		month: "mm",
		day: "źź"
	},
	el: {
		year: "εεεε",
		month: "μμ",
		day: "ηη"
	},
	en: {
		year: "yyyy",
		month: "mm",
		day: "dd"
	},
	eo: {
		year: "jjjj",
		month: "mm",
		day: "tt"
	},
	es: {
		year: "aaaa",
		month: "mm",
		day: "dd"
	},
	et: {
		year: "aaaa",
		month: "kk",
		day: "pp"
	},
	eu: {
		year: "uuuu",
		month: "hh",
		day: "ee"
	},
	fa: {
		year: "سال",
		month: "ماه",
		day: "روز"
	},
	ff: {
		year: "hhhh",
		month: "ll",
		day: "ññ"
	},
	fi: {
		year: "vvvv",
		month: "kk",
		day: "pp"
	},
	fr: {
		year: "aaaa",
		month: "mm",
		day: "jj"
	},
	fy: {
		year: "jjjj",
		month: "mm",
		day: "dd"
	},
	ga: {
		year: "bbbb",
		month: "mm",
		day: "ll"
	},
	gd: {
		year: "bbbb",
		month: "mm",
		day: "ll"
	},
	gl: {
		year: "aaaa",
		month: "mm",
		day: "dd"
	},
	he: {
		year: "שנה",
		month: "חודש",
		day: "יום"
	},
	hr: {
		year: "gggg",
		month: "mm",
		day: "dd"
	},
	hsb: {
		year: "llll",
		month: "mm",
		day: "dd"
	},
	hu: {
		year: "éééé",
		month: "hh",
		day: "nn"
	},
	ia: {
		year: "aaaa",
		month: "mm",
		day: "dd"
	},
	id: {
		year: "tttt",
		month: "bb",
		day: "hh"
	},
	is: {
		year: "áááá",
		month: "mm",
		day: "dd"
	},
	it: {
		year: "aaaa",
		month: "mm",
		day: "gg"
	},
	ja: {
		year: "年",
		month: "月",
		day: "日"
	},
	ka: {
		year: "წწწწ",
		month: "თთ",
		day: "რრ"
	},
	kk: {
		year: "жжжж",
		month: "аа",
		day: "кк"
	},
	kn: {
		year: "ವವವವ",
		month: "ಮಿಮೀ",
		day: "ದಿದಿ"
	},
	ko: {
		year: "연도",
		month: "월",
		day: "일"
	},
	lb: {
		year: "jjjj",
		month: "mm",
		day: "dd"
	},
	lo: {
		year: "ປປປປ",
		month: "ດດ",
		day: "ວວ"
	},
	lt: {
		year: "mmmm",
		month: "mm",
		day: "dd"
	},
	lv: {
		year: "gggg",
		month: "mm",
		day: "dd"
	},
	meh: {
		year: "aaaa",
		month: "mm",
		day: "dd"
	},
	ml: {
		year: "വർഷം",
		month: "മാസം",
		day: "തീയതി"
	},
	ms: {
		year: "tttt",
		month: "mm",
		day: "hh"
	},
	nb: {
		year: "åååå",
		month: "mm",
		day: "dd"
	},
	nl: {
		year: "jjjj",
		month: "mm",
		day: "dd"
	},
	nn: {
		year: "åååå",
		month: "mm",
		day: "dd"
	},
	no: {
		year: "åååå",
		month: "mm",
		day: "dd"
	},
	oc: {
		year: "aaaa",
		month: "mm",
		day: "jj"
	},
	pl: {
		year: "rrrr",
		month: "mm",
		day: "dd"
	},
	pt: {
		year: "aaaa",
		month: "mm",
		day: "dd"
	},
	rm: {
		year: "oooo",
		month: "mm",
		day: "dd"
	},
	ro: {
		year: "aaaa",
		month: "ll",
		day: "zz"
	},
	ru: {
		year: "гггг",
		month: "мм",
		day: "дд"
	},
	sc: {
		year: "aaaa",
		month: "mm",
		day: "dd"
	},
	scn: {
		year: "aaaa",
		month: "mm",
		day: "jj"
	},
	sk: {
		year: "rrrr",
		month: "mm",
		day: "dd"
	},
	sl: {
		year: "llll",
		month: "mm",
		day: "dd"
	},
	sr: {
		year: "гггг",
		month: "мм",
		day: "дд"
	},
	"sr-Latn": {
		year: "gggg",
		month: "mm",
		day: "dd"
	},
	sv: {
		year: "åååå",
		month: "mm",
		day: "dd"
	},
	szl: {
		year: "rrrr",
		month: "mm",
		day: "dd"
	},
	tg: {
		year: "сссс",
		month: "мм",
		day: "рр"
	},
	th: {
		year: "ปปปป",
		month: "ดด",
		day: "วว"
	},
	tr: {
		year: "yyyy",
		month: "aa",
		day: "gg"
	},
	uk: {
		year: "рррр",
		month: "мм",
		day: "дд"
	},
	"zh-CN": {
		year: "年",
		month: "月",
		day: "日"
	},
	"zh-TW": {
		year: "年",
		month: "月",
		day: "日"
	}
}, "en");
function ww(e, t, n) {
	return e === "era" || e === "dayPeriod" ? t : e === "year" || e === "month" || e === "day" ? Cw.getStringForLocale(e, n) : "––";
}
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/datepicker/IncompleteDate.mjs
var Tw = class e {
	constructor(e, t, n) {
		if (this.era = n?.era ?? null, this.calendar = e, this.year = n?.year ?? null, this.month = n?.month ?? null, this.day = n?.day ?? null, this.hour = n?.hour ?? null, this.hourCycle = t, this.dayPeriod = null, this.minute = n?.minute ?? null, this.second = n?.second ?? null, this.millisecond = n?.millisecond ?? null, this.offset = "offset" in (n ?? {}) ? n.offset : null, this.hour != null) {
			let [e, n] = Dw(this.hour, t);
			this.dayPeriod = e, this.hour = n;
		}
	}
	copy() {
		let t = new e(this.calendar, this.hourCycle);
		return t.era = this.era, t.year = this.year, t.month = this.month, t.day = this.day, t.hour = this.hour, t.dayPeriod = this.dayPeriod, t.minute = this.minute, t.second = this.second, t.millisecond = this.millisecond, t.offset = this.offset, t;
	}
	isComplete(e) {
		return e.every((e) => this[e] != null);
	}
	validate(e, t) {
		return t.every((t) => {
			if ((t === "hour" || t === "dayPeriod") && "hour" in e) {
				let [t, n] = Dw(e.hour, this.hourCycle);
				return this.dayPeriod === t && this.hour === n;
			}
			return this[t] === e[t];
		});
	}
	isCleared(e) {
		return e.every((e) => this[e] === null);
	}
	set(e, t, n) {
		let r = this.copy();
		return r[e] = t, e === "hour" && r.dayPeriod == null && "hour" in n && (r.dayPeriod = Dw(n.hour, this.hourCycle)[0]), e === "year" && r.era == null && (r.era = n.era), e !== "second" && e !== "literal" && e !== "timeZoneName" && (r.offset = null), r;
	}
	clear(e) {
		let t = this.copy();
		return t[e] = null, e === "year" && (t.era = null), t.offset = null, t;
	}
	cycle(e, t, n, r) {
		let i = this.copy();
		if (i[e] == null && e !== "dayPeriod" && e !== "era") {
			if (e === "hour" && "hour" in n) {
				let [e, t] = Dw(n.hour, this.hourCycle);
				i.dayPeriod = e, i.hour = t;
			} else i[e] = n[e];
			return e === "year" && i.era == null && (i.era = n.era), i;
		}
		switch (e) {
			case "era": {
				let e = this.calendar.getEras(), n = e.indexOf(i.era);
				n = Ew(n, t, 0, e.length - 1), i.era = e[n];
				break;
			}
			case "year": {
				let r = new Ar(this.calendar, this.era ?? n.era, this.year ?? n.year, this.month ?? 1, this.day ?? 1);
				r = r.cycle(e, t, { round: e === "year" }), i.era = r.era, i.year = r.year;
				break;
			}
			case "month":
				i.month = Ew(i.month ?? 1, t, 1, this.calendar.getMaximumMonthsInYear());
				break;
			case "day":
				i.day = Ew(i.day ?? 1, t, 1, this.calendar.getMaximumDaysInMonth());
				break;
			case "hour": {
				let e = r.some((e) => [
					"year",
					"month",
					"day"
				].includes(e));
				if ("timeZone" in n && (!e || i.year != null && i.month != null && i.day != null)) {
					let e = this.toValue(n);
					e = e.cycle("hour", t, {
						hourCycle: this.hourCycle === "h12" ? 12 : 24,
						round: !1
					});
					let [r, a] = Dw(e.hour, this.hourCycle);
					i.hour = a, i.dayPeriod = r, i.offset = e.offset;
				} else {
					let e = i.hour ?? 0, r = this.getSegmentLimits("hour");
					i.hour = Ew(e, t, r.minValue, r.maxValue), i.dayPeriod == null && "hour" in n && (i.dayPeriod = Dw(n.hour, this.hourCycle)[0]);
				}
				break;
			}
			case "dayPeriod":
				i.dayPeriod = Ew(i.dayPeriod ?? 0, t, 0, 1);
				break;
			case "minute":
				i.minute = Ew(i.minute ?? 0, t, 0, 59, !0);
				break;
			case "second": i.second = Ew(i.second ?? 0, t, 0, 59, !0);
		}
		return i;
	}
	toValue(e) {
		if ("hour" in e) {
			let t = this.hour;
			t == null ? (this.hourCycle === "h12" || this.hourCycle === "h11") && (t = this.dayPeriod === 1 ? 12 : 0) : t = Ow(t, this.dayPeriod ?? 0, this.hourCycle);
			let n = e.set({
				era: this.era ?? e.era,
				year: this.year ?? e.year,
				month: this.month ?? e.month,
				day: this.day ?? e.day,
				hour: t ?? e.hour,
				minute: this.minute ?? e.minute,
				second: this.second ?? e.second,
				millisecond: this.millisecond ?? e.millisecond
			});
			return "offset" in n && this.offset != null && n.offset !== this.offset && (n = n.add({ milliseconds: n.offset - this.offset })), n;
		}
		return e.set({
			era: this.era ?? e.era,
			year: this.year ?? e.year,
			month: this.month ?? e.month,
			day: this.day ?? e.day
		});
	}
	getSegmentLimits(e) {
		switch (e) {
			case "era": {
				let e = this.calendar.getEras();
				return {
					value: this.era == null ? e.length - 1 : e.indexOf(this.era),
					minValue: 0,
					maxValue: e.length - 1
				};
			}
			case "year": return {
				value: this.year,
				minValue: 1,
				maxValue: 9999
			};
			case "month": return {
				value: this.month,
				minValue: 1,
				maxValue: this.calendar.getMaximumMonthsInYear()
			};
			case "day": return {
				value: this.day,
				minValue: 1,
				maxValue: this.calendar.getMaximumDaysInMonth()
			};
			case "dayPeriod": return {
				value: this.dayPeriod,
				minValue: 0,
				maxValue: 1
			};
			case "hour": {
				let e = 0, t = 23;
				return this.hourCycle === "h12" ? (e = 1, t = 12) : this.hourCycle === "h11" && (e = 0, t = 11), {
					value: this.hour,
					minValue: e,
					maxValue: t
				};
			}
			case "minute": return {
				value: this.minute,
				minValue: 0,
				maxValue: 59
			};
			case "second": return {
				value: this.second,
				minValue: 0,
				maxValue: 59
			};
		}
	}
};
function Ew(e, t, n, r, i = !1) {
	if (i) {
		e += Math.sign(t), e < n && (e = r);
		let i = Math.abs(t);
		e = t > 0 ? Math.ceil(e / i) * i : Math.floor(e / i) * i, e > r && (e = n);
	} else e += t, e < n ? e = r - (n - e - 1) : e > r && (e = n + (e - r - 1));
	return e;
}
function Dw(e, t) {
	let n = +(e >= 12);
	switch (t) {
		case "h11":
			e >= 12 && (e -= 12);
			break;
		case "h12":
			e === 0 ? e = 12 : e > 12 && (e -= 12);
			break;
		case "h23":
			n = null;
			break;
		case "h24": e += 1, n = null;
	}
	return [n, e];
}
function Ow(e, t, n) {
	switch (n) {
		case "h11":
			t === 1 && (e += 12);
			break;
		case "h12":
			e === 12 && (e = 0), t === 1 && (e += 12);
			break;
		case "h24": --e;
	}
	return e;
}
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/datepicker/useDateFieldState.mjs
var kw = {
	year: !0,
	month: !0,
	day: !0,
	hour: !0,
	minute: !0,
	second: !0,
	dayPeriod: !0,
	era: !0
}, Aw = {
	year: 5,
	month: 2,
	day: 7,
	hour: 2,
	minute: 15,
	second: 15
}, jw = {
	dayperiod: "dayPeriod",
	relatedYear: "year",
	yearName: "literal",
	unknown: "literal"
};
function Mw(e) {
	let { locale: t, createCalendar: n, hideTimeZone: r, isDisabled: i = !1, isReadOnly: a = !1, isRequired: o = !1, minValue: s, maxValue: c, isDateUnavailable: l } = e, u = e.value || e.defaultValue || e.placeholderValue || null, [d, f] = Sw(u, e.granularity), p = f || "UTC";
	if (u && !(d in u)) throw Error("Invalid granularity " + d + " for value " + u.toString());
	let [m, h] = q(() => {
		let r = new Mr(t, {
			dateStyle: "short",
			timeStyle: "short",
			hour12: e.hourCycle == null ? void 0 : e.hourCycle === 12
		}).resolvedOptions();
		return [n(r.calendar), r.hourCycle];
	}, [
		t,
		e.hourCycle,
		n
	]), [g, _] = kS(e.value, e.defaultValue ?? null, e.onChange), [v] = J(g), y = q(() => bw(g, m) ?? null, [g, m]), [b, x] = J(() => new Tw(m, h, y)), S = m.identifier === "gregory" && b.era === "BC", C = q(() => ({
		granularity: d,
		maxGranularity: e.maxGranularity ?? "year",
		timeZone: f,
		hideTimeZone: r,
		hourCycle: e.hourCycle,
		showEra: S,
		shouldForceLeadingZeros: e.shouldForceLeadingZeros
	}), [
		e.maxGranularity,
		d,
		e.hourCycle,
		e.shouldForceLeadingZeros,
		f,
		r,
		S
	]), w = q(() => vw({}, C), [C]), T = q(() => new Mr(t, w), [t, w]), E = q(() => T.resolvedOptions(), [T]), D = q(() => xw(e.placeholderValue, d, m, f), [
		e.placeholderValue,
		d,
		m,
		f
	]), O = q(() => {
		let t = h === "h11" || h === "h12", n = [
			"era",
			"year",
			"month",
			"day",
			"hour",
			...t ? ["dayPeriod"] : [],
			"minute",
			"second"
		], r = n.indexOf(e.maxGranularity || "era"), i = n.indexOf(d === "hour" && t ? "dayPeriod" : d);
		return n.slice(r, i + 1);
	}, [
		e.maxGranularity,
		d,
		h
	]), [k, A] = J(y), [j, M] = J(m), [N, P] = J(h);
	(y !== k || h !== N || !Hr(m, j)) && (b = new Tw(m, h, y), A(y), M(m), P(h), x(b));
	let F = (t) => {
		if (!(e.isDisabled || e.isReadOnly)) {
			if (t == null || t instanceof Tw && t.isCleared(O)) x(new Tw(m, h, y)), _(null);
			else if (!(t instanceof Tw)) t = Qr(t, u?.calendar || new Nr()), x(new Tw(m, h, y)), _(t);
			else {
				if (t.isComplete(O)) {
					let e = t.toValue(y ?? D);
					if (t.validate(e, O)) {
						let t = Qr(e, u?.calendar || new Nr());
						if (!g || t.compare(g) !== 0) {
							x(new Tw(m, h, y)), _(t);
							return;
						}
					}
				}
				x(t);
			}
		}
	}, I = q(() => b.toValue(y ?? D).toDate(p), [
		b,
		p,
		y,
		D
	]), L = q(() => Nw(I, b, T, E, m, t, d), [
		I,
		T,
		E,
		b,
		m,
		t,
		d
	]), R = (e, t) => {
		F(b.cycle(e, t, D, O));
	}, z = q(() => mw(g, s, c, l, C), [
		g,
		s,
		c,
		l,
		C
	]), B = VS({
		...e,
		value: g,
		builtinValidation: z
	}), V = B.displayValidation.isInvalid, ee = e.validationState || (V ? "invalid" : null);
	return {
		...B,
		value: y,
		defaultValue: e.defaultValue ?? v,
		dateValue: I,
		calendar: m,
		setValue: F,
		segments: L,
		dateFormatter: T,
		validationState: ee,
		isInvalid: V,
		granularity: d,
		maxGranularity: e.maxGranularity ?? "year",
		isDisabled: i,
		isReadOnly: a,
		isRequired: o,
		increment(e) {
			R(e, 1);
		},
		decrement(e) {
			R(e, -1);
		},
		incrementPage(e) {
			R(e, Aw[e] || 1);
		},
		decrementPage(e) {
			R(e, -(Aw[e] || 1));
		},
		incrementToMax(e) {
			let t = e === "hour" && h === "h12" ? 11 : b.getSegmentLimits(e).maxValue;
			F(b.set(e, t, D));
		},
		decrementToMin(e) {
			let t = e === "hour" && h === "h12" ? 12 : b.getSegmentLimits(e).minValue;
			F(b.set(e, t, D));
		},
		setSegment(e, t) {
			F(b.set(e, t, D));
		},
		confirmPlaceholder() {
			if (!(e.isDisabled || e.isReadOnly) && b.isComplete(O)) {
				let e = b.toValue(y ?? D), t = Qr(e, u?.calendar || new Nr());
				(!g || t.compare(g) !== 0) && _(t), x(new Tw(m, h, y));
			}
		},
		clearSegment(e) {
			let t = b;
			e !== "timeZoneName" && e !== "literal" && (t = b.clear(e)), F(t);
		},
		formatValue(e) {
			if (!y) return "";
			let n = vw(e, C);
			return new Mr(t, n).format(I);
		},
		getDateFormatter(e, t) {
			let n = vw({}, {
				...C,
				...t
			});
			return new Mr(e, n);
		}
	};
}
function Nw(e, t, n, r, i, a, o) {
	let s = [
		"hour",
		"minute",
		"second"
	], c = n.formatToParts(e), l = new cC(a, { useGrouping: !1 }), u = new cC(a, {
		useGrouping: !1,
		minimumIntegerDigits: 2
	});
	for (let e of c) if (e.type === "year" || e.type === "month" || e.type === "day" || e.type === "hour") {
		let n = t[e.type] ?? 0;
		e.value = r[e.type] === "2-digit" ? u.format(n) : l.format(n);
	}
	let d = [];
	for (let e of c) {
		let n = jw[e.type] || e.type, r = kw[n];
		n === "era" && i.getEras().length === 1 && (r = !1);
		let c = kw[n] && t[e.type] == null, l = kw[n] ? ww(n, e.value, a) : null, u = {
			type: n,
			text: c ? l : e.value,
			...t.getSegmentLimits(n),
			isPlaceholder: c,
			placeholder: l,
			isEditable: r
		};
		n === "hour" ? (d.push({
			type: "literal",
			text: "⁦",
			isPlaceholder: !1,
			placeholder: "",
			isEditable: !1
		}), d.push(u), n === o && d.push({
			type: "literal",
			text: "⁩",
			isPlaceholder: !1,
			placeholder: "",
			isEditable: !1
		})) : s.includes(n) && n === o ? (d.push(u), d.push({
			type: "literal",
			text: "⁩",
			isPlaceholder: !1,
			placeholder: "",
			isEditable: !1
		})) : d.push(u);
	}
	return d;
}
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/datepicker/useDatePickerState.mjs
function Pw(e) {
	let t = kC(e), [n, r] = kS(e.value, e.defaultValue || null, e.onChange), [i] = J(n), a = n || e.placeholderValue || null, [o, s] = Sw(a, e.granularity), c = n == null ? null : n.toDate(s ?? "UTC"), l = o === "hour" || o === "minute" || o === "second", u = e.shouldCloseOnSelect ?? !0, [d, f] = J(null), [p, m] = J(null);
	if (n && (d = n, "hour" in n && (p = n)), a && !(o in a)) throw Error("Invalid granularity " + o + " for value " + a.toString());
	let h = n?.calendar.identifier === "gregory" && n.era === "BC", g = q(() => ({
		granularity: o,
		timeZone: s,
		hideTimeZone: e.hideTimeZone,
		hourCycle: e.hourCycle,
		shouldForceLeadingZeros: e.shouldForceLeadingZeros,
		showEra: h
	}), [
		o,
		e.hourCycle,
		e.shouldForceLeadingZeros,
		s,
		e.hideTimeZone,
		h
	]), { minValue: _, maxValue: v, isDateUnavailable: y } = e, b = q(() => mw(n, _, v, y, g), [
		n,
		_,
		v,
		y,
		g
	]), x = VS({
		...e,
		value: n,
		builtinValidation: b
	}), S = x.displayValidation.isInvalid, C = e.validationState || (S ? "invalid" : null), w = (e, t) => {
		r("timeZone" in t ? t.set($r(e)) : ei(e, t)), f(null), m(null), x.commitValidation();
	}, T = (n) => {
		let i = typeof u == "function" ? u() : u;
		l ? p || i ? w(n, p || yw(e.defaultValue || e.placeholderValue)) : f(n) : (r(n), x.commitValidation()), i && t.setOpen(!1);
	}, E = (e) => {
		d && e ? w(d, e) : m(e);
	};
	return {
		...x,
		value: n,
		defaultValue: e.defaultValue ?? i,
		setValue: r,
		dateValue: d,
		timeValue: p,
		setDateValue: T,
		setTimeValue: E,
		granularity: o,
		hasTime: l,
		...t,
		setOpen(r) {
			!r && !n && d && l && w(d, p || yw(e.defaultValue || e.placeholderValue)), t.setOpen(r);
		},
		validationState: C,
		isInvalid: S,
		formatValue(e, t) {
			if (!c) return "";
			let n = vw(t, g);
			return new Mr(e, n).format(c);
		},
		getDateFormatter(e, t) {
			let n = vw({}, {
				...g,
				...t
			});
			return new Mr(e, n);
		}
	};
}
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/datepicker/useDateRangePickerState.mjs
function Fw(e) {
	let t = kC(e), [n, r] = kS(e.value, e.defaultValue || null, e.onChange), [i] = J(n), [a, o] = J(() => n || {
		start: null,
		end: null
	});
	n == null && a.start && a.end && (a = {
		start: null,
		end: null
	}, o(a));
	let s = n || a, c = (e) => {
		s = e || {
			start: null,
			end: null
		}, o(s), Iw(s) ? r(s) : r(null);
	}, [l, u] = Sw(s?.start || s?.end || e.placeholderValue || null, e.granularity), d = l === "hour" || l === "minute" || l === "second", f = e.shouldCloseOnSelect ?? !0, [p, m] = J(null), [h, g] = J(null);
	s && Iw(s) && (p = s, "hour" in s.start && (h = s));
	let _ = (e, t) => {
		c({
			start: "timeZone" in t.start ? t.start.set($r(e.start)) : ei(e.start, t.start),
			end: "timeZone" in t.end ? t.end.set($r(e.end)) : ei(e.end, t.end)
		}), m(null), g(null), E.commitValidation();
	}, v = (n) => {
		let r = typeof f == "function" ? f() : f;
		d ? Iw(n) && (r || h?.start && h?.end) ? _(n, {
			start: h?.start || yw(e.placeholderValue),
			end: h?.end || yw(e.placeholderValue)
		}) : m(n) : Iw(n) ? (c(n), E.commitValidation()) : m(n), r && t.setOpen(!1);
	}, y = (e) => {
		Iw(p) && Iw(e) ? _(p, e) : g(e);
	}, b = s?.start?.calendar.identifier === "gregory" && s.start.era === "BC" || s?.end?.calendar.identifier === "gregory" && s.end.era === "BC", x = q(() => ({
		granularity: l,
		timeZone: u,
		hideTimeZone: e.hideTimeZone,
		hourCycle: e.hourCycle,
		shouldForceLeadingZeros: e.shouldForceLeadingZeros,
		showEra: b
	}), [
		l,
		e.hourCycle,
		e.shouldForceLeadingZeros,
		u,
		e.hideTimeZone,
		b
	]), { minValue: S, maxValue: C, isDateUnavailable: w } = e, T = q(() => hw(s, S, C, w ? (e) => w(e, null) : void 0, x), [
		s,
		S,
		C,
		w,
		x
	]), E = VS({
		...e,
		value: n,
		name: q(() => [e.startName, e.endName].filter((e) => e != null), [e.startName, e.endName]),
		builtinValidation: T
	}), D = E.displayValidation.isInvalid, O = e.validationState || (D ? "invalid" : null);
	return {
		...E,
		value: s,
		defaultValue: e.defaultValue ?? i,
		setValue: c,
		dateRange: p,
		timeRange: h,
		granularity: l,
		hasTime: d,
		setDate(e, t) {
			v(e === "start" ? {
				start: t,
				end: p?.end ?? null
			} : {
				start: p?.start ?? null,
				end: t
			});
		},
		setTime(e, t) {
			y(e === "start" ? {
				start: t,
				end: h?.end ?? null
			} : {
				start: h?.start ?? null,
				end: t
			});
		},
		setDateTime(e, t) {
			c(e === "start" ? {
				start: t,
				end: s?.end ?? null
			} : {
				start: s?.start ?? null,
				end: t
			});
		},
		setDateRange: v,
		setTimeRange: y,
		...t,
		setOpen(n) {
			!n && !(s?.start && s?.end) && Iw(p) && d && _(p, {
				start: h?.start || yw(e.placeholderValue),
				end: h?.end || yw(e.placeholderValue)
			}), t.setOpen(n);
		},
		validationState: O,
		isInvalid: D,
		formatValue(t, n) {
			if (!s || !s.start || !s.end) return null;
			let r = "timeZone" in s.start ? s.start.timeZone : void 0, i = e.granularity || (s.start && "minute" in s.start ? "minute" : "day"), a = "timeZone" in s.end ? s.end.timeZone : void 0, o = e.granularity || (s.end && "minute" in s.end ? "minute" : "day"), c = vw(n, {
				granularity: i,
				timeZone: r,
				hideTimeZone: e.hideTimeZone,
				hourCycle: e.hourCycle,
				showEra: s.start.calendar.identifier === "gregory" && s.start.era === "BC" || s.end.calendar.identifier === "gregory" && s.end.era === "BC"
			}), l = s.start.toDate(r || "UTC"), u = s.end.toDate(a || "UTC"), d = new Mr(t, c), f;
			if (r === a && i === o && s.start.compare(s.end) !== 0) {
				try {
					let e = d.formatRangeToParts(l, u), t = -1;
					for (let n = 0; n < e.length; n++) {
						let r = e[n];
						if (r.source === "shared" && r.type === "literal") t = n;
						else if (r.source === "endRange") break;
					}
					let n = "", r = "";
					for (let i = 0; i < e.length; i++) i < t ? n += e[i].value : i > t && (r += e[i].value);
					return {
						start: n,
						end: r
					};
				} catch {}
				f = d;
			} else {
				let r = vw(n, {
					granularity: o,
					timeZone: a,
					hideTimeZone: e.hideTimeZone,
					hourCycle: e.hourCycle
				});
				f = new Mr(t, r);
			}
			return {
				start: d.format(l),
				end: f.format(u)
			};
		},
		getDateFormatter(e, t) {
			let n = vw({}, {
				...x,
				...t
			});
			return new Mr(e, n);
		}
	};
}
function Iw(e) {
	return e?.start != null && e.end != null;
}
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/collections/Item.mjs
function Lw(e) {
	return null;
}
Lw.getCollectionNode = function* (e, t) {
	let { childItems: n, title: r, children: i } = e, a = e.title || e.children, o = e.textValue || (typeof a == "string" ? a : "") || e["aria-label"] || "";
	!o && !t?.suppressTextValueWarning && process.env.NODE_ENV !== "production" && console.warn("<Item> with non-plain text contents is unsupported by type to select for accessibility. Please add a `textValue` prop."), yield {
		type: "item",
		props: e,
		rendered: a,
		textValue: o,
		"aria-label": e["aria-label"],
		hasChildNodes: Rw(e),
		*childNodes() {
			if (n) for (let e of n) yield {
				type: "item",
				value: e
			};
			else if (r) {
				let e = [];
				dr.Children.forEach(i, (t) => {
					e.push({
						type: "item",
						element: t
					});
				}), yield* e;
			}
		}
	};
};
function Rw(e) {
	return e.hasChildItems == null ? !!(e.childItems || e.title && dr.Children.count(e.children) > 0) : e.hasChildItems;
}
var zw = Lw;
//#endregion
//#region ../../node_modules/.pnpm/react-stately@3.49.0_react@19.2.7/node_modules/react-stately/dist/private/select/useSelectState.mjs
function Bw(e) {
	let { selectionMode: t = "single", shouldCloseOnSelect: n = t === "single" } = e, r = kC(e), [i, a] = J(null), o = q(() => e.defaultValue === void 0 ? t === "single" ? e.defaultSelectedKey ?? null : [] : e.defaultValue, [
		e.defaultValue,
		e.defaultSelectedKey,
		t
	]), [s, c] = kS(q(() => e.value === void 0 ? t === "single" ? e.selectedKey : void 0 : e.value, [
		e.value,
		e.selectedKey,
		t
	]), o, e.onChange), l = t === "single" && Array.isArray(s) ? s[0] : s, u = (n) => {
		if (t === "single") {
			let t = Array.isArray(n) ? n[0] ?? null : n;
			c(t), t !== l && e.onSelectionChange?.(t);
		} else {
			let e = [];
			Array.isArray(n) ? e = n : n != null && (e = [n]), c(e);
		}
	}, d = DC({
		...e,
		selectionMode: t,
		disallowEmptySelection: t === "single",
		allowDuplicateSelectionEvents: !0,
		selectedKeys: q(() => Vw(l), [l]),
		onSelectionChange: (e) => {
			if (e !== "all") {
				if (t === "single") {
					let t = e.values().next().value ?? null;
					u(t);
				} else u([...e]);
				n && r.close(), m.commitValidation();
			}
		}
	}), f = d.selectionManager.firstSelectedKey, p = q(() => [...d.selectionManager.selectedKeys].map((e) => d.collection.getItem(e)).filter((e) => e != null), [d.selectionManager.selectedKeys, d.collection]), m = VS({
		...e,
		value: Array.isArray(l) && l.length === 0 ? null : l
	}), [h, g] = J(!1), [_] = J(l);
	return {
		...m,
		...d,
		...r,
		value: l,
		defaultValue: o ?? _,
		setValue: u,
		selectedKey: f,
		setSelectedKey: u,
		selectedItem: p[0] ?? null,
		selectedItems: p,
		defaultSelectedKey: e.defaultSelectedKey ?? (e.selectionMode === "single" ? _ : null),
		focusStrategy: i,
		open(t = null) {
			(d.collection.size !== 0 || e.allowsEmptyCollection) && (a(t), r.open());
		},
		toggle(t = null) {
			(d.collection.size !== 0 || e.allowsEmptyCollection) && (a(t), r.toggle());
		},
		isFocused: h,
		setFocused: g
	};
}
function Vw(e) {
	if (e !== void 0) return e === null ? [] : Array.isArray(e) ? e : [e];
}
//#endregion
//#region lib/components/DatePicker/CalendarCell.tsx
function Hw(e) {
	let t = K(20), { state: n, date: r } = e, i = Tr(null), a;
	t[0] === r ? a = t[1] : (a = { date: r }, t[0] = r, t[1] = a);
	let { cellProps: o, buttonProps: s, isSelected: c, formattedDate: l, isDisabled: u } = qn(a, n, i), d = Wr(r, n.timeZone), f = "highlightedRange" in n, p = f && n.highlightedRange ? Ur(r, n.highlightedRange.start) : c, m = f && n.highlightedRange ? n.highlightedRange ? Ur(r, n.highlightedRange.end) : c : !1, h = f && c && p, g = f && c && m, _ = h ? "rounded-none rounded-l-md" : "", v = g ? "rounded-none rounded-r-md" : "", y = d ? "text-text-brand hover:bg-transparent" : "", b = c ? f && !p && !m ? "rounded-none bg-interactive-secondary-button-focus-background hover:bg-brand-primary hover:text-text-primary-inverse" : "bg-background-brand text-text-primary-inverse hover:bg-brand-primary" : "", x = u ? "hover:bg-inherit text-text-disabled hover:text-text-disabled" : "", S;
	t[2] !== _ || t[3] !== v || t[4] !== y || t[5] !== b || t[6] !== x ? (S = W("relative flex cursor-pointer items-center justify-center rounded-md p-sm text-label-medium outline-none transition-all hover:bg-background-secondary", _, v, y, b, x), t[2] = _, t[3] = v, t[4] = y, t[5] = b, t[6] = x, t[7] = S) : S = t[7];
	let C = d ? "opacity-100" : "", w;
	t[8] === C ? w = t[9] : (w = W("absolute top-7 size-[.3rem] rounded-full bg-brand-primary opacity-0 transition-opacity", C), t[8] = C, t[9] = w);
	let T;
	t[10] === w ? T = t[11] : (T = /* @__PURE__ */ Y("div", { className: w }), t[10] = w, t[11] = T);
	let E;
	t[12] !== s || t[13] !== l || t[14] !== T || t[15] !== S ? (E = /* @__PURE__ */ X("div", {
		...s,
		className: S,
		ref: i,
		children: [l, T]
	}), t[12] = s, t[13] = l, t[14] = T, t[15] = S, t[16] = E) : E = t[16];
	let D;
	return t[17] !== o || t[18] !== E ? (D = /* @__PURE__ */ Y("td", {
		...o,
		children: E
	}), t[17] = o, t[18] = E, t[19] = D) : D = t[19], D;
}
//#endregion
//#region lib/components/DatePicker/CalendarGrid.tsx
function Uw(e) {
	let t = K(16), n, r;
	t[0] === e ? (n = t[1], r = t[2]) : ({state: r, ...n} = e, t[0] = e, t[1] = n, t[2] = r);
	let { locale: i } = ir(), { gridProps: a, headerProps: o, weekDays: s } = Jn(n, r), c;
	if (t[3] !== a || t[4] !== o || t[5] !== i || t[6] !== r || t[7] !== s) {
		let e = Vr(r.visibleRange.start, i), n;
		t[9] === s ? n = t[10] : (n = s.map(Gw), t[9] = s, t[10] = n);
		let l;
		t[11] === n ? l = t[12] : (l = /* @__PURE__ */ Y("tr", { children: n }), t[11] = n, t[12] = l);
		let u;
		t[13] !== o || t[14] !== l ? (u = /* @__PURE__ */ Y("thead", {
			...o,
			className: "text-body-small text-text-secondary",
			children: l
		}), t[13] = o, t[14] = l, t[15] = u) : u = t[15], c = /* @__PURE__ */ X("table", {
			...a,
			cellPadding: "0",
			className: "w-full flex-1",
			children: [u, /* @__PURE__ */ Y("tbody", { children: Array.from({ length: e }, Ww).map((e) => /* @__PURE__ */ Y("tr", { children: r.getDatesInWeek(e).map((e, t) => e ? /* @__PURE__ */ Y(Hw, {
				date: e,
				state: r
			}, t) : /* @__PURE__ */ Y("td", {}, t)) }, e)) })]
		}), t[3] = a, t[4] = o, t[5] = i, t[6] = r, t[7] = s, t[8] = c;
	} else c = t[8];
	return c;
}
function Ww(e, t) {
	return t;
}
function Gw(e, t) {
	return /* @__PURE__ */ Y("th", {
		className: "text-center",
		children: e
	}, t);
}
//#endregion
//#region lib/components/DatePicker/Popover.tsx
function Kw(e) {
	let t = K(23), n, r, i;
	t[0] === e ? (n = t[1], r = t[2], i = t[3]) : ({children: n, state: i, ...r} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i);
	let a = Tr(null), o;
	t[4] === r ? o = t[5] : (o = {
		...r,
		popoverRef: a
	}, t[4] = r, t[5] = o);
	let { popoverProps: s, underlayProps: c } = or(o, i), l;
	t[6] === c ? l = t[7] : (l = /* @__PURE__ */ Y("div", {
		className: "fixed inset-0",
		...c
	}), t[6] = c, t[7] = l);
	let u;
	t[8] === s.style ? u = t[9] : (u = { ...s.style }, t[8] = s.style, t[9] = u);
	let d;
	t[10] === i.close ? d = t[11] : (d = /* @__PURE__ */ Y(Hn, { onDismiss: i.close }), t[10] = i.close, t[11] = d);
	let f;
	t[12] === i.close ? f = t[13] : (f = /* @__PURE__ */ Y(Hn, { onDismiss: i.close }), t[12] = i.close, t[13] = f);
	let p;
	t[14] !== n || t[15] !== s || t[16] !== u || t[17] !== d || t[18] !== f ? (p = /* @__PURE__ */ X("div", {
		...s,
		ref: a,
		style: u,
		children: [
			d,
			n,
			f
		]
	}), t[14] = n, t[15] = s, t[16] = u, t[17] = d, t[18] = f, t[19] = p) : p = t[19];
	let m;
	return t[20] !== l || t[21] !== p ? (m = /* @__PURE__ */ X(Wn, { children: [l, p] }), t[20] = l, t[21] = p, t[22] = m) : m = t[22], m;
}
//#endregion
//#region lib/components/DatePicker/Select.tsx
function qw(e) {
	let t = K(8), n = Tr(null), { state: r } = e, { listBoxProps: i } = rr(e, r, n), a;
	t[0] === r.collection ? a = t[1] : (a = [...r.collection], t[0] = r.collection, t[1] = a);
	let o;
	t[2] !== r || t[3] !== a ? (o = a.map((e) => /* @__PURE__ */ Y(Jw, {
		item: e,
		state: r
	}, e.key)), t[2] = r, t[3] = a, t[4] = o) : o = t[4];
	let s;
	return t[5] !== i || t[6] !== o ? (s = /* @__PURE__ */ Y("ul", {
		...i,
		className: "flex max-h-52 min-w-24 flex-col gap-1 overflow-y-scroll rounded-md border-outline-decorative bg-background-secondary px-1 py-2 shadow-md",
		children: o
	}), t[5] = i, t[6] = o, t[7] = s) : s = t[7], s;
}
function Jw(e) {
	let t = K(8), { item: n, state: r } = e, i = Tr(null), a;
	t[0] === n.key ? a = t[1] : (a = { key: n.key }, t[0] = n.key, t[1] = a);
	let { optionProps: o, isSelected: s } = ar(a, r, i), c = s ? "bg-interactive-secondary-button-focus-background" : "", l;
	t[2] === c ? l = t[3] : (l = W("font-label-medium flex w-full cursor-pointer items-center justify-between gap-6 rounded-sm px-3xs py-3xs text-label-medium font-normal text-text-primary outline-none hover:bg-interactive-secondary-button-hover-background", c), t[2] = c, t[3] = l);
	let u;
	return t[4] !== n.rendered || t[5] !== o || t[6] !== l ? (u = /* @__PURE__ */ Y("li", {
		...o,
		className: l,
		ref: i,
		children: n.rendered
	}), t[4] = n.rendered, t[5] = o, t[6] = l, t[7] = u) : u = t[7], u;
}
function Yw(e) {
	let t = K(23), n = Bw(e), r = Tr(null), { labelProps: i, triggerProps: a, valueProps: o, menuProps: s } = cr(e, n, r), { buttonProps: c } = Gn(a, r), l;
	t[0] !== i || t[1] !== e.label ? (l = /* @__PURE__ */ Y("div", {
		...i,
		children: e.label
	}), t[0] = i, t[1] = e.label, t[2] = l) : l = t[2];
	let u;
	t[3] !== e.isDisabled || t[4] !== e.label || t[5] !== e.name || t[6] !== n ? (u = /* @__PURE__ */ Y(Un, {
		isDisabled: e.isDisabled,
		label: e.label,
		name: e.name,
		state: n,
		triggerRef: r
	}), t[3] = e.isDisabled, t[4] = e.label, t[5] = e.name, t[6] = n, t[7] = u) : u = t[7];
	let d = n.selectedItem ? n.selectedItem.rendered : e.placeholder, f;
	t[8] !== d || t[9] !== o ? (f = /* @__PURE__ */ Y("div", {
		className: "text-label-medium font-semibold text-interactive-tertiary-button-enabled-foreground",
		...o,
		children: d
	}), t[8] = d, t[9] = o, t[10] = f) : f = t[10];
	let p;
	t[11] === Symbol.for("react.memo_cache_sentinel") ? (p = /* @__PURE__ */ Y(mn, { className: "rotate-90" }), t[11] = p) : p = t[11];
	let m;
	t[12] !== c || t[13] !== f ? (m = /* @__PURE__ */ X("button", {
		...c,
		className: "flex items-center justify-between gap-2",
		ref: r,
		children: [f, p]
	}), t[12] = c, t[13] = f, t[14] = m) : m = t[14];
	let h;
	t[15] !== s || t[16] !== n ? (h = n.isOpen && /* @__PURE__ */ Y(Kw, {
		placement: "bottom",
		state: n,
		triggerRef: r,
		children: /* @__PURE__ */ Y(qw, {
			...s,
			state: n
		})
	}), t[15] = s, t[16] = n, t[17] = h) : h = t[17];
	let g;
	return t[18] !== l || t[19] !== u || t[20] !== m || t[21] !== h ? (g = /* @__PURE__ */ X("div", {
		className: "inline-block",
		children: [
			l,
			u,
			m,
			h
		]
	}), t[18] = l, t[19] = u, t[20] = m, t[21] = h, t[22] = g) : g = t[22], g;
}
//#endregion
//#region lib/components/DatePicker/Calendar.tsx
function Xw(e) {
	let t = K(45), n, r;
	t[0] === e ? (n = t[1], r = t[2]) : ({yearOptions: r, ...n} = e, t[0] = e, t[1] = n, t[2] = r);
	let { locale: i } = ir(), a;
	t[3] !== i || t[4] !== n ? (a = {
		...n,
		locale: i,
		createCalendar: Ir
	}, t[3] = i, t[4] = n, t[5] = a) : a = t[5];
	let o = AS(a), s = o.focusedDate.month, c = o.focusedDate.year, [l] = J($w), u;
	t[6] === Symbol.for("react.memo_cache_sentinel") ? (u = Array.from({ length: 12 }, Qw), t[6] = u) : u = t[6];
	let d = u, f;
	t[7] !== l || t[8] !== r ? (f = r ?? Array.from({ length: 21 }, (e, t) => l - 10 + t), t[7] = l, t[8] = r, t[9] = f) : f = t[9];
	let p = f, m = Tr(null), { calendarProps: h, prevButtonProps: g, nextButtonProps: _ } = Kn(n, o), v;
	t[10] !== c || t[11] !== o ? (v = function(e) {
		e && o.setFocusedDate(new Ar(c, Number(e), 1));
	}, t[10] = c, t[11] = o, t[12] = v) : v = t[12];
	let y = v, b;
	t[13] !== s || t[14] !== o ? (b = function(e) {
		e && o.setFocusedDate(new Ar(Number(e), s, 1));
	}, t[13] = s, t[14] = o, t[15] = b) : b = t[15];
	let x = b, S;
	t[16] === Symbol.for("react.memo_cache_sentinel") ? (S = /* @__PURE__ */ Y(mn, { className: "size-lg rotate-180" }), t[16] = S) : S = t[16];
	let C;
	t[17] === g ? C = t[18] : (C = /* @__PURE__ */ Y(Q, {
		...g,
		className: "px-0 hover:text-brand-primary",
		variant: "plain",
		children: S
	}), t[17] = g, t[18] = C);
	let w = String(s), T;
	t[19] === i ? T = t[20] : (T = d.map((e) => /* @__PURE__ */ Y(zw, { children: new Intl.DateTimeFormat(i, { month: "short" }).format(new Date(2e3, e - 1, 1)) }, e)), t[19] = i, t[20] = T);
	let E;
	t[21] !== y || t[22] !== w || t[23] !== T ? (E = /* @__PURE__ */ Y(Yw, {
		"aria-label": "date-picker-month-select",
		onSelectionChange: y,
		placeholder: "Month",
		selectedKey: w,
		children: T
	}), t[21] = y, t[22] = w, t[23] = T, t[24] = E) : E = t[24];
	let D = String(c), O;
	t[25] === p ? O = t[26] : (O = p.map(Zw), t[25] = p, t[26] = O);
	let k;
	t[27] !== x || t[28] !== D || t[29] !== O ? (k = /* @__PURE__ */ Y(Yw, {
		"aria-label": "date-picker-year-select",
		onSelectionChange: x,
		placeholder: "Year",
		selectedKey: D,
		children: O
	}), t[27] = x, t[28] = D, t[29] = O, t[30] = k) : k = t[30];
	let A;
	t[31] === Symbol.for("react.memo_cache_sentinel") ? (A = /* @__PURE__ */ Y(mn, { className: "size-lg" }), t[31] = A) : A = t[31];
	let j;
	t[32] === _ ? j = t[33] : (j = /* @__PURE__ */ Y(Q, {
		..._,
		className: "px-0 hover:text-brand-primary",
		variant: "plain",
		children: A
	}), t[32] = _, t[33] = j);
	let M;
	t[34] !== E || t[35] !== k || t[36] !== j || t[37] !== C ? (M = /* @__PURE__ */ X("header", {
		className: "flex w-full items-center justify-between gap-1 pb-xs",
		children: [
			C,
			E,
			k,
			j
		]
	}), t[34] = E, t[35] = k, t[36] = j, t[37] = C, t[38] = M) : M = t[38];
	let N;
	t[39] === o ? N = t[40] : (N = /* @__PURE__ */ Y(Uw, { state: o }), t[39] = o, t[40] = N);
	let P;
	return t[41] !== h || t[42] !== M || t[43] !== N ? (P = /* @__PURE__ */ X("div", {
		...h,
		className: "inline-block",
		ref: m,
		children: [M, N]
	}), t[41] = h, t[42] = M, t[43] = N, t[44] = P) : P = t[44], P;
}
function Zw(e) {
	return /* @__PURE__ */ Y(zw, {
		textValue: `${e}`,
		children: e
	}, e);
}
function Qw(e, t) {
	return t + 1;
}
function $w() {
	return (/* @__PURE__ */ new Date()).getFullYear();
}
//#endregion
//#region lib/components/DatePicker/DateField.tsx
function eT(e) {
	let t = K(47), n, r, i, a;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4]) : ({focusInputContainer: r, defaultTimeOfDay: n, segmentClassName: a, ...i} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a);
	let { locale: o } = ir(), s;
	t[5] !== o || t[6] !== i ? (s = {
		...i,
		locale: o,
		createCalendar: Ir
	}, t[5] = o, t[6] = i, t[7] = s) : s = t[7];
	let c = Mw(s), l = Tr(null), { fieldProps: u } = Yn(i, c, l), d;
	t[8] === c.segments ? d = t[9] : (d = c.segments.some(tT), t[8] = c.segments, t[9] = d);
	let f = d, p;
	bb0: {
		if (c.granularity !== "second") {
			let e;
			t[10] === Symbol.for("react.memo_cache_sentinel") ? (e = [], t[10] = e) : e = t[10], p = e;
			break bb0;
		}
		if (n === "start") {
			let e;
			t[11] === f ? e = t[12] : (e = f ? [["dayPeriod", 0]] : [], t[11] = f, t[12] = e);
			let n = f ? 12 : 0, r;
			t[13] === n ? r = t[14] : (r = ["hour", n], t[13] = n, t[14] = r);
			let i, a;
			t[15] === Symbol.for("react.memo_cache_sentinel") ? (i = ["minute", 0], a = ["second", 0], t[15] = i, t[16] = a) : (i = t[15], a = t[16]);
			let o;
			t[17] !== e || t[18] !== r ? (o = [
				...e,
				r,
				i,
				a
			], t[17] = e, t[18] = r, t[19] = o) : o = t[19], p = o;
			break bb0;
		}
		if (n === "end") {
			let e;
			t[20] === f ? e = t[21] : (e = f ? [["dayPeriod", 1]] : [], t[20] = f, t[21] = e);
			let n = f ? 11 : 23, r;
			t[22] === n ? r = t[23] : (r = ["hour", n], t[22] = n, t[23] = r);
			let i, a;
			t[24] === Symbol.for("react.memo_cache_sentinel") ? (i = ["minute", 59], a = ["second", 59], t[24] = i, t[25] = a) : (i = t[24], a = t[25]);
			let o;
			t[26] !== e || t[27] !== r ? (o = [
				...e,
				r,
				i,
				a
			], t[26] = e, t[27] = r, t[28] = o) : o = t[28], p = o;
			break bb0;
		}
		let e;
		t[29] === Symbol.for("react.memo_cache_sentinel") ? (e = [["second", 0]], t[29] = e) : e = t[29], p = e;
	}
	let m = p, h = Tr(0), g;
	t[30] !== c || t[31] !== m ? (g = () => {
		let e = m.find((e) => {
			let [t] = e;
			return c.segments.find((e) => e.type === t)?.isPlaceholder;
		});
		if (!e) {
			h.current = 0;
			return;
		}
		h.current > m.length * 3 || (h.current += 1, c.setSegment(e[0], e[1]));
	}, t[30] = c, t[31] = m, t[32] = g) : g = t[32], br(g);
	let _;
	if (t[33] !== f || t[34] !== c.segments) {
		if (_ = -1, !f) {
			for (let e = c.segments.length - 1; e >= 0; e--) if (c.segments[e]?.type === "literal" && c.segments[e]?.text === ":") {
				_ = e;
				break;
			}
		}
		t[33] = f, t[34] = c.segments, t[35] = _;
	} else _ = t[35];
	let v = c.isInvalid ? "!text-text-negative" : "", y;
	t[36] === v ? y = t[37] : (y = W("flex items-center justify-between gap-0", v), t[36] = v, t[37] = y);
	let b;
	t[38] !== r || t[39] !== _ || t[40] !== a || t[41] !== c ? (b = c.segments.map((e, t) => t === _ ? null : /* @__PURE__ */ Y(nT, {
		className: a,
		focusInputContainer: r,
		segment: e,
		state: c
	}, t)), t[38] = r, t[39] = _, t[40] = a, t[41] = c, t[42] = b) : b = t[42];
	let x;
	return t[43] !== u || t[44] !== y || t[45] !== b ? (x = /* @__PURE__ */ Y("div", {
		...u,
		className: y,
		ref: l,
		children: b
	}), t[43] = u, t[44] = y, t[45] = b, t[46] = x) : x = t[46], x;
}
function tT(e) {
	return e.type === "dayPeriod";
}
function nT(e) {
	let t = K(10), { segment: n, state: r, className: i, focusInputContainer: a } = e, o = Tr(null), { segmentProps: s } = $n(n, r, o), c;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (c = [
		"day",
		"month",
		"year",
		"hour",
		"minute",
		"dayPeriod"
	], t[0] = c) : c = t[0];
	let l = !c.includes(n.type);
	if (n.type === "second") return null;
	let u;
	return t[1] !== i || t[2] !== a || t[3] !== l || t[4] !== n.isPlaceholder || t[5] !== n.text || t[6] !== n.type || t[7] !== s || t[8] !== r ? (u = l ? /* @__PURE__ */ Y("span", {
		className: W("flex h-5 items-center justify-center font-light text-text-secondary", r.isDisabled ? "text-text-disabled opacity-70" : "", r.isReadOnly ? "text-text-primary" : "", i),
		children: n.text
	}) : /* @__PURE__ */ Y(xi, {
		...s,
		"aria-disabled": l,
		"aria-label": `date-segment-${n.text}`,
		className: W("h-5 border-none bg-transparent text-center text-label-medium text-text-primary !caret-text-primary outline-none", "font-mono disabled:text-text-disabled", r.isReadOnly ? "!text-text-primary" : "", n.type === "year" ? "w-9" : "w-5", n.isPlaceholder ? "uppercase text-text-secondary" : "", i),
		disabled: l || r.isDisabled,
		onBlur: (e) => {
			s.onBlur?.(e), a(!1);
		},
		onChange: (e) => {
			let t = e.target.value;
			if (n.type === "dayPeriod") {
				let e = t.trim().charAt(0).toLowerCase();
				e === "a" ? r.setSegment("dayPeriod", 0) : e === "p" && r.setSegment("dayPeriod", 1);
				return;
			}
			let i = Number(t);
			Number.isNaN(i) || r.setSegment(n.type, i);
		},
		onFocus: (e) => {
			e.target.select(), a(!0);
		},
		ref: o,
		value: n.text
	}), t[1] = i, t[2] = a, t[3] = l, t[4] = n.isPlaceholder, t[5] = n.text, t[6] = n.type, t[7] = s, t[8] = r, t[9] = u) : u = t[9], u;
}
//#endregion
//#region lib/components/DatePicker/DatePicker.tsx
var rT = G({
	base: "\n    flex items-center justify-between overflow-hidden rounded-1 outline-none border border-outline-input-enabled\n    hover:border-outline-input-hover hover:ring-1 hover:ring-outline-input-hover px-4 py-2 gap-x-4\n  ",
	variants: {
		variant: {
			primary: "",
			compact: "px-sm py-xxs"
		},
		isInvalid: { true: "border-outline-negative ring-1 ring-outline-negative" },
		isFocused: { true: "ring-1 !ring-outline-input-focus !border-outline-input-focus" },
		isDisabled: { true: "cursor-not-allowed [&_*]:!cursor-not-allowed border-outline-input-disabled bg-background-primary hover:!ring-0 hover:!border-outline-input-disabled" },
		isReadOnly: { true: "!bg-background-secondary !border-transparent hover:!ring-0" }
	}
});
function iT(e) {
	let t = K(32), { yearOptions: n, assistiveText: r, tooltipText: i, className: a, variant: o, ...s } = e, c = o === void 0 ? "primary" : o, l = Tr(null), { years: u, minDate: d, maxDate: f } = It(n, s.minValue, s.maxValue), p = Pw({
		...s,
		minValue: d,
		maxValue: f
	}), { groupProps: m, labelProps: h, fieldProps: g, buttonProps: _, dialogProps: v, calendarProps: y } = Zn({
		...s,
		minValue: d,
		maxValue: f,
		shouldForceLeadingZeros: !0
	}, p, l), b = s.isInvalid || p.realtimeValidation.isInvalid, x = s.isDisabled ?? !1, [S, C] = J(!1), w;
	t[0] === a ? w = t[1] : (w = W("relative flex flex-col gap-[.15rem]", a), t[0] = a, t[1] = w);
	let T = rT({
		variant: c,
		isFocused: !x && !s.isReadOnly && S,
		isInvalid: b,
		isDisabled: x,
		isReadOnly: s.isReadOnly
	}), E = c === "compact" ? "h-auto text-label-small leading-xs" : void 0, D;
	t[2] !== g || t[3] !== C || t[4] !== E ? (D = /* @__PURE__ */ Y(eT, {
		focusInputContainer: C,
		segmentClassName: E,
		...g
	}), t[2] = g, t[3] = C, t[4] = E, t[5] = D) : D = t[5];
	let O = c === "compact" ? "border-0" : "", k = x ? "text-text-disabled" : "", A = s.isReadOnly ? "!text-text-primary" : "", j;
	t[6] !== O || t[7] !== k || t[8] !== A ? (j = W("p-0", O, k, A), t[6] = O, t[7] = k, t[8] = A, t[9] = j) : j = t[9];
	let M = x || s.isReadOnly, N = c === "compact" ? "size-[14px]" : "size-lg", P;
	t[10] === N ? P = t[11] : (P = /* @__PURE__ */ Y(Le, { className: N }), t[10] = N, t[11] = P);
	let F;
	t[12] !== _ || t[13] !== M || t[14] !== P || t[15] !== j ? (F = /* @__PURE__ */ Y(Q, {
		..._,
		className: j,
		isDisabled: M,
		variant: "plain",
		children: P
	}), t[12] = _, t[13] = M, t[14] = P, t[15] = j, t[16] = F) : F = t[16];
	let I;
	t[17] !== m || t[18] !== F || t[19] !== T || t[20] !== D ? (I = /* @__PURE__ */ X("div", {
		className: T,
		...m,
		ref: l,
		children: [D, F]
	}), t[17] = m, t[18] = F, t[19] = T, t[20] = D, t[21] = I) : I = t[21];
	let L;
	t[22] !== r || t[23] !== x || t[24] !== b || t[25] !== p.realtimeValidation ? (L = r || p.realtimeValidation.validationErrors.length ? /* @__PURE__ */ Y(gl, {
		isDisabled: x,
		isInvalid: b,
		children: p.realtimeValidation.validationErrors.length ? p.realtimeValidation.validationErrors.join(", ") : r
	}) : null, t[22] = r, t[23] = x, t[24] = b, t[25] = p.realtimeValidation, t[26] = L) : L = t[26];
	let R;
	return t[27] !== y || t[28] !== v || t[29] !== p || t[30] !== u ? (R = p.isOpen ? /* @__PURE__ */ Y(Kw, {
		placement: "bottom",
		state: p,
		triggerRef: l,
		children: /* @__PURE__ */ Y(fi, {
			...v,
			className: "rounded-md border border-outline-decorative bg-background-primary p-xl shadow-md",
			children: /* @__PURE__ */ Y(Xw, {
				...y,
				yearOptions: u
			})
		})
	}) : null, t[27] = y, t[28] = v, t[29] = p, t[30] = u, t[31] = R) : R = t[31], /* @__PURE__ */ X("div", {
		className: w,
		children: [
			/* @__PURE__ */ Y(Vl, {
				isDisabled: x,
				label: s.label,
				labelProps: h,
				tooltipText: i
			}),
			I,
			L,
			R
		]
	});
}
//#endregion
//#region lib/components/DatePicker/TimeField.tsx
function aT(e) {
	let t = K(19), n;
	t[0] === e ? n = t[1] : ({...n} = e, t[0] = e, t[1] = n);
	let { locale: r } = ir(), i;
	t[2] !== r || t[3] !== n ? (i = {
		...n,
		locale: r,
		createCalendar: Ir
	}, t[2] = r, t[3] = n, t[4] = i) : i = t[4];
	let a = Mw(i), o = Tr(null), { fieldProps: s } = Yn(n, a, o), c;
	t[5] === a.segments ? c = t[6] : (c = a.segments.find(sT), t[5] = a.segments, t[6] = c);
	let l = c, u;
	t[7] === a.segments ? u = t[8] : (u = a.segments.find(oT), t[7] = a.segments, t[8] = u);
	let d = u, f = a.isInvalid ? "!text-text-negative" : "", p;
	t[9] === f ? p = t[10] : (p = W("flex items-center gap-0", f), t[9] = f, t[10] = p);
	let m;
	t[11] !== l || t[12] !== d || t[13] !== a ? (m = l && d ? /* @__PURE__ */ X(Dr, { children: [
		/* @__PURE__ */ Y(lT, {
			"aria-label": `date-segment-${l.text}`,
			segment: l,
			state: a
		}),
		/* @__PURE__ */ Y("span", {
			className: "px-xs font-bold",
			children: ":"
		}),
		/* @__PURE__ */ Y(lT, {
			"aria-label": `date-segment-${d.text}`,
			segment: d,
			state: a
		})
	] }) : null, t[11] = l, t[12] = d, t[13] = a, t[14] = m) : m = t[14];
	let h;
	return t[15] !== s || t[16] !== p || t[17] !== m ? (h = /* @__PURE__ */ Y("div", {
		...s,
		className: p,
		ref: o,
		children: m
	}), t[15] = s, t[16] = p, t[17] = m, t[18] = h) : h = t[18], h;
}
function oT(e) {
	return e.type === "minute";
}
function sT(e) {
	return e.type === "hour";
}
var cT = G({ base: "\n    size-full h-8 w-8 rounded-1 border border-outline-input-enabled bg-transparent py-xs\n    text-center text-label-small font-semibold text-text-secondary !caret-text-primary outline-none\n    hover:border-outline-input-hover hover:ring-1 hover:ring-outline-input-hover\n    focus:border-outline-input-focus focus:ring-1 focus:ring-outline-input-focus\n  " });
function lT(e) {
	let t = K(11), { segment: n, state: r, className: i } = e, a = Tr(null), { segmentProps: o } = $n(n, r, a), s = `date-segment-${n.text}`, c;
	t[0] === i ? c = t[1] : (c = cT({ class: i }), t[0] = i, t[1] = c);
	let l;
	t[2] !== n.type || t[3] !== r ? (l = (e) => {
		r.setSegment(n.type, Number(e.target.value));
	}, t[2] = n.type, t[3] = r, t[4] = l) : l = t[4];
	let u;
	return t[5] !== n.text || t[6] !== o || t[7] !== s || t[8] !== c || t[9] !== l ? (u = /* @__PURE__ */ Y(xi, {
		...o,
		"aria-label": s,
		className: c,
		onChange: l,
		onFocus: uT,
		value: n.text
	}), t[5] = n.text, t[6] = o, t[7] = s, t[8] = c, t[9] = l, t[10] = u) : u = t[10], u;
}
function uT(e) {
	e.target.select();
}
//#endregion
//#region lib/components/DateRangePicker/NoFocusSelect.tsx
function dT(e) {
	let t = K(24), { options: n, selected: r, onClick: i, className: a } = e, [o, s] = J(!1), c;
	t[0] !== n || t[1] !== r ? (c = n.find((e) => e.key === r) || n[0], t[0] = n, t[1] = r, t[2] = c) : c = t[2];
	let l = c, u = Tr(null), d, f;
	t[3] === o ? (d = t[4], f = t[5]) : (d = () => {
		let e = (e) => {
			u.current && !u.current.contains(e.target) && s(!1);
		};
		return o && document.addEventListener("click", e, !0), () => {
			document.removeEventListener("click", e, !0);
		};
	}, f = [o], t[3] = o, t[4] = d, t[5] = f), br(d, f);
	let p;
	t[6] === o ? p = t[7] : (p = () => s(!o), t[6] = o, t[7] = p);
	let m = l.label, h = o ? "-rotate-90" : "rotate-90", g;
	t[8] === h ? g = t[9] : (g = W("h-4 w-4", h), t[8] = h, t[9] = g);
	let _;
	t[10] === g ? _ = t[11] : (_ = /* @__PURE__ */ Y(mn, { className: g }), t[10] = g, t[11] = _);
	let v;
	t[12] !== l.label || t[13] !== p || t[14] !== _ ? (v = /* @__PURE__ */ X(Q, {
		className: "flex items-center gap-sm",
		onPress: p,
		variant: "tertiary",
		children: [m, _]
	}), t[12] = l.label, t[13] = p, t[14] = _, t[15] = v) : v = t[15];
	let y;
	t[16] !== a || t[17] !== i || t[18] !== n || t[19] !== o ? (y = o ? /* @__PURE__ */ Y(fi, {
		"aria-label": "no-focus-select-dialog",
		className: W("absolute top-xl z-10 min-w-[10rem] rounded-md border border-outline-input-enabled bg-background-secondary px-1 py-2 shadow-md outline-none", a),
		children: /* @__PURE__ */ Y("div", {
			className: "max-h-[14rem] overflow-y-auto",
			children: n.map((e) => /* @__PURE__ */ Y(Q, {
				className: "w-full",
				onPress: () => {
					i(e.key), s(!1);
				},
				variant: "dropdown",
				children: e.label
			}, `option-${e.key}`))
		})
	}) : null, t[16] = a, t[17] = i, t[18] = n, t[19] = o, t[20] = y) : y = t[20];
	let b;
	return t[21] !== y || t[22] !== v ? (b = /* @__PURE__ */ X("div", {
		className: "scrollbar-custom relative",
		ref: u,
		children: [v, y]
	}), t[21] = y, t[22] = v, t[23] = b) : b = t[23], b;
}
//#endregion
//#region lib/components/DateRangePicker/TimezoneSelect.tsx
function fT(e) {
	let t = K(15), { timezoneOptions: n, selected: r, onChange: i } = e, [a, o] = J(""), s;
	t[0] !== a || t[1] !== n ? (s = a ? n.filter((e) => e.label.toLowerCase().includes(a.toLowerCase())) : n, t[0] = a, t[1] = n, t[2] = s) : s = t[2];
	let c = s, l;
	t[3] === Symbol.for("react.memo_cache_sentinel") ? (l = /* @__PURE__ */ Y(mn, { className: "rotate-90" }), t[3] = l) : l = t[3];
	let u = r ? `${r.label} (${r.abbrev})` : "Local Timezone", d;
	t[4] === u ? d = t[5] : (d = /* @__PURE__ */ Y(Q, {
		IconRight: l,
		variant: "tertiary",
		children: u
	}), t[4] = u, t[5] = d);
	let f;
	t[6] === Symbol.for("react.memo_cache_sentinel") ? (f = (e) => o(e), t[6] = f) : f = t[6];
	let p;
	if (t[7] !== c || t[8] !== i) {
		let e;
		t[10] === i ? e = t[11] : (e = (e, t) => /* @__PURE__ */ X(Jl, {
			onPress: () => i(e),
			children: [
				e.label,
				" (",
				e.abbrev,
				")"
			]
		}, t), t[10] = i, t[11] = e), p = c.map(e), t[7] = c, t[8] = i, t[9] = p;
	} else p = t[9];
	let m;
	return t[12] !== d || t[13] !== p ? (m = /* @__PURE__ */ Y(Xl, {
		AnchorEle: d,
		className: "h-[15rem] w-[15rem] overflow-y-scroll",
		onSearch: f,
		withSearch: !0,
		children: p
	}), t[12] = d, t[13] = p, t[14] = m) : m = t[14], m;
}
//#endregion
//#region lib/components/DateRangePicker/RangeCalendar.tsx
var pT = {
	week: "This Week",
	month: "This Month",
	year: "This Year"
};
function mT(e) {
	let t = K(78), n, r, i, a, o, s, c, l, u;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4], o = t[5], s = t[6], c = t[7], l = t[8], u = t[9]) : ({dateFieldStartState: r, dateFieldEndState: n, dateRangePickerState: i, timezoneOptions: l, timezone: c, setTimezone: s, yearOptions: u, onPresetSelect: a, ...o} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a, t[5] = o, t[6] = s, t[7] = c, t[8] = l, t[9] = u);
	let { locale: d } = ir(), f;
	t[10] !== d || t[11] !== o ? (f = {
		...o,
		locale: d,
		createCalendar: Ir
	}, t[10] = d, t[11] = o, t[12] = f) : f = t[12];
	let p = MS(f), m = Tr(null), { calendarProps: h, prevButtonProps: g, nextButtonProps: _ } = sr(o, p, m), v = p.focusedDate.month, y = p.focusedDate.year, b;
	t[13] === Symbol.for("react.memo_cache_sentinel") ? (b = Array.from({ length: 12 }, bT), t[13] = b) : b = t[13];
	let x;
	t[14] === d ? x = t[15] : (x = b.map((e) => new Intl.DateTimeFormat(d, { month: "short" }).format(new Date(2e3, e, 1))).map(yT), t[14] = d, t[15] = x);
	let S = x, C;
	t[16] !== y || t[17] !== p ? (C = function(e) {
		p.setFocusedDate(new Ar(y, Number(e), 1));
	}, t[16] = y, t[17] = p, t[18] = C) : C = t[18];
	let w = C, T;
	t[19] !== v || t[20] !== p ? (T = function(e) {
		p.setFocusedDate(new Ar(Number(e), v, 1));
	}, t[19] = v, t[20] = p, t[21] = T) : T = t[21];
	let E = T, D;
	t[22] !== i || t[23] !== a || t[24] !== p ? (D = function(e) {
		let t = He(e);
		t && (i.setValue({
			start: new jr(t.start.year, t.start.month, t.start.day, 0, 0, 0),
			end: new jr(t.end.year, t.end.month, t.end.day, 23, 59, 59)
		}), p.setFocusedDate(t.start), a?.(pT[e]));
	}, t[22] = i, t[23] = a, t[24] = p, t[25] = D) : D = t[25];
	let O = D, k;
	t[26] !== i || t[27] !== a ? (k = function(e, t) {
		let n = /* @__PURE__ */ new Date(), r = /* @__PURE__ */ new Date(n.getTime() - e * 60 * 1e3);
		i.setValue({
			start: new jr(r.getFullYear(), r.getMonth() + 1, r.getDate(), r.getHours(), r.getMinutes()),
			end: new jr(n.getFullYear(), n.getMonth() + 1, n.getDate(), n.getHours(), n.getMinutes())
		}), a?.(t);
	}, t[26] = i, t[27] = a, t[28] = k) : k = t[28];
	let A = k, j;
	t[29] !== p || t[30] !== u ? (j = function() {
		(p.focusedDate.month !== 12 || p.focusedDate.year !== u[u.length - 1]) && p.focusNextPage();
	}, t[29] = p, t[30] = u, t[31] = j) : j = t[31];
	let M = j, N;
	t[32] !== p || t[33] !== u[0] ? (N = function() {
		(p.focusedDate.month !== 1 || p.focusedDate.year !== u[0]) && p.focusPreviousPage();
	}, t[32] = p, t[33] = u[0], t[34] = N) : N = t[34];
	let P = N, F = i.hasTime, I = [...r.segments, ...n.segments].some(vT), L;
	t[35] === Symbol.for("react.memo_cache_sentinel") ? (L = /* @__PURE__ */ Y(mn, { className: "size-lg rotate-180" }), t[35] = L) : L = t[35];
	let R;
	t[36] !== P || t[37] !== g ? (R = /* @__PURE__ */ Y(Q, {
		...g,
		className: "px-0 hover:text-brand-primary",
		onPress: P,
		variant: "plain",
		children: L
	}), t[36] = P, t[37] = g, t[38] = R) : R = t[38];
	let z;
	t[39] !== v || t[40] !== w || t[41] !== S ? (z = /* @__PURE__ */ Y(dT, {
		onClick: w,
		options: S,
		selected: v
	}), t[39] = v, t[40] = w, t[41] = S, t[42] = z) : z = t[42];
	let B;
	t[43] === u ? B = t[44] : (B = u.map(_T), t[43] = u, t[44] = B);
	let V;
	t[45] !== y || t[46] !== E || t[47] !== B ? (V = /* @__PURE__ */ Y(dT, {
		onClick: E,
		options: B,
		selected: y
	}), t[45] = y, t[46] = E, t[47] = B, t[48] = V) : V = t[48];
	let ee;
	t[49] === Symbol.for("react.memo_cache_sentinel") ? (ee = /* @__PURE__ */ Y(mn, { className: "size-lg" }), t[49] = ee) : ee = t[49];
	let H;
	t[50] !== M || t[51] !== _ ? (H = /* @__PURE__ */ Y(Q, {
		..._,
		className: "px-0 hover:text-brand-primary",
		onPress: M,
		variant: "plain",
		children: ee
	}), t[50] = M, t[51] = _, t[52] = H) : H = t[52];
	let U;
	t[53] !== R || t[54] !== z || t[55] !== V || t[56] !== H ? (U = /* @__PURE__ */ X("header", {
		className: "flex w-full items-center justify-between gap-1 pb-xs",
		children: [
			R,
			z,
			V,
			H
		]
	}), t[53] = R, t[54] = z, t[55] = V, t[56] = H, t[57] = U) : U = t[57];
	let te;
	t[58] !== h || t[59] !== p ? (te = /* @__PURE__ */ Y(Uw, {
		...h,
		state: p
	}), t[58] = h, t[59] = p, t[60] = te) : te = t[60];
	let ne;
	t[61] !== n || t[62] !== r || t[63] !== i.dateRange || t[64] !== O || t[65] !== A || t[66] !== F || t[67] !== I || t[68] !== o || t[69] !== s || t[70] !== c || t[71] !== l ? (ne = F ? /* @__PURE__ */ X(Dr, { children: [
		/* @__PURE__ */ X("div", {
			className: "flex items-center justify-between border-b border-outline-decorative py-xs",
			children: [
				/* @__PURE__ */ Y(Q, {
					className: "px-md py-xxs text-label-medium font-semibold",
					onPress: () => O("week"),
					variant: "tertiary",
					children: "This Week"
				}),
				/* @__PURE__ */ Y(Q, {
					className: "px-md py-xxs text-label-medium font-semibold",
					onPress: () => O("month"),
					variant: "tertiary",
					children: "This Month"
				}),
				/* @__PURE__ */ Y(Q, {
					className: "px-md py-xxs text-label-medium font-semibold",
					onPress: () => O("year"),
					variant: "tertiary",
					children: "This Year"
				})
			]
		}),
		/* @__PURE__ */ Y("div", {
			className: "flex items-center justify-center py-xxs",
			children: /* @__PURE__ */ Y(fT, {
				onChange: (e) => s(e),
				selected: c,
				timezoneOptions: l
			})
		}),
		/* @__PURE__ */ X("div", {
			className: W("flex w-full flex-col gap-xxs pb-[1.25rem] pt-lg", i.dateRange ? "" : "pointer-events-none opacity-50"),
			children: [/* @__PURE__ */ X("div", {
				className: "grid grid-cols-3 items-center",
				children: [
					/* @__PURE__ */ Y("span", {
						className: "text-label-small text-text-secondary",
						children: "Start"
					}),
					/* @__PURE__ */ Y(aT, { ...o.startFieldProps }),
					I ? /* @__PURE__ */ X(gS, {
						className: "w-fit",
						onSelectionChange: (e) => [...e][0]?.toString() === "AM" ? r.decrement("dayPeriod") : r.increment("dayPeriod"),
						selectedKeys: [r.segments.find(gT)?.text?.toLocaleUpperCase() ?? "AM"],
						selectionMode: "single",
						children: [/* @__PURE__ */ Y(vS, {
							className: "px-md py-3xs",
							id: "AM",
							children: "AM"
						}, "AM"), /* @__PURE__ */ Y(vS, {
							className: "px-md py-3xs",
							id: "PM",
							children: "PM"
						}, "PM")]
					}) : null
				]
			}), /* @__PURE__ */ X("div", {
				className: "grid grid-cols-3 items-center",
				children: [
					/* @__PURE__ */ Y("span", {
						className: "text-label-small text-text-secondary",
						children: "End"
					}),
					/* @__PURE__ */ Y(aT, { ...o.endFieldProps }),
					I ? /* @__PURE__ */ X(gS, {
						className: "w-fit",
						onSelectionChange: (e) => [...e][0]?.toString() === "AM" ? n.decrementPage("dayPeriod") : n.incrementPage("dayPeriod"),
						selectedKeys: [n.segments.find(hT)?.text?.toLocaleUpperCase() ?? "AM"],
						selectionMode: "single",
						children: [/* @__PURE__ */ Y(vS, {
							className: "px-md py-3xs",
							id: "AM",
							children: "AM"
						}, "AM"), /* @__PURE__ */ Y(vS, {
							className: "px-md py-3xs",
							id: "PM",
							children: "PM"
						}, "PM")]
					}) : null
				]
			})]
		}),
		/* @__PURE__ */ X("div", {
			className: "flex items-center justify-between",
			children: [
				/* @__PURE__ */ Y(Q, {
					className: "px-md py-xxs text-label-medium font-semibold",
					onPress: () => A(30, "30m"),
					variant: "tertiary",
					children: "30m"
				}),
				/* @__PURE__ */ Y(Q, {
					className: "px-md py-xxs text-label-medium font-semibold",
					onPress: () => A(60, "1h"),
					variant: "tertiary",
					children: "1h"
				}),
				/* @__PURE__ */ Y(Q, {
					className: "px-md py-xxs text-label-medium font-semibold",
					onPress: () => A(360, "6h"),
					variant: "tertiary",
					children: "6h"
				}),
				/* @__PURE__ */ Y(Q, {
					className: "px-md py-xxs text-label-medium font-semibold",
					onPress: () => A(720, "12h"),
					variant: "tertiary",
					children: "12h"
				})
			]
		})
	] }) : /* @__PURE__ */ X(Dr, { children: [/* @__PURE__ */ Y("div", {
		className: "flex items-center justify-center py-xxs",
		children: /* @__PURE__ */ Y(fT, {
			onChange: (e) => s(e),
			selected: c,
			timezoneOptions: l
		})
	}), /* @__PURE__ */ X("div", {
		className: "flex items-center justify-between pt-xs",
		children: [
			/* @__PURE__ */ Y(Q, {
				className: "px-md py-xxs text-label-medium font-semibold",
				onPress: () => O("week"),
				variant: "tertiary",
				children: "This Week"
			}),
			/* @__PURE__ */ Y(Q, {
				className: "px-md py-xxs text-label-medium font-semibold",
				onPress: () => O("month"),
				variant: "tertiary",
				children: "This Month"
			}),
			/* @__PURE__ */ Y(Q, {
				className: "px-md py-xxs text-label-medium font-semibold",
				onPress: () => O("year"),
				variant: "tertiary",
				children: "This Year"
			})
		]
	})] }), t[61] = n, t[62] = r, t[63] = i.dateRange, t[64] = O, t[65] = A, t[66] = F, t[67] = I, t[68] = o, t[69] = s, t[70] = c, t[71] = l, t[72] = ne) : ne = t[72];
	let re;
	return t[73] !== h || t[74] !== U || t[75] !== te || t[76] !== ne ? (re = /* @__PURE__ */ X("div", {
		...h,
		className: "inline-block w-full",
		ref: m,
		children: [
			U,
			te,
			ne
		]
	}), t[73] = h, t[74] = U, t[75] = te, t[76] = ne, t[77] = re) : re = t[77], re;
}
function hT(e) {
	return e.type === "dayPeriod";
}
function gT(e) {
	return e.type === "dayPeriod";
}
function _T(e) {
	return {
		key: e,
		label: e.toString()
	};
}
function vT(e) {
	return e.type === "dayPeriod";
}
function yT(e, t) {
	return {
		key: t + 1,
		label: e
	};
}
function bT(e, t) {
	return t;
}
//#endregion
//#region lib/components/DateRangePicker/DateRangePicker.tsx
var xT = G({
	base: "\n    flex items-center justify-between rounded-1 outline-none border border-outline-input-enabled\n    hover:border-outline-input-hover hover:ring-1 hover:ring-outline-input-hover px-4 py-2 gap-x-4\n  ",
	variants: {
		isInvalid: { true: "border-outline-negative ring-1 ring-outline-negative" },
		isFocused: { true: "ring-1 !ring-outline-input-focus !border-outline-input-focus" },
		isDisabled: { true: "cursor-not-allowed [&_*]:!cursor-not-allowed border-outline-input-disabled bg-background-primary hover:!ring-0 hover:!border-outline-input-disabled" },
		isReadOnly: { true: "!bg-background-secondary !border-transparent hover:!ring-0" }
	}
});
function ST(e) {
	let t = K(61), { yearOptions: n, granularity: r, onRangeChange: i, tooltipText: a, className: o, ...s } = e, c = r === void 0 ? "day" : r, { years: l, minDate: u, maxDate: d } = It(n, s.minValue, s.maxValue), { locale: f } = ir(), p = Tr(null), { userTimezone: m, timezoneOptions: h } = wt(), [g, _] = J(m), v;
	t[0] !== f || t[1] !== i || t[2] !== g ? (v = function(e) {
		if (e) {
			if (g && Zt(e.start) && Zt(e.end)) try {
				i(Ye(e.start, e.end, g, f));
			} catch (e) {
				console.error(e);
			}
			else i({
				start: e.start.toDate("UTC").toString(),
				end: e.end.toDate("UTC").toString()
			});
		}
	}, t[0] = f, t[1] = i, t[2] = g, t[3] = v) : v = t[3];
	let y = v, b = Fw({
		...s,
		shouldCloseOnSelect: !1,
		granularity: c,
		shouldForceLeadingZeros: !0,
		maxValue: d,
		minValue: u,
		onChange: y
	}), { labelProps: x, groupProps: S, startFieldProps: C, endFieldProps: w, buttonProps: T, dialogProps: E, calendarProps: D } = Qn({
		...s,
		granularity: c,
		shouldForceLeadingZeros: !0,
		maxValue: d,
		minValue: u,
		onChange: y
	}, b, p), O;
	t[4] !== f || t[5] !== C ? (O = {
		...C,
		locale: f,
		createCalendar: Ir
	}, t[4] = f, t[5] = C, t[6] = O) : O = t[6];
	let k = Mw(O), j;
	t[7] !== w || t[8] !== f ? (j = {
		...w,
		locale: f,
		createCalendar: Ir
	}, t[7] = w, t[8] = f, t[9] = j) : j = t[9];
	let M = Mw(j), N = s.isInvalid || b.realtimeValidation.isInvalid, P = s.isDisabled ?? !1, [F, I] = J(!1), L;
	t[10] === o ? L = t[11] : (L = W("flex flex-col gap-[.15rem]", o), t[10] = o, t[11] = L);
	let R = xT({
		isFocused: !P && !s.isReadOnly && F,
		isInvalid: N,
		isDisabled: P,
		isReadOnly: s.isReadOnly
	}), z;
	t[12] !== I || t[13] !== C ? (z = /* @__PURE__ */ Y(eT, {
		defaultTimeOfDay: "start",
		focusInputContainer: I,
		...C
	}), t[12] = I, t[13] = C, t[14] = z) : z = t[14];
	let B = P ? "text-text-disabled opacity-70" : "", V;
	t[15] === B ? V = t[16] : (V = W("text-text-primary", B), t[15] = B, t[16] = V);
	let ee;
	t[17] === V ? ee = t[18] : (ee = /* @__PURE__ */ Y(A, {
		className: V,
		size: 20
	}), t[17] = V, t[18] = ee);
	let H;
	t[19] !== w || t[20] !== I ? (H = /* @__PURE__ */ Y(eT, {
		defaultTimeOfDay: "end",
		focusInputContainer: I,
		...w
	}), t[19] = w, t[20] = I, t[21] = H) : H = t[21];
	let U;
	t[22] !== ee || t[23] !== H || t[24] !== z ? (U = /* @__PURE__ */ X("div", {
		className: "flex flex-row items-center gap-x-4",
		children: [
			z,
			ee,
			H
		]
	}), t[22] = ee, t[23] = H, t[24] = z, t[25] = U) : U = t[25];
	let te = P ? "text-text-disabled" : "", ne = s.isReadOnly ? "!text-text-primary" : "", re;
	t[26] !== te || t[27] !== ne ? (re = W("p-0", te, ne), t[26] = te, t[27] = ne, t[28] = re) : re = t[28];
	let ie = P || s.isReadOnly, ae;
	t[29] === b ? ae = t[30] : (ae = () => b.open(), t[29] = b, t[30] = ae);
	let oe;
	t[31] === Symbol.for("react.memo_cache_sentinel") ? (oe = /* @__PURE__ */ Y(Le, { className: "size-lg" }), t[31] = oe) : oe = t[31];
	let se;
	t[32] !== T || t[33] !== re || t[34] !== ie || t[35] !== ae ? (se = /* @__PURE__ */ Y(Q, {
		className: re,
		isDisabled: ie,
		onPress: ae,
		variant: "plain",
		...T,
		children: oe
	}), t[32] = T, t[33] = re, t[34] = ie, t[35] = ae, t[36] = se) : se = t[36];
	let ce;
	t[37] !== S || t[38] !== U || t[39] !== se || t[40] !== R ? (ce = /* @__PURE__ */ X("div", {
		className: R,
		...S,
		ref: p,
		children: [U, se]
	}), t[37] = S, t[38] = U, t[39] = se, t[40] = R, t[41] = ce) : ce = t[41];
	let le;
	t[42] !== P || t[43] !== N || t[44] !== s.assistiveText || t[45] !== b.realtimeValidation ? (le = s.assistiveText || b.realtimeValidation.validationErrors.length ? /* @__PURE__ */ Y(gl, {
		isDisabled: P,
		isInvalid: N,
		children: b.realtimeValidation.validationErrors.length ? b.realtimeValidation.validationErrors.join(", ") : s.assistiveText
	}) : null, t[42] = P, t[43] = N, t[44] = s.assistiveText, t[45] = b.realtimeValidation, t[46] = le) : le = t[46];
	let ue;
	return t[47] !== D || t[48] !== E || t[49] !== w || t[50] !== M || t[51] !== c || t[52] !== s.firstDayOfWeek || t[53] !== _ || t[54] !== C || t[55] !== k || t[56] !== b || t[57] !== g || t[58] !== h || t[59] !== l ? (ue = b.isOpen ? /* @__PURE__ */ Y(Kw, {
		placement: "bottom",
		state: b,
		triggerRef: p,
		children: /* @__PURE__ */ Y(fi, {
			...E,
			className: "w-[22.5rem] rounded-md border border-outline-decorative bg-background-primary p-xl shadow-md",
			children: /* @__PURE__ */ Y(mT, {
				...D,
				dateFieldEndState: M,
				dateFieldStartState: k,
				dateRangePickerState: b,
				endFieldProps: w,
				firstDayOfWeek: s.firstDayOfWeek,
				onChange: (e) => {
					if (b.setDateRange(e), c === "second") {
						let t = {
							start: new jr(e.start.year, e.start.month, e.start.day, 0, 0, 0),
							end: new jr(e.end.year, e.end.month, e.end.day, 23, 59, 59)
						};
						b.setValue(t);
					}
				},
				setTimezone: _,
				startFieldProps: C,
				timezone: g,
				timezoneOptions: h,
				yearOptions: l
			})
		})
	}) : null, t[47] = D, t[48] = E, t[49] = w, t[50] = M, t[51] = c, t[52] = s.firstDayOfWeek, t[53] = _, t[54] = C, t[55] = k, t[56] = b, t[57] = g, t[58] = h, t[59] = l, t[60] = ue) : ue = t[60], /* @__PURE__ */ X("div", {
		className: L,
		children: [
			/* @__PURE__ */ Y(Vl, {
				isDisabled: P,
				label: s.label,
				labelProps: x,
				tooltipText: a
			}),
			ce,
			le,
			ue
		]
	});
}
//#endregion
//#region lib/components/DateRangeSelect/DateRangeSelect.tsx
function CT({ yearOptions: e, granularity: t = "day", onRangeChange: n, assistiveText: r, tooltipText: i, className: a, buttonClassName: o, placeholder: s = "Select date range", startAdornment: c = /* @__PURE__ */ Y(Le, { className: "size-lg" }), renderTrigger: l, ...u }) {
	let { years: d, minDate: f, maxDate: p } = It(e, u.minValue, u.maxValue), { locale: m } = ir(), h = Tr(null), { userTimezone: g, timezoneOptions: _ } = wt(), [v, y] = J(g), [b, x] = J(null);
	function S(e) {
		if (e) {
			if (x(null), v && Zt(e.start) && Zt(e.end)) try {
				n(Ye(e.start, e.end, v, m));
			} catch (e) {
				console.error(e);
			}
			else n({
				start: e.start.toDate("UTC").toString(),
				end: e.end.toDate("UTC").toString()
			});
		}
	}
	let C = Fw({
		...u,
		shouldCloseOnSelect: !1,
		granularity: t,
		shouldForceLeadingZeros: !0,
		maxValue: p,
		minValue: f,
		onChange: S
	}), { startFieldProps: w, endFieldProps: T, dialogProps: E, calendarProps: D } = Qn({
		...u,
		granularity: t,
		shouldForceLeadingZeros: !0,
		maxValue: p,
		minValue: f,
		onChange: S
	}, C, h), O = Mw({
		...w,
		locale: m,
		createCalendar: Ir
	}), k = Mw({
		...T,
		locale: m,
		createCalendar: Ir
	}), A = Xn(t === "second" ? {
		dateStyle: "medium",
		timeStyle: "short"
	} : { dateStyle: "medium" }), j = C.value?.start && C.value?.end ? `${A.format(C.value.start.toDate(Br()))} – ${A.format(C.value.end.toDate(Br()))}` : void 0, M = b ?? j, N = u.isInvalid || C.realtimeValidation.isInvalid, P = u.isDisabled ?? !1, F = C.realtimeValidation.validationErrors.length ? C.realtimeValidation.validationErrors.join(", ") : r, I = typeof u.label == "string" ? u.label : void 0, L = () => C.setOpen(!C.isOpen);
	return /* @__PURE__ */ X(Dr, { children: [l ? l({
		value: M,
		placeholder: s,
		isOpen: C.isOpen,
		isDisabled: P,
		isInvalid: N,
		ref: h,
		onPress: L
	}) : /* @__PURE__ */ Y(iS, {
		"aria-label": u["aria-label"] ?? I ?? "Select date range",
		assistiveText: F,
		buttonClassName: o,
		className: a,
		isDisabled: P,
		isInvalid: N,
		isOpen: C.isOpen,
		isReadOnly: u.isReadOnly,
		isRequired: u.isRequired,
		label: I,
		onPress: L,
		placeholder: s,
		ref: h,
		startAdornment: c,
		tooltipText: i,
		value: M
	}), C.isOpen ? /* @__PURE__ */ Y(Kw, {
		placement: "bottom start",
		state: C,
		triggerRef: h,
		children: /* @__PURE__ */ Y(fi, {
			...E,
			className: "w-[22.5rem] rounded-md border border-outline-decorative bg-background-primary p-xl shadow-md",
			children: /* @__PURE__ */ Y(mT, {
				...D,
				dateFieldEndState: k,
				dateFieldStartState: O,
				dateRangePickerState: C,
				endFieldProps: T,
				firstDayOfWeek: u.firstDayOfWeek,
				onChange: (e) => {
					if (x(null), C.setDateRange(e), t === "second") {
						let t = {
							start: new jr(e.start.year, e.start.month, e.start.day, 0, 0, 0),
							end: new jr(e.end.year, e.end.month, e.end.day, 23, 59, 59)
						};
						C.setValue(t);
					}
				},
				onPresetSelect: x,
				setTimezone: y,
				startFieldProps: w,
				timezone: v,
				timezoneOptions: _,
				yearOptions: d
			})
		})
	}) : null] });
}
//#endregion
//#region lib/components/FilterRail/ClearButton.tsx
function wT(e) {
	let t = K(8), n, r;
	t[0] === e ? (n = t[1], r = t[2]) : ({className: n, ...r} = e, t[0] = e, t[1] = n, t[2] = r);
	let i;
	t[3] === n ? i = t[4] : (i = W("h-auto px-xxs py-0 text-label-extra-small font-medium text-text-secondary hover:text-text-primary data-[focus-visible]:text-text-primary", n), t[3] = n, t[4] = i);
	let a;
	return t[5] !== r || t[6] !== i ? (a = /* @__PURE__ */ Y(Q, {
		...r,
		className: i,
		variant: "plain"
	}), t[5] = r, t[6] = i, t[7] = a) : a = t[7], a;
}
//#endregion
//#region lib/components/FilterRail/rail/Catalogue.tsx
function TT({ sections: e, row: t }) {
	return e.map((e) => /* @__PURE__ */ X("section", {
		"aria-label": e.label ?? void 0,
		children: [e.label ? /* @__PURE__ */ X(Dr, { children: [/* @__PURE__ */ Y(Vy, {
			className: "flex h-[22px] items-center pl-xs pr-5 py-3xs text-label-extra-small font-bold capitalize text-text-secondary",
			level: 3,
			children: e.label
		}), /* @__PURE__ */ Y(Fy, { className: "border-neutral-200" })] }) : null, e.rows.map(t)]
	}, e.label ?? ""));
}
//#endregion
//#region lib/components/FilterRail/criteria/boolean.ts
var ET = ["true", "false"];
function DT(e) {
	return e === "true" ? "True" : e === "false" ? "False" : e;
}
function OT(e) {
	if (e.values.length !== 1) return null;
	let t = e.values[0];
	return t !== "true" && t !== "false" ? null : t === "true" === e.negated ? "false" : "true";
}
//#endregion
//#region lib/components/FilterRail/criteria/operators.ts
function kT(e, t = e.defaultOperator) {
	return e.operators.find((e) => e.id === t) ?? {
		id: t,
		label: t,
		takesValue: !0,
		needsQualifier: !1
	};
}
//#endregion
//#region lib/components/FilterRail/criteria/criterionText.ts
function AT(e) {
	return e.kind === "boolean" ? DT : (t) => e.options?.find((e) => e.value === t)?.label ?? t;
}
function jT(e, t, n = AT(t)) {
	let { label: r } = kT(t, e.operator);
	return {
		subject: [t.label, ...e.qualifier === void 0 ? [] : [e.qualifier]].join(" "),
		operator: `${e.negated ? "not " : ""}${r.charAt(0).toLowerCase()}${r.slice(1)}`,
		values: e.values.map(n)
	};
}
function MT(e, t, n) {
	let { subject: r, operator: i, values: a } = jT(e, t, n);
	return [
		r,
		i,
		...a.length ? [a.join(", ")] : []
	].join(" ");
}
//#endregion
//#region lib/components/FilterRail/rail/ValueNames.tsx
function NT(e) {
	let t = K(12), { source: n, values: r, children: i } = e;
	if (!n || !r.length) {
		let e;
		return t[0] === i ? e = t[1] : (e = i(), t[0] = i, t[1] = e), e;
	}
	let a;
	t[2] === i ? a = t[3] : (a = i(), t[2] = i, t[3] = a);
	let o;
	t[4] === i ? o = t[5] : (o = (e) => i((t) => e.find((e) => e.value === t)?.label ?? t), t[4] = i, t[5] = o);
	let s;
	t[6] !== n || t[7] !== o ? (s = /* @__PURE__ */ Y(n, { children: o }), t[6] = n, t[7] = o, t[8] = s) : s = t[8];
	let c;
	return t[9] !== a || t[10] !== s ? (c = /* @__PURE__ */ Y(pr, {
		fallback: a,
		children: s
	}), t[9] = a, t[10] = s, t[11] = c) : c = t[11], c;
}
//#endregion
//#region lib/components/FilterRail/rail/CriterionLine.tsx
function PT(e) {
	let t = K(7), { item: n, filter: r, source: i } = e, a;
	t[0] !== r || t[1] !== n ? (a = (e) => /* @__PURE__ */ Y("span", { children: MT(n, r, e) }), t[0] = r, t[1] = n, t[2] = a) : a = t[2];
	let o;
	return t[3] !== n.values || t[4] !== i || t[5] !== a ? (o = /* @__PURE__ */ Y(NT, {
		source: i,
		values: n.values,
		children: a
	}), t[3] = n.values, t[4] = i, t[5] = a, t[6] = o) : o = t[6], o;
}
//#endregion
//#region lib/components/FilterRail/criteria/answer.ts
function FT(e, t, n) {
	let { takesValue: r, needsQualifier: i } = kT(e, t);
	if (r ? e.kind !== "boolean" : i) return null;
	let a = Vn({
		name: e.name,
		operator: t
	}, e);
	return r ? {
		picked: n ? OT(n) : null,
		criterion: (e) => ({
			...a,
			values: [e],
			negated: !1
		})
	} : {
		picked: n ? n.negated ? "false" : "true" : null,
		criterion: (e) => ({
			...a,
			values: [],
			negated: e === "false"
		})
	};
}
//#endregion
//#region lib/components/FilterRail/overlay/OverlayColumn.tsx
function IT(e) {
	let t = K(11), { title: n, action: r, children: i } = e, a;
	t[0] === n ? a = t[1] : (a = /* @__PURE__ */ Y("span", {
		className: "grow text-label-small font-medium text-text-primary",
		children: n
	}), t[0] = n, t[1] = a);
	let o;
	t[2] !== r || t[3] !== a ? (o = /* @__PURE__ */ X("div", {
		className: "flex h-7 shrink-0 items-center pl-sm pr-3xs",
		children: [a, r]
	}), t[2] = r, t[3] = a, t[4] = o) : o = t[4];
	let s;
	t[5] === i ? s = t[6] : (s = /* @__PURE__ */ Y("div", {
		className: "min-h-0 overflow-y-auto",
		children: /* @__PURE__ */ Y("div", {
			className: "flex flex-col gap-3xs py-3xs",
			children: i
		})
	}), t[5] = i, t[6] = s);
	let c;
	return t[7] !== o || t[8] !== s || t[9] !== n ? (c = /* @__PURE__ */ X("div", {
		"aria-label": n,
		className: "flex w-[218px] shrink-0 flex-col border-l border-neutral-200 py-3xs first:border-l-0",
		role: "group",
		children: [o, s]
	}), t[7] = o, t[8] = s, t[9] = n, t[10] = c) : c = t[10], c;
}
//#endregion
//#region lib/components/FilterRail/marks.tsx
function LT(e) {
	let t = K(4), { count: n } = e, r;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (r = /* @__PURE__ */ Y("circle", {
		cx: "7",
		cy: "7",
		fill: "currentColor",
		r: "5.6875"
	}), t[0] = r) : r = t[0];
	let i = Math.min(8, 18 / String(n).length), a;
	return t[1] !== n || t[2] !== i ? (a = /* @__PURE__ */ X("svg", {
		className: "size-[14px] shrink-0 text-stacklet-orange-500",
		"data-testid": "applied-count",
		viewBox: "0 0 14 14",
		"aria-hidden": !0,
		children: [r, /* @__PURE__ */ Y("text", {
			className: "fill-neutral-white",
			dominantBaseline: "central",
			fontSize: i,
			fontWeight: "700",
			textAnchor: "middle",
			x: "7",
			y: "7",
			children: n
		})]
	}), t[1] = n, t[2] = i, t[3] = a) : a = t[3], a;
}
function RT(e) {
	let t = K(2), { item: n } = e, r;
	return t[0] === n ? r = t[1] : (r = OT(n) === "false" ? /* @__PURE__ */ Y(Fe, {
		className: "shrink-0 text-negative-600",
		"data-testid": "applied-boolean",
		size: 12
	}) : /* @__PURE__ */ Y(f, {
		className: "shrink-0 text-positive-700",
		"data-testid": "applied-boolean",
		size: 14
	}), t[0] = n, t[1] = r), r;
}
//#endregion
//#region lib/components/FilterRail/overlay/OverlayList.tsx
function zT(e) {
	let t = K(9), { "aria-label": n, items: r, selected: i, onSelect: a } = e, o;
	t[0] === a ? o = t[1] : (o = (e) => {
		let [t] = e === "all" ? [] : [...e];
		t !== void 0 && a(String(t));
	}, t[0] = a, t[1] = o);
	let s;
	t[2] === i ? s = t[3] : (s = [i], t[2] = i, t[3] = s);
	let c;
	return t[4] !== n || t[5] !== r || t[6] !== o || t[7] !== s ? (c = /* @__PURE__ */ Y(Ti, {
		"aria-label": n,
		className: "flex flex-col gap-3xs outline-none",
		escapeKeyBehavior: "none",
		items: r,
		onSelectionChange: o,
		selectedKeys: s,
		selectionMode: "single",
		disallowEmptySelection: !0,
		children: BT
	}), t[4] = n, t[5] = r, t[6] = o, t[7] = s, t[8] = c) : c = t[8], c;
}
function BT(e) {
	return /* @__PURE__ */ X(Ei, {
		className: VT,
		id: e.id,
		textValue: e.label,
		children: [/* @__PURE__ */ Y(Ki, {
			className: "min-w-0 grow truncate",
			slot: "label",
			children: e.label
		}), e.count ? /* @__PURE__ */ X(Dr, { children: [/* @__PURE__ */ X(Ki, {
			className: "sr-only",
			slot: "description",
			children: [e.count, " applied"]
		}), /* @__PURE__ */ Y(LT, { count: e.count })] }) : /* @__PURE__ */ Y(We, {
			className: "shrink-0 text-text-secondary",
			size: 12
		})]
	});
}
function VT(e) {
	let { isHovered: t, isFocusVisible: n, isSelected: r } = e;
	return W("mx-3xs flex cursor-pointer items-center gap-xs rounded-xs px-sm py-xxs text-label-small font-medium text-text-secondary outline-none", t || r ? "bg-background-secondary" : void 0, n ? "ring-2 ring-inset ring-outline-brand" : void 0);
}
//#endregion
//#region lib/components/FilterRail/overlay/ValueList.tsx
function HT(e) {
	let t = K(41), { "aria-label": n, items: r, selected: i, onChange: a, selectionMode: o, removable: s, search: c, icon: l, decorate: u, limit: d, emptyMessage: f, ref: p } = e, m = o === void 0 ? "multiple" : o, h = s !== void 0 && s, g = c === void 0 ? "" : c, _ = d === void 0 ? 8 : d, v = f === void 0 ? "No values" : f, [y, b] = J(!1), x;
	t[0] !== r.length || t[1] !== _ ? (x = () => r.length > _, t[0] = r.length, t[1] = _, t[2] = x) : x = t[2];
	let [S] = J(x), C = Tr(null), w;
	t[3] === Symbol.for("react.memo_cache_sentinel") ? (w = () => C.current, t[3] = w) : w = t[3], Sr(p, w);
	let T = g.trim().toLowerCase(), E;
	t[4] === i ? E = t[5] : (E = () => new Set(i), t[4] = i, t[5] = E);
	let [D, O] = J(E), [k, A] = J(T !== "");
	k !== (T !== "") && (A(T !== ""), T || O(new Set(i)));
	let j = T ? r.filter((e) => [e.label, e.value].some((e) => e?.toLowerCase().includes(T))) : r, M;
	t[6] !== j || t[7] !== S || t[8] !== D ? (M = S ? [...j.filter((e) => D.has(e.value)), ...j.filter((e) => !D.has(e.value))] : j, t[6] = j, t[7] = S, t[8] = D, t[9] = M) : M = t[9];
	let N = M, P;
	t[10] !== y || t[11] !== _ || t[12] !== N ? (P = y ? N : N.slice(0, _), t[10] = y, t[11] = _, t[12] = N, t[13] = P) : P = t[13];
	let F = P, I = N.length - F.length;
	if (!j.length) {
		let e;
		return t[14] === v ? e = t[15] : (e = /* @__PURE__ */ Y("p", {
			className: "px-sm py-xxs text-label-small text-text-secondary",
			children: v
		}), t[14] = v, t[15] = e), e;
	}
	let L;
	t[16] !== u || t[17] !== l || t[18] !== h ? (L = [
		l,
		u,
		h
	], t[16] = u, t[17] = l, t[18] = h, t[19] = L) : L = t[19];
	let R;
	t[20] !== a || t[21] !== i || t[22] !== F ? (R = (e) => a(e === "all" ? [.../* @__PURE__ */ new Set([...i, ...F.map(WT)])] : [...e].map(String)), t[20] = a, t[21] = i, t[22] = F, t[23] = R) : R = t[23];
	let z;
	t[24] !== u || t[25] !== l || t[26] !== h ? (z = (e) => /* @__PURE__ */ Y(Ei, {
		className: UT,
		id: e.value,
		textValue: e.label ?? e.value,
		children: (t) => {
			let { isSelected: n, isHovered: r } = t;
			return /* @__PURE__ */ X(Dr, { children: [
				l ? /* @__PURE__ */ Y("span", {
					className: "flex size-[14px] shrink-0 items-center",
					children: l
				}) : null,
				/* @__PURE__ */ Y("span", {
					className: W("min-w-0 grow truncate", n ? "text-text-primary" : void 0),
					children: u ? u(e.value) : e.label ?? e.value
				}),
				/* @__PURE__ */ Y(GT, {
					isHovered: r,
					isPicked: n,
					removable: h
				})
			] });
		}
	}), t[24] = u, t[25] = l, t[26] = h, t[27] = z) : z = t[27];
	let B;
	t[28] !== n || t[29] !== i || t[30] !== m || t[31] !== F || t[32] !== L || t[33] !== R || t[34] !== z ? (B = /* @__PURE__ */ Y(Ti, {
		"aria-label": n,
		className: "flex flex-col gap-3xs outline-none",
		dependencies: L,
		escapeKeyBehavior: "none",
		items: F,
		onSelectionChange: R,
		ref: C,
		selectedKeys: i,
		selectionMode: m,
		children: z
	}), t[28] = n, t[29] = i, t[30] = m, t[31] = F, t[32] = L, t[33] = R, t[34] = z, t[35] = B) : B = t[35];
	let V;
	t[36] === I ? V = t[37] : (V = I > 0 ? /* @__PURE__ */ X(Q, {
		className: "mx-3xs justify-start rounded-xs border-0 px-sm text-left text-label-small font-normal text-text-secondary hover:bg-background-secondary data-[focus-visible]:bg-background-secondary",
		onPress: () => {
			b(!0), C.current?.focus();
		},
		variant: "plain",
		children: [
			/* @__PURE__ */ Y(nn, {
				className: "shrink-0",
				size: 14
			}),
			/* @__PURE__ */ X("span", {
				className: "min-w-0 grow truncate",
				children: [
					I,
					" more ",
					I === 1 ? "option" : "options",
					"…"
				]
			}),
			/* @__PURE__ */ Y(_n, {
				className: "shrink-0",
				size: 12
			})
		]
	}) : null, t[36] = I, t[37] = V);
	let ee;
	return t[38] !== B || t[39] !== V ? (ee = /* @__PURE__ */ X(Dr, { children: [B, V] }), t[38] = B, t[39] = V, t[40] = ee) : ee = t[40], ee;
}
function UT(e) {
	let { isHovered: t, isFocusVisible: n } = e;
	return W("mx-3xs flex cursor-pointer items-center gap-xs rounded-xs px-sm py-xxs text-label-small text-text-secondary outline-none", t || n ? "bg-background-secondary" : void 0);
}
function WT(e) {
	return e.value;
}
function GT(e) {
	let n = K(4), { isPicked: r, isHovered: i, removable: a } = e;
	if (!r) {
		let e;
		return n[0] === Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ Y(f, {
			className: "shrink-0 text-neutral-700",
			size: 14
		}), n[0] = e) : e = n[0], e;
	}
	let o;
	return n[1] !== i || n[2] !== a ? (o = a && i ? /* @__PURE__ */ Y(t, {
		className: "shrink-0 text-text-secondary",
		"data-testid": "remove-mark",
		size: 14
	}) : /* @__PURE__ */ Y(f, {
		className: "shrink-0 text-stacklet-orange-500",
		"data-testid": "picked-mark",
		size: 14
	}), n[1] = i, n[2] = a, n[3] = o) : o = n[3], o;
}
//#endregion
//#region lib/components/FilterRail/overlay/TrueFalseList.tsx
var KT = ET.map((e) => ({
	value: e,
	label: DT(e)
}));
function qT(e) {
	let t = K(8), { "aria-label": n, picked: r, onPick: i } = e, a;
	t[0] === i ? a = t[1] : (a = (e) => {
		let [t] = e;
		return i(YT(t) ? t : null);
	}, t[0] = i, t[1] = a);
	let o;
	t[2] === r ? o = t[3] : (o = r ? [r] : [], t[2] = r, t[3] = o);
	let s;
	return t[4] !== n || t[5] !== a || t[6] !== o ? (s = /* @__PURE__ */ Y(HT, {
		"aria-label": n,
		decorate: JT,
		items: KT,
		onChange: a,
		selected: o,
		selectionMode: "single"
	}), t[4] = n, t[5] = a, t[6] = o, t[7] = s) : s = t[7], s;
}
function JT(e) {
	return /* @__PURE__ */ X("span", {
		className: "flex items-center gap-xs",
		children: [e === "true" ? /* @__PURE__ */ Y(te, {
			className: "shrink-0 text-positive-700",
			size: 14
		}) : /* @__PURE__ */ Y(ce, {
			className: "shrink-0 text-negative-600",
			size: 14
		}), DT(e)]
	});
}
function YT(e) {
	return e === "true" || e === "false";
}
//#endregion
//#region lib/components/FilterRail/overlay/SourceValues.tsx
function XT(e) {
	let t = K(4), { source: n, children: r } = e, i;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (i = /* @__PURE__ */ Y(QT, {}), t[0] = i) : i = t[0];
	let a;
	return t[1] !== n || t[2] !== r ? (a = /* @__PURE__ */ Y(pr, {
		fallback: i,
		children: /* @__PURE__ */ Y(n, { children: r })
	}), t[1] = n, t[2] = r, t[3] = a) : a = t[3], a;
}
var ZT = [
	"70%",
	"55%",
	"80%",
	"45%"
];
function QT() {
	let e = K(1), t;
	return e[0] === Symbol.for("react.memo_cache_sentinel") ? (t = /* @__PURE__ */ Y(nx, {
		className: "flex flex-col gap-3xs",
		label: "Loading values",
		children: ZT.map($T)
	}), e[0] = t) : t = e[0], t;
}
function $T(e) {
	return /* @__PURE__ */ Y("div", {
		className: "flex h-[26px] items-center px-sm",
		children: /* @__PURE__ */ Y(Gl, {
			height: 12,
			width: e
		})
	}, e);
}
//#endregion
//#region lib/components/FilterRail/overlay/editors/ChoiceValueEditor.tsx
function eE(e) {
	let t = K(9), { filter: n, values: r, onChange: i, valueSource: a, decorate: o } = e, [s, c] = J(""), [l] = J(r), u = Tr(null), d;
	if (t[0] !== l || t[1] !== o || t[2] !== n.label || t[3] !== n.options || t[4] !== i || t[5] !== s || t[6] !== a || t[7] !== r) {
		let e = (e) => {
			let t = new Set(e.map(nE)), a = [...l.filter((e) => !t.has(e)).map(tE), ...e], d = a.length > 8;
			return /* @__PURE__ */ X("div", {
				className: "flex flex-col gap-3xs",
				children: [d ? /* @__PURE__ */ Y(Wl, {
					"aria-label": `Search ${n.label} values`,
					className: "sticky top-0 z-10 w-auto bg-background-primary px-3xs",
					inputProps: {
						className: "py-px",
						placeholder: "Search…"
					},
					onChange: c,
					onKeyDown: (e) => {
						if (e.key === "ArrowDown") {
							e.preventDefault(), u.current?.focus();
							return;
						}
						e.continuePropagation();
					},
					value: s
				}) : null, /* @__PURE__ */ Y(HT, {
					"aria-label": `${n.label} values`,
					decorate: o,
					items: a,
					onChange: i,
					ref: u,
					search: d ? s : "",
					selected: r
				})]
			});
		};
		d = a ? /* @__PURE__ */ Y(XT, {
			source: a,
			children: e
		}) : e(n.options ?? []), t[0] = l, t[1] = o, t[2] = n.label, t[3] = n.options, t[4] = i, t[5] = s, t[6] = a, t[7] = r, t[8] = d;
	} else d = t[8];
	return d;
}
function tE(e) {
	return { value: e };
}
function nE(e) {
	return e.value;
}
//#endregion
//#region lib/components/FilterRail/overlay/editors/DateValueEditor.tsx
function rE(e) {
	let t = K(9), { filter: n, values: r, onChange: i } = e, a = `${n.label} date and time`, o;
	t[0] === i ? o = t[1] : (o = (e) => i(e ? [aE(e)] : []), t[0] = i, t[1] = o);
	let s;
	t[2] === Symbol.for("react.memo_cache_sentinel") ? (s = qr(Br()).set({
		second: 0,
		millisecond: 0
	}), t[2] = s) : s = t[2];
	let c;
	t[3] === r[0] ? c = t[4] : (c = r[0] ? iE(r[0]) : null, t[3] = r[0], t[4] = c);
	let l;
	return t[5] !== a || t[6] !== o || t[7] !== c ? (l = /* @__PURE__ */ Y(iT, {
		"aria-label": a,
		className: "px-3xs",
		granularity: "minute",
		onChange: o,
		placeholderValue: s,
		value: c,
		variant: "compact",
		hideTimeZone: !0
	}), t[5] = a, t[6] = o, t[7] = c, t[8] = l) : l = t[8], l;
}
function iE(e) {
	try {
		return Jr(e);
	} catch {
		return null;
	}
}
function aE(e) {
	return e instanceof Fr ? e.toAbsoluteString() : e.toDate(Br()).toISOString();
}
//#endregion
//#region lib/components/FilterRail/overlay/editors/onEnter.ts
function oE(e, t) {
	if (e.key === "Enter" && !e.nativeEvent.isComposing) {
		e.preventDefault(), t();
		return;
	}
	e.continuePropagation();
}
//#endregion
//#region lib/components/FilterRail/overlay/editors/TagValueEditor.tsx
function sE({ filter: e, operator: t, applied: n, onKeyChange: r, onKeyRemove: i, keySource: a }) {
	let [o, s] = J(""), [c, l] = J(""), u = Tr(null), d = Tr(null), { takesValue: f } = kT(e, t), p = () => d.current?.focus(), m = (e) => n.filter((t) => t.qualifier === e).flatMap((e) => e.values), h = (e, t = c.trim()) => {
		!e || f && !t || (r(e, f ? [.../* @__PURE__ */ new Set([...m(e), t])] : []), l(""), f || s(""));
	}, g = n.flatMap((e) => e.values.length ? e.values.map((t) => ({
		qualifier: e.qualifier ?? "",
		value: t
	})) : [{ qualifier: e.qualifier ?? "" }]), _ = (e) => {
		for (let t of new Set(e.map((e) => e.qualifier))) {
			if (!f) {
				i(t);
				continue;
			}
			let n = new Set(e.filter((e) => e.qualifier === t).map((e) => e.value));
			r(t, m(t).filter((e) => !n.has(e)));
		}
	};
	return /* @__PURE__ */ X("div", {
		className: "flex flex-col gap-3xs",
		children: [
			/* @__PURE__ */ X("div", {
				className: "sticky top-0 z-10 flex gap-xxs bg-background-primary px-3xs",
				children: [/* @__PURE__ */ Y(Zx, {
					"aria-label": "Tag key",
					className: "min-w-0 flex-1",
					inputProps: {
						placeholder: "Insert key",
						variant: "compact"
					},
					onChange: s,
					onKeyDown: (e) => oE(e, f ? p : () => h(o.trim())),
					ref: u,
					value: o
				}), f ? /* @__PURE__ */ Y(Zx, {
					"aria-label": "Tag value",
					className: "min-w-0 flex-1",
					inputProps: {
						placeholder: "Insert value",
						variant: "compact"
					},
					isDisabled: !o.trim(),
					onChange: l,
					onKeyDown: (e) => oE(e, () => h(o.trim())),
					ref: d,
					value: c
				}) : null]
			}),
			g.length ? /* @__PURE__ */ Y(HT, {
				"aria-label": `${e.label} values`,
				icon: /* @__PURE__ */ Y(B, { size: 14 }),
				items: g.map((e) => ({
					value: cE(e),
					label: lE(e)
				})),
				limit: Infinity,
				onChange: (e) => {
					e.length || u.current?.focus(), _(g.filter((t) => !e.includes(cE(t))));
				},
				selected: g.map(cE),
				removable: !0
			}) : null,
			a ? /* @__PURE__ */ Y(XT, {
				source: a,
				children: (t) => /* @__PURE__ */ Y(HT, {
					"aria-label": `${e.label} keys`,
					items: t,
					onChange: ([e]) => {
						e && f ? (kr(() => s(e)), p()) : e && h(e);
					},
					search: o,
					selected: [],
					selectionMode: "single"
				})
			}) : null
		]
	});
}
function cE({ qualifier: e, value: t }) {
	return JSON.stringify([e, t ?? null]);
}
function lE({ qualifier: e, value: t }) {
	return t === void 0 ? e : `${e}: ${t}`;
}
//#endregion
//#region lib/components/FilterRail/overlay/editors/TextValueEditor.tsx
function uE(e) {
	let t = K(22), { filter: n, values: r, onChange: i, placeholder: a, inputMode: o, accept: s } = e, c = a === void 0 ? "Insert value" : a, l = o === void 0 ? "text" : o, u = s === void 0 ? fE : s, [d, f] = J(""), p = Tr(null), m;
	t[0] !== u || t[1] !== d || t[2] !== i || t[3] !== r ? (m = () => {
		let e = d.trim();
		!e || !u(e) || (r.includes(e) || i([...r, e]), f(""));
	}, t[0] = u, t[1] = d, t[2] = i, t[3] = r, t[4] = m) : m = t[4];
	let h = m, g = `${n.label} value`, _;
	t[5] !== l || t[6] !== c ? (_ = {
		placeholder: c,
		inputMode: l,
		variant: "compact"
	}, t[5] = l, t[6] = c, t[7] = _) : _ = t[7];
	let v;
	t[8] === h ? v = t[9] : (v = (e) => oE(e, h), t[8] = h, t[9] = v);
	let y;
	t[10] !== d || t[11] !== g || t[12] !== _ || t[13] !== v ? (y = /* @__PURE__ */ Y(Zx, {
		"aria-label": g,
		className: "sticky top-0 z-10 bg-background-primary px-3xs",
		inputProps: _,
		onChange: f,
		onKeyDown: v,
		ref: p,
		value: d
	}), t[10] = d, t[11] = g, t[12] = _, t[13] = v, t[14] = y) : y = t[14];
	let b;
	t[15] !== n.label || t[16] !== i || t[17] !== r ? (b = r.length ? /* @__PURE__ */ Y(HT, {
		"aria-label": `${n.label} values`,
		icon: /* @__PURE__ */ Y(ae, { size: 14 }),
		items: [...new Set(r)].map(dE),
		limit: Infinity,
		onChange: (e) => {
			e.length || p.current?.focus(), i(e);
		},
		selected: r,
		removable: !0
	}) : null, t[15] = n.label, t[16] = i, t[17] = r, t[18] = b) : b = t[18];
	let x;
	return t[19] !== y || t[20] !== b ? (x = /* @__PURE__ */ X("div", {
		className: "flex flex-col gap-3xs",
		children: [y, b]
	}), t[19] = y, t[20] = b, t[21] = x) : x = t[21], x;
}
function dE(e) {
	return { value: e };
}
function fE() {
	return !0;
}
//#endregion
//#region lib/components/FilterRail/overlay/editors/ValueEditor.tsx
var pE = /^\d+$/;
function mE(e) {
	let t = K(25), n, r, i, a, o;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4], o = t[5]) : ({applied: n, onKeyChange: a, onKeyRemove: o, keySource: i, ...r} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a, t[5] = o);
	let { filter: s, operator: c, values: l, onChange: u } = r;
	switch (s.kind) {
		case "choice": {
			let e;
			return t[6] === r ? e = t[7] : (e = /* @__PURE__ */ Y(eE, { ...r }), t[6] = r, t[7] = e), e;
		}
		case "number": {
			let e;
			return t[8] !== s || t[9] !== u || t[10] !== l ? (e = /* @__PURE__ */ Y(uE, {
				accept: hE,
				filter: s,
				inputMode: "numeric",
				onChange: u,
				placeholder: "Insert number",
				values: l
			}), t[8] = s, t[9] = u, t[10] = l, t[11] = e) : e = t[11], e;
		}
		case "date": {
			let e;
			return t[12] === r ? e = t[13] : (e = /* @__PURE__ */ Y(rE, { ...r }), t[12] = r, t[13] = e), e;
		}
		case "tag": {
			let e;
			return t[14] !== n || t[15] !== s || t[16] !== i || t[17] !== a || t[18] !== o || t[19] !== c ? (e = /* @__PURE__ */ Y(sE, {
				applied: n,
				filter: s,
				keySource: i,
				onKeyChange: a,
				onKeyRemove: o,
				operator: c
			}), t[14] = n, t[15] = s, t[16] = i, t[17] = a, t[18] = o, t[19] = c, t[20] = e) : e = t[20], e;
		}
		default: {
			let e;
			return t[21] !== s || t[22] !== u || t[23] !== l ? (e = /* @__PURE__ */ Y(uE, {
				filter: s,
				onChange: u,
				values: l
			}), t[21] = s, t[22] = u, t[23] = l, t[24] = e) : e = t[24], e;
		}
	}
}
function hE(e) {
	return pE.test(e);
}
//#endregion
//#region lib/components/FilterRail/overlay/FilterOverlay.tsx
function gE(e) {
	let t = K(44), { filters: n, model: r, onClose: i } = e, a;
	t[0] === r.criteria ? a = t[1] : (a = (e) => r.criteria.filter((t) => t.name === e.name), t[0] = r.criteria, t[1] = a);
	let o = a, s = vE, c;
	t[2] !== o || t[3] !== n ? (c = () => yE(n, o), t[2] = o, t[3] = n, t[4] = c) : c = t[4];
	let [l, u] = J(c), d, f, p, m, h, g, _, v, y, b, x, S, C;
	if (t[5] !== o || t[6] !== n || t[7] !== r || t[8] !== i || t[9] !== l) {
		m = n.find((e) => e.name === l.name) ?? n[0], {operator: h} = l, _ = r.presentation[m.name] ?? {};
		let e = o(m), a = m.operators;
		C = e.filter((e) => s(e, m) === h);
		let { takesValue: c } = kT(m, h);
		p = C.find(_E) ?? null, y = (e, t, n) => {
			let i = Vn({
				name: m.name,
				qualifier: e,
				operator: h
			}, m), a = C.find((t) => t.qualifier === e);
			r.set(i, c && !t.length ? null : {
				...i,
				values: t,
				negated: n ?? a?.negated ?? !1
			});
		}, v = (e) => r.set(Vn({
			name: m.name,
			qualifier: e,
			operator: h
		}, m), null), f = () => C.forEach((e) => r.set(Vn(e, m), null)), d = FT(m, h, p), g = (e, t) => {
			r.set(Vn({
				name: m.name,
				operator: h
			}, m), t ? e.criterion(t) : null), i();
		}, b = "flex min-h-0", x = n.length > 1 ? /* @__PURE__ */ Y(IT, {
			title: "Criteria",
			children: /* @__PURE__ */ Y(zT, {
				"aria-label": "Criteria",
				items: n.map((e) => ({
					id: e.name,
					label: e.label,
					count: Cn(o(e))
				})),
				onSelect: (e) => {
					let t = n.find((t) => t.name === e) ?? m;
					u(yE([t], o));
				},
				selected: m.name
			})
		}) : null, S = a.length > 1 ? /* @__PURE__ */ Y(IT, {
			action: e.length ? /* @__PURE__ */ Y(wT, {
				onPress: () => {
					r.clear(m.name), i();
				},
				children: "Clear all"
			}) : null,
			title: "Operator",
			children: /* @__PURE__ */ Y(zT, {
				"aria-label": "Operator",
				items: a.map((t) => ({
					id: t.id,
					label: t.label,
					count: Cn(e.filter((e) => s(e, m) === t.id))
				})),
				onSelect: (e) => u({
					name: m.name,
					operator: e
				}),
				selected: h
			})
		}) : null, t[5] = o, t[6] = n, t[7] = r, t[8] = i, t[9] = l, t[10] = d, t[11] = f, t[12] = p, t[13] = m, t[14] = h, t[15] = g, t[16] = _, t[17] = v, t[18] = y, t[19] = b, t[20] = x, t[21] = S, t[22] = C;
	} else d = t[10], f = t[11], p = t[12], m = t[13], h = t[14], g = t[15], _ = t[16], v = t[17], y = t[18], b = t[19], x = t[20], S = t[21], C = t[22];
	let w;
	t[23] !== f || t[24] !== C.length ? (w = C.length ? /* @__PURE__ */ Y(wT, {
		onPress: f,
		children: "Clear"
	}) : null, t[23] = f, t[24] = C.length, t[25] = w) : w = t[25];
	let T;
	t[26] !== d || t[27] !== p?.values || t[28] !== m || t[29] !== h || t[30] !== g || t[31] !== _ || t[32] !== v || t[33] !== y || t[34] !== C ? (T = d ? /* @__PURE__ */ Y(qT, {
		"aria-label": `${m.label} values`,
		onPick: (e) => g(d, e),
		picked: d.picked
	}) : /* @__PURE__ */ Y(mE, {
		applied: C,
		decorate: _.decorate,
		filter: m,
		keySource: _.keySource,
		onChange: (e, t) => y(void 0, e, t),
		onKeyChange: (e, t) => y(e, t),
		onKeyRemove: v,
		operator: h,
		valueSource: _.valueSource,
		values: p?.values ?? []
	}, `${m.name}:${h}`), t[26] = d, t[27] = p?.values, t[28] = m, t[29] = h, t[30] = g, t[31] = _, t[32] = v, t[33] = y, t[34] = C, t[35] = T) : T = t[35];
	let E;
	t[36] !== w || t[37] !== T ? (E = /* @__PURE__ */ Y(IT, {
		action: w,
		title: "Value",
		children: T
	}), t[36] = w, t[37] = T, t[38] = E) : E = t[38];
	let D;
	return t[39] !== b || t[40] !== x || t[41] !== S || t[42] !== E ? (D = /* @__PURE__ */ X("div", {
		className: b,
		children: [
			x,
			S,
			E
		]
	}), t[39] = b, t[40] = x, t[41] = S, t[42] = E, t[43] = D) : D = t[43], D;
}
function _E(e) {
	return e.qualifier === void 0;
}
function vE(e, t) {
	return e.operator ?? t.defaultOperator;
}
function yE(e, t) {
	let n = e.find((e) => t(e).length) ?? e[0], [r] = t(n);
	return {
		name: n.name,
		operator: r?.operator ?? n.defaultOperator
	};
}
//#endregion
//#region lib/components/FilterRail/rail/rowClasses.ts
var bE = "h-7 w-full justify-start gap-xs rounded-xs border-none py-xxs pl-xs pr-[6px] font-medium", xE = {
	primary: {
		states: "hover:bg-background-secondary data-[focus-visible]:bg-background-secondary",
		open: "bg-background-secondary"
	},
	secondary: {
		states: "hover:bg-background-primary data-[focus-visible]:bg-background-primary",
		open: "bg-background-primary"
	}
};
//#endregion
//#region lib/components/FilterRail/rail/RowLabel.tsx
function SE(e) {
	let t = K(7), { row: n } = e, r;
	t[0] === n.icon ? r = t[1] : (r = /* @__PURE__ */ Y("span", {
		className: "flex size-[14px] shrink-0 items-center text-text-secondary",
		children: n.icon
	}), t[0] = n.icon, t[1] = r);
	let i;
	t[2] === n.label ? i = t[3] : (i = /* @__PURE__ */ Y("span", {
		className: "min-w-0 grow truncate text-left text-label-small text-text-secondary",
		children: n.label
	}), t[2] = n.label, t[3] = i);
	let a;
	return t[4] !== r || t[5] !== i ? (a = /* @__PURE__ */ X(Dr, { children: [r, i] }), t[4] = r, t[5] = i, t[6] = a) : a = t[6], a;
}
//#endregion
//#region lib/components/FilterRail/rail/outsidePress.ts
function CE(e, t) {
	let n = e.closest("[role=dialog]");
	return !t?.contains(e) && !(n && !n.contains(t));
}
//#endregion
//#region lib/components/FilterRail/rail/useOverlayState.ts
function wE() {
	let e = K(6), [t, n] = J(!1), r = Tr(null), i = Tr(null), a = !t, o;
	e[0] === Symbol.for("react.memo_cache_sentinel") ? (o = (e) => {
		CE(e.target, r.current) && n(!1);
	}, e[0] = o) : o = e[0];
	let s;
	e[1] === a ? s = e[2] : (s = {
		ref: i,
		isDisabled: a,
		onInteractOutside: o
	}, e[1] = a, e[2] = s), nr(s);
	let c;
	e[3] === Symbol.for("react.memo_cache_sentinel") ? (c = {
		ref: i,
		placement: "right top",
		isNonModal: !0,
		shouldCloseOnInteractOutside: (e) => CE(e, r.current)
	}, e[3] = c) : c = e[3];
	let l = c, u;
	return e[4] === t ? u = e[5] : (u = {
		isOpen: t,
		setOpen: n,
		triggerRef: r,
		popoverProps: l
	}, e[4] = t, e[5] = u), u;
}
//#endregion
//#region lib/components/FilterRail/rail/FilterRailRow.tsx
function TE(e) {
	let t = K(36), { row: n, model: r, surface: i } = e, a = i === void 0 ? "primary" : i, { isOpen: o, setOpen: s, triggerRef: c, popoverProps: l } = wE(), u = xr(), d = xE[a], f;
	if (t[0] !== r || t[1] !== n.filters) {
		let e;
		t[3] === r ? e = t[4] : (e = (e) => r.criteria.filter((t) => t.name === e.name).map((t) => ({
			item: t,
			filter: e
		})), t[3] = r, t[4] = e), f = n.filters.flatMap(e), t[0] = r, t[1] = n.filters, t[2] = f;
	} else f = t[2];
	let p = f, m = p.length ? u : void 0, h = n.label, g = o ? d.open : void 0, _;
	t[5] !== d.states || t[6] !== g ? (_ = W(bE, d.states, g), t[5] = d.states, t[6] = g, t[7] = _) : _ = t[7];
	let v;
	t[8] === n ? v = t[9] : (v = /* @__PURE__ */ Y(SE, { row: n }), t[8] = n, t[9] = v);
	let y;
	t[10] !== p || t[11] !== u || t[12] !== r ? (y = p.length ? /* @__PURE__ */ X(Dr, { children: [/* @__PURE__ */ Y("span", {
		className: "sr-only",
		id: u,
		children: /* @__PURE__ */ Y(OE, {
			applied: p,
			presentation: r.presentation,
			separator: "; "
		})
	}), /* @__PURE__ */ Y(qt, {
		placement: "top",
		title: /* @__PURE__ */ Y("span", {
			className: "flex flex-col",
			children: /* @__PURE__ */ Y(OE, {
				applied: p,
				presentation: r.presentation
			})
		}),
		asChild: !0,
		children: /* @__PURE__ */ Y("span", {
			className: "flex shrink-0 items-center",
			"aria-hidden": !0,
			children: /* @__PURE__ */ Y(EE, { applied: p })
		})
	})] }) : /* @__PURE__ */ Y(We, {
		className: "shrink-0 text-text-secondary",
		size: 12
	}), t[10] = p, t[11] = u, t[12] = r, t[13] = y) : y = t[13];
	let b;
	t[14] !== n.label || t[15] !== m || t[16] !== _ || t[17] !== v || t[18] !== y || t[19] !== c ? (b = /* @__PURE__ */ X(Q, {
		"aria-describedby": m,
		"aria-label": h,
		className: _,
		ref: c,
		variant: "plain",
		children: [v, y]
	}), t[14] = n.label, t[15] = m, t[16] = _, t[17] = v, t[18] = y, t[19] = c, t[20] = b) : b = t[20];
	let x = `${n.label} filter`, S;
	t[21] === s ? S = t[22] : (S = () => s(!1), t[21] = s, t[22] = S);
	let C;
	t[23] !== r || t[24] !== n.filters || t[25] !== S ? (C = /* @__PURE__ */ Y(gE, {
		filters: n.filters,
		model: r,
		onClose: S
	}), t[23] = r, t[24] = n.filters, t[25] = S, t[26] = C) : C = t[26];
	let w;
	t[27] !== l || t[28] !== x || t[29] !== C ? (w = /* @__PURE__ */ Y(Su, {
		...l,
		"aria-label": x,
		className: "flex flex-col border-neutral-200",
		dialogClassName: "flex min-h-0 flex-col",
		offset: 2,
		children: C
	}), t[27] = l, t[28] = x, t[29] = C, t[30] = w) : w = t[30];
	let T;
	return t[31] !== o || t[32] !== s || t[33] !== w || t[34] !== b ? (T = /* @__PURE__ */ X(mi, {
		isOpen: o,
		onOpenChange: s,
		children: [b, w]
	}), t[31] = o, t[32] = s, t[33] = w, t[34] = b, t[35] = T) : T = t[35], T;
}
function EE(e) {
	let t = K(6), { applied: n } = e, [r] = n;
	if (n.length === 1 && r.filter.kind === "boolean" && OT(r.item)) {
		let e;
		return t[0] === r.item ? e = t[1] : (e = /* @__PURE__ */ Y(RT, { item: r.item }), t[0] = r.item, t[1] = e), e;
	}
	let i;
	t[2] === n ? i = t[3] : (i = Cn(n.map(DE)), t[2] = n, t[3] = i);
	let a;
	return t[4] === i ? a = t[5] : (a = /* @__PURE__ */ Y(LT, { count: i }), t[4] = i, t[5] = a), a;
}
function DE(e) {
	let { item: t } = e;
	return t;
}
function OE({ applied: e, presentation: t, separator: n = null }) {
	return e.map(({ item: e, filter: r }, i) => /* @__PURE__ */ X("span", { children: [i ? n : null, /* @__PURE__ */ Y(PT, {
		filter: r,
		item: e,
		source: t[r.name]?.valueSource
	})] }, i));
}
//#endregion
//#region lib/components/FilterRail/logic/EditorContext.tsx
var kE = hr(null);
function AE() {
	let e = yr(kE);
	if (!e) throw Error("useEditor must be used under a LogicEditor");
	return e;
}
//#endregion
//#region lib/components/FilterRail/logic/scope.ts
function jE({ root: e, level: t, start: n, length: r, onWrite: i, sections: a, presentation: o }) {
	let s = Ln(e, t).terms.slice(n, n + r).filter((e) => e.kind === "criterion"), c = s, l = (a) => {
		c = a, i(Mn(e, t, n, r, a.map(In)), a.length);
	};
	return {
		sections: a,
		presentation: o,
		expression: e,
		criteria: s,
		isFiltered: s.length > 0,
		summary: [],
		set: (e, t) => l(Bn(c, e, t)),
		clear: (e) => l(c.filter((t) => t.name !== e)),
		clearAll: () => l([]),
		setExpression: (e) => i(e, r)
	};
}
//#endregion
//#region lib/components/FilterRail/logic/AddCondition.tsx
function ME(e, t) {
	let n = t.trim().toLowerCase();
	return e.map((e) => ({
		...e,
		rows: e.rows.filter((e) => e.label.toLowerCase().includes(n))
	})).filter((e) => e.rows.length);
}
function NE(e) {
	let t = K(25), { level: n } = e, { root: r, onChange: i, sections: a, presentation: o } = AE(), [s, c] = J(""), l;
	t[0] !== n || t[1] !== r ? (l = () => ({
		start: Ln(r, n).terms.length,
		length: 0
	}), t[0] = n, t[1] = r, t[2] = l) : l = t[2];
	let [u, d] = J(l), f;
	t[3] === i ? f = t[4] : (f = (e, t) => {
		i(e), d((e) => ({
			...e,
			length: t
		}));
	}, t[3] = i, t[4] = f);
	let p;
	t[5] !== u.length || t[6] !== u.start || t[7] !== n || t[8] !== o || t[9] !== r || t[10] !== a || t[11] !== f ? (p = jE({
		root: r,
		level: n,
		start: u.start,
		length: u.length,
		onWrite: f,
		sections: a,
		presentation: o
	}), t[5] = u.length, t[6] = u.start, t[7] = n, t[8] = o, t[9] = r, t[10] = a, t[11] = f, t[12] = p) : p = t[12];
	let m = p, h;
	t[13] !== s || t[14] !== a ? (h = ME(a, s), t[13] = s, t[14] = a, t[15] = h) : h = t[15];
	let g = h, _;
	t[16] === Symbol.for("react.memo_cache_sentinel") ? (_ = { placeholder: "Search filters…" }, t[16] = _) : _ = t[16];
	let v;
	t[17] === s ? v = t[18] : (v = /* @__PURE__ */ Y("div", {
		className: "px-xs",
		children: /* @__PURE__ */ Y(Wl, {
			"aria-label": "Search filters",
			className: "w-full",
			inputProps: _,
			onChange: c,
			value: s,
			autoFocus: !0
		})
	}), t[17] = s, t[18] = v);
	let y;
	t[19] !== g || t[20] !== m ? (y = /* @__PURE__ */ Y("div", {
		className: "min-h-0 overflow-y-auto",
		children: g.length ? /* @__PURE__ */ Y(TT, {
			row: (e) => /* @__PURE__ */ Y(TE, {
				model: m,
				row: e,
				surface: "secondary"
			}, e.key),
			sections: g
		}) : /* @__PURE__ */ Y("p", {
			className: "px-sm py-xxs text-label-small text-text-secondary",
			children: "No filters match"
		})
	}), t[19] = g, t[20] = m, t[21] = y) : y = t[21];
	let b;
	return t[22] !== v || t[23] !== y ? (b = /* @__PURE__ */ X("div", {
		className: "flex min-h-0 flex-col gap-xs pt-xs",
		children: [v, y]
	}), t[22] = v, t[23] = y, t[24] = b) : b = t[24], b;
}
function PE(e) {
	let t = K(23), { level: n, anchorRef: r, small: i } = e, a = i !== void 0 && i, { besideOffset: o } = AE(), { isOpen: s, setOpen: c, triggerRef: l, popoverProps: u } = wE(), [d, f] = J(0), p;
	t[0] !== r || t[1] !== o || t[2] !== c ? (p = (e) => {
		e && f(o(r.current)), c(e);
	}, t[0] = r, t[1] = o, t[2] = c, t[3] = p) : p = t[3];
	let m = p, h = a ? 12 : 16, g;
	t[4] === h ? g = t[5] : (g = /* @__PURE__ */ Y(Qe, { size: h }), t[4] = h, t[5] = g);
	let _ = a ? "h-auto self-start px-xs py-3xs text-label-extra-small font-bold" : "self-start", v = a ? "tertiary" : "secondary", y;
	t[6] !== g || t[7] !== _ || t[8] !== v || t[9] !== l ? (y = /* @__PURE__ */ Y(Q, {
		IconLeft: g,
		className: _,
		ref: l,
		variant: v,
		children: "Add Condition"
	}), t[6] = g, t[7] = _, t[8] = v, t[9] = l, t[10] = y) : y = t[10];
	let b;
	t[11] === n ? b = t[12] : (b = /* @__PURE__ */ Y(NE, { level: n }), t[11] = n, t[12] = b);
	let x;
	t[13] !== r || t[14] !== d || t[15] !== u || t[16] !== b ? (x = /* @__PURE__ */ Y(Su, {
		...u,
		"aria-label": "Add condition",
		className: "flex w-[300px] flex-col border-neutral-200 bg-background-secondary",
		dialogClassName: "flex min-h-0 flex-col",
		offset: d,
		triggerRef: r,
		children: b
	}), t[13] = r, t[14] = d, t[15] = u, t[16] = b, t[17] = x) : x = t[17];
	let S;
	return t[18] !== s || t[19] !== m || t[20] !== y || t[21] !== x ? (S = /* @__PURE__ */ X(mi, {
		isOpen: s,
		onOpenChange: m,
		children: [y, x]
	}), t[18] = s, t[19] = m, t[20] = y, t[21] = x, t[22] = S) : S = t[22], S;
}
//#endregion
//#region lib/components/FilterRail/logic/ConditionRow.tsx
var FE = 3, IE = "flex h-[30px] shrink-0 items-center gap-xxs rounded-sm border border-neutral-300 pl-sm pr-xs text-body-small font-bold text-text-primary";
function LE(e) {
	return {
		name: e,
		label: e,
		kind: "text",
		operators: [],
		defaultOperator: ""
	};
}
function RE(e) {
	let n = K(29), { parts: r, text: i, isOpen: a, isEditable: o, removeTitle: s, onPress: c, onRemove: l, ref: u } = e, d = a ? "bg-background-secondary" : void 0, f;
	n[0] === d ? f = n[1] : (f = W("relative flex h-[30px] items-center gap-xxs rounded-xs border border-neutral-300 pl-[5px] pr-xs hover:bg-background-secondary has-[[data-condition][data-focus-visible]]:bg-background-secondary", d), n[0] = d, n[1] = f);
	let p;
	n[2] === Symbol.for("react.memo_cache_sentinel") ? (p = /* @__PURE__ */ Y("span", { className: "absolute -left-px inset-y-[-1px] w-[5px] rounded-l-xs bg-neutral-300" }), n[2] = p) : p = n[2];
	let m = !o, h;
	n[3] === r.subject ? h = n[4] : (h = /* @__PURE__ */ Y("span", {
		className: "shrink-0 text-text-primary",
		children: r.subject
	}), n[3] = r.subject, n[4] = h);
	let g;
	n[5] === r.operator ? g = n[6] : (g = /* @__PURE__ */ Y("span", {
		className: "shrink-0 text-text-secondary",
		children: r.operator
	}), n[5] = r.operator, n[6] = g);
	let _;
	n[7] !== r.values[0] || n[8] !== r.values.length ? (_ = r.values.length === 1 ? /* @__PURE__ */ Y("span", {
		className: "min-w-0 truncate font-bold text-text-primary",
		children: r.values[0]
	}) : null, n[7] = r.values[0], n[8] = r.values.length, n[9] = _) : _ = n[9];
	let v;
	n[10] !== c || n[11] !== m || n[12] !== h || n[13] !== g || n[14] !== _ || n[15] !== i ? (v = /* @__PURE__ */ X(Q, {
		"aria-label": i,
		className: "h-full min-w-0 grow justify-start gap-xxs rounded-none px-xs text-body-small font-normal",
		isDisabled: m,
		onPress: c,
		variant: "plain",
		"data-condition": !0,
		children: [
			h,
			g,
			_
		]
	}), n[10] = c, n[11] = m, n[12] = h, n[13] = g, n[14] = _, n[15] = i, n[16] = v) : v = n[16];
	let y;
	n[17] === Symbol.for("react.memo_cache_sentinel") ? (y = /* @__PURE__ */ Y(t, { size: 14 }), n[17] = y) : y = n[17];
	let b;
	n[18] !== l || n[19] !== s ? (b = /* @__PURE__ */ Y(wT, {
		"aria-label": s,
		className: "size-[14px] shrink-0 p-0",
		onPress: l,
		children: y
	}), n[18] = l, n[19] = s, n[20] = b) : b = n[20];
	let x;
	n[21] !== s || n[22] !== b ? (x = /* @__PURE__ */ Y(qt, {
		placement: "right",
		title: s,
		asChild: !0,
		children: b
	}), n[21] = s, n[22] = b, n[23] = x) : x = n[23];
	let S;
	return n[24] !== u || n[25] !== x || n[26] !== f || n[27] !== v ? (S = /* @__PURE__ */ X("div", {
		className: f,
		ref: u,
		children: [
			p,
			v,
			x
		]
	}), n[24] = u, n[25] = x, n[26] = f, n[27] = v, n[28] = S) : S = n[28], S;
}
function zE(e) {
	let n = K(17), { parts: r, values: i, expanded: a, onExpand: o, onRemove: s } = e, c;
	n[0] !== a || n[1] !== i ? (c = a ? i : i.slice(0, FE), n[0] = a, n[1] = i, n[2] = c) : c = n[2];
	let l = c, u = i.length - l.length, d = `${r.subject} values`, f;
	if (n[3] !== s || n[4] !== r.values || n[5] !== l) {
		let e;
		n[7] !== s || n[8] !== r.values ? (e = (e, n) => /* @__PURE__ */ X("div", {
			className: IE,
			role: "listitem",
			children: [/* @__PURE__ */ Y("span", {
				className: "min-w-0 grow truncate",
				children: r.values[n]
			}), /* @__PURE__ */ Y(qt, {
				placement: "right",
				title: "Remove condition",
				asChild: !0,
				children: /* @__PURE__ */ Y(wT, {
					"aria-label": `Remove ${r.values[n]}`,
					className: "size-[14px] shrink-0 p-0",
					onPress: () => s(n),
					children: /* @__PURE__ */ Y(t, { size: 14 })
				})
			})]
		}, `${n}:${e}`), n[7] = s, n[8] = r.values, n[9] = e) : e = n[9], f = l.map(e), n[3] = s, n[4] = r.values, n[5] = l, n[6] = f;
	} else f = n[6];
	let p;
	n[10] !== u || n[11] !== o ? (p = u > 0 ? /* @__PURE__ */ Y("div", {
		role: "listitem",
		children: /* @__PURE__ */ X(Q, {
			className: W(IE, "w-full justify-between hover:bg-background-secondary data-[focus-visible]:bg-background-secondary"),
			onPress: o,
			variant: "plain",
			children: [/* @__PURE__ */ X("span", { children: [u, " more items"] }), /* @__PURE__ */ Y($e, {
				className: "text-text-secondary",
				size: 14
			})]
		})
	}) : null, n[10] = u, n[11] = o, n[12] = p) : p = n[12];
	let m;
	return n[13] !== d || n[14] !== f || n[15] !== p ? (m = /* @__PURE__ */ Y("div", {
		className: "pl-md",
		children: /* @__PURE__ */ X("div", {
			"aria-label": d,
			className: "flex max-h-[144px] flex-col gap-xs overflow-y-auto [scrollbar-gutter:stable] [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-neutral-300 [&::-webkit-scrollbar]:w-[6px]",
			role: "list",
			children: [f, p]
		})
	}), n[13] = d, n[14] = f, n[15] = p, n[16] = m) : m = n[16], m;
}
function BE(e) {
	let t = K(55), { path: n, item: r } = e, { root: i, onChange: a, sections: o, presentation: s, filterFor: c, besideOffset: l } = AE(), u;
	t[0] !== c || t[1] !== r.name ? (u = c(r.name), t[0] = c, t[1] = r.name, t[2] = u) : u = t[2];
	let d = u, f;
	t[3] !== d || t[4] !== r.name ? (f = d ?? LE(r.name), t[3] = d, t[4] = r.name, t[5] = f) : f = t[5];
	let p = f, m = n.slice(0, -1), h = n[n.length - 1], { isOpen: g, setOpen: _, triggerRef: v, popoverProps: y } = wE(), [b, x] = J(0), [S, C] = J(!1), w;
	t[6] === r ? w = t[7] : (w = () => /* @__PURE__ */ new Set([r]), t[6] = r, t[7] = w);
	let [T, E] = J(w);
	T.has(r) || (E(/* @__PURE__ */ new Set([r])), _(!1), C(!1)), S && r.values.length <= FE && C(!1);
	let D = Ln(i, m).terms, O = 0;
	for (; T.has(D[h + O]);) O += 1;
	let k = jE({
		root: i,
		level: m,
		start: h,
		length: O,
		onWrite: (e, t) => {
			a(e), E(new Set(Ln(e, m).terms.slice(h, h + t)));
		},
		sections: o,
		presentation: s
	}), A = r.values.length > 1 ? `Remove all ${r.values.length} conditions` : "Remove condition", j;
	t[8] !== T || t[9] !== h || t[10] !== r || t[11] !== m || t[12] !== a || t[13] !== i || t[14] !== E ? (j = (e) => {
		let t = {
			...r,
			values: r.values.filter((t, n) => n !== e)
		};
		E(new Set(Array.from(T, (e) => e === r ? t : e))), a(Mn(i, m, h, 1, [t]));
	}, t[8] = T, t[9] = h, t[10] = r, t[11] = m, t[12] = a, t[13] = i, t[14] = E, t[15] = j) : j = t[15];
	let M = j, N = s[r.name]?.valueSource, P;
	t[16] !== l || t[17] !== d || t[18] !== S || t[19] !== p || t[20] !== g || t[21] !== r || t[22] !== a || t[23] !== n || t[24] !== A || t[25] !== M || t[26] !== i || t[27] !== v || t[28] !== C || t[29] !== x || t[30] !== _ ? (P = (e) => {
		let t = jT(r, p, e);
		return /* @__PURE__ */ X(Dr, { children: [/* @__PURE__ */ Y(RE, {
			isEditable: d !== void 0,
			isOpen: g,
			onPress: () => {
				x(l(v.current)), _(VE);
			},
			onRemove: () => a(zn(i, n)),
			parts: t,
			ref: v,
			removeTitle: A,
			text: MT(r, p, e)
		}), r.values.length > 1 ? /* @__PURE__ */ Y(zE, {
			expanded: S,
			onExpand: () => C(!0),
			onRemove: M,
			parts: t,
			values: r.values
		}) : null] });
	}, t[16] = l, t[17] = d, t[18] = S, t[19] = p, t[20] = g, t[21] = r, t[22] = a, t[23] = n, t[24] = A, t[25] = M, t[26] = i, t[27] = v, t[28] = C, t[29] = x, t[30] = _, t[31] = P) : P = t[31];
	let F;
	t[32] !== r.values || t[33] !== N || t[34] !== P ? (F = /* @__PURE__ */ Y(NT, {
		source: N,
		values: r.values,
		children: P
	}), t[32] = r.values, t[33] = N, t[34] = P, t[35] = F) : F = t[35];
	let I = `${p.label} condition`, L;
	t[36] === p ? L = t[37] : (L = [p], t[36] = p, t[37] = L);
	let R;
	t[38] === _ ? R = t[39] : (R = () => _(!1), t[38] = _, t[39] = R);
	let z;
	t[40] !== k || t[41] !== R || t[42] !== L ? (z = /* @__PURE__ */ Y(gE, {
		filters: L,
		model: k,
		onClose: R
	}), t[40] = k, t[41] = R, t[42] = L, t[43] = z) : z = t[43];
	let B;
	t[44] !== g || t[45] !== b || t[46] !== y || t[47] !== v || t[48] !== _ || t[49] !== z || t[50] !== I ? (B = /* @__PURE__ */ Y(Su, {
		...y,
		"aria-label": I,
		className: "flex flex-col border-neutral-200",
		dialogClassName: "flex min-h-0 flex-col",
		isOpen: g,
		offset: b,
		onOpenChange: _,
		triggerRef: v,
		children: z
	}), t[44] = g, t[45] = b, t[46] = y, t[47] = v, t[48] = _, t[49] = z, t[50] = I, t[51] = B) : B = t[51];
	let V;
	return t[52] !== B || t[53] !== F ? (V = /* @__PURE__ */ X("div", {
		className: "flex flex-col gap-xs",
		children: [F, B]
	}), t[52] = B, t[53] = F, t[54] = V) : V = t[54], V;
}
function VE(e) {
	return !e;
}
//#endregion
//#region lib/components/FilterRail/logic/ModePill.tsx
var HE = Object.keys(Rn).map((e) => ({
	id: e,
	name: Rn[e]
}));
function UE(e) {
	let t = K(11), { mode: n, isDraft: r, name: i, onChange: a } = e, o;
	t[0] !== r || t[1] !== n ? (o = r ? [] : HE.filter((e) => e.id === n), t[0] = r, t[1] = n, t[2] = o) : o = t[2];
	let s = o, c;
	t[3] === a ? c = t[4] : (c = (e) => a(e.id), t[3] = a, t[4] = c);
	let l;
	t[5] !== s || t[6] !== c ? (l = {
		items: s,
		append: c
	}, t[5] = s, t[6] = c, t[7] = l) : l = t[7];
	let u;
	return t[8] !== i || t[9] !== l ? (u = /* @__PURE__ */ Y(Ab, {
		"aria-label": i,
		className: "w-[65px] shrink-0",
		isClearable: !1,
		isSearchable: !1,
		items: HE,
		placeholder: "Select",
		selectedItems: l,
		selectionMode: "single",
		size: "xs"
	}), t[8] = i, t[9] = l, t[10] = u) : u = t[10], u;
}
//#endregion
//#region lib/components/FilterRail/logic/Level.tsx
function WE(e) {
	let n = K(14), { mode: r, isDraft: i, pillName: a, onModeChange: o, onRemove: s, removeTitle: c } = e, l;
	n[0] !== i || n[1] !== r || n[2] !== o || n[3] !== a ? (l = /* @__PURE__ */ Y(UE, {
		isDraft: i,
		mode: r,
		name: a,
		onChange: o
	}), n[0] = i, n[1] = r, n[2] = o, n[3] = a, n[4] = l) : l = n[4];
	let u;
	n[5] === Symbol.for("react.memo_cache_sentinel") ? (u = /* @__PURE__ */ Y("span", {
		className: "text-body-small text-text-secondary",
		children: "are true"
	}), n[5] = u) : u = n[5];
	let d;
	n[6] === l ? d = n[7] : (d = /* @__PURE__ */ X("div", {
		className: "flex items-center gap-xs",
		children: [l, u]
	}), n[6] = l, n[7] = d);
	let f;
	n[8] !== s || n[9] !== c ? (f = s ? /* @__PURE__ */ Y(qt, {
		placement: "right",
		title: c,
		asChild: !0,
		children: /* @__PURE__ */ Y(wT, {
			"aria-label": c,
			className: "size-[14px] p-0",
			onPress: s,
			children: /* @__PURE__ */ Y(t, { size: 14 })
		})
	}) : null, n[8] = s, n[9] = c, n[10] = f) : f = n[10];
	let p;
	return n[11] !== d || n[12] !== f ? (p = /* @__PURE__ */ X("div", {
		className: "flex h-7 items-center justify-between pr-xs",
		children: [d, f]
	}), n[11] = d, n[12] = f, n[13] = p) : p = n[13], p;
}
function GE() {
	let e = K(1), t;
	return e[0] === Symbol.for("react.memo_cache_sentinel") ? (t = /* @__PURE__ */ X("div", {
		className: "flex flex-col items-center gap-xs rounded-sm border border-dashed border-neutral-300 px-lg py-xl text-center text-body-small",
		children: [
			/* @__PURE__ */ Y(re, {
				className: "text-neutral-400",
				size: 24
			}),
			/* @__PURE__ */ Y("p", {
				className: "font-bold text-text-primary",
				children: "No conditions yet"
			}),
			/* @__PURE__ */ Y("p", {
				className: "text-text-secondary",
				children: "Add a condition, or pick filters in the Filters view — they appear here joined by AND."
			})
		]
	}), e[0] = t) : t = e[0], t;
}
function KE(e) {
	let t = K(65), { path: n, level: r, isRoot: i } = e, a = i !== void 0 && i, { root: o, onChange: s, drafts: c } = AE(), l = Tr(null), u;
	t[0] !== c || t[1] !== r ? (u = c.has(r), t[0] = c, t[1] = r, t[2] = u) : u = t[2];
	let d = u, f;
	t[3] === r ? f = t[4] : (f = Tn(r), t[3] = r, t[4] = f);
	let p = f, m, h, g, _, v, y, b, x, S;
	if (t[5] !== d || t[6] !== a || t[7] !== r || t[8] !== p || t[9] !== s || t[10] !== n || t[11] !== o) {
		let { criteria: e, groups: i } = jn(r), c = a ? `${Rn[p]} conditions` : d ? "New group" : `${Rn[p]} group`, u;
		t[21] !== a || t[22] !== s || t[23] !== n || t[24] !== o ? (u = a ? () => s(wn()) : () => s(zn(o, n)), t[21] = a, t[22] = s, t[23] = n, t[24] = o, t[25] = u) : u = t[25];
		let f = u, C = !a || An(r).length > 0;
		x = c;
		let w = a ? void 0 : "pt-xxs";
		t[26] === w ? S = t[27] : (S = W("flex flex-col gap-xs", w), t[26] = w, t[27] = S), m = l, h = "group";
		let T;
		t[28] !== a || t[29] !== s || t[30] !== n || t[31] !== o ? (T = (e) => s(a ? Fn(o, e) : Dn(o, n, e)), t[28] = a, t[29] = s, t[30] = n, t[31] = o, t[32] = T) : T = t[32];
		let E = C ? f : null, D = a ? "Conditions mode" : "Group mode", O = a ? "Clear all filters" : "Remove group";
		t[33] !== d || t[34] !== p || t[35] !== T || t[36] !== E || t[37] !== D || t[38] !== O ? (g = /* @__PURE__ */ Y(WE, {
			isDraft: d,
			mode: p,
			onModeChange: T,
			onRemove: E,
			pillName: D,
			removeTitle: O
		}), t[33] = d, t[34] = p, t[35] = T, t[36] = E, t[37] = D, t[38] = O, t[39] = g) : g = t[39], b = "pl-md";
		let k = p === "none" ? "border-data-viz-bright-red" : a ? "border-neutral-300" : "border-neutral-700";
		t[40] === k ? _ = t[41] : (_ = W("flex flex-col gap-xs border-l-2 pl-md", k), t[40] = k, t[41] = _);
		let A;
		t[42] === n ? A = t[43] : (A = (e) => {
			let { index: t, term: r } = e;
			return /* @__PURE__ */ Y(BE, {
				item: r,
				path: [...n, t]
			}, t);
		}, t[42] = n, t[43] = A), v = e.map(A);
		let j;
		t[44] === n ? j = t[45] : (j = (e) => {
			let { index: t, term: r } = e;
			return /* @__PURE__ */ Y(KE, {
				level: r,
				path: [...n, t]
			}, t);
		}, t[44] = n, t[45] = j), y = i.map(j), t[5] = d, t[6] = a, t[7] = r, t[8] = p, t[9] = s, t[10] = n, t[11] = o, t[12] = m, t[13] = h, t[14] = g, t[15] = _, t[16] = v, t[17] = y, t[18] = b, t[19] = x, t[20] = S;
	} else m = t[12], h = t[13], g = t[14], _ = t[15], v = t[16], y = t[17], b = t[18], x = t[19], S = t[20];
	let C;
	t[46] !== a || t[47] !== r || t[48] !== n ? (C = a ? r.terms.length ? null : /* @__PURE__ */ Y(GE, {}) : /* @__PURE__ */ Y(PE, {
		anchorRef: l,
		level: n,
		small: !0
	}), t[46] = a, t[47] = r, t[48] = n, t[49] = C) : C = t[49];
	let w;
	t[50] !== C || t[51] !== _ || t[52] !== v || t[53] !== y ? (w = /* @__PURE__ */ X("div", {
		className: _,
		children: [
			v,
			y,
			C
		]
	}), t[50] = C, t[51] = _, t[52] = v, t[53] = y, t[54] = w) : w = t[54];
	let T;
	t[55] !== w || t[56] !== b ? (T = /* @__PURE__ */ Y("div", {
		className: b,
		children: w
	}), t[55] = w, t[56] = b, t[57] = T) : T = t[57];
	let E;
	return t[58] !== m || t[59] !== h || t[60] !== g || t[61] !== T || t[62] !== x || t[63] !== S ? (E = /* @__PURE__ */ X("div", {
		"aria-label": x,
		className: S,
		ref: m,
		role: h,
		children: [g, T]
	}), t[58] = m, t[59] = h, t[60] = g, t[61] = T, t[62] = x, t[63] = S, t[64] = E) : E = t[64], E;
}
//#endregion
//#region lib/components/FilterRail/logic/LogicEditor.tsx
var qE = {}, JE = 2;
function YE(e) {
	let t = K(40), { expression: n, onChange: r, sections: i, presentation: a, className: o } = e, s = a === void 0 ? qE : a, c = Tr(null), [l, u] = J($E), d;
	t[0] === n ? d = t[1] : (d = () => ({
		expression: n,
		tree: On(n)
	}), t[0] = n, t[1] = d);
	let [f, p] = J(d);
	f.expression !== n && p({
		expression: n,
		tree: On(n)
	});
	let m = f.tree, h;
	t[2] === m ? h = t[3] : (h = En(m), t[2] = m, t[3] = h);
	let g = h, _;
	t[4] === i ? _ = t[5] : (_ = new Map(i.flatMap(ZE).map(XE)), t[4] = i, t[5] = _);
	let v = _, y;
	t[6] === v ? y = t[7] : (y = (e) => v.get(e), t[6] = v, t[7] = y);
	let b;
	t[8] === Symbol.for("react.memo_cache_sentinel") ? (b = (e) => {
		let t = c.current?.getBoundingClientRect().right, n = e?.getBoundingClientRect().right;
		return t === void 0 || n === void 0 ? JE : t - n + JE;
	}, t[8] = b) : b = t[8];
	let x;
	t[9] !== l || t[10] !== r || t[11] !== s || t[12] !== i || t[13] !== y || t[14] !== m ? (x = {
		root: m,
		onChange: r,
		sections: i,
		presentation: s,
		filterFor: y,
		besideOffset: b,
		drafts: l
	}, t[9] = l, t[10] = r, t[11] = s, t[12] = i, t[13] = y, t[14] = m, t[15] = x) : x = t[15];
	let S = x, C;
	t[16] !== r || t[17] !== g.level || t[18] !== g.path || t[19] !== m ? (C = () => {
		let e = {
			kind: "group",
			connective: "and",
			negated: !1,
			terms: []
		};
		u((t) => {
			let n = [...t].filter((e) => g.level.terms.includes(e));
			return /* @__PURE__ */ new Set([...n, e]);
		}), r(Nn(m, g.path, e));
	}, t[16] = r, t[17] = g.level, t[18] = g.path, t[19] = m, t[20] = C) : C = t[20];
	let w = C, T;
	t[21] !== g.level || t[22] !== g.path ? (T = /* @__PURE__ */ Y(KE, {
		level: g.level,
		path: g.path,
		isRoot: !0
	}), t[21] = g.level, t[22] = g.path, t[23] = T) : T = t[23];
	let E;
	t[24] === g.path ? E = t[25] : (E = /* @__PURE__ */ Y(PE, {
		anchorRef: c,
		level: g.path
	}), t[24] = g.path, t[25] = E);
	let D;
	t[26] === w ? D = t[27] : (D = /* @__PURE__ */ Y(Q, {
		onPress: w,
		variant: "tertiary",
		children: "Add Group"
	}), t[26] = w, t[27] = D);
	let O;
	t[28] !== E || t[29] !== D ? (O = /* @__PURE__ */ X("div", {
		className: "flex items-center gap-xxs pt-3xs",
		children: [E, D]
	}), t[28] = E, t[29] = D, t[30] = O) : O = t[30];
	let k;
	t[31] !== O || t[32] !== T ? (k = /* @__PURE__ */ X("div", {
		className: "flex flex-col gap-lg px-md py-lg",
		children: [T, O]
	}), t[31] = O, t[32] = T, t[33] = k) : k = t[33];
	let A;
	t[34] !== o || t[35] !== k ? (A = /* @__PURE__ */ Y("div", {
		className: o,
		ref: c,
		children: k
	}), t[34] = o, t[35] = k, t[36] = A) : A = t[36];
	let j;
	return t[37] !== A || t[38] !== S ? (j = /* @__PURE__ */ Y(kE, {
		value: S,
		children: A
	}), t[37] = A, t[38] = S, t[39] = j) : j = t[39], j;
}
function XE(e) {
	return [e.name, e];
}
function ZE(e) {
	return e.rows.flatMap(QE);
}
function QE(e) {
	return e.filters;
}
function $E() {
	return /* @__PURE__ */ new Set();
}
//#endregion
//#region lib/components/FilterRail/rail/Banner.tsx
function eD(e) {
	let t = K(23), { tone: n, icon: r, children: i, actions: a, className: o } = e, s;
	t[0] === o ? s = t[1] : (s = W("p-xs", o), t[0] = o, t[1] = s);
	let c = n === "info" ? "border-informative-200 bg-informative-50" : "border-warning-200 bg-warning-50", l;
	t[2] === c ? l = t[3] : (l = W("flex gap-xs rounded-sm border p-sm text-body-small text-text-primary", c), t[2] = c, t[3] = l);
	let u = n === "info" ? "text-informative-600" : "text-warning-500", d;
	t[4] === u ? d = t[5] : (d = W("flex size-[16px] shrink-0 items-center", u), t[4] = u, t[5] = d);
	let f;
	t[6] !== r || t[7] !== d ? (f = /* @__PURE__ */ Y("span", {
		className: d,
		children: r
	}), t[6] = r, t[7] = d, t[8] = f) : f = t[8];
	let p;
	t[9] === i ? p = t[10] : (p = /* @__PURE__ */ Y("p", { children: i }), t[9] = i, t[10] = p);
	let m;
	t[11] === a ? m = t[12] : (m = a ? /* @__PURE__ */ Y("div", {
		className: "flex gap-sm",
		children: a
	}) : null, t[11] = a, t[12] = m);
	let h;
	t[13] !== p || t[14] !== m ? (h = /* @__PURE__ */ X("div", {
		className: "flex min-w-0 grow flex-col gap-xxs",
		children: [p, m]
	}), t[13] = p, t[14] = m, t[15] = h) : h = t[15];
	let g;
	t[16] !== l || t[17] !== f || t[18] !== h ? (g = /* @__PURE__ */ X("div", {
		className: l,
		role: "status",
		children: [f, h]
	}), t[16] = l, t[17] = f, t[18] = h, t[19] = g) : g = t[19];
	let _;
	return t[20] !== s || t[21] !== g ? (_ = /* @__PURE__ */ Y("div", {
		className: s,
		children: g
	}), t[20] = s, t[21] = g, t[22] = _) : _ = t[22], _;
}
function tD(e) {
	let t = K(8), n, r;
	t[0] === e ? (n = t[1], r = t[2]) : ({className: n, ...r} = e, t[0] = e, t[1] = n, t[2] = r);
	let i;
	t[3] === n ? i = t[4] : (i = W("h-auto p-0 text-body-small font-normal hover:underline data-[focus-visible]:underline", n), t[3] = n, t[4] = i);
	let a;
	return t[5] !== r || t[6] !== i ? (a = /* @__PURE__ */ Y(Q, {
		...r,
		className: i,
		variant: "plain"
	}), t[5] = r, t[6] = i, t[7] = a) : a = t[7], a;
}
//#endregion
//#region lib/components/FilterRail/criteria/summary.ts
var nD = {
	and: "AND",
	or: "OR",
	not: "NOT",
	open: "(",
	close: ")"
};
function rD(e, t) {
	return t > 0 && e[t].kind !== "close" && e[t - 1].kind !== "open";
}
//#endregion
//#region lib/components/FilterRail/rail/Summary.tsx
var iD = {
	and: "font-bold text-informative-300",
	or: "font-bold text-stacklet-orange-300",
	not: "font-bold text-negative-300",
	open: void 0,
	close: void 0
};
function aD(e) {
	let t = K(8), { model: n } = e, r;
	t[0] === n.sections ? r = t[1] : (r = new Map(n.sections.flatMap(sD).map(oD)), t[0] = n.sections, t[1] = r);
	let i = r, a;
	t[2] !== i || t[3] !== n.presentation || t[4] !== n.summary ? (a = n.summary.map((e, t) => {
		let r = rD(n.summary, t) ? " " : "";
		if (e.kind === "criterion") {
			let a = i.get(e.item.name);
			return /* @__PURE__ */ X(fr, { children: [r, a ? /* @__PURE__ */ Y(PT, {
				filter: a,
				item: e.item,
				source: n.presentation[a.name]?.valueSource
			}) : e.item.name] }, t);
		}
		return /* @__PURE__ */ X(fr, { children: [r, /* @__PURE__ */ Y("span", {
			className: iD[e.kind],
			children: nD[e.kind]
		})] }, t);
	}), t[2] = i, t[3] = n.presentation, t[4] = n.summary, t[5] = a) : a = t[5];
	let o;
	return t[6] === a ? o = t[7] : (o = /* @__PURE__ */ Y("span", { children: a }), t[6] = a, t[7] = o), o;
}
function oD(e) {
	return [e.name, e];
}
function sD(e) {
	return e.rows.flatMap(cD);
}
function cD(e) {
	return e.filters;
}
//#endregion
//#region lib/components/FilterRail/rail/useHasChanged.ts
function lD(e) {
	let [t] = J(e), [n, r] = J(!1);
	return !n && e !== t && r(!0), n;
}
//#endregion
//#region lib/components/FilterRail/rail/ViewToggle.tsx
function uD(e) {
	let t = K(9), { view: n, onChange: r } = e, i;
	t[0] === r ? i = t[1] : (i = (e) => {
		let [t] = [...e];
		(t === "filters" || t === "logic") && r(t);
	}, t[0] = r, t[1] = i);
	let a;
	t[2] === n ? a = t[3] : (a = [n], t[2] = n, t[3] = a);
	let o, s;
	t[4] === Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ Y(vS, {
		id: "filters",
		children: "Filters"
	}), s = /* @__PURE__ */ Y(vS, {
		id: "logic",
		children: "Logic"
	}), t[4] = o, t[5] = s) : (o = t[4], s = t[5]);
	let c;
	return t[6] !== i || t[7] !== a ? (c = /* @__PURE__ */ X(gS, {
		"aria-label": "View",
		className: "border border-overlay-medium bg-background-primary",
		onSelectionChange: i,
		selectedKeys: a,
		selectionMode: "single",
		disallowEmptySelection: !0,
		children: [o, s]
	}), t[6] = i, t[7] = a, t[8] = c) : c = t[8], c;
}
//#endregion
//#region lib/components/FilterRail/FilterRail.tsx
function dD(e) {
	let t = K(50), { model: n, collapsed: r, onCollapsedChange: i, view: a, onViewChange: o, logicHintDismissed: s, onLogicHintDismiss: c, className: l } = e, u = r !== void 0 && r, d = Tr(null), f = lD(u), [p, m] = J(!1), h, g;
	if (t[0] !== n.expression || t[1] !== n.sections) {
		let e = new Map(n.sections.flatMap(pD).map(fD));
		h = (t) => e.get(t), g = Pn(n.expression, h), t[0] = n.expression, t[1] = n.sections, t[2] = h, t[3] = g;
	} else h = t[2], g = t[3];
	let _ = g ? a : "logic", v;
	t[4] !== n || t[5] !== o || t[6] !== a ? (v = (e) => {
		a !== "logic" && o("logic"), n.setExpression(e);
	}, t[4] = n, t[5] = o, t[6] = a, t[7] = v) : v = t[7];
	let y = v;
	if (u) return null;
	let b;
	t[8] !== h || t[9] !== n || t[10] !== o ? (b = (e) => {
		if (e === "filters") {
			let e = kn(n.expression);
			if (!Pn(e, h)) {
				m(!0);
				return;
			}
			e !== n.expression && n.setExpression(e);
		}
		m(!1), o(e);
	}, t[8] = h, t[9] = n, t[10] = o, t[11] = b) : b = t[11];
	let x = b, S;
	t[12] !== n || t[13] !== o ? (S = () => {
		n.clearAll(), m(!1), o("filters");
	}, t[12] = n, t[13] = o, t[14] = S) : S = t[14];
	let C = S, w;
	t[15] === l ? w = t[16] : (w = W("flex shrink-0 pr-xl", l), t[15] = l, t[16] = w);
	let T;
	t[17] === i ? T = t[18] : (T = () => i?.(!0), t[17] = i, t[18] = T);
	let E;
	t[19] === Symbol.for("react.memo_cache_sentinel") ? (E = /* @__PURE__ */ Y(pn, { size: 20 }), t[19] = E) : E = t[19];
	let D;
	t[20] !== T || t[21] !== f ? (D = /* @__PURE__ */ Y(qt, {
		placement: "bottom",
		title: "Collapse the filters",
		asChild: !0,
		children: /* @__PURE__ */ Y(Q, {
			"aria-label": "Hide filters",
			autoFocus: f,
			className: "px-xxs text-text-primary",
			onPress: T,
			ref: d,
			variant: "tertiary",
			children: E
		})
	}), t[20] = T, t[21] = f, t[22] = D) : D = t[22];
	let O;
	t[23] !== x || t[24] !== _ ? (O = /* @__PURE__ */ Y(uD, {
		onChange: x,
		view: _
	}), t[23] = x, t[24] = _, t[25] = O) : O = t[25];
	let k;
	t[26] !== O || t[27] !== D ? (k = /* @__PURE__ */ X("div", {
		className: "flex h-12 shrink-0 items-center justify-between rounded-t-1 border-b border-neutral-200 bg-background-secondary pl-sm pr-sm",
		children: [D, O]
	}), t[26] = O, t[27] = D, t[28] = k) : k = t[28];
	let A;
	t[29] !== p || t[30] !== s || t[31] !== c || t[32] !== C || t[33] !== _ ? (A = _ === "filters" ? s ? null : /* @__PURE__ */ Y(eD, {
		actions: /* @__PURE__ */ Y(tD, {
			className: "text-text-informative",
			onPress: c,
			children: "Dismiss"
		}),
		icon: /* @__PURE__ */ Y(pn, { size: 16 }),
		tone: "info",
		children: "All filters conditions must match. For complex filters use the Logic editor"
	}) : p ? /* @__PURE__ */ Y(eD, {
		actions: /* @__PURE__ */ X(Dr, { children: [/* @__PURE__ */ Y(tD, {
			className: "text-text-secondary",
			onPress: () => m(!1),
			children: "Cancel"
		}), /* @__PURE__ */ Y(tD, {
			className: "text-text-brand",
			onPress: C,
			children: "OK"
		})] }),
		className: "pb-0",
		icon: /* @__PURE__ */ Y(j, { size: 16 }),
		tone: "warning",
		children: "Reset all conditions and switch back to filters view?"
	}) : null, t[29] = p, t[30] = s, t[31] = c, t[32] = C, t[33] = _, t[34] = A) : A = t[34];
	let M;
	t[35] !== y || t[36] !== n || t[37] !== _ ? (M = /* @__PURE__ */ Y("div", {
		className: "min-h-0 grow overflow-y-auto",
		children: _ === "filters" ? /* @__PURE__ */ Y(TT, {
			row: (e) => /* @__PURE__ */ Y(TE, {
				model: n,
				row: e
			}, e.key),
			sections: n.sections
		}) : /* @__PURE__ */ Y(YE, {
			expression: n.expression,
			onChange: y,
			presentation: n.presentation,
			sections: n.sections
		})
	}), t[35] = y, t[36] = n, t[37] = _, t[38] = M) : M = t[38];
	let N;
	t[39] !== n || t[40] !== _ ? (N = n.isFiltered && _ === "filters" ? /* @__PURE__ */ X("div", {
		className: "flex shrink-0 items-center justify-between border-t border-neutral-200 px-sm py-xxs",
		children: [/* @__PURE__ */ Y(wT, {
			onPress: () => {
				n.clearAll(), d.current?.focus();
			},
			children: "Clear all"
		}), /* @__PURE__ */ Y(qt, {
			buttonProps: {
				"aria-label": "Filters summary",
				className: "text-label-extra-small text-text-secondary hover:text-text-primary"
			},
			className: "max-w-[440px]",
			placement: "top",
			title: /* @__PURE__ */ Y(aD, { model: n }),
			children: "Filters summary"
		})]
	}) : null, t[39] = n, t[40] = _, t[41] = N) : N = t[41];
	let P;
	t[42] !== k || t[43] !== A || t[44] !== M || t[45] !== N ? (P = /* @__PURE__ */ X("aside", {
		"aria-label": "Filters",
		className: "flex w-[300px] flex-col rounded-1 border border-neutral-200 bg-background-primary",
		children: [
			k,
			A,
			M,
			N
		]
	}), t[42] = k, t[43] = A, t[44] = M, t[45] = N, t[46] = P) : P = t[46];
	let F;
	return t[47] !== P || t[48] !== w ? (F = /* @__PURE__ */ Y("div", {
		className: w,
		children: P
	}), t[47] = P, t[48] = w, t[49] = F) : F = t[49], F;
}
function fD(e) {
	return [e.name, e];
}
function pD(e) {
	return e.rows.flatMap(mD);
}
function mD(e) {
	return e.filters;
}
//#endregion
//#region lib/components/FilterRail/FilterRailToggle.tsx
function hD(e) {
	let t = K(17), { model: n, collapsed: r, onCollapsedChange: i, className: a } = e, o = lD(r);
	if (!r) return null;
	let s;
	t[0] === n.criteria ? s = t[1] : (s = Cn(n.criteria), t[0] = n.criteria, t[1] = s);
	let c = s, l = c ? `Show filters, ${c} applied` : "Show filters", u;
	t[2] === a ? u = t[3] : (u = W("px-xxs", a), t[2] = a, t[3] = u);
	let d;
	t[4] === i ? d = t[5] : (d = () => i(!1), t[4] = i, t[5] = d);
	let f;
	t[6] === Symbol.for("react.memo_cache_sentinel") ? (f = /* @__PURE__ */ Y(pn, { size: 20 }), t[6] = f) : f = t[6];
	let p;
	t[7] === c ? p = t[8] : (p = c ? /* @__PURE__ */ Y("span", {
		className: "absolute -right-[6px] -top-[6px] flex",
		children: /* @__PURE__ */ Y(LT, { count: c })
	}) : null, t[7] = c, t[8] = p);
	let m;
	t[9] === p ? m = t[10] : (m = /* @__PURE__ */ X("span", {
		className: "relative flex",
		children: [f, p]
	}), t[9] = p, t[10] = m);
	let h;
	return t[11] !== o || t[12] !== l || t[13] !== u || t[14] !== d || t[15] !== m ? (h = /* @__PURE__ */ Y(Q, {
		"aria-label": l,
		autoFocus: o,
		className: u,
		onPress: d,
		variant: "tertiary",
		children: m
	}), t[11] = o, t[12] = l, t[13] = u, t[14] = d, t[15] = m, t[16] = h) : h = t[16], h;
}
//#endregion
//#region lib/components/Autocomplete/Autocomplete.tsx
function gD(e) {
	return /* @__PURE__ */ Y(Ab.Tag, { children: e.name });
}
function _D(e) {
	let t = K(34), n, r, i, a, o, s;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4], o = t[5], s = t[6]) : ({value: r, defaultValue: i, onChange: a, multiple: o, tag: s, ...n} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a, t[5] = o, t[6] = s);
	let c = o !== void 0 && o, l;
	t[7] === i ? l = t[8] : (l = () => i === void 0 ? [] : Array.isArray(i) ? i : [i], t[7] = i, t[8] = l);
	let [u, d] = J(l), f;
	bb0: {
		if (r !== void 0) {
			let e;
			t[9] === r ? e = t[10] : (e = Array.isArray(r) ? r : [r], t[9] = r, t[10] = e), f = e;
			break bb0;
		}
		f = u;
	}
	let p = f, m;
	t[11] !== c || t[12] !== a ? (m = (e) => {
		d(e), a?.(c ? e : e.length > 0 ? e[0] : null);
	}, t[11] = c, t[12] = a, t[13] = m) : m = t[13];
	let h = m, g, _;
	t[14] !== h || t[15] !== c || t[16] !== p ? (g = (e) => {
		let t = c ? [...p.filter((t) => t.id !== e.id), e] : [e];
		h(t);
	}, _ = (e) => {
		if (!c) {
			h(e.slice(-1));
			return;
		}
		let t = new Set(p.map(vD)), n = e.filter((e) => !t.has(String(e.id)));
		h([...p, ...n]);
	}, t[14] = h, t[15] = c, t[16] = p, t[17] = g, t[18] = _) : (g = t[17], _ = t[18]);
	let v;
	t[19] !== h || t[20] !== p ? (v = (...e) => {
		let t = new Set(e.map(String)), n = p.filter((e) => !t.has(String(e.id)));
		h(n);
	}, t[19] = h, t[20] = p, t[21] = v) : v = t[21];
	let y;
	t[22] !== p || t[23] !== g || t[24] !== _ || t[25] !== v ? (y = {
		items: p,
		append: g,
		appendMany: _,
		remove: v
	}, t[22] = p, t[23] = g, t[24] = _, t[25] = v, t[26] = y) : y = t[26];
	let b = y;
	if (c) {
		let e = s ?? gD, r;
		return t[27] !== n || t[28] !== b || t[29] !== e ? (r = /* @__PURE__ */ Y(Ab, {
			...n,
			selectedItems: b,
			selectionMode: "multiple",
			tag: e
		}), t[27] = n, t[28] = b, t[29] = e, t[30] = r) : r = t[30], r;
	}
	let x;
	return t[31] !== n || t[32] !== b ? (x = /* @__PURE__ */ Y(Ab, {
		...n,
		selectedItems: b,
		selectionMode: "single"
	}), t[31] = n, t[32] = b, t[33] = x) : x = t[33], x;
}
function vD(e) {
	return String(e.id);
}
_D.Tag = Ab.Tag, _D.Option = Ab.Option;
//#endregion
//#region lib/components/SteppedMultiColumnDropdown/columns/CheckboxColumn/CheckboxColumn.tsx
function yD(e) {
	let t = K(26), { column: n, onSelect: r, selectedValue: i, onSearch: a, searchTerm: o } = e, s = o === void 0 ? "" : o, [c, l] = J(i || ""), u;
	t[0] === c ? u = t[1] : (u = c ? c.split(",") : [], t[0] = c, t[1] = u);
	let d = u, f;
	bb0: {
		if (!s) {
			f = n.items;
			break bb0;
		}
		let e;
		if (t[2] !== n.items || t[3] !== s) {
			let r = s.toLowerCase();
			e = n.items.filter((e) => e.name.toLowerCase().includes(r)), t[2] = n.items, t[3] = s, t[4] = e;
		} else e = t[4];
		f = e;
	}
	let p = f, m;
	t[5] === r ? m = t[6] : (m = (e) => {
		if (e === "all") return;
		let t = Array.from(e);
		l(t.join(",")), t.length > 0 && r(t.join(","));
	}, t[5] = r, t[6] = m);
	let h = m, g;
	t[7] === a ? g = t[8] : (g = (e) => {
		a?.(e);
	}, t[7] = a, t[8] = g);
	let _ = g, v = `${n.title} search`, y;
	t[9] === n.placeholder ? y = t[10] : (y = {
		placeholder: n.placeholder,
		className: "h-[1.625rem] text-body-small"
	}, t[9] = n.placeholder, t[10] = y);
	let b;
	t[11] !== _ || t[12] !== s || t[13] !== v || t[14] !== y ? (b = /* @__PURE__ */ Y(Zx, {
		"aria-label": v,
		className: "w-full gap-0 px-2 py-1",
		inputProps: y,
		onChange: _,
		value: s
	}), t[11] = _, t[12] = s, t[13] = v, t[14] = y, t[15] = b) : b = t[15];
	let x = `${n.title} options`, S;
	t[16] === p ? S = t[17] : (S = p.map(bD), t[16] = p, t[17] = S);
	let C;
	t[18] !== h || t[19] !== d || t[20] !== S || t[21] !== x ? (C = /* @__PURE__ */ Y(Ti, {
		"aria-label": x,
		onSelectionChange: h,
		selectedKeys: d,
		selectionMode: "multiple",
		children: S
	}), t[18] = h, t[19] = d, t[20] = S, t[21] = x, t[22] = C) : C = t[22];
	let w;
	return t[23] !== C || t[24] !== b ? (w = /* @__PURE__ */ X(Dr, { children: [b, C] }), t[23] = C, t[24] = b, t[25] = w) : w = t[25], w;
}
function bD(e) {
	return /* @__PURE__ */ Y(Ei, {
		className: xD,
		id: e.id,
		textValue: e.name,
		children: (t) => {
			let { isSelected: n, isHovered: r, isFocusVisible: i } = t;
			return /* @__PURE__ */ X(Dr, { children: [/* @__PURE__ */ Y(bl, {
				isFocused: i,
				isHovered: r,
				isSelected: n
			}), /* @__PURE__ */ Y("div", {
				className: "overflow-hidden text-ellipsis whitespace-nowrap",
				children: e.name
			})] });
		}
	}, e.id);
}
function xD(e) {
	let { isHovered: t, isFocusVisible: n, isSelected: r } = e;
	return W("flex cursor-pointer gap-2 border-r px-lg py-xs text-body-small focus:outline-none", t || n || r ? "border-outline-brand bg-overlay-brand" : "border-overlay-medium");
}
//#endregion
//#region lib/components/SteppedMultiColumnDropdown/columns/EnterValueColumn/EnterValueColumn.tsx
function SD(e) {
	let t = K(11), { column: n, onSelect: r, selectedValue: i } = e, [a, o] = J(i || ""), [s, c] = J(""), l;
	t[0] !== a || t[1] !== r ? (l = (e) => {
		if (e.key === "Enter") {
			e.preventDefault();
			let t = a.trim();
			t ? (c(""), r(t)) : c("Please enter a value");
		}
	}, t[0] = a, t[1] = r, t[2] = l) : l = t[2];
	let u = l, d;
	t[3] !== n.placeholder || t[4] !== u ? (d = {
		placeholder: n.placeholder,
		onKeyDown: u,
		className: "h-[1.625rem] text-body-small"
	}, t[3] = n.placeholder, t[4] = u, t[5] = d) : d = t[5];
	let f = !!s, p;
	return t[6] !== s || t[7] !== a || t[8] !== d || t[9] !== f ? (p = /* @__PURE__ */ Y(Zx, {
		assistiveText: s,
		className: "w-full gap-0 px-2 py-1",
		inputProps: d,
		isInvalid: f,
		onChange: o,
		value: a
	}), t[6] = s, t[7] = a, t[8] = d, t[9] = f, t[10] = p) : p = t[10], p;
}
//#endregion
//#region lib/components/SteppedMultiColumnDropdown/columns/CustomListItem.tsx
function CD(e) {
	let t = K(14), n, r, i, a;
	t[0] === e ? (n = t[1], r = t[2], i = t[3], a = t[4]) : ({children: n, className: r, allowWrap: a, ...i} = e, t[0] = e, t[1] = n, t[2] = r, t[3] = i, t[4] = a);
	let o = a !== void 0 && a, s;
	t[5] === r ? s = t[6] : (s = (e) => {
		let { isHovered: t, isFocusVisible: n, isSelected: i } = e;
		return W("cursor-pointer border-r px-4 py-2 text-body-small", t || n || i ? "border-outline-brand bg-overlay-brand" : "border-overlay-medium", r);
	}, t[5] = r, t[6] = s);
	let c = o ? "overflow-hidden" : "overflow-hidden text-ellipsis whitespace-nowrap", l;
	t[7] !== n || t[8] !== c ? (l = /* @__PURE__ */ Y("div", {
		className: c,
		children: n
	}), t[7] = n, t[8] = c, t[9] = l) : l = t[9];
	let u;
	return t[10] !== i || t[11] !== s || t[12] !== l ? (u = /* @__PURE__ */ Y(Ei, {
		className: s,
		...i,
		children: l
	}), t[10] = i, t[11] = s, t[12] = l, t[13] = u) : u = t[13], u;
}
//#endregion
//#region lib/components/SteppedMultiColumnDropdown/columns/ListColumn/ListColumn.tsx
function wD(e) {
	let t = K(11), { column: n, onSelect: r, selectedValue: i } = e, a;
	t[0] === r ? a = t[1] : (a = (e) => {
		if (e !== "all" && e.size > 0) {
			let t = Array.from(e)[0];
			typeof t == "string" && r(t);
		}
	}, t[0] = r, t[1] = a);
	let o = a, s = `${n.title} options`, c;
	t[2] === i ? c = t[3] : (c = i ? [i] : [], t[2] = i, t[3] = c);
	let l;
	t[4] === n.items ? l = t[5] : (l = n.items.map(TD), t[4] = n.items, t[5] = l);
	let u;
	return t[6] !== o || t[7] !== s || t[8] !== c || t[9] !== l ? (u = /* @__PURE__ */ Y(Ti, {
		"aria-label": s,
		onSelectionChange: o,
		selectedKeys: c,
		selectionMode: "single",
		children: l
	}), t[6] = o, t[7] = s, t[8] = c, t[9] = l, t[10] = u) : u = t[10], u;
}
function TD(e) {
	return /* @__PURE__ */ Y(CD, {
		allowWrap: !!e.element,
		id: e.id,
		textValue: e.name,
		children: e.element || e.name
	}, e.id);
}
//#endregion
//#region lib/components/SteppedMultiColumnDropdown/columns/SearchColumn/SearchColumn.tsx
function ED(e) {
	let t = K(51), { column: n, onSelect: r, selectedValue: i, onSearch: a, searchTerm: o } = e, s = o === void 0 ? "" : o, c;
	t[0] !== n.items || t[1] !== i ? (c = i && !n.items.some((e) => e.id === i), t[0] = n.items, t[1] = i, t[2] = c) : c = t[2];
	let l = c, u;
	t[3] === a ? u = t[4] : (u = (e) => {
		a?.(e);
	}, t[3] = a, t[4] = u);
	let d = u, f;
	bb0: {
		if (!s) {
			f = n.items;
			break bb0;
		}
		let e;
		if (t[5] !== n.items || t[6] !== s) {
			let r = s.toLowerCase();
			e = n.items.filter((e) => e.name.toLowerCase().includes(r)), t[5] = n.items, t[6] = s, t[7] = e;
		} else e = t[7];
		f = e;
	}
	let p = f, m;
	t[8] !== d || t[9] !== r ? (m = (e) => {
		if (e !== "all" && e.size > 0) {
			let t = Array.from(e)[0];
			typeof t == "string" && (r(t), d(""));
		}
	}, t[8] = d, t[9] = r, t[10] = m) : m = t[10];
	let h = m, g;
	t[11] !== n.allowCustomValue || t[12] !== d || t[13] !== r || t[14] !== s ? (g = (e) => {
		if (e.key === "Enter" && (e.preventDefault(), n.allowCustomValue)) {
			let e = s.trim();
			e && (r(e), d(""));
		}
	}, t[11] = n.allowCustomValue, t[12] = d, t[13] = r, t[14] = s, t[15] = g) : g = t[15];
	let _ = g, v;
	t[16] === s ? v = t[17] : (v = s.trim(), t[16] = s, t[17] = v);
	let y = v, b;
	t[18] !== n.allowCustomValue || t[19] !== p || t[20] !== y ? (b = n.allowCustomValue && y && !p.some((e) => e.name === y) && !p.some((e) => e.id === y), t[18] = n.allowCustomValue, t[19] = p, t[20] = y, t[21] = b) : b = t[21];
	let x = b, S = `${n.title} search`, C;
	t[22] !== n.placeholder || t[23] !== _ ? (C = {
		placeholder: n.placeholder,
		onKeyDown: _,
		className: "h-[1.625rem] text-body-small"
	}, t[22] = n.placeholder, t[23] = _, t[24] = C) : C = t[24];
	let w;
	t[25] !== d || t[26] !== s || t[27] !== C || t[28] !== S ? (w = /* @__PURE__ */ Y(Zx, {
		"aria-label": S,
		className: "w-full gap-0 px-2 py-1",
		inputProps: C,
		onChange: d,
		value: s
	}), t[25] = d, t[26] = s, t[27] = C, t[28] = S, t[29] = w) : w = t[29];
	let T = `${n.title} options`, E;
	t[30] === i ? E = t[31] : (E = i ? [i] : [], t[30] = i, t[31] = E);
	let D;
	t[32] !== x || t[33] !== y ? (D = x ? /* @__PURE__ */ Y(CD, {
		id: `${y}`,
		textValue: `Use "${y}"`,
		children: /* @__PURE__ */ X("div", {
			className: "gap-0.5 flex flex-col",
			children: [/* @__PURE__ */ X("div", {
				className: "text-body-small-strong",
				children: [
					"Use \"",
					y,
					"\""
				]
			}), /* @__PURE__ */ Y("div", {
				className: "text-content-secondary text-label-extra-small",
				children: "Please enter or click here to use this value"
			})]
		})
	}, `custom-${y}`) : null, t[32] = x, t[33] = y, t[34] = D) : D = t[34];
	let O;
	t[35] !== l || t[36] !== s || t[37] !== i ? (O = l && i && !s ? /* @__PURE__ */ Y(CD, {
		className: "border-b-2 border-outline-brand italic",
		id: i,
		textValue: i,
		children: i
	}, `selected-${i}`) : null, t[35] = l, t[36] = s, t[37] = i, t[38] = O) : O = t[38];
	let k;
	t[39] === p ? k = t[40] : (k = p.map(DD), t[39] = p, t[40] = k);
	let A;
	t[41] !== h || t[42] !== T || t[43] !== E || t[44] !== D || t[45] !== O || t[46] !== k ? (A = /* @__PURE__ */ X(Ti, {
		"aria-label": T,
		onSelectionChange: h,
		selectedKeys: E,
		selectionMode: "single",
		children: [
			D,
			O,
			k
		]
	}), t[41] = h, t[42] = T, t[43] = E, t[44] = D, t[45] = O, t[46] = k, t[47] = A) : A = t[47];
	let j;
	return t[48] !== w || t[49] !== A ? (j = /* @__PURE__ */ X(Dr, { children: [w, A] }), t[48] = w, t[49] = A, t[50] = j) : j = t[50], j;
}
function DD(e) {
	return /* @__PURE__ */ Y(CD, {
		id: e.id,
		textValue: e.name,
		children: e.element || e.name
	}, e.id);
}
//#endregion
//#region lib/components/SteppedMultiColumnDropdown/columns/ColumnContent.tsx
function OD(e) {
	let t = K(20), { column: n, onSelect: r, selectedValue: i, onSearch: a, searchTerm: o } = e;
	switch (n.type) {
		case "checkbox": {
			let e;
			return t[0] !== n || t[1] !== a || t[2] !== r || t[3] !== o || t[4] !== i ? (e = /* @__PURE__ */ Y(yD, {
				column: n,
				onSearch: a,
				onSelect: r,
				searchTerm: o,
				selectedValue: i
			}), t[0] = n, t[1] = a, t[2] = r, t[3] = o, t[4] = i, t[5] = e) : e = t[5], e;
		}
		case "list": {
			let e;
			return t[6] !== n || t[7] !== r || t[8] !== i ? (e = /* @__PURE__ */ Y(wD, {
				column: n,
				onSelect: r,
				selectedValue: i
			}), t[6] = n, t[7] = r, t[8] = i, t[9] = e) : e = t[9], e;
		}
		case "search": {
			let e;
			return t[10] !== n || t[11] !== a || t[12] !== r || t[13] !== o || t[14] !== i ? (e = /* @__PURE__ */ Y(ED, {
				column: n,
				onSearch: a,
				onSelect: r,
				searchTerm: o,
				selectedValue: i
			}), t[10] = n, t[11] = a, t[12] = r, t[13] = o, t[14] = i, t[15] = e) : e = t[15], e;
		}
		case "enter-value": {
			let e;
			return t[16] !== n || t[17] !== r || t[18] !== i ? (e = /* @__PURE__ */ Y(SD, {
				column: n,
				onSelect: r,
				selectedValue: i
			}), t[16] = n, t[17] = r, t[18] = i, t[19] = e) : e = t[19], e;
		}
		default: return null;
	}
}
//#endregion
//#region lib/components/SteppedMultiColumnDropdown/utils.ts
function kD(e, t) {
	return !e || !t ? e : (t.type === "checkbox" || t.type === "list" || t.type === "search") && t.items ? t.items.find((t) => t.id === e)?.name ?? e : e;
}
function AD(e, t) {
	if (e.length === 0 || t.length === 0) return null;
	let n = e[0], r = n === "account-tag" || n === "resource-tag", i, a, o, s;
	if (r) {
		if (e.length < 4) return null;
		let n = t[1];
		i = kD(e[1], n), a = e[2], o = e[3], s = 3;
	} else {
		if (e.length < 3) return null;
		i = n, a = e[1], o = e[2], s = 2;
	}
	let c = t[s];
	if (!c) return null;
	let l = [];
	if (c.type === "checkbox") {
		let e = o ? o.split(",").filter(Boolean) : [];
		for (let t of e) {
			let e = kD(t, c);
			l.push({
				id: t,
				name: e
			});
		}
	} else if (c.type === "list" || c.type === "search") {
		if (o) {
			let e = kD(o, c);
			l.push({
				id: o,
				name: e
			});
		}
	} else c.type === "enter-value" && o && l.push({
		id: o,
		name: o
	});
	return {
		criteria: n,
		name: i,
		operator: a,
		value: l
	};
}
//#endregion
//#region lib/components/SteppedMultiColumnDropdown/SteppedMultiColumnDropdown.tsx
var jD = 350, MD = (e, t) => !e || !t ? e : (t.type === "checkbox" || t.type === "list" || t.type === "search") && t.items ? t.items.some((t) => t.id === e) ? e : t.items.find((t) => t.name === e)?.id ?? e : e, ND = (e, t) => {
	if (e.length === 0) return e;
	let n = [...e];
	return t.forEach((e, t) => {
		let r = e.find((e) => !e.condition || e.condition(n));
		if (!r) return;
		let i = n[t];
		if (i) {
			if (r.type === "checkbox") {
				n[t] = i.split(",").filter(Boolean).map((e) => MD(e, r)).join(",");
				return;
			}
			n[t] = MD(i, r);
		}
	}), n;
};
function PD(e) {
	let t = K(83), { config: n, onChange: r, onChangeStructured: i, initialSelections: a, trigger: o, autoHeight: s, onSearch: c, onScrollEnd: l, onOpenChange: u, className: d } = e, f;
	t[0] === a ? f = t[1] : (f = a === void 0 ? [] : a, t[0] = a, t[1] = f);
	let p = f, m = s !== void 0 && s, [h, g] = J(!1), _;
	t[2] !== n || t[3] !== p ? (_ = () => ND(p, n), t[2] = n, t[3] = p, t[4] = _) : _ = t[4];
	let [v, y] = J(_), [b, x] = J(100), S;
	t[5] === Symbol.for("react.memo_cache_sentinel") ? (S = {}, t[5] = S) : S = t[5];
	let [C, w] = J(S), T = Tr(null), E;
	t[6] === Symbol.for("react.memo_cache_sentinel") ? (E = [], t[6] = E) : E = t[6];
	let D = Tr(E), O;
	t[7] === Symbol.for("react.memo_cache_sentinel") ? (O = [], t[7] = O) : O = t[7];
	let k = Tr(O), A;
	t[8] !== n || t[9] !== v ? (A = [], n.forEach((e) => {
		let t = e.find((e) => !e.condition || e.condition(v));
		t && A.push(t);
	}), t[8] = n, t[9] = v, t[10] = A) : A = t[10];
	let j = A, M;
	t[11] === Symbol.for("react.memo_cache_sentinel") ? (M = () => {
		if (T.current) {
			let e = T.current.offsetWidth;
			x(e);
		}
	}, t[11] = M) : M = t[11];
	let N;
	t[12] === o ? N = t[13] : (N = [o], t[12] = o, t[13] = N), br(M, N);
	let P, F;
	t[14] === Symbol.for("react.memo_cache_sentinel") ? (P = () => () => {
		k.current.forEach(clearTimeout);
	}, F = [], t[14] = P, t[15] = F) : (P = t[14], F = t[15]), br(P, F);
	let I;
	t[16] !== h || t[17] !== l || t[18] !== v ? (I = l && h ? (e) => {
		e !== void 0 && l(e, v);
	} : void 0, t[16] = h, t[17] = l, t[18] = v, t[19] = I) : I = t[19];
	let L = I, R;
	t[20] !== n || t[21] !== p || t[22] !== u ? (R = (e) => {
		g(e), e || (y(ND(p, n)), w({})), u?.(e);
	}, t[20] = n, t[21] = p, t[22] = u, t[23] = R) : R = t[23];
	let z = R, B;
	t[24] !== j || t[25] !== h ? (B = { deps: [j, h] }, t[24] = j, t[25] = h, t[26] = B) : B = t[26], Nl(D, L, B);
	let V;
	t[27] !== c || t[28] !== v ? (V = (e, t) => {
		w((n) => ({
			...n,
			[t]: e
		})), c?.(e, t, v);
	}, t[27] = c, t[28] = v, t[29] = V) : V = t[29];
	let ee = V, H, U, te, ne, re, ie, ae, oe, se, ce;
	if (t[30] !== j || t[31] !== m || t[32] !== d || t[33] !== n || t[34] !== z || t[35] !== ee || t[36] !== h || t[37] !== b || t[38] !== r || t[39] !== i || t[40] !== c || t[41] !== C || t[42] !== v || t[43] !== o) {
		let e = (e, t) => {
			let a = [...v];
			if (a[e] = t, e === 0 && v[0] !== t) {
				w({}), k.current.forEach(clearTimeout), k.current = [];
				let e = 0;
				n.forEach((t, n) => {
					let r = t.find((e) => !e.condition || e.condition(a)), i = r && (r.type === "search" || r.type === "enter-value"), o = t.some(FD);
					if (i || !r && o) {
						let t = setTimeout(() => {
							c?.("", n, a);
						}, e);
						k.current.push(t), e += jD;
					}
				});
			}
			if (v[e] !== t) {
				let t = e + 1;
				for (let r = e + 1; r < n.length; r++) {
					let e = n[r].find((e) => !e.condition || e.condition(a));
					if (e) {
						let r = [];
						n.forEach((e) => {
							let t = e.find((e) => !e.condition || e.condition(v));
							t && r.push(t);
						});
						let i = r[t], o = a[t];
						o && i && (e.type === i.type && e.title === i.title ? (e.type === "list" || e.type === "search") && e.items && (e.items.some((e) => e.id === o) || (a[t] = "")) : a[t] = ""), t++;
					} else t < a.length && (a[t] = "");
				}
				for (let e = t; e < a.length; e++) a[e] = "";
			}
			y(a);
			let o = [];
			n.forEach((e) => {
				let t = e.find((e) => !e.condition || e.condition(a));
				t && o.push(t);
			});
			let s = o.every((e, t) => a[t] && a[t].trim() !== ""), l = e === o.length - 1;
			if (s) {
				let e = a.slice(0, o.length);
				r?.(e);
				let t = AD(e, o);
				t && i?.(t);
				let n = o[o.length - 1]?.type === "checkbox";
				l && !n && z(!1);
			}
		}, a;
		t[54] !== h || t[55] !== o ? (a = () => o ? typeof o == "function" ? o({ isOpen: h }) : o : /* @__PURE__ */ Y(Q, {
			IconRight: /* @__PURE__ */ Y(gt, {
				className: W("text-gray-600", h ? "rotate-180" : ""),
				size: 16
			}),
			className: "w-[50rem] justify-between border-legacy-navy-L50 font-normal text-legacy-neutrals-ash",
			variant: "tertiary",
			children: "Select Criteria"
		}), t[54] = h, t[55] = o, t[56] = a) : a = t[56];
		let s = a;
		te = mi, oe = h, se = z;
		let l;
		t[57] === d ? l = t[58] : (l = W("inline-flex", d), t[57] = d, t[58] = l);
		let u;
		t[59] === s ? u = t[60] : (u = s(), t[59] = s, t[60] = u), t[61] !== l || t[62] !== u ? (ce = /* @__PURE__ */ Y("span", {
			className: l,
			ref: T,
			children: u
		}), t[61] = l, t[62] = u, t[63] = ce) : ce = t[63], U = ji, ae = "bottom start", H = fi;
		let f = m ? "max-h-[20.25rem]" : "h-[20.25rem]";
		t[64] === f ? ne = t[65] : (ne = W("flex overflow-hidden rounded-xs border border-outline-decorative bg-background-secondary py-2 shadow-lg", f), t[64] = f, t[65] = ne);
		let p = `${b}px`;
		t[66] === p ? re = t[67] : (re = { width: p }, t[66] = p, t[67] = re), ie = j.map((t, n) => /* @__PURE__ */ X("div", {
			className: W("flex min-w-[11.25rem] flex-col", t.flex ? "flex-1" : "max-w-[11.25rem]"),
			children: [
				/* @__PURE__ */ Y("h3", {
					className: "px-4 py-2 text-body-small text-text-secondary",
					children: t.title
				}),
				/* @__PURE__ */ Y("div", {
					className: "flex-1 overflow-y-auto",
					ref: (e) => {
						D.current[n] = e;
					},
					children: /* @__PURE__ */ Y(OD, {
						column: t,
						onSearch: (e) => ee(e, n),
						onSelect: (t) => e(n, t),
						searchTerm: C[n] || "",
						selectedValue: v[n]
					})
				}),
				t.cta ? /* @__PURE__ */ Y("div", {
					className: "text-text-link px-4 py-2 text-body-small",
					children: t.cta
				}) : null
			]
		}, `${t.title}-${n}`)), t[30] = j, t[31] = m, t[32] = d, t[33] = n, t[34] = z, t[35] = ee, t[36] = h, t[37] = b, t[38] = r, t[39] = i, t[40] = c, t[41] = C, t[42] = v, t[43] = o, t[44] = H, t[45] = U, t[46] = te, t[47] = ne, t[48] = re, t[49] = ie, t[50] = ae, t[51] = oe, t[52] = se, t[53] = ce;
	} else H = t[44], U = t[45], te = t[46], ne = t[47], re = t[48], ie = t[49], ae = t[50], oe = t[51], se = t[52], ce = t[53];
	let le;
	t[68] !== H || t[69] !== ne || t[70] !== re || t[71] !== ie ? (le = /* @__PURE__ */ Y(H, {
		className: ne,
		style: re,
		children: ie
	}), t[68] = H, t[69] = ne, t[70] = re, t[71] = ie, t[72] = le) : le = t[72];
	let ue;
	t[73] !== U || t[74] !== ae || t[75] !== le ? (ue = /* @__PURE__ */ Y(U, {
		placement: ae,
		children: le
	}), t[73] = U, t[74] = ae, t[75] = le, t[76] = ue) : ue = t[76];
	let de;
	return t[77] !== te || t[78] !== oe || t[79] !== se || t[80] !== ce || t[81] !== ue ? (de = /* @__PURE__ */ X(te, {
		isOpen: oe,
		onOpenChange: se,
		children: [ce, ue]
	}), t[77] = te, t[78] = oe, t[79] = se, t[80] = ce, t[81] = ue, t[82] = de) : de = t[82], de;
}
function FD(e) {
	return e.type === "search" || e.type === "enter-value";
}
//#endregion
//#region lib/components/Toast/Toast.tsx
var ID = class extends $i {
	constructor(e) {
		super({
			...e,
			wrapUpdate(e) {
				"startViewTransition" in document ? document.startViewTransition(() => {
					kr(e);
				}) : e();
			}
		});
	}
};
function LD(e) {
	let t = K(8), { queue: n, className: r } = e, i;
	t[0] === r ? i = t[1] : (i = W("fixed left-1/2 top-4 z-[9999] flex -translate-x-1/2 flex-col gap-2", r), t[0] = r, t[1] = i);
	let a;
	t[2] === n ? a = t[3] : (a = (e) => {
		let { toast: t } = e;
		return /* @__PURE__ */ Y(Zi, {
			className: "toast-item min-w-80 max-w-lg",
			style: { viewTransitionName: t.key },
			toast: t,
			children: /* @__PURE__ */ Y(Qi, { children: /* @__PURE__ */ Y(Rl, {
				onClose: () => n.close(t.key),
				role: "none",
				severity: t.content.severity,
				children: Array.isArray(t.content.message) ? /* @__PURE__ */ Y("ul", {
					className: "m-0 list-inside list-disc p-0",
					children: t.content.message.map(RD)
				}) : t.content.message
			}) })
		});
	}, t[2] = n, t[3] = a);
	let o;
	return t[4] !== n || t[5] !== i || t[6] !== a ? (o = /* @__PURE__ */ Y(ea, {
		className: i,
		queue: n,
		children: a
	}), t[4] = n, t[5] = i, t[6] = a, t[7] = o) : o = t[7], o;
}
function RD(e, t) {
	return /* @__PURE__ */ Y("li", { children: e }, t);
}
//#endregion
export { tu as AVATAR_COLORS, $t as AdminIcon, At as AirplayIcon, Rl as Alert, Bl as AlertTitle, Gt as AlertTriangleIcon, $l as AppHeader, ft as ArrowDownFillIcon, Be as ArrowDownIcon, Pt as ArrowLineRightIcon, Yt as ArrowRightIcon, qe as ArrowUpIcon, St as ArrowsClockwiseIcon, rn as ArrowsInIcon, Ze as ArrowsOutIcon, _D as Autocomplete, lu as Avatar, rt as AwsLogo, Rt as AwsWhiteLogo, Et as AzureLogo, lt as BellSimpleIcon, ot as BracketsCurlyIcon, du as BreadcrumbHeader, Q as Button, gu as ButtonGroup, xa as CHART_COLORS, qc as COLORS, Le as CalendarIcon, vu as Card, cn as CardsIcon, _n as CaretDownFillIcon, We as CaretRightFillIcon, mn as CaretRightIcon, Ff as ChangelogCard, pe as ChartBarIcon, l as ChartLineIcon, dn as ChartLineUpIcon, ge as ChatTextIcon, h as CheckBoldIcon, f as CheckCircleFillIcon, te as CheckCircleIcon, yt as CheckIcon, yl as Checkbox, If as CheckboxGroup, r as CheckboxIcon, gt as ChevronDownIcon, Ux as Chip, z as CircleIcon, ee as CirclesThreeIcon, Dl as CircularProgress, ie as ClearIcon, v as ClockCounterClockwiseIcon, D as ClockIcon, I as CloudArrowUpIcon, ue as CloudIcon, bn as CloudOperationsIcon, Mm as CodeBlock, o as CodeBlockIcon, Se as CodeIcon, w as ColumnsIcon, Ab as ComboBox, ye as CompassToolIcon, Te as ComputerTowerIcon, Tu as CopyButton, x as CopyIcon, N as CubeIcon, Ht as CurrencyDollarIcon, $c as DEFAULT_PROVIDERS, A as DashIcon, je as DatabaseIcon, iT as DatePicker, ST as DateRangePicker, CT as DateRangeSelect, Oe as DefaultLogo, Pe as DensityComfortableIcon, se as DensityCompactIcon, e as DensityStandardIcon, Xf as Dialog, $f as DialogContent, ep as DialogFooter, Qf as DialogHeader, pi as DialogTrigger, nt as DiffIcon, Ay as DiffView, Im as Disclosure, Lm as DisclosureHeader, Rm as DisclosurePanel, Fy as Divider, nn as DotsThreeIcon, Nt as DotsThreeVerticalIconBold, Jt as DoubleChevronLeftBoldIcon, ht as DoubleChevronRightBoldIcon, Ue as DownloadSimpleIcon, Lt as DynamicCollectionIcon, Qt as EditIcon, Iy as EmptyState, Bx as EntityCard, Lx as EntityCardHeader, Hx as ExpandableEntityCard, Bb as ExpandableSearchField, Xe as ExportBoldIcon, Tt as ExportIcon, sn as ExternalLinkIcon, $e as EyeIcon, at as EyeSlashedIcon, Vt as FileCssIcon, kt as FileIcon, dt as FileSearchIcon, ct as FileTextFillIcon, ze as FileTextIcon, un as Files2Icon, yn as FilesIcon, Ke as FilterIcon, dD as FilterRail, hD as FilterRailToggle, gn as FolderIcon, he as FoldersIcon, zy as FormFooter, d as FunnelBoldIcon, pn as FunnelIcon, au as GRAVATAR_KEY, ve as GcpLogo, _ as GearIcon, m as GitLogo, re as GraphIcon, xt as GridNineIcon, a as GroupIcon, Vy as Heading, vt as HomeIcon, V as HouseLineIcon, Gx as HumanTimestamp, U as InfoCheckFillIcon, oe as InfoIcon, b as InfoIconBold, k as InsecureIcon, R as JiraBugIcon, fe as JiraCheckSquareIcon, Sn as JiraLogoIcon, c as K8sLogo, we as KeyIcon, E as KeyboardIcon, xe as KeyholeIcon, De as LightbulbFillIcon, C as LightningSlashIcon, fu as Link, mu as LinkButton, F as ListDashesIcon, Wt as ListMagnifyingGlassIcon, M as LockIcon, YE as LogicEditor, Ne as McpIcon, Ae as MinusCircleIcon, Ie as MinusIcon, kx as ModeToggleButton, ob as MultiSelectDropdown, sS as MultiSelectField, dS as MultiTextField, ib as MultiToggleDropdown, le as NegativeSolidIcon, n as NotePencilIcon, et as NotificationIcon, en as NotificationsIcon, tS as NumberField, jt as OpsCostIcon, dx as PageSkeleton, Kt as PaletteIcon, bu as Paper, pt as PaperPlaneTiltIcon, Ve as PasswordIcon, Ft as PencilIcon, Xt as PencilSimpleIcon, Je as PerspectiveIcon, Ct as PlugsConnectedIcon, an as PlusCircleIcon, Qe as PlusIcon, Su as Popover, it as PresentationChartIcon, db as ProgressBar, hl as ProviderIcon, xl as ProviderSelectBox, zb as ProviderSelector, zt as QueryIcon, Dt as QuestionIcon, zf as Radio, Vf as RadioGroup, ut as RefreshIcon, st as RepeatIcon, El as ResourceManagerIcon, Re as RocketLaunchIcon, Ii as RouterProvider, ln as RowsIcon, vn as ScanIcon, Ge as ScrollIcon, Wl as SearchField, hn as SearchIcon, Hb as SecretTextField, rx as SectionSkeleton, me as SecureIcon, iS as SelectField, u as SettingsIcon, ex as Sidebar, Jb as SidebarLink, fn as SidebarSimpleIcon, Xl as SingleSelectDropdown, Jl as SingleSelectDropdownItem, Gl as Skeleton, nx as SkeletonStatus, _e as SparkleIcon, g as SparkleOutlineIcon, p as SpinnerGapIcon, ne as StackFilledIcon, bt as StackletLogo, Zc as StackletUIThemeProvider, i as StarIcon, Sx as StatCard, bx as StatCardContent, xx as StatCardTitle, Yx as StatusLight, PD as SteppedMultiColumnDropdown, Ox as Stepper, tb as Switch, tt as SystemIcon, Jc as TOOLTIP_BG_DARK, Ix as Tab, Px as TabList, Mx as TabPanel, ux as TableSkeleton, jx as Tabs, pb as Tag, _t as TagChevronIcon, mb as TagGroup, B as TagIcon, H as TencentCloudLogo, ae as TextAaIcon, mS as TextArea, Zx as TextField, y as TileViewIcon, ID as ToastQueue, LD as ToastRegion, vS as ToggleButton, gS as ToggleButtonGroup, O as ToolsIcon, qt as Tooltip, mt as TooltipProvider, L as TrashIcon, de as UpdateIcon, xn as UserCheckIcon, s as UserCircleGearIcon, Ce as UserCircleIcon, T as UserGroupIcon, be as UserIcon, yS as UserMenu, Ee as UserMinusIcon, S as UserPlusIcon, P as UserXIcon, Ut as UsersThreeIcon, Kx as VisuallyHidden, j as WarningCircleFillIcon, Me as WarningCircleIcon, ke as WebhookIcon, Fe as XCircleFillIcon, ce as XCircleIcon, t as XIcon, su as backgroundColorFormatter, sl as capitalize, W as cn, AD as convertSelectionsToCriteriaFilterValue, G as customTv, on as focusableTriggerClasses, tl as formatProvider, rl as formatProviderFullName, ll as getAccountNoun, iu as getAvatarColorOption, Ca as getChartColors, ul as getIdentifierLabel, Qc as getIsActivePath, pl as getNameFieldHint, fl as indefiniteArticle, cu as initialsFormatter, ru as isAvatarColorKey, ou as isAvatarSelectionKey, el as isProvider, Ot as tailwindPreset, Xc as theme, nl as toProviderKey, ya as useFreshworksWidget, tr as useInteractOutside, ga as usePreloadIntent, tn as withSize };

//# sourceMappingURL=ui.js.map